/**
 * Databetrix game-id -> display name mapping.
 * Databetrix is an aggregator; these titles come from its 3 Oaks Gaming, Amatic, Amigo, Amusnet, Backseat, Belatra, Betby, Booming, Croco Gaming, EGT, EGT VIP, ELK, Evolution, Flexrix Sportsbook, Greentube, Habanero, Hacksaw, IGT, KaGaming, Kajot, Merkur, Netent, NolimitCity, PLAYSON, PatePlay, PlaynGo, Playtech, Pragmatic Play, Pragmatic Play Live, Push, RedRake, Relax, RubyPlay, Spribe Gaming, Tomhorn, Yggdrasil, Zitro, platipus feed.
 * Ids delisted from the catalog are kept so historical rounds still resolve.
 * Auto-generated from databetrix_all_games.json.gz by scripts/generate_databetrix_name_mapping.py.
 * Generated on: 2026-10-29. Total games: 8685.
 */

const databetrixGameNameMapping = {
  "0f000bbb7f83d10e2f86ea191e7e11d2465a602a": " Lucky Tiger Gold",
  "3e0243ff617d682321961a552982811489ed9281": "*NSYNC Pop",
  "b66e065f0b355ede339f7d0291bdb95bdfa65497": "1-Of-A-Kind",
  "f65cdd628e02ab19169eaf8dfb2b9b07f15c4f67": "10 Action Diamond",
  "d7de60164ddf1252ffd9942eba16bc0932d1b862": "10 Bulky Fruits",
  "9f6f299e5140c2a6409b5f2dc3fafbbb2e7fef52": "10 Burning Clover",
  "75226ada02dceceabdef96e87721214007d2857c": "10 Burning Heart",
  "b223c5e1fd2445e2d1810fc3e742e146ffb2e50d": "10 Burning Heart",
  "e2788feb6baf1c22c0984c6a2437f50904100200": "10 Burning Power",
  "c591e8eefc70bfb1846045ebe9a9c14219dd5f30": "10 Burning Roll",
  "c989be79143a9f1a18f4c40498f2af57641e451e": "10 Clover Hit",
  "158227246aab59ab48b5f28fa45498b46c4b6825": "10 Crown Hit",
  "246038df8a5751306f6caee2cd5eef06a94b9c4e": "10 Crown hot",
  "ebd9baff683dbb95753b652e03c4faaf7df2c464": "10 Crystal Wish",
  "d3d9e92f423f93d7ab3a5afcdae8312d2a0d5eed": "10 Dazzling Cash",
  "9aadc416b1dc8657be62cc1f53a98f9d68257a65": "10 Dazzling Hot",
  "5400e73a4360a836d14ad79ee7b0860bd3fd35d8": "10 Flaming Bisons",
  "0214af1b0358465cc022431aee048d3c2e8082df": "10 Glossy Hot",
  "501602de38dd4e97bdfb81feeb3727268fbef7ac": "10 Imperial Crown deluxe Diamond Mystery",
  "8d139e999ca30a49dc6736efef3e69a41e465803": "10 Joker Hit",
  "02ef4748fffcf6dfa33cfc64f35318ed630e80a2": "10 Joker Hit VIP",
  "204f10f10918fdaaa34be538cf9b0a5961555ff9": "10 Leprechaun Hot",
  "6503fd16da7308a6729d49155a27374515e9a85d": "10 Leprechaun Roll",
  "d6a37f8440857151be5ca146104e62466c84d664": "10 Leprechaun Roll VIP",
  "149200e97f7233e47015de82dc493f0b6357e320": "10 Pharaohs",
  "fe29a79fd2eead6ef255151f2cd2c3eb56c6cd53": "10 Power Hot",
  "fd3aa5bd4f2a16101e73cecbaa70edb3fa53e967": "10 Shining Diamond",
  "a849bec441a323d6308b6efeb19c3e6a9b35454d": "10 Shining Diamonds HIGH RTP",
  "8dbe8211768869fe39fc142f10da8260bdd9e220": "10 Shining Diamonds HIGH RTP VIP",
  "605bbf7cb4a68066404291c420587b4dcc8228e7": "10 Shining Roll",
  "a81752f0c432b131c9bfe2b1ea4cd6ee775ecc93": "10 Shiny Hit",
  "2fa2f1662619a5ce05f4133a44e3065501084ae7": "10 Super Fruits",
  "0ba0b93664d2bb0e979b42dedbec235cbd1f0078": "10 Super Roll",
  "a23dbdae81ce2f7c87b3261c1ebf08658dc8dabe": "10 Super Roll VIP",
  "127e6ca335f69ac77f83f5ff4341683b5583d516": "10 Swords",
  "d37c1a175072265e8a1a2963735ab05766249de2": "10 Vampire Beast",
  "2b2755921ca30e3f33b1d7d8b81d7ad651eeed67": "100 Art of Gold",
  "addc5e578930d378bba6a0d08b875eb68c6d375a": "100 Art of Gold Dice Edition",
  "d981a5727357f381c758c6c1075ffd6aadc8a047": "100 Bulky Dice",
  "2a71654f035176a360437b6b1944757ddfac2b56": "100 Bulky Dice Golden Coins Link",
  "4384516060f6b3aa29121b0e980e0a6a9dafefe2": "100 Bulky Dice Golden Coins Link VIP",
  "14393f72abcb8abfe765cd5accc0d48af3e59b0a": "100 Bulky Fruits",
  "1587e7d815404084a99f16b9c82a1b440af971a1": "100 Bulky Fruits Golden Coins Link",
  "bfaa5109ecccebc91fd9ce70d244c4f366fc2832": "100 Bulky Fruits Golden Coins Link VIP",
  "947205442ba0a37af5809b54ecb2a0de8de6a350": "100 Burning clover",
  "50ae78353f5d0437e57b880edcae00c2c0211f8e": "100 Burning Hot",
  "d5de0a0054a9dcf795dd967eb9b2d5f69bf3c1a8": "100 Burning Hot",
  "f5be8557506ecef25d9060c60ddbd25cdce34a35": "100 Burning Hot Buy Bonus",
  "817f408099c9ecb6803c8b469fcf0257a876661f": "100 Burning Power",
  "c9ce4f2a261a1b3cc5f6ea671446ee25e88ebf61": "100 Burning Power VIP",
  "d5c830c213433e551a8462b45a447383dc7ea926": "100 Burning Roll",
  "c261d54a8314e5063a4254390b1943eef41f31ac": "100 Cats",
  "d8dd1fc2ee2ac4211a1299026361472aa43c5b28": "100 Clover Hit",
  "49e03ff711376d0064a8c1e1b36e33bdb248b3a6": "100 Crown Hit",
  "d564c1de9afb561b27e1cd5616a50366e6f13972": "100 Crown Hot",
  "c54b3646cb5d79c43c5998caf93af01d2e0566c6": "100 Dazzling Cash",
  "3859171382abdd4333c9d5a6d5e2cd47be8b5d47": "100 Dazzling Hot",
  "bf19e66e647e252b5dbac5b6e423df6c2eff287c": "100 Dazzling Roll",
  "0c630870d9b493c6b995e548641ba17cb990ad2c": "100 Dazzling Roll VIP",
  "011dc7b093285cea791f605ced965981a2a0d30d": "100 Dice",
  "96131ca333582dc24c4a3dc06ebf12b5d7fc67b7": "100 Extra Crown",
  "c915402c1aad27668387e0f732fd0a36c6599b78": "100 Extra Crown - Buy bonus",
  "db9da187e063ff257a19f7874e13ffe93986917e": "100 Extra Crown 6 Reels",
  "cca8060121ba8b8c4fda26283f20302b8062ba76": "100 Golden Coins",
  "bc4e001a39763a46e7409886ea2ad62386fda8fd": "100 Golden Coins Dice Edition",
  "bdb064ae7987bba13a4970a1c4254c9aa585e316": "100 Golden Coins: Reel Fishing",
  "7d9270508244db724f4fea029896b14465d81f72": "100 Happy Seven",
  "60cda9135336ee5d4366b3524810b3b74942deac": "100 Joker Hit",
  "7eced7034b0328ab77960db1ed97b51cebc4abf3": "100 Joker Hit VIP",
  "505fadda0b8226a7f2a54f67646c454ecac7a2fe": "100 Joker Roll",
  "cfe7b22fe3169dfe8c1a8629fee1bb12191960fe": "100 Joker Roll VIP",
  "f984f80d23392c652235605dd2b08f58c0ddbe0c": "100 Joker Staxx",
  "29adc0f9fae18a1266402d2e4b3d152c6d663055": "100 Leprechaun Hot",
  "0bccb02f25f2f4eeac84c77bfb58ced9b1e0926b": "100 Leprechaun Roll",
  "349d93c89b0a84fcdc2251b39869bfbd533f8a31": "100 Leprechaun Roll VIP",
  "5562923e5528297c0ee5a6db311dcda5338d4f4d": "100 Lucky Hat",
  "bcd12655648823ac8c56e77c5c1d8fadee253fa9": "100 Power Hot",
  "46c6191786bda6ace548a7d467970b6a71a35438": "100 Power Hot Dice Edition",
  "e3322017bc410c2b81a94d264018e4833ed41671": "100 Power Hot Dice Edition Golden Coins Link",
  "aac45368a55b0b84104a7d9d92dc5f04be3abb5b": "100 Power Hot Dice Edition Golden Coins Link VIP",
  "b09b365c03bf730a242488a7d4380a85dbcc9a9d": "100 Power Hot Golden Coins Link",
  "e43eca1ed541836ea0d2e29b9a88b0c847b53822": "100 Power Hot Golden Coins Link VIP",
  "a3e7fbbca5d2fa7c934cfc870e32584737abdf48": "100 Shining Roll",
  "a19c0497b7ec9278d1ea92cb01da448e81b578a7": "100 Super Dice",
  "2572e30e2e0e5af55218799f269c106edaa6f4a0": "100 Super Fruits",
  "46c809a416e41f96089c67a0dbd84655f16c9e1e": "100 Super Hot",
  "bb22a48eb07afd00395080c86cf568a03b043ecd": "100 Super Hot",
  "5ba418b8a93fb7b41f9e5ca1ea89baa17e19e261": "100 Super Hot 6 reels",
  "c98535547d3791dd52b68ea1b46cd15dd7dd50d2": "100 Super Power",
  "a3a2cff08663f852e96adfe36f39f80e95587bf7": "100 Super Roll",
  "fe2dc6a827161dfd1bd464d63ffb9ed5a2a486ed": "100 Super Roll VIP",
  "b0b6400f9c98af1c49a31bd6e5238f653fecdebc": "100,000 Pyramid",
  "f047117cd4801f729cd27c19a0b032d568fcd064": "1000 Moon Girls",
  "916df1fd036f9903d02e3f09b17cd9cec08cdc01": "1000 Olympus Rivals",
  "b3a201e708ddcf18d3bec7181a82076bde5eb124": "1001 Mystery Genie Fortunes",
  "de424affc6331dc4655da52a8b1fb2001aedf0a8": "1001 spins",
  "c9312219bfa03d5a78ae09a816150e74b53ba662": "101 Candies",
  "c813137439b21b64cf3a804e0d8e1fa29657a3ca": "12Zodiacs",
  "5fa90627ff95aea50f0e842b93fe26362916d921": "13th Trial Hercules Abyssways",
  "e48c8e91b90e4d4646c09a5f18bea055c6a92869": "15 Crystal Roses: A Tale of Love",
  "0e49c3a9865355ebd62e833290af78f768f2d250": "15 Dragon Pearls",
  "d76bffeb38eb28c525e287495cbe42ae40f36daa": "1717 Caribbean Pirates",
  "58a38c94ebe36b9e5efecc73c30fec686485f11e": "1960 Elvis Guava",
  "0f3fca6b6fd699af9ae08c31565fe339c42854b4": "1st Cricket League",
  "4935b72139f95e547839cb03e6e38e3a824b3ef1": "1st of the Irish",
  "e5870516efa6a070b3097faa8e5d0231fdf35a23": "2 Dragons",
  "7b2ed11d2211bd5a62179b3f2239f401e45fe587": "2 Hand Casino Hold'em",
  "122d279a82240866f8e83bf87774042aeb16c875": "2 Hand Casino Hold'em",
  "c7d8cc0c4651c199ff450476dc3b7251d414d6b6": "2 Kings of Africa",
  "ca2f2dbf94dd681b1c06bb5d241401468546e772": "2 Wild 2 Die",
  "d588a0c48084b6711968aa389c0fcd17e490bcee": "20 000 Waves",
  "88698ce84ae4422b394858f113721ee9869a7cb8": "20 Aztec Coins",
  "9eb30c119fa34aa1a6a11c0c40557f60368fa018": "20 Bulky Dice",
  "ed3c4c3f59bf3fe1451e1192c41caa89b4ec2b90": "20 Bulky Fruits",
  "8117ec498f96281357d5d7c0898d3f4db275c1ae": "20 Bulky Fruits Buy Bonus",
  "1d1d6b80be2edcf8a6862739df159f70751279b2": "20 Burning Clover",
  "f616b420c6d1860652406e5a8cc434bb1ce3d3c7": "20 Burning Dice",
  "9d7ad5db20b2bed868d272c3ee8ef69843b1b3e3": "20 Burning Hot",
  "b9cc5e63418bfd75e5fe5dd0a4b0bc54d5cf9619": "20 Burning Hot",
  "b386a52999d4ae38a3987d80b7bfb046b5fcd878": "20 Burning Hot Cash Heat",
  "473be5b620cbe9c9d8aae2e1c400a25ce92eec80": "20 Burning Power",
  "0b2d8ab0452573685cab5066f39930676c219024": "20 Burning Roll",
  "f20ad5fb9c4bc78919a518413e00660a55ed8e6d": "20 Burning Roll VIP",
  "518a8ed7bc231bd334ff12a330cf5116db5dec46": "20 Charming Joker",
  "27c9c087bbfc69a889d010923f8f3c003450306a": "20 Clover Hit",
  "237b0c5c65cf7a2e9bc9d1fe662315e23cbebd27": "20 Crown Hot",
  "4be55741f6830cc34a4d1f651ddac3b99efbde2a": "20 Dazzling Cash",
  "336ff48d433fe4a74ce71b7d808f77ccf2bad7b8": "20 Dazzling Hot",
  "6b5dd7cea986de004ef9c73eadff029701d50016": "20 Dazzling Hot",
  "74b38dc8fecd5e2d932c2d0b64e8730a8a928dc2": "20 Dazzling Roll",
  "3f4a8928be0012e1456f97a958ad856a0798e9b3": "20 Dazzling Roll VIP",
  "966550e58ca8503a68018b6285cd9f8d3e28fc87": "20 Diamond Plus",
  "02a2443d251967c3776c20d1ca0af431547497fe": "20 Diamonds",
  "f5cd3238260dd8e8ebe236cf28dda5638d936863": "20 Extra Crown",
  "a9b7ecd74ead2822fcedeef260521e08fb0bbfbf": "20 Extra Crown - Buy bonus",
  "087fbd771e7856a7f1fd28a567311427ede7017b": "20 Glossy Hot",
  "883d2be6ad403e8dec5ae6985a885e741a004bf5": "20 Glossy Hot Golden Coins Link",
  "1b6b49af4551e12ddd27c286bff058cc0a070718": "20 Glossy Hot Golden Coins Link VIP",
  "8b34ac1b7e1a733d95ebf41fc2eb2c7167ea16a3": "20 Golden Coins",
  "7270793553453c70378f72ce16c904131f569a03": "20 Golden Coins - Christmas Edition",
  "968155b45d0e9722dd54e67200ba0017697ca3e0": "20 Golden Coins Dice Edition",
  "48fa2887e43127dbe9f5bbabd97bb7d3d3863a35": "20 Golden Coins: Reel Fishing",
  "a18c160e88b776b5fecba4f7a6def0f5ca8b4ef5": "20 Happy Seven",
  "e91f100c2cf4a89e74df702d86102fd6dc7f26fb": "20 Hot Blast",
  "d3ddcb114adde78d23b7a769957c9df6e7dbd889": "20 Hot Burst",
  "2af2aeb7a47c29f6737930cbb304fa58e32a6f29": "20 Icy Fruits",
  "b4fd511df0d7e8a06b20777326346924e8ff8acd": "20 Joker Dice",
  "54d641f641b6876cdb6809ca21dfb3316f311ff2": "20 Joker Hit",
  "5835417ffd0398432cc9cb24abcfb78d7ae75914": "20 Joker Hit VIP",
  "8d700b597d940a8284f06123cf135015f5607d66": "20 Joker Reels",
  "8fb9d432785b9bea4d559579035b9365e732986f": "20 Leprechaun Hot",
  "8a06470f7c608d86dbb6c28e6769595764e6a4f9": "20 Leprechaun Roll",
  "86751073a6bcd3b93a891e5783991eac0a0c81cc": "20 Leprechaun Roll VIP",
  "11be260fa06800731deaa12ed2d169214ee25db4": "20 Pirate Bombs",
  "882875b5f27a821c4b9dab5ea1b630481de0efb8": "20 Power Hot",
  "b416253b706d6d282bd5a7776fd0ac0d51a82717": "20 Power Hot Dice Edition",
  "7e4639331fdf351c474312c910198765d4dabead": "20 Shining Roll",
  "041408647af476eb7f6e1883996dd033ad9ef028": "20 Shining Roll VIP",
  "80c04e47ad776b67e148f02391617db4af82e3a0": "20 Shiny Hit",
  "6073fe7c83ef79fc7df6af28b30b70dba2c49dbc": "20 Super Dice",
  "97cf655d3bb31fb85fc7936d7ebc35d0cb1d14e7": "20 Super Dice Egypt Quest (EQ)",
  "69af82c5f9002e38b1beb9966f57fb25709b33d0": "20 Super Fruits",
  "488866c64cd0654c8dcd2328b172281f2d36b707": "20 Super Fruits Bell Link",
  "9156c43d4316aec234658876173c51d57c21d317": "20 Super Fruits Bell Link VIP",
  "03dde4ff4809b7470ae4b121abda4ef6a3b5c903": "20 Super Hot",
  "371ada5f59f75aa8e0db878255147e46d879ef7a": "20 Super Hot",
  "dace22e98ffd8c001c11b136196a45948855c989": "20 SUPER HOT",
  "3465bb30a6848df57b39de7b1772a8253e638d39": "20 SUPER HOT BELL LINK",
  "fd95bedcd9b742fce850c77b4c998e9d480940ac": "20 SUPER HOT BELL LINK VIP",
  "e7c1c944aafff5bf52a5a43ff39a1a151de1e1c5": "20 Super Hot Egypt Quest (EQ)",
  "93d7adc46ff643d53391e23c31f8f8f4523b07c2": "20 Super Power",
  "193f1399413394c7d3547a281cad629666f824ac": "20 Super Power VIP",
  "9b9761ddef45e597dff2bcf67d655780fc7d93bb": "20 Super Roll",
  "861a8c8e553e7ab66b1797e36083232c1645cd7b": "20 Super Stars",
  "912e6a4004b9819aa480a175e9f92739c1652ba6": "20 Vampire Beast",
  "757de930b6dd317cbbd527fd44918354ecd396bc": "20 Wild Goals",
  "235d1d00af7838dfcdfcc98a23d22f1e22fb0cb6": "20 Wild Goals Dice",
  "c0c8c906c3aab187c5adc39f198d6f89d864a3a2": "20000 Leagues Under The Sea",
  "216c9859a29816ad6d5192753041c708e749cd65": "243 Chili",
  "5427a06a2c91f5579770a1e055c635132c5001b9": "243 Christmas Fruits",
  "97b422b9ab57d64ca686a317cced9a8b12bf7c29": "243 Clover Fruits",
  "fa608ae38e5a44ba8eff2aff18998ffc76adf020": "243 Crystal Fruits Deluxe",
  "900b97576cac8019480862d34d7e531ffb93f436": "243 Crystal Fruits Reversed",
  "bdc360e3db5ad4ea1c0d87b73156f76b63324e62": "243 Fire'n'Diamonds",
  "b3a1e46e7dedb017a32822b98cf236a81e5b2e63": "243 Zeus Fruits",
  "8063f87816267eae85d02d0962f0708e56e74090": "24D Spin",
  "6978bf2515aec51306f510e80ad01b881f0b7300": "24k Dragon",
  "57387a07281a1aef41bb80108e9506da087492cb": "25 Cookies: Hit the Bonus™",
  "ba88ebcc0e9b5825d829dfe6612b3b4e79ac0441": "25 Red Hot 7 Clover Link",
  "cb2deef36552bfe438d5e1923e57881c2d19d3d9": "25 Red Hot Burning Clover Link [CC] [linked]",
  "494bff74455835c5782acc68bcb520dfe6f2d347": "256 Frutas Grandes",
  "c994aff49d656cabe227bf834047e8e59b8d0bab": "27 Dice",
  "7b611945aafe03a12fde032f0feaa00cb3818193": "27 Eternal Hot",
  "7de600179b933f3613aec4cf01e66af2ce661946": "27 Fruit Ways",
  "301b44f58a9b7d9e90ffc3981e651871d3071374": "27 Wild Shots",
  "a0d6c32f946a443e4bcd0e690f55e7dc17b14a88": "27 Wild Shots Dice",
  "c8de14d1e909d281ed9f0016505b8eef0aa2cc20": "27 Wins",
  "1367e9aa3b8290b9530cfe0cf71d716812b4ae81": "28 Mansions",
  "b47de51f9784da3cbb16d6d8edaf4fe55f4cd483": "3 African Drums",
  "a645ba6997213f23327d974cc0adb0cd0fc05c9a": "3 Aztec Temples",
  "2de57d9a6aadc0add745db0cf5d843cc578357e1": "3 Big Barrels Aztec",
  "842a37920e66858a108b7c341663dc1401da03c9": "3 Big Barrels Buffalo",
  "d5d021ea81ea94f448a034a5aaf0bcf1a12d9dcd": "3 Blades & Blessings",
  "327f2b0da6819e0d526842a9e58adb535a48fbd4": "3 Butterflies",
  "4f1108aba865959a710c219375c6ca308e8b0be4": "3 buzzing Wilds",
  "6c8bbd3aaf4e657ebdd6cbdf4e63a655b6d33052": "3 Buzzing Wilds",
  "88d6ea9e703b0c110643ac455d81fa01756a19e3": "3 Carts of Gold: Hold and Win",
  "55e7bce123f1790f025c0c09097a6a600a7a56e7": "3 Chillies and Joker: Hold and Win",
  "0b2ddf04e74997c8bdf7cb89fbd90f63c028ed08": "3 Clover Pots Extra",
  "33e60803b205196a609d9fca6c5f13c8497eadd7": "3 Clown Monty",
  "59948c57ebcb48323167cdf62978ed4db60910c0": "3 Clown Monty II",
  "adc990df5830b1073789203d9674b94e2f939d9b": "3 Cursed Chests: Hold & Win",
  "b2071084dda6381174b2d60d0b9442f770148b4e": "3 Dancing Monkeys",
  "9d446156eb0cd8c2814ee64e1abc9b4d4a81c962": "3 Dancing Monkeys",
  "e403b14b5543b45d0c5fdc7e4b6f9ac38c4110cf": "3 Egypt Chests",
  "fad92b14650b1e9b2db6d272cd2a5b5d31a3d52a": "3 Energy Crowns",
  "1c0a9d697dcc460bdbdc71068abb4cde78c51996": "3 Fortune Pots",
  "7b56052918eee45aec776bf3f17799ff1e8044d9": "3 Fortune Pots Hold & Win",
  "fd05d30d2d0260dc78e21c157f5ed9893df9ce74": "3 Fruits Win: 10 Lines",
  "8aa343fcb9253818be765bd159c817644d25208b": "3 Genie Wishes",
  "1af026be94dcac9e8fb63c4b38305d6e8eddca79": "3 Genie Wishes",
  "0cfc5f0f8475cbf73467bcabb1532ca16e90678b": "3 Gladiators Vs Caesar",
  "6a13bd87955692d3f17ecb1bec041fcd7968c6a5": "3 Hot Teapots",
  "28402e5591cfe45e3b0e99c2159f4624355bbc82": "3 Jewel Crowns",
  "df11999e7bcb3d8a4f561ccb86cf136a6d47b379": "3 Kingdoms - Battle of Red Cliffs",
  "7b7d17e584249c7944d934c1e0b253d40f1f80d3": "3 Kingdoms - Battle of Red Cliffs",
  "86e9dd51b11cb887e57077ccbe8f9cf7f2f62976": "3 Luxor Pots: Hold and Win",
  "0ede6a93ac5d9e89d6e9ee6bc2d8925c67c164da": "3 Magic Eggs",
  "71cc8acd9107400c9e0aaa0474d21b2ca2cafa7f": "3 Magic Eggs",
  "4b60e8605402fab0f357b40b1824e3b714953983": "3 Magic Lamps: Hold and Win",
  "43d79e6039c7ad10a06a4b75c1cf7d46f4f6053d": "3 Magic Pots",
  "7a0542f6ecda7aac2367dedc16cf83a3fc3900dd": "3 Mermaids",
  "52ee02d0ce5453eaacf1a2416fe81019ae3acbe0": "3 Numbers",
  "b7f5e3d1f884f269e847d1dfc3c260ec17447167": "3 Pharaohs",
  "f67c6b2044e02ae4d6d5416ecb5219b2686555db": "3 Piggies of Bank",
  "853aa02983f86952b9d09c85b2985203137c5d28": "3 Pirate Barrels: Hold and Win",
  "e769fa51f1f5d9027428fdd8a103b093b1cd960e": "3 Pots of Egypt",
  "7adceda754afdfe7746561177f0bac0270160c7e": "3 Pots of Luck",
  "8be643de2b5df4fd6176096e7f2c321dcf42836d": "3 Pots Riches Extra: Hold and Win",
  "5f691fc94e514d11e5166a2f7952f899d10d9155": "3 Pots Riches: Hold and Win",
  "a19ec56ddda14dd06d92dfd921229cf7330c92ff": "3 Ribbon Pots",
  "333db2accad7124ad673779acb45c677e37da731": "3 Royal Bags",
  "14e53d12964b53fe5a53e91f3199f02f71350f74": "3 Royal Coins: Hold and Win",
  "3363b42e340a34c27b6db109289d8542ecf86982": "3 Street Sevens",
  "217d79bbbdab935d19790fe77b2bfeaf757f1f84": "3 Tombs",
  "4142a5af16490ef40d24326d710b164dc368a430": "30 Spicy Dice",
  "05d83e8c0436ce825ce56da2141e1d4b1eab1da6": "30 Spicy Fruits",
  "6c8ccbc442f9a315f60624cadeda286256992db0": "30 Spicy Fruits",
  "6fb95657280fc20e9887cf42898fadd9a9117f97": "30 Spinning 7’s",
  "6474c4b3ce3658b9b9c04a7f565741e55deaa4b6": "30 Summer Bliss",
  "5c96562ad54b3cc6119ce36147a2b68b22e3c172": "3x Catch",
  "7aab90600a898a02c2c1ddf579e4496f722b3597": "3x Monkeys",
  "a785724c6dd313666830606e32c6e8919a610622": "3x Super Peppers",
  "b9634bc19080d316d9281979e11133a313e09d1a": "4 Pots Riches: Hold and Win",
  "722688acdb400a2882ee9e91a8a139df606116a4": "4 Supercharged Clovers: Hold and Win",
  "f6c0f085816a4e71ca11709058667331dcb58082": "40 Alebrijes Eternal",
  "e38625e228bcbe7a8056d2b237e715f3e2407490": "40 Almighty Ramses II",
  "a5efe32792c40c35e5c1e585d8e9f3f7a0aa33a5": "40 Art Of Gold 6 Reels Dice Edition",
  "df391c068c2965d71f36ca3e70ead18e3bad226d": "40 Art of Gold Dice Edition",
  "aed7cc72e70bcdb274ddb59b77230078996feedf": "40 Art Of Gold Dice Edition Golden Coins Link",
  "c506f23d2c799c14aa8f05b89509af2c83c8d3ed": "40 Art of Gold Dice Edition Golden Coins Link VIP",
  "fb28d34422574560414aa90bccd6e9704206642c": "40 Bulky Dice",
  "aaf3ad4edf15a6bddccf553545ee3d2c8be79617": "40 Bulky Dice 6 Reels",
  "b96c3024994969cf8dc38a63c214baccbdca90fe": "40 Bulky Dice Golden Coins Link",
  "97e6afd21b97caf9c3f7b62657a8481e43b60a2b": "40 Bulky Dice Golden Coins Link VIP",
  "023397ecba635e0e8944caa11e422f925f57d697": "40 Bulky Fruits",
  "0b23737f1341f4e3e7f1039b3cd341e3f48d56a6": "40 Bulky Fruits 6 Reels",
  "989be1967ae405833baa43eda872233db595c0e5": "40 Bulky Fruits Buy Bonus",
  "845a80cc979f88c29314fe155cf33d7159570583": "40 Bulky Fruits Golden Coins Link",
  "7d2a29ec2249509d844e2b90fe20f300bcd169bc": "40 Bulky Fruits Golden Coins Link VIP",
  "bc8a851822630d8806763b0ec43685109e765ebc": "40 Burning Clover",
  "1da04c26a4f6d7e989562609cb54787b25cae1b1": "40 Burning Clover 6 Reels",
  "e75cbdf9ca7f3a1ab7b6dc0ecb91c9ff79c8dad6": "40 Burning Dice",
  "afac52af7ca56e83d897bdf90a94d9b558b352fd": "40 Burning Hot",
  "d95d7626afa06d6ba5c01e464680a83e9f2386dc": "40 Burning Hot",
  "0ba62a1c56ed23e96347d9f1b24ece191e472bac": "40 Burning Hot 6 reels",
  "172b26e8a3039a591572378bb838b6dd9aba8f85": "40 Burning Hot 6 Reels",
  "7686ad766310457ca918c7ec27c4f497423b2f00": "40 BURNING HOT BELL LINK",
  "31226fe87444c0178494f30778643ac5bc50ad07": "40 BURNING HOT BELL LINK VIP",
  "23d3b8767dae4b8103dfa94475746ca64830baae": "40 Burning Hot Buy Bonus",
  "e090e5f6eb1f372be1502fbae88266998e1d8036": "40 Burning Power",
  "296f9f5eb2e809bc9cf32dc30d325abaa0bf4392": "40 Burning Roll",
  "592bb8f343d21c8e467ff5bd75ac244a44f31524": "40 Burning Roll VIP",
  "1fb4293171683c447c101f15d1e78f3a13c3a536": "40 Charming Joker",
  "993132b250ed7e87e65951a096d4b23b6095b46d": "40 Clover Hit",
  "fab3237d8caa44cff17b4348860ed90f9f0b3a9e": "40 Crown Hit",
  "8988bff908bae5093a82165c8f2efeac02617dca": "40 Crown hot",
  "c5b852116f0b7b1ff67292556230851ac77cb9f5": "40 Dazzling Cash",
  "06a88cc127f83d7a61fc0b0b641b0154a0ca73b0": "40 Dazzling Hot",
  "4d7044594525f471352cad8b6f96c854897a908c": "40 Dazzling Roll",
  "c8f93ee325e42af2fa72b2708ef403a00efc5e7e": "40 Dazzling Roll VIP",
  "c307cb234c25519fd25dd1bddbe191a332f74b22": "40 Diamond Plus",
  "43fcab7bd0b5945f002ccc611d165422577f4105": "40 Extra Crown",
  "45e0f9a2ef16a5cfe81182390bdbeb864c14c595": "40 Extra Crown 6 Reels",
  "ea8abadaae83c1f0dd5015b5ccd95517d73a8375": "40 Extra Crown Classic Dice",
  "e93c43fd7421487287ed6a6437a2434fa06ec3d1": "40 Extra Crown Classic Dice Golden Coins Link",
  "053ebf3fb128da1666ffbd9e1b097630acd2b440": "40 Extra Crown Classic Dice Golden Coins Link VIP",
  "4144ba574a909b64e9646af0041288a0bf9abfdc": "40 Extra Crown Golden Coins Link",
  "38bbd377bf80681f9166c37aa22b8252a562c5f1": "40 Extra Crown Golden Coins Link VIP",
  "6d19d85a80f267d330bb057c2b931b9d436b819a": "40 Fruits & Gold",
  "2ed128527eabdb7779651a179a5694a52dc6aa7b": "40 Glossy Hot",
  "7d1499dbc40f02f4694b6703dda9c1c82d801948": "40 Golden Coins",
  "5fab09c4b53142ed9e5895a572ade3e783e6a5df": "40 Golden Coins Dice Edition",
  "c7cad73d4dcdabdf643a33f691b88c5963042302": "40 Golden Coins: Reel Fishing",
  "2d3391e924a6cb95d375686c4018d1fecbcf798b": "40 Happy Seven",
  "dc79ee9f4ac83e09b000b839c1b54040f2ad1afc": "40 Hot & Cash",
  "11f7f05f3eb6e63cd5f097a1dbfff3cff18f027f": "40 Imperial Crown linked",
  "5af6ddff9fb424798f5ab928236cba63cadc192a": "40 Joker Hit",
  "fbaae1c6f0b9424ccc1e4bc02e9516250225ae3d": "40 Joker Roll",
  "505cb23c46915130412d27c30396966ca76b3ea8": "40 Joker Roll VIP",
  "ab98e23e4ce16b205010616806e39ec14dcc7074": "40 King",
  "3338215202912f362442d67c0cde227ad60f4517": "40 Leprechaun Hot",
  "3cf8ebf59325cf26400fb26222dd6f248eb3c5ca": "40 Lucky king",
  "c2c0d12a57d533eab69798b0ad07636736851b9a": "40 Lucky King",
  "fa13f457ca73ee022207ad20abb29d7807a54f72": "40 Lucky King Bell Link",
  "40afd59806b0956d62c458b6d432035a8ad6d90e": "40 Lucky King Bell Link VIP",
  "6e20cde2f6cee74b0d65181ea156383b9842b750": "40 Lucky King Extreme Bell Link",
  "591d8a0eb55448e6bf266b9a1e56dd78e1882258": "40 Lucky King Extreme Bell Link VIP",
  "08e055268736fbf8df5038c48fdfdfde7b8275e1": "40 Lucky Wilds Hot",
  "7001dceb72d5b8c5489b88673b00e67d28fe8ca2": "40 Lucky Wilds Hot Golden Coins Link VIP",
  "6d7c09b80838015ed7349bdcb9f9b8517f25b54f": "40 Luxury Dice",
  "26a2140277ba84accdfad67f5fac203f028707f9": "40 Mega Clover",
  "b6a0ba91cd28badbff1461d475fa858f5392f8ad": "40 Mega Clover",
  "c5b5be2f8875868841ba1ab19ee89e4fe00f1e42": "40 Mystic Gem",
  "a478c902b07c6a200adfa9607f92b8de95592e04": "40 Mystic Gem Golden Coins Link",
  "8fbe0ca8164d8dba2948cc4f0f64cb9e2372c3f4": "40 Mystic Gem Golden Coins Link VIP",
  "944c6aaeacf0a9c2e13a439574df76ba02360557": "40 Power Hot",
  "0f3f94fcdd10e17136fc3abcc4f0045294e0027c": "40 Power Hot Dice Edition",
  "6706ead1f062eb0be07b7d261f847c9467522a49": "40 Power Hot Dice Edition Golden Coins Link",
  "aae139b9b4533e21d18c311e25c45fc17c6bf030": "40 Power Hot Dice Edition Golden Coins Link VIP",
  "06824f1dcf8b63278705cf01b2c4ebf7c0a1eece": "40 Power Hot Golden Coins Link",
  "baa2b189cbcf5cd5a3c4cc2f6abebef1a248689a": "40 Power Hot Golden Coins Link VIP",
  "a017b5d10aac5a89c8c2eb6d4ae873e04127f96e": "40 Shining Crown",
  "811c8a1d9af8c2f2a44002a21485e6c260347199": "40 SHINING CROWN BELL LINK",
  "e9ca66a3d73669fbb54b1c55f0811f6263d75300": "40 SHINING CROWN BELL LINK VIP",
  "1d7f2168bdd16649d51de51f83fcf6d9c5afd6b4": "40 Shining Rainbow",
  "851388341daedcff95df5e2e594444fec030b051": "40 Shining Rainbow High RTP",
  "a2e90d20a3ff490296d4bd12e21ad9e2fda01a3a": "40 Shining Rainbow High RTP VIP",
  "55ce0881869a4899e7ba26c58c6a4250dd62bb65": "40 Shining Rainbow VIP",
  "3dcbb655a24b32bcd9989c211fb26153bb83f08a": "40 Shining Roll",
  "fbb07ef177e664e66f09062a5aa90b48af7dfd3f": "40 Shining Roll VIP",
  "473ce699b70b846fd5238f42e6b9fb87971aa949": "40 Shiny Hit",
  "6a32f2a57dfb56d2d445485c2ad41ad70413d40f": "40 Super Dice",
  "545b04f36ca3012af124e32568bc3a60f4ac5845": "40 Super Fruits",
  "75d26c0fe242f86e06e04def98503abdceaf47c8": "40 Super Fruits Bell Link",
  "d77516121066f278f0c408bb78fc3e09b067141a": "40 Super Fruits Bell Link VIP",
  "73895e6df651bef155a8c3e4d5acbef8898b4918": "40 Super Hot",
  "df6e46af666e5b37f07a3c40d306e05b6c0dfed9": "40 Super Hot",
  "625b46889d0bcf27eee8fe43b09cf8646b38d1c9": "40 SUPER HOT",
  "f87bf5c3d77121e7a13654d487267a0c492e1f09": "40 SUPER HOT BELL LINK",
  "ebc91e9a134f0b74739e3d553fa692913d9e8b08": "40 Super Hot Bell Link Boost",
  "e3c2df00edf92f3428c4aae8549144fd4e8c96ff": "40 Super Hot Bell Link Boost VIP",
  "f87fec57bf57f5e97680c3f3296c61dc11f3f0d2": "40 SUPER HOT BELL LINK VIP",
  "f53e4af793cd54072464a91506cf396c71ce93d7": "40 Super Power",
  "f7f4d2f67d3e126fc2ba4c067815a1227ccf6003": "40 Super Roll",
  "0cbc13fe9578ef7e26fc936eaec0821f86195c37": "40 Ultra Respin",
  "403dbbff49754d8b206c8f22d4a164b7321b7185": "40 Vampire Beast",
  "410efccd476617ba272f8cff1afb35585be309a6": "40 Wild Fire 6",
  "c5b2ff3d258aa0a755397cf47523c0603eb3411c": "40 Wild Gobbler",
  "43d6a9ad28aa3e54b4227ca5360480d0b3afe3d1": "40 Zodiac Wheel Bell Link",
  "21b59a18aeb6d823026a4a5b94c7170f23c9e3eb": "40 Zodiac Wheel Bell Link VIP",
  "2a5f0ec29490656f74717e74951f79b8b66275af": "5 Bloodlusts",
  "d071997410bfdae1533cd76f127342f12b106550": "5 Burning Clover",
  "0aab82151548e235a3458c7f3a0f058b27b6030f": "5 Burning Heart",
  "b39305757eebecc9027678741b5f93ffe8d12603": "5 Burning Heart",
  "d991a5d0b3b029b8bce624f3c243fa89302e471b": "5 Burning Power",
  "26251377fccb1ae9b77b06f6b004845c3cf5efd4": "5 Burning Roll",
  "bb11aa6277c06b5fce4ca32cc62567dbff085dc5": "5 Burning Roll VIP",
  "ad4fd03d56ecdcc928468ebdaf3ab3f5cd9f583a": "5 Clover Hit",
  "5ee080128983fe955cab62900a888900b347817d": "5 Crown Hit",
  "b179a20dbc5cf747dc20f4f89c6de3d67d264d62": "5 Crown Hot",
  "c0fa96a4e5e9c70c921ffd4fa71a903437ebecb6": "5 Dazzling Cash",
  "e233a88da844613cdec18062f3562457e06a1541": "5 Dazzling Hot",
  "efa677228b6cb83f0771b016f04be48d4fb48ad8": "5 Dazzling Hot",
  "ad94a4391444aa87bd7dc17b6ef0d657592e939a": "5 DAZZLING HOT BELL LINK",
  "c13e17a3f01a3f592f0ddf1306e418338675f524": "5 DAZZLING HOT BELL LINK VIP",
  "56b1f815c19d52d52c755970951d0af86c17fc8d": "5 Diamond Plus",
  "c039b4a268c969d5973da02bbdafc3aac6e451f0": "5 Extra Crown",
  "0da307386bf0ad6b7f0b11b16f2847e3e840467b": "5 Fortunator",
  "5b0f58d27c96f461fd59063655e8ddefeb233359": "5 Frozen Charms MegaWays",
  "cfb0d9a8c8cf4e7d33ef6ce74bb1428b5c4ca2d9": "5 Fruit Invaders",
  "422d64b7ad36b778bcbb5d1ba12972ac5250d9a5": "5 Glossy Dice",
  "460668ec6e80dab9002898237f846a7d8d3a27a6": "5 Glossy Hot",
  "698640c9390a1ea9382dcc817ce6b03546831529": "5 Gods of War",
  "b4d2ef1857e0530bca820766052b9bc1345f479c": "5 Great Star",
  "d8df6a42a1efe18f3b09ed132d3d52289d152d85": "5 Heroes",
  "c81ca4e622f7b3bc93469e657b3515723408b65f": "5 Hot Dice",
  "aca5d5559e567eabf20f5b9474bd1bf38ecff53e": "5 Joker Hit",
  "0b933410e164f96892953170f2fff5ab1832d900": "5 Juggle Fruits",
  "575ef347abf51fcf84702f6a40affbea91e9544d": "5 Leprechaun Roll",
  "a5caa29670bf96fca37a05eb9430f512ff50ec7d": "5 Leprechaun Roll VIP",
  "2ba9b90123b6918af56bdbdab2be02909bdcc6b4": "5 Line Bonus 21",
  "365867a74d16b236d3b3fb5a18df3c5a1f8d1d23": "5 Line Hold and Spin",
  "244231cdaed598960c1c399208f377458d38980a": "5 Lions",
  "ec16ab4f8e50ab769619562713978e8df56e7c04": "5 Lions Dance",
  "f9305283215fce367e493d5535ca978a338be7e8": "5 Lions Dance",
  "68355d691e38d8aba85d60553b9e77bb0ea84b9c": "5 Lions Gold",
  "5492e0a230ed50e699fbe3bb7fded33a02135c63": "5 Lions Gold",
  "f6971815347f67cdaf74af07eb59f82e450607d5": "5 Lions Megaways",
  "65c9853f331c68dccca2609ac239e048e9a6d11c": "5 Lions Megaways",
  "b6d73d906c7868b152e1abd3f4a971b6f0cf53a3": "5 Lions Megaways 2",
  "c8bc9d5d101dfc2fd3c5a8dcfa9606310cd82f59": "5 Lions Megaways 2",
  "3ccb7d702a39c936867c531984fd207d1345535a": "5 Lions Reborn",
  "32f8e7e685215df2b0483d0a9890535283c9eddf": "5 Lions Reborn",
  "e522e7cdbf2dce71c9c2cb138c4bb1ad6d480dac": "5 Power Hot",
  "2009852286866da03c84c1d48b08a15366c01e0d": "5 Rabbits Megaways",
  "96f68cdec9f80a61b692bbd02a0feb3d769058d5": "5 Shining Roll",
  "1128871ff4789ef9c51de3bd5ca2cf3189cbb4be": "5 Shiny Hit",
  "e3bc057408da9109d23b764b4ba60c54c8b7a7a8": "5 Super Fruits",
  "6100362378bd3b07349d72cab19460c861c68113": "5 Super Power",
  "b57f2daaca5c8a4d8e3f1934afce47d60022faac": "5 Super Roll",
  "b811adbe0a3e703befde1075d93c9e21e91a0c0a": "5 Super Roll VIP",
  "a62509a31b1fa1a68006b0d1c723ef7cc34dd1fb": "5 Wild Wild Peppers",
  "a0ad3baad878cb923f9f9a5b4cf663c9cb71a15f": "50 Amazons' Battle",
  "44896b461f3f6b79c53850b149ead594ff5a5557": "50 Horses",
  "e1a6d2c601a1663066bc651d8852c836856400f2": "50 Hot Blast",
  "96a23a942c604b1dee9d0d626bce1eec577aba00": "50 Hot Burst",
  "d33f563ec1a50d40a389fda303864c4bd5e01cf5": "50 Red Hot 7 Clover Link",
  "ca3acabc7711f2e4297ccda245cee02af5b6e9ff": "50 Red Hot Burning Clover Link [CC] [linked]",
  "eb37c4d899dd342ff02cbe54475c0b79d3a0ebbc": "500 Juicy Fruits",
  "fcb9d9b5309f39c004a6f56c705eec25ca4c5994": "5LuckyLions",
  "5c2e3a35c9bae88f4a6b08cf5be87ec9abcc4a56": "5Mariachis",
  "08683e53eb92f80a940a6837bcee34d3ca79edbd": "5x Magic",
  "4fb65244281b3e66da9059eecea817ea114fe772": "6 Jokers",
  "21eae262079ae31150729bccb544b2d3f7ecb596": "6 Jokers",
  "668fd6ddf7c6ba764445df4848fcc5f4c166b7ba": "64 Gold Coins Hold and Win",
  "a46133d45da23b793094b7248706893ade1ea54a": "64 Gold Coins Hold and Win 20,000",
  "60f3ac8f35668b739fe40deb8209da9a9ea9e732": "64 Presents Hold and Win",
  "6ed360e61a6f783d369660dff7a4f17891c1acb6": "7 & Crystals",
  "3058435181c3c08739b01263361af25fdc23262a": "7 & Crystals Dice",
  "28d42a62f5ed7ea85e2a87db7c82b098bed3bc83": "7 & Fruits Rush",
  "e400d08284194592d00887e50ddd290662e66527": "7 & Hot Fruits",
  "b73f3de5b088afff17924f86e07a188884d41974": "7 Clovers of Fortune",
  "7c18abd2047a3bb8a78e43c825dd78e0288672dd": "7 Clovers of Fortune",
  "6fe1fee80c8b79f56170120609f5660809bc1bba": "7 Fruits",
  "b9d4dbb63aa26393b62b7eb14f66f038bd6293c4": "7 Heroines",
  "7c6a917ff0ac551f05a40ab5f3fe6360d3e5553a": "7 Monkeys",
  "d82c35c628cbd4c248b7392f99101466fee17db7": "7 Monkeys",
  "cce8ec69bdffc3234d080b842b9e7e9c07ac90bc": "7 Piggies",
  "8aa018a0d957ce52be6e55f93ed50ff063565f4d": "7 Piggies",
  "bd792c3d9f5f11b96dff1cffbaa2c27e3e5c1d6e": "7 Piggies 5,000",
  "b1594f36f8ac5e74675bc09bd487fae8168e2c31": "7 Sinners",
  "a7b98707c014bdf8085997201d1fe2dc8f48497b": "7 Sins",
  "ed629bac4e671a0616ecbb3f15dd3c1df618924f": "777 Coins",
  "b7e96aede87e383e3bd07f3937f3bae87839a8ab": "777 Fruity Coins",
  "81ce000b60e45c1cce33d32f43da9c3ee326015d": "777 Gems Fusion Reels",
  "3cc3f0c461f8a7e6de0419d2a52cdfbfab03deba": "777 Heist",
  "2f1d8b8bd2c8e8158f9e933c7e41ab0fb9e76e5c": "777 Heist 2 The Art Forger",
  "49cd444e03dcc24b5f44073f5bc2179120c7b508": "777 Kickoff",
  "5fb5bd30a1f563b55fb642d746e0d455dca25b29": "777 Rush",
  "f49bc5e4fcb862e11327f743fa8b3f912663bdab": "777 Rush",
  "00567ab6764d940f0bcd05dd0c59c0dd0db9a8f7": "777 Sizzling Wins: 5 lines",
  "d98d2389de3494e18063fb38806d00c49c6d96ed": "777 Vegas",
  "48057371583c98a0e3c82f0175d4c7a8ebd8681e": "777 Wheel Blitz",
  "195710ec1f5b36f6ea9cb01980e6c669caa74aa7": "7s Fruit Fiesta",
  "e5e8505586b3bb49c70f4e423a48bfe744439f3f": "7s Wild",
  "b139cb0d81c878811ace3168f69df108d8cc016e": "7s Wild Gold",
  "e8c776ac1023b99bbbd5eabfce4412841417e396": "7x7 Fruity Shots",
  "e3b6730b665f5ed92be6b8e2a33286a14b976f7e": "7x7 Fruity Shots VIP",
  "7ec4526396751bf4bca0f49dbdb617b5e0a964ad": "8 Dragons",
  "74506eb6d84da2df63eb00419c3aca2836751c9d": "8 Dragons",
  "43dd9f1101a9ca41b4e4e2bc389f7d86a9718702": "8 Golden Dragon Challenge",
  "e60b0398d1cf0b3eff6eb5d7f9be1d30e45560bf": "8 Golden Dragon Challenge",
  "66f0d35223f9215ce8c9d162907fc132fa8c674a": "81 Crystal Fruits",
  "5f52e4f25ad92f711f113305449b6069f7251cd2": "81 Dice",
  "1e20678c093ce1caff04604073d12f282eb33e44": "81 Frutas Grandes",
  "08238244bccbf557248466b4b6dd6762c97613dd": "81 Frutas Grandes VIP",
  "b3e673e6322fe78e4148b4303de48e7b9cdaf751": "81 Joker Hot Reels",
  "80e105373208b1e665a55dda8bedd22057657242": "81 JokerX",
  "65972a80c78f91b398107c541819ac3c825c0ddc": "81 Tumble Hot",
  "43ff2d45dc9fd86eab549f756f771bfac3f9a2bb": "81 Tumble Hot High RTP",
  "cd933f33de5820c6258f94b846914ffd28b60b79": "81 Tumble Hot High RTP VIP",
  "0652daaa80016023fbcc3e64debfe14f1e40e3a9": "81 Tumble Hot VIP",
  "6e6814b5ffa7cf226c31717745e5c38e117dd0cd": "81 Vegas Magic",
  "11f534cb70ac5512d9be9f7f1ad896be4f11ba29": "81 Wins",
  "8803c02d16a5b94accddbc9629eaa99c2bc9a08b": "88 Golden",
  "750a78bf6a10a990473e50aa6ed32df839f8da32": "888 Bonanza",
  "27af74b722c23e1b7a89a58316adbcc0f0c2f495": "888 Dragons",
  "9b851fadf444f01234b6545ffd8f6f7cd1ed0029": "9 Circles of Hell",
  "e81ba8e53bdb5846b0a4cda1b3ff4d55d9e5517a": "9 Dragon Kings",
  "608b0940ef4c1fbcaa1d232731e6284d12af62b0": "9 STARS",
  "bde0b72498765cb7b9f47def299e9e029af97f62": "9 Stars Ablaze",
  "0ee71c2f5b51c333ec5eacadfaf0cb30f9ff5f14": "9x Monkey Lock 2 Spin",
  "2658c39835dcbb1348c2c6559b2aaf8ea163f1f8": "A Girl's Best Friend",
  "05dcf709af9a8986a030be4cf75528fa3e551b49": "A Thirsty Crow",
  "3b722f052f0fe2c60c8a179c22d7661a2d69d840": "Aarupolis",
  "c1a861bc1db974893c57a094bccc4d29239ea7b6": "Absolutely Mammoth",
  "75f5e5ac069e0106700dc04d48837fedb754964e": "Ace of Spades",
  "949cb101856a767e8f37c3dcd3c2d6e82a8f82de": "Acrobats",
  "9fc9ae0e23956386928179e0268f2414b0f75941": "Action Jack",
  "855da7ddc7f5f77d06c465f266328cfe540dc575": "Action Joker",
  "3bd54c1eeb47bc53475bf19e737eb360ed035b0f": "Action Money",
  "0b5debf75aec570c5cc1697893700ff973dd37ba": "Adamant Bang 20",
  "952cb0b67ffcc7d969725807c3f4cec04edcd1ee": "Adamant Bang 40",
  "c1bc04dc3a71bda9b84e9602153d5ec65e7f49cf": "Adamant Bang 50",
  "32b8906150ca5ff89c8276f4b95635fcb67ca51e": "Admiral Nelson",
  "534db23ec7e1db484e1426f10b24ac0dbcc04f1a": "Africa Gold",
  "b09992409036565cd4b1b96a96b3853a09b8cbf5": "Africa Gold 2",
  "0ee8fc020467ed93fd78cac34662dd1f47ee071f": "Africa Run",
  "052abb1b2727c1a28ef08f071f2d3a8d8eabb1d5": "African Cats",
  "1f329b8f0973a533bc5de70dd8b4ed9a0c3cb04f": "african elephant",
  "d4e1b382c6637595a7cad44c15d8da91fe63e0a7": "African Elephant",
  "124498012bd717d29631778bb04506b1dcee1eec": "African Simba™",
  "bd2e75db26c051346bb63725a8064c82803e07ca": "Age of Asgard",
  "e760ce43c589fc2a579985074cc264285129e95e": "Age of Olympus: Apollo",
  "9486d9d3b6a3eb6f99c2da5dc84136be95e2c873": "Age of the Gods Norse: Book of Dwarves",
  "94c3f37482a65282f60ef8a55177c500e350b605": "Age of the Gods Norse: Gods and Giants",
  "14e7dc6ebb43e11c892b1a5266dd16c92c6c909a": "Age of the Gods: King of Asgard",
  "234e7a893d8f4f7b6efdda2b49c1eea8180eb614": "Age of Troy",
  "4004c8870102a79786c30169acbc25222ce3735a": "Age of Vikings",
  "b83efcf0daf8bc5d3a6f144b8c0f935a2d086842": "Agent Angels",
  "69ef5dbe769e52e50baf05463db84574fd616ef8": "Agent of Hearts",
  "72cf6c972500505078efe7bc3052dd6edef5cef6": "AgroCulture",
  "436aba02db87310f9eb52eabab2515ea0af20da5": "Aiko and the Wind Spirit",
  "658f669296427b1c0d1477c2e1905e900c2fb8af": "Akne Fruits",
  "7e053006a59a96a28bdd38fa513430fcd0765186": "Aladdin",
  "6c02a726b7d5121382a5dc2525e71475442f9fc4": "Aladdin and the Sorcerer",
  "c41abc7cebd0fff908dd5cc7a1b5bd6c5fb67595": "Aladdin and the Sorcerer",
  "39a64a780883329885e0e1b455f282d62e47176b": "ALCHEMY",
  "6ae33308d265d0e86ebc005523bbb9c7a18499a5": "Alchemy Redux",
  "3ddf0525f046dddd561ac097bd9575befedadf1a": "Alchemy Ways",
  "ad62c2a07f839e36efc693b6a83116f6ec99083b": "Alduin and Celdor",
  "07dca7f31a9678808b0631e239d99c7059df950a": "Alexander the Great",
  "c7e3f901514c91726ff8bb98f5c115fcee9f1529": "Alexander's Fortune",
  "7873143591a6b8b1b7d1f1377b12023c2824252c": "Ali Baba's Bounty",
  "2711a57f6583f8dc77be06bbe636339b9886cfe2": "Alice Cooper and the Tome of Madness",
  "579da196d0de2ed4bfd0e23ea0783460fa0a603c": "Alice in MegaLand",
  "40ab8e0574423b8fdb40ef6c1df2a64cb438277b": "Alice In Wonderland",
  "b9b2a63cd78c93cc817dc061009d78e75a7bebff": "ALIEN FUN 41",
  "60fb09a7b599cc26ae70254a20342aaa1088def4": "ALIEN FUN DICE 41",
  "c89ca16c332662e8476ad32566b9b6d32ab356ee": "Alien Invaders",
  "a5b690601046b195dafbd1014b9faa770f63e051": "Alien Invaders",
  "d4b0707f82050cb6716eb78504b57b6390536dca": "Alien Tour",
  "030d1a04b10bc09d5c2d710d54bd497320b930b1": "Alien Turtles vs Humans",
  "96251977eb0ec80b721841138d4b44680579e5f4": "All Ways Candy",
  "62f4a397d7b72284a478d30274e12e926d6274b9": "All Ways Fruits",
  "f1d64f2ad75f2ce82994c1571cbfe47104b4d4a2": "All Ways Hot Fruits",
  "6539c0d37e5c413715feadf566f78c35ae8a9438": "All Ways Joker",
  "36250ced596424003a95e5ec9a44cd53a4863ad7": "All Ways Win",
  "0947a20a49985b0d2c0ade8004b58e1c64dbb05c": "AllForOne",
  "1a25d05a0f428254014b31b58f1d5e31c33ca8f8": "Almighty Ramses II",
  "ba4ce3e66dcd0a0eae6240fc1264eb55762a1c3b": "ALMIGHTY REELS - Power of Zeus",
  "2858fcb472cea86bd9a6a1deb7639b9b5cb9a856": "Aloha Party",
  "238137f437dc6f8a89ef03abdaf4ec7e5d834ad3": "Alohawaii: Cash Collect",
  "4164c43347b6e107cfe99efb35f38b355178f0d2": "Alpha Eagle",
  "9ffc81a08efccaeae67e67baadfd9e077d9e3b29": "Altenar Sportsbook",
  "4229963e250a8eed7dba77cf7fe1bb8aea32683f": "Always 8 Baccarat",
  "dcb4ed7b5596f35dd809a27ddda5ca7344685d5e": "Always 8 Baccarat",
  "cb58a61efa320665a4671bce9d66791694b88b39": "Always 8 Baccarat",
  "12cb83ab7272a0db5c70427861913e768db655ee": "Always 8 Baccarat",
  "472f0a2ddc1ab6d6a0be7013b2ebd606346a1b6b": "Always 9 Baccarat",
  "f2d9ebdc6d9d22c8d14a6d77745da8e313a98bff": "Always 9 Baccarat",
  "471c21b73bed9c8d85fd568c6b7ff3b126904598": "Always 9 Baccarat",
  "5227f57f6f2bbe00aa11b0f814d7411dd607149b": "Always 9 Baccarat",
  "fcdb0aba0e4570af205d601727a80dc01bfcfae8": "Always Hot™ deluxe",
  "4032c0bc68f4f5c104416eb25f3cdf9db9ef739a": "Amaterasu's Treasures x1000",
  "20dd2a56c2338f199e8b2e80d89e179d456abc4c": "Amazing Amazonia",
  "9399fa1666afa8b12b7162aa17a962c14d069962": "Amazing Money Machine",
  "a95787c0571025fdeb0bb4dc58041782cfaf9ed8": "Amazing Money Machine",
  "a3e87a12d7b0069bf4b19f1ab6313aa491cde8de": "Amazonia Wins",
  "086cfde09651ad68d4aa64b9787530fdfbd4e6c6": "Amazons' Battle",
  "7f374c6273bb8a8454b9247c71a3c0e4b54c58d7": "Amazons' Battle",
  "7e4a40336ad38a7c755f33f6b33fb6a9c15c4767": "American Burger",
  "34896f725f99c86e1a9178fffae029e0d740b3fc": "American Roulette",
  "25b62ac1533dccbc887aa06aca05090e74eb5b3d": "American Roulette",
  "486c64b2da36473fc8c16d2477f1fd635530751c": "American Roulette",
  "6a3df676ac19051914fc831775e5199ca6cdfc92": "American Roulette",
  "3f36eefb836d8ab699babc310abd9db5de91e348": "American Spirit",
  "135e8926061f4b3bbc33ddd0207e571e96597d0c": "Amigo Bronze Classic",
  "b8d99e4081897e790ff1d0a6410869c581c401ef": "Amigo Double Classic",
  "7b18c7ccd86bd1ca04752483d381228dfd329026": "Amigo Fruits 5",
  "c5b8282edf0fbdfcecb1c6ab2dacbae3c315892d": "Amigo Gift Store",
  "5de079f9d96637ac36098d50cfd00c403535cc0f": "Amigo Gold Classic",
  "c97069e511925c5a457ca44d693fbecc9ebb2c9a": "Amigo Hot 100",
  "ca14b3f08fcd91091108cfc03fb0b255e81fb114": "Amigo Hot 20",
  "ad247ecaa03ea20e339ef39e8e871c345c172a96": "Amigo Hot 40",
  "05a511f7da360ffa812c1911795a31f30b43788f": "Amigo Hot Classic",
  "78972095dc4337794f76b45cfacff390f5bda14c": "Amigo Lucky Fruits",
  "e15498223a2201e509ec9d458bac3155f90369a5": "Amigo Lucky Fruits: Pin Win",
  "01f66e1595261c327e6369e168a7507d962759e2": "Amigo Mighty Stars",
  "d43d8cdf07b40fe7c799177574afa7761d8f6299": "Amigo Monkey",
  "88dd3c6cddb13297ef59ec31ccb646d88143b5ce": "Amigo Monkey 2",
  "000bc75b54d93f59fc4a0b2679dca481a3b75a10": "Amigo Multifruits",
  "6893964e0bcad64462f83a3fbb0d6c2515b2183d": "Amigo Silver Classic",
  "e4336f45bb212cc168b2bea090d55e898a5d3e83": "Amigo Wild Luck",
  "72562a2ecdc769e173bca3b8bf212f93d23104c8": "An Escape from Alcatraz",
  "241685e2cff1562c94e9e657b5bdb9135fb036bf": "Anaconda Gold",
  "d611dc4b99276e36064540139139319ebe9544e5": "Anaconda Gold",
  "de0a079d093eb51fc5afb375dadf3d17b9dac461": "Anaconda Uncoiled",
  "860ca33f7c8876a6102ae807fe8b0923d43f9219": "Anaconda Wild 2",
  "2b6a51c297d584129e3792be7bf978ecf5f19ce7": "Anaconda Wild 2 Power Play",
  "a785e155db875a33be233c6b772d51a7ef4b3313": "Ancient Coins",
  "86110a014bf3161dfa13023f73c0c792fcbdf27e": "Ancient Dynasty",
  "55e5e3a5fc409f1be594e8d821077087a0150235": "Ancient Egypt",
  "15b25adea2ebf7aea8b46eb5649acbe14bb8a662": "Ancient Egypt",
  "9e35f9672a830395e2a92ea9a638568a26faa4c6": "Ancient Egypt Classic",
  "55fe89d226a732f295c270424d0bce277839d84e": "Ancient Egypt Classic",
  "556a1660ba2d82a7efb682c9c3642d4e86852466": "Ancient Island Megaways",
  "fefb1c14b5351539d0cb88e341364e0a5ade70ae": "Ancient Island Megaways",
  "03dab16bf240f1133d736ed7b8d17b3e005c53dd": "Ancient Pharaoh",
  "e1d774d7a4f8d0ab5098e09f00fce4d7361889a0": "Ancient Temple Gems",
  "26379d51281a74a831cd51d1d7dccf814288c447": "Ancient World Deluxe",
  "3b1029d05621f7b9e409542bb01f5cfbbd9e51de": "Angel vs Sinner",
  "5189dfc9abce593134428104b6d1f92deff2e6d6": "Angel vs Sinner",
  "bc3f6a513e0ed054dbc714d036dbe41bab9c3fa0": "Angry Piggies",
  "45f41484dbe0fbdb7b0d3d9fda60004acc2aab43": "Animal Dojo",
  "81712add0a09ccaf49f9719527d0ab7464be8aef": "Animal Housing",
  "581d2256f8451484453d6a04b9af85eabe900c41": "Animal Land",
  "edbb001d2a388ebb011ae5a7901277b8a0c26ba9": "Animal Madness",
  "ccb3fa873e0a85ba3644314766eb2dbf97919a8e": "Animal Rhapsody",
  "1cfda2b2bdade0137eb169d1b547b4c4fc26d33f": "Anime Mecha Megaways",
  "f56289c9337b0df220894547f37e47bb94e9e928": "Ankaa's Dawn",
  "a33b5a7c78fa16ece54929150455a2c1e44535d3": "Ankh of Anubis",
  "b6e8a3b345cd33a90b41bd02c0a25c757927ea49": "Ankh of Anubis Awakening",
  "423a15af8f55ba15e3f9825c76137e96c415bd96": "Annihilator",
  "f7e0faab559dc84d3729a3e697ed6153de2d25c0": "Ape of Luck",
  "a31f75b985b814b73652821a4bc33c2256bb4cf3": "Aphrodite Goes Wild",
  "7570c55c6ba54e2de7ea00671fe64d50f0cbd1c6": "Apocalypse Reels",
  "913942308393f851da4ee87a24cce176964e2744": "Apocalypse Super xNudge®",
  "0292af2eb019970d926253d87de8bac5635c83e5": "Apollo and Artemis",
  "7a18abfef8a9a73e650e0abb510db3d0a88d1490": "Aquatic Adventurer",
  "f3bb6633d32345f614663206965cfaf0018300f9": "Arabian Secret",
  "45c29d00a43619f4a4ddb68fd48e7e9220a29193": "Arabian Tales",
  "f2cf47c07911c62a19795aecd5d72591270cd244": "Arabian Wins",
  "eed528201ebf098fc79bafb4d632895ccbdd1a5b": "Arabic Roulette",
  "923406625c366acf86fbaf0bee241a006631c12f": "Arcane Beauties",
  "6db2187b052e038331b4afeb4f233a637390cba6": "ArcaneElements",
  "e5fcd8e047310a285c22ea8c3ce1a11268189f08": "arcanum",
  "80d5faa0af29119d4a2d33de04ba7d14860b6609": "Archer",
  "248c74bd9d7d2617f505b34d2ee72f390fa8eef2": "Archer Robin Hood",
  "7fedcc2d92343347d60bf21275d36c061f862c51": "Arctic Race",
  "3946b1e0eb35156f398adb5518ae909d3c74333b": "Arctic Storm",
  "2ff45e7962f892f9518c2f2a3c7b3c85b485f330": "Area 51 Lock 2 Spin",
  "ec4a017f8f30298c1e542b31493024437dba9b59": "Arena",
  "f480cf66503f4111f34a6b8175b50a06b9f9402a": "Ares God of War",
  "afcec9d0255392f6abb8a912c77e5670967ca130": "Argonauts",
  "418040b1eab23882a37d950680256cdb5602f60a": "Argonauts",
  "8298e64b8ee250ae73c5b4a6c955f51b8adde66c": "Arising Phoenix",
  "fa8628ffa671623bb9289b96f54c66f852e6b9fe": "Arizona James and The Lost Relics",
  "9a5bd27e7502b3821de6aa0a16cfe5debe55365c": "Army of Ares",
  "83d472432bd97636b53504dffccd246b324c57da": "Art of Gold",
  "776a96ca5eeed216a913f88671710f8c2a9d064a": "Art of Gold 6 Reels",
  "a37c69068054538c0a18f4f8581aa8901c70f9e3": "Art of Gold Golden Coins Link",
  "abca91ac9e979275b98c8d07eceb9bef7eef355a": "Art of Gold Golden Coins Link VIP",
  "86364f9fe46a827bd162e424ec81520b640cc4bf": "Arthur Pendragon",
  "b302991a45d5580ee643f30e5c62176fe9ec7ebd": "Arthur's Fortune",
  "022f2b3743f165c84ee345fbc154d4a3e4f9769f": "Arthurian Legend",
  "0342c68d1487cfcf3da903eb8febbd8ba48ea611": "Artificial Intelligence",
  "182435459eddb08384ddf68b69d3e18bff73966f": "Artist Studio",
  "bb17df00ae44768e69ebf358e54c8aed57d5879d": "Asgard",
  "4c340d2bf7ebb1acb42b879e9c21fdf2df9d4a8e": "Asgard",
  "6b17ce6db4e5e65283d5da6eebb044d446ccf0f8": "ashoka",
  "3d98d25d8d3c93c9ff732eae5c77c4d293f53dfc": "ashoka-eternal",
  "d817beaec8316ff3b3873e950599d194dd0ff058": "Asian Palace",
  "161cee64a38c7dcfe329082ba88adab189d81962": "Assassin Mission",
  "9cea56259a777a8b7a065832032f0797c3c7632b": "Astrology",
  "b9b407b10443f265a38bcfb2a645029807d865b8": "Athena Ascending",
  "636699c11c00856eee49fb9e3b976858a5cf596d": "Atlantide",
  "be29fabee1cefe2fc057288bdf6acb06ea107efd": "Atlantis Cash Collect",
  "767e598756752c33a736739a7617507ffc7ea383": "Atlantis Crush",
  "2bb1e846c563b72cfca6084726156f8f65dceb17": "Attack Huge Mushroom",
  "2012b02b1b1d758e101d25602c65fbc96434a6f0": "Attila The Hun",
  "3b4510d631c4bf7ad3ea697d9fb5adcef87bdd52": "Attractive flirt 30",
  "4eee5c28fcb7f9e2b2050eaf362d68f1e6c6d690": "Attractive flirt 50",
  "25823bad3d628a041d787ac62b3a2d71a164ee30": "Aurora",
  "77b9df14f9db2d01f3b5b9f64c2cd55abaca1dcb": "Aussies vs Emus",
  "b026b13b151aae5f879ea3bfa5ca6baaff3df919": "Auto Lightning Roulette",
  "bcba4890f1b91db69af92278d9071c1d01d39c65": "Auto Mega Roulette",
  "a2a16cc6c0f900ce8777d44b1530b797ec9d5b32": "Auto Roulette",
  "9d91ad3cb2c20f1e11fe037c71bb05d11c22e619": "Auto-Roulette",
  "ca2335e8a577851b4700f23bb59762234ee5e6ed": "Auto-Roulette",
  "774d952c6f7a7033231e2b13ce0601ba388df8d0": "Auto-Roulette Vip",
  "c90ffadd843434ee521e67cdece2b817b6e41fd5": "Auto-Roulette Vip",
  "853dd6ae1e283f6035999792bd2aca27caf8e13b": "Auto-Roulette VIP",
  "bd7fc1e8cd454c379207d1b683422ea21bce3699": "Auto-Roulette VIP",
  "5259691a088c4d3fc30d6c38252cfb53f3dc9487": "avalon-gold",
  "134116030c8d3754e09adfc7d90c8cbf888ee254": "avalon-x",
  "c1cab3f80fec825480d3327f2863d617c73616f0": "Avatars Gateway Guardians",
  "951af9e8cfd27414392a8eae1c3dc71571419a92": "Aviator",
  "2b428c22d324d68d0463424c712490750cbd1c5f": "AzlandsGold",
  "fd9db3d05c1f98044cf76bf088bec1a7a92bfc4b": "Aztec Blaze",
  "a31932bf0874ea85e8617be7ac3c4ebd86697e1f": "Aztec Blaze",
  "5181fc1296a476f31f11aac21fd7bf5c858d6d73": "Aztec Bonanza",
  "562a25180a2bf5c67a553e61fc5df6e647e2b33f": "Aztec Bonanza",
  "9b5425d86879a974dda96a904bf85cfc06b77dc2": "Aztec Coins",
  "03ce4df34ec06fe798b9620d341a4eabf601750f": "Aztec Dice",
  "103545e556763d3390acdd1f845040dec3be8706": "Aztec Expedition Thundershots",
  "17d34353a34f46f8d351f586590de792b17ffade": "Aztec Fire 2",
  "6ef605e5c19ab60d1d20d9778fd09d7b4c48fea8": "Aztec Forest",
  "f72499809878c2e2235acb26d97b4a7f69949ea2": "Aztec Gems",
  "f0398c72b5106d378ac3a2d050c2e7668d7cff8c": "Aztec Gems",
  "91306e4a02ad4f175777839fd77957c10607e431": "Aztec Gems Deluxe",
  "3078ade855038eda33788fd715445b693d5214c6": "Aztec Gems Deluxe",
  "ad8e685215b0df67d6cd893f6d812f56d29397e9": "Aztec Gems Megaways",
  "59fd094ad2cc7935fe60a3494de66fb9eba5d187": "Aztec Gems Megaways",
  "653496c89042af9897728106468e653653c74a7e": "Aztec Glory",
  "9b1758e7573561344c668606e7778cb2545ce667": "Aztec Glory Buy Bonus",
  "6533b06c39ad21405dc85e49467e88412b1ab11b": "Aztec Idols",
  "ccc437c143abfe1df75255ce9db49ca72b1e40c9": "Aztec King",
  "2f664a133a2cda950e5d2b2f2d3566e63a7bd018": "Aztec King Megaways",
  "cc058f2c234dcf111ef16a3ae50408566ee7c041": "Aztec Powernudge",
  "eadb704eb8c47d5cc1a341124c9e43953a9d9f4f": "Aztec Powernudge",
  "dfa989f702967c7d1ef29d57574b0e83af2c3a16": "Aztec Rush",
  "11f10460adeb0da9469a4cf08d5f4c53130f6a59": "Aztec Secret",
  "a4a37b989f68ddd8a311734d2feb8fdb4edd67e7": "Aztec Smash",
  "7922a31ce695f663be7b220d00d28f419c2547e1": "Aztec Smash",
  "bff8013a9169fbc235919769ccb83c3a882f58fa": "Aztec Temple",
  "ea5d6014972abd9b93d38b6cf526de7c71dc059e": "Aztec Treasure",
  "f355d147a3af31172b5b1655ed58916a87199dc5": "Aztec Treasure",
  "e03611aa08c8bc96ece2f21eb7cac0bf778d5343": "Aztec Treasure Hunt",
  "775eef7ddb4d4a8fac09ac5c58f033294fd439f6": "Aztec Treasure Hunt",
  "3cc63d4be0ec1b0eb754e5f1f5707e0b692f6d87": "Aztec Twist",
  "226cce11dcc9ccc6d47324b9d968a2d77f1fe924": "Aztec Warrior Princess",
  "93cf0a3005b944286fa4b6c04ec46cd5b33b2d49": "Azteca Bonus Lines",
  "560839ec19b117e833f8a56a94fc0cdd84a94c76": "Azteca Gold Collect",
  "c53b0e3634b1c406371f131417611f197567c7f3": "Azteca: Cash Collect",
  "863934d9051712142ddc180d0398cc03bcf5b96a": "Ba Wang Bie Ji",
  "799043291374b6608a30f178b1ff9262d8a37cc0": "BabaYaga",
  "011ef517dd4b25d8c4d7da7f27d3a545abe7ff50": "Bac Bo",
  "9c1d50ebff226e5157f6707b55629e3fcaf4cb99": "Bac Bo",
  "e177439791840b7c2f7fb57da24da32a0bafb167": "Bac Bo",
  "03066755bf3b8a668a4dd46459d56d23033d278a": "Bac Bo",
  "21e163d15cb2da877981bf63635d5ab6e5db1547": "Bac Bo Ao Vivo",
  "ba2e624970bd3cc83ce05aecff8ba09e6bc08886": "Bac Bo Ao Vivo",
  "2eea732f567f82fa5731360d8acfe013387b281a": "Bac Bo Ao Vivo",
  "d15c899692d914d9d8ab17b3bd07fff5bbe568ed": "Bac Bo Ao Vivo",
  "0a0e0f03706f8c407a9b0ba2088d238d9f528e65": "Bacará Rápido",
  "199988856038fcf1aa3ab9df009a4170bd501203": "Bacará Rápido",
  "b51fe22600a837192c1ffb020a9364650a83862b": "Baccarat 1",
  "ab5740ae0e6219143914bbf02a8bd88dd4268d80": "Baccarat 2",
  "1933ab9b2c437a5609602a2e31141be648e1df44": "Baccarat 3",
  "4fae1f419f9e6dd3e7fd86bfc00d16d658cd3ae6": "Baccarat 5",
  "3b84ac3de5b0c254494dd92b445348a8df3b2c65": "Baccarat 6",
  "c89663eacb0765ca29467d9abebe229dd16cb8be": "Baccarat 7",
  "c9d775dc7f85548491dc16962802d5353c2c6687": "Baccarat 9",
  "d5dab7cee4055863e5fb4b189419aa6feb30cb4d": "Baccarat A",
  "09aa196b934594684a3fc3b07ba22ca31452fba2": "Baccarat A",
  "dc725b22fbbc9930d8ce0915a1aa3206bfdaf2ea": "Baccarat B",
  "fd75a274148514a4a3731bcc8ce73fef75ade4b7": "Baccarat B",
  "32fbb79697dac9c752842939a9912f0ea43eb144": "Baccarat B",
  "0776b8dbcc3d09173bfe22001d779a692ca0921a": "Baccarat B",
  "402b64b8ba9203caad72bde93725fd3920e3c379": "Baccarat C",
  "87455c9f4196050ecdd3fd09b50706e03c941446": "Baccarat C",
  "b0055f22feb4b6bddecc130adb337de9649b51cc": "Baccarat Control Squeeze",
  "c6228041a24349a4ee874926bbc70f15ae5fa837": "Baccarat Controlled Squeeze",
  "72241178530afcadf591b9defaf0f81c5180bd1c": "Baccarat Lobby",
  "908274fe70c3a07f2f24cd55d9efb8a0848df9aa": "Baccarat Lobby",
  "d29210c6d17534afd831b40afc56f2d18c64d434": "Baccarat Rápido ao Vivo 1",
  "5b2f07f7f90ef8147b8f5c63d62d84d157fe7a88": "Baccarat Rápido ao Vivo 1",
  "617885aeaa3ca11aa988eb05e8e588b62455abfe": "Baccarat Rápido ao Vivo 2",
  "a5c9c980264024e84f43e7fcbaa43b4365aa2153": "Baccarat Rápido ao Vivo 3",
  "bb1a562fe2c33363f8a416e66da46f77ad7d7367": "Baccarat Squeeze",
  "ceff19ffe7b64e2e1aeb55c5f5d11211b6fd619c": "Bacon Bankroll",
  "ceed59df8d9cf5c9ea3e11bc8e43d066ddeae575": "Badge Blitz",
  "c7d749c18a6f6aa75664b120c7f1da4b81426d99": "Badge Blitz",
  "3f3caec13df381c4ddccb4213821e2b97332899d": "Baker's Treat",
  "94adc5fd92f0652ed34db47b6f17daa08ef4aac8": "Bakery Sweetness",
  "f296cb34618703c9a7cc905933c7e7777ed9db38": "Bali Dragon",
  "b74465059f4c4aa79719f94a556dc0d046d58853": "Balloon",
  "089dce37bf29c2bd1e5f1da9c53c61c47cd82697": "Balloon Race",
  "1de4a771f6b095877850facf594e0a9045eec9bd": "Balloon Race",
  "50487ff0820029b859d1498f1d052f7a09bd640f": "Balloon Race",
  "7426aa09c8bc401cff3386fa2c63e52b3e1a0371": "Balloon Race",
  "5d7874b5bcdc8c8b944ec8f52fbb79fafbea3fe2": "Balloonies",
  "f69b4c59fbfd0042739a04ca258c6c521b33406e": "Bamboo Wilds",
  "30cd380cafca525572f0701220b1d275f3504820": "Banana Rock",
  "f9786679a361513b35e3f53b533ec3a4c01355a5": "Banana Rush",
  "82ef7bc4bef3d6fb667747703808046c3945da34": "Banana Town",
  "482390a34167f6d51b82164ebe71ed1f1cfaaebd": "Banana Town Dream Drop",
  "2b7ec8126dffc3cea39ecd94c22402567e1a402c": "Band Girl",
  "c98de6acf19979a4463bdada6355c15fe6c00700": "Bandit Megaways",
  "8cd38781ef9a4d5f39c1cba5170d99dfcafdbc06": "Bandit Megaways",
  "b8ba20c1b20a978d8bd81548c148f6de2c2ab17d": "Bang Bang",
  "b597ea1fc578ee0c775babf71d125687e6617ac9": "Bang Bang Reloaded",
  "19ba732552ddcbd938ac9bfc776f406dadfe5834": "BANK 81 DICE",
  "d137434fa3ec94ae1330b68a40a40d7f3f108073": "Banquet of Dead",
  "71b465f811e354fa36fd596936c700101ba5ecbf": "Bao Shi",
  "89a0f9dbe87d8760c476f7848efb8c55f648cca4": "Barbarian Fury ",
  "e97a0790739033e820ff4de72860223b23f5893b": "Barbarian Giants Fusion Reels",
  "d63ec1a95ff21a95e7373f2f1d48aea5a460e973": "Barbarian Stash",
  "98b40791975d0b24855b2464a980e02cca4f50bd": "Barkin' Clusters Ante Bet",
  "bd4945b6e498af05adc0dbba2dc5fef3a1cf49ff": "Barn Busters",
  "332f01863480fdc6fa52abcb693a72be7a00d3dd": "Barn Festival",
  "fff60d69586440381294a8087bd321b7178eca31": "Barn Festival",
  "922a58e40900c134d98d2fd9c36c9f9e5b6aa975": "BarnstormerBucks",
  "013ea1c9aca618715083ef0b43a6765df7628db1": "Barnyard Megahays Megaways",
  "2af8b923948a691fbdaf302017abd2188c566707": "Barnyard Megahays Megaways™",
  "65503aaf42d5c2859276f8792b33519615f72155": "Baron: Lord of Saturday",
  "0d80d38544b48a8c68d4b8e10fa465586dd15df9": "Barrel Bonanza",
  "0604b92871d9b8298145ca9f5f54ba6c5312e0d4": "Barrels of Riches",
  "956a76cc43c149b925535727bcd5def7285e15c9": "Baseball Fever",
  "aa8107fcb697649341d3ae976cda2b1c3b0ad7b6": "Bash Bros",
  "d69a90520e188cc3713b90014cf80aeedf13376c": "Battle Royal",
  "83103aa4519364ec9f65184b74d98a7e2a7a042a": "Beach Life",
  "b2d4147a4c713fd6be4c5719fd650508a8ef38a9": "Bear Buzz",
  "7e80b386276e993b09cbd6f4a249b1fcff34486e": "Bear Crazy",
  "203de0d5f62e0bc5e9705346403f67f65b22c58f": "Bear Crazy",
  "4da7f5dc086ef019ccbfd5a33da0e389f5f92bf7": "Bear Paw Legend",
  "094328ba762681dd23796c169af8254232a5b187": "Bear Paw Legend Plus",
  "e8a243100b920c33605db2bf610e0611be392924": "Bear's Tricks",
  "4cb79c550b5c62b2edf428a2fc953f48b77e09a6": "Beast Below",
  "07666f66aad39978c90e9eba2ae36bd96311750c": "Beast Coinz",
  "a12504f38886b2d7b33650b2ef03450f4a0b8ea6": "Beastie Bux",
  "4ae0565640891068230ad190b92ec2c61eb8e3f4": "Beasts Joy 30",
  "e7c5e0eaa1c9d311fbbd0906adf6a6eef7b95ea0": "Beasts Joy 50",
  "7d5de8a1249aa0450db5a5c0e946928d3d596e14": "Beasts of Fire",
  "13e246dd795ed231022591834373220f5d9b1b4b": "Beasts of Fire Maximum",
  "ad1933058c9c1dc8152d2fd58440c762d9133f10": "Beat Coin",
  "6c853e4688d970772dc1544573589aef7aeff9cc": "Beautiful Lady",
  "385b49fbeed6efb4f3f9b79268bca00afba41ae1": "Beauty and the Beast",
  "d4dad67d0e3e3edb7c5665b64d12d027148ddf09": "Beauty and the Beast",
  "9cca71440529e5dc423f8771368e7f717a655282": "Beauty Fairy",
  "a56a140c74c397460527643c154a0cc8cde2073d": "Beauty Pageant",
  "e8bea4cf00e4e4c57871b172da5ac2a476e6f6f7": "Beauty Trap",
  "bd7e015d2f276c7a66add0d0d836869920c44809": "Bee Frenzy",
  "9d25f059db866294aa3f102fa94a820601c4cdc2": "Bee Keeper",
  "d8829053da9e07236108b64064582bb75c7afb60": "Bee Keeper",
  "18b50e2f80d7282896cd92f7addd1598b5431dee": "BeforeTimeRunsOut",
  "7b1c19a8305ce3ab97ceff4848803f42841a5dee": "Beheaded",
  "9e93211bf909fc79ed7ae75cefbe562edd2d3bfb": "Bells on Fire",
  "2ae17a5943f114d69a6f454ba9051540c8d05197": "Bells on Fire Boost",
  "fb68a4b75057d28a9c2f42a4291489ddfe263adf": "Bells on Fire: Rombo",
  "e3360052f940541f09524c40cbee7eb8e27fa314": "Benji Killed In Vegas",
  "2f48d472073c184624d6cfbc6e8af55c444601b4": "Benny the Beer",
  "3081a74d9a57d88797e921dc1692511eaa95afed": "Bermuda Riches",
  "a0472fcebb7624ee68ff6c969d083b3ddcbcb783": "Bermuda Riches",
  "d6979eebb9717bcb1cd6e1dd6c70582339ce0ac5": "Berry Berry Bonanza",
  "88634f6a536dbaeb147870221d30580d2d89fe9d": "Betby",
  "7ebdfc366969980f3345cc16de902cdae8ae2b19": "Betby Sportsbook",
  "52691704553d17487c1248a220f0f2b36a84df80": "BetConstruct Sportsbook",
  "9316c90abcd7db253254e676fa58f52de01b5019": "Better Barn House Bonanza",
  "c22c5d8c93ee0965391e28ec662479cb53fac9a2": "Better Barn House Bonanza",
  "1b880e70ea0abb7e19fb107a8c85ad96c4e6a592": "Better Wilds",
  "5d7ff70dbdd19a20f1908c9b47a8a3170ea18cae": "Beware The Deep Megaways",
  "0f866e0d867b14e881e01f9399b40a412a2b2b88": "Bicicleta",
  "93a95ca9880be36692f4cfd6ca9c57728d9cf30e": "Big Apple",
  "e7ff8aab6fa0af47d66aacb2b1bfcca9f690adef": "Big Bad Wolf: Cash Collect & Link",
  "1c6023656261773f7dc452e9d6bbae460f0e48d0": "Big Bam-book",
  "06a1ebb7786ad1935a72861c6a971633c48e3026": "Big Bang",
  "017254d9310982534f446a9dfafbdbdfff2435d7": "Big Bang 2",
  "50fab06ffa92d345b679a88336ee8923822ddaee": "Big Bankin Bonanza",
  "89e1afb7754b8beb90c06a3ef4d4ae6764153f58": "Big Bass - Hold & Spinner",
  "dee4714d668c8ce2b81ad19b3c468ba60c29a3f0": "Big Bass - Hold & Spinner",
  "8bba42b17c4a78f35c8d378d78751ba42d812394": "Big Bass Amazon Xtreme",
  "68573b9645259fe6b768e27749f2708b2b047e53": "Big Bass Amazon Xtreme",
  "f754ca25c33c9be91e711e9c65de8d16b6b70f7f": "Big Bass and the Gold Ness Monster",
  "018599df899bf2c2c29d92eb0713859ca4b8e126": "Big Bass Blast",
  "fed2ebee8a0f71062d4fbdc2652a36692c457341": "Big Bass Blast",
  "f9e4c79b85d5d0942aeac11fc060347f6a778982": "Big Bass Bonanza",
  "96c3e90b3b10d4537cfd0f927dcb10d1985ca41d": "Big Bass Bonanza",
  "925502040de4cb25e09ce19689d48bc3386d68e0": "Big Bass Bonanza - Keeping it Reel",
  "90c3a6d73ceb464036a10dd1e57d813a61f7b20f": "Big Bass Bonanza - Keeping it Reel",
  "5f6adcffe999409cd30521c4457804cf6788edc5": "Big Bass Bonanza - Reel Action",
  "187d97343b4a220f8dd47b7d64d66513784adbc8": "Big Bass Bonanza 1000",
  "f3eef1d78b7c559477eca0a3ad6462d7b97d036d": "Big Bass Bonanza 1000",
  "1a67b3959e9a222dc1fcc134b8e851fc7d91cc24": "Big Bass Bonanza 3 Reeler",
  "e18e92782c8de912a2bd2b01450c57b64be8eb38": "Big Bass Bonanza 3 Reeler",
  "82bf2f82b75f948334f8d1f3a77a71a47b249fa5": "Big Bass Bonanza Megaways",
  "fe14ef0d94c0cd1368c5b6e474507bfbb740a55b": "Big Bass Bonanza Megaways",
  "1075f24e165ca98164b9e4ce7fd506d141f4ac2c": "Big Bass Bonanza – Reel Action",
  "9d47bc35c5dbe76f7b1188961b4430d6938a64b4": "Big Bass Boxing Bonus Round",
  "c4c5cfbb31628373790d2b2c3f90410a9a97dbb4": "Big Bass Boxing Bonus Round",
  "d63368b16bb12d2fc29671098cb8448fb402c684": "Big Bass Christmas Bash",
  "9fac42d38e17dc5f8b3d46dc191c80935f81774b": "Big Bass Christmas Bash",
  "16337a2e919d6b355a3425a66cb03b8d55874900": "Big Bass Christmas – Frozen Lake",
  "f6d1e60f6c7b70bb709c1e84ca7d844d6ebfc14b": "Big Bass Christmas – Frozen Lake",
  "c41e498a7dc3c3073812fc91af8921088440c30c": "Big Bass Crash",
  "105b1f8cdbfa55a488e670ea5140c6701fd5c71a": "Big Bass Day at the Races",
  "093e65572108fdadbb42a36a9d58bd82f3693e63": "Big Bass Day at the Races",
  "974fcf86a0b6929b15124148276d0a49b947b44b": "Big Bass Dice",
  "5352d36c372a8d108eff763302771308a127bf12": "Big Bass Floats my Boat",
  "23dbdbc04471e51a63ebd487e122ac1124204dbf": "Big Bass Floats My Boat",
  "42e59cec9617d02f63daeb3031275062a6f657e8": "Big Bass Football Bonanza",
  "0cada0177352e113ba98a0fbeff604d982521534": "Big Bass Football Bonanza",
  "4fdd141182c372e1114449759e8e987b49938794": "Big Bass Halloween",
  "e635588db941ace5fffe3eaf6647237f5e06e071": "Big Bass Halloween",
  "13e278a9446c39b3fbd4ccf41242f87a8d75c0be": "Big Bass Halloween 2",
  "4f13b19d8f1592b838b80c676c7498b809277990": "Big Bass Halloween 2",
  "a0e72ef7ddcaa9cd878bfdd854a28e66fb0670e4": "Big Bass Halloween 3",
  "058cc0bc6b3956d2d31a856a69116e7b959669b9": "Big Bass Halloween 3",
  "687b482e324c77769c089a763b355e01aeb42b22": "Big Bass Halloween Splash 1000",
  "94cc06e3dda6c492950205be5c2fb06871b4523a": "Big Bass Hold & Spinner Megaways",
  "a1e04b5e27a2a5ec9ce01d20f7a0c92aa0392b77": "Big Bass Hold & Spinner Megaways",
  "186713deffccbda73affd66d1be4ad1489a0f73d": "Big Bass Mission Fishin",
  "7dc4299a39caeef5d50106131331cffec3ea5dd6": "Big Bass Mission Fishin'",
  "e3e06adc562cd5128306efb63e08fffd561a8e91": "Big Bass Raceday Repeat",
  "cb924dc0b08fc36b2c318de28783c484ef360dae": "Big Bass Raceday Repeat",
  "cb84b3dfa5c1d745663ee7590968b4cd3d1914b2": "Big Bass Reel Repeat",
  "f74876241a0ef9a9422277460a431efd2e69a5dd": "Big Bass Reel Repeat",
  "7c03e65079d3caf1c4ae40d1d71f4e622dc6e79d": "Big Bass Return to the Races",
  "d369498aec95e654979b16a97fe00ed872427695": "Big Bass Return to the Races",
  "79259e9fd9e15f84b7c06a367c7c4e30af77db41": "Big Bass Secrets of the Golden Lake",
  "0b71c1eade1ef6b2074a583d581a5a2f6d5f65a1": "Big Bass Splash",
  "22bcdca63f6d87fb78610d35ba2af6c9c6eba7f2": "Big Bass Splash",
  "c65db7773fce05781e68b9d6cedd80156ee20a7f": "Big Bass Splash 1000",
  "6ff9f39de39f5209e80e46d4b12504225ef0e940": "Big Bass Splash 1000",
  "4b3a89598b247ecd69118a0310402ce6d1dad29e": "Big Bass Trophy Catch",
  "da97269659c98306babe9be9a6136090739df1c7": "Big Bass Trophy Catch",
  "f136b437752ec75599b00b3e7197ec09cad10f89": "Big Bass Vegas 1000",
  "dba48e450c8bac270bc348667c406cbfddb72c9c": "Big Bass Vegas Double Down Delux",
  "018d0d57cb78c49cba9c835f0a3b98b7a7b62031": "Big Bass Vegas Double Down Deluxe",
  "ca35f7130b0f6bb44170e7915646cae658a787dd": "Big Bass Xmas Extreme",
  "73a7eee07212436c4d204af8511cf6c7864392e6": "Big Bass Xmas Xtreme",
  "7e4e413e18db1a90547e54457b121dce59983bbc": "Big Bite",
  "85236bca38c4a434976f02699244d2297466fff7": "Big Blox",
  "efab6eb4459e7168488812766f26cc5716bfd7ed": "Big Boss Party Lock 2 Spin",
  "708c89f7eb0d0735a606ffc8ccb42cd1edfbfbde": "Big Buck Bunny",
  "98e186960a0ecf6b4746e601fdab3e005f1bb5bf": "Big Burger load it up with Xtra Cheese",
  "593f822776356042c257de6931000319df069595": "Big Burger Load it up with Xtra Cheese",
  "8f2cf827fe8f9bf42f80fc49d3cd0760fdc9724b": "Big Catch Lock 2 Spin",
  "47d018f2d137d8fc969eeb701d4ee079e90444ad": "Big City 5's",
  "5402f32b3fa2076f4a637c2c89297250b1a4509c": "Big Heist",
  "2e6239b8eba5a6435458b937371786157e55d337": "Big Juan",
  "d720cf659d45535d6942268c07ac50b51d61f27c": "Big Juan",
  "a7d86afe388088974657d7c9687aea785fef3019": "Big Size Fishin'",
  "ea55c8476c505472ae7daeb149b279115c91b4da": "Big Wild Buffalo",
  "e27c191dc51099b6e7c4b1bcf3b1f8147e5f69ab": "Big Wild Buffalo 2",
  "ecfd5f0ff89a8a18be121bbf8dcaf1355ffe6006": "Big Win 777",
  "fff386dfb5dc99dd2228b459bf1e4af0f4d43a45": "Big Win Cat",
  "bf6cd9fd6c12738f8738f5f0a2680b17c604f4ec": "Big Win Cat Pawsperity",
  "135c43ad580ce899e2fe8e370ecceb0c98e33fb5": "Bigfoot Yeti",
  "73e004c126a45a608ad7a77cc6885ff692db4ad3": "Bigger Barn House Bonanza",
  "5cb45c2e5348ce1e09f2246e2c37876056dbef76": "Bigger Barn House Bonanza",
  "739d7965b5cfb2ababce87d4ae13eced45e84a84": "Bigger Bass Blizzard - Christmas Catch",
  "9e6d12c55824261188d6d9aa8202f13c8d03e411": "Bigger Bass Blizzard - Christmas Catch",
  "10269ff3e6b479fa6355580c2cf434ea0d8a796c": "Bigger Bass Bonanza",
  "e579a9d54a3df7d6fd887fa9efa305722619a2e6": "Bigger Bass Bonanza",
  "13c15e8de1e50f5c3542cc8e643e3a578345e58b": "Bigger Bass Splash",
  "8cc214bec4bbfbda44bc3b5365e796ab47106145": "Bigger Bass Splash",
  "01501a20d13a35c51a7f6978841d5da92f507529": "Bigger Size Fishin'",
  "99ebe5c0ad6a30b7f2d8a1decb23f39b2b61c031": "Biggy Winnie feat. The Rich One",
  "f61afd8f44baa01f8271c6d0fe67ed6efcf51d1d": "BikiniIsland",
  "8351547e67495ada296e5d65637b0526bf13c546": "BikiniIslandDeluxe",
  "e4be0f76ef524ae150f74160fd4e9a7f871d3cb4": "Billy's Game",
  "d4b1cc5d7e8ea78b1c72c7b293293afa55a7d7aa": "Billyonaire",
  "ff9c1aba29d7f6f2aa1ff78f6f1fe6d83a9833e1": "Bingo Mania",
  "c3c32b13fc6b547d495623d9b6c59c33f6801cfd": "Bingo Mania",
  "d77dfd909ef8ec774f174b39dca1e57e07401dca": "BINGO STAXX Amazon Fury",
  "514e49e2bf78dc5a35a0c83f37c856bf7836b0f3": "BINGO STAXX Rudolphs Reign",
  "fe7254abfb0ddacecd600702a2d41b2b90eeb57b": "BINGO STAXX Thunder Power",
  "fc226380ff9ccc94ae7bfe893d475c7dd0d60c74": "Bionic Human",
  "7422371e149510d77e84eb5953640aa7398db36d": "BirdOfThunder",
  "2872556bf3e6fb4329017104b9c193cd8e0cd7b6": "birthday",
  "2e7573e982dbed36ff6823d4b72a53b589c7b01e": "Bison Trail",
  "e8b3b1cb339296ff8b15d47a9f6d05c2253b5943": "Bison vs Buffalo",
  "74bbad1146cafb9c6e239679000e3ad02694b91e": "Bivol Beasts",
  "fc6b3540178a23aaa98d6afbf326fa6026381812": "Bizarre Barber",
  "f7d83550052446719dce74fa19be03cdd042ab71": "Black Bull",
  "8941d90c6e8519304493f2639e11c9a1394d8870": "Black Bull",
  "2c1a6ea251c0b3541c2340f03203eceb7d4200b9": "Black Clover Bell Link VIP",
  "bd8099f793de69ee3b0e58a33f593276ab529880": "Black Diamond Bell Link",
  "6c8bf7e297fead2aac9a15d342319ef896f9521f": "Black Diamond Bell Link VIP",
  "a01a4e9803d194f53c36dce6fde97421add347c2": "Black Friday Cart Craze",
  "b3295cd348f71f167f1ffe972daa13d2b1bf6846": "Black Lounge Bell Link",
  "4a2d98bced660f921148ff865b1e4dd30d689042": "Black Lounge Bell Link VIP",
  "db8bec0e8e40fe13120575e4e961213052c6f434": "Black Mamba",
  "1445a82287e81600b815069e0bcb24d68fc83bf6": "Black Seven Bell Link",
  "8b7d692a23c9a32d05b6bb8ffbcd533bbe9c0064": "Black Seven Bell Link VIP",
  "d892daa75f2c4c2fb01a731ae62577bdbf799f37": "Black Swan Lock 2 Spin",
  "0f95e5001c8c04db61e3f0fdb0d2cb617561be68": "black-river-gold",
  "c5ee13f39b5f098be29cc5c4f1a452e2b39c1245": "BlackbeardsBounty",
  "1d5af17469edccb4b6fcef3be57ff985e055b52d": "Blackbeardâ€™s Hoard Cash Sacks",
  "abdaca15dbbdd0d6ed05075b76fb65c18307d7f2": "Blackjack",
  "6ecab743b1fa5a806dd3de6b9464909c3cc21981": "Blackjack 1 - Azure",
  "349a95eeacf295b1802e92a6f3abb344e6aebafb": "Blackjack 10 - Azure",
  "72e0064fc55cb6de58064118413efba9f2fe3adb": "Blackjack 100 - Azure",
  "6964dc68e4c95eee9f9e2d748a5737c845f952cb": "Blackjack 101 - Azure",
  "de6dc75da365ce2d8a4874d8a845304dbb04d779": "Blackjack 102 - Emerald",
  "62f01594510ef3703e70906794f7166a49d3ba58": "Blackjack 103 - Emerald",
  "b9ef45218b4279fdd9d342cbcd9a539e286530d8": "Blackjack 104 - Emerald",
  "d9671c48482e6d9e84c93819eaa81b37073fea71": "Blackjack 105 - Emerald",
  "38cc01b7da61043f566e47956059a7bcfe408ed0": "Blackjack 106 - Emerald",
  "197b6cbbd13b20848f7cc4679b4f38d8c8f267b8": "Blackjack 107 - Emerald",
  "4e011435c1f038d5959523e425b09dd7df86351b": "Blackjack 108 - Emerald",
  "a1d119b1a204165f6081de9497ae8480dc46d75c": "Blackjack 109",
  "ab6b95115e13e5bec7647f6210a274545a9c473b": "Blackjack 11",
  "421052914b13eae97a9d9644495655f22303ce0d": "Blackjack 110",
  "a8ca54c130ff2197eb7f21f3f5fdce4d23f340d7": "Blackjack 111",
  "0677580aa22d34ecde8fb5ca0fefe2993afcd7e1": "Blackjack 112",
  "8d68ac75783e3aa56f439d62fa8cfa05cace814d": "Blackjack 113",
  "3a97732eba4c34cad375aa8c5b52908f540bc107": "Blackjack 114",
  "205a687de480464387514f2e9ef31e13766dea02": "Blackjack 115",
  "bc06ea771a1f876c67707a3fd05e68e9f53617a2": "Blackjack 116",
  "efad46622a4e7207ecd9f6d63e21b8680e6681c8": "Blackjack 117",
  "7d6bf1dc35b5cf3ef1d600b2a2c00a43f790650b": "Blackjack 118",
  "3c8515a0bfcda7c6eac3dd2fa121abc838d9a055": "Blackjack 119",
  "c7c8495659f0c3ec54689815938ba1dbc64cafbf": "Blackjack 12",
  "ae6b73fec63bba519f32344da5d0381fe467dd72": "Blackjack 120",
  "ff34b0fbbc3a02105889ecc6d14d20d9bf721790": "Blackjack 121",
  "9e3f1cf6f92895e9c8fd45eeab58c69ef5b842bb": "Blackjack 122",
  "7b73292877e12e8967c19c1c2fe4c0396489e86b": "Blackjack 123",
  "720e3807810d9920805489d28932589eb8d52b74": "Blackjack 124",
  "d7fc4ea919c5e026ef9bde2d0da5a5d96adf4c4a": "Blackjack 125",
  "14ba1ba68f20f825b57bcaaaf821095582072ecf": "Blackjack 126",
  "a03711a01d1fb6fa1ac9813ae37715bd546c87b9": "Blackjack 127",
  "52b6ab21f48752fdb77dde0c66e2a8d6252500d2": "Blackjack 128",
  "0e7e3601d920602aca6f23a42e7fe5b5d045dade": "Blackjack 129",
  "688f56c6f66cb99d37c9dc67729632b34bf14237": "Blackjack 130",
  "781f2abb790bc1d7bf0150a8aa6fe51a87dcd744": "Blackjack 131",
  "56e551746873e61f759cd5e8667b009546dbaaff": "Blackjack 132",
  "c02a7d6c201730ec6652440b339277e23a689048": "Blackjack 133",
  "9acf5d585d2bef6d6fa85e729ce8d3e343c0881b": "Blackjack 134",
  "380cb1a62c13bc54867c308a0299fad5018ca427": "Blackjack 14",
  "92f0c9e92d2d4784615ecaff7cffed51792eb797": "Blackjack 15",
  "8bcb57d27eb1fa8ae0d86571f0c5112664112de9": "Blackjack 16",
  "44414796509462d4d34a8ef7b526593b64a783db": "Blackjack 17 - Azure",
  "1c9dbdb9e1848ecad02e1c41969f5eb4709347f9": "Blackjack 18 - Azure",
  "e73adb54ba054f6a9e31bf7cc6fa36e43d6e1ad4": "Blackjack 19 - Azure",
  "8aaf22a21b448c781de7d9b229e1afa1750c0869": "Blackjack 2 - Azure",
  "e26a369a42b94f1b22c06793fca8cadaecbdfcaa": "Blackjack 20 - Azure",
  "13681f203025836edd68a78b9a09e8788b19114c": "Blackjack 21 - Azure",
  "687aea5f11e4e75d56c28b7594aed1e05d358870": "Blackjack 22 - Azure",
  "74c7f550f7bd069698e607939e1b4d04fbd507f5": "Blackjack 23 - Azure",
  "66a3a29a469fddd7e7bed19ba60711df1c213f8e": "Blackjack 24 - Azure",
  "7be7cccbbf7edbac16b6dc28ff9449824cb33f71": "Blackjack 25 - Azure",
  "1e4ff7776b8a7bfa75a73e6e18b8d758c9c5e041": "Blackjack 26 - Azure",
  "acbe71e01145aab0183765692f5b9194cbf64314": "Blackjack 27 - Azure",
  "7bb1a0aa8d4843530662b1e34a71867ab3418673": "Blackjack 28 - Azure",
  "d776ae733c3d2f7db5a9b739f9ba198bff27b76a": "Blackjack 29 - Azure",
  "23c8cd336362805ec4bd503cce2c92440584d72c": "Blackjack 3 - Azure",
  "b96522faa2e7ec7072706eefb575544c7391780e": "Blackjack 30 - Azure",
  "d5d14bb827b8c907104e993ecb3ea47954c7aea8": "Blackjack 31 - Azure",
  "8d1c3aac2018d3368b0c01a302fc678c097d2ac6": "Blackjack 32 - Azure",
  "e70eedf8298fd69221ecd4e60c946fdfdc37b5cd": "Blackjack 33 - The Club",
  "f87dec843c5e6c0c1e96d602fd2862d9bd39bd78": "Blackjack 34 - The Club",
  "fe828ad15547ca111d7ade7bfc5bca6ad918c1e3": "Blackjack 35 - The Club",
  "6d26fe09d098f72fe885a62d61efa8debfe14452": "Blackjack 36 - The Club",
  "fa13fc0f135b757ed5da81ea2521da40d7bbe1a2": "Blackjack 37 - Ruby",
  "f95987243303b3e96de2d144fe0135cb948bfe6c": "Blackjack 38 - Ruby",
  "db8aaf42484ec62890f8c763adb3b3a503002e0d": "Blackjack 39 - Ruby",
  "3101c6e36e944b727682fed0f009c8008d6b9bc2": "Blackjack 4 - Azure",
  "15920b817b421064a9b9223b6a211a277be8ae81": "Blackjack 40 - Ruby",
  "a29812f6214aa21584cb937883e9d894e208279e": "Blackjack 41 - Ruby",
  "a8248bd137a8b83a898671335d546d54d7cee469": "Blackjack 42 - Ruby",
  "ef41f8f95da570be1b4e4d2a9595810294d11093": "Blackjack 43 - Ruby",
  "36e76a67da523aebe4e9c6d3e6d5f6a2c27f1402": "Blackjack 44 - Ruby",
  "63380eb96e2db89113b3dc56e63cc4917e61a318": "Blackjack 45 - Ruby",
  "8f2e8d328be08842cbba8407b894e3e3c3f4bfdc": "Blackjack 46 - Ruby",
  "467b7083d722e4e8925cadcb114b6cf23e45aceb": "Blackjack 47 - Ruby",
  "47ea2bdc239b82bdfcbc8b694e4299b524892dd5": "Blackjack 48 - Ruby",
  "7e1ad3e56e8038c75ed7c3ba854098dc623ed62f": "Blackjack 49 - Ruby",
  "58bbf6cd136b7ba520e080d2fdd69b6570b8e957": "Blackjack 5 - Azure",
  "f2b5846adde025fee560ab991326c421e254c976": "Blackjack 50 - Ruby",
  "6b4e5ba6331a7728a9e120473b8f3e29ae0f6171": "Blackjack 51 - Ruby",
  "ebd9375668b3cb1a8ec6d92e60d9e4536cdc4940": "Blackjack 52 - Ruby",
  "43477dd28a13e7ffdadba2846e08c929884d6591": "Blackjack 53 - Ruby",
  "ca452ac602243445f676676b2b9b586d7a425ede": "Blackjack 54 - Ruby",
  "485c799196ecebec9cb8c483e22a70cd873cb75c": "Blackjack 55 - Ruby",
  "a2b40da18d3a84d95d847439b1f03c6036009d36": "Blackjack 56 - Ruby",
  "129591d68cd231ba311465f495997f4680a5a93a": "Blackjack 57 - Azure",
  "e0557cafc326a1842a5d79e23c4861e1e2f3e54b": "Blackjack 58 - Azure",
  "00392dcdf3b1570a1ad316349b9e280af05bc12a": "Blackjack 59 - Azure",
  "146a06d8c23344b987e29226c2abf7b7d35f0bcc": "Blackjack 6 - Azure",
  "fa00286e1304f03f57e95728f5853b1814b97d25": "Blackjack 60 - Azure",
  "b15f9930e7aad70d9935ff74c52140678b2f6d61": "Blackjack 61 - Azure",
  "2034966baca323dbeb99ea1bb9299836fba21441": "Blackjack 62 - Azure",
  "7f5af0e29b3986af537e0b1dd3f7a690f2463101": "Blackjack 63 - Azure",
  "6a4de0ebfc3b853ea32a92280051d8674748339a": "Blackjack 64 - Ruby",
  "d7b2e639a4ccb2c6b024a5a69250f99a374d2e12": "Blackjack 65 - Ruby",
  "224ab7c238e82ab7227b84e1ef2265a91aa809cf": "Blackjack 7 - Azure",
  "e349bebef73103139a8ef6e19badfb55492a8d94": "Blackjack 70 - Ruby",
  "25234d293396765d937f2982c80d23ce7b9df4b0": "Blackjack 71 - Ruby",
  "3b9ae2187d774c80d17b544bbf20b2d29fece777": "Blackjack 72 - Ruby",
  "06e2b27151023657efab1ddbcffe337c298a34f9": "Blackjack 73 - Ruby",
  "80199a50d34d50ca54a3b76f002f41b2b87c6292": "Blackjack 74 - Ruby",
  "ac95f4e517814aaa9219b0d16b764ab1e7c4397d": "Blackjack 75 - Azure",
  "6d06275ab8e4d5fc5149e5121101656ead5e1c10": "Blackjack 76 - Azure",
  "f7dc5e66f1fafe3a01c96267006ec28b4271f155": "Blackjack 79 - Emerald",
  "6b07d64defde61e614de6116c2e438195466997e": "Blackjack 8 - Azure",
  "44e4451c10d9e8f371e6c6a23543095924339bf1": "Blackjack 80 - Emerald",
  "6f9f2d5630fc6624b99777a44ad710ad28de49f7": "Blackjack 81 - Emerald",
  "3ad3970b35d3b6663f5e8804f2c4175cce4c2610": "Blackjack 82 - Emerald",
  "19f04ba72febf0bb1912624ccb8dd8530f2c28c8": "Blackjack 83 - Emerald",
  "1f46a93f5c826ddf584518aed808a07bd2475058": "Blackjack 84 - Emerald",
  "8438d61b8c559d16adce3c8ffcd1ff949d9ab577": "Blackjack 85 - Emerald",
  "c5f2729ce320d1745defd00ae19cbc611e89307e": "Blackjack 86 - Ruby",
  "f51b0cca4209d97b59b84e72d32a5832e707c9de": "Blackjack 87 - Emerald",
  "2fa0f79813a906104fcd109e8f4227cc2d38d485": "Blackjack 88 - Emerald",
  "0588653785c3c266ed831644ec3491e779f06034": "Blackjack 89 - Emerald",
  "3d10a1f411749e309bde61d96ed91ab79e7624d6": "Blackjack 9 - Azure",
  "658ae82816b1d498c68d3511bd6cce011116f6f5": "Blackjack 90 - Azure",
  "5b8a63301d64d4890c7a6ace8c303fec35b737bf": "Blackjack 91 - Azure",
  "c5ba8c0084b97b3df2a07783aabc44698b45bc67": "Blackjack 92 - Azure",
  "ded5b31d6c847bfb6a39e53c92556facbc960868": "Blackjack 93 - Azure",
  "ac14ae8944df9a9c2f7e0b26fba7f3e1410474dd": "Blackjack 94 - Emerald",
  "221508f92769f31f5d20f426b939bc4752bd6542": "Blackjack 95 - Emerald",
  "a6c23b7ce1330b6e6338faa0d57ab1d3ca754bbb": "Blackjack 96 - Emerald",
  "882b608431ab4d40535feca9056e5ec0ea3e1472": "Blackjack 97 - Azure",
  "78a051d6e144ea7e5b21bb73b01e195387dd6a95": "Blackjack 98 - Azure",
  "34115214dad72f254b62b9f9218cdc9708d86690": "Blackjack 99 - Azure",
  "27f40b3e86238b6c06aee9694ad611ea360de44a": "Blackjack A",
  "9c3832d95cc9abae6b90f41a67f49011256f60b2": "Blackjack A",
  "820dbf43c83addb1960319b777dab3d1d96e199a": "Blackjack A",
  "8e60d1d3ab8d19f5aa02dc998283c68929c9ca35": "Blackjack A",
  "08e645622eac67be3f09b021a2c2457f05a15312": "Blackjack B",
  "cc091c172d28f1634dd3b46c25a4cc7929538ef7": "Blackjack B",
  "5dc4fe2be82110c072e008362ece499020f84cae": "Blackjack B",
  "ff5700fd550bf24f51efb2cd5b1eb0a62a77d062": "Blackjack B",
  "64cd3c8bd4c742d207ab5410e538e874a1ea8661": "Blackjack C",
  "b1d6e015dbfc5abeee0e874dffad5d89b2f9de20": "Blackjack C",
  "6c6b2fc9db330240e7b4b732ede60825a3acdf86": "Blackjack C",
  "345cbb1161b3adc31882f6b0f761feb4906096f3": "Blackjack C",
  "478973baf64cc0ef15167ee6cec33c51ac78458e": "Blackjack Clasico en Español 1",
  "6970b720f3c83e0e51c486e8ecedb20ce655bf0a": "Blackjack Clasico en Español 10",
  "c7cefa2f2bdcad5d5fa05d3c33b46752c8c130b8": "Blackjack Clasico en Español 11",
  "57de474feb23545373ec375a9f2749f6b02e5da4": "Blackjack Clasico en Español 2",
  "8ec16183ce8359d677de19595d5a6c00c07806c7": "Blackjack Clasico en Español 3",
  "a7f5e837a83e62b8d584cd9545855c91c64ef242": "Blackjack Clasico en Español 4",
  "5a164f05f716f6316945d814ceaf98c70f75fa54": "Blackjack Clasico en Español 5",
  "d6c865b1a6b23c616f64f8cfbd85d6e8a0c4b72b": "Blackjack Clasico en Español 6",
  "46436d274645ac610fd2420d39ec8a29f6d1e9d5": "Blackjack Clasico en Español 7",
  "9af92bf2be1f0c91863bfc4a5fb02a156b0aac78": "Blackjack Clasico en Español 8",
  "6586961ca169d85935f147f2415f1b5725afc7dd": "Blackjack Clasico en Español 9",
  "d5ee994a4e4f561264dd900e0c6152b008e93cfc": "Blackjack Classic 1",
  "a9258e37f7a4201a9e15c72b95b7a0611a35d2e1": "Blackjack Classic 10",
  "22844c25e1aee47370c43724c29acbf82a94b2d5": "Blackjack Classic 10",
  "af5b82ff1961f05cdbc84c6af310b05f5e473eaa": "Blackjack Classic 11",
  "28989a766a7ed547f075c24cd80e1c2d7e3797c7": "Blackjack Classic 11",
  "6551f84e0444213be89646d25199e1e84bd36451": "Blackjack Classic 12",
  "2d01472c4eaae3c95601e2df87f2a49e564a8612": "Blackjack Classic 13",
  "be3bd0f34420460cd148fe034e9dd55883020c89": "Blackjack Classic 14",
  "2f469ce22cecf9e1667ddac001c001e37f3de731": "Blackjack Classic 15",
  "309f96419a4c0cb9cd52640f22f487f880616d69": "Blackjack Classic 16",
  "184fd377dc252de49c2fca3085c1b8fa644e16b3": "Blackjack Classic 17",
  "dbd7ccd5fdbeee2f82865f0f3e4e1cd383db56e5": "Blackjack Classic 17",
  "45d8ed9b0877b73376aec965225dd31e16d9be83": "Blackjack Classic 17",
  "b7385f3b20e5d01fad8e2e6cc8a7238326538392": "Blackjack Classic 18",
  "f804d0df24e78ff1a439b7d83f71b41ea7b02bc2": "Blackjack Classic 18",
  "cfdbac09132158ee04558f2d35450b10a22fe92a": "Blackjack Classic 18",
  "5e76948bb7846caee8d7b61146c65ef139a427fb": "Blackjack Classic 18",
  "3298ac03dddd267cc77d966a2de521de3d305fff": "Blackjack Classic 19",
  "a8965c2cd52921787c7a96dbdb30192617b9639f": "Blackjack Classic 2",
  "107462cc109c839bb288eddd0f996c7a0f4ef4af": "Blackjack Classic 20",
  "42f0ebdee1ebabdbf00b853a72312fe93744e675": "Blackjack Classic 20",
  "162d16732f8d0ece7c693e78e628beaf467a2a27": "Blackjack Classic 20",
  "97a12b722822f3cf18ab1b67fdab867933b8003a": "Blackjack Classic 20",
  "97bdf8784dac1237fd4667ce5bfb06b8f6a6be76": "Blackjack Classic 21",
  "e8250bd73b6a8f7fac6a08d88dd22282853f3000": "Blackjack Classic 22",
  "09a1f699491d249425da7f398e9aa34b80bea6a0": "Blackjack Classic 23",
  "07c7f84a85c07a5357ccc7500b53d7368034c259": "Blackjack Classic 24",
  "817766769849e013f9cf23fc2146d4900569f647": "Blackjack Classic 24",
  "3920cd0f8291e9a654441dffd15494079dfc27e2": "Blackjack classic 24",
  "fb470485aaec964029743b3a021c20467b8c2f5c": "Blackjack Classic 24",
  "3dd9cdf919ec63886448d2f5fad61e5ae2fb2998": "Blackjack Classic 24",
  "45033ad4f962d3682c953e8bf87b8e286979da90": "Blackjack Classic 25",
  "72a10722ced064a4c075a614e2159eb7160f8788": "Blackjack Classic 25",
  "f68d5f9afd48cc261d9000d7db3e32d62ca317ef": "Blackjack Classic 25",
  "d1f6fba513e1aef3dd4eda7d81be487f6bebc683": "Blackjack Classic 25",
  "84e7e00a9b5e9fb57a070975e59f982e608fa608": "Blackjack Classic 26",
  "cac478718f7aae296b7866d67d39fa3b5bc16b2a": "Blackjack Classic 26",
  "3441fba812293ca1a97050afd9b5a69510958cf6": "Blackjack Classic 26",
  "bae15ea003b79d79707ec2f6131a59d55fcc7d55": "Blackjack Classic 27",
  "e5f26e7997899a8f79a63e78f0d58f6003c4381e": "Blackjack Classic 27",
  "5af2c6774570d104bf38bf569a683a427d2592b7": "Blackjack Classic 28",
  "3c723e12c2a18c6ed988178183105550169d6e3f": "Blackjack Classic 29",
  "752f649b64514cd3add9c4b365a9ae31e99714cd": "Blackjack Classic 29",
  "7950247bb7141a9f0c3f531f19e1962f7bf94ba1": "Blackjack Classic 29",
  "b292ff535b37925dc5faa145941a2ff27652110b": "Blackjack Classic 29",
  "cdee124d14104b20817b3b825409430afe4c3e4e": "Blackjack Classic 3",
  "2b976d9c2b7e8d825573cffbcef8bd68ce240829": "Blackjack Classic 3",
  "81dfb62c20ea18704624a772fad2a3ce92164601": "Blackjack Classic 30",
  "f8f5e69ade324d78d84dbede871733ddaa64f3db": "Blackjack Classic 30",
  "b16f05f79296c1eaca4774ba37c3c719c47df651": "Blackjack Classic 30",
  "b358992c6b536b42ed7b3b6ecfb2f8d6631165e6": "Blackjack Classic 30",
  "8f09ff2502d43a275b40bf49f2d47021a81949c1": "Blackjack Classic 31",
  "c9193d72774e8e18afce968fa77f4d3d01c44624": "Blackjack Classic 32",
  "b40502ea4904216f9c557c99ca175e24c13143af": "Blackjack Classic 33",
  "10724ffb4f7348461b776dec0d470a8c244fdd5b": "Blackjack Classic 34",
  "579e9fd3df96c52d46b47f51265ec353fdc4c79f": "Blackjack Classic 35",
  "d415ae80cf24d1b971485d058b322d791e87cde1": "Blackjack Classic 35",
  "72502f5172d5d413c14063b8563e8a673d82a28a": "Blackjack Classic 35",
  "9ddc68a98153f0d0a0663e99fb1e9bd5e25e1e5e": "Blackjack Classic 35",
  "ad5bcdffd29a43527b7b939f191386884478cf0c": "Blackjack Classic 36",
  "3fe9ef6945cacf046204fce70b8d4552f025ef19": "Blackjack Classic 37",
  "a8d534f8a725fef07dcaca3ffd03f6446e441a46": "Blackjack Classic 38",
  "bfa31abe282d543defac091fd0408d881af01a04": "Blackjack Classic 39",
  "92091752fa5dbd68509866314ff50d213c299bef": "Blackjack Classic 39",
  "073ef016627a996155d7bf10e0ee2f8c255f58da": "Blackjack Classic 4",
  "3b914cd35c83d35f9c8a9e4b71794fd0b3e429c4": "Blackjack Classic 4",
  "5565b77fbc03386a7f1f1ea17109babba3d73225": "Blackjack classic 40",
  "a850b5d5a134d465bd262d9c7b72ccbc12eddca2": "Blackjack Classic 40",
  "ea2d86b49a8eb19a4d90dbab7cd98b32de0ed427": "Blackjack Classic 41",
  "915b25802451a4105b1ac8f35896a5d4b21d1e40": "Blackjack Classic 42",
  "9da17da3e050843395e46ea2bab6ef9ca93596bf": "Blackjack Classic 43",
  "fb6ca6dee23688e4bea6b529ef36f0089026dba7": "Blackjack Classic 43",
  "1a6d8df12c57fb0172ce81bfeccc6aca9132f04e": "Blackjack Classic 43",
  "8ed602d05e7f2fbcfb5438c4687076da55920f31": "Blackjack Classic 43",
  "4e70c9c949bc9e082baf2f910c94d4e028ea9e32": "Blackjack Classic 44",
  "6fcb7df8c92cc127369e7144cf5032ff87462bb8": "Blackjack Classic 44",
  "b4f93161532c2de4e424821c6f129e84364abf52": "Blackjack Classic 44",
  "7c671f0bc275bad56d2bc0f9c648f29050c433fb": "Blackjack Classic 44",
  "7958c140b088712c5bc5a1f8f2675ee6d3f1b273": "Blackjack Classic 45",
  "a896d992e711c8fc001c310f2a46a76de1fde6d9": "Blackjack Classic 45",
  "b32d5bc467eb08621a5b232fddd5117d70a8b8f3": "Blackjack Classic 45",
  "dafc02244afdbdaf814f146b1e684512b31bb087": "Blackjack Classic 45",
  "c7917798651e3e1e9a6d504a2f76b7b2debdbe3a": "Blackjack Classic 46",
  "fe920cf2e7a04b0724aa5d97d146443dfb27e83d": "Blackjack Classic 46",
  "4c19242df00d9c8454a45bf0ca9b74139b28d04a": "Blackjack Classic 46",
  "2ce5ddaeae0e7c4afee393e40a26d3b1e01ad14f": "Blackjack Classic 46",
  "5f99c5dc490e520739d981b0397165fd6d67bfa7": "Blackjack Classic 47",
  "63d8b38efb17867a76de3bcc8da2e98ba039eb0e": "Blackjack Classic 47",
  "dc7ba7877ff6c558ea71e500306976db20e90c1e": "Blackjack Classic 47",
  "36b3cb8b80857d684b5b94acc6932e678d1f55da": "Blackjack Classic 47",
  "37805024df319675a86899075f4927e4ecedec42": "Blackjack Classic 48",
  "f93eb19fe081cf847f0bbfe7fb4e19b2a3eab708": "Blackjack Classic 48",
  "40cd3ae4574f1d423dd1d9cc16786094d9a74e24": "Blackjack Classic 48",
  "a2e861274144b451e525d033cc4d57102a7427e2": "Blackjack Classic 48",
  "61e213eb78e670f22d6aada20f7a29670e191ddb": "Blackjack Classic 49",
  "d97cba925dfc05ea1e0691a560240ff890806a14": "Blackjack Classic 49",
  "d3abf78e3616259a0ddea74d9860813eb5426564": "Blackjack Classic 49",
  "bd19e61da6dd37b063b422c2996e263accbfb4fe": "Blackjack Classic 49",
  "fe4a58f0026b599bfadb4d519d65fe30a7cb73b4": "Blackjack Classic 5",
  "666f7c400da3dc25d3156d4b2fbed97c3bedc2cd": "Blackjack Classic 50",
  "e38a5afce8f9f93781f50fb46847ecb427ce962c": "Blackjack Classic 50",
  "6ace22201e39b4ba7ed41062fd26642056d6f776": "Blackjack Classic 50",
  "24ed8c51c906aaa33a4a6ecb891d21f65c3df28f": "Blackjack Classic 50",
  "964eab72f9e9dfa0784776d8ad7040438a123e23": "Blackjack Classic 51",
  "ad08c1e1700cea175c656516470d5ed108066dcb": "Blackjack Classic 51",
  "9a4bb3fa159f18337ce286680b65233f2bd1b122": "Blackjack Classic 51",
  "6250f40fdc177abcaa66b402a05db32aa18f529f": "Blackjack Classic 51",
  "5e134cd575ea41cbe46c1d537157d8bf0fe6a4d0": "Blackjack Classic 52",
  "877f10c5e7b19203dc674fc79db5b83a1ba01965": "Blackjack Classic 52",
  "645634bd7b09d1db0f0dd5587f6a5806ab40855a": "Blackjack Classic 52",
  "d4b207194a1ddbbc27494bbd32043adfb3db39cb": "Blackjack Classic 52",
  "b649e4022efe86c5d4f21f85e15d3a79c1e53f13": "Blackjack Classic 53",
  "f68854fa5842389923689e1d5273a2a8f2a2d189": "Blackjack Classic 53",
  "1b055f4dd3dad7824caa19da13085ec87617dc38": "Blackjack Classic 53",
  "8237e4c447bb28809065cd04d5a13f6d9d81977e": "Blackjack Classic 53",
  "8479ca4f5497d6a885fdd0d9cc45e47febdcd6ea": "Blackjack Classic 54",
  "8b8e654de867938b3578ef2901a7221d599e2fdc": "Blackjack Classic 54",
  "36de86a38d0e2c18152b2c07e356b67f10046093": "Blackjack Classic 54",
  "e954b81535ac74c6932c54844389512615a6a78b": "Blackjack Classic 54",
  "3c61efb520d8fb7a818f91fd008df0c648a0d84b": "Blackjack Classic 55",
  "3d5ebd7aba588ca4415d57fb851eb776d7a6939a": "Blackjack Classic 55",
  "fb9eb74e16ef9df348a3d36926c0b8b123177729": "Blackjack classic 55",
  "f2a3a33c8e0b409985fffa652447487a5e55a267": "Blackjack Classic 55",
  "2ef2d57f19eb9d31c44ea0c1f473fb6a083de679": "Blackjack Classic 55",
  "8bcfa7f5911101e0d6701f91d704911b204186ab": "Blackjack Classic 56",
  "fce9ab33f83133e2897db699c67daccef60213d0": "Blackjack Classic 56",
  "328d3b422114fb9c39a23333e9a462c333d37858": "Blackjack classic 56",
  "13e192a4be6f9bb657e72993e8676fc1e333dff9": "Blackjack Classic 56",
  "ea7f03187a3e03b914cd3b8473b68dae78c523b2": "Blackjack Classic 56",
  "a5afbd3771b41f1f74c9a18ec07fccaf550265e2": "Blackjack Classic 57",
  "fcb2ceb0a31bb72cdc98d0f480e5036499d9c2e5": "Blackjack Classic 57",
  "1f04297ead5938c2cef62d8d19b2cd49d7f3a681": "Blackjack Classic 57",
  "ffbeacd2ed57a0b380dd4b47b23517098fa8566b": "Blackjack Classic 57",
  "04c6bf2e2172e8e2251921c1abf0e5f1e098a514": "Blackjack Classic 58",
  "0c1313dd2de2010e937871545cd6d6f8d386a6d1": "Blackjack Classic 58",
  "3df3a166207c0984804e0e71941fab11fe6e2f9e": "Blackjack Classic 58",
  "757630bc7755e3b87d4d33118b8d748f4579d7bc": "Blackjack Classic 58",
  "0b9a7cd34d787efb9bc2683c87b82e6cd6f6cb4a": "Blackjack Classic 59",
  "9c4ebd28fc1fb025c82f4f8f005a270358f9dbd9": "Blackjack Classic 59",
  "3f07907b9fee95fb3875fbc1a53df7ef290402b5": "Blackjack Classic 59",
  "a70419b8ce81da84fb789a31b9d525d83cc6398e": "Blackjack Classic 59",
  "c69fdb6c3b9b3e75504a60ca93185c4d34ef5285": "Blackjack Classic 6",
  "4a2d9e8cd8dafba13865de327856aff2cea3fca1": "Blackjack Classic 60",
  "d6e54171659c0a3817d8026cdf535d7a8461ef87": "Blackjack Classic 60",
  "994c895ee30550b97a00ae60913a2ebbea95ea94": "Blackjack Classic 60",
  "c0e198c888fa8bb3a0affcfa74ee82d52638a3b4": "Blackjack Classic 60",
  "7bebdbc1b7e48045eb27b200ed0ca32070a038c8": "Blackjack Classic 61",
  "914537d8e995f29bd218eef447594ca9cd451b82": "Blackjack Classic 61",
  "87b2b7ab2e3038831eae90e1b9e3a7e7a971285e": "Blackjack Classic 61",
  "6699cfa86a1f3e41b4ccbe4d0abb76356555d068": "Blackjack Classic 62",
  "9bce4457c6c9ae602b43dce07524e6cf1562221e": "Blackjack Classic 62",
  "480c34fa49d31adedb9fe347b0311c397fa27620": "Blackjack Classic 62",
  "6d5c096810b87a1a797bbafb541789cc474b6fbe": "Blackjack Classic 62",
  "8ccd50079e590e576428b5263b97d4b8fbb552a4": "Blackjack Classic 63",
  "e2fb5178b46e946294eea862b78df66efbfe246c": "Blackjack Classic 63",
  "764dd82c2d0be0453362b44aa739a7500ed371ba": "Blackjack Classic 63",
  "d0ef530f6b8496e0d28a3a6f7d860838a5bb0017": "Blackjack Classic 63",
  "155eea6622e831f2c0c128aca012427149fd7d36": "Blackjack Classic 64",
  "e6478b4cec56b94509df26cf79f2ed1d6f4b009d": "Blackjack Classic 64",
  "66e4a24d28930daa84c0d8c862fa236efc9d1739": "Blackjack Classic 64",
  "770b5d79d338e6a4af3533e856c5ad143316f1be": "Blackjack Classic 64",
  "6ba850858f0cea99549f7b1859e9a42a2373b52c": "Blackjack Classic 64",
  "b5c4f5f8f0a1c4d9a41efb58be020b5dbeb790cd": "Blackjack Classic 65",
  "ceed796ece96d49f4e03c36241224cf504d9960a": "Blackjack Classic 65",
  "4016a7dddb8bdf7563683064c3306e91fa898838": "Blackjack Classic 65",
  "65a71b0861f0e58abe703060c486a54db1e7dcf6": "Blackjack Classic 65",
  "8c77a2ec14543bb11b21498b08c8994af129bb95": "Blackjack Classic 65",
  "e080c3e9f0c11643b6995ef9582b943739ba26a0": "Blackjack Classic 66",
  "ff7948b6c2f4c1448bee6d7be06c544dde200d71": "Blackjack Classic 66",
  "bf57e920c35392c6d3f64da0a60aa0841c6f8bfe": "Blackjack Classic 66",
  "22657749c280bb055a842141f33b64c005fa8f19": "Blackjack Classic 67",
  "89ab94a35c5da80e95b7c1db4df9fda216b32f84": "Blackjack Classic 67",
  "60ca5fc314a2a07da25912f1e2f2423fbc1ff064": "Blackjack Classic 67",
  "18802f4aa0bc80f401d440684eeedae9e121a1aa": "Blackjack Classic 68",
  "a9b2cc05f3cc31f66ea019aa71d7275769786942": "Blackjack Classic 68",
  "6aa3d6007fd779761925e37ec5369ca8a3e55c31": "Blackjack Classic 68",
  "957b46ee4675fa831e1659dcbfd0c30764c5c09d": "Blackjack Classic 68",
  "0c104510fe922188f78e3bb3947c51248dcdf11a": "Blackjack Classic 69",
  "9c01300f3b0132759c04ed938e7b065f21d6e875": "Blackjack Classic 69",
  "5dfbcd0b759d3cee03f51be045ebf4e13ea4e74c": "Blackjack Classic 69",
  "a764987e61b84b40268f7b68b6eae1eb544eeb7f": "Blackjack Classic 69",
  "23720325299f11ab5fe0fd9c5be5167b2918af17": "Blackjack Classic 7",
  "23ec6626ffe630142ff39c247465caf2fd4b06fd": "Blackjack Classic 7",
  "07f61a790547e74500af25706ae7a5425bd434d7": "Blackjack Classic 7",
  "262203317593f2944c56a8c820934308586a1908": "Blackjack Classic 7",
  "cb274fcb72ff145f07d75fdead09ddd9bd2407b5": "Blackjack Classic 7",
  "85f884717b9aa5635553cd7e65de14ca235f7672": "Blackjack Classic 70",
  "bc9802384087ec0628984b6097143921e6dcdb84": "Blackjack Classic 70",
  "6dc850ade1a0c729e7edcea0682915c75e594d1f": "Blackjack Classic 70",
  "2a2788d891c6e5bf4f5f6d852d4dc991ad144e7b": "Blackjack Classic 71",
  "c051fb6374071cc6d6307a28d7160b3a3b839e07": "Blackjack Classic 71",
  "dd3d65b434590d978d81524b652f8c52a3ee0ff8": "Blackjack Classic 71",
  "463f94ff77c28ff84affad65f4dc55c612eb1439": "Blackjack Classic 72",
  "6d6a924520054f6afc018141422a48b644702259": "Blackjack Classic 72",
  "1ab3778caa605a9027452a49f63895ae152d32a5": "Blackjack Classic 72",
  "84522a2974c17032505e24f0fb53c76aa7be0d3b": "Blackjack Classic 73",
  "9e740cee6a813d8fe77d52ebe8c683375c7c0a9a": "Blackjack Classic 73",
  "45c7bc611fa47d99f8b9337a59416f9820baf5c3": "Blackjack Classic 73",
  "44d4dc0cbc1b9549c5bc86b76430acca1aa940d7": "Blackjack Classic 74",
  "6bbfeb9090ab511cec37164da1175d62f4d07ebf": "Blackjack Classic 74",
  "cccd0cef71fda61f5b42bd77f3e50213fd989cc8": "Blackjack Classic 74",
  "46b049bc6e93d3d43c81b151c719825a24aa07d4": "Blackjack Classic 75",
  "d2ebc10700d710598dc1c58039990df4ca94470b": "Blackjack Classic 75",
  "31133600767cdb25495655763efa2cf236c7c393": "Blackjack Classic 76",
  "ed8defee6883ce6da25c21ca56c9c3863abd2e10": "Blackjack Classic 76",
  "3fd5c64a66305158de9fd663befff7afaba5da60": "Blackjack Classic 77",
  "a22349f21026bc64dc0782cb5348f997d89dab6e": "Blackjack Classic 77",
  "39baa216ccb21f8cb74d1d59e9a6c8bfc33cc82c": "Blackjack Classic 78",
  "58231dc6a16e0fddedf1594a42787e9093000018": "Blackjack Classic 78",
  "b6b73d9003ff065a08a5a0afd674e1c01e68b01e": "Blackjack Classic 78",
  "44942a3ffd785e44da27ed795e36a9df54b2bf78": "Blackjack Classic 79",
  "cfd8d5c640ba48cc1d93c25ebca913e5a976d426": "Blackjack Classic 79",
  "11ba765b5df5f2cc0f3754be8f0e0ff72d4e5be2": "Blackjack Classic 79",
  "30fd6e7e6348c0a91511fe31a2dd6008490cf873": "Blackjack Classic 8",
  "364da13a6aadb3e8dd234266721badc2b4a610b5": "Blackjack Classic 8",
  "37241e31d9ed4832ed5f03e80ae85cb3d970d2ea": "Blackjack Classic 8",
  "194e831d0229a28b962eb7ff785ecc9ecb4b75cb": "Blackjack Classic 80",
  "ac0c5a77bb31f75590c9020b086888a720c0aa2b": "Blackjack Classic 80",
  "a42f29ef2b98cfd6d2637a40fc96dfb8398e0d33": "Blackjack Classic 80",
  "3fdbeea78177e8c7c6175a0c4ed473fbcdfab800": "Blackjack Classic 81",
  "4d0fe994cd7434b4e05f4f6702358a49269f9e47": "Blackjack Classic 81",
  "2ab187bc8abb366d71de0d075ddfacd1ad72d43f": "Blackjack Classic 81",
  "3deda2f9da706163e6b5500d5a30d34699b8584a": "Blackjack Classic 82",
  "7a7a0d3008023578780679bb742ffafbb11b097f": "Blackjack Classic 82",
  "421cc2f726a7c763a277f45cb8ddbc532b41f265": "Blackjack Classic 82",
  "74c75ca8d4c87a0d2738b02c9eedadc4b77bbe6d": "Blackjack Classic 83",
  "7e4c2ba892073332a88d772be0f3ba234da0db9b": "Blackjack Classic 83",
  "bc5386d1bfa275beb590552fc11732dd79d9b3ef": "Blackjack Classic 83",
  "4647f73cb854a4d2c57f66000fb1311a57f5d5cc": "Blackjack Classic 84",
  "ffcc6b4f95b8538c00e106ac3563b827c0928bcc": "Blackjack Classic 84",
  "956fc796fd71910f912668444c7d646f9d516728": "Blackjack Classic 84",
  "7e699af019071185f5a8c4e27e56f481c8dd9680": "Blackjack Classic 85",
  "ab5dc7fd6cbdd3061b6733b445ee7eda0be89e10": "Blackjack Classic 85",
  "b2ae325bffb6dae659f0e77e9cb993256aa8a245": "Blackjack Classic 85",
  "019f7b5ee663e8cdeb8da5a3c5364d2cd5478503": "Blackjack Classic 86",
  "44cf1f26b25e74b3b7bbf788ac48552a5b6c556f": "Blackjack Classic 86",
  "807e0ca415b6dd90091024dbcd41a3f7f7d71817": "Blackjack Classic 86",
  "2d4250fc1f44a734f03902aa02a259604b1a2576": "Blackjack Classic 87",
  "ff99df50687d097458c109cea6c52576ebb56c7a": "Blackjack Classic 87",
  "4150191d7370e4b3b44898cf7ad073995df0b8a9": "Blackjack Classic 87",
  "0fd1341db3c41d82bb5dc626f8223765bef5842c": "Blackjack Classic 88",
  "1c6f7e1c44ceab8e12b1dd5e6a88887c2f977bea": "Blackjack Classic 88",
  "cf27828dd1aed3cc014e5fb36c64f96db334c513": "Blackjack Classic 88",
  "70cc774af5cab12cbab941fc85c652e0681ce307": "Blackjack Classic 89",
  "e330056fad758040b6e8a5ce75bea441bec248d2": "Blackjack Classic 89",
  "3dc36db94ce35f39241805011ce77c87a708b385": "Blackjack Classic 89",
  "173471d88e6c81c2b5126f14dac32fa8c0244408": "Blackjack Classic 9",
  "90b7a0fc60680c8c7b92b1b4449d440a3c476d06": "Blackjack Classic 9",
  "9beb99bbf5a2876d27864feabbd856567b6a0e5d": "Blackjack Classic 9",
  "01276562af4b52f5998d35da07029e11345b616c": "Blackjack Classic 9",
  "486897184ee2d4fbd6a30c5e37b6bffb2ac2c090": "Blackjack Classic 90",
  "f9aed87a0350b78c83ee328432f2af3b236af9fc": "Blackjack Classic 90",
  "720bdf2c0ab00d8d5ca7452ec7faa01f2de7137a": "Blackjack Classic 90",
  "a75d0db19a2465bd51662e4b9cac207fac8dbaad": "Blackjack Classic 91",
  "ae3716a2782301e8571b4d832109243fe42c90ad": "Blackjack Classic 91",
  "0eedf149cf75478ed5bc39beef03bad329334546": "Blackjack Classic 92",
  "dc722262c474ab035c68be96e8c4d8b04c2ff371": "Blackjack Classic 92",
  "17229907e2fd67cef7b8efc690c0d87edaf1807a": "Blackjack Classic 93",
  "4d7a29e4ffe580096c02d2758cb3a8a63f272628": "Blackjack Classic 93",
  "b3df551722f4be707193cd00324d10639ac71dc9": "Blackjack Classic 94",
  "fb0e325829ce4f38eb357661fd414d682d4356ec": "Blackjack Classic 94",
  "05ae2217e5aa1e88090ce26542d2cfb0840ef7c9": "Blackjack Classic 95",
  "08a5eceb8ea56b83fe10ce3bbec85b42ab3c9607": "Blackjack Classic 95",
  "57deb309b0f4ff2c942b62a1f5455517aed4b885": "Blackjack Classic 96",
  "ee715ce05d9684b3e79613aeb453a44062b4c7e6": "Blackjack Classic 96",
  "3618cf94ca26312e1e14c05cfc76fd685ff11b31": "Blackjack Classic 97",
  "4fde48713a3acf39387fa8e2f36814fd92de5ba7": "Blackjack Classic 97",
  "cfa12a288e6f4127459e5f62ed10d05d7f54a18c": "Blackjack Classic 98",
  "efdcb65e6b8188df4c1e555e871721e47a44434a": "Blackjack Classic 98",
  "b407b45601ab8e90e48cf6d19cb5511e3b7fb923": "Blackjack Classic Ru",
  "7aa63daf082dd75094a5592a42dcff5be084ca15": "Blackjack Classic Ru 2",
  "539f5e9f1c016813770a30656109d56dbb9b0f0b": "Blackjack Classic Ru 3",
  "388488f3ba8399a8effe1957c50c05892fc97943": "Blackjack Clássico em Português 1",
  "e014372e2896a6ab52aa72664d22734ad153edab": "Blackjack Clássico em Português 10",
  "4e1efa2c0bfaf5025820ae1fce61c79f208d664d": "Blackjack Clássico em Português 11",
  "50506d7538752d00546e41407a571e6dfa059e0c": "Blackjack Clássico em Português 12",
  "3751e2423ff470e716888398f2199706334a6fa6": "Blackjack Clássico em Português 13",
  "cdc721240fa3a04c98be1c69ea8b623949ed462f": "Blackjack Clássico em Português 14",
  "5411613e014fe0a86c316ca549df5e54e1a978d8": "Blackjack Clássico em Português 15",
  "31b1d3786c44aeaa1556c718e133d183c2f9fc5d": "Blackjack Clássico em Português 16",
  "9be8fb6b6200c6dda0561a467b2f63f248db7c8c": "Blackjack Clássico em Português 17",
  "7cfad8352b2a74367939d3a4eb211805463c6bb2": "Blackjack Clássico em Português 18",
  "e55c008866c094e705b5c747ccb9eee39709207d": "Blackjack Clássico em Português 19",
  "7619d5ac17b5123338f9da7ecf5489afca9c6648": "Blackjack Clássico em Português 2",
  "3955015c580ea32483f508cfa00498529f387d3c": "Blackjack Clássico em Português 3",
  "7af1dc692a5623cba84ee88ab4e2750c58165d68": "Blackjack Clássico em Português 4",
  "4c65f6841d96ff5753a555eba28c4ba8b99555db": "Blackjack Clássico em Português 5",
  "15679b36467cac8b5dd723a7182f617b10cce03b": "Blackjack Clássico em Português 6",
  "a73ca47fdd5ca3d1b2cf5ed006ae2a1bdcca8391": "Blackjack Clássico em Português 7",
  "ea44baa5ffb53622982079b1a05c6170f18bc88d": "Blackjack Clássico em Português 8",
  "20c957f00d8f111bde19f1b4fe13f96e512f9acd": "Blackjack Clássico em Português 9",
  "77ee4e005181b989b3f5d2b54c11176239a844c0": "Blackjack Diamond Vip",
  "8c290d9de0550c8574ec9defb5ea3a5e80109c60": "Blackjack Diamond Vip",
  "b71671e828be72aa3fcfa1130f659943e2ff5e55": "Blackjack Diamond VIP",
  "9796af0cd8bfd88358679206e20ecd9ad0b7e1f1": "Blackjack Diamond VIP",
  "0b7076a9554323d1e222dd301149395dd53ec0af": "Blackjack Em Português 1",
  "f8978a82931bf1bcaffbda609a2dc770868733bc": "Blackjack Em Português 1",
  "adbc13071b2304587da2b6a2e2e67aaee1089ebe": "Blackjack em Português 1",
  "085937a1924292f4567af43990f4fef8607d51bd": "Blackjack em Português 1",
  "8e21cca3559478e8591246613b0d81d836bcfea4": "Blackjack em Português 2",
  "16cda9678fac1b27e80fc1fb31ee2a3444a3392f": "Blackjack em Português 3",
  "09a108d2d25805a4ecfa04e14ce65691c9db7fcd": "Blackjack Em Português Ouro",
  "8175f1603185650db783617015cea66576e4cc4b": "Blackjack Em Português Ouro",
  "bfa86321d183be4a699c5be221c754176b107263": "Blackjack em Português Ouro",
  "7d3bcc7d2883fb636befc5dd2b878c7778361657": "Blackjack em Português Ouro",
  "4800282286237c943ecffb94bd35bb07296f6c8e": "Blackjack En Español 1",
  "7da0daa18ad921a8ed12a776f5b18b8d401e1f1a": "Blackjack En Español 1",
  "dfd90e51cc8dd480149ad0f911feabafff94c7cf": "Blackjack en Español 1",
  "9f20d80f0ad00ae02f532b1b4b27188330e153cc": "Blackjack En Español 2",
  "ce09fff65bc28c6c0aeccf7eb36dd141c7dc1690": "Blackjack En Español 2",
  "6964219eee2e7b08728522abbbac89a1eee5cdfc": "Blackjack en Español 2",
  "9d204d8cb157a354bd3c71d3b9b62817b3e375d9": "Blackjack En Español 3",
  "aa425cff79d69c49ee06bca09461959a8c318c76": "Blackjack En Español 3",
  "991e860e971d5f0766d73a56d6399897fc0657b6": "Blackjack en Español 3",
  "461aff2b13c0616b3d8e5be0c2a0b9015bee5182": "Blackjack en Español 3",
  "38decc37632c499c9f4d8c841ffb8b1097a5876f": "Blackjack Fortune Vip",
  "f02454d78ac0d4b40b6ffde8f5cfef55248edaa9": "Blackjack Fortune Vip",
  "04ba91bb8e0b1fbfd3c89b17972a9bcbc146f009": "Blackjack Fortune VIP",
  "ea300e5be57d566662b60432ee51dcc479359568": "Blackjack Fortune VIP",
  "7f67eaaf0d03ee2df61052329e4a1aebab42e061": "Blackjack Grand Vip",
  "ccdbd58e524ae96b40588ea72f227f47778825fb": "Blackjack Grand Vip",
  "29e80890df9eb834f889bdde7219e31500c5dfc5": "Blackjack Grand VIP",
  "259a76368d03adeabea40eb8293b3cf3884be4d4": "Blackjack Grand VIP",
  "2026c0945047803d074d1bc2b0394e4b9795ea3c": "Blackjack Ilimitado Ao Vivo",
  "73ce35f442e934208c3c90589c596e4a01bc497d": "Blackjack Ilimitado Ao Vivo",
  "0b22930525f6b29770296227e2fa051bda5cc873": "Blackjack Ilimitado Ao Vivo",
  "d0d3ff6417292782fb35e944095406278be753e8": "Blackjack Ilimitado Ao Vivo",
  "420d00cfe5bd5ae3568a0b4cc985f468d47ac6a5": "Blackjack Ilimitado En Vivo",
  "a408b76878986996e22b6c8bfac191cc53905803": "Blackjack Ilimitado En Vivo",
  "8496841a51bad99ebbc1797b580ef052e7845533": "Blackjack Ilimitado en Vivo",
  "4125dc0c21649b02b5a4aeced2b83a0ddedb9bb0": "Blackjack Ilimitado en Vivo",
  "b179f059a93253704eed085753f42f8e9ba23c66": "Blackjack Lobby",
  "62dd57b2ffdbd2567f9f8deac4b8c36e20ad668c": "Blackjack Lobby",
  "137d084ba30ff93d1980b1823ff9fb32158d4854": "Blackjack Party",
  "b3ff71d29044c495ab7fa1e10d8587f4789d65a5": "Blackjack Party",
  "4dd85aba951fd0264cf3807c6fbae1bc100bfd06": "Blackjack Party",
  "6380cc542cf93d731be09eaef82c81fbdf1b5557": "Blackjack Party",
  "25bc699cea3ce1b8081965e47acdeae189476789": "Blackjack Platinum Vip",
  "979c1c934de45539fc2dd8776a077f99b305550d": "Blackjack Platinum Vip",
  "25ef54c21dff70fd9358cb62ac399c2b027b5a40": "Blackjack Platinum VIP",
  "b6dc23ed38cc36ffa6fae97486bee972bd948a36": "Blackjack Platinum VIP",
  "422c8fa8f846b582c2c4251edb20f961424244ef": "Blackjack Silver A",
  "438ac41c20085052e1ba389099a524c8cf55461d": "Blackjack Silver A",
  "f2e146c71b9004444cdff8d731fd15c707cec6a3": "Blackjack Silver A",
  "e08d43d258cb5f8a67d1c8ec11ea3c5e7337e923": "Blackjack Silver A",
  "e1fb0a9890d9805349a7af6b5cd9bd813abaf108": "Blackjack Silver B",
  "e4a7140366efceca6901f5dee937d87631470a44": "Blackjack Silver B",
  "d850fc6bd0b269cfb612f38c18f2071fd2505399": "Blackjack Silver B",
  "f5b975d6acac7a8dd2e2b7628d7f6840d5a41f99": "Blackjack Silver B",
  "19345169c5a9c8192e4806e7d94aa465645cdef2": "Blackjack Silver C",
  "62f2c3599bcab51104f82b304378296dd1d87952": "Blackjack Silver C",
  "d0cdf30cee5c4d056033140149f522d8f98b4cac": "Blackjack Silver C",
  "dc61285988bd442495a29bd32d90d80c2a1f87cc": "Blackjack Silver C",
  "24d31cb8350bdea513ad7c45126b59629414bd1e": "Blackjack Silver D",
  "498d058bd39b257187d18e7088a6ed7a501fded0": "Blackjack Silver D",
  "fa0e4ffacd2ae246ed27aba0895a67d04039b227": "Blackjack Silver D",
  "56ae4e4acea963cfe86ede0119f74e2cd8b809da": "Blackjack Silver D",
  "a024ae59df117ae9268cde30115ff7e932c2bb37": "Blackjack Silver E",
  "b7ff957e232169ab9ddb9ba4c5e3242ed4ada406": "Blackjack Silver E",
  "ea628fec7589e0b2d6703d70d77beabb817252a3": "Blackjack Silver E",
  "2664cc20eba8809290b9aece1de8a346b48bdca4": "Blackjack Silver E",
  "392b5417ced59f97fc564451b99bf4042249e51e": "Blackjack Silver F",
  "8672dbff348ff91f5f8cf7e550fc45b828816fae": "Blackjack Silver F",
  "d6224b7e882e5eb4924850b1042e456d61235073": "Blackjack Silver F",
  "6dd9e8ccec9cb22a0309ab32fa50aa428e024f55": "Blackjack Silver F",
  "0ced9d9c352311fc58ae4585656568dcd9693d7c": "Blackjack Silver G",
  "7de3eff051aee4971c05df9b51374b369de9f281": "Blackjack Silver G",
  "8b0af12f8a0348fe4ba3e03a256f9b2acc1f1268": "Blackjack Silver G",
  "a73b41266e01181bdd833e12157ed17015d1c0aa": "Blackjack Silver G",
  "a0a19b34212233abd4f905a1d68d90e36bd75019": "Blackjack Vip 1",
  "e7b91b478e4941a45f8e91f2551c951b12804a08": "Blackjack Vip 1",
  "14204e1994e54c764bbd32cbdbd33cb2ae9282c3": "Blackjack VIP 1",
  "dd1ad3ba458addfbcef1306ea05bb7aec93d76f9": "Blackjack VIP 1",
  "073a2c3145c96173bce4749dbc1087543793dbc2": "Blackjack Vip 10",
  "a602cc4df20b7a178bf7c31ae665f241a2e97d69": "Blackjack Vip 10",
  "c36700ce9f179fe65a1ef9c639d5878904579678": "Blackjack VIP 10",
  "69a0339d8ec04718f919ff0cb9002b5b7f3c994d": "Blackjack VIP 10",
  "6f3e27d7dac5b4c3e6feaefb7de8a3193f4bd6fa": "Blackjack Vip 11",
  "def4a81437d11f4cc7b0cbca875f07ad72fb1925": "Blackjack Vip 11",
  "d073bdba0a73dfbcbdf1510063a698ea57b6704f": "Blackjack VIP 11",
  "95d3e6f459ad4a823d954acc6f000b81632f3747": "Blackjack VIP 11",
  "1328e387a9e4705f1ee9ab62854b3904503c2469": "Blackjack Vip 12",
  "2eb588360cf85c884eb9b5c816e68b8aa4a534ac": "Blackjack Vip 12",
  "42c3bc5ea71069198c4947eeb8e8960cff14ab44": "Blackjack VIP 12",
  "3035110b59748a93ad0db1280edad8d6a89fbc58": "Blackjack VIP 12",
  "c6386f5a2bcf0753fc54c4e0aab4c7fec090b359": "Blackjack Vip 13",
  "fc7cfafb6e5dd23f183bd5cf994ca1bc97d38261": "Blackjack Vip 13",
  "bb1b7c46af434bfd503931c2c7224d0df886fa79": "Blackjack VIP 13",
  "c8b4856a9f3452b7ae930be1d5e8f4a22a8b6122": "Blackjack VIP 13",
  "3c546807c6daf72812b496b7954f0e4a9aee53fc": "Blackjack Vip 14",
  "dfaffc29631ab2cbd11c0a1025c8955209654230": "Blackjack Vip 14",
  "7ca408af195b1700b92ea3b3324f547bc9fdb997": "Blackjack VIP 14",
  "3e33a1dc09485ce47db503ff06b10f7157acd057": "Blackjack VIP 14",
  "90c8197a9906db5187145af4d9c720fad22f110c": "Blackjack Vip 15",
  "c0a7c90e5e1f38c0fef6b8661a53f82dba9beb3b": "Blackjack Vip 15",
  "57e8bd01279e05fd0bb43b21a74a35eccfdd5b55": "Blackjack VIP 15",
  "433a7d9e1205e60a10305ba8f8787c928b5f92eb": "Blackjack VIP 15",
  "59a44839e990251c18507e3551f17d240799d8c6": "Blackjack Vip 16",
  "b40ba0ada85f04f7e43dc592bc4c56dddf0fb32a": "Blackjack Vip 16",
  "81118f64c9bf17db5ce0353bfa0f5d65cf3f3745": "Blackjack VIP 16",
  "635c1824491f75c131a46c07e515034db473ea80": "Blackjack VIP 16",
  "4740be111bc34ca5fb30422a3be62bd5a092796a": "Blackjack Vip 17",
  "795e53143214a93100d88e6b9180b6e352200824": "Blackjack Vip 17",
  "44db4bd92ccea7cee3ac791ca2762a5f85dd4979": "Blackjack VIP 17",
  "5792de00de86709ece1c8de7e8a073359822a3fa": "Blackjack VIP 17",
  "0f07399cf61ca1e69a9ce39a6d7400ccc3cb8b10": "Blackjack Vip 18",
  "a45c21e157ec97f220fb1aeae397614d36ec0c2c": "Blackjack Vip 18",
  "b2cbe20ea1d1eb4a36ec3b7be137b2d204549d5b": "Blackjack VIP 18",
  "05d0943df7cf74218c7fba4956269d3fc4bd8f35": "Blackjack Vip 19",
  "4ea012aac76aa7bc81e7af2258587fb6184a6908": "Blackjack Vip 19",
  "5f3aea1245406aae4cbdf67ecc744d649997b389": "Blackjack VIP 19",
  "e58122f8d6c261acf4d6fdb72ade1c39ac47262a": "Blackjack VIP 19",
  "0346d67d37dcbfd47b8e57423b4d3e8701bfaba7": "Blackjack Vip 2",
  "b1e6a1595fcd63551c7c530a6dc9a5ca4605cd91": "Blackjack Vip 2",
  "6b7efe613e77346bedb85f56eb95b96844c39df7": "Blackjack VIP 2",
  "3066c785836fcfc7276f03b7e1ae5e6bfe35a08c": "Blackjack VIP 2",
  "8a6809a60aedd614d1b08f398814715002bd6b73": "Blackjack Vip 20",
  "a884e9def2389b9c682d82270db554627fac8c9a": "Blackjack Vip 20",
  "4615b3469a8f1331a7b0b2f1ac9cbff100ea0eb5": "Blackjack VIP 20",
  "c1ecbde6cb56cc4d34a9b647bd1265cdac69a8fb": "Blackjack Vip 21",
  "e86288a728ba1de776ffbee755965a6549b88019": "Blackjack Vip 21",
  "64f9193effa40ac7c4319d9eff4f144aea6b8051": "Blackjack VIP 21",
  "2c355be714ad29bf049bf888d61c2e503373f5d2": "Blackjack Vip 22",
  "585df0f149ca5a6847f88f3028a4e93ad3f6988e": "Blackjack Vip 22",
  "2b169c918eca3016f16bde51312984a21e7e6fd3": "Blackjack VIP 22",
  "8cff88d40c493c666e769a57ff92dc04cce2d10a": "Blackjack VIP 22",
  "5421fea51ed5a826c124fb8bf117549fe859df6c": "Blackjack VIP 23",
  "b879af6b40c63efd47fea162ef80f98519b2555e": "Blackjack VIP 24",
  "6e7e7bdb178463a8c2979b5cbc08c64c9b5ec5a1": "Blackjack Vip 25",
  "e90b376d1a73b6323006da2bc4ca59ad1dab6df3": "Blackjack Vip 25",
  "b2e696aa1e2adb97fd67306907917833b14b3e2b": "Blackjack VIP 25",
  "7356cedc5828c7553192d5b1770ce65dcce298fd": "Blackjack VIP 25",
  "629fabf8c5dbd511c6cb83702bf59d003c64360f": "Blackjack Vip 26",
  "f2b2504db9fa948eda29e62b67e527c3d9145b97": "Blackjack Vip 26",
  "c1a80908ac464ac05e6ed049852f00ec3bf53d23": "Blackjack VIP 26",
  "73c3bca784091df1091e26cfcdc61e39d6a34a66": "Blackjack VIP 26",
  "828fdbd3a6c7f420f30ea153e112ce6e38462b60": "Blackjack Vip 27",
  "a275e5679932991fb2e25d31b95d3bac339f67f7": "Blackjack Vip 27",
  "f349d3649deca97dfe85fe91bb8b3be273d8ee89": "Blackjack VIP 27",
  "6680ee4e899f4ad6af2de872c62646c4434403be": "Blackjack VIP 27",
  "d8463d4b70c0d39724064a77ec9d7c3d90d5cc2c": "Blackjack Vip 28",
  "f9bad98fa3766d05ffc85e139772760de62d7195": "Blackjack Vip 28",
  "b422768c172642f4ce7bfc6096c32f47897fcaf2": "Blackjack VIP 28",
  "0e77019e100b76fcc7fde41b57a404e581b180a4": "Blackjack VIP 28",
  "01b12d47ff76f5de1d56d7f034b5a40ceb6c5993": "Blackjack Vip 29",
  "bab6276710e6650130e513cf70d09a83e0a8b68c": "Blackjack Vip 29",
  "7ea1f5cce3d33b558be9c95407593694591a9db7": "Blackjack VIP 29",
  "68f3adec5e6af46c30e228b40ec086b533ceb38e": "Blackjack VIP 29",
  "3e389a38218e443fab0d30ec57477e4ee4caa6d4": "Blackjack Vip 3",
  "45054415a920f069bac955a62dfb4037233bbba2": "Blackjack Vip 3",
  "2b49d4d404a05acec4057e081cc52b00d839bd13": "Blackjack VIP 3",
  "aab32c84dd95b2e224018b663cfb93d3801bbf9e": "Blackjack VIP 3",
  "059d01f5346949fb0c52dcfb7b00abc3df9b872e": "Blackjack Vip 30",
  "edb2e2e0653b9fe627f3693b775d46a62a22f7c1": "Blackjack Vip 30",
  "89c4cdcecf321f7cb5a281b0676fbe4b2d3a5d72": "Blackjack VIP 30",
  "fcf8d9f18a05f66910b1d7314b7f45b2399db52a": "Blackjack VIP 30",
  "224de228b4ec005783d2b67cd5ab0001d5ccc785": "Blackjack Vip 31",
  "e6f78bfcd98377b0f8eb02105c6f7f8037cf9b3e": "Blackjack Vip 31",
  "8dd26c0d8adfd9ecd4c41c167357b428c230f5c5": "Blackjack VIP 31",
  "5bad93f1909ead651bb79a8cbd088bf205de6c44": "Blackjack VIP 31",
  "5a205fef2bcdab3c342ec436e29c03ebd5022f14": "Blackjack Vip 32",
  "5db4f274fce5d4df4c13a16319a3cf3268c8939c": "Blackjack Vip 32",
  "d5c06df8934fa55a7a0c5ece2db7cc71fb01214d": "Blackjack VIP 32",
  "63bf6a84c7199ca22f7fc9de311aff319389ebad": "Blackjack VIP 32",
  "037667b2b91fdc3e2e9992339b1541e6ea073a23": "Blackjack Vip 33",
  "510de92599231f79747d8aebcf0da0e09d43d273": "Blackjack Vip 33",
  "e589799a6a0f6204c0773d80219f4c2c42c92d36": "Blackjack VIP 33",
  "31ad688dc0d867f1fd7ae1c5938aaf1cea57d558": "Blackjack VIP 33",
  "5872d0251f25f4e236403a4bf283563f69be7321": "Blackjack Vip 34",
  "e73fab29f38bcbb8c610fb59a011bd0585b0d7d7": "Blackjack Vip 34",
  "218c9ebeabd88e06b08eaaa866cbdab6be6d7168": "Blackjack VIP 34",
  "888a21a5aa753554bec1db44588eea33bc5e709a": "Blackjack VIP 34",
  "201d1745d903822e4c6cc992717c3489c178b3a5": "Blackjack Vip 35",
  "3301cf8e3c3ffedf52e1b02d3cbf291af7da745a": "Blackjack Vip 35",
  "cd40cc00f34dee3d24f4fa653d3a9e5a7eda2de8": "Blackjack VIP 35",
  "8d57d7b914cb4e13ee1a1cbcfdc36abe858bb96d": "Blackjack VIP 35",
  "209f223d0c6ebfe16338da03f227ceefd9f05f73": "Blackjack Vip 36",
  "7b067edad5d83bce084aa05f15fbcedb334ccdac": "Blackjack Vip 36",
  "02d4f02dc95fb82bd6cc964e3b5fe140da545da5": "Blackjack VIP 36",
  "cda04e0038ab7d165d95d049cf8f160e51bdd0f4": "Blackjack VIP 36",
  "40ba9a34b48c83ea97fe21d713778579a27cd6da": "Blackjack Vip 37",
  "76f1a3c8aab8e49b2c8a303c67f6d33641965556": "Blackjack Vip 37",
  "656123a93c68477ce922200d8240a1baa9e178c0": "Blackjack VIP 37",
  "5c5759b24b6a16329c83fcaed965938f1be38218": "Blackjack Vip 38",
  "5d9032489cf760222c387cc719b68d726d69d62d": "Blackjack Vip 38",
  "23b8756d632570bb32fb19ffd8b2db4adbff290e": "Blackjack VIP 38",
  "66a1ae229337cb756d775251b52f0225c406f201": "Blackjack VIP 38",
  "ba562a2037ee4117cb21612a7399ddf975727fde": "Blackjack VIP 38",
  "a9b65e3498e18e3f291bf6c392575a6e5ac21bab": "Blackjack Vip 39",
  "eb012b94719391b604ebcfc4abb252b7e92c7154": "Blackjack Vip 39",
  "97e685b43282752bb595e15b0039454b58c8d3c4": "Blackjack VIP 39",
  "174d6ce2caed8179e80194ae5efb1542a0986f44": "Blackjack VIP 39",
  "7c1b0b004b825a07cffbb2715ba5ba10eb1d7636": "Blackjack VIP 39",
  "909c4a42384e8dc7407efde04b2d350af2bc2af0": "Blackjack Vip 4",
  "968fce0ea47fccedf8e6a5b23488e2b8315e5f7f": "Blackjack Vip 4",
  "ce34dcab5b91f115204e6ab91b91ad388c00f879": "Blackjack VIP 4",
  "18bf2fa19806a242fcb111cb3a9f06b3546110ca": "Blackjack VIP 4",
  "46636ee67d270e6794bb76c3e5b0a6628a3cbcb2": "Blackjack Vip 40",
  "680b8ce5eaa1db68f23a6a3b686a9d898542c535": "Blackjack Vip 40",
  "9ba11574a6d3de1b7b7bbb1e8adaaff5c6cebad1": "Blackjack VIP 40",
  "a69623d46f65029cd00f837f0a66c1068bd80147": "Blackjack VIP 40",
  "433a175587a750278b41b8f4c7d5f4310a912153": "Blackjack Vip 41",
  "a11014b9e88751845434a703d791f7e02510d17d": "Blackjack Vip 41",
  "277860edf270a8c363e2f2998bd9a212e04bb689": "Blackjack VIP 41",
  "a0af6552ea1b844fbf1152cec933ba4c792acfb4": "Blackjack VIP 41",
  "6c29601c3bf02fa860431398ff528fa156128125": "Blackjack Vip 42",
  "b4a7d2567ef4c7ebe4e9324e5266654afe118f74": "Blackjack Vip 42",
  "bb0077756cc5c48a5f93e642f850286f58c6d568": "Blackjack VIP 42",
  "577a093caeaad63690df159f08a8e717264503a5": "Blackjack Vip 43",
  "90ed907e897499f74a0238f749fa01d55373d81b": "Blackjack Vip 43",
  "48ff01b6afc3d34a320f45fbcdd0448c31d472a9": "Blackjack VIP 43",
  "34e28d5c3268bdfa8557ecb78af1ba2972eac727": "Blackjack VIP 43",
  "0b1e31ce89634406d3293f9c87ee60436cfc7f56": "Blackjack Vip 44",
  "7a18aed8193913b235023644035608435be913ee": "Blackjack Vip 44",
  "08c40d48f7e0922ae4d308a19bd8702860f39013": "Blackjack VIP 44",
  "29c18ae201ee3581a028bf695232e3bc10850c36": "Blackjack VIP 44",
  "7c347ca223d8b7257445a2a5a139000ecafa02b6": "Blackjack Vip 45",
  "7dcb981e47fa545c33019866c9a8fbc249ef9069": "Blackjack Vip 45",
  "2f51665fada48439b6c680ee3bcc5539120f766a": "Blackjack VIP 45",
  "61683077c3346d9398928ff235ae621606df0ed4": "Blackjack VIP 45",
  "3b5b9e34b92cc5275ab2353fa9d83c3da43b43ce": "Blackjack Vip 46",
  "8a9272f60d660472b282edc664090e5f72763e2b": "Blackjack Vip 46",
  "ed4dbd1d6c98de32f61a0b2f611d3d1a9921ef04": "Blackjack VIP 46",
  "045e654883e14f061ca0b32c9daca0f524ec8fb7": "Blackjack VIP 46",
  "4b923da9d029a4dd854c4bd686863f8c046bc2a5": "Blackjack Vip 47",
  "ecfbe4386b7335867ada7c89e3caef7964551268": "Blackjack Vip 47",
  "74e0a3a85e13fe6117df88ec0974f4f2a62cbc8d": "Blackjack VIP 47",
  "58f96dd4c73309e0e37f358f3b948c8f4b28970d": "Blackjack VIP 47",
  "7a538cf48423ff930104391d0c4f809ae65c0401": "Blackjack Vip 48",
  "fc2cf926fae77b9aac39bf47481c02e0cf5550a6": "Blackjack Vip 48",
  "0f913421942c1b284433b082f9417c3c5ab56f37": "Blackjack VIP 48",
  "56da4f2209e424bfe0cb9143371e2dd85b3a9cf6": "Blackjack VIP 48",
  "7f5ec47b46c926fd633aa5179257754e0f1b3254": "Blackjack Vip 49",
  "fba490a9927300f931accb881057f8132e2b1008": "Blackjack Vip 49",
  "0a18b81e960a2d17098ef76f524d4664afeac4c8": "BlackJack VIP 49",
  "579c3e7aaa7ff46c819f35ee889402d5bc19af89": "Blackjack VIP 49",
  "309b94c098dbcfb95bf1132fce0c77ca8483a0c6": "Blackjack Vip 5",
  "60a06ed1dd341519d3347bd7882f942baf1818dd": "Blackjack Vip 5",
  "0a6695ca7189cf93aef5fedf0aae93c21bdd7971": "Blackjack VIP 5",
  "a3c670194d222b7c593c28cef5ff31ad2d0c80c0": "Blackjack VIP 5",
  "12678cb18c6cabf8e17f99d95900f1b038a981ef": "Blackjack Vip 50",
  "1dcc5ad9e450d012e0321ddc76a5814c6d9c5af5": "Blackjack Vip 50",
  "4d851b00cc5e44cdf687e696fddca33ec712bc51": "Blackjack VIP 50",
  "9c323aa48d9499218e8d3e7b4dc71f43adc93ddb": "Blackjack VIP 50",
  "a1305b2ec9505a655cf56cc35eeab670da9fc7d3": "Blackjack VIP 50",
  "1620e255eaf13c02e32c2dfa39cbadbb4b8ae8f3": "Blackjack Vip 51",
  "6edccc7d79cc68ffa655710f53cd23a018c5eaad": "Blackjack Vip 51",
  "24310aa7125ce84c0cbc4292a49e79a53d5e20cf": "Blackjack VIP 51",
  "2b896ce31796565d512e4844df31ad6ad759dbbb": "Blackjack VIP 51",
  "548ef03da5fe8dc5aeeadde51570a5d10fe3853f": "Blackjack VIP 51",
  "72f7adacadc32c0d74436d5ed107b02e0e7bc51d": "Blackjack Vip 52",
  "d0b1f8d492dbfce62296a3ea9bbf0efa1cc5d885": "Blackjack Vip 52",
  "b872b8a758053d99a17946dfa9d2445609d62b87": "Blackjack VIP 52",
  "784de72d8c8df3ede0b5d80a71604f95ace593c2": "Blackjack VIP 52",
  "3285483daf5ca6163147ed6e1a24860024e563e8": "Blackjack Vip 53",
  "5bc1593a1ef854d9d7f86f18597e3941fe734563": "Blackjack Vip 53",
  "bf987ba1ed894c0ae1f5cd41987242aafce2b7be": "Blackjack VIP 53",
  "6003995fc22ab32b110b87e459be3a90fd463269": "Blackjack VIP 53",
  "337a69a6393d521fc04f3886346cc1f934b827d2": "Blackjack Vip 54",
  "875ff4df2cbc59ac5918abdb46a8a3e2aa9600a8": "Blackjack Vip 54",
  "f41033487bc7c52e6118e9096273bd3a35a56c59": "Blackjack VIP 54",
  "f40e4abf8b0312fe43020ed66e9c535be2d15904": "Blackjack VIP 54",
  "7a57b896ee690c3d06e498debe481010e3a516da": "Blackjack Vip 55",
  "8d39222d47ad06e65572414e6509eee26f23df3b": "Blackjack Vip 55",
  "c36e058aa222c49da320b670f465f17116fd3965": "Blackjack Vip 56",
  "f81c8b4fba4e5429b2c879a91bf4ad5d61588883": "Blackjack Vip 56",
  "2fd928339faabcae2537ff1cfabf1bca574daa79": "Blackjack Vip 57",
  "9e61b28c71a4a887eb5785a6b9950373ac3220a2": "Blackjack Vip 57",
  "21b473982ecac38a21adc54760a08d552b3e0ee1": "Blackjack Vip 58",
  "81efc11dcfd79deaf401fd3ab39aeb26cf35e21f": "Blackjack Vip 58",
  "8604799216e74190641d8d2fc9fd3f9ac6f99eff": "Blackjack Vip 59",
  "b4804410dcd58637cc5fb75832b2668c2fc6e105": "Blackjack Vip 59",
  "16b89eff25232f559fb691391c5324615cb1d31d": "Blackjack Vip 6",
  "8bdcb9b9bfc74e521d5d9ae8542c69aa424d1592": "Blackjack Vip 6",
  "5e1284ee8b97374eabb97d68fa4b5079f1370ee2": "Blackjack VIP 6",
  "04266a6c8b8ae44d71e93b49dc399a5552f908fe": "Blackjack VIP 6",
  "1263bf3d956f54ba577c2ed30f19a49418372255": "Blackjack Vip 60",
  "c1a36a27c672a59f6d1b5a085ef6312145db1ea7": "Blackjack Vip 60",
  "00f76d641dc7ee9045a1629962f0426703d6a81e": "Blackjack Vip 61",
  "4b5915b59f1f032b5c57fa5ecc75d0105a9d89f9": "Blackjack Vip 61",
  "4d27ac293efac50a8e5ec6b8bc62584ef66a9d15": "Blackjack Vip 62",
  "5f4dc0ba9bc938216737bce25e60f52aaa75597d": "Blackjack Vip 62",
  "4fe019dd08a3237411347a0dbb9077ac58ac9372": "Blackjack Vip 63",
  "9293ce7ca944d85b58bd76f113d13afe4f35f79b": "Blackjack Vip 63",
  "a5c32ebe68767526592a1ae4ab474918a82eddc3": "Blackjack Vip 64",
  "d4faf39b7897341b878aee1f35bf3770ff005e32": "Blackjack Vip 64",
  "77d9920d894a0548dc89aa2746d7397246a2b0e1": "Blackjack Vip 65",
  "b20c2842bd99f9165d717f71ddaef71275bb1d2b": "Blackjack Vip 65",
  "49db389f0d69ebc49536ad34891b26a74096ad8d": "Blackjack Vip 66",
  "f7abe37b33486e536f53a3a6091fa43d9554c3e8": "Blackjack Vip 66",
  "c257d83863f9fdc03d8db6e09504a68b8d654003": "Blackjack Vip 67",
  "cf67525595a838a9b686d5f99f6ebe8dfed75579": "Blackjack Vip 67",
  "431e0780444f82ded2164a329ed75929c7076ec8": "Blackjack Vip 68",
  "e0a300381348597e5b0561ffc614bbf64eee1cc2": "Blackjack Vip 68",
  "7c089792e79c4ddba638b77d830827e55f5b3a6f": "Blackjack Vip 69",
  "e52990de8ce9c0bff63a6126193b5cbc8fa4f943": "Blackjack Vip 69",
  "ada025df3fd5a057362c0c95e4fb6ac95f943c2f": "Blackjack Vip 7",
  "d55f0e98bd82958d4a9e8099c8ed591d47ef10f7": "Blackjack Vip 7",
  "0697321c3ba5c0a555782a8910926c49263acd8b": "Blackjack VIP 7",
  "4ec36102ff886ae143fea5f2bc77e9aa316ae689": "Blackjack VIP 7",
  "01b9825cce461c201c3b588a768a90de20ce8b61": "Blackjack Vip 70",
  "e3b6628b75622feaf0e666e0c5f61f7fe9d5d7c1": "Blackjack Vip 70",
  "507121973b01bb678363ce11ff89fede62fe6557": "Blackjack Vip 8",
  "acd8fd447c7fd05c0afcf9353252653146dc9919": "Blackjack Vip 8",
  "03636daaa3e5333ec6ca3412a193c536c96d2838": "Blackjack VIP 8",
  "063c2ec801ca40a59c8d3066a8cc03de88302a05": "Blackjack VIP 8",
  "02f3e7d455f4c1ef8518657bca3a14299ff01b7a": "Blackjack Vip 9",
  "cc84d0e848dfa1fab46d1fa57eb5e138e2cfd1d6": "Blackjack Vip 9",
  "045ecc9ee76ab183ee9091bb49e0da4da4056d17": "Blackjack VIP 9",
  "f1ee54c036f415195e870c49dc64f4b6a1f54058": "Blackjack VIP 9",
  "597c85eaa6232d958910fcf27bba5df655185a4d": "Blackjack Vip A",
  "d38da47086dcee29b4e43312633c55de643e3a97": "Blackjack Vip A",
  "7ff199f65d2983b354fe2bca944af9f714ee4e42": "Blackjack VIP A",
  "00d311367f5dd33f830d44b41c59dd3ff372e883": "Blackjack Vip Alpha",
  "90118bd8992c4772f71b019018997c3153ad8783": "Blackjack Vip Alpha",
  "f7b999b090d42067c21e34ea656f52a12049593b": "Blackjack VIP Alpha",
  "dbdf70c1321749b56bc62a295f1dbdf01086f547": "Blackjack VIP Alpha",
  "223a57d96d5cd6096136d5b44b0d5983cda1293b": "Blackjack Vip B",
  "2a39613b0c840f3bb464e13779deeba979eaf03a": "Blackjack Vip B",
  "a7afe734f3542c9def9cf86b64c66c7d226fdc72": "Blackjack VIP B",
  "5ce2dea485bb71526cd23e86f3af6ee85511c196": "Blackjack Vip Beta",
  "e74df90ed2e00e3bdf7f65248e53224fe4b6a415": "Blackjack Vip Beta",
  "1da8f6033a0abc0010b7bc8b3a15c570efd6ec13": "Blackjack VIP Beta",
  "f9ef8b8be67fd2a7cbe41c400e267e41796f351d": "Blackjack VIP Beta",
  "56d8c1925bebe9f4974d7c087f5664f18d85b877": "Blackjack Vip C",
  "8ba3915fd191e338de93ad43c665054cb637ce82": "Blackjack Vip C",
  "22cf47f16e3f9da941df69290d2f3b8f245f3c5a": "Blackjack Vip D",
  "300ee299bb2e3e9b17c5a743a8948c11f40e8996": "Blackjack Vip D",
  "96388dc5013f02dd1dfda8b39018e29724777571": "Blackjack Vip E",
  "c780c98e66e403fe4b3defb09434837ebbc169bd": "Blackjack Vip E",
  "d1c830388db2b3e90a1e7daa560f66c3ee75951c": "Blackjack VIP E",
  "4a8070292eacde97051443b9960468bd5cea4b4c": "Blackjack Vip F",
  "8248872c3656564238135b2a67c1bee9e95d96d0": "Blackjack Vip F",
  "df023d468295bb4bafd36735496d2c0424f349ff": "Blackjack VIP F",
  "41126b009511b53011c5f0dd4f10b138a2ed8799": "Blackjack Vip G",
  "9261be9bab09853a777f11a5cc5cf3544f859747": "Blackjack Vip G",
  "4bc5490e263e5baf6e479eb0f70317c4e7fc0f2b": "Blackjack VIP G",
  "c7baf79fce4a6d74cb213e0f65ca207e56de0af1": "Blackjack Vip Gamma",
  "c894fff0033786773a69ac46095301c94543f9f4": "Blackjack Vip Gamma",
  "6df28f326e4cd154c5ee50a05831166f666a51ed": "Blackjack VIP Gamma",
  "a427b55c685ebad593dfc70b099720bdaf5fd633": "Blackjack VIP Gamma",
  "6507db549fbe3914056d12b38726e6a1bf75f514": "Blackjack Vip H",
  "a8daf989f379ddab3d460d74fabc61f5365379f0": "Blackjack Vip H",
  "2086eaf7fec9dfc6c32410eb9b2e1704c3836dc2": "Blackjack VIP H",
  "3b501c4dfbf70352161a6ab430a889ae598d6f32": "Blackjack Vip I",
  "8d276a29d91cca78b1c98c4fdbb4e7b3a9bc39e4": "Blackjack Vip I",
  "225d8a739ff529f8dc81ca7c97439f7ca98be7bc": "Blackjack Vip J",
  "3783e3f6129e014b118b1aea16dbe16ecdc22b99": "Blackjack Vip J",
  "ce6980016cdbdb9664ba95955e4fcae384b1c7f0": "Blackjack VIP J",
  "136f8cf5b7336fcb82e9e31c2b225981dcf3eee2": "Blackjack Vip K",
  "b187f9c67b173add0d17838fc32ce0c4322b70ea": "Blackjack Vip K",
  "4858dd4783369b6258c579a1318df2e600582c00": "Blackjack Vip L",
  "515db8f405d44852497977be67b6521e1c594158": "Blackjack Vip L",
  "65954c8b8a206a2041a4ad8a8e7d7c15ff5a0a80": "Blackjack VIP L",
  "a7df3654a22f69c52aefce0fffa46fe66f7631dd": "Blackjack Vip M",
  "acea98e2d79dc48f165b336790c98ea401781553": "Blackjack Vip M",
  "533e58be7af20fc34f26abeacdb9a4f5414bd7f9": "Blackjack Vip N",
  "8eead6a565903e51a27290ce76a2cef3253f598d": "Blackjack Vip N",
  "375f3dc890a11a539e0f7b6ab899bd2ac23b883c": "Blackjack Vip O",
  "e2d6b516f689ed2ab1ee9476c4412cc9140bc717": "Blackjack Vip O",
  "6620f81c7aee0866e413db679d828726f9273096": "Blackjack Vip P",
  "e398482352d9346a389ad238828b0d7cbd70d8bb": "Blackjack Vip P",
  "6f4934f8f8de7f097b2d94d88f4c40d8027148ea": "Blackjack Vip Q",
  "85c6c83c9305f6951b9594078916bf32446545d8": "Blackjack Vip Q",
  "d64f911db6bd43ce73cd2842e1192339ed1e11b1": "Blackjack Vip R",
  "f6c43b8ef845acbc1c457b5301f5a1e0feec9aaf": "Blackjack Vip R",
  "352615b18429f55f9b78699b81bc7b8012bc268a": "Blackjack Vip S",
  "deb1fbe45e30613f258957aca2d8b4d2aa1c4dad": "Blackjack Vip S",
  "4b06ea174875c1c8206aea6248cf5106d3374de6": "Blackjack VIP S",
  "8ea85dc20b024206f33e3e3020da7b7fd2c2c641": "Blackjack Vip T",
  "ad792b0171b3916f4666537b856858278f775e64": "Blackjack Vip T",
  "1bfa9fa49a8a17bb9a5339f00d8ece07bee3ad60": "Blackjack Vip U",
  "4296e6ff3a5cdb737d665898e34d09c6767771f1": "Blackjack Vip U",
  "2df5cd83b5cc2dd61d25296115a04689ba2460ca": "Blackjack Vip V",
  "f9415b6eeb08ebf7dbb69cda6c75e9441be8fa1e": "Blackjack Vip V",
  "9c686c2db8679d69981c5ac35b206a268b962c97": "Blackjack VIP V",
  "c2a29f9c18ff06d475615938f0427f578ecf95df": "Blackjack Vip X",
  "c8b5cd91aa5b726bfacc72fe609d3d6697e714ec": "Blackjack Vip X",
  "3c0751e8cf9d2c93e7a4a60f68334465d2727c45": "Blackjack Vip Z",
  "c2f83bfcdf511d2959f1e5ac4bfa5788e736d9f3": "Blackjack Vip Z",
  "86a9edbad5fe9f42e1c66130969bede8c7498ee0": "Blackjack X 1 - Azure",
  "7983768a8aeba5ed89dba7c985440cd77f5f9a65": "Blackjack X 10 - Ruby",
  "3e0648104a9dadfaea4ebebab8b3e221c2f4a45e": "Blackjack X 14 - Ruby",
  "3f328b56fa1f72e399f5368a8ca5ee0c37e51914": "Blackjack X 15 - Ruby",
  "b52b541299c1e4357159fc1b38876b5b6e955895": "Blackjack X 16 - Azure",
  "9aeaedea3bfbba531353618634616601ef893c31": "Blackjack X 17 - Azure",
  "948270e7a654dd36c8b1121d79d21064bf0b0afe": "Blackjack X 18 - Azure",
  "0a67510d47ad721ce107b34531a972bb3de6e7c5": "Blackjack X 19 - Ruby",
  "88a6790962aa12c1b36c50e483620fb6945ace25": "Blackjack X 2 - Azure",
  "2cb4bf7dda7b44a1a1e15a81b0cebff2bb2a93bc": "Blackjack X 20 - Ruby",
  "422b8d4ef2a59a86cac2af0a026f1cfdac575987": "Blackjack X 21 - Ruby",
  "6a702601092b31825eb521ea90fa618134cb398b": "Blackjack X 24 - Azure",
  "a71dfaa766c1e5124ff8b98c8285af85d0ff5438": "Blackjack X 25 - Azure",
  "2c0eda411f2a827ed2ace1acb64304de4e33ca08": "Blackjack X 3 - Azure",
  "1cbf0f4694623109d8ec156666555d4f58c149f3": "Blackjack X 4 - Ruby",
  "e91add159cbb3f5a4ec5149d0ed9f88bfa1733b0": "Blackjack X 5 - Ruby",
  "28f4b85c17078cb509188d9a5bc28e48b3ffc762": "Blackjack X 6 - Azure",
  "169aad13ea785903795262e11628ab6e47937989": "Blackjack X 7 - Azure",
  "9cf9857f00c7c349a9a0732ec94e50cac6f89fb6": "Blackjack X 8 - Ruby",
  "9caaf44b2f989f380f2f0cdb073527e2daf1f2ef": "Blackjack X 9 - Ruby",
  "d50da3c337e1d33cf022f0b80f4beb86f27de45f": "BlackjackX 11 - Emerald",
  "c03ed9d658719ef74f1b0512a5db79df28cbe948": "BlackjackX 12 - Emerald",
  "bea6da7af7bb807f3446bda7bd749544a0ca590a": "BlackjackX 13 - Emerald",
  "09d546fa919ecf92164c41ce73a427d2cb80dd49": "BlackjackX 22 - Emerald",
  "06eded1f0493a7037434de7a630d1924256bde9a": "BlackjackX 23 - Emerald",
  "1968f5a97d7b677b8f23b2fbd3253bc1a645842d": "BlackjackX 26 - Emerald",
  "9b5dedc6ca342e1223c9f99553109e2144644583": "BlackjackX 27 - Emerald",
  "3940b6953166761772fe19f043390c1b3eb6f195": "BlackjackX 28 - Emerald",
  "2251c726fa47ca653db1e6fd7a14a9413bc041fc": "BlackjackX 29 - Emerald",
  "76494d24656bf86ed5940219fe000fe83c7b4727": "BlackjackX 30 - Emerald",
  "a66eb74b525b55a15e5c18bd8923dfb9d927a46d": "BlackjackX 31",
  "dc43da49a8d62514627bfcd3f5fbae7924e08395": "BlackjackX 32",
  "02cbf7e0e6029c653864e52742b860bdddda3786": "BlackjackX 33",
  "83ca66a4afdb024b50a9d4e45d21e8a959287216": "BlackjackX 34",
  "487d2fab42bb1dc8fee5aa72a4046c8af3b3e3f5": "BlackjackX 35",
  "1dbc517b0537a998e33ca38012364c0fa24a93b7": "BlackjackX 36",
  "55061694616ec352b9fb53dd5b82bf0514a40094": "BlackjackX 37",
  "1659aabb0df0bbc10644ce1e71d2c834cabca97e": "BlackjackX 38",
  "791c8b7918b10cab7df5575174221aab2b34d1e6": "BlackjackX 39",
  "6b8abd722089193ea0b84b473b2cb8e0c748b8d7": "BlackjackX 40",
  "7c96341f93f82b3a95656c4dfd6b4cddef75ae75": "Blackjak Classic 2",
  "b82afced2787821f71703490613f1b06876295c5": "Blackmoore Wolf",
  "59864bf3b4db11c7ae0fcfe2392d6bf28d4201df": "Blade & Fangs",
  "5a2a817e94f4fc859e9ad34c8aed08eb015a709e": "Blade & Fangs",
  "8bb91d80baead31ce5194ffd872f83e07729f50c": "Blademaster",
  "769bbc70f3b049c430e3fce384bb921447d493a2": "Blast the Bass",
  "eb3e586af273bf37da8813cf4c2bdd20e38fb050": "Blaze Buddies",
  "cbda619f19602847d23ed5273dabba0f4715222b": "Blaze of Riches",
  "3f5b08bac798740d4bc922d2d2e618a79e09a3b2": "Blazin' Bullfrog",
  "2cdf4979bf315f7e1c5f059b4a39f13c201a8bbc": "Blazing Buffalo",
  "184f85723c2f496df726fef6cafcbad4a5775fdc": "Blazing Circus",
  "1197b0e868d89d4127063446de5bb336032fb341": "Blazing Crown",
  "0bfce6d8aff0422d7072b9260331c1318820aedb": "Blazing Crown Deluxe",
  "43538f866a08544df8578d6287d933417be5f45e": "Blazing Crown Dice",
  "37bf8a764dc7f7c329aea5043622f3ad4feab904": "Blazing Star",
  "8c93f187cd1ee698dfc81795772a322be22fa1cc": "Blazing Wilds 20",
  "31f28640365979013e0099733368ecf8797557d3": "Blazing Wilds Megaways",
  "7719344122c754fc57358cb3ad1ea01c43a734d6": "Blazing Wilds Megaways",
  "306f33ab1bdcc0b0d448b37af40a2856c0d12929": "Blender Blitz",
  "01ce27c0cdd610ee0034501e3c860eb3490af6a9": "Blinged",
  "7d6a5be4f7584c1b57fe8c5f3c076270db720619": "Blitz Super Wheel",
  "57fcf576470bc5442d2ab22b5ec1363fb24334c3": "Blitz Super Wheel",
  "4cfd8490568915974545474ef4cddf4d2ce16503": "Blocky Block",
  "246c3f590816162c8a94f27252a3fcf3a141b3f3": "Blocky Block 2",
  "0f6a829f89174923327bd49a634fb9f5726b8442": "Blood & Shadow",
  "388ae7d3120693d9a2f1d814639f1fb40d4676a3": "Blood & Shadow 2",
  "97f480c9ab73b8d13f1729704880d319e891106d": "Blood Diamond",
  "3bb27251af7d1c1f637de589e54252d132f12df0": "Blood Suckers",
  "61cd6263f5a6e58f6ef3fd5e75b4d2793ba12a06": "blood-lust",
  "169fe505b5cb0d18c82b70171d819e8fb8414e3a": "Bloodthirst",
  "2eb7901663d84c4fae0735cb08e0966aa806ac44": "Bloody Dawn",
  "5bb0e0a7615e2d333ee6f7acf8d41bc3c8b4037b": "Bloody Dawn",
  "e11067ba0bf95c4eaf927404a6afe634758135bd": "Bloody Deep Sea",
  "4c64a7d3cb050957201f34017dda815d437f2a3d": "Bloody Pesos",
  "b9bde8476cb80ce8d93a3957034e8ffddb7dcc7d": "bloopers",
  "aa1285c7dc55a4789d6ef312cbdc6ef9eb958bba": "Blue Beard",
  "cd013ccc4b225d9d738559b8f404957dcd09d5a3": "Blue Dolphin",
  "f05ac5ec66b103e1ad6169a88d4795041e4641d9": "Blue Heart",
  "31a3511872b6f5f9ee891fbc98588bbe83ec472d": "Blue Oceans",
  "fa5481abb1fcbe5e7b0e474490a6710c27c57499": "Blue Wizard: Cash Collect & Link",
  "bbe8bafddbeacd18751e7898435725328a34234f": "Boat Bonanza",
  "164aab2e63e6ee97cb9c5d112dfa5a61d7d78160": "Boat Bonanza Christmas",
  "dad8b38a326775e79640d495ac550e663531e0f1": "Boat Bonanza Colossal Catch",
  "42a748a670e717c7eaedbadc7b008679eefb6c39": "Boat Bonanza CrocoNile!",
  "433cd07e46cf13d520ea46f38e774ba8aec540fd": "Boat Bonanza Down Under",
  "970d7fa154c1b4d6f5d4f82f5031e49453f855ca": "Bob Marlin Goes Splashing",
  "ccd61b9c0ceb14e201ffb84d61ce51804210c832": "Boilin' Pots",
  "e8238d7d53d9eb8ceebb384a92e54fd057bd72d9": "Bollywood Romance",
  "ce2505718f3ec5eee7bd925ba0fa0f64c1e27be6": "Bomb Bonanza",
  "de03e96d1f34106c1842fd3146a846aa892ae594": "Bomb Bonanza",
  "4875f8e509072cf4300f5802f35ad52a749cba3b": "Bombing Fruit",
  "fe85d9b6b192685d51f24b5ca2bf58c97b34840d": "bompers",
  "d4b98fdbcd1bfcbc1f163254b4ed175f61781cbd": "Bonanza Gold",
  "fd7a585880db1ccb3b7add480db20e1b3a7dbeea": "Bone Raiders",
  "4897c35c64f1d3ff3ce8d7d85d8ae5ff876ecbb5": "Bonkers Chicken Lock 2 Spin",
  "924be168bf32f3f4a0a9269b81ae26e1f6c3daf0": "Bonnie & Clyde",
  "975f28bd92b371f5c88ef8f9902ff6d0d3cc093e": "Bonsai Dragon Blitz",
  "9eec7d1ae40033e8fd9e68b1383b6f5c23c4ae5e": "Bonsai Dragon Blitz Dream Drop",
  "306eeecc3057ea93ea7701b6cec82bbc4769f631": "Bonsai Speed Baccarat A",
  "4b71a5c0bf3d89a11c757a74117d3631e3c99f74": "Bonsai Speed Baccarat A",
  "5ff7aa0dddb16873ed283dcb2afe20388acd9d9e": "Bonsai Speed Baccarat A",
  "ea6f8247074a8733873cf7ef5784a002cc638ec4": "Bonsai Speed Baccarat A",
  "5b295059279c9c169ead5e1be4b2462cee84d25e": "Bonsai Speed Baccarat B",
  "75190d2ca6a605ab2d6c3ce17e3515b482e9fa00": "Bonsai Speed Baccarat B",
  "f6fd8c4ba838308bb5200b59f0de9157bb0a1fe3": "Bonsai Speed Baccarat B",
  "f74e26e530d7504e39ea2c4fe2bb5517a7a2bcb3": "Bonsai Speed Baccarat B",
  "6039e72340b006d5417a009eb67e8bac49c9b97e": "Bonsai Speed Baccarat C",
  "98a87fe6703b8da81e328eb2c1da344483b81e96": "Bonsai Speed Baccarat C",
  "5c992a65331bf43d3ba6bd74ca169e49deb9d27f": "Bonsai Speed Baccarat C",
  "a7712b8855d658d027fafed44e2e137ffc9f5d02": "Bonsai Speed Baccarat C",
  "47321550c21f431524332bb873add34a536e8c85": "Bonus Bears",
  "83736f60c2d23a0ede9df9f3ce6620be0f658c90": "Bonus Mania",
  "91390cc880ed078b40de3af648c834526d5faa8a": "Bonus Mania Deluxe",
  "f46ad932af8e6ceb0417acd569c4c761da69486d": "Bonus Mania Plinko",
  "b2c81321e15241e8d573e212a9215f2a73e2541e": "Bonus Vending",
  "4b12ef8d22696f03a514d1c74e557deb1c8cf88a": "Bonza Bucks Hold and Win Extreme 10,000",
  "12e604da00477d4b5f325fd35c6979102f6713da": "bonzos-bananza",
  "01562cc4f3202568a9e67ac630703d3e7f5859b1": "Boogie Boom",
  "70ef2e8cca8f5ba3b49f036b875ff159216ccf93": "Book del Sol: Multiplier",
  "bf05d642e4268da6f21f41407297d8386251a3cc": "Book of 99",
  "1a89af9a63dbc84e72eb03f5015432fe29c2a56a": "Book of Admiral",
  "9b5d0571d29b5a7359c2ea727780f672043c4374": "Book of Aladdin",
  "f3e0b147c9b3f9472528f251cc3f354e2ba1445c": "Book Of Amigo",
  "2320e907edc1de35c96dba96baa5044744ca96cd": "Book of Aztec",
  "3e123935fdb397e2ea4fbe4c4a7da343d7f5a5ab": "Book of Aztec King",
  "947aaa7c4312e15fe19ff1b255328a72c949bd65": "Book of Aztec Select",
  "b152d440da8cfa974c82b2e8bb629c015320c7ec": "Book of Azure",
  "642c61470b95ef6c1d7445e843af30a2875cd02e": "Book of Cleo",
  "38d1bb2f6ea7867eebc89a50b113eac3ecbe7570": "Book of Cthulhu",
  "5ecc02bc3a56522e7f34316a468cb97f5214ab0a": "Book of Darius",
  "9d9b29633ab04ea2eec876a0188eaa437bd7884d": "Book of Dead GO Collect",
  "14a87ca1c8522644c5fe336ea4bac701c46f6d5e": "Book of Dice",
  "6ceb489280dc4d44ec46fdca3460d4e026b723e5": "Book of Doom",
  "993a45603d8626566e604e5458b30c88aacc0c78": "Book of Egypt",
  "0178456500c00153100c6cd1682d72a293ae09e4": "Book of Fallen",
  "36a082100bc674e906639601e16ddf84cda67cae": "Book of Fallen",
  "60922265b477ac572b5b01dcd520a38cf93050e3": "Book of Fortune",
  "b2ecff07d3c8130e5dabb407cacf0e319606cefc": "Book of Fruits",
  "8bbf3f42d99f90c755dcc786f6df548bb799e300": "Book of Fruits 10",
  "85b9ec53140438269b481da5719438d6d48b5cdb": "Book of Fruits 20",
  "a388f6d7bea3210ee4c6463d2d6261bed606e226": "Book of Fruits Halloween",
  "143eca266e6232a8bce027b32b706c38d00749b5": "Book of Gold: Classic",
  "653865c67c0c11b6517b967958832d967e132014": "Book of Gold: Multichance",
  "8ce13738cefd6a9d4fc4afc548430c1ce8ead822": "Book of Golden Sands",
  "dfac0d30f0fb9d4960b3429831c9c1d8ad1f1455": "Book of Golden Sands",
  "82738cb028462c3320be3e002f01d486d8f0e3fc": "Book of Jurassic",
  "ad6fdd1628e9f75738b4a51a898a4bd0364b85a3": "Book of Kingdoms",
  "e491375431b8053bf7521af0f166f5ee2f72b03a": "Book Of Kingdoms",
  "ce83adda828b81a3f6900621bb0503d10a57f973": "Book of Light",
  "1ee3886633daa4283a64b7920879ed7bfcbccbae": "Book of Lords",
  "e0ec026e228a984197759c393063ce3f7da616e4": "Book of Magic",
  "1d266f91bfe4242099400d9a0e2ae62fac0d6b18": "Book of Monsters",
  "5a83d1919bfca677557ee7faf2e208f472b646f9": "BOOK OF MOON",
  "eb045185effb7d6356d656473dd0855b04822afc": "BOOK OF MOON DICE",
  "912883f497b886173eb8d0c8fad8280da8b4b2b8": "Book of Moon Fusion Reels",
  "85441417bfae7b42755d191a5a9a1699cbfd7567": "Book of Mummy",
  "91657975fba13436ab9e38f7084e5ca19f257184": "Book of Power",
  "e8358682b00170c4907754de15ff915838c2628e": "Book of Queen",
  "5410e905baa213db487b400fd6df68a6b0dccdb4": "Book of Ra",
  "8749f4cd4cef283224ec3009f78f6bed0b5677dd": "Book of Ra Deluxe",
  "04cd8acc293f9a25921a5b4937faf0a42affec12": "Book Of Ra Deluxe 10",
  "20b522791a6037870058a2610caeabedebb2b94b": "Book of Ra deluxe: Win Ways (Ante Bet Buy Bonus)",
  "3cc547ac2b995b119ea59f082f38c09a01a236c3": "Book of Realm",
  "2f9cfa38c828f48d51697e6bb8413f49064dfef2": "Book of Realm High RTP",
  "588f7c82d72d6ee6e4b0df72384bb747cf782138": "Book of Realm High RTP VIP",
  "999bd297df8204da818e79d63dab7b3365b89eb0": "Book Of Realm Jumboways",
  "e2b17259c259f4153b017bb6e0dc952b628c56d2": "Book Of Riches",
  "35b6d71ee621e606141fc13be84f3a88504c5be1": "Book Of Riches Deluxe",
  "6c291bd0d48b7a786cca61aed30102ee8d6b27e9": "Book Of Riches Deluxe: Chapter 2",
  "5186f3cdf0bb8d695afa8d1e042c88aef183155b": "Book Of Riches Deluxe: Chapter 2 SE",
  "9344ec4e4df3b91d8eaef9e41c6cdfd703882605": "Book of Shining Hot",
  "26955ac8d0ffd87c70247a82f4270d75d149690b": "Book of Shining Hot Bell Link",
  "25280200af7ea4566837ff05a7024a6dfd2823b2": "Book of Shining Hot Bell Link VIP",
  "9deafbf0c2feb785b4f6e1db940bddf86633b9f7": "Book of Shining Hot Jumboways",
  "0d53c6783b5ebba2d3e33e5c4d49ad334678bd39": "Book of Skull",
  "a6a088a6beeb9ae082f4b1ffff05e63fb5ba384e": "Book of Sorcery",
  "7c2f22e92e133e7dc6c94e8a4298fe347ab62734": "Book of Stars",
  "d7846bfb955fcdd763f37f954c2c70656b0fbb26": "Book of Time",
  "8c11b02da6a478412947fa60258619ba310d1eb8": "Book of Tut",
  "02c659cff6f707c62f0b36b6b09a16c76df14375": "Book of Tut",
  "5e28cfc36819cc7715a58e814a0d8dc2af0cf976": "Book of Tut Megaways",
  "cda3608360ccdbcc7eb69c0c16da17cb2b2bb07c": "Book of Tut Megaways",
  "8973943f067ae0bae9f50149c1604cb81d33a051": "Book of Tut Respin",
  "02a8aed7b33acddf720dda918049e1567f35db80": "Book Of Tut Respin",
  "9d80951e359126debadb0b60cf794ef636f495a9": "Book of Vampires",
  "4457ce21de561edef009243a9bf783ff48d66022": "Book of Vikings",
  "f1babab9c2eb9c8964f2b5ed18e1b1199d190d5b": "Book of Waka-Waka",
  "287a879e790ae38d11f64ca1b6ec328d368c33c1": "Book of Waka-Waka Buy Bonus",
  "7f63d16ed85d53be8c8cb8546842119578c33b48": "Book Of Zeus",
  "bfaa72ffc953e13908ffd8bbf37952777bad93e4": "book-of-sam",
  "a2a956042e750ba7ec9e64cb95c526c395b9b57b": "book-of-toro",
  "47e5f3ef391c98b31df33494465210091f9ccb49": "Books of Giza",
  "b9ee8db03a437afee5e533b5cc7093242ce9a312": "Boom Star Fruits",
  "80f81c8e0312dfaf1ee6542372894eb3707e45ea": "Boom! Boom! Gold!",
  "4eacd5f98ce501f906583e6cedc091c6367449aa": "Boombastic",
  "4a0ec365352631df7f8673306062ff9e34925952": "Boomerang Jack's Lost Mines",
  "0dc950c301b94b712ce004282533b6bfe7d1b4f5": "Booming Seven Deluxe Legacy",
  "ab273bee1366a885bef492258d9f26b32ab0a00a": "Booze Bash",
  "69e1ebee918eec93c2f3c4ae6a1c1cbb2b0935cb": "Borderland",
  "cb6f9a715de2e69b30bdb027a11d864c58826cf4": "Born Wild",
  "4b6d4d3d130f7c1eca92f79598eb15c28e9205f0": "Boss Bear",
  "22f6a625aaea79c80033d9a3bd6661d41a84844e": "Bouncy Bombs",
  "4c325a919e2b6c06a47263706bb6992dff36af9e": "Bounty Gold",
  "3b9ae06cee2aaed3ba43a070fce05dee4ce40482": "Bounty Gold",
  "212152999ad2f1730b51bf2617c1f2e0593ead00": "Bounty Hunter",
  "8797a495a462883eceaceb53bc2e00300d89278e": "Bounty Hunter",
  "f6195c067446398744863c6f74e4fdf62dec2667": "Bounty Hunter",
  "8e28710e0a72a3a8075ae010b035cc5f147fdcf3": "Bounty Hunters",
  "82bbc208e7ce4cd88c5b551b89a62fb2b4c2d2c3": "Bow of Artemis",
  "d04fd0b959afde6aad6b87b1d0a07ff4ae1ee102": "Bow of Artemis",
  "9d0ac55c17445f4a2163c4eb6e722038d2265800": "Boxing Roo",
  "92fb897477ef809e15126a8786afb6cde1176849": "Boy Toys",
  "6c35b033345c992ac2a98f2af886573be4b911f7": "Brave Cat",
  "3836f0c1fc77012a54e485d077db6a4f63851968": "Brazil Bomba",
  "4f642653336c300e8fe4dd1f129206598e0d9a4e": "Breach the Vault",
  "3f2d4f2c38cba5c7184e4e48fcdfbbdbeb16ef15": "Break Bones",
  "b0f007c48e63a9657596c8e031883ef4fa8df18f": "Break Through Lock 2 Spin",
  "81096119ac965d447712b078b19a0200f778110a": "Breakout Bob",
  "4aeaa7af511a760c21eb190bc9fd3e1bd8bbcc77": "Brick House Bonanza",
  "fcb75adca07a96a9034332639999d89a58e3986a": "Brick House Bonanza",
  "53096ce33eaf564c37396bde379144fdc48fffcd": "Brilliant Dice",
  "14f469e5987e4c8854fe7f648a24707f8ec95c9f": "Brilliant Dice Egypt Quest (EQ)",
  "6c4e88533f370713b426605ed11dfa4a186480e6": "Brilliant Gems",
  "668ee7044376549722aa01a56d2973ee860c26c4": "Brute Force",
  "c5e6972c727342f2b786bc30f4d2c992d1f82654": "Brute Force: Alien Onslaught",
  "470080978f888d32211ab2e2656006ca47e8201f": "Bubble Double",
  "11845816a1052464ccbd1acaa1c386cce8de8bda": "Bubble Pop",
  "678e45792af7987fb0ca47947689feb7ff656273": "Bubble Up!",
  "efb6e4a5b0bad52e03726156761f0b76f2410207": "Bubblin' Riches",
  "49d727094c4e380142986aaf048e3eeac90fcd05": "Buccaneer Bells",
  "08d6d8a0a8381b9af70739717de3a9a2d7d4495e": "Bucharest Auto-Roulette",
  "1dd0a7787e2b40f7d7641e6d53b65d1c2d40623e": "Bucharest Auto-Roulette",
  "037363d2e005fa0f0b0039dc6c1f675dde8e28d2": "Bucharest Auto-Roulette",
  "af405c38e0d218ca2ef00d3b66f1945674aeba3b": "Bucharest Auto-Roulette",
  "8ba03bbf012212049167d0a719ba44faa60615c9": "Bucharest Infinite Free Bet Blackjack",
  "019755d6edf31d7320c8deb2364c832325d04d3a": "Bucharest Roulette",
  "9196b243d31185d5b403ed030962af8b4f457e76": "Buffalo Blitz",
  "17a81c4c940434cd652b40cfe66b8c277ffa4269": "Buffalo Blitz II",
  "09cd08adc9388410f433f69b20d012d1d238eaa1": "Buffalo Blitz: Mega Merge",
  "f03264ea80dd3636af7d15fcecf3f04174d0b172": "Buffalo Blitz: Megaways",
  "9aafcd9fc54aaa0ee463a9778f2f24ddd9b4b8d7": "Buffalo Creek",
  "a19c19902d2f058ef9f1daf6949e49b59c0d629c": "Buffalo Creek High RTP",
  "dcc989b06a6dfedd1ba54ea88e669c028aeda327": "Buffalo Creek High RTP VIP",
  "b835fe4e6c8fbbe89c360fb017091bb7d8d45986": "Buffalo Creek VIP",
  "c214105f037def30b700403fc11ab137dcf41b17": "Buffalo Freedom",
  "32446fcb0d59511ec51c6bddf531b92d7e094e2d": "Buffalo Hold and Win",
  "763f594f46159523141a319d5bc825b2523586cb": "Buffalo Hold and Win Extreme",
  "a70ab563bc06d2ef76c90189bd8883359003135f": "Buffalo Hold and Win Extreme 10,000",
  "014affc6dc71659f62c611dce43ee6729a8ed332": "Buffalo King",
  "efc778fe9f0a538d86051bb445c2b63d720da5eb": "Buffalo King",
  "195a4e74263a5a77cb8e3b61c90466bdb78d2096": "Buffalo King Megaways",
  "e5820a3d45da80e694a3da0ec3832cad3c8dd6ce": "Buffalo King Megaways",
  "676dc5d5735ade6fc2ada10a2fb1b9616ddae91e": "Buffalo King Untamed Megaways",
  "78db21c7312f2459f24b473707b3c9076fe542c3": "Buffalo King Untamed Megaways",
  "742aa18d93e5d94fbae6b8b894d3a3e0ce5b70fe": "Buffalo on Fire!",
  "fbfbc75517c517e42867af691d36ba3a93704ae6": "Buffalo Power 2: Hold and Win",
  "a7d277589ea22e74814e18fa9207d316b1459df7": "Buffalo Power Megaways™",
  "ea09ff236e16b38d89c816f5454699fb7c1e7088": "Buffalo Power: Christmas",
  "c5139740b0b70616d6c748e96cbd3138981a02b9": "Buffalo Power: Hold and Win",
  "81747841b40abdfc1a5c6e735812321dc9ffb50c": "Buffalo Thunderstacks",
  "dd086ea672e2723c86590ef424b5d26bdb7a2552": "buffalo-toro",
  "831e71d1d72a9f480bc300a22638bb199962602f": "Bufona Alegre 10",
  "2c8fa4345e26de191f99f7783da1071f65ad02f1": "Bufona Alegre 20",
  "7a409da0799044b1a4146917e5056e425775c27e": "Bufona Alegre 5",
  "a037ccbea3207a03dc694df2556a19fd400da378": "Bufón Fortuna Deluxe",
  "ce6366c795cdd7af88e2e6c0744d79a83d777dae": "buggin",
  "bdd818ea05fff1f989393ca4d34a1ba22639e10b": "Bugs Party",
  "8899dd5f8eb79b4fcd88e92481a17e8bcd2923f2": "Buildin' Bucks",
  "a6c820a6291afba0887a4f44d47832791b96d15f": "Buildin' More Bucks",
  "d971018657dc2d89d3b6f207aeb23d679190c32f": "Bulky Dice",
  "08dda7dac49330f90150a6381389245274e78520": "Bulky Fruits",
  "210b9696fc62066c9e9778de6f66a8e4ad8a5fc2": "Bulky Fruits Buy Bonus",
  "6a2efe5c223b50fe6620d03e79e014860a4223a5": "Bull Fever",
  "339051a519482332e9854fd087a6568443c6c900": "Bull Fiesta",
  "cfa79b5f662f37d023aea88664199c8f94f06a09": "Bull in a China Shop",
  "a3d117e97156dfe768df50dc01ded876d96d3f95": "Bull in a Rodeo",
  "39680d51931e6fc01e7a62e82bb4c8427612b5de": "Bull Stampede",
  "258cfe79785f93f2608e84065e474457d28f3646": "Bullets and Bounty",
  "da58988f568038dd6ed30964a00184c7a47db3ce": "Bullion Xpress",
  "250d51d5c24bb3568a3c788070e8493ee15b8874": "Bulls Eye Bandits Triple Way Jackpots",
  "dcdc4955505d10fcb37378e9319854fa5926b2f1": "Bulls Eye Bells",
  "210082ae5e7da395ef9cf39f7055a84670746f7e": "Bumble Bee",
  "2f6d895dc518aae0d775a92de9975b78e6b441cf": "Bunny Girl",
  "2c8479e4540d1b9a3f0dbb3281a5177671cd57d5": "Burger Jenga Lock 2 Spin",
  "be898643c4115f62dcf64269a8f96d4e6919c210": "Burning Bells 10",
  "7e5274faced3642ecaab02eebe7c7d2500488739": "Burning Bells 20",
  "1526a75964712c3fb8c43947a210eca82159636f": "Burning Bells 40",
  "81f1e3050a352cf634b18c2989a7f0961c7910d7": "Burning Classics",
  "7fbcbe46c91e6d739501b7f83049d884c4d62726": "Burning Classics 2",
  "5d82bfe1af2a6679983061b086266df933269fd7": "Burning Classics 5000",
  "10d92730f0143d14ba3a287670c164f6fda8fe67": "Burning Classics Royal Edition",
  "99921f5945f531b3057d930a581bd6f622eb60dd": "Burning Dice",
  "d7e8f2bd71542c98f66e2ca0ea306b0e7f4cad00": "Burning Dice Egypt Quest (EQ)",
  "e4f9b1a19826ad82bedf9bd7ce4d43a7227d52a6": "Burning Eye",
  "3a3390e965e800cb44b1e8eb1fecb3fec25bd3cc": "Burning Fortunator",
  "fde3e1fa6a9427de9da546cb54b0bfda31dc41a1": "Burning Goals",
  "519def0bbeb34b1006ec9e99673f65ad27dc2c48": "Burning Hot",
  "c7d54515abd0ea014fdab33216e3443906287124": "Burning Hot",
  "65c285e4710cec4e48d358f4f358d91e4019e9b5": "Burning Hot 6 Reels",
  "144f5589d3bda64ee24c3ac8d3d7ee7fafdee818": "BURNING HOT BELL LINK",
  "f006c096caecc9f1f91f6f994abd336afc7e44d3": "BURNING HOT BELL LINK VIP",
  "268d3a8f7e090a0f04f77a277c39baf60829e5ee": "Burning Hot Buy Bonus",
  "538b0b99d95da9523c0649cde6dd66d3b82d6192": "Burning Hot Egypt Quest (EQ)",
  "2f99d8930e3a7378d1e7d436bde34b058cebac39": "Burning Hot Extreme",
  "91d59910b660b766d12c10ff215ac903c63ea176": "Burning Love",
  "2d764de5b5a6afd67bbc6976e3fafe224c247318": "Burning Phoenix",
  "124755216304db319a69ec2a35ed9582dcd69ab1": "Burning Power Bell Link Boost",
  "e2d76a6ba8641ae67b739e0e803b6a2e71caa2bd": "Burning Power Bell Link Boost VIP",
  "6da979eb4f1cce15d7ceaf938a46548713bfc7a5": "BURNING Wild",
  "4f416a98ac8e09ba358b55f0811efa8a5afa81fa": "Burning Wins x2",
  "7c4d094cddd1a7717d1ac1d91556b2549a13f115": "Burning Wins: classic 5 lines",
  "d01cc2719c81fd89087f25f3a265ad875dcec645": "Bushido Ways xNudge®",
  "f567534b8fa8346544761009e72e217f4f1818c4": "Busy Bees",
  "3c876841b0f9e7d7cf0e78eaca025e68a3e40c8c": "Butterfly Lovers",
  "df14ef3753b642c5a53724354aa47170eaa1a2dd": "Butterfly Wild Dance",
  "faec01d6db06f8d50506ba46fdf5047cabdd8a89": "BuyBonus of Maya",
  "2486cf5aad38c105691bab883db38604adcec8d0": "Buzzkill Bonanza",
  "3cd727e80046f03af3f1ddeff46dd7ec652d8f0d": "Cache Rush",
  "325633cea28c14943acf3c8c22d1edf5cba6d366": "Caesar",
  "cdce1af15a38de479d24c26d2492479abced061a": "Cafe Meow",
  "f5a3a67ce746fb58e9d66b101fb22cfa65b41c14": "Cai Shen 88",
  "7c304cf560145bd2fc4f4218371e27a93174a4dd": "Cai Yuan Guang Jin",
  "710d7cbe36436913635f3b0142594517bf2389a0": "Cairo Dice",
  "676b3c39ce2549962299b457acf9e7b51969396e": "Caishen's Cash",
  "dc582cdcd4a8bf1cb2c1e0f16df080d2bd3f74bc": "Caishen's Cash",
  "48d671a6f9dc75bb7a771f16efea597b13632e7f": "Caishen's Gifts",
  "59514fec6871d00bfb491e2f10d9673b6193c56b": "Caishen's Gold",
  "0f751954c9207f805418fcdb0ca85831a048dcc7": "Caishen's Gold",
  "fbe29001d5b643f2bd7a8c7fc8d8b5ca94870858": "Caishen’s Cash Pots",
  "d5ade3bfc9d20dda6968da6b0f48923efd633977": "CakeValley",
  "9dda6e584bd9fc04d5b806026850a275e9e46671": "Calabash Boys",
  "94fea3c293dae172b841c4939286941ee342bc29": "Calacas Cash Buy Bonus",
  "250a466ce3653eb21c65743d066f0af54d671ade": "California Gold Rush",
  "ad61d655003b8f95c44588e45c36eb918a8f8b61": "Calligraphy Master",
  "7071ff270665d9ccc32f70b9fb33c0f275f208c2": "Camelot Cash",
  "87d9521d43f2796bd8eb85f0bc4c9cf41de6f521": "Can Can",
  "7498b4c1510e5ea1e021a265e2399fd925dc35c7": "Candy Blitz",
  "c0f1fc35267fa12247c4245a41b636cc94691aa5": "Candy Blitz",
  "ffd067fe3fe2654b584899d026a97d5c2a146c1d": "Candy Blitz Bombs",
  "5f10e560a3665f94f8fce4a3a3d4ec2548cddea2": "Candy Blitz Bombs",
  "1dff0e27ff09300d2e72fcbe27b0129416f42252": "Candy Coins",
  "7cdabd46e2054d490481099ecc5517dd07e04c26": "Candy Corner",
  "bf4246e2b136e2d6c8e43233a66c196b30a01e56": "Candy Corner",
  "23343ab13043a0ce5cb09945311d396d762e6f87": "Candy Fiesta 1000",
  "0efd07392c552b6f99ade1aca4a43fa4f9dfe74a": "Candy Island Princess",
  "ee57ddc89090b62bbd730d098a7766a922a07d04": "Candy Jar Clusters",
  "386cc00089046b57b5bbe6397067ccf9eb77c358": "Candy Mania",
  "2828730582fb47d544faa13077e44cc8e9a00b1d": "Candy Palace",
  "6b736e38ad6e884dee76f3dd68c9d10c0fb088b1": "Candy Palace - Christmas Edition",
  "92d43a50e2b3029734a235efe639664906d6595d": "Candy Palace 1000",
  "2a3b1090f86b758761443c387472bdc16b944e5a": "Candy Roll",
  "ff9e01037e4f3fb628aa0d90c6cc9047a84c0c27": "Candy Rush",
  "c5f90b857ba403ce08f175a81bdc88460df73aec": "Candy Rush",
  "5162ce657f0c6c05cb9292e26e910d44325fce7b": "Candy Splasher Buy Bonus",
  "8eb7553bbe359a5d9e31c009e9da8df99c12acb3": "Candy Stars",
  "9079954ce444c9d3392766133d34d5058c59a724": "Candy Stars",
  "726e45e74e82806cbce79148e074bbb145e5827e": "Candy Storm",
  "bfc64f2b7cbdb2c09f12b04fdf77c64d92732dca": "Candy Time",
  "778c40ff2bfb5cdfa6f213600c0d43caf3000999": "Candy Village",
  "ce9acc0c75ff8a0c598d0eae382ae144edd724e0": "CandyTower",
  "b0c7d15486b322702bca6835b6948cdf2a66914b": "Canine Carnage",
  "7cbf9c3d5c3537c85482c262e0b2e03048d1a6a8": "Cannibal Garden",
  "f675315f9a6ad79512244c0022e0c69b2b90b3c6": "Cannonball Riches",
  "05073e8f27f2e0e443d5790978098fda64f7834b": "Cantonese Fried Noodles",
  "aead2dd2e1457f50f7f682d55a122c874b87296d": "Captain Black Cat Fusion Reels",
  "f398325717591cc7875c75759d7ff6ad0e43f40e": "Captain Glum: Pirate Hunter",
  "b37653aa26a32e8542ad602d47aaedb571c631b0": "Captain Kraken Megaways",
  "3739f323370cf41819774eb1b33291e081ff8f3f": "Captain Kraken Megaways",
  "83af592baf50e68b9335c3e3a1cefa9a90eafbbc": "Captain Pirate",
  "06d4aca0c844707fd43812852df5ba319349129b": "Captain Venture",
  "75de7ad3b6d1011e546bc912c061dc165a0c82a3": "Captain Wild",
  "8bfe6d18b34e48f641ab48680d554315e22a8b33": "Captain Xeno's Earth Adventure",
  "b685c99a9046740086b65e25cda2fb4b0187357f": "Captain's Treasure",
  "854cde1f9a8055d66f4fc326e71a6f43953cbeac": "Caramel Dice",
  "12670dff31250490bad5956017162e0ed1082049": "Caramel Dice - Christmas Edition",
  "3d7fad96665f150cd13d031489c9c7a478a0f552": "Caramel Hot",
  "73f8b12aabc81435fae50ba89f3d0a2da3f6f5a3": "Caramel Hot - Christmas Edition",
  "cb360d2a01b3878021138e79496d66d74b4d825a": "Caramelo Sortudo",
  "845d703dba76c2baa21dfa3de60cf3bba1611129": "Caribbean Holidays",
  "1ef363238f195148fe40e7759f2f9f0d8dfced26": "Caribbean Stud Poker",
  "e5b08ed9584f2457aeca1ca78976dba469addc56": "Caribbean Stud Poker",
  "93f378e2f40b4abb9ac446f409f68844f5fe7ce6": "Caribbean Stud Poker",
  "cfd2836bd90e4613f74668a6e33bcaba309bb32f": "Caribbean Stud Poker",
  "8060bd6db9ba481c486f42a446dfcb9664df4856": "Carnevale Di Venezia",
  "2d3310ccd8b8ec497e81a1ea6fcee2a9862a3c08": "Carnival Beauty",
  "c3e8e167afda8d22fccd10fb943ab0f8ff01b7dc": "Carnival of Venice",
  "233de2bcbde41ed98a8d7e10f6b587ad4ee6d2e4": "CarnivalCash",
  "9a2a794229cded0fa7fe7b52bd684c85940be21c": "CarnivalCove",
  "1e154e2ecc67a312674e6903355d6afcccedadf1": "Carp Princess",
  "7c2ffcc7e56ddc3c5ab252ce0bcf581e78cea86e": "Carthage Challenge",
  "b80a62e8d81fb0ace712821778d40a76cd3824df": "Casanova",
  "e1195f5ade7f693cf22be852ff670fb0816f7950": "Casanova's Ladies",
  "6c12c2bd3cb39fd9389dc5865c70796229772a53": "Cascading Cave",
  "e83e270c65ea85ee7a1cccd91ab20470a0e20409": "Cash Bonanza",
  "5e5a7d6869438da84b70f52ea85207e3d596c31e": "Cash Bonanza",
  "c4a1019212fc5bbd9138258a23dd5ba9f774b96e": "Cash Box",
  "0d30158e8c97d46f7361724936c4945340a2f0fd": "Cash Box",
  "1017408b946b42db42a0daec252d151953b92918": "Cash Cascade - Imperial Crown (Linked)",
  "ce80ce800d8ebd063d0401ba3ca131cf8bcce5c2": "Cash Cascade 100 Charming 7 s Linked",
  "0ee2e1628ca046fc223c7f1505959cba492ab0c1": "Cash Chips",
  "d758b71c1f0931fca10a2655c743ddb3af994fd0": "Cash Chips",
  "ad0e425b5103c81bccad21b48a6bbc437900768e": "Cash Coming",
  "bce3481c9481c6eae6b675afbf5d41e1e6ce6515": "Cash Compass",
  "8e88ef37b44b1f0415285f4c6789d5e8abb3c9b9": "Cash Connection - Book of Ra (Linked)",
  "6c1dbbf33cf815354dce7762fd2873ffb8f82b85": "Cash Connection - Candelas de los Muertos - Senor Muerte Linked",
  "4ea5985fb97745c3e64fc2f8a3a19c94205b109f": "Cash Connection - Charming Lady (Linked)",
  "9e9940d8a4d062fb3e58b20ab9e0eff6cfc37999": "Cash Connection - Dolphin's Pearl (Linked)",
  "c6c7709308677c5588351cdab683513ccedc3239": "Cash Connection - Golden Book Of Ra (Linked)",
  "8d1c828e38b370ec91c20d92531908b7ae256309": "Cash Connection - Golden Voodoo Magic (Linked)",
  "df01c9a361b3f04530e4e487dc842e0a6558de86": "Cash Connection - Sizzling Hot (Linked)",
  "70536ee8382a2bf861efbbe6acadd532b1ebc797": "Cash Connection - Voodoo Magic (Linked)",
  "d872d4d7017ffdffe1a93838e4b04e072553c461": "Cash Crew",
  "2a3e4ec236ff5b446b0636421f1c928ff6070437": "Cash Diamonds",
  "fe68e3461cabb5eca419ed6346adee878c044717": "Cash Elevator",
  "d8a06f8412d5eb5c7f552d76a8e8f46fa40eb003": "Cash Eruption",
  "0954e267d9536c6ddbaaca55bde55d12fd3a0961": "Cash Eruption Calgary Flames",
  "cc4770f2d6e0f9babcf4f316cccdaeaf3b77d7e1": "Cash Eruption Coins & Clovers",
  "f5d57886eeb4b6175e7f6e16b06452a3dd43b8df": "Cash Eruption Edmonton Oilers",
  "aad50322b310a662a372b2084118351011803c54": "Cash Eruption Hephaestus",
  "747ab750e51589925d638e1e5780cc4c230d0c7c": "Cash Eruption High Stakes",
  "1e39503f4b4f4a58363ec635fe9aee2dd29a088e": "Cash Eruption Hoggin Cash",
  "01985b863c203d840b357396583d6ee28bd7727c": "Cash Eruption Power Surge",
  "60584480a4120b13b94aabfc6ca31ae3103614e9": "Cash Eruption Red Hot Joker",
  "7eefec42a9f81847d8367626c89be7feb3525346": "Cash Eruption Vegas",
  "27c78cb89e129c362766b5458c40f2ae76e8e44d": "Cash Fruits Plus",
  "b5fb7eb0c8b9fb957a58ce174ea4f936d77c3ef6": "Cash in Transit",
  "9c04ee888e863d1ea63c8ec508534da2d10e49cd": "Cash Melon",
  "9528bdc2a732c8f65b33a4d897c4c346aaccba8a": "Cash of Command",
  "f9ba8b60fb52acd293bf5253c7e7527d78eaedc5": "Cash Patrol",
  "88229e91ea1308c2908fdf30e52d6922a6cd6f96": "Cash Patrol",
  "e7bc424b9ef8b6e582e8b60e99abd4c372a0103b": "Cash Pig",
  "a0e8e3ea59d4ef37ef84be5ee54cbb5477b73581": "Cash Pig 2",
  "ca6d737fc92472d425d3662cd28efb41a1b6fdfe": "Cash Pig 2 15,000",
  "dde8a1dbdaedd27027462fa831b11a4a0d1ca216": "Cash Pump",
  "7e4b9719879c28d69b16df1d0051e92c0c30da08": "Cash Quest",
  "b45cf0d942f693cd0eb53b2fec3d28d87c252e8c": "Cash Reveal - Credits",
  "4a49091993a9775db1e57bf79aff26fed8dbcf5f": "Cash Surge",
  "b406507069e76fbad96829fd0154deaabdffdc54": "Cash Vandal",
  "c522b8bb69383de03dee020e273fb99c326a06b8": "Cash-a-Cabana",
  "2da5739586f9ff6b3388e4782fdeb88f51d68fa4": "Cashin' Joker",
  "640e93ceb5c1858eb6390a8201530ba66ffcf77c": "CashinΓÇÖ Reels",
  "a1ef6f07005720c1123520e056091c09782be5c8": "Cashosaurus",
  "711cace0773a9f5c3cf26c1e2614af8149a82667": "Casino Charms",
  "5d366ece14eaea8cb3ae12675693ec3fb148ea4d": "Casino Heist Megaways",
  "81db845c1b150834edeafcf92bfa611f221d3908": "Casino Hold'em",
  "fe802aa0485d374d9c24a0457ecfcb487c6f7136": "Casino Hold'em",
  "10f820728a32788a8e403adbeb0ec01add8339cd": "Casino Hold'em",
  "eadde667926c491dc70b363343b05fdb2c97b40d": "Casino Hold'em",
  "5d26400c0b0087fc21ffe5d9951605b865ed43f0": "Casino Hold'em Italia",
  "efe8f64d4f82eb742c8d3184bf313d4545de3ef7": "Casino Hold’em",
  "5819bab9fc347435163e4642a571bce0967e54b0": "Casino Malta Roulette",
  "7d0a8f7c7f42aef1417b1882631daaed978c805b": "Casino Malta Roulette",
  "022153bc37792a1f275000b6fd1ba55ac05dd606": "Casino Mania",
  "460d602e3d830fde25f1d2b38a530278812825f4": "Casino Win Spin",
  "87d633c251e77c9497f015c917fc006cd63cc6cb": "Castle of Fire",
  "d41fca2226862d447714be414eee3d3008c43bf1": "Castle of Fire",
  "b87096002b670d51e236b7b34d48489555fbd978": "Cat Museum",
  "eda01b0e349477b5ecabda835a724971b522fb43": "Cat Wilde and the Doom of Dead",
  "521cc0763b60df64a4e4d22fd3e1fcf118732eaf": "Cat Wilde and the Incan Quest",
  "2eee0dfd337796c5480ee6f935937aff80edca15": "Cat Wilde and the Lost Chapter",
  "ae0d59a86b47f3f2db06af9b3bcd9009f3e88281": "Cat Wilde and the Pyramids of Dead",
  "418b89c09407bf032b74063510b2aa5023e8a26a": "Cat Wilde in the Eclipse of the Sun God",
  "82d4322944f38d4cfc2576dd08b008277abaea2f": "Catch & Snatch",
  "13124caf04f4754e2cd37f3f76fef590f7272eff": "Catch the Leprechaun",
  "dc492abb5ccc2ba1a150e1bfe2d65d14d7e5cb8a": "Catch the Luck",
  "2d6666246179c82185127a1cccdaa3ccc55fff18": "Catch The Thief",
  "11cf562a8c52175664faff4fdf004b7bde422ad3": "catemple",
  "71ccd18e3188614207a0505ff528a51d7b9e6f77": "cathedral-9",
  "6fdcdd6ea58f9b96b8abd3d71d07e58fa518000c": "Cats",
  "9972aae97e990dbd1b641e88eb309fbf4dba9534": "Cats and Cash",
  "e0bf6aff429092016a8c646d337ecfa5120ea68b": "Cats Royal",
  "210866c3058601e7c47705853935cdf420b301fb": "Caveman Bob",
  "aae49d927d3ff8ada4df3e02c5a6c7ee6d61e4de": "Cazino Zeppelin Reloaded",
  "5627ece159c38ce21c932684af7e243a6c325605": "Chai Gong",
  "e73326f27ce030ca0b4351a7456f736957b70dbc": "Chain of Wild",
  "3abf339badbc685129a87a3ea63a0092bc32f316": "Chambers of Ancients",
  "4d78a92d32bc757fd93669035b1ea8b74e532d5f": "Champions of Mithrune",
  "edd841caea8b872c7035964398d74c8a72657539": "Champions of Rome",
  "7798c0a9a0cfbd49756f450236e29547700d6920": "Chaos Combat Buy Feature",
  "c79b5582ac8ba538e04f644fb33c52f3694023fb": "Chaos Crew",
  "cf6a76dfaa8583e1958779c3eaf0ceb937e2d9ab": "Chaos Crew 2",
  "73c3042d77c22009592b6c9e776264434b6621e9": "Chaos Crew 3",
  "ddbc3bed7c58d29f00fcce253cd76cbf2a6fc629": "Charge the Clovers: Hit the Bonus™",
  "2be43e3e93a2fa334b465b89c0a2963146059d65": "Charge the Reels",
  "e2082a5d49c335e8e9f7f81a7d361c3f1c7ee880": "Charlie Chance",
  "1fda4d35454ece1873e61c174507feccca5e26fa": "Charlie Chance and the Curse of Cleopatra",
  "9aa659670026cf1c305438c108e559f6ec0dd8ec": "Charlie Chance in Hell to Pay",
  "e9e19167c027fcd2cacf512981760cf73b53d8af": "Charlotte's Web",
  "008191998e1c4c3ac5106fe8eb7e0e679cf492b0": "Charming Lady's Boom",
  "ac5fa0236eba5a4274fc7e6e7998af226da4e916": "Charming Sorceress",
  "1bfa5cba659ac7324874460a220497228e9ddda1": "Chase for glory",
  "712ede39e47d1ebb77b280d551c0ae0f157ba1de": "Chase For Glory",
  "fee433a9c46de5b8bd12e286a84fd2e773b7fb5e": "Cheeky Cherry",
  "6e949f9800ee0b8d76183d92523f21619a0e6d75": "Cheeky Emperor",
  "2b66713bf8fe5c289711f5fa46fe998c66376c74": "Cheer Up",
  "55aa5e59d2bb70085f0782b06f224d443631c28c": "Cheerleading Team",
  "26befdae41288f15d4ace636456cdc7df4f8949c": "CHEESER & JASPER",
  "5df2d85fee8d9a386afc8b9bb5c31bf59d20f50c": "CHEESER & JASPER DICE",
  "279a715fff402fe8c30064227da3d02d09a77c0e": "Cheetah Wild",
  "c6d5a76d6308f31aafa08808aaa0268c9f92c45c": "Chef's Sticky Fruits",
  "563ec1a9ce4c7013bdcbe6c691181ac0e64a5332": "Cherry Cherry Baby",
  "14760a5a5a6d5e9d5bf0974d72e74a7eed9c1044": "Cherry Surprise (Buy Bonus)",
  "bea131d89108bc2dedde50ac629a1554024da08c": "Chess King",
  "b66f06ce724626c270ceeb047c5f33aefc7de519": "Chests of Cai Shen",
  "6732890ca0a8bdea3fc8037c00c76191ccda2ee2": "Chests of Cai Shen 2",
  "f2b26d4741cbb2669e6b28e9f4ffd9ed4d523af2": "chi",
  "7cf0b0f9e3993514f15c6fa07c993e604f91f94e": "Chi You",
  "9deffe9f8437909169d1b7dfce8076c68d36af96": "Chibeasties",
  "6b9ea3ba737a9820fdfee37ed7eb9ea2075922b7": "Chica Alegre 10 Buy Bonus",
  "eb1a157a4452d3fa232b89b0b2e2998c46fb8ca8": "Chica Alegre 20",
  "1da275e26aabaef1f98d18be46e5bdb974643cd1": "Chica Alegre 5",
  "5817e950a0dfc4abdd0fc2f9dcc7343fe7b94ac3": "CHICA BONITA",
  "8b37e9d2c3e2f8862618776c7521fb6cef158600": "CHICA BONITA DICE",
  "0fdd773c6fb1838290acb238e759c08fc0f96431": "Chicken Chase",
  "9cbc8ffbd2873235cb46d6ae87d568a8c5a44166": "Chicken Drop",
  "e2595d20c5dda5bec6fb0e004d1e4a159dde0850": "Chicken Drop",
  "a1bf6d4da842b8d0e79c0d5d569d3ba0d03b4231": "Chicken Man",
  "c15baadb2b7a7e65257a1c490f6c7583bc694cee": "Chicken+",
  "e10275c034b0c096da9b9ab6c3b5f3a7b01269c2": "Chihuahua Party",
  "0ed7ee252853bfdedac175709a0491cc17a24025": "Chilli El Toro",
  "878d1b72f58192d07b1cd7f3bb20ffb736bd8588": "Chilli Eruption Thundershots",
  "514aafe6128584ea5a517bcaef430eecfa36cd10": "Chilli Fiesta",
  "a7567c602fc430e6c61d44ad3067a6c142d43f44": "Chilli Heat",
  "83f3246dfaa0a5f57049ed684da1113feeded639": "Chilli Heat",
  "f14835b975c4ce14c0e584873b690400a765f2f5": "Chilli Heat Megaways",
  "89a4dcd607f56c6436d111de976cd42964c982d6": "Chilli Heat Megaways",
  "ffce02f4cacf2720c86fe111eeb7b1313de1f66e": "Chilli Heat Spicy Spins",
  "b3fe440acf38858de34a0dfc76f54a5d374fbb2b": "Chilli Heat Spicy Spins",
  "e46edd9ee6c3ff8b041fcb3cd70f8a33f07c5ad2": "Chilli Willie",
  "1f2e38e861222168500c591cda4ddcf040c342f6": "Chilli Xtreme",
  "d0e0d085069f03ece71db77f14bcb3b5e5cae35e": "Chinese Ancient Tomb",
  "86e9f5d1ca3fa73ff781fd73a96f042300a1398d": "Chinese Feast",
  "11d731920ebfbb51f1266566ca8dcac38ad2a215": "Chinese New Year",
  "1dd03663d409c1a075ef6adcc2028f9955543237": "Chinese Opera",
  "f7f7b9bf6900aabc70fdb4fc0743277092274bef": "Chinese Pastry",
  "386655973a2f05da74f2f1115974ccd6e2f0f2d4": "Chinese Phoenix",
  "f566a4f9ede68d152a3c108c05bd082e3364fb23": "Chinese Quyi",
  "f192541d61ca3be822a80d3bd30bd94c5ddbc431": "Chinese Speed Baccarat 1",
  "4ad7469b475b5a4329de3e19f268e3e0b466deee": "Chinese Spider",
  "1e80d80bb8d182ac54583cb6fc341c721638c3e4": "Chinese Tigers",
  "b4771effd20bd14567a7eaa454b3d769ad14b174": "Chinese Valentines Day",
  "8d4bb7aef78dcd621875931abc63bc1b2db4d294": "Chinese Zombie",
  "bde787c86c168f03db660c09b28ba0de426020ba": "Chivalrous Girl",
  "9d680995c6a6fd5e78240be9b18edcd23784d123": "Chocolate Factory Fusion Reels",
  "67ca5ab4469e6ff80cf155f05fa3637adc9cd6f6": "Chocolate Rocket",
  "833f7815ddb1c959a24dc785f75c6cb0666281f6": "Christmas Big Bass Bonanza",
  "19ac7d545065c23aacef67713265b0d5cd7cd4af": "Christmas Big Bass Bonanza",
  "f3b3641465fc3890a325b037252e1911839a141e": "Christmas Candy",
  "df8c5db7b0ece96b4996d003ecb672819cac0e2d": "Christmas Carol Megaways",
  "029919830d38d3b8c01d51da549ad1b8520c8d1f": "Christmas Carol Megaways",
  "a9bf4c673792196c77eade123d05089f947721ac": "Christmas Jackpot",
  "3d798cde82f10902ed24a6b40b3d75d514eb3ef1": "Christmas Wins",
  "bd7390f3fa9e715db32a58b39764108be585fe65": "Chronos Joker",
  "cb1744c1be69d74a00f6017d55a556e07aaf5a80": "Cinderella's Glass Slipper",
  "d6bccf9357c8df2d02a0b6a6dd257ca454e4b29f": "Circle of Life",
  "f4b85813fba9e76f6da6f74ad55a751b00982d01": "Circus Brilliant",
  "ad35a8eb45d13aea537c6ddaeed1a2e2ecd6ca84": "Circus Brilliant Egypt Quest (EQ)",
  "8c096d1926390dc392757dd13f0c97af2212ecdb": "CIRCUS CIRCUS 81",
  "5bdc02fe5b3ba09aadb4a0a0fc9f0caefd06bce1": "CIRCUS CIRCUS 81 DICE",
  "aa1b61c2ff1396bdd4cc61e820543ea1660ba070": "City of Sound",
  "5e2c27a6fe13f664f5b4a40665277bb6caefc855": "Clash & cash",
  "1caf83813ed997bc8fc87d49e3dea79c7b8d3858": "Clash of Camelot",
  "322d7fdcf877b5824c18393ddc9f618def49b60c": "Clash of Legends Battle Lines Ante Bet (Buy Bonus)",
  "c2d7b503ddf6f27d9f284bdc85c772f8acb369a6": "Classic Always 6 Blackjack 1",
  "48df82a9c6f206631a94dd78910a58075ad2c6d1": "Classic Always 6 Blackjack 1",
  "d525f10fb1a21f3de459f4ef7b450e9b5ebcfacb": "Classic Always 6 Blackjack 2",
  "396f9d32f5adfe4b1719055b4b6ad44cee0f7746": "Classic Always 6 Blackjack 2",
  "dfdc0057e432598d274f38842a1994d42e421f42": "Classic Always 6 Blackjack 3",
  "9d2f3a22c63e6e615b3b870a0d14f336f8dcd40a": "Classic Always 6 Blackjack 3",
  "72e91d8d3139c7adc045a07226f5c01909734ac6": "Classic Always 6 Blackjack 4",
  "62d404c5c1c918c4b5f5da842e396303d5182e91": "Classic Always 6 Blackjack 4",
  "bcedb7b3e3c85c14d29cccbf42c8ef46bac3e22f": "Classic Bet Stacker Blackjack 1",
  "a47cd7aaf09e3939bcb9a66dbd5f87cbef881aca": "Classic Bet Stacker Blackjack 1",
  "38f469e89a4b454bb4f8a336837ee8cd922cefec": "Classic Bet Stacker Blackjack 10",
  "3c748078594b5c289166d14b2774910193eba213": "Classic Bet Stacker Blackjack 10",
  "4a96985b1fe9e63f83cf4ad85d5076ea3b159567": "Classic Bet Stacker Blackjack 11",
  "6e345a28972d7523c928595901300717b11da313": "Classic Bet Stacker Blackjack 11",
  "38fc3db50b3d8ad9a5a6fbae3c89e42d73cf5b8d": "Classic Bet Stacker Blackjack 12",
  "e98a5faabffff499b0eb06e88958defcd38504dd": "Classic Bet Stacker Blackjack 12",
  "0a7e4cfbdea4e9e4aab22604f220bc1cab0ceb2e": "Classic Bet Stacker Blackjack 13",
  "cb8b6d937b67815fbb924348fee4fdea45221e38": "Classic Bet Stacker Blackjack 13",
  "09aca683edd4d5d3a542742fc760ca4b698bd32d": "Classic Bet Stacker Blackjack 14",
  "6f3a969a20660ea2eac8c196d94ce3adf17be225": "Classic Bet Stacker Blackjack 2",
  "026982a96b4518e90f1f10586acfad16cec8ee44": "Classic Bet Stacker Blackjack 2",
  "06cf9c7945528aedeb581c110b2c5435e14aac82": "Classic Bet Stacker Blackjack 27",
  "36e6e1fe3fd4c0b995cb5c4104556a6d4c883a14": "Classic Bet Stacker Blackjack 28",
  "f9d428aad5085723661819521b5512ff48d05d0a": "Classic Bet Stacker Blackjack 3",
  "362b527eeb6196409ee4cc89e3bcb934ed2d951f": "Classic Bet Stacker Blackjack 3",
  "e38bc71735bcee7b235812331c96d265fc7af288": "Classic Bet Stacker Blackjack 4",
  "76348a05f813ed3e10af54624140a128a6378879": "Classic Bet Stacker Blackjack 4",
  "4d83392bf0cd847b4d72f52b2d66c386182649d6": "Classic Bet Stacker Blackjack 5",
  "3321ca5ed7e93f614d7b746fbce4729ebf337015": "Classic Bet Stacker Blackjack 5",
  "80bc83dd5fc11e7680e1e597086baf456bcaabd4": "Classic Bet Stacker Blackjack 6",
  "66bdd5b0ad688096990e2fa4a415630fb11ec907": "Classic Bet Stacker Blackjack 6",
  "0ebc8294a4e3a8d75a20302904e678d94f88c620": "Classic Bet Stacker Blackjack 7",
  "1578a5bd12e06eaafd976eb980f083909fd817b8": "Classic Bet Stacker Blackjack 7",
  "b1037cc00eb1cc539b04e287ad9233d46fbbf05b": "Classic Bet Stacker Blackjack 8",
  "344c2dcb72c41a55119a1f6f72c2ff19ac407803": "Classic Bet Stacker Blackjack 8",
  "21fc9392bca0fa6e8528aa9435f3941851fe1946": "Classic Bet Stacker Blackjack 9",
  "ca4cbdc201c4b26864fee4db5d4ebb6b59206978": "Classic Bet Stacker Blackjack 9",
  "0a3192c3b4a353c34d83b8c04b605fde9e968577": "Classic Fantastic",
  "73187c18fee64d9615469a725d3e06c3a047d1e6": "Classic Speed Blackjack 1",
  "9425490cdf998b58dca3e8c81092c3494c6556fe": "Classic Speed Blackjack 1",
  "870a174fd671e15fb732cceef56d22a9f5a5d812": "Classic Speed Blackjack 1",
  "c67ddc6f11a155bf4346f23fa2d59343fe312529": "Classic Speed Blackjack 1",
  "0cec3a29986bfa855987ff92206c86481111518a": "Classic Speed Blackjack 10",
  "98a664e75ee10dc9ca1831c52aec2346175c47f2": "Classic Speed Blackjack 10",
  "25eaadbf45ac48a83fc983b508fe781847fdd2a7": "Classic Speed Blackjack 10",
  "a7b6e0224377b0305cc7630276bb5217125e7b65": "Classic Speed Blackjack 10",
  "909b1a716e5548cc35c84f7428716d287e11f1b2": "Classic Speed Blackjack 100",
  "fa6fcd9b6e6805a5b5c2f1209f9920602157f69b": "Classic Speed Blackjack 100",
  "3aeb71f6b315c1b72aa3d21cfadbe7c324ab2f13": "Classic Speed Blackjack 101",
  "a80a0cbea76434442d406c6390ae7d37960617b0": "Classic Speed Blackjack 101",
  "30a3f7a3ab6e090f87d317742b4ec6fead66cd36": "Classic Speed Blackjack 101",
  "3ddd766b5258a4a9f4a8ba6e26f3ffcf53d1743a": "Classic Speed Blackjack 102",
  "e55b510bf3b039923fea8f79314eb4f5447527e7": "Classic Speed Blackjack 102",
  "b2cdb44a256e88f69c5912104bb46da91fadf67a": "Classic Speed Blackjack 103",
  "ce7ca64037633ff95484b915f8d46d4ae99d9bde": "Classic Speed Blackjack 103",
  "f44d5031fde68573593de869f37362bcdaebac89": "Classic Speed Blackjack 103",
  "5516aa09a4c68103d357c86da2afc3a97e76ad41": "Classic Speed Blackjack 104",
  "ccbeefd18535df9722c029d910386e3daaed46a6": "Classic Speed Blackjack 104",
  "317d88f08bbc110b802c33ede951dbf81e137170": "Classic Speed Blackjack 105",
  "a0b346f6001dee719b70101c0ac973efe138fa7f": "Classic Speed Blackjack 105",
  "4ec76e2b22fbe2dd55885aeff323478cc6a64fab": "Classic Speed Blackjack 106",
  "db306eb590ce8d7fdb6a7821c3f062524580f5d3": "Classic Speed Blackjack 106",
  "a51c72787e57b351c88bdc0fb5c11190178ffa14": "Classic Speed Blackjack 106",
  "0e6b687284bf70b911b8389a39bc6304997ec230": "Classic Speed Blackjack 107",
  "bc3ca0f89de1ee4e60bbb314996e888a0f0391c1": "Classic Speed Blackjack 107",
  "40cf9b7ba344825c21f907ebdee22c68c6b58321": "Classic Speed Blackjack 108",
  "8bc5d7f16cd660288797ae51b3147ecb7360e187": "Classic Speed Blackjack 108",
  "05aad64766496ee5b425c064503025a615b8d5f8": "Classic Speed Blackjack 108",
  "9beb9a533b6763245ee4da548c8fc3b11acc71f2": "Classic Speed Blackjack 109",
  "e1bc07f036fa799928362ff8d7b1319ba686db35": "Classic Speed Blackjack 109",
  "a1afb4bd6b0817bf0a8ddbfaf6981033bb08ec1b": "Classic Speed Blackjack 109",
  "2ae60b24fdc8182780264863aea137ce97311d91": "Classic Speed Blackjack 11",
  "9ec458c1fc749fb46877e1559e69499be113e14b": "Classic Speed Blackjack 11",
  "d4ac34d4a5a8e97439667c14d2925e7683971f30": "Classic Speed Blackjack 11",
  "4d7308b676bc63976c85476c207f64c9d3b7554f": "Classic Speed Blackjack 11",
  "8865ea8b5961e75fae008881d8dd1e34a76acc71": "Classic Speed Blackjack 110",
  "a7a389bf4fabfc539034d020fbf551b2ef3dff47": "Classic Speed Blackjack 110",
  "c7f4274a78e2b13f9bbb2b26efa29d73d0679f55": "Classic Speed Blackjack 110",
  "3ed5c4833cf647a7d8deb93b91f53d780f44face": "Classic Speed Blackjack 111",
  "e73e51e240f225f6cd5dfb16b496f8a0c6edfdc2": "Classic Speed Blackjack 111",
  "55407c937c68b5b549b93e2895951bce60b8361c": "Classic Speed Blackjack 111",
  "77d196c3141441af27efea734950c6c9a9429d53": "Classic Speed Blackjack 112",
  "f0b7b9bc150b52b5368ad0cf42e80465eb563e81": "Classic Speed Blackjack 112",
  "ac0ec51221b05addae381adc10b20aad137eea1b": "Classic Speed Blackjack 112",
  "2b3a6d5dd15f175c2ecc4574d531c005d4d7490d": "Classic Speed Blackjack 113",
  "bc064de381f7a2ff980b1719af76b65d64b34356": "Classic Speed Blackjack 113",
  "401b8d0f485e30a15b015d426b3096c4a6658a9e": "Classic Speed Blackjack 113",
  "6ebceb085de32c12fd1fd119086049f542945a5d": "Classic Speed Blackjack 114",
  "ff09d3e2f683e1ba3aa6f83251eaabe41bab03fe": "Classic Speed Blackjack 114",
  "06a95e983a85ba4535c42464308c95b8c1ceaa3f": "Classic Speed Blackjack 114",
  "1b889745969a89f3eb2f68c9b7bd7c0a2414b7da": "Classic Speed Blackjack 115",
  "e7d1431f307749f277f14d6f056c7dab68146c8e": "Classic Speed Blackjack 115",
  "94e65ed517f435184df9dc36d283dcfc190c2193": "Classic Speed Blackjack 115",
  "13be425ff93c0e884281c605c63558276541655c": "Classic Speed Blackjack 116",
  "e291ae4bcfb2c3d3c41a93884dbb4e1115049edd": "Classic Speed Blackjack 116",
  "29240c8902f9d01c18425435e8449a53bf60d6d0": "Classic Speed Blackjack 116",
  "bc44dbb0d4241852996e5503009bf655d0c4a11b": "Classic Speed Blackjack 117",
  "e683b42df0c0bf779ed4766f8244243fb28719ce": "Classic Speed Blackjack 117",
  "4dd276473b4797fed9fc4997ac469cd0b6d11677": "Classic Speed Blackjack 118",
  "eb5b72aee72da5a83d413b3a50d0902685dbad31": "Classic Speed Blackjack 118",
  "b7794bfbd543bcbaa9352d9a038a8a566190fdfb": "Classic Speed Blackjack 119",
  "c17e2fef587f801a237b6c31e6a7e6ec5087d7ed": "Classic Speed Blackjack 119",
  "6157ba2eba9f3558e1e1b2885316511103f24981": "Classic Speed Blackjack 12",
  "d852b90089fd58695fd559b484d5743c0b912967": "Classic Speed Blackjack 12",
  "da1528d5e07a97db20a6de07d55156888db92d11": "Classic Speed Blackjack 12",
  "0dfe1389992bed0df7a07e6bbc0cca452efba631": "Classic Speed Blackjack 12",
  "5b77d17088dbf40e191f2182cf7f3dfcb86568bc": "Classic Speed Blackjack 120",
  "d1f82a85214abc873928c287349f2c309c22f564": "Classic Speed Blackjack 120",
  "e49bc2861a1da2c43e9f1b635caac9e8aa67619b": "Classic Speed Blackjack 120",
  "d07c0d190267c8091a260e13fe87d28a3a057264": "Classic Speed Blackjack 121",
  "db7a344c24ee2569fb02f289e7e20f63209778e0": "Classic Speed Blackjack 121",
  "38afe8919dadc686501aff6201f02218a10a0e3d": "Classic Speed Blackjack 121",
  "8b8d1f19e9d0ba4facdd6b896cb571328d38deff": "Classic Speed Blackjack 122",
  "d0eebbbdced8be41a8f2dddfa990a69a365cf988": "Classic Speed Blackjack 122",
  "1dffd6bf4bd766746473237417d902400f7f15f3": "Classic Speed Blackjack 122",
  "9d0db1e93d47513b655d87c2b31854d538b0ea9c": "Classic Speed Blackjack 13",
  "e4755f8e1502951d95be195679b2ad67a5a50294": "Classic Speed Blackjack 13",
  "23cae676fec35a5eb8c6713eaa08a28fd2e08adb": "Classic Speed Blackjack 13",
  "fbf7fff90fd5c465dca01f6b7e598678b00efdd4": "Classic Speed Blackjack 13",
  "4e912354c5a1db7cd9dd8c7e80a29cf158101a0b": "Classic Speed Blackjack 14",
  "8800d2fe41a3242e19810299ebc1b9c4833dd49e": "Classic Speed Blackjack 14",
  "0f13e1099b14e993128e30d08ec6ecdb96499897": "Classic Speed Blackjack 14",
  "47a6c373d93e31f11f9be8a632fb30c62a4f85e1": "Classic Speed Blackjack 14",
  "1a4b45a7e3054d480952893271290f2a30969684": "Classic Speed Blackjack 15",
  "2ac7dc4ac39777d9f9cb99f398d9dd57267dcb24": "Classic Speed Blackjack 15",
  "933499f7244550588ac2234138bc87a06e1f2bf1": "Classic Speed Blackjack 15",
  "a5efee930e886047b14a7bd7556ce38104f006ab": "Classic Speed Blackjack 15",
  "bc5772e724cc6674f6b5eaed480eaaa7dd0e2663": "Classic Speed Blackjack 16",
  "dd3cddd49934975dcd3f8578380b28f26c2a6440": "Classic Speed Blackjack 16",
  "212507f0166ba41cfd52a3d37270903fd13cc327": "Classic Speed Blackjack 16",
  "1aaf9e5b73cf6d7f74b927c8f177df89ab65ec16": "Classic Speed Blackjack 16",
  "6f5fdc8e900a415b3537b78d8e269ea1b3b64396": "Classic Speed Blackjack 17",
  "8f7fb1f066df50925fa43bca5d9263e5a7acf7b7": "Classic Speed Blackjack 17",
  "fe5fc83263ab145adbfa7ea8b0ceefc3216c0d74": "Classic Speed Blackjack 17",
  "a12ee7eff0c33f3d502e0d9cd7b55bc84a66b872": "Classic Speed Blackjack 17",
  "2cb4646d8cf10903ee08469aec0f276652868bc4": "Classic Speed Blackjack 18",
  "956df2c6b1a4db424b6a458bdf3d8186656710f3": "Classic Speed Blackjack 18",
  "276071eddd31ad5a6b3f17a80edbbc3c8a990452": "Classic Speed Blackjack 18",
  "d9a04b1e1d90ea194c7e55dbf1ab16eff6b519e7": "Classic Speed Blackjack 18",
  "f4d7090b570a34043b4cc2f3121dd0a7e69a0ec8": "Classic Speed Blackjack 19",
  "ffff7c5cf7057aee6ff4089b11e70e50e22a31a8": "Classic Speed Blackjack 19",
  "eff7dc7c1db2d8951ba838f3ac64bc6b6c48f4e8": "Classic Speed Blackjack 19",
  "37bc0c2091474d4fc767f9caf255222fb863442a": "Classic Speed Blackjack 19",
  "12164ef6cdb5e8db3915225fca6e8b0e11db99e1": "Classic Speed Blackjack 2",
  "8f51f70a8c0194b6e1bd114face733f40679ff54": "Classic Speed Blackjack 2",
  "dc00c9c3dbdece579f71c86c088ac98cb3665b2c": "Classic Speed Blackjack 2",
  "43128d5c26f9adc81e6688d975762c08320a9baa": "Classic Speed Blackjack 2",
  "5511edff7f10a488202c95107cd30826a4c2777f": "Classic Speed Blackjack 20",
  "dd47b0957aeadc174c77c3c9234143570697572a": "Classic Speed Blackjack 20",
  "50d2e43d8c8bfb532b82f86a2f4721c8a5101e96": "Classic Speed Blackjack 20",
  "64355d34101bb956d74f4a8004edb0ffcb369ad6": "Classic Speed Blackjack 20",
  "9d29b2ce56847e3ac7acb6879a556f42609a5657": "Classic Speed Blackjack 21",
  "e0d75cc45c7762906ec25371c778831e09f47565": "Classic Speed Blackjack 21",
  "9491b7ae90048c3c0aeefacc6c7ba97a0ae19de2": "Classic Speed Blackjack 21",
  "e1f2f84c2020a435dfddab876c4043392b2e104d": "Classic Speed Blackjack 21",
  "13b042b98acec026cbf5348a27076f020403ede7": "Classic Speed Blackjack 22",
  "a3769cef366b1f24555ce826eb852125bd4031d5": "Classic Speed Blackjack 22",
  "bdf143e54a6771ba1856b87509587d3c13e0d7e0": "Classic Speed Blackjack 22",
  "844a16e9e2883710fc3d8889e4ff3da318fadb55": "Classic Speed Blackjack 22",
  "3d9d450ea2a685b54a109f50c19ff1bd57d7f70b": "Classic Speed Blackjack 23",
  "510c95677db05356edaee2c4f48b0f9b8c49c049": "Classic Speed Blackjack 23",
  "ff269f5c094ac04438ccd7cbddf1645c006f6cd5": "Classic Speed Blackjack 23",
  "d96245a6edd34146397576968b639a88390039c2": "Classic Speed Blackjack 23",
  "8fff09b7a335c42a7a843aabb267cd6986b7bd76": "Classic Speed Blackjack 24",
  "a40ebf64bebf07841b14130c09995640c65571ff": "Classic Speed Blackjack 24",
  "eddb493d3aec2cf5c3fe82b862d5f90ada1d3eb3": "Classic Speed Blackjack 24",
  "2e504f4b0737b2f968741be588ad9f3c0f03d2e0": "Classic Speed Blackjack 24",
  "1f4d26bde2b6c894c56f66ebe374638fb8f2139b": "Classic Speed Blackjack 25",
  "ff742d23883bf2e03cea822c72008baca6193dda": "Classic Speed Blackjack 25",
  "07541b142e44cfb8919b5eca9760ed3b188c3c3d": "Classic Speed Blackjack 25",
  "a32252768d41f58a21f5bb5e217d6895c33de7b5": "Classic Speed Blackjack 25",
  "97ba0a3cdf30dea57760a4d1b80c10c167180bf5": "Classic Speed Blackjack 26",
  "f31714cd1f25524a0b5b6d7e98acc622a11c34d0": "Classic Speed Blackjack 26",
  "5034c2714418f7a6989e2ffd456afa9bb484f4fa": "Classic Speed Blackjack 26",
  "2fb9908778a5ef66f0eeec08f585208ccf5fb415": "Classic Speed Blackjack 26",
  "76796d32465e0d0aa6d77061367eb95645a065d3": "Classic Speed Blackjack 27",
  "8fbbeb4fee13e686aec98ec06b367df82640f074": "Classic Speed Blackjack 27",
  "7ed449f6a214bd790fed38e36050793241e2e96d": "Classic Speed Blackjack 27",
  "9a97595b87730656d1e1789669f2a4209647299f": "Classic Speed Blackjack 27",
  "5f73445b85f20e6507a81198a08c56ba09758bac": "Classic Speed Blackjack 28",
  "6f00957c00e99abfedb9aee9f4b4fb9763c0d358": "Classic Speed Blackjack 28",
  "45898984d7b0dbe9bd80e66a8d8518450c4dccfd": "Classic Speed Blackjack 28",
  "3ec15819666fab23045cb7318cc4b090df4a67d2": "Classic Speed Blackjack 29",
  "f7fe881e55b6d2eb4e50cbc6671a0b706589a6a7": "Classic Speed Blackjack 29",
  "f41bd9bcded6a8388eb8301fd8126f936b784915": "Classic Speed Blackjack 29",
  "767820da9c16004c44c646f28dc77fe4569b6c65": "Classic Speed Blackjack 29",
  "4ce9febc6af95069fcbfb6de114e6fa2196204c1": "Classic Speed Blackjack 3",
  "f07475ab191020571bc7c508fbd218171d8509ee": "Classic Speed Blackjack 3",
  "1e0f53ff47dbed78325cf0a8d56b651d4163412a": "Classic Speed Blackjack 3",
  "293d168df116e2d715591a943478cacfbfb1ae29": "Classic Speed Blackjack 3",
  "902ae509d189869d591ac1ad4cae03930d3ce828": "Classic Speed Blackjack 30",
  "cbb7e829ed3ee4ffbb282573fc97f35b77f38420": "Classic Speed Blackjack 30",
  "612b4598989d7d6b84602d4a660fcaebbcf40a9d": "Classic Speed Blackjack 30",
  "b9f3c1093844bed6452899cf4ec74454b41475c4": "Classic Speed Blackjack 30",
  "7efaf04a671d7acc1ea7d9c5259d636a99fc02fb": "Classic Speed Blackjack 31",
  "bc140dfd69833f14afda49ca374874cf26faa780": "Classic Speed Blackjack 31",
  "895de84d47665c9fe0cc21f24af19ba5dd93fc6e": "Classic Speed Blackjack 31",
  "ef2b911719b3100fc4086d4e4d34584e06744448": "Classic Speed Blackjack 31",
  "22bd145a6ad2f04314d616ff07d750981a038acc": "Classic Speed Blackjack 32",
  "b32124ccde9ab779978c389c57efee7d7de47e72": "Classic Speed Blackjack 32",
  "080435b3050e0782492477f2c1fda3e7d0fa2b7b": "Classic Speed Blackjack 32",
  "90a2539f147878edd5615debfdc2ac0194813452": "Classic Speed Blackjack 32",
  "807068137dd3ca70cd995321f97e4b07404c7635": "Classic Speed Blackjack 33",
  "c0662d7723ea7393f7fa48f963ce3582b5bf2ff7": "Classic Speed Blackjack 33",
  "8aa8f5c4d4c3e0920cbda98a831d2cd8fac4d0bb": "Classic Speed Blackjack 33",
  "7dc48ffd626922444a1fefba5ba382ad33943bbd": "Classic Speed Blackjack 33",
  "407cdaa1e9a483b0d5e34d8297e1e1f047a89b0a": "Classic Speed Blackjack 34",
  "827b2d239c48f3d2b7baffec7096d86bea549789": "Classic Speed Blackjack 34",
  "29d30b88295ec6865974ebbde007ebdc508d11c8": "Classic Speed Blackjack 34",
  "08484da9fa5d323a26dbeb086c283df856919b5c": "Classic Speed Blackjack 34",
  "a1993ac934b74ea130e56a839ea6680980b41b98": "Classic Speed Blackjack 35",
  "c90f4740a43b435352d9692c8a85a281cbd8cf7a": "Classic Speed Blackjack 35",
  "027acdc49fc63d95b6942265eed15bd756467be3": "Classic Speed Blackjack 36",
  "418335014eda65cafaa8efabe710cb2ca1540dad": "Classic Speed Blackjack 36",
  "25fe428d780427c0e8ed1c5efca84bc837d8c3ea": "Classic Speed Blackjack 36",
  "064a9c24a3665524ed97d5501fe4a78f6034bc44": "Classic Speed Blackjack 36",
  "1229e71786c80723adbf4706f88a9d8ff418e1ff": "Classic Speed Blackjack 37",
  "1c17c0eec32d01271b0ac11321e541bb729fc8ef": "Classic Speed Blackjack 37",
  "d6331648ed47aec0bdc967556260a7b0ee6cada1": "Classic Speed Blackjack 38",
  "e82fc51ed9ced033d91e12c139aad341d5f188f8": "Classic Speed Blackjack 38",
  "b616be6d3387f8bc765f92f7ce26753da59b9623": "Classic Speed Blackjack 38",
  "4b9a3e2919a0be01dac6300c2729f185271856d7": "Classic Speed Blackjack 39",
  "d316835146e7cdf0cdb09d37eb8b7bf4f9376fd6": "Classic Speed Blackjack 39",
  "cc3f75d9b060f0a4d99639dacefe6d8ea88af13c": "Classic Speed Blackjack 39",
  "bcdc2ed774028e74af98f9942378ec321dbd07d9": "Classic Speed Blackjack 39",
  "2abe12d7321ed977b119a4c0fe34e3b84134a923": "Classic Speed Blackjack 4",
  "9005ea7a19e12b3a1558c05da8722f052c4ce98b": "Classic Speed Blackjack 4",
  "ac5f1cd6f2d36e19c3b4f4508c39be0fe6964548": "Classic Speed Blackjack 4",
  "762b1f0fe7d91fac467a34020d3cdee142627a3a": "Classic Speed Blackjack 4",
  "8e78cfe29b1ad7e19f59580d578966777390c599": "Classic Speed Blackjack 40",
  "bdc5291f321bd370161255908cc83e849b7368ce": "Classic Speed Blackjack 40",
  "cee9190ec9d2352deb80773703429e644e1df8b6": "Classic Speed Blackjack 40",
  "586f55e31e5eda6f98f011235c4823b52c2ca00a": "Classic Speed Blackjack 40",
  "0e461deffbd04c17b343a4de15e1b2ba5bf1e9de": "Classic Speed Blackjack 41",
  "c59a8eb1b5a4adcd31d1babac1ad80aa438a5d87": "Classic Speed Blackjack 41",
  "a61a0bebbf3191dadd28ecf514e010a365645bec": "Classic Speed Blackjack 41",
  "6dee1c8c243c97828834002d3b30d5f594367557": "Classic Speed Blackjack 41",
  "4fffb9a6e1861608f94d063b81dc72fb38b3cc67": "Classic Speed Blackjack 42",
  "a2b16e5b82eaf063d6ba4e700f4a09c1bd5f8603": "Classic Speed Blackjack 42",
  "0a444af1718974d990f8fbd374d68aa03e538826": "Classic Speed Blackjack 43",
  "464ff865b24438dca8ba9d921e4d5d33ecf163fb": "Classic Speed Blackjack 43",
  "bccdc0fdf97394e39dcd2aa3f13d9b36d12f869d": "Classic Speed Blackjack 44",
  "cbcd58e9d08395e1daee3fc1d9336b361b397fe1": "Classic Speed Blackjack 44",
  "71b187d2ffcb96304c812a47a992c96c4c515289": "Classic Speed Blackjack 45",
  "e77fd15f8b014b585419fa2b1a9b2b177dc8de28": "Classic Speed Blackjack 45",
  "f6b6d8f01a387543d5b0a70becddda0774baf000": "Classic Speed Blackjack 45",
  "c675e921c96c2619067af6077d061702c3739c63": "Classic Speed Blackjack 45",
  "508447280c2642a3a3a3f44d0dd12b5819df6629": "Classic Speed Blackjack 46",
  "b21bcc6491a013ff22f32a0868d5c94a7f87f489": "Classic Speed Blackjack 46",
  "d77ddbbfe12118a7f1383003ab7c63917a5a127f": "Classic Speed Blackjack 46",
  "faffe6183416ed5f5ddfc52d30a68376bc1fd231": "Classic Speed Blackjack 46",
  "890cf6a846b6508b01978e5403968639f5c8bceb": "Classic Speed Blackjack 47",
  "f291d9ad02535bf8da2d8178bacac33b811bdab2": "Classic Speed Blackjack 47",
  "51ff6e9b66ef5aebd1de47e037dc06f9ca4d6d2c": "Classic Speed Blackjack 47",
  "6e8e038c001ccd60c2f5422814b5cb9b871fe8bc": "Classic Speed Blackjack 47",
  "2baef73665c58f6a5047e123eafb35fbee461ae3": "Classic Speed Blackjack 48",
  "35bcb3815a09dcd315514bd6decf6849d5a230ae": "Classic Speed Blackjack 48",
  "c1678f3acfaaac74c510d339708b56669144fed9": "Classic Speed Blackjack 48",
  "91ef39a1a8ac2056a975ca98b625f064b1137030": "Classic Speed Blackjack 48",
  "52412a63d64a7e24ff747ba766a07cca0b6a86bf": "Classic Speed Blackjack 49",
  "c2ced7dd3a0a728082a1816577bcc46f8380af73": "Classic Speed Blackjack 49",
  "b46be49ec85fe6a5b44540e250f5ac5dafb417fa": "Classic Speed Blackjack 49",
  "1eee658e2fee5b3b997b5f3b042432c5495c07f6": "Classic Speed Blackjack 49",
  "bacba25023a5b2414c56dd5595b33f8bf7ad2eaf": "Classic Speed Blackjack 5",
  "f9cad919e12f252cec93b30d9f3b04713d8c3814": "Classic Speed Blackjack 5",
  "b7c05dccb63b5c83c93437b0963e1c5df0d499f6": "Classic Speed Blackjack 5",
  "96e4092bbd0c9df618a722fc12ddf8badf94735e": "Classic Speed Blackjack 5",
  "4e228d82388d305b2966844b3533bad356865d6f": "Classic Speed Blackjack 50",
  "8083c9db2ba3f324d87d9dc1b882e37a406f191b": "Classic Speed Blackjack 50",
  "de2027b96167f2443ca19c257e2a14ac1096011f": "Classic Speed Blackjack 50",
  "4d53bb2bae9a5dc150e2c1297b843057388acde8": "Classic Speed Blackjack 50",
  "212e47be24ba2ebbbfff56f89b814c638ff0c6e7": "Classic Speed Blackjack 51",
  "6ab6b0bf612f18c0eebbd6c8a3e3628c1b93ebb2": "Classic Speed Blackjack 51",
  "982b24f95f371ff574c7da0ea6830dbca0a5ceab": "Classic Speed Blackjack 51",
  "78bbe0dbacf9039fe709d3af3df14b82368aa52a": "Classic Speed Blackjack 51",
  "5caa7eab3fde7fb56bf954f4d541371148d6d370": "Classic Speed Blackjack 52",
  "c303449523bf402491aa6955d4aab0d6cabc997f": "Classic Speed Blackjack 52",
  "03a3dc2d8b9eb7d2b818160b8d49c0f288893906": "Classic Speed Blackjack 52",
  "1e28fb1ccf79ff0706b73bc1f346c60bbd8148ae": "Classic Speed Blackjack 52",
  "635ca3041be7c516d0cb8f34a26d1a781fa50f69": "Classic Speed Blackjack 53",
  "906e4531ad1169a8bb65472a5aff2eba2bd0be79": "Classic Speed Blackjack 53",
  "6d09beb26f521636245ab34e39736865bda9ad6d": "Classic Speed Blackjack 53",
  "b6079408f95e9fc2e2a2b01446cb51930a6f47a8": "Classic Speed Blackjack 53",
  "4823922539fb45c61758b266f74c1e1dac2bb725": "Classic Speed Blackjack 54",
  "b4706e1aa55cf13d8b2c58e34a1cdf89e813ab1f": "Classic Speed Blackjack 54",
  "774349c9743b78c449395926aaccb3366722937a": "Classic Speed Blackjack 54",
  "54f17bcacc17f771c71e5b33c913503bcdeda97f": "Classic Speed Blackjack 54",
  "1f7ce5468a39b4d72a68ad7f53ecad585ceb27fe": "Classic Speed Blackjack 55",
  "2d6ba7a6754aee21b776f7e790465c467684b79a": "Classic Speed Blackjack 55",
  "0a4b65287335a7d75d6e1bd20995d50e34e8e390": "Classic Speed Blackjack 56",
  "6596cc6b969543e04587cba5357cc090944d1657": "Classic Speed Blackjack 56",
  "59dcdfa336a814dd61f8c0a6bd8660d5aa07b997": "Classic Speed Blackjack 57",
  "cbe776772f4668db41f5dd12d9d62d5edb066635": "Classic Speed Blackjack 57",
  "8605e63f743e619eabaf56ab4804b89d459da0c9": "Classic Speed Blackjack 57",
  "10131ee5a59da85218e9c662eb50ed84dedfc4b8": "Classic Speed Blackjack 57",
  "8668891bba2fc278f358929c6b6295c7944c602d": "Classic Speed Blackjack 58",
  "8cf847e60d92684fbb2ae67e21694a8352a3da61": "Classic Speed Blackjack 58",
  "baaef071db800b6968e8720b742ebe7f0dd404a0": "Classic Speed Blackjack 58",
  "addd7d4b315ffd2566054534ffca6aa911a97b5b": "Classic Speed Blackjack 58",
  "1f3a524b7fc96b1ea888d11c821aea0d090b1326": "Classic Speed Blackjack 59",
  "63c4363e876750169de1c8f58be872aa9e9489d0": "Classic Speed Blackjack 59",
  "b22e2a6654e4c175428f4eb4a57c8d36ba3016ef": "Classic Speed Blackjack 59",
  "1e893027fa67d97e95894414d51acbefa827b783": "Classic Speed Blackjack 59",
  "17c17e863048496d20a17176076d2d0743957f6b": "Classic Speed Blackjack 6",
  "33fe047076733859ef01f6d42f2bbd45842cd1d7": "Classic Speed Blackjack 6",
  "cf6e63a4ba6e173fe09e96673223f306c4504779": "Classic Speed Blackjack 6",
  "ea4c71d7a250545f33809b5c0b6a4810dfd41a5a": "Classic Speed Blackjack 6",
  "56c0f5eb8c7ccfaf3a05b28ef71f8a5adef06fcc": "Classic Speed Blackjack 60",
  "692a5be1b4220b35418efadb7e1287fdb19e7f88": "Classic Speed Blackjack 60",
  "2655cddae04e7389b0cbf0cdab58340ba2b48131": "Classic Speed Blackjack 60",
  "d7c58a22528cc0dee331fec9da5b8f34f4618ce8": "Classic Speed Blackjack 60",
  "4cedecd2243688e8b9122e923800e602414cc2c0": "Classic Speed Blackjack 61",
  "c9f594530389de981fc42770c30b4ab7157e44b4": "Classic Speed Blackjack 61",
  "c2fa0eab3aeb3740d4ce20ba2f210e98f5f049cb": "Classic Speed Blackjack 61",
  "01fa576d15e61dd619c5ad0ca791a654e4a8b969": "Classic Speed Blackjack 61",
  "3944c6047165633d40ba3b085d8ed10c9f665d09": "Classic Speed Blackjack 62",
  "4eab701283f8468153a49fcd1fa12780b687f0a6": "Classic Speed Blackjack 62",
  "79dcdde32e7b618937e63f2b0c6770c58d4d7b6d": "Classic Speed Blackjack 63",
  "a7b615226d612fc98d55fdd23cc1acb847761a2e": "Classic Speed Blackjack 63",
  "a1882eeefd4de58d25f09bb6930c93b79bb6b82d": "Classic Speed Blackjack 63",
  "11e4f9f0369c9a9ee9fe3fe8be28e47ff0026e6a": "Classic Speed Blackjack 63",
  "4f51eb7d810d22a547a9f7da43252f61284e025e": "Classic Speed Blackjack 63",
  "352dc29083a1ea47a00dcee52ea00bc7bc258e1e": "Classic Speed Blackjack 64",
  "d27120bb5e873e8970a17a0a7941ad21f0433f1e": "Classic Speed Blackjack 64",
  "99cd7ed1f6dc83770da0913adcf02588b2e8aee7": "Classic Speed Blackjack 64",
  "2a857ef3815f2e865f644d06d55a318eae7dd58e": "Classic Speed Blackjack 65",
  "3eeb8853ddd2d87ccacd27c9ff4ed1b3dda1c955": "Classic Speed Blackjack 65",
  "b096355db2b56bded68b85da692aadb48c6baa31": "Classic Speed Blackjack 65",
  "78fa4ecce1b0c0748040f58c8cbb42c1e7180197": "Classic Speed Blackjack 66",
  "92fdff75587e4a02b57a35d1c51f5cab3fd02ca4": "Classic Speed Blackjack 66",
  "7cb8af839823a81ef8a0fdfc75dd97a6d76b18ef": "Classic Speed Blackjack 66",
  "27a9541c5c78147f4a4ccf23931fff83c9ec3c03": "Classic Speed Blackjack 67",
  "2d8d5210938934c4b002ffa1ab743377dbc100b6": "Classic Speed Blackjack 67",
  "ea7351a4bc80ec9466a624feb2a1612665ed3fb7": "Classic Speed Blackjack 67",
  "abfc6c2f0040f8806eed556a8b3363df5873ab41": "Classic Speed Blackjack 67",
  "22244a0e4316b4b0575bc6d6c048d73c383bb073": "Classic Speed Blackjack 68",
  "c610a408fabe92adfa50ca6413dba3dd9753cab6": "Classic Speed Blackjack 68",
  "b8e8a6f2edd280d8ba04a6bf781e01ba7fbe159d": "Classic Speed Blackjack 68",
  "2caccb8818af36a85b0c94540f4046a0c5dc2a10": "Classic Speed Blackjack 68",
  "7da7a6bbee6f79c87e452b120632922a8ae85c73": "Classic Speed Blackjack 69",
  "ef64834949f0d643e760cea46fe6d75bb2423cec": "Classic Speed Blackjack 69",
  "91999d85adb17faa2153e7fba87332e2177cd9d5": "Classic Speed Blackjack 69",
  "b1b769972fb01b83e6a96a04b3758b31df379ad7": "Classic Speed Blackjack 69",
  "773110e8904e1aa536aea202eb3562dd76f7463b": "Classic Speed Blackjack 7",
  "79dee3d940a33ebb34d223742878f53942ea477b": "Classic Speed Blackjack 7",
  "f7f5601fa26ac2189ab6b95850cae1861881b75a": "Classic Speed Blackjack 7",
  "6b93dca09a1cc1e03471e313a087b6762d88e6ab": "Classic Speed Blackjack 7",
  "d5c54a1dcccf54cdee51e0a9cfaa0f6ba4655c49": "Classic Speed Blackjack 70",
  "fff43008e0564766fe6a9eda03fb7c690f0f9f3b": "Classic Speed Blackjack 70",
  "0d8cecb97750228d8e6b1b2b94793a835f25b583": "Classic Speed Blackjack 70",
  "75d2dbcdfa9936cba9341645694a74a5d1b8544a": "Classic Speed Blackjack 70",
  "8f7d4eb2f9bb4b6c702e5f3945d506921f830c8b": "Classic Speed Blackjack 71",
  "f21773b7851074e869921d59877ef7f95233bd1a": "Classic Speed Blackjack 71",
  "af9e697d85583383173c8fabdc612567293eb2e3": "Classic Speed Blackjack 71",
  "51394598ad9e96402d82eef99ea13a8eafd0b51d": "Classic Speed Blackjack 72",
  "9014687fc246bdda3ea8ad65acbdc83624fd39c7": "Classic Speed Blackjack 72",
  "1fd0175818bb27c30fdfafcf8ba3d3fa2a08c874": "Classic Speed Blackjack 72",
  "8094956537a61bd1a6d54525d60040da9beea631": "Classic Speed Blackjack 72",
  "6dad58c5436373bab57497b03b9a6a81d23931c8": "Classic Speed Blackjack 73",
  "d73969cfe36cae0cce38310ec54920b0a06264ea": "Classic Speed Blackjack 73",
  "f91161335fc087de0f8dd749c04e340838953a2c": "Classic Speed Blackjack 73",
  "b46fd8d18b37ea32e5d850aa77a304e8d7117d0f": "Classic Speed Blackjack 73",
  "371c0067bb4701502d7dae3b92eba6355a9cf862": "Classic Speed Blackjack 74",
  "c5d96da521b566b4742aa8a29d62b77cd3b47573": "Classic Speed Blackjack 74",
  "fec3f0ae2ec20d4cc5b723e792a26dcb276779bc": "Classic Speed Blackjack 74",
  "6245c04d164f5935087b40f75857362837aa2f50": "Classic Speed Blackjack 74",
  "35971ad6b4753dcf31dda7c988d545f5673b0eeb": "Classic Speed Blackjack 75",
  "a3414ab88c366b0e0a92af6753c70736ca7073c0": "Classic Speed Blackjack 75",
  "4fd0f76a4edee4983b02abc9357b493a56bffd64": "Classic Speed Blackjack 75",
  "3de6151fa9a7f6383f22fa5dbb70440661e24f6b": "Classic Speed Blackjack 76",
  "b6a783080dfe2a7f6792c682fed2b3c0923d46bc": "Classic Speed Blackjack 76",
  "1e9f073a557a1ee6471553fccea867bd4a41b2a2": "Classic Speed Blackjack 76",
  "09d64ec904e1694478405ae2606d2f9100d94b4a": "Classic Speed Blackjack 77",
  "408b6162b35535c9f88e25c1d3e77780a8d70e16": "Classic Speed Blackjack 77",
  "6070290785030482b55a719399d2f3a25bb5328e": "Classic Speed Blackjack 77",
  "ea03e0c490fb1cad1205fd5d2547168b5cd13ec0": "Classic Speed Blackjack 77",
  "f2babcb6447fb67c14c69a80be56e923fd4a5738": "Classic Speed Blackjack 78",
  "feba2957bfdb787800e8541c3042b5f1c57c9b17": "Classic Speed Blackjack 78",
  "e6512040016862c93a38a4eb29537814c83a7311": "Classic Speed Blackjack 78",
  "723b2213bc617696e840fb1484a0e81637dacfd0": "Classic Speed Blackjack 78",
  "831175200373355c0bf352e8631eda4934dc20a7": "Classic Speed Blackjack 79",
  "c735b144902cacb8015ea452b23013afc8e17a6e": "Classic Speed Blackjack 79",
  "c0633fff88c79be81f16fd142e031ea0d2107076": "Classic Speed Blackjack 79",
  "5233a8956b670f09cb447f376535d2785f77d972": "Classic Speed Blackjack 79",
  "2cd455f993168af1d91a13d89931ac44947b0307": "Classic Speed Blackjack 8",
  "ce0fab935fa2b9d0c956a68acf64c1da48778634": "Classic Speed Blackjack 8",
  "0ab4802bc7f15a1348954b5e14201d6057b82def": "Classic Speed Blackjack 8",
  "7607859cb32b868d17be3e65e6f24db205fbb403": "Classic Speed Blackjack 8",
  "6067e9b42e3c4a3aa37348a29f624022348ca80e": "Classic Speed Blackjack 80",
  "e4b7576a72b11294b398ee9002ca58b2e64553dc": "Classic Speed Blackjack 80",
  "0d05e75130686640d943a55f02eb432d66b22753": "Classic Speed Blackjack 80",
  "db0f83b2bc54322822b1a7ab219a2abe43a42b2f": "Classic Speed Blackjack 80",
  "ba9950284c517a59e5fb2f6d761762abd86e28ef": "Classic Speed Blackjack 81",
  "f6ef040ce103bd5bd3fe5d76fd359640bbfd34d8": "Classic Speed Blackjack 81",
  "373abed74685b52adcc8d09ed9a752afb4028a87": "Classic Speed Blackjack 82",
  "7960a4487ac0085dbf12b56ad33360b313420682": "Classic Speed Blackjack 82",
  "ebbb21330cc3f98719688de169beb9ce8f66f502": "Classic Speed Blackjack 82",
  "7fb746abe600523504f5f10761136a8247d7e217": "Classic Speed Blackjack 82",
  "2b979000343e67fefd9b3799f645016edf64e11e": "Classic Speed Blackjack 83",
  "7f29eeb96bea9649c2c463cabf8aa8fd72179da6": "Classic Speed Blackjack 83",
  "96a47024ffc10712a984f16c323b8f2f6a6945e5": "Classic Speed Blackjack 83",
  "b775a2b0341c8a1afd5329665ff659a666af26a4": "Classic Speed Blackjack 83",
  "273cf3aba748c353530802bab5f1439aa6200e1c": "Classic Speed Blackjack 84",
  "29d13766fd29b3bc1ea77ab140e49b9327f0a223": "Classic Speed Blackjack 84",
  "d958f8c3aeaba21bd6bcfaecc9cd7d796ab8e2c8": "Classic Speed Blackjack 84",
  "422bc0207fab9bc56077503fb64b72042c0c56a5": "Classic Speed Blackjack 85",
  "7891b08c970730a195f1a9473a4075c710eda373": "Classic Speed Blackjack 85",
  "a90a0a4a921ed77a506a9de0ad3447bcb69a2991": "Classic Speed Blackjack 85",
  "ae6f35cfc3346f9b02c9d0dd2d3c1f73af7de1b8": "Classic Speed Blackjack 85",
  "c612bb3c19557567671c16a53c38c0086781035c": "Classic Speed Blackjack 86",
  "dfc7b8a405cbc7da66bda883b71ecee1a2678ac2": "Classic Speed Blackjack 86",
  "812143fa33c9f3bc4013a6996cd7d176e7e2f610": "Classic Speed Blackjack 86",
  "ac86eb594a8207e46a76c1e5830252bb5698c83b": "Classic Speed Blackjack 86",
  "48164e9dc8a185cb4b53977f7018f6ed5956ae4e": "Classic Speed Blackjack 87",
  "c7827e012ac5235f7d5d56166adefb0b6744588e": "Classic Speed Blackjack 87",
  "8680021ca914b7d4101961f144e3acf6a12e5933": "Classic Speed Blackjack 88",
  "960d1d9973be4b3fce456bdd0ecd836dd8f5fe27": "Classic Speed Blackjack 88",
  "cc99cfbc683a22f5633168e81cee28a08707d6b2": "Classic Speed Blackjack 88",
  "be7b7c733a569341b5945237b15640fcfe899b6b": "Classic Speed Blackjack 88",
  "6ed8bacffb44d690d441c89dfa15c4fa3d5931d9": "Classic Speed Blackjack 89",
  "75ed12f476be5fdbdd1a0842d77d83688c15aa70": "Classic Speed Blackjack 89",
  "3cd914de7403a0e5feec6fb2d4ce4dcd387fc268": "Classic Speed Blackjack 89",
  "14d5f43bbc3caee50274e1f97993afd541499268": "Classic Speed Blackjack 89",
  "273fbeadb49e038bc0811d4133aed8b2378b928d": "Classic Speed Blackjack 9",
  "f4cf5ec2027e11996612f0799f4a7cfb4f665a9a": "Classic Speed Blackjack 9",
  "997357ff46d1e7d347d5362322288edf71934544": "Classic Speed Blackjack 9",
  "16cc3c170c865180fdaebd57e20b432aab73fa20": "Classic Speed Blackjack 9",
  "27ed75101bfac6c9bbb58254d9638b09a412ab3e": "Classic Speed Blackjack 90",
  "9a76ec58fbd788003c556c463a9a2a5ca3adc9de": "Classic Speed Blackjack 90",
  "91ee9f565e36b32029db9a01b651085adc35f7e0": "Classic Speed Blackjack 90",
  "688335bd7f2f18eb30acab0517a7bbe8400e6acd": "Classic Speed Blackjack 90",
  "5ffd6e365988c38321a427b688f535b0c19c05af": "Classic Speed Blackjack 91",
  "7be7d8d9b9ae806e6568a81f471b903cca95d3f6": "Classic Speed Blackjack 91",
  "8d7c997ecccc96d56219806e1030d55306a544bd": "Classic Speed Blackjack 91",
  "b5564fefe4db16fbe6ba4cb3e23030022daece32": "Classic Speed Blackjack 91",
  "0d4595e2d2250b96ed00879c1146d0a6e4324906": "Classic Speed Blackjack 93",
  "3cb33346e60fb8629e6c22f851154b4d98d1d8c3": "Classic Speed Blackjack 93",
  "edadef93406de1d58c62907e6353fbad9e056fcd": "Classic Speed Blackjack 93",
  "e97dfe324009550a79538200e14cb9d5d2caf351": "Classic Speed Blackjack 93",
  "14f9fa50eb7ade67d26f10e1d9479d506e142817": "Classic Speed Blackjack 95",
  "385b2cc6490f5b45b2d775d3c99fc76a0d0aafc8": "Classic Speed Blackjack 95",
  "0a58cdef0e527223bee8c37df058721d8af9ef24": "Classic Speed Blackjack 95",
  "96f344741ecce12e29b72a4f1bde7cb55ea3a1ec": "Classic Speed Blackjack 96",
  "de469c06d0dec2ff0b0a2f7780f122a5204db4d1": "Classic Speed Blackjack 96",
  "fa79fb46c8be85a32ab58762eed484aca6bef43c": "Classic Speed Blackjack 96",
  "6b70d79d9e96249f5fd00f7e086a01def0be5e5d": "Classic Speed Blackjack 97",
  "9f88d7f77fb57018276e2d5516ec499a9933b6e0": "Classic Speed Blackjack 97",
  "1269392b07edd71b336fe25ec2019bd31d885451": "Classic Speed Blackjack 97",
  "06ccf26e7d62946badf358c8a05098ecca864eff": "Classic Speed Blackjack 97",
  "22246b07b2b1f9cccce44c05a0cbc1b60566ed94": "Classic Speed Blackjack 98",
  "92d2d75549ee6feb69f46c92f4ab2488e2570ee8": "Classic Speed Blackjack 98",
  "2a86e3467555db880dd6657991962456ea71665b": "Classic Speed Blackjack 98",
  "1f1cb3444853f3a1572a0ec51d1bd76e86a50721": "Classic Speed Blackjack 98",
  "070ffd551cc3eea59638b476944bdc20c7978c6a": "Classic Speed Blackjack 99",
  "5db8a75607738872a2dbccc5b6bb1229d6ce7667": "Classic Speed Blackjack 99",
  "c45fb04c1045ec290eb7048cf55671b054002c79": "Classic Speed Blackjack 99",
  "53b39051d7aa5fde5a4e1e5ca02c88122dc6b1c7": "Classic Speed Blackjack 99",
  "382a5bdbc1cee05ba3bce0b5d0f5af4fb59b660b": "Classic Ukrainian Blackjack 1",
  "05167d63204ec07aaa4d534b21affdd1ae33f8ea": "Classic Ukrainian Blackjack 2",
  "100368f4dcf0354b228feb682991906ba6e53012": "Classic Ukrainian Blackjack 3",
  "27e34f6c20415664f6f64d91f75f7c9cbf118518": "Classical Dollhouse Lock 2 Spin",
  "011f618d60571577dd4510b9782006f2137a4d31": "Classique Blackjack Un",
  "2280f1dd193ff4ab5860b008de8ac37e113b7b23": "Cleo Team",
  "70759e3b888d21e8d8fea419662b5e868a5bbe93": "Cleo's Book",
  "257b4f88ec6f12072503a868696a144e18c71946": "Cleocatra",
  "4f2cb0ddbdade0c80242c5e8b7327ec79fb1f410": "Cleocatra",
  "5d83be03130456b964a48835892a12d0fa7b0b1d": "Cleopatra",
  "1a1a070d8d12994fbbc5cfeee652b1b6f02ee9fd": "Cleopatra Hyper Hits!",
  "7c853326e6d31018289cf964d0b8e20ac8f6a88b": "Cleopatra II",
  "bf1b56214167b169b2af89cf9c68c77d4d85230a": "Cleopatra PLUS",
  "3ea7ca8c7c619f2dd849d0abde0f1decf0e6cc35": "Cloud Princess",
  "f47d36e0229c8cfebde5f1cea696ba699b5cf6c2": "Cloud Quest",
  "c3d4f75aa90b785219cea9a9bf6056904d59d653": "Clover Charm: Hit the Bonus",
  "f6cbce56bb2170db09b550863d97d95d74a6c1d5": "Clover Gold",
  "e99ab4fa0681849d74d9a04dff36a1213b237df5": "Clover Gold",
  "569a0be65cc3122449c2b2bc3bb2c836e1bf1f21": "Clover Hell",
  "1958eea5646b75823d573d305b4e83658ba09ce8": "Clover Respin",
  "c0f6d5e1c390c80e40e2c2c72b9640a00effc04d": "Clover Strike: Hold and Win",
  "8fe47468b913f8df6e64fa19efc44f4624164099": "Clover Super Pot",
  "10615f9296c90270e4b7c7ab66a664bf7e2d45f7": "Clovers Of Luck 2",
  "d07f6de83a34148914ed49a837cf918aa172bdfa": "Club Tropicana",
  "f466b3fc6285b9bac2fb2f617330aa340724f025": "Club Tropicana",
  "b9087d415110af5643d33cc6937271fe49dd86a4": "Club Tropicana – Happy Hour",
  "8356a23aa363e44f7c451e878dbd5135d320b89f": "Club Tropicana – Happy Hour",
  "88fad6db3a2369d083f89e6ee0496ccb1aa92cde": "Clumsy Cowboys",
  "824141e60d1857e13bdc1ff648668fdc053bdb65": "Cluster Tumble",
  "638bdefbc010cbcfccd2a6b6707452bf8636dab3": "Cluster Tumble Dream Drop",
  "726210646df516b96a9230e7a86a7d15d73095c0": "cluster-kingdom",
  "fb53295200d4d8d23585dfb4f47c2ac229e71a43": "cluster-slide",
  "9d8fde130fadfeaceeb807374e64ce9feb547884": "coba",
  "5608bf0ff89e982f726500f4627791cacac51110": "coba-reborn",
  "e5d2bf2ea9b26437c395f0ad69e211bb9d054040": "Cocktail Dice",
  "9a648b6be23a408fde1ab6f92423c19718b87948": "Cocktail Rush",
  "edc31fb41dc9770c295ff63a15c7687c47dca4cb": "Cocktail Rush - Easter Edition",
  "46f446664e82a5bdec132b16cc78cbc6d8a620be": "Cocktail Rush Buy Bonus",
  "7f1855fd9ddb6dac33049c52ecc5ef0db7a6de8e": "Cocorico",
  "ba89d870d600b5175d4cac824e988ae06e5d13bd": "Code of Cairo",
  "45216aa40534bb20dc6e1b54376987f4ae3e3f3e": "Code of Cairo",
  "5f92ad905d9b4731093b154f14c72d7372372c4a": "Coffee Wild",
  "eded442f1fc174a36e6de043c446f8f3a7f7063b": "Coffee Wild",
  "8555d8c1507f447d83ec7fd59f34b706ab94afcd": "Coils of Cash",
  "10967152bd15b98972c7b978b8c66f4924d0a2a3": "Coin Blaze",
  "17bc80101523f836a43f745465a53438ba52b9bd": "Coin Charge",
  "4d41facfa50b2a7ed459c15968cc558baf759bf3": "Coin Crusher Hold and Win",
  "bcddc12857ee82cc6c68bc276cf0fa6808a8ef79": "Coin Dazzle",
  "f8c2df8399549ed3b93793c6ecefb0d06abc711c": "Coin Express",
  "74db0c8fff76f5a7c3aa4ae127b4a46eaa0bb677": "Coin Frenzy",
  "bb44fcfbb94cd9d1c92ec6f1521cc2cd0c88d9b5": "Coin Gobbler",
  "d3adf681d78bd345d9e2efaa85d0a400f6a7169f": "Coin Gobbler - Christmas Edition",
  "31143bac1567daac25ba86d98ae9193762fe8d16": "Coin Gobbler Dice Edition",
  "8a39a978f8aff50102798de9b52ecbd049ac4db3": "Coin Lamp",
  "db98bdf87f7b42e444f96b4896c6a4a108acd033": "Coin O Mania",
  "fecc7eb329e011350d8c2f3e68c8ac1db9a94ed4": "Coin Princess x1000",
  "a2ed104872c93ce8d2863400f6e86793028104c5": "Coin Strike 2: Hold and Win",
  "5a6a892bd5efa3700cd9b8a716cb44892b02a153": "Coin Strike XXL: Hold and Win",
  "b9270fc5d8b764ccf6df5a7afbc0598687e7b9fd": "Coin Strike: Hold and Win",
  "9a4046a1326ba48893fec8690d6a8a7040c5d757": "Coin Surge",
  "d0aa04db0ae70b118eba409cbca26a25ce411226": "Coinboy",
  "ee28f08f752a785e195c267d302920a73cc29de0": "Coinboy Riches",
  "2e3b0de7832ca7711aaa837394cb15260222e20e": "Coinfest",
  "f2a7da0954129a8b9794a8c50c90915c94be57a7": "Coins of Fortune",
  "521db2e862a1188039ce861de91df8cf34fbebc1": "Colossal Cash Zone",
  "bf2829ce9b3b2aeb069d8eb523f43035ff0d0c1c": "Colossal Cash Zone",
  "87c222c927eb86f62aeda899e1d627e60c6bdec5": "ColossalGems",
  "cea853cb69e23d296ad61c5903140ce2b9bd0190": "Colt Lightning",
  "cea54dc9ecd7561e6cac8d6a7d0e75ddc994a16a": "Colt Lightning Firestorm",
  "4ddba2f342fbb02b677a183836824ab6a65315d6": "Colt Lightning Inferno",
  "44f3b36738356da7dc56db5f244babb1ab4396d8": "Columbus Deluxe",
  "1a8bc7c54ce7d6d00cf9b32ebfdcb1b1ac3302cd": "Come On Rhythm",
  "430b0eeea23512039b12812d86576319368a8967": "Congo Cash",
  "8ef3840cc331039039c4d07acfaf3169137e0e15": "Congo Cash",
  "51d87728fd8bb416f6d3cdc1f20f635f992ffa41": "Congo Cash XL",
  "a571ca93b523b28d64fbb455ff9b3d05cebbebc7": "Congo Cash XL",
  "7d646d8c7d5df21967e726868f00688cb8c5efa1": "Conquer Babylon",
  "d53d9846bbc22a3faa10d37d0d48654501007157": "Contact",
  "90455db36f67d76be1c7e5553f385bdf69064386": "Control Squeeze Baccarat",
  "a793ef97d6e57306b3b691288511cd31c2da7505": "Control Squeeze Baccarat",
  "89709f3542eaa0c3fd10899e64278e704f0972ce": "Control Squeeze Baccarat",
  "b3910f17cf3020295374e301ecf5d95512ef0bea": "Coo Coo Cashoo",
  "5e862bab00ca1c0cf37aaeda62dd932d673910b6": "Cool Diamond II",
  "4c2a908bfb86622f40732d360c2d51d06b6831ff": "Cops 'n' Robbers Vegas Nights",
  "60b8c85fd60e30710e0026362feb17ca0bcde43f": "Cops ’n’ Robbers",
  "3a48ccf76ee04b338aaf1c95a20d23cd348b7609": "Coral Island",
  "1b6984736e5682022a4b1edd39b8515a5e7be6c6": "Cornelius Milk Hunter Megaways™",
  "1605f9deb24f09dd37262011639f566fb661ec86": "Cosmic Cash",
  "a0c1c74e63b6caf386a419f75959a71639ef028e": "Cosmic Cash",
  "c68c061a15aa68590b41052b2175f53aa02c9a73": "Cosmic Clusters!",
  "ee121ef1f740faaab29922cae8a444b00a1b131b": "Cosmic Clusters!",
  "a427c559b074e96f96744328837ed71778c96388": "Couch Potato",
  "2244751e8c754af298cd3dace7b37cc9113f57ba": "Count Jokula",
  "b3f7ba23ea554e879a248812587fbe92795875f4": "Country Farming",
  "17784bcfad1ebd80df56d118bd2665553986b198": "County Seat",
  "c86559297976a8cbcfb18a66bebfeac47bcbd1b2": "Coven Rising",
  "0c626851c27e2c0e6dc5ee5794130c8022f855ac": "Cowboy Coins",
  "b7bfdd41f764335b8ef5bc79c00fbcee7138535f": "Cowboy Coins",
  "739c234a2d8dcae9374032bab528a0b86519c342": "Cowboys",
  "37b3da8a9a403d94b7b93b7790dc4594b926363b": "Cowboys Gold",
  "c9294f44ab3c6a46a006bca9e3aecd7b40899b8e": "Cowboys Gold",
  "8400235b78ec213fde96e325512504eb25c72c56": "CoyoteCrash",
  "04d69828f281aa86c96db8715b4b431dc476ab51": "Coywolf Cash",
  "1fb1424baaad3cbdd66b0e6f81a7b1a649db1dfd": "Crab Trap",
  "4f0d73e22b62fcb6b10801e6b14a83c8bc9178dd": "Crabby's Gold",
  "099970ee3bde5888f7c7799b9559824773b4202f": "Crack the Egg",
  "db49a3e98555bee2bd6571711db070b650579970": "Crank it Up",
  "b7e3f9db24e6b0ba4ff64899c49709f4801fc42b": "Crank It Up",
  "58bf846a0579295f1aac9c5afbb074cb996f7f2f": "Craps",
  "63a5eaf74553d63a13e292253219e7932413ee97": "Craps",
  "258159251a5e1e0372ceda5a0dfbbfc67c51a8a5": "Craps",
  "c415a77c7a3dd0e7a2204c2b0167fd1f510a5544": "Craps",
  "c600b5c6cb3cd41680fc04d21bf3c290aef10846": "Crazy Balls",
  "5b711b2ef89b36cf98a9f502609f1cd201349033": "Crazy Balls",
  "e20999eef2d649d534e4ea24f8e8a52ad3671a20": "Crazy Bee",
  "db876afc73f9a67998f4b861b5c6280f54fdbeb2": "Crazy Blackbeard",
  "c4c985ae423cd6348ce9c8c034ddc2af1f509f54": "Crazy Bugs II",
  "b51dfb4b9577fd004a513f3a5cd5ad2371fa4ba4": "Crazy Circus",
  "45bf2293385f3ad888f2cb0e3cd492915e3ef32d": "Crazy Coin Flip",
  "df5ff6a2cfc8ebab6e1f2dd8ea9d6cfed29dbe02": "Crazy Coin Flip",
  "9db125a7a1535da26ece763c6a17b2da5d96ae20": "Crazy Coin Flip",
  "2c8003c5bf31bbede18508d36c6dfa835c9aef87": "Crazy Coin Flip",
  "08f25fcfbc50344a10fb7e81f33159206e1ea44d": "Crazy Cows",
  "c3c8a3d6053054525d065ce13bac7811e9ad5156": "Crazy Guava Lock 2 Spin",
  "4178c19a96a59cc103747b7b1e40fb294669be2b": "Crazy Gym",
  "b83d407aa8a2286c6492c7d4dcb0f9ac2cbaec37": "Crazy Killer",
  "c37cd76b00cbb3435de422f3b6e41ce95a7ecab0": "Crazy Octopus",
  "3309b52a79f5a3012f4d1338fccf97a5460eb853": "Crazy Oktoberfest",
  "3896117358f1fbf485a03818b6043e4be180195e": "Crazy Pachinko",
  "8549925f854cacb218f2f2297df50fd5683c8989": "Crazy Pachinko",
  "3db2b7b6d82fd6a603be6ae03d986c610b0ce34c": "Crazy Red",
  "ca8f325b38bf896f8d9ba96a052a1d11efdb0dd5": "Crazy Taxi",
  "c818347704541dd95ff3ef717db4d6086b8c1735": "Crazy Time",
  "d5c71b5aa956152a500b6f9e199d1508112a4a1f": "Crazy Time",
  "f42992a178bb8574b69f4cad644f00f0b8665c3b": "Crazy Time",
  "bb1b1f35df93d006b96cbdc35c006533abdf7041": "Crazy Time",
  "289cebce87b6cffc507c097e4919137d870d9831": "Crazy Time A",
  "fc7e480005d7db3b78324578c6863317144065fb": "Crazy Time A",
  "dada043c029aef2453f75ec6855b59567e867c84": "Crazy Time Brasil",
  "ca6b08ba3057098c549e8240bff487d1757c85b5": "Crazy Wizard Classic",
  "f22a109b89ed6d7e2e41bbb4ca0de43b4029c256": "Crazy Women's Jail",
  "b951445da12bb7a874c56ef5d05173d8aea8e449": "Creator Ra",
  "e4900a26a9e1f3bf4877ada6be002862971d8da9": "crescendo",
  "81e733f04efc18ca3f93c1227c186252fe9cdf3a": "Cricket Mania",
  "0f9db9944f4b74198d44a97300cd6b0e5c0aba3a": "Cricket Winner",
  "f16c60dca90d65ca9d9889c01d6ee932e31ee2f3": "Crime King 1000",
  "16aadc66878b7c0ef974dcd534403ba2756f32e1": "Crime Town",
  "276d848e44b4f3697fc8ac0b17e1abbce98e72ee": "Crocodile Blitz",
  "123f42cba1dfd363043d29df3e3db3842f67be2a": "Crown and Diamonds: Hold and Win",
  "a57140ca4ad58db1b7b8ac4a1f0245fa48ec3303": "Crown King Hot Gods & Kings Link",
  "9e621bdc8f4fcfdaa186a3ec5e0146dfbb6eba92": "Crown King Hot Gods & Kings Link VIP",
  "84a8bde653250bac88bc853b2a3c5c97d38864c9": "Crown Of Egypt",
  "e38502272d0433192eaf947f4129f8d37f6356c6": "Crown of Fire",
  "fdd5c1805b824a7c4ea40b47c0fa33d74c1569d0": "Crown of Fire",
  "8a66362be02e1a097e7b192caa24b4e419e865b1": "Crown of Fire Jackpot Play",
  "bd6899a8e2c8d1b349543ee51b91ccc15bc5fa13": "Crown's Legacy",
  "1ad0920f62eaabbd3ebf1c3fd5066e697cf44b6e": "crusader",
  "69be71a068662f26cb12fd0be7468140d25dc2b4": "Crypto Hit",
  "83250dee827e7bd91b966ad06307259bdb2e39c2": "Cryptopia",
  "0636e880a61f9c02419bb8e5b102a5fbef228df6": "Crystal Catcher",
  "9dd369d1b72f3a803c280c902f0aa619d5841302": "Crystal Caverns Megaways",
  "4e19932c37b5ddb557d28992269c10be746ade2d": "Crystal Caverns Megaways",
  "fce32b977abadf67b6450417cf0599b8e1575466": "Crystal Fruits",
  "26013ec9844b652e4b848f31680eace07331aa38": "Crystal Fruits Bonanza",
  "2018c45ac01064436d69c59a3f38f8d84379b0fd": "Crystal Hall",
  "719823e98a05c765b4c20bfd68f0567b259d304a": "Crystal Hunters",
  "cf64cf1ca6dba53350eb30d3b892f1a95ec37809": "Crystal Robot",
  "9b065a0679826c49aa9901e6a7aeb41dd8e004ff": "Crystal Sevens",
  "f30a1718b1864d00396129f695e7d5977aab3116": "Crystal Sun",
  "2e3e56e08b0f30d00f95c0daf00bf5c6b83d8359": "Crystals Digger",
  "5e51e3e07c92570de0dd13f51c229f69bf51b820": "Cthulhu Secret",
  "537d390b93db2e7644ab1e235ecc32d2f6961de1": "Cu Ju",
  "77ab1a711c81d65ef80bd83d3c7ec74d4aff1010": "Cubes",
  "f8a51fa0fcf21331693b53addc6fe528e10ffb59": "Cubes 2",
  "8282aa47894a5af5ea2ab81a9c42022d5c1da2af": "CULT",
  "b4e0fc7d99abd2ad0ecaebfe1f48ea2d34cc300f": "CULT",
  "e52b990218b97dbaf7551d9e63f4aed8e5e729b8": "Cupid and Psyche",
  "9f6a9d64111e3287b92fb67c1c55287178c178a5": "Curse of Anubis",
  "d789e5ece9b6e94eaf434a2a602b005acc95c33c": "Curse of the Werewolf Megaways",
  "ef5169daf4048eabbca69b1893cfe41477afaa7c": "Curse of the Werewolf Megaways",
  "104f8fe8855076d331792290db4575222169eff0": "Cursed Crypt",
  "95899e1c6cd5a9da44d287b3f1e496972cba15eb": "Cursed Seas",
  "a90373bd56c56d41e45035965b0987c417d4daac": "Cursed Treasure",
  "585a9161e7cabea4e4190a6b8c0e9f22a8f4b571": "CursedDoll",
  "2930f8bc42ec700c56b8a9f3ce95de7f5f7254cb": "Cyber Gypsies",
  "ab8bd2d2c9f184304474e13fe2a8547fbc5e3893": "Cyber Heist",
  "a4fb7445e8c283e1b8bda7bc81e03835e0a45bd9": "Cyber Wildz (Buy Bonus)",
  "40e69878313e2f33464d04bf8621b74f005cad9b": "Cyberheist City",
  "5fc118260119d0252360d3c2fbb18bd12092725e": "Cyberheist City",
  "5d9dfb4a58ceaf58163f58abb91a2171d20457f2": "Cyberpunk XXII",
  "579ca0ce3a5331ad08c892ae98de16f546247604": "Cyclops Smash",
  "d04e2dc4d7f0f37828012e582f282ffa61e2f178": "Cyclops Smash",
  "2a2601ddae5e7a0b7868476cd2846b240cff6acd": "cygnus",
  "6d9894ad10316f3b7832f22bb47ad7aaaab0e637": "cygnus-2",
  "6d9e3a6de1a81d43b7154afbf7f1199efef70255": "cygnus-3",
  "a0cdb04569c266c75c08f4f8a3fcc2ac2fd301f6": "cygnus-4",
  "ee6dc2c53abce9f2d57037fed16a889283faa47e": "cygnus-5",
  "ba1ccaebac69b6dcae2c852cd94ba3b55a77f23b": "cygnus-6",
  "813b1e2573ff44624539ed70238952e20b1edac7": "Da Guan Yuan",
  "112a0325f7ca46e407b8a1c3828f4737b3ef3411": "Da Ji Da Li",
  "140cfc16e4c7bf2e7d5d13163b70ecfbeb2369dd": "da Vinci",
  "b1df40e84f2101299cda7b3dee4c1ca5833845fd": "Da Vinci Diamonds",
  "277e35c4fb5059a2685338609a87d59052f0566b": "Da Vinci Diamonds Dual Play",
  "dc80be9c550568214456ef9154ef1fd934b7d107": "Da Vinci's Treasure",
  "f18c0f18854eb9bec083e0806bff12237900c89f": "Da Vinci's Treasure",
  "3e4498be69b6b7d90784cbc358cb824938c41bd0": "Daji",
  "0f10a16521ea33ee5f570c1d4bb896c0cb19390e": "dam-beavers",
  "53a3bd72cca50535d72d63bf93b171a9d44b9152": "Dance Party",
  "48c57153e41831dc2789594b07b7d0d48b5fb4c2": "Dance Party",
  "93f6f1a114ee1e5927087c2abe0e0554d100e3c9": "Dancheong Guardians",
  "fb116f5ebefe5ef24f4666ef54f74b5b1a36d016": "Dancing Dead",
  "587bcf73660214bc46d54542339b19095647f340": "Dancing Joker",
  "75b87e13f55941d46ce35b7943051c2643ca8cd1": "Dandy Diamonds",
  "ab55ddd50394d23a8141052d91b50cb8e4486122": "DanLudan's Fortune Bass",
  "fe6eb448c43494ca99e1ebe0cc31cf98416ef8ce": "Danny Dollar",
  "6e86378ab08527cb171ec1cdaff916163255fea6": "Dansband På Turné",
  "09442d39060ce82ed11cfbb405675c51c31168a3": "Dansk Roulette",
  "0d66b1ca9984c8d1274dd33ccad92d186c824e33": "Dark Family",
  "f303fea9b7ab7291e70810db37989e276c0a67c9": "Dark Fortress",
  "419a0e7937b1bd24b0b95167113d34f669a7eacf": "Dark Queen",
  "3fec7d183c4472f2553dee0cff098ab55a547ab5": "Dark Spiral",
  "3181dc81f158f5104b1ee4fab8b4b54605b8134a": "Dark Summoning",
  "7cb13e30858d2c6d2c467a8fe5b7faff4644e9f2": "DarumaImpact",
  "c4010a4f280d88e02a4a4b1f467633fd35cbdc7f": "Das xBoot",
  "ecd1a090a97b074352441c94c630f67b7e6db0de": "Dash OΓÇÖCash",
  "d4af60e2f55f96564e427067cbaae3464195e51e": "Dawn of Egypt",
  "941502ef0f5eee6c4676669d62553ded0b2656f9": "Dawn of Kings",
  "19d8a146fc8776160416418530898ef448428f1e": "Dawn Of The Incas",
  "3d88965ad3fa23484c07957dc7b3e25aac9a01fc": "Day of Dead",
  "c2b622f95c62afc1970716d1cae4e46e0872d1e6": "Day of Dead",
  "f6c19a4e5d97cbfcf52dd067c5ee45c982729180": "Dazzle Me Christmas",
  "7f03e62f18ad25921c0fa730b3a4be68821e7746": "Dead Canary",
  "34d3e7b9d99c083cb2a9ae3f169613b180ca3179": "Dead Man's Trail",
  "b94731f46cb3f54d7562a05465aab94c966f77c9": "Dead Mans Trail Dream Drop",
  "a8d5f2d1ba945c0afb505eb1c8408d6a886c021a": "Dead or Alive",
  "253dd812c47d1aa8c0f90fe84d4d7adb86372d2d": "Dead or Alive Saloon",
  "c3a1d598037ef25400b0a6573d89d83ab231f97d": "Dead Or Alive: Saloon",
  "d447df105202aa5ac19aea0c5406d7025c6a76e0": "Dead Or Alive: Saloon",
  "05082160bd8a9f9185a0716525ec342ae1cb6c11": "Dead or Alive: Saloon",
  "b4dc817970d6d91d2b3e561b82ccdab117e0afc0": "Dead or Alive™ 3: Wanted",
  "41250e1d85673faffd5bad58122310a4abb39d09": "Dead, Dead Or Deader",
  "0110ea2f60bfea50a482a1f4e4ab660809f11ded": "dead-mans-gold",
  "e5355488b7d8af7400d578e3d1e6b3532fd583d8": "deadeye",
  "6c4828c335a63e5a25b2d7549f7a9c46f7048670": "Deadliest Sea",
  "fbe815824b416f761e2b706d6c6de67321223434": "Deadly 5",
  "2f1e3d5a38c1fcebdd8974fc9480d975664ba90a": "Deadwood R.I.P",
  "705e5819fa3cd033b3b87b2876c4753b11b1cef4": "Deal With Death",
  "563a163f25ab9f6b69da6bc0e0eca80a9a459299": "Death Becomes You",
  "4d657bd971207bdf5b139dd8033a90e2c07c197f": "Death Dominion",
  "60658a892ff799f647f9871279ebab90a2d3bb65": "Death Dominion",
  "dcac10295df853526d4fa9da5c236c89b70f8647": "Deep Descent",
  "a92b6718fdecaf7a9c004dec95801daca95194d3": "Deep Sea Adventure",
  "7b5f7071e0f92b80f9c4f173020a9adf9df68fb2": "Deep Sea Frenzy",
  "65f40b71c37f66041cd7e7c020bf134b3fc444fb": "Deep Sea Monster",
  "5cc44f2e0923399db6bf18c2a2a28bd545993d21": "Def Leppard: Hysteria",
  "33165176b67fb716d194d5d9f39ab650d06841e8": "Demon",
  "5c531a379f2373168f2c292bc8504bb5f8c52f74": "Demon Fox",
  "a89dd66a089c2525609f0af157148ab536fa52d8": "Demon Pots",
  "b8c4a92e526a37210cd3b377d4cbc26194df61d4": "Demon Pots",
  "9fe9d988deb7691be0d827448b31772349973560": "Densho",
  "4959dab2b3d61153ec0072e19ddbe06671527809": "Derby Wheel",
  "e187a586838e1cd4adb7de7223fd44984b510c7c": "Desert Island Adventure Lock 2 Spin",
  "29c73f9f4276beb1f3f37de460d55c4cf43f5b3a": "Desert Temple",
  "79a3c024d6d413e6d27f597075f49067e81a193d": "Desert Wealth",
  "ab06e253dffff28d281f337398dabb25d67aecf3": "Dessert Kingdom Ante Bet Buy Bonus",
  "1ff0ab595ced220c3dccb02a2f65c94783e8b30c": "Destiny Dragon",
  "239cbe53ae626ce18cfb098fa40312a02667d5ea": "Detective Dee",
  "b281555c6b8f9e23935e98a620a557f124ecd456": "Deutsches Roulette",
  "a2a25b1d2c73e6e542ea51b85e95f2e72d7a6dbd": "Devil Wilds",
  "cd538eace0fbac37569419435436064cf49b8b83": "Devil's 13",
  "1643b139d70dc6e02f960f84932bf9851d65e723": "Devil's Crossroad",
  "f8df2d5659dd5ee097d7d4a19bfa0a089ee6660d": "Devilicious",
  "a9d5fd38ce7f3cad55bd211129546ac3ce7830b6": "Devilicious",
  "81d9e82904b121ae05c25d08586f7f68841b2269": "Devils Messenger",
  "a389093179bf6a24905a94ad63469fa69e13aae6": "Dia De Muertos",
  "de4a2d9e9316b5e3a3e2ca32b86b005c3fc35355": "diablo-reels",
  "655142d13e4a1c84edd2e754649ad2e5e7bf678f": "Diamond and Gold",
  "a00c260edcc58b88eaddbc6db5cd69a0fdbc318c": "Diamond Cascade",
  "5577a7ff0551cb03f09d8637ba5f1d656cf89784": "Diamond Cascade",
  "460808aada95358bc8a8852c653e67ad8112d7ff": "Diamond Cascade",
  "35bbe7baf73cd355a7c0d06e56eae75358254d48": "Diamond Cats",
  "b43aaf1cbb9bf92ddc224980a975d341e568d905": "Diamond Explosion Â® 7s",
  "3715dce084b9998c6a1d8719324ce3a48d5f6858": "Diamond Explosion® 777",
  "cc067f039e03981162c85a72bf247b555b97b287": "Diamond Explosion® 7s SE",
  "7207e24e64268b835c14a892df9b290e76a1a64a": "Diamond Explosion® Christmas Tango",
  "5a986267c4c1fcaa6bfa8e83585b69238957d0b2": "Diamond ExplosionÂ® Patriots",
  "5ae78624aa8c998c642e325fd7c631149840f1d1": "Diamond ExplosionÂ® Sweet Love",
  "403d38e0c470ff44457cde20368b93ff5f689d9c": "Diamond Fortunator: Hold and Win",
  "a9fd3a3bdad103d03abacc5daa7baaf189bedb17": "Diamond Hill",
  "606341b007f4f66ce0d3839ffb7a78b10fb85324": "Diamond Hits",
  "315343134740daada755f86b44943e345fe516ac": "Diamond Hits Trio: InstaStrike",
  "23e70145895c659f9a12764dedf1184aa0c32c1b": "Diamond Hunt",
  "5fcea73a6289dbf46fa15a0b6e303a9881cc6b8c": "Diamond Link Mighty Elephant WIN WAYS",
  "6f101b0024a145e042e9834df830fd036f059997": "Diamond Link Mighty Santa Boarded Up (Linked)",
  "22540bdfe73c5c0a518530b9a90f3778345f0ba6": "Diamond Link Mighty Sevens WIN WAYS",
  "f30812bc5924c3841fbaeb9392940d28c7d8aa13": "Diamond Link: Almighty Kraken (Linked)",
  "da9b5494535e3f9a5f26e374ce71ca290018212b": "Diamond Link: Almighty Wolf (Linked)",
  "a900f0df7c1a20660de05869ce55e18efc4621f1": "Diamond Link: Cops n Robbers (Linked)",
  "377c59ebccde02f6e57c745aa22a383550bb41d0": "Diamond Link: Mighty Buffalo (Linked)",
  "3a9761ade5900727f2cb6306552c2807db45f8c2": "Diamond Link: Mighty Cleopatra (Linked)",
  "e42aae14a4c5581a342a01de23436df77f13556a": "Diamond Link: Mighty Dwarves Inc. (Linked)",
  "1d9e043d12df2cccc65559f75ad67c289f5c6f9a": "Diamond Link: Mighty Elephant (Linked)",
  "791271a2ad0a897662aa624ee8b681bd63fd36ce": "Diamond Link: Mighty Santa (Linked)",
  "415ecdccafdc6348eee105e598c4399612a1f69b": "Diamond Link: Mighty Sevens (Linked)",
  "d6bdb5c11ba4aaffccf20f85270ed893b74432bf": "Diamond Link: Mighty Stampede (Linked)",
  "7a3e7e9bf88cc2e90e59d2675d74be35119fcbb5": "Diamond Match",
  "bf9ebc37a3d9ed5e83d0ed028aa6850359d3b098": "Diamond Match Deluxe",
  "de60726fa3d2d668b462c5ee907ab57b2d51dd76": "Diamond Monkey",
  "51c43ff91672781ef34e67e13792d7652966ec7e": "Diamond Mystery - 100 Wild Fire (Linked)",
  "c6ac33e126de07dbd0cd9a727188fc8caf545e38": "Diamond Mystery - 40 Imperial Crown deluxe (Linked)",
  "2ec1fa9c0a656fb0699e89400df0572d43f26092": "Diamond Mystery - Mega Blaze (Linked)",
  "0953d41d781fc49892d7746adbf8c423ae3c4a8e": "Diamond Mystery 100 Charming 7 s Linked",
  "9bdd324ce8a1feac6e1868c0e822aa07f51c6aa5": "Diamond Mystery 20 Imperial Crown deluxe Linked",
  "70d4ab7d10c5bc5195d1a5b489cc4667a5b2c00d": "Diamond Mystery 40 Charming 7 s Linked",
  "a93db29fa966e19cdcf1724b5951eb4a1f5e8c4d": "Diamond Mystery Fortune Streaks Linked",
  "444ab0208ace7f35dfc710b4badc1d98c11e38cd": "Diamond Mystery Fruitful Frenzy Cash Accumulator linked",
  "56ef5468de8e995224f35d5426278fbece08c217": "Diamond Plus",
  "f0d463f6820338863634238e95f4e63071311d5e": "Diamond Plus - Football Edition",
  "fdc0434783c67dbc302641906fcce452ce653229": "Diamond Plus - Valentine's Edition",
  "adec7bdae5711914ff3e2d1467e5f0723fdbfe02": "Diamond Power",
  "e4908e20bac8839e94ee8b1f28786b23551f0b09": "Diamond Raid",
  "2a72275e9bb2d47302c404084acbb1ab70277f73": "Diamond Riches",
  "a63b452efda65e31f693ea94c599969a92860694": "Diamond Rise",
  "2424bc9ba4592ec9c373effdb81b78fece9d70ab": "Diamond Strike",
  "5b42b58896738e4963d7e04e8912ac3204116448": "Diamond Strike",
  "a9a4f652c21d426d628e3589a42a836450ee05c0": "Diamond Strike 100,000",
  "9c1ddcf7035d0aa12e5e6e372dc22ba8d76dcc4b": "Diamond Tales: The Little Mermaid (Buy Bonus)",
  "8d1986c9f64d03aef7770df5335d6b1c1e86ed72": "Diamond Tales: The Princess and the Pea (Buy Bonus)",
  "67e74b0e8e4faa3f4dcb0a5c63d6dbf0bb9f9db2": "Diamond Tales: The Ugly Duckling (Buy Bonus)",
  "7faf6c9e098f0b89be1bf63013ad0ee257c98284": "Diamond Vortex",
  "6669c79a5dff8219b4017121115bc1d9e2812931": "Diamond Wins: Hold and Win",
  "a2c7f0365d1b71511c829b9afe4ab8a53c01a40d": "Diamonds Diamonds Diamonds Hold and Win",
  "1b653bdd5b3f3d3c624d58fd5bb682452df126b4": "Diamonds of Egypt",
  "bbb98f947514e6874e06e92fe8caefb0811133fc": "Diamonds of Egypt",
  "23fdb8d11f5169859be66aabdfcd36f3fcee73e7": "Diamonds of Liberty",
  "cdebca6bc8abce0b5d893514cfe098a4a4dbd381": "Diamonds of the Realm",
  "79f3e51badf3878e8dc0ca0e73d43da7e47c9034": "Diamonds on Fire",
  "86dc8499c28f41062d2b075beb608f60fbc05d07": "Diamonds Power XXL: Hold and Win",
  "7dbef3784e2c63ef548a362e1d9da6f4afe7b433": "Diamonds Power: Hold and Win",
  "4b3ec8245b921505ca91ac4012f84d97083ab927": "Dice",
  "954619bbe3db58ea92ede798c1e84c35226f080c": "Dice & Dinosaurs",
  "112e2782a4c34341fdb33c93655c4869e3b73e73": "Dice & Roll",
  "f8d7f49d1a15621966fb7f98800dcf7fba3e5b15": "Dice & Roll - Christmas Edition",
  "1ab6c8b06927eb07faa71ac7444129cd2a3745f7": "Dice City",
  "05b7353459f7af8331166efc0c47d0f4bcf7a5b8": "Dice Club",
  "112be17acb6b5eb426e289e2a13a3094d7be0e9e": "Dice Deco",
  "09d73f31bc583a5c6f166c3edaaf2b3fb5c89ce0": "Dice Deco Super Pot",
  "b0b398337816a1dd4617e5306f51936f9e897527": "Dice Invaders",
  "5bece49e8a050e5322cb643ffcffbc07edfa6d1d": "Dice of Magic",
  "6334c4def609459294e86a79175d9d2eeaf49b30": "Dice of Magic - Easter Edition",
  "51cf59ad0027b957dc63b1a31490e8ba61842ba1": "Dice of Ra",
  "f687f28a2ecb133c9e956f5327f203bbae1c4d5a": "Dice of Ra Egypt Quest (EQ)",
  "93677ac9aa9a38a5f9f5b1b08d412ab832af14fd": "Dice of Sherwood",
  "0cc56a712bb2c315ae8d419c95624e081d3db64f": "Dice Plus",
  "79603a502f0770f23938567d4236a598d65e1b08": "DICE VEGAS 81 EXCLUSIVE",
  "a80b45a77457847ac24c70e5cb43940e82eb4b80": "Dice Vikings",
  "3f33b77dd9f33782b2c56d999a70c862d0381b34": "Dice Ways",
  "8c2df7586e8a03fd33c77b9149dca473aaae7445": "Dick the Farmer",
  "98c4a8ccac0457c8a0ae6fb1f9df8aabe1120448": "Digitain Sportsbook",
  "6b91853c8dade702bde690dc8310d1f375e520d4": "Dim Sum",
  "d352fbf4ba0f540f0769eadf30d52675030d5933": "Ding Dong Christmas Bells",
  "bfaa02df44b9cef1ac0b52f1c02dd593d534db5f": "Ding Dong Christmas Bells",
  "c7f939e724a35e9466a132f9f8aea6b26cebbf27": "Dino Drop",
  "c173faf17bd6bc14979f78ab4346d2eed29c8d33": "Dino Drop",
  "b9cbde6abf0b8172748a21c21b9bac79a637ba6f": "Dinosaur Carnival",
  "731b599f9560316e3487516429a41239a61a0e09": "Dinosaur Park",
  "86c5e09273a94422cb05606034335163713ddfca": "Dio Killing the Dragon",
  "99a876fe636d6f4909bfbede2ff9df1b4030d0df": "dirty-dawgs-of-nitropolis",
  "b7c87ed53fe357d08a18940c5e84d3b28d8fd36a": "Disco Balls",
  "81a0e0884e7f788840945244c3026be6f970ecff": "Disco Diamonds",
  "e7081464c42b5db03530a0966e3e3dd592659616": "Disco Lady",
  "38a52257c2b77032e33fc73cbc8e47a78fba157b": "Disco Roulette",
  "b9492235e7c82ab95e47bbb5341140544c704438": "DiscoBeats",
  "7fc7799961760b45b296a51d4754d3226f047ab2": "DiscoFunk",
  "8498e8f420a568146e84dd1c302ff97997749108": "Disturbed",
  "4e3870caf97fd4b704911d1c6ff74b3a06e7655e": "Divina Commedia I Nove Cerchi",
  "837cfbab72b3b3a08d36bce5cfb5d6235b84092d": "Divine 9",
  "c6db94a765d111336cb5195b28525c38f9e25533": "Divine Drop",
  "975e1f50884512589760755b69cb3f4d2d58c49c": "Divine Fortune Black",
  "96040b2b0d5e8c6426b0eccd9dad15f6ed2e6f49": "Divine Fortune Gold",
  "2d14bd85a9aeadef2972a725360e2824876826d2": "Divine Garden Fusion Reels",
  "aa3cf226c4442077efe43bb9e15fd4995899625c": "Divine Showdown",
  "fbd06cd92d0f41b147d9ef53de3040c7589baa7f": "DJ Cat",
  "a15b07c7516aec59f56206964ecccfdd1a382596": "DJ Fox",
  "60fca7cbad0c51733cdcde3e7fe5f3b874132ce1": "DJ Neko",
  "f153906ee9edd1c271ffe91aaf8843dbd55d3e56": "DJ Neko",
  "cbb23568eb027ecee465d97bbd3915f39b53ef1a": "DJ Psycho",
  "2abfe652753b88941fa937bb50d02f537effeddb": "dj-wild",
  "6d56ef7a6457706322c067d12c5563c5f4f0fb4f": "Doll Theater Fusion Reels",
  "8ff262eed69fddadc6941f8993545bfb39cb9358": "Dolphin Reef",
  "117ddd969ffa919fceebdc19ea22c74d6d910061": "Don Quixote",
  "c3b62ab50ca4441bac0abc20f9333795b63718c6": "Donny and Danny",
  "375349e7e0ac388e1326470f360324f02f34c81f": "Donny Dough",
  "029b5d76f71313bda1ce436aab4f1b8b6c698fa9": "Donut City",
  "9464165a6161e1f7279c1918d541cf34b9598b59": "Donut Division",
  "3f2dd1dbfbd3639935d7b2d8db98fd3dc098889b": "Doom of Egypt",
  "cc81c33a33cac41c051eaa7fbf5fd58cf2a0e167": "Dork Unit",
  "e241bf938607d6acfbfbc07e361c4ea6255f48f4": "Dorks of the Deep",
  "cfdd367ec6e1f116b55823acc9331de0aa2952d0": "Dorothy's Fairyland",
  "24171d920aa429e44feaa90c33a52245aa971dd1": "Double Ball Roulette",
  "f8b108dd8b4d38c8e058f65b91533d1336b8a6b6": "Double Ball Roulette",
  "6e3b83309a818eb15ca3f0bfd69fe9ba1308e899": "Double Ball Roulette",
  "16b9f0ef02ce8c3f5e737787f48993a9ee6de57a": "Double Ball Roulette",
  "9e75119b3567625ef89a93d93451337fa69e1821": "Double Diamond",
  "514dce241920a1de1f72ba0c429061d83684602a": "Double Diamonds",
  "8723cb51b062a1cb0ef4ed8af37bff56cbe2fea6": "Double Diamonds Dice",
  "f44a5e5b6b10837a4e38a50d615ce9b273057e72": "Double Digger",
  "b792f147d434da27ca37c4211bbd309e3a710383": "Double Fireworks",
  "20968d91d7f1be7bc1950717227d82aede58c668": "Double Fortune",
  "03231cc9478cbdeb3259e910781494bf271a8baa": "Double Happiness",
  "c72153eb70b26bc6fafbd82edfbb174a5eceb183": "Double Heat: Crown",
  "859ffa9e9296a5a3f8c54d4e3d08ac1dcb7c57ea": "Double Rainbow",
  "04c92e9be880edd2a60a2d20af4452ab23fd6f3a": "Double Steam",
  "0ddbadd1048ce07285c2e70b4ed0b4d9f95eb0e0": "Double Top Dollar",
  "16a9d3ee2a0babd3f86275e641f533870628b7a8": "Double Triple Chance",
  "9259075e5a1548364eced0d8afbadeb3f1fa82f0": "DoubleODollars",
  "cfc7ca2f9aac72f6a85435cf980393dd92fae9fd": "Down the Rails",
  "d04eddec1b1ed3202e1846986b8f9440a86a1779": "Dr Zappo",
  "58fe1006a6ed411ae75eb86acccff8eacfb4db56": "Dr. Frankenstein",
  "91b7cd84398a71ed7795d4d7290707e3db5e78f6": "Dr. Geek",
  "56abe0b50a3e79846017c6e3d254f9d597ea489e": "Dr. Mad",
  "118368998e432d38f5e117b6d722266550cf3841": "Dr. Toonz",
  "a792f5e38328f57451d479aa5d13c7b95fedbdaa": "Dracula",
  "4b5a230f616325c260566bd44d46c05ceb2c24aa": "Dracula Riches",
  "45cbfaf6fdb1751c1a6316ce498305c831e41332": "Drago - Jewels of Fortune",
  "2f1ffbd4c7a81bcb2cd2aeeec2033e5f5ceaccf2": "Drago - Jewels of Fortune",
  "c8028ddd22906b56a6c0dce66ad3c661469d052f": "Dragon 8s 25x",
  "7e936e5e166f7c5d2774b1c6e8afa6dea2754cca": "Dragon Blitz",
  "aab651e5c159d8482114f68cab77f7fa6ec535e3": "Dragon Boat",
  "7807e37d9284d795c2a62476763f05bb795dc188": "Dragon Boat 2 Lock 2 Spin",
  "ca916e30c2638b23a616aef1193f8876622ce44d": "Dragon Champions",
  "31e145d92d022b178db0f98f44419bb030dcff08": "Dragon Chi",
  "cbc65f666a4d166ba32683086f9cc2e6577b195d": "Dragon Dragon",
  "d97771cbc808e8848d060f2954be5474dc310822": "Dragon Dragon",
  "153db85773fff50fa0c38179e16bdd833f472617": "Dragon Dragon",
  "245328ba425964ea09d07b8b0e719158bbe6d47a": "Dragon Dragon",
  "0cbbb7fb5f3bcfe84d66f15b8c52cf274a876dad": "Dragon Egg FeatureStorm",
  "3db7bea660ea4d6a3739532dd918481649f34e01": "Dragon Gate",
  "194a5aa9ab17e2b20bd458e0b575de68667f3ceb": "Dragon Gold 88",
  "35d133e2d5392d9eeae9ef1add7302f3dfe17202": "Dragon Gold 88",
  "daeec527361f4fc7424e0360f4b2b1d2d556da55": "Dragon Hero",
  "2e485430d299964511b90f192c8442290085eae8": "Dragon Hero",
  "93e643669ed21fcbafce8e0a59e75f7032a6927a": "Dragon Hopper",
  "e0c42dc52bf5a292f17bc2d422798bbfc33754fb": "Dragon Hot Hold & Spin",
  "5d9c97fe933316e65868bd2339bf86011d6d26d7": "Dragon Hot Hold & Spin",
  "7351440e803cf6554c9aa88a366110746eb28284": "Dragon Hunter",
  "72b457c53e2be1af8864f7191c4230c3bd84286a": "Dragon Ingot",
  "9f781291f434d1728bdfd862c3b1e41a47ffa477": "Dragon Inn",
  "938d2499ba4e85e8f8f411205469437166abe76c": "Dragon King Hot Pots",
  "65d7a11f7be43a2f471a316c4af99d3205303942": "Dragon King Hot Pots",
  "110ac9683dbd931a6fcb0a06cc891d1c7c2be839": "Dragon Kingdom",
  "c63f0bde10d2ea720f2360864d5436bc62d9e96d": "Dragon Kingdom",
  "6834cfd0de7d5b90c36f2871fe13adff86e34982": "Dragon Kingdom - Eyes of Fire",
  "c164e7790f2b5c84bdefe630324bb54700eb8bdb": "Dragon Legend Lock 2 Spin",
  "a89cd8854e8fcdae7cba80949832df0b44d6d8f3": "Dragon Maiden",
  "2d003c607b027067f356fc125b038b35620800ed": "Dragon Pearl",
  "fc1ecef717daebf72a58c524bbdce65aab87d9e4": "Dragon Pearls",
  "d5ce7cc0e7880a7ac2498a9b104e43b02480e054": "Dragon Pots Megaways",
  "7e1c80ee8109d4a8085a45f19fbb47c547795167": "Dragon Prophecy",
  "397165d5fb6b127b1e5c06add51d4b61157ddf84": "Dragon Quest",
  "8617d36b1bd957660bc26b1673131796f4c77807": "Dragon Reborn",
  "d5815152ac573c4c4b78d5e6b3bb782166ef344f": "Dragon Reels",
  "c15ec9bb568dc43217ebe9aab3910ef70f4465c4": "Dragon Riches",
  "5708638eb1862172dcbcd42dc8b2e7198c634101": "Dragon Ship",
  "5119afa69c7cab3514de42be5469b435e9f6a82a": "Dragon Spirit",
  "9a6faea1ae4e7343b432a533757fc031b46c2180": "Dragon Tiger",
  "bb27b87ac625bf32d821c7c17f6040c0ed096c2d": "Dragon Tiger",
  "9c98e3fb03c2ccd805c9842ca0b1f7a37552570b": "Dragon Tiger",
  "b27cbe936a5b4bb111b19a0270344d5782a85183": "Dragon Tiger",
  "f87fbd4773f2bba3d0d0665b56321c75efd119b5": "Dragon Tiger",
  "29691c172403f3701ef306c0f6231cd6da9c79d0": "Dragon Tiger Fortunes",
  "1a7ab8ab34aa5c090798e948e360fb87a15c3477": "Dragon Tiger Fortunes",
  "10a26000818628114b2fd38ed3b6b23846698a5f": "Dragon Tiger Phoenix",
  "ccd261a7adcacb0721f1154c56988aed0b8ca46f": "Dragon Tiger Phoenix",
  "f80cc9b58c0420614991902687e83eca8fff4708": "Dragon Tiger Phoenix",
  "061f1bd6860725b0e786f51803f792fee1725523": "Dragon Tiger Phoenix",
  "eaa2ba4e53d6adc06c8dcc37498cc995aa887391": "Dragon Turtle",
  "4d5aaef722cf4b320aba7568292b2c26bb4f8a8b": "Dragon vs Phoenix",
  "2050e484d09d046ecf15ff12d4ca5bfa732a5f40": "Dragon Wealth",
  "ff51fc41bb74371e340f085e8ffd85fd96f5a6ae": "Dragon's Bonanza",
  "855b61540b8451678bc8a48d579d9c245c1c7759": "Dragon's Domain",
  "0b0faff031325b49d7e71f91cf5456c6e7af34a2": "Dragon's Element",
  "ea123ea7e759591f845b85a4bbd406404dc4f469": "Dragon's Element Deluxe",
  "2d878d6788219e821aa8ae0d79e20ce7a6fa70a8": "Dragon's Hall Thundershots",
  "87d222886253611512e92b12f5a5f3e6c3f0390f": "Dragon's Hoard",
  "66844a550d73059cf57e1a21d68b43552b5739dd": "Dragon's Money",
  "080cfe50a30a3c65036b33eab8970a08f4915224": "Dragon's Pearl",
  "389307c2eaa4b14cb42e131e8c5c5878db4fa728": "Dragon's Treasure",
  "11fb4f77e7ebc6fe5fdaf28677042a2b5929f2cb": "Dragon's Treasure 2",
  "ac4c6308cb5a44b497428e886f5ba4ef9fea7e8c": "Dragon's Way",
  "f5c06a556d6bbe10d0a30281deb0f9e2620d53fc": "Dragonara Roulette",
  "40eae03f02a590a1dfc04c49c99f529a0cc31326": "Dragonara Roulette",
  "d3fac7bee9a20d0b78d058f6c0986a2a7de84a74": "Dragonfate's Favor",
  "a26bf1d6f225125773dade66f2f9a11c78736d74": "Dragons Awakening",
  "6d341038c47f67df0beef58c3f07ade32f5f4459": "Dragons' Realm",
  "779834d4c64bf146f91d58219fd1f15c442b9a4b": "DragonsRealm",
  "5b3e25995b3b8c1fcb00605cef3a25defb9cefe6": "DragonsThrone",
  "e22de02e46d3bfcb2c1d3a221a973744855ae780": "DragonTigerGate",
  "28a52352676c4f1d966239d1bb1515fe9632fd09": "Dragon’s Gate – Bonus Choice",
  "4671f09098752ed7157fc641a8fcb4b88ce5ed54": "Dream Catcher",
  "506e517e5280e04649a04631d2868bb140f65391": "Dream Catcher",
  "f4501c4e0dbdd7ca1bbac39c11b8dacd43453b26": "Dream Catcher",
  "6d07bff39e13ff2062d3bcfd13eb057d81d77ba5": "Dream Catcher",
  "3cf74ab946d3df9adabbe965ac6b878e04a0e968": "dream-diver",
  "d694a87b4de3a69c3ae814401431ce2f394378a8": "Dreamcatcher",
  "cba0a5e0d717f640f2e772ccefac40d79e13c6a8": "Dreaming Island",
  "30adf28d22b5233fec7aae79b84a22c91321593d": "dreamzone",
  "350be6ff3a9e173fb96869231142b51645505517": "DrFeelgood",
  "491e6105d2dd5252f1ed8bb9c276b4a1f4799613": "Drill That Gold",
  "5a4c93be87c755e7c1ade2007ac7528a90a7f8cc": "Drill That Gold",
  "f4c87a553a78c50a9b04a90b24c4e50285cea5ef": "Drop for Top",
  "de1465a4bc275ed30e7344e5adc49204a3ffd294": "Drop'em",
  "c073bac9e41a5cf6ec0ec0a0025899ad47e3282a": "Drops of Water",
  "fca60d7f79c63a770f34d1f3a76c2b92253a62c2": "dropz",
  "04476b335c1673e08632de4fb92d85cb5d291710": "Duck Hunters",
  "8a8d7a68227a2ce4478199671a4350d9a0985dbb": "Duel at Dawn",
  "f3506901f601a22c718e949e46ba93491619e58e": "Duel of Night & Day",
  "273f7c5176f031045832bb21c4df0d53d7be6909": "Duel of Night & Day",
  "a27507b483a1c2af37d98075e56de8f95f0331f9": "Duel Skateboards",
  "0a5d7e161683becc16516255d736ee6786d59f3c": "Dumb Hero Fusion Reels",
  "42274b839121fa3274820fcc02a34f1dbf63eaa8": "Dungeon Quest",
  "9905c5b08d81ec239d8800eabf049a035e0483c9": "Dusk Princess",
  "51f257a7b9cee2069818033fcd6d445a24b4b26f": "Dwarf & Dragon",
  "6f18eafc422e6723c0c35307a035b3c7c341ac41": "Dwarf & Dragon",
  "3099bf78fc6e230ef7964776e037fbbf51356be7": "Dwarf Miner",
  "d076b47d6872965a96727d3d1c3dfa19653c21ff": "Dwarven Gold Deluxe",
  "6973eeca3baf4bb39cbef16cf20b60b8f5d5bcd2": "Dwarven Gold Deluxe",
  "add128d82d69bd530c6f1ff06dd6fc55f75710d0": "Dynamite Diggin Doug",
  "95b7b90a5454dd5028868a5ddf5ee3be761e54d7": "Dynamite Diggin Doug",
  "75b4b95fcf9cccd3d3fc93b979380ce7b2270db6": "Dynamite Splash 10",
  "be9b3abb2909f87c257b64d43f7c6d117095eb95": "Dynamite Splash 20",
  "b63e28df927bce968e5e5ac53a11103757cb2d37": "Dynamite Splash 5",
  "1c1d665b41af8726707f722961fda608680bc3f0": "Dynamite Trio",
  "83e671527dd6c09153c36e7a158be7da77ec8357": "Dynasty Classic Blackjack 1",
  "62515592d242fd23b528897f6f3f65280c66f200": "Dynasty Classic Blackjack 2",
  "b7222c78c73aa9850677061b8494fd3aeef5b143": "Dynasty Classic Blackjack 3",
  "d6c9436b720f2ec839c0e2ec99053f55b6704320": "Dynasty Classic Blackjack 4",
  "b1d66001073a35cd0c9be4b4fc042bc81d607434": "Dynasty of Death",
  "136ddd4bcdd4fc1af382b752236ad371f470aa28": "Dynasty Roulette",
  "8cbb0f3364e850286d52f66b8d98057d49e8931c": "Dynasty Roulette",
  "62ee3c2d642e55f01492fc6a79c45baff547f2c3": "Dynasty Roulette",
  "3a627a428da451d7c69ef89298e0582e0272d397": "Dynasty Speed Baccarat 1",
  "9eb932e16211b8ef0282bb6265d13439354bcc75": "Dynasty Speed Baccarat 1",
  "3f39f14f3928614c856836d6c7ae3a52cb8aeda2": "Dynasty Speed Baccarat 1",
  "a619d4ddf0577192cd07ba151da1d01a078b69ea": "Dynasty Speed Baccarat 10",
  "9e64dec90e71132ab6acaa716817142631f858ec": "Dynasty Speed Baccarat 11",
  "55cff972c162b08cf8d7b765763f65ba32aa058f": "Dynasty Speed Baccarat 12",
  "58e47d316c9ccd1c5765f967c2900359dd67728f": "Dynasty Speed Baccarat 13",
  "d3d15a29ea4807fe4d4edf750ed9c20f3e9b5ad4": "Dynasty Speed Baccarat 14",
  "d8ea3f34c8346515ed61474e83aefddeae746bf5": "Dynasty Speed Baccarat 15",
  "2839b60ebb8b747f767c377fec4eee175944ea0c": "Dynasty Speed Baccarat 16",
  "31b224989f07ecafc635ef2041924a2d7f62b798": "Dynasty Speed Baccarat 17",
  "1a6bc5f270b8f51cdfe53325718c5d7030dd96c6": "Dynasty Speed Baccarat 2",
  "d6a9017ef8d61d8ac96967318de330d950a75f7f": "Dynasty Speed Baccarat 2",
  "55ea1490edb1bae79eb7f8c882dbb18afc3578d8": "Dynasty Speed Baccarat 2",
  "5773889afcf0ad2c0e108997b15a3ed46a2fd3b7": "Dynasty Speed Baccarat 3",
  "9d2bdc2346206c5366ad70c781d8840e4aadb34e": "Dynasty Speed Baccarat 3",
  "6c878b834c12a1a759d6c440616b629bdd2ec34d": "Dynasty Speed Baccarat 3",
  "a19353cdc2c5ddf95037960c00ddb843475171bc": "Dynasty Speed Baccarat 4",
  "b8cd07a2ea304953ed0c9f54f1b46c27eeae9eed": "Dynasty Speed Baccarat 4",
  "c705b7f7dc390aedd752ce624328208c581dbd66": "Dynasty Speed Baccarat 4",
  "32b630439ad96d23752c49d0175a92410abb7c90": "Dynasty Speed Baccarat 5",
  "70109b82215db899773f9f7edee89413303d41f2": "Dynasty Speed Baccarat 5",
  "bdd1c5f5ab6d79fb567db2a8829d63cd7d9f1290": "Dynasty Speed Baccarat 5",
  "9e9725909073ae68e817586f9739fcfdd7e0511c": "Dynasty Speed Baccarat 6",
  "e23ed37e98e183d96da7564608a2af347eb86635": "Dynasty Speed Baccarat 6",
  "8d06a6472b97b7940117266b79186116a8afcbef": "Dynasty Speed Baccarat 6",
  "c368af11d245c82537b7172a2ab740c527fec4d2": "Dynasty Speed Baccarat 7",
  "e73f21e709c6d558bd911688cd714e21477545ec": "Dynasty Speed Baccarat 7",
  "ca13617f14648833c1f969b17d39fd430f638d0f": "Dynasty Speed Baccarat 7",
  "8457aa7c9af881accfb3f14ffa5e2d7ffe890520": "Dynasty Speed Baccarat 8",
  "ba009b003c8f6d117aa02636808808069e1c0deb": "Dynasty Speed Baccarat 8",
  "4fb99d54694c138c0ee436ab672fea4404412ccd": "Dynasty Speed Baccarat 8",
  "c2c463a4173cdfadf43f768590bb220678f5fdc6": "Dynasty Speed Baccarat 9",
  "720e435332704eb3ac0cc23e681ca40750de339d": "E-Force",
  "49348af973dab302150584507a3a48b6a9838dc0": "Eagle Wilds",
  "27f254e03f29dcfaae625406a4e95c869f79a143": "Eagle: Cash Collect & Link",
  "3d0370beb3728e73e72e82092759795674acacda": "Earth God",
  "84848529e3af221da20269a6f459b1461bb1eb3b": "East Coast VS West Coast",
  "8e1827d676fb564f6f3f7ce023195a700c8b5c48": "Easter Classics",
  "7f687709e9225e59382ce37e28094e6e13d0c951": "Easter Egg Party",
  "fb8500b4551b3b73252aacb3875a399f19c6ef78": "Easter Eggs",
  "7f54fc905ee888b3f326d2352000b80b5fff49e4": "Easter Eggspedition",
  "731fa4ddab1da2af7bdb28e6736b27adaee2828d": "Easter Frog",
  "8c498ad6192960f299b75d8cc21e03c67d46e747": "Easter Frog Dice",
  "3257553e9482debd31efc880aad6738ec11bb34c": "Easter Island 2",
  "0a6704729e48370152e80c99d6a966e192fb98cd": "Eastern Fury",
  "328803dcbd557928c06266e0f91ee2d80e78bded": "Eastern Goddesses",
  "be2c1a1edf092c53fc835874a878ce3262a4a87e": "Easy Blackjack",
  "c7a7749e31c16c0d3b0e63e39772fba2b0ff3d9a": "Easy Blackjack",
  "533da54ec92fa58989e67f1d220f0eef862beb07": "Easy Blackjack",
  "3732e391e1496c8107a7e37afb3b907abe152b30": "Easy Blackjack",
  "2ab8e810e06b9b341b829d8d81698cdfbb1257ec": "Easy Cash",
  "fcf5853be1190604f24ae3b823c9416e7911abc9": "ecuador-gold",
  "5e381d85cbcb14e90d6a3c921b557ece79b342fa": "Edge of the Stars",
  "d343340802fe054b1d5178c063663974bdac2848": "Egypt Dice",
  "d6b573f9c5dc85d05da780ff21335b2254d62010": "Egypt Dice Egypt Quest (EQ)",
  "ab3a11299eb5a654b875614514bd2b50e7be9531": "Egypt Sky",
  "3d1f9ca9e61a65d883eb6bd5f33835264c7a60e5": "Egypt Sky Egypt Quest (EQ)",
  "d4c63a96b009ee461770b2006e8ac86897e9b2c3": "Egyptian Deity",
  "b7167a19696d1bc8e045362aa586e35aef6b4b9a": "Egyptian Empress",
  "7fe70c992afd4fff6df8a53c3db962b2adbfae37": "Egyptian Fortunes",
  "ed0a46140277e85851b5ac890b84a1645f152f31": "Egyptian Fortunes",
  "15f2bee7f5821d78fc4f03c748e8cb6dd8506950": "Egyptian Goddess",
  "2d594d51f8655d176c60f599fd327e9b46e90760": "Egyptian Mythology",
  "463ae9f99f463230d10a8881aed3303f2c29d1a5": "Egyptian Sun",
  "6e5491e43e3f8dd9cc2d6ef67bf060c0dab94deb": "Egyptian Sun SE",
  "79292180ea1438427ae279fc56d3a37e6ce2fb31": "Egyptian Underworld",
  "29730ae0d3d8bbe20195cd3edfc63ff8c1952866": "EgyptianDreams",
  "a6305d43cd73fe018c04d424997d866cd48ab3e6": "EgyptianDreamsDeluxe",
  "8306c0e3d63ccd7b631543c1a4731abb3518980e": "Eight Treasures",
  "d484ec0407a7ca8657f3b31ffe824e7f02f4f526": "El Dorado Fruits",
  "4609ae1f0e19f2332e499c0f12b6857d9b06480c": "El Ranchero Cash Collect Diamond Path",
  "4633d71c1e87ad2382e33f7147d7d24963cd1308": "El Torero Raging Bull",
  "48b9a326705b439c2b40217fd7cc9c3e5ebdd1bc": "Elastic Jelly",
  "20eb77d42e0309d9e63eda7f33070f6521db7303": "Electric Energy",
  "f2d4b66a13acdc717c7b22f24291c6c7246a4e81": "Electric Flamingo",
  "e319704878a614069e2b457c714d93607ff2ceba": "Electric Fruit",
  "5e237f8fbecbae9169927ab2cdee8e014af1f4a2": "Electric Sevens",
  "596c39227195bc62e213346ffda9a8f00db9c747": "electric-sam",
  "b2af09b3f9ea852b643159a17cf3d64b5181abeb": "Element Shaman",
  "4993ab975a56f99e5b963a6cd59ddd85f09f3172": "Elemental Gems Megaways",
  "be126bc81aea830e0ede3de5848ef1bdc08046cc": "Elemental Gems Megaways",
  "4687a71c23612858f061ec2958ac1b2659b80398": "Elephant Riches",
  "766c434e79feaef1d50fa08dd3c4de4b6f926943": "Elephant Splash",
  "b87b52a58b8eefadc6ae857ee28342c25913be44": "Elephant Stampede",
  "eb22faadbe7db6fde584b2e8510661feb794d095": "Elephant Stampede SE",
  "2da55fbb6595d1198cfc4e01e67e089cd76b4cc4": "Elf Castle",
  "b89fd12b2fdb365253cadf95439924336c6eff6a": "Elf Treasure Lock 2 Spin",
  "63797eabed68ae3839a70afe5623b5cca7f4e41f": "Elite Games",
  "eafc80605aa7cd805e8746ca2b07cf204b47c6b4": "Elite VIP Speed Baccarat 1",
  "606b3f4e2b6ff269943136a04783013777142174": "Elite VIP Speed Baccarat 1",
  "28f97070481a1e598e891421dde6c4ccf8a7ebf3": "Elite VIP Speed Baccarat 2",
  "7d5030c9879a302575c740c9c64a784331b2f57e": "Elite VIP Speed Baccarat 2",
  "01c4ef8bc32d1f4ce6da4710e4b08279c31ba2f4": "Elk Hunter",
  "5a511b0f956315a18c493df6b399a47e95f5d8e0": "elysian-gold",
  "1dce12bac558c255b1943cdfb7db6639b14c2ec4": "Emerald King",
  "52ecbd32d70b77e9abf4960ead74765590c76c5f": "Emerald King Rainbow Road",
  "80ad3aaa837d538e2ff4d6bbed04e3ae140680bc": "Emerald King Rainbow Road",
  "71d5c0d1c91c5e00644a471484a9dc1ef754243e": "Emerald King – Wheel of Wealth",
  "bdb7b747a2bc1071329e370650cf194e743fd9e5": "Emerald King – Wheel of Wealth",
  "5ec821f432ac86dfeb1b840538c4e8cc156bb5e2": "Emerald's Infinity Reels",
  "d1b132eb39cfa635add6d75435ddd779890cf97c": "Emoji",
  "0ac2355d5504ff091c92681331106f1ab2855837": "Emotiwins",
  "34f8bdaed244790626fb5aef2e4cc1e830896d63": "Emperor Bac Bo",
  "68e58919653067d87558e512709b557cb12078bd": "Emperor Bac Bo",
  "e6bc7497c4916f008785af96bb2b3871b87fcbfa": "Emperor Bac Bo",
  "f23477f605fe480d36430693e8234f9af31e164d": "Emperor Caishen",
  "8928ee6fc325c3db3ee880f41a692d66f6154cac": "Emperor Dragon Tiger",
  "d2c28f353e81944c5acbe2e9cf298cde0bb98e9c": "Emperor Dragon Tiger",
  "2c679463073d2893a21bba2b5bc6e02fd2bde487": "Emperor Dragon Tiger",
  "3c068d5488f65c31ca106691854938a355bd81a0": "Emperor Golden Wealth Baccarat",
  "da5cb6a652c5f9212462f631daeb081a0e7501aa": "Emperor Golden Wealth Baccarat",
  "d6ce405e96ccad07f6c9ce3e01e4d12e54008a6f": "Emperor Golden Wealth Baccarat",
  "1df599b035d0e2da98bcbeeaa5a06d1f7ada5810": "Emperor Qin",
  "30531589058cf974bc09fa5d773b81aa72289ef0": "Emperor Roulette",
  "4593f660cf9e8fa8433ee789800ef0f2f5f1520b": "Emperor Roulette",
  "d7b3b4fded0c8ccc4811ff8a15e8d497dadb886f": "Emperor Roulette",
  "c7462e5c32654230078071745b1b729f4f768236": "Emperor Sic Bo",
  "f927d17e3d6ec7d77ad9f53e1af51109ac905e08": "Emperor Sic Bo",
  "07b1dfd422780c4c3659b663eddf853c37caf1c9": "Emperor Sic Bo",
  "482e4add2d20a10f16bebd1d2cb0558efc1404e6": "Emperor Sic Bo A",
  "90ededc62a313c48031d8c719db7ab7f48e5ea25": "Emperor Sic Bo A",
  "38ad2e994306be91eca87c108477e928a8f136a1": "Emperor Sic Bo A",
  "a7293fc945e35fe2b9880d0eddb3bf2ae26d08fe": "Emperor Speed Baccarat A",
  "dcc3041fb97d8aad1b81b3cb701f7a62fdaac07e": "Emperor Speed Baccarat A",
  "8ca768de1dd90b8775402eb2764f7cace8ded319": "Emperor Speed Baccarat A",
  "6ea718e1a053c786d0928f6b5ddf74f4f927f70e": "Emperor Speed Baccarat B",
  "90ee3587c0ba3782f23455fafde3fd6fdc054cb0": "Emperor Speed Baccarat B",
  "33433d2a7fc9404a53bd888f97483ed92ca2e059": "Emperor Speed Baccarat B",
  "50c987f7857b4b2dcd99436a356f6bea0c35c000": "Emperor Speed Baccarat C",
  "a39648b21850246955b493a876c5f1c615e1b703": "Emperor Speed Baccarat C",
  "d427611084d522dba3a6e456a300fd90bbdfb534": "Emperor Speed Baccarat C",
  "75523ea1b3d07ac462899c632bfad374c8f968b7": "Emperor Speed Baccarat D",
  "a4748fbe635d255542c8db292099737c21936f0c": "Emperor Speed Baccarat D",
  "e924cdaf8765c7902d59c636340dfbb80e1c03b9": "Emperor Speed Baccarat D",
  "12bf6db5cdb76da031a7784c45d80b6543ce2b24": "Emperor's Dream",
  "f282ddfeefae8872ec6a8d09e4e80021f79e5394": "Emperor's Palace",
  "78dff541a4f46b7a829b95562ea8b820e32e1afd": "Emperor's Palace",
  "70e221e57807977298762438b94f206d9f03bdc9": "Empire Gold: Hold and Win",
  "d69a212f61a2263054a06c6524c028244cdb614d": "Empress Charm",
  "401a856ec4c6cfc0c98fac90df142818782d7632": "Empty City",
  "83d587883e48672676348b3885e06240bc975c85": "Empty the Bank",
  "347ecbd7c70bd3e152277cc5644a30153b74bb32": "Empty the Bank",
  "52e990f6ea7f3592169b8c46e341ed802c9c53b7": "Enchanted",
  "1a84def01c6bb9cf210b58a62d57061f9a209ed0": "Enchanted Cleopatra",
  "864bc70c7c6b111278ff59137556d2f4ed6ce4bb": "Enchanted Crystals",
  "bfd763baa5dead605146612fd8522e6583cf6acd": "Enchanted Lamp",
  "689952c332db7833588e57826ede45819bda65d6": "Enchanted Meadow",
  "1951f1e349fc3a21a3f25203b1a2cba511e1ed36": "Enchanted Waters",
  "5e99a40e1ac1744207daf6f22ca30f408726b117": "Enchantress Area",
  "09a73fc28a4e0c5d3ae0f709a4deb040f65c54cd": "Energoonz",
  "7f433000eb4b93b0c5ab51a8a36e00e8da589c9a": "Energy Awakening",
  "463c10d2c37ac2d0a292ff8ff9e38b0dd584845a": "Energy Coins: Hold and Win",
  "4f9ef18b6219d8e2acba8c66bfb22923b58ccf6f": "Energy Joker: Hold and Win",
  "b3beb661f0c1f2007b858288efe09ee55c59a790": "Epic Ape",
  "a43e8590e7382625d0c1bc56347ac1a609da5d04": "Epic Ape II",
  "4b1f27ba4aeea0f426b81cdb8e951ecaf27aa885": "Epic Bullets and Bounty",
  "2e7ae7e55882fe0f06e6bfcfe7b131e29e58f05b": "Epic Coins",
  "ad7e8f03072eeffa63c2f5e0f9d25f8de70d1810": "Epic Joker",
  "2acfd57cac54419c27ec3e0837c5b3cc549a3ad8": "Epic Ze Zeus",
  "a41e8c851537559951814d0805835cf350117629": "Erik the Red",
  "beb7ecbf10ae51200f05b4873f44ef8bee3e2a6c": "Erlang Shen",
  "55ddd7a7b03da2c1cf56028040315847301f2f80": "Escape the Pyramid – Fire & Ice",
  "e469b84eb06ea8f5688e126db79860173940cbdc": "Escape the Pyramid – Fire & Ice",
  "eb2f98e8d031cb6711a0398c833e67154397507e": "Eternal Diamonds",
  "585d8900232651630f82671b24b176c48781dde8": "Eternal Duel",
  "5489e070849539ae0eb52bce00bfa6715cc724e7": "Eternal Empress - Freeze Time",
  "c6517e757440609a1d63c0f947f29c2a31da295a": "Eternal Empress – Freeze Time",
  "3d37d7e7b999dcfabbabe0b5e5ec7bf2668118c9": "Eve of Gifts",
  "213bbf7817b811259a78c9b75724bae194a20e97": "EveryMatrix Sportsbook",
  "9abe810e67b413a8c38f8c2b0b32eddfaa28d84a": "Evil Eyes",
  "8db81e8a5d3748bc1015929476c3e60b78d121fc": "Evil Goblins xBomb®",
  "fffd43a121642022ab7ecf61a7131ea56a3179c0": "Evil Pumpkin",
  "9af8ca07674a3d9bb7011207c6034193c4b7fc8b": "Evil Wizard Cat",
  "b863611b5c821879cb2bf8d7f87046a8c4528fc1": "EVO PowerBall",
  "0025a9aba6adcecfa022d1406ada955c7f6a799b": "Evo Speed Blackjack 1",
  "046a3ce3b235fa1e1bb56ff96dd7ee6bd2c1834b": "Evo Speed Blackjack 1",
  "36be7a3215a0aad87bdf3e9ebc80a5a3a5ff9cbd": "Evo Speed Blackjack 1",
  "29defbf823ad7f7c3d717ac103f55de49d1fe275": "Evo Speed Blackjack 1",
  "465b0b3adcc30f6db17f1aadee4c16ab8dd546ec": "Evo Speed Blackjack 10",
  "f9e59a02144e6bbc974d6e2fbd1402f9268b797b": "Evo Speed Blackjack 10",
  "27f4c3bf5c96d404afbdfd1b7c1a928bfdfa77d4": "Evo Speed Blackjack 10",
  "87cd80c89461e2cc95be7dab6ba9ecfdab510f5a": "Evo Speed Blackjack 10",
  "0b80cce11065ef1cb92aae937c68f1ac3d1ca093": "Evo Speed Blackjack 11",
  "3c80ca177ce5ea6e7660db3d76c3f548155d9ccb": "Evo Speed Blackjack 11",
  "f5f7d73baafb61a4b943f87ed599b181dd1f7ca0": "Evo Speed Blackjack 11",
  "28a54636fb87e6d91b5fd6abe91d876d1d5773c6": "Evo Speed Blackjack 11",
  "f59ec0874e896b3ab5f6e661c31d8535d18d3464": "Evo Speed Blackjack 12",
  "fffb54a1098a1c8f6f18fa0d844f980b293daf91": "Evo Speed Blackjack 12",
  "29332974926bc9212489363c50b514f7a326fbae": "Evo Speed Blackjack 13",
  "38ece1fd33034e63db4f00ed10c9834128e51a5f": "Evo Speed Blackjack 13",
  "5d6d59b1b3f5992da1a9890f176c9ef81a8f5355": "Evo Speed Blackjack 14",
  "7c1506e16f760e05c8a461e3e0ab03effb839620": "Evo Speed Blackjack 14",
  "68fb606181af2da6ce9c5debcb300107f7257d9b": "Evo Speed Blackjack 15",
  "6a923338a8564cddc44b66aea236beec730450f8": "Evo Speed Blackjack 15",
  "a725c51fc86f349dd0f4e33406aa95e78402a267": "Evo Speed Blackjack 16",
  "d7cc8cc1e127fe6ed1dcdb4a98d700a97bd7417c": "Evo Speed Blackjack 16",
  "aaa891d27be1962e807ac2b2406044e4650937bf": "Evo Speed Blackjack 17",
  "fc59fbd058a6f699e29422f7540176534ab61a3a": "Evo Speed Blackjack 17",
  "5a89475709ea84655e54034a6a61f94aacbf755f": "Evo Speed Blackjack 18",
  "e65e5c6219c08cee4f540d8acdbcaceafcf74aa2": "Evo Speed Blackjack 18",
  "a07158b0c99d69ba5f92fd756bf205d1139c5083": "Evo Speed Blackjack 19",
  "bb902479741a6d9ad9b472f49a339a4a3ccd178a": "Evo Speed Blackjack 19",
  "930d6f3491459f9a1af3dcc1460006fa17c8163c": "Evo Speed Blackjack 2",
  "c988dc56ffbc129106aee5725fe479d4d6879115": "Evo Speed Blackjack 2",
  "78e2b0f5b7272b6bcaec594b040b9439330a9d35": "Evo Speed Blackjack 2",
  "9aea02c09a6d625f27c8147fe8fed7feff4f1ceb": "Evo Speed Blackjack 2",
  "703b63095f747ad13c0b8e41b8ee553c103160b2": "Evo Speed Blackjack 20",
  "b97098397bafad193a29ef7ad61331bfca83cf0f": "Evo Speed Blackjack 20",
  "a8243806e0ec0bd05f037ea28e2c29ca1827a397": "Evo Speed Blackjack 3",
  "bf392eb5c29942b20483f84953e36ff4ed43a7c9": "Evo Speed Blackjack 3",
  "90dbce7b5d842343e85f13533f620e8145e746e9": "Evo Speed Blackjack 3",
  "2c81f990874710557e9e74a4492a9d4f9745e350": "Evo Speed Blackjack 3",
  "30f5c4c1c4a45c3265a4c0057819512f6f653b4b": "Evo Speed Blackjack 4",
  "a88d46b2331fabd13cee6e6d52817f3f11adc10f": "Evo Speed Blackjack 4",
  "8be97e06f61614ee1f9d517a0b24412746ff6d0b": "Evo Speed Blackjack 4",
  "85a6e1664afbbb80c41cd5d955707f3f76fd7df4": "Evo Speed Blackjack 4",
  "7d0cb865765345e70e6c32d6cc080e925da32821": "Evo Speed Blackjack 5",
  "c352f9fba21664b1a464c554685cf504a4379287": "Evo Speed Blackjack 5",
  "f9badca5afb2037c869edfaf4458df85aca6fe45": "Evo Speed Blackjack 5",
  "72161ce91c3dc02fd3c7585179ddd6d18afde775": "Evo Speed Blackjack 5",
  "440c963e2c2acd0f61fe777d8482128c81de3cbe": "Evo Speed Blackjack 6",
  "9bd6897f58117bc081d9409a3a3a34757ce87b7b": "Evo Speed Blackjack 6",
  "c611b223ae760ee6ca8383b8843f1ccd4cf205e2": "Evo Speed Blackjack 6",
  "3d0595611bb6062b7cdcf7b45df65268f7eee271": "Evo Speed Blackjack 6",
  "7447fdb42e688b8d15e18f7e9ef79f4a4d2a986b": "Evo Speed Blackjack 7",
  "fb1a612336ae5400690e15add5946ea202276ea9": "Evo Speed Blackjack 7",
  "43d0e369aabc85e77e7284407ea9bac773a6440a": "Evo Speed Blackjack 7",
  "e3bc00134f1a545d5018f599df6fc5bfc8af22d8": "Evo Speed Blackjack 7",
  "9fde87962dcd9650e4b64de52fac64f55af07f2e": "Evo Speed Blackjack 8",
  "cea86d05f78e5a52ad11f24c64301c6c58ac6cdb": "Evo Speed Blackjack 8",
  "648b140c737127a75a129461f308a6a23628557b": "Evolution Baccarat",
  "d257cea1e6570931ab10b1e7ca41a31bd98e47b9": "Evolution Baccarat",
  "73ecb36ef50477c2012215a9dcb4117332c0d9f5": "Evolution Blackjack",
  "954b24343e9cb3d9c2d0ef63eccbc6c9502933b2": "Evolution Blackjack",
  "ab8f163435fb72a0191b097c9cdfff656af3fa25": "Evolution Lobby",
  "f52fe6545b538e3d0c6341f81f100977e541f0f2": "Evolution Lobby",
  "06748a9c962ff60447b839c4fb69685777b5b7a8": "Evolution Poker",
  "ad877ec4f1bbdec1c2b985fe25a0a34071ded3b1": "Evolution Poker",
  "1dd44385d9d5e19f60b81ac6e621c31fc2123207": "Evolution Top Games",
  "6fc8a9c9c1e378946254a3d53507147a93ef7335": "Evolution Top Games",
  "a8b8dfaa89818f5bab1493a7652e3881b0629728": "Excalibur Unleashed",
  "7bd1e6937ac47159737c2251fc77b8e404da1264": "Excalibur Unleashed",
  "90d8d49ba770ca12c012c3ce477d305f296b86f6": "Expanding Wins",
  "cad7c00ad92581ad8a4201d5167745a72c00236a": "Extra 10 Liner",
  "4171155be08be8aac5a2c46f27910f09d9541842": "Extra Chilli Epic Spins",
  "cad4fbc1060ab955ea5ed87b43754bb677fa5041": "Extra Chilli Epic Spins",
  "2b53de3ab34a74c9194c5cf5e2ae0c2cc9d4b710": "Extra Chilli Epic Spins",
  "35273191a01315bfa230bebb176d7c2a79b8fa40": "Extra Chilli Epic Spins",
  "2cc65b9e3a0c8a4251a79946c8127a4037175871": "Extra Crown",
  "62ba61a32ba0b251d3bed3047a44da60b85bbe29": "Extra Crown Classic",
  "2e279b9ce7f67a867bdadbae61f4c781d8f73728": "Extra Crown Classic - Buy bonus",
  "cdd94d1a864fce2054226a9e6f0fc2cd70bca2f9": "Extra Crown Classic Dice",
  "d24cbf451527f58e8b99fc414e082b5d662803d3": "Extra Crown Deluxe",
  "260699147d99622d18ad3ae798130fe9af527a8e": "Extra Crown Dice",
  "048654ff2514ee49f66559836d397c82046e6b76": "Extra Gems",
  "239e57de58a82fc0b127f77bba910bb32726a07b": "Extra Joker",
  "e8f4f37a0a25b2881129f8681ff085500b8eaa83": "Extra Juicy",
  "d0417284019c8e34636c298983e862cc7eb7e574": "Extra Juicy",
  "59a002b60b32e11621501c46f6f6d03ac5d8cc25": "Extra Juicy Megaways",
  "334275b0e8c35669be2845d0ea06a40bebca1e0d": "Extra Liner Jackpot",
  "fdafec3f4560f2dc68e1ab2d0b58baa4cb6c634f": "Extra Stars",
  "29397dab5305cb944868d8fae3d15ba7802a0b93": "Extra Wild",
  "ff05a8f05b9f93d51072b8de7bba22ac97a9d186": "Extreme Dice",
  "0288dbad08e05057565b49f2f4572c8166ac7d3c": "Extreme Texas Hold'em",
  "d3f12d3508015bde025df4bb78d241c60e8955fa": "Extreme Texas Hold'em",
  "78ca3a0229027911c156f1d086b27fa2b9ef6596": "Extreme Texas Hold'em",
  "c22dad6431a21a2b6a345b419763ac8b10cf66f9": "Extreme Texas Hold'em",
  "6c487ec0616d3be25a3f7aef1b6dd36b95f78995": "Extremely Hot",
  "dfe1c31b5fd33156868d7f59ee29a21cb265c0aa": "Eye of Anubis",
  "2c226bb0d1e8beb364460fbb9ff6d50f0f7ab9bf": "Eye of Atum",
  "73049166ef507eba4791c6190217481ff2153519": "Eye of Cleopatra",
  "8fe367b86f55ec4cb4c7ea5e36f88262bfa31da6": "Eye of Cleopatra",
  "99de49941b3fa00f4bd53e974626472a2de819a4": "Eye of Horus Luxe",
  "0f8dc9554e7253bd37d606cb6ebb5243a21c6eab": "Eye of Medusa",
  "d238eb4f83bb0d18f34960b37f9c17c019386636": "Eye of Ra",
  "e2e09e1373a0e9f6b221d74408875623339f29cc": "Eye of Spartacus",
  "0c4b8f6664fa3e0ceb2a696538818a3905c25b76": "Eye of Spartacus",
  "79aab8d54009ea31320aef002ed6ccbfdda7099f": "Eye of the Kraken",
  "561a95266e2a5942915d38d5eabbcb01424f8ac3": "Eye of the Panda",
  "3f36c340c77018fcb6b1f229d87e4ad381ecc5a7": "Eye of the Storm",
  "bc1bdeda699f3a34e64e2d5e184ba4399f52b43a": "Eye of the Storm",
  "738003076f06b2fc73c832a9108d05954d3ef5f1": "Fa Cai Destiny",
  "85859dcd40c21a67ed87f7712d011d4d07d1ee8f": "Fa Cai Shu",
  "c4ead4e804cfba6366bd7e80aa2a97333923fbbf": "FaCaiShen",
  "dbd228319ca4509389ceb51d50be32b684e0aa51": "FaCaiShenDeluxe",
  "bf2d87c5c4a06a804e6c470ef7e46e54f9d262b4": "Fairy Dust",
  "ed7733a4f4c9fcdb27143e3d8b1e6f51b03ac099": "Fairy Forest",
  "02c395b2a4101a52ac4af7f8d76a6119cae5411c": "Fairy Forest Tale",
  "1e0dd1977fe31cc627bbf5cd7b8de66559a0d20e": "Fairy Queen™",
  "504245cdf85adf59e1a050b7ea44f702b266ed1c": "Fairytale Fortune",
  "b37b96aced0c3261ecde4b2d9f5d0566c5a39684": "Fairytale Fortune",
  "b316c3030a06d24b726f516f865618c333d75e30": "Fan Tan",
  "defeb1d185a6939f791774cd37ec9c06998e2874": "Fan Tan",
  "a5a57fe2474cc74301dc64d4e09db9819d9767b2": "Fan Tan",
  "593aabfad4630450808573439dbd170048cae8d5": "Fan Tan",
  "b0600da70c3ac45b4804892cbf4e5db5884b9f48": "Fang City",
  "89ad9d2c385e634f5b4de1c62b49dce4b8855431": "Fangs & Fire",
  "ca9a6ab614447f1e9c721a195eec0ba7243ad4e2": "Fangtastic Freespins",
  "5f79b36df81ed7adbb8616e43a3a000a52ff33c6": "Fangtastic Freespins",
  "5e124289413b242279baa3e27bea39b951dc8dd2": "Fantasy 777",
  "428bafebc29722fb88dbfd564eba1ee43dbfe641": "Fantasy Circus",
  "0b7434bd39893a9e0ea9728e6d0478e82b9cda10": "Fantasy Dragons",
  "5f26f62418f98b25269a53478770036d9824bc57": "Fantasy Oktoberfest Buy Feature",
  "dfbf610c6e5976795a91d0e8da3b5ece562d23a8": "Fantasy Park",
  "4c6c98db6b3056f19961047d19faf0111767b4ea": "Fantasy Universe",
  "11f634dedf6653eeb24aa74d0f264b2928886b24": "Fantasy War",
  "18b1324f8e8578d40f6a644f79a49134d52d849e": "Farm Mania",
  "3c239414c44cfb32d79d49080bb5ed32de735341": "Fashion Bones",
  "5b00daa76a0af65ded8ad169bbe55079e629a250": "Fashion Life",
  "ffd3730b0fa165e127592973fa0d15156283775b": "FashionTV Bank: Cash Collect",
  "4ba80636aa2693b899609b635212e0931409947d": "Fast Blast",
  "790c5e10b371aa460825b899df6e6b795fc6fac0": "Fast Money",
  "e8b08d31c2ef76a65d595c79398f3ff22cd5cd85": "Fastbreak",
  "5531e5f44b5785c14b63e395045956a57d116cf2": "Fat banker",
  "a8d95ac628a41df3ec3e158f2e66b65a03a69c39": "Fat Frankies",
  "65f3d70ca418c7f53253037f6cf27cde489c009c": "Fat Guy",
  "1b3ff40673a25b9f7869307f1c9b78e6d9aa7dd5": "Fat Panda",
  "74971d747a2b5ceaa1eebfaff6a4a313d4b5cc97": "Fat Panda",
  "827c7b2ab1f545a0726308e7b5caf10d0847cfb6": "Fat Rabbit",
  "6ff2f810b900a2e36c4bc7436979fbea9d62b9ff": "Fat Santa",
  "c0efb9a01d9a087b4b58c12d13b216d7147af8e9": "Fate of Dead Blitzways",
  "c86f6783981fa19b2fe5cbe45351ec20655748aa": "fate-of-fortune",
  "43721da1228c95ca0977753a105a566885b49266": "Fear the Dark",
  "1ae0bbf0c285262184276805e014ab4087c66301": "Feather Frenzy",
  "df288b3f5117c842538dd796a90c0de40c114f3e": "Feather Fury",
  "c289371744571af20fa1a3d316c748b1618ed9d0": "Feel the Beat",
  "450fdeaa9a931b7e0b41f116dabf88204a589750": "Feelin' Fruity Win Ways (Buy Bonus)",
  "fa747eecbcdcc9e0c241f0ccaf23eb6c9f89d4ad": "Feline Fury",
  "57a63e143c16f6f55d7d062bade9a6705795c1b8": "Feliz DÃ­a De Los Muertos",
  "dbad5f0ab4eb532bd7654f3d03fcaae5c3553b50": "Fenghuang",
  "9f3536e2c4e71c572570f409fe0c6ab7624efa13": "Festa Brazil",
  "62bbc82b06c2d88d9ba43efd4216c0eaa7fe9229": "FESTIVAL FRUIT DICE",
  "1b6eeb4b47a29b3c931e3472188715692cab4b11": "FESTIVAL FRUITS",
  "92515643cbbc05b92b4cf17390d3186be80710d1": "Fiery Fruits",
  "e19e852c97de529d6f5b48ef18231e517991b2eb": "Fiery Fruits Frenzy",
  "9e79ed1928fcf41a03bc82a30017518816c52005": "Fiesta De los Muertos",
  "19cf3355d51fb16d56201ea891a549de34480737": "Fiesta Fortune",
  "2c4dc3f5e4602de9df89ef45fee3c692a23a38f8": "Fiesta Fortune",
  "a57520f27c7a1f07762d462a8dba70366363a8cf": "Fighter Pit",
  "bed7a8c6244d2e415fc7c006800a7dc398c502fd": "Fighting Girls",
  "8dd5660e316cc3f16e649f9f81f8f491ab5f5567": "Finger Lick’n Free Spins",
  "f9cca37ff8a5bd47a9495e36798823ab3dfd8e6c": "Finger Lick’n Free Spins",
  "2f4895f11cf5182a32d8e8bf1f6f7a162a9792b0": "Finn and the Dragon Tales",
  "e7f5bd286d492c80bea0398960dce58b55119f2f": "Fire 4: Cash Collect Quattro",
  "1b3556de86b1db68bd36f6803ffa5e755d0d8089": "Fire 88",
  "3598024a65fc328a255590265f692bb0b6c11740": "Fire 88",
  "62a3af2cc852e0a0c2818cf93faceb787110d49b": "Fire and Ice",
  "1a3493c26fe874ca8763ea35c3f277817225b625": "Fire Archer",
  "515942bee494143bd5a0e5a357a92b5ea65a1a3b": "Fire Archer",
  "5ea212ec29e5390a95d037e7e71fd0e84bb046be": "Fire Ball Roulette",
  "dac68bce5b334ab01289445de9e67129d03cc8ad": "Fire Ball Roulette",
  "8b3c4baf82a7426ddb5047140b59c51636b58758": "Fire Blaze Classic Blue Wizard Megaways",
  "d707f786e7db4b756b2f11340c02e46af2765090": "Fire Blaze Golden Amazing Factory",
  "0cebeef1e73064a69039e642d083d048cfcca982": "Fire Blaze Golden: Buccaneer Bells",
  "ee77e49bfef59ce753aa1dcef7b1abdfb087188d": "Fire Blaze Quattro: Celtic Charm",
  "6e5e7147747d4d890890b79a752216aa31faa166": "Fire Blaze River Empress",
  "4df02754f55ccdfd9d284294e9b29e5cc18d8871": "Fire Blaze: Fire Fighter",
  "904b3fd3dc92d9e89ae8d55e0540b187c0eea32e": "Fire Blaze: Green Wizard",
  "0f1d3864c5baeee7498c95bc171af93027c4c8fd": "Fire Blaze: Oink Oink Oink",
  "dfb4356d4df3f1db17f569dd987ae6e4ba7c9732": "Fire Blaze: Red Wizard",
  "76626c762dfc9ab96cf3636a65a2aeedffd7aa77": "Fire Blaze: Sky Queen Megaways",
  "ec6b1d494588027664cefd269e495ae4a0a80cd8": "Fire Blaze: Toltec Blocks",
  "65cf8c74ddfe10e155b41091803577ed2bf59721": "Fire Blaze: Toltec Blocks",
  "dd208d99e1ef48ea17e47786f9602f9c3da37f3a": "Fire Blaze: Tundra Wolf",
  "81179f06383acb41327db301e09771cbf27d4287": "Fire Blaze: White Witch",
  "62e0bd387c284f46134b03a3b57d035ba3ad6bb5": "Fire Burner Classic",
  "8dab2e84c190ef958789f0e01e1d92a322e163bd": "Fire Corrida",
  "6dc12f396fa7bc10010311fc85e0d753da8a7a6c": "Fire Dragons",
  "0c65f2af04f70ef68b4b575970410ba414ebcd00": "Fire Hit",
  "4d2d88dbe24d2fb090daa680fdcf532dcdb8d566": "Fire Hopper",
  "db4d0c9e87ae564d8a00b8043eafa54f0c4c7792": "Fire Hot 100",
  "f7904b260479a36f392ec7f597572943ea18fb2a": "Fire Hot 100",
  "48b0d3f4ead2504b6fce22d49e8bdf316cd2e73e": "Fire Hot 20",
  "e422a83ff5dc16991e769c0e7b486e4b60776211": "Fire Hot 20",
  "d8ffa0fabdc9dd65fb526a3443ac223d3ef11fd8": "Fire Hot 40",
  "4839f73a6096771bf930d7bdc169b572cdeacddb": "Fire Hot 40",
  "3af547444914b7428f656b082e8e1eb4f6186fb3": "Fire Hot 5",
  "9e7bb7027e3db77279ea6cd0425820ebcc4fafca": "Fire Hot 5",
  "5e200383feeaced4ef8c4960b2ad84e3eea5a21c": "Fire In The Hole",
  "9e795232dd2a6839f43f4c16430328bb239f88bb": "Fire in the Hole 2",
  "476958b96c4d5e58f2fc3fec1f13945ef8cdb128": "Fire Joker",
  "55e3cffd55be88ee858b8cc1ef71d9026d0447de": "Fire Joker 100",
  "1da3ec22a3a498582d9cdc9f741fd25466f0f434": "Fire Joker Blitz",
  "99cba1df924eb26c26a0b7fb57fe3e5839835055": "Fire Joker Freeze",
  "066682c7dbf20e834468d60996980c024a1d4f72": "Fire my Laser",
  "0d440f79be663570e980d0294464887870a972f4": "Fire of Egypt",
  "56bd120e60cf92ea85ddec35b6b5329b0a6a2313": "Fire Phoenix Lock 2 Spin",
  "6ce928fc5ec35069f2aeca12a8c3264b6c9d12e3": "Fire Portals",
  "0f691da75ece3c4c5fa7a63bcd22bbf466af76f3": "Fire Portals",
  "418a7301355ca587185af1d639960e6d0399e9e3": "Fire Queen (Amatic)",
  "03a6d02ab714f2917ee8aedb8845179992bcd240": "Fire Stampede",
  "db865c7a93b29996e8fb9bf466beeab8dc59c770": "Fire Stampede",
  "56bf86d6d82e1dbbc3284d1d7095226384351ce3": "Fire Stampede 2",
  "8daf07fc5a9ad23279824f0c0653dbb3ff9fd232": "Fire Stampede 2",
  "2709cc525a3684d1c5ca5f2d39be8f5bf86511a4": "Fire Stampede Ultimate",
  "5320d3fbdc2904a9b3f4e34cf3b0b58d0e79ba76": "Fire Strike",
  "58e93f4bf3f9f961f35cc18c189a7c710b2fcad8": "Fire Strike",
  "f0aa42b6d72c8d238be0df1c87ce8e8e98740d2b": "Fire Strike 2",
  "a1ae402b8a6c96d703c4f6102d4122c622fc4a9b": "Fire Strike 2",
  "7dd4482460ab209d02c819bfbc2a054e9ae0bc11": "Fire Temple: Hold and Win",
  "f7e52686632c6123d9c481f65ea937eccdf5b798": "Fire Toad",
  "5757abb70b6643584c26f4076aacc0a9a78efcaf": "Fire Toad 2",
  "5e255d3c8c74f4d0ef426fd5d623bacc96caeabb": "Fire'n'Frenzy 5",
  "0e0899124e8492e5262c13b06f5c845f0c546e89": "Fireball Roulette",
  "90dc692e47603c1ba4600f41860aa353b37079fc": "Fireball Roulette",
  "73a81fb27b8e478d9fccac3de6d2915b01a57066": "Firebird Spirit - Connect & Collect",
  "d0644aa0a06f81c34a0ad0940b856a8d9b1b0364": "Firebird Spirit - Connect & Collect",
  "f1da55b8acb14fd2270735642453ad8e5947394b": "Fireborn",
  "cfd010468c6b2579f595fee36730a932b2d684ca": "Firefighters",
  "6265ae0b0defdaf6aca525b07bf3af4f8d61e851": "Firefly Frenzy",
  "24d2211d7cb195d017bbdbb7b9f29620b0019251": "First Dynasty",
  "f6d4ba3a6e6ea0ac22aeca59c0a9d8e4eceb98d2": "First of Olympians",
  "3901506ab83844adea2824782850013b8a464fcb": "First Person American Roulette",
  "e9e6569e42cf10ac28846a6df91652c9180a7409": "First Person American Roulette",
  "9040e245b72a5998b68e581a24a87dfd84fe0ef5": "First Person American Roulette",
  "404cc9db0943ef0fe3a150dcdc0ecdcf35c4ebc0": "First Person Bac Bo",
  "fab956550d55d30d3ccabab73c829c0ce74d4a5a": "First Person Baccarat",
  "fed59e55f4c5172c6107d32b0dd7a3bcc00bc8dd": "First Person Baccarat",
  "4f0a00251541eda2e2ee87a98568fb169f491451": "First Person Baccarat",
  "324150575c16b659f6265478473e5462a25b0dd8": "First Person Blackjack",
  "725968052bbe463d99f0cdf248c656652217fe68": "First Person Blackjack",
  "5c7059a41e19f6a66ed5dd285f13b3084354c324": "First Person Blackjack",
  "47feb8a288db247b0cd622cdf45b86c36cf8a0b0": "First Person Craps",
  "ed30c43a1132a3da2e8a399554f94554a17ce0e2": "First Person Craps",
  "24095c41edd61e496b2fd6c4c065e0fea6daf2fb": "First Person Craps",
  "2667a80f1ffada6d4f45957d74077c0cd8be5d34": "First Person Deal Or No Deal",
  "a14aa3eade263df9d400ef32b666758ebaa2bf30": "First Person Deal Or No Deal",
  "0982a397972205b58b89fcec11869522b358aaed": "First Person Dragon Tiger",
  "af3a226fb1b7f4e20664637e8f0ab7f2c7a06837": "First Person Dragon Tiger",
  "2e270622a9dae0ff9edfe5f7d942db8b47024563": "First Person Dragon Tiger",
  "adf0b010df00a5b318ac4536ed4393c00200516c": "First Person Dream Catcher",
  "f3471a7bd3d319c188a0e36f7c5d28aaa27e7618": "First Person Dream Catcher",
  "18f1ff1201dde0a89dd1f635d35170ebe69fe4f0": "First Person Dream Catcher",
  "2fec45f358d0bccfc0da6979490ddd5e58b2c32d": "First Person Football Studio",
  "e322a20b12e915d571c9fdb408f72c0edab7ae28": "First Person Golden Wealth Baccarat",
  "f88733bf61a7a9072e42fd9ab6aa04ea8d194886": "First Person Golden Wealth Baccarat",
  "36282f8eac1dadacc1eb1179ea1980ac501af207": "First Person Golden Wealth Baccarat",
  "167b7afb5404872ffda757e1c5a11a9c306641f4": "First Person Hilo",
  "f0da3376500adef514463eb0c2dd6e0d94812b77": "First Person Hilo",
  "7641b8356cfc681c3894ee174bed39419c6f5175": "First Person HiLo",
  "445c759b3788bb86e2830cc6ac1fc8ff9459f141": "First Person Lightning Baccarat",
  "bd80baf553e2434e279aaa31e8148a6f64940eae": "First Person Lightning Baccarat",
  "73d285d1cc37518d806aa44018cd4341a06722f5": "First Person Lightning Baccarat",
  "4c1a6af079a8eca98b07cce6969694f2a93bf850": "First Person Lightning Blackjack",
  "73bd83c1461116882bfcefddb6ccc42387e18a65": "First Person Lightning Blackjack",
  "225e725a2fb529565e58326fd0a7dcfb9cd88894": "First Person Lightning Blackjack",
  "118d6e8fcdbe4b46255ecb4fc42b3f4236436fce": "First Person Lightning Roulette",
  "1cf06943df9855ed16a47ffe766737ab67bb86fc": "First Person Lightning Roulette",
  "29519866a229640303308058ca3b7afdb778c3e9": "First Person Lightning Roulette",
  "b10ebf7bfe38281913cf099992c0ab05079f5764": "First Person Lobby",
  "1ad7475c8bd6d244bfcd2031ce811ee6a49f90ab": "First Person Mega Ball",
  "b38392aba3cb3fdd736fe5618b65c12cbc1957fd": "First Person Mega Ball",
  "b319f0e81c0a9e3873522dc734398f16d35beaf1": "First Person Mega Ball",
  "3fe0093ec24cd7725febba129bbe3ec5fa3a4033": "First Person Prosperity Tree Baccarat",
  "d1189b5af1ef49e96788081c1f5296f283412d2b": "First Person Prosperity Tree Baccarat",
  "cad79a9b3a02a4facb5d335ca3fe24d3ee2ad414": "First Person Prosperity Tree Baccarat",
  "6ad7c091d221879ab2108750aa69db22bac8511a": "First Person Roulette",
  "8d7039f9c28cc4d59a0d922078bdcffd2a446a3a": "First Person Roulette",
  "9815f2957bafd37be555cc6ae64ec0710df8a4eb": "First Person Roulette",
  "b8c8671d351b8d019fc9f8e05689215e48ea2c26": "First Person Stock Market",
  "1682a38eaed22a4d6b556ff37d577baac534b900": "First Person Super Sic Bo",
  "7f30c6d46ee67e91f13946d6a6e0249aa649b437": "First Person Super Sic Bo",
  "f9e8337f94dea12e5b35f0dae5e6148efbc8c1e3": "First Person Super Sic Bo",
  "7825d4cec9a98a86b621ad7f72029ca17dff5321": "First Person Top Card",
  "b9dac22809892cd27ee12bb94aa0604e3747b52f": "First Person Top Card",
  "6bbd58e2555965a64edd735e60022fa1b4cdd3b1": "First Person Top Card",
  "1c27a5945123126e2d5eaef4efd133a395dba857": "First Person Video Poker",
  "d1465d2bb3a352f5c04f33ea7197a824884be3db": "First Person Video Poker",
  "7fa7e7518e268a53d4646325ead177506ebba4d1": "First Person Video Poker",
  "727feff270fb55028def4ae4416b29a5e6ab98c2": "First Person Xxxtreme Lightning Baccarat",
  "bbdb43905d9739d3b9ae5cc192f35492436d1c03": "First Person Xxxtreme Lightning Baccarat",
  "c5a907343171c161b04497af93283723ef91e802": "First Person XXXtreme Lightning Baccarat",
  "ab6f61f1d6858ef5571361020e6d9ffc709b3506": "First Person Xxxtreme Lightning Roulette",
  "b19bc568a0554fe0bc8e19f8985d5dc52898e4cd": "First Person Xxxtreme Lightning Roulette",
  "e018b4caf18a677dad4fa7980a7e13d166ac0e87": "First Person XXXtreme Lightning Roulette",
  "1f4db7d956128d232660bf339e93fe507a9b5069": "Fish Eye",
  "8cd0c53876aaf4616c1f302d86f398785c9ceef2": "Fish Eye",
  "f2e9edc9c78d12359fd41967f25e11953be1b7ea": "Fish Tales Colossal Catch: Link & Loot",
  "efea27c788fe78d24cb9dd8e22741fac41370d86": "Fish Tales Double Catch",
  "8e4cc3cd3d7b117cebcac54fa8ddfb5022c2bd7e": "Fish Tales Halloween",
  "e0578eb46fcaaa0c04dd8ac302cbd31bd3895c25": "Fish Tales Monster Bass",
  "68b8f6bb25cefa04b261fd82e14467cf8eddda58": "fish-and-bird",
  "323d43e0a04063449a2fbaccfa952d37c749e75c": "Fishin Bonanza",
  "433bcda0de2b55ba0a445398754db6f7eaaafde7": "Fishin Reels",
  "3b5def187977c2d45c6a37e94ce532704c649b1f": "Fishin Reels",
  "f7faaee829608dc9b38b1536cba1f67e1399a2df": "Fist of Destruction",
  "acffc560336210355ae411e47ae6a9f30e8086e6": "Fist of Destruction Megamultiplier",
  "3ba5dd4763221ca63504cf3cf6188853e431687d": "Five Fortune Gods",
  "56729a193eec5d0b988344830dd013b60f89586a": "Five Sound Fortune",
  "af0aa7fc82cf1d2d4e7bcb54bce7d7497a9ecab0": "Flames of Egypt",
  "4ec7c2c167c11b06b1e2f156520b99c3f9ed5208": "Flaming 7's",
  "5b2ee75a578c4dcd21440214f45dffc72fba64e7": "Flaming Bells: Hold and Win",
  "bd2dad1cff38cd51752827be4d9e5317738dd597": "Flaming Chillies",
  "a5edb9724aa3ddd432262f4e57b39d4b8d67717e": "Flaming Dice",
  "b89cbf9389c1a13f421b2350834fef871a784fef": "Flaming Fruit Deluxe",
  "d72624bdb737289aeabe6f9be860f438de4041ac": "Flaming Hot",
  "5b0afb05eba0b92a2f42a405f512062667638bd5": "Flaming Hot",
  "0ae674340879432f82bffaea358cafb63acc4e28": "Flaming Hot 6 Reels",
  "b949a8267979ca10a21b871c3542431a1a90eab8": "FLAMING HOT BELL LINK",
  "67075cc172e7440c6931489a2becd217d393315a": "FLAMING HOT BELL LINK VIP",
  "a90e49f0c06fcc5ccd438896b754ba0af5cc88f8": "Flaming Hot Extreme",
  "e25fe8bcf13918760bb433102d81084a5c5efc6f": "Flaming Hot Extreme",
  "9db8a0ca7d607ef105144eea00762c213a87b98d": "FLAMING HOT EXTREME BELL LINK VIP",
  "29f09556aaf2a7c1cccc93aecca9842cd88fbbb9": "Flaming Monkey Classic",
  "2b4b30ef9e524a2a9abf7eef856ac32cf5cb6756": "Flaming Wild 27",
  "806b05df16996bc754a0a0fbb35dd45414a9f8fb": "Flamingo Paradise",
  "7f39d5f10cf29bf6cb1ebd476e675071b7a5e028": "Flight Mode",
  "a3638b438a382027ec9755d99e796affe9fd4e78": "Floating Dragon",
  "2876797d70351b0273246cb52f43fdb88c91e949": "Floating Dragon",
  "8b7549f726eafbb8a8777d6cad0bc5b610ef433d": "Floating Dragon - Dragon Boat Festival",
  "94da0e2a4afd933c9a074c7ef0b0cadffdeeb90b": "Floating Dragon - Dragon Boat Festival",
  "1008f18142766e95384043e28b63bd357a321f61": "Floating Dragon Hold & Spin Megaways",
  "cf90f0492f5094646c7a580ec4bcdf60bb9c492a": "Floating Dragon Hold & Spin Megaways",
  "53ecfa68ec4a103c3bb5169e335f0f99de0e1d20": "Floating Dragon New Year Festival Ultra Megaways Hold & Spin",
  "63b79055cb5feed8680a5384eb0755718be1a28d": "Floating Dragon New Year Festival Ultra Megaways Hold & Spin",
  "91ea969cd568b47721a9f424f17478062cc8b8aa": "Floating Dragon Wild Horses",
  "083cf13671a02693110b0874556fda3e77a3da18": "Floating Dragon Wild Horses",
  "e23f20ed2cc68dae19d4d03eab34e3bdae0bdb10": "Floating Dragon – Year of the Snake",
  "6492837683dd2d96481347ec098d9461b0a44a98": "Floating Dragon – Year of the Snake",
  "60d1a9a3835838e2018d72e367fe61d815fe9338": "Flock Me",
  "cce5af6994b5c24598164b1ddcd218327ac58914": "Flower Goddess Festival",
  "496cc812f85ecc61d08d5f28f905e608944e99b5": "Flowers",
  "9f30f28a54cd9835f409e65e14b7ae664690f511": "Fluffy Buddy",
  "11bab709c95956119733c7114e12d9e5b7a5d126": "Fluffy Favourites: Cash Collect",
  "b522526b44e939cecfb856416154be33b08a94fe": "Fluxberry",
  "49aa1e74fdfc87d7961327271dc46fe7b0815e10": "Flying Pigs",
  "6e53ffcfee53aa5095da65c6cd388ceea92af1c1": "FlyingHigh",
  "e8213b8a6fc3089a77955969353941220cb2d418": "Folsom Prison",
  "125c4e8808003c054b2c5869c18eb69d8ad0ec94": "Fonzo’s Feline Fortunes",
  "b5f77d58679373f07f7f4d4acef59985f6537c2c": "Fonzo’s Feline Fortunes",
  "b0952ab049ebefaaec1dcae3d7168fff8faa2faf": "Football Baby",
  "2b7e1f5e57fe9552508000ea97108859bb29ea92": "Football Cash Collect",
  "af86e294566e3eee0e500a284364407000e47dca": "Football Hits",
  "219aa293ff8dc80e0b52047a04a1350c1f50fb18": "Football Mania",
  "c0d628601684b0498f37aa6a5649db9ad60f351c": "FOOTBALL ON FIRE",
  "22e707a7664b46972fd834207ca7f17d310a5784": "FOOTBALL ON FIRE DICE",
  "dfc9885156de6fab3a3506af1a406a454b88fd09": "Football Palace 1000",
  "c835b6c8fa4f3d7abd8c1364488a48c3fc58d050": "Football Studio",
  "d1117b35b59ea851f1c7532ef76dbf09a3ce9d2b": "Football Studio",
  "9cd25a834843bd8f620ed33beb5952b08a54a69a": "Football Studio",
  "157501a137e155eedac0c133639c00ada5e2cc50": "Football Studio",
  "73a5c082e7d40cbf722aaf54155549b8ae28e1b5": "Football Studio Dice",
  "8a5dfcc3b3fb2492ba078fbe9ab6992f6fb11984": "Football Studio Dice",
  "e1f5f0fb6c54a50c0deb6d17b94deebaaffe7c61": "Football Studio Dice",
  "0f2834f9bec4488ac8f99a6d3d7f65baa31ce71f": "Football Studio Dice",
  "2d0efb0c7804ba19dba68dda6edbaef0aefc95dd": "Football Studio Roulette",
  "7496055226912db31567b3bfa943343350a523be": "Football Studio Roulette",
  "5a245e43387c8a1f3118d1e8be6d14e6011b3380": "Football Studio Roulette",
  "7c468c226628952eff6fd7b805d975966a485fd6": "Football Studio Roulette",
  "c29ece6af81b74216b59110ff2c81f3b4b661f18": "Football! Cash Collect PowerPlay Jackpot",
  "a553727fcb7f0030ccc6b33737c609bd01cdce47": "Forbidden Princess",
  "77e543ca75d619d526d56d3e65dab8277b3f7d94": "Forbidden Temple Power Hit",
  "92fa1fc2494caf009b34e83c0ca5c7f40dd2bde9": "Forest Band",
  "a6a4064a33c2bbff760f06d395250a2acf1b88b7": "Forest Fortune",
  "982782ea122c31f9804ba15297547323e2c82068": "Forest Scorpion",
  "2182d055e6a4ea9a41c79bcc1b4cda9d47dfb863": "Forest Tale",
  "dbb3d2c7682e9ea7f63b657c21b9e4524b49575b": "Forever Hot",
  "edb838d36b1d0ba3e8a42fd37a463f9984c2a3dc": "Forever Split Megaways™",
  "1335dc8cfb07cb9cee90e6f3835e6350aaf10ca5": "Forge of Fortunes",
  "9ebec474d7441e13bc8e637e2b115bffd2b6bc63": "Forge of Gems",
  "7733609e0ab853decd568578b02f18b565ab569e": "Forge of Olympus",
  "4c7c260042729b124e3ebf7dd63764b5edaeaabf": "Forge of Olympus",
  "912df702382b4dbddc786eb15784ed1a6ef29ddb": "Forging Wilds",
  "18a70d16044dab7cf697f3a7b6873eac8aab7762": "Forging Wilds",
  "01c84b95c5d25c5def66091af0e0f3e889a11e8c": "Formosan Birds",
  "d8b5fc2d9c0c9166178bb60316ba204248f556a4": "Fortuna",
  "718c5a88a3f2a1f444bcb742688b56fcdfe9380b": "Fortuna's Fruits",
  "cabfc7315f6a2304b440108724ea099537e333b9": "Fortune 6 Baccarat",
  "b53de7b1ae0ff42bf56bb72b281b956f1d95bcec": "Fortune Ace",
  "75117d6b2214d491da415a02865312e154faa1c8": "Fortune Ace Super Scatter",
  "af6ca5c3509d1fe6b9f84e891a0f23f6e0725029": "Fortune Bags",
  "0f43ad47e238719028dcfd82ecc3c8978a21cde8": "Fortune Beauty Megaways",
  "8f9db03f163e7e2b2a261ba6fb45d38e274c9200": "Fortune Bros",
  "a4724f8fd22a59a62e383678a5de20b651cb3985": "Fortune Coin",
  "730a85793b13576170ca90912db0556202c0cb91": "Fortune Coin Boost Classic",
  "75b7c6571d910ee7757608417ed99a27fc1c2552": "Fortune Coin Charm",
  "458badd6c0a980610a0d5b40c6896a0b19ee2d39": "Fortune Coin Fever Spins",
  "949c04a58e1fd8c1b300dbf5aad01645f0b3fb64": "Fortune Craft",
  "d0a2686767948941db59bbfbd7943541975236e4": "Fortune Dice",
  "56a32360d9b963a2b43baf63e1a7708977824d1a": "Fortune Dragon",
  "e5433aea49eb936133bc31dd11a7355747a3eae8": "Fortune Feast Fusion Reels",
  "a7bee2e8bdb0318c05297e14704988d5b182ca3e": "Fortune Fortune Thundershots",
  "e0be0dbeafe3cbeaaa1f44370f5206962725ea92": "Fortune Fu",
  "1c5b22ef0b1b1b1b586fb536304182a940679d0f": "Fortune Funland",
  "af0a0d50f8a368787364a8179465941e38964a57": "Fortune Ganesha",
  "c08f5a0c4871f8ed78b2d0a6502351c094c7d0f7": "Fortune Ganesha VIP",
  "0d971ef2dda28ee19e21a292e2ae475cf170b499": "Fortune Girl",
  "a4966e424e95ac9285de2f1772ace9ac10183e62": "Fortune Globe",
  "2e6272168a32e22815f5a1f709087a166077a304": "Fortune God",
  "5b4a89154ec512c87f735429a3312682a273214a": "Fortune Hammer",
  "d98269da8599cea37b94219fe58ec41259fea464": "Fortune Hit’n Roll",
  "d076d6349da2dcf36ed8e643198bcedb71a99664": "Fortune Hit’n Roll",
  "70c9a2072cd43900a7e98a5f5626437821c258f8": "Fortune Lions",
  "2694d617708e2baea2136b38104e66298a3d3fa9": "Fortune Love",
  "7a6de7718db865bfa0c439dd7a982f42dce0fb1b": "Fortune of Aztec",
  "ec638cce77323d94549077a4d1f3b14c6335c3be": "Fortune of Aztec",
  "42bc52f17402929311c03bf32df29ec54796cd03": "Fortune of Giza",
  "72256913e2dc0a241300bf58803148b6741ed079": "Fortune of Giza",
  "a114818ee5353ef43bed920bd59de8ea81b458be": "Fortune of Olympus",
  "64fbf44d8ab4be486d05bb9ed5a314e87e5e9fd2": "Fortune of Olympus",
  "b7e684420158a0b2765fc3af69bb6d132d51da7e": "Fortune Pig VIP",
  "683d72f863ef4d566e88c59d00526f995e2d8d21": "Fortune Piggy Bank",
  "223b11866cc2889d9a690a506d2d32c4af88ff9b": "Fortune Rabbit Lock 2 Spin",
  "2e01a06bca565442e248dabbd9b8e9f2146b9fdc": "Fortune Rewind",
  "cada8cecf278a36b1a769ae94531f19b58d99371": "Fortune Roulette",
  "5a3d1083cecb41e65018db73d5b49607e92e60e0": "Fortune Smash",
  "9b6c477e1dd3813ddc1b945a8ce175a23f666d47": "Fortune Spells",
  "0c8b10aa273b885bec8ff11675e1b51708127fdd": "Fortune Spells Buy Bonus",
  "fc67df8e96c50a04c406aa918cd9098722b40db8": "Fortune Star Lock 2 Spin",
  "aa01d54a3d53efa9e2ebf647616dab891bf1b747": "Fortune Teller",
  "435fad1ba12e20e60b9c0950a1bdf25ac03f1ade": "Fortune Ways x10",
  "ea7e82b1f62e94cd6cce60eca547b69039f8a4d4": "FortuneDogs",
  "e52a02196b67803954c3aa329d5ef31c6015d6b5": "FortuneDragonJoy",
  "95d796dd3ebd8dfc7b751aa376aa94d1f8d939ef": "Fortunes of Ali Baba",
  "366ed9f2bbc91582f502c2bedc8264b9845cd70f": "Fortunes of Aztec",
  "62789e5af8a9d00c77bf9253a9abea547f44f714": "Fortunes of Aztec",
  "33a9dfc32191b24dbe05f0d3637cf4f629688247": "Four Beauties",
  "d446fb73bc87c2774f8f0b38c9eb1334ac7bf971": "Four Seasons",
  "78f1be41a5b958954aefa0ce92f82c747f8ee4e6": "Fox Mayhem",
  "666129e64b6807f244c5ee961020deb45026ebbb": "Foxy Eggs",
  "282eaee2e1c595310c70499ebb90022cc133b9d6": "Foxy Mama",
  "b610715a080d403ae5e5d28f39873999cd234f87": "Frank's Diner",
  "054f38bec58a43a250b92fc57e3cee8f44a6efdd": "Frank's Farm",
  "2ac166993d96f72eff372038210c6a12ee0f9b6c": "Frankenstein",
  "263ff5742b16828bf407c27b77ea7101a696cfdd": "Freaked out Fish",
  "d5c454b8d00516e495a607a5a72d46496fd90df9": "Freds Food Truck ",
  "9af52ef408e9c0c18122864e1a22b6590c7c7d0a": "Free Bet Blackjack 1",
  "c4dc2498a23b6ea1cc17d4295fd4d95520f0c000": "Free Bet Blackjack 1",
  "52efff223fe64847ab3033faf3599d7cced06ce1": "Free Bet Blackjack 1",
  "89563a54491cc840d989414f05d6738af6a6432c": "Free Bet Blackjack 1",
  "536d58d1b10bbbe19b0c027edee3881b47c25082": "Free Bet Blackjack 10",
  "904467f422e2db15e3f6e296c6f6a8cd5c586a2a": "Free Bet Blackjack 10",
  "ee117b02f6934fcc5c157485ff069505ec332de5": "Free Bet Blackjack 10",
  "77c04ccaa56702078603978c97bc2f3e70bb1c0d": "Free Bet Blackjack 11",
  "9cb206dbb50f4075b8bb0b01dd31d2b9af76e133": "Free Bet Blackjack 11",
  "c09bfa601bb7ec822c04df0e7cb5aa1320a8503d": "Free Bet Blackjack 11",
  "774bb0f9ccb168e3e3a4210d9fd30ef44f225938": "Free Bet Blackjack 12",
  "fab8daa66a3f64a0596af91145b22206f5edbca4": "Free Bet Blackjack 12",
  "1a684eece772d425fd42b762a39bc3385e11a662": "Free Bet Blackjack 13",
  "76c0de4f0e4c3b34e35759b25402ff1b73bdc911": "Free Bet Blackjack 13",
  "d010e4b9555b35f4c191e23f4e8631951ef3790d": "Free Bet Blackjack 14",
  "ddc0c0e7c730cc67be3590206d36de64659c74fd": "Free Bet Blackjack 14",
  "90a3cb30591ae1807e7354c5bf06c13ad7364891": "Free Bet Blackjack 15",
  "b78aefb5dc78eecf85d15840e38767f6ccc1c122": "Free Bet Blackjack 15",
  "1dbf16f2d34bd8aee93a84e49ea1d20446f98dd0": "Free Bet Blackjack 16",
  "9109b799272bc1eff2c3da1ab66530a76ccdb2df": "Free Bet Blackjack 16",
  "050b39bb0660f89bb8ce43d366833929bd9a00dd": "Free Bet Blackjack 17",
  "b130a86b1520a99f88bd68003259215a556faf99": "Free Bet Blackjack 17",
  "1592b3c314782ef9b4e6953278c018a44154579c": "Free Bet Blackjack 18",
  "5c3dc77a07490b50d0ade6f7aaa78db82e756ce7": "Free Bet Blackjack 18",
  "028918ddc6b016a3429deb250ccec09524e45da9": "Free Bet Blackjack 19",
  "3cd85800089d1c1b7a739d8031c0e2bc39ae789d": "Free Bet Blackjack 19",
  "60729cc201512e191fffe5b79169d407c6dcde7a": "Free Bet Blackjack 2",
  "cdcac33aa5bf9276632a6d518e9f7d70acf60b5b": "Free Bet Blackjack 2",
  "89932c6d1d634f73b878cb949c7037a7d0fc3e09": "Free Bet Blackjack 2",
  "6ece1f8c72b703c1cdcb6c9d391eb70f31c29cfe": "Free Bet Blackjack 2",
  "6f469683525e5b49b566855c568b07691ed3d857": "Free Bet Blackjack 20",
  "7935044f44ec7878d3e3e377025ff7040727e68c": "Free Bet Blackjack 20",
  "117b63c96af04909e2f3cc04a98bb7ba527d124c": "Free Bet Blackjack 21",
  "8591841f0431980c51206c8a886656c1044545ce": "Free Bet Blackjack 21",
  "a6bf423b81e51b134a549a24a8c0213d10831a40": "Free Bet Blackjack 22",
  "e73c09cccffb189f989614cc763da60b8cb01fa0": "Free Bet Blackjack 22",
  "4e5c32131857c6d61f07ee4f9a8d52365c4febb2": "Free Bet Blackjack 22",
  "ba8d2714a37be9283f22bbe41a5c7c0e5630cb4b": "Free Bet Blackjack 23",
  "dfd79b9b91413623455cefa01893eab471e9f0d5": "Free Bet Blackjack 23",
  "dc4270f2a8ffc2cb0b8705c27aaa45eda2e1382c": "Free Bet Blackjack 3",
  "f684936f3764b2f3d22a3576b6a8ed4b627066fb": "Free Bet Blackjack 3",
  "c77103c8541052bea713df2fc5b75e20d9e14bed": "Free Bet Blackjack 3",
  "165dd0b0cc5279f9dc2f01cce4aaae3a45d0966b": "Free Bet Blackjack 3",
  "52e79a9732a9368c85f489cdecc778b59320eac5": "Free Bet Blackjack 4",
  "e06f932833c94c862e598f49bd8dd3d7376aac64": "Free Bet Blackjack 4",
  "e77844d522b4330a462fc38ddf63fc1ea3fdf581": "Free Bet Blackjack 4",
  "442afd2c623045d10ef3342904d7278fbe4ec543": "Free Bet Blackjack 4",
  "0ffece90a5c0362a8a3979d2dc75d14f1f292e14": "Free Bet Blackjack 5",
  "119fd44a36ba3c224142163143f84f307ee25fec": "Free Bet Blackjack 5",
  "943d9ab6076df561e840c601d7d44a4f26b3640e": "Free Bet Blackjack 5",
  "bf79e3290dbc33127d6ab32e4f053ab2eabb7217": "Free Bet Blackjack 5",
  "29882359d10a58b89012f94a3d4d0ff1798c9e91": "Free Bet Blackjack 6",
  "7d19d275e5729dda4938450563804ec1d67463b3": "Free Bet Blackjack 6",
  "ae34d0c8aea15d432e2a640f442ce572c6813f44": "Free Bet Blackjack 6",
  "2daa9b99175d0918b3e63db21a5cbbc151c2af21": "Free Bet Blackjack 6",
  "440457afb94e1d796ec97d58e0107db659c56ea8": "Free Bet Blackjack 7",
  "a8fbd88a2c401b59d208d8e0465d7076fc7b26eb": "Free Bet Blackjack 7",
  "de1f76bcb1d01a8f8e78f13790b7d5caebfebd1e": "Free Bet Blackjack 7",
  "ffdeb5f388eb1d0ebffd90b1bcc3b036c028d03f": "Free Bet Blackjack 7",
  "14ded8fddea91b5f772f29d7b8eecbb15ab1fa06": "Free Bet Blackjack 8",
  "952fd459cfd7213034f9089112c8897e9ebac9e7": "Free Bet Blackjack 8",
  "0817af228f480528d92d5036b567d976595f849f": "Free Bet Blackjack 8",
  "3c1ead2f0b6346395fc1bc426264c73e712f71e4": "Free Bet Blackjack 9",
  "a4c8c005c3d70208a98016eeeb9fcc40dd4d3034": "Free Bet Blackjack 9",
  "2fa21b0e751f4e81fe758a01f3898ac2c2479c6c": "Free Bet Blackjack 9",
  "0bab4a0f1bad75807e6a8d98ce4555ea3efd1bfb": "Free Bet Blackjack Clássico em Português 1",
  "b1373e2996ee740f00606065934a7040914d6424": "Free Bet Blackjack Clássico em Português 2",
  "b6620a95f181149002c840a3766569aed21b725d": "Free Bet Vip Blackjack A",
  "f06c22137325e94ec7f74aaaaaf9c348efab176a": "Free Bet Vip Blackjack A",
  "2a97c91e28e293e4a6f3c54e1b53f296c14b5630": "Free Bet VIP Blackjack A",
  "5d591fdff8bd4619dce591c83ff25aef190e1405": "Free Bet VIP Blackjack A",
  "22dd943892457215de90dccf7124f5b448a8066b": "Free Bet Vip Blackjack B",
  "c5b7dbdfae31de3b7d9dc2fb4e0397375e898bd3": "Free Bet Vip Blackjack B",
  "ea6e07f502ee8df1562626b91f6800ac5c31f27a": "Free Bet VIP Blackjack B",
  "ee7c01ef51da6108df99fa735b67158f447f174a": "Free Bet VIP Blackjack B",
  "42cce515d256fcdbcd47425ab18330eb00bdf7bd": "Free Bet Vip Blackjack C",
  "a613f21bb7e62416f6bc598e94038530e0be1f55": "Free Bet Vip Blackjack C",
  "161ac62c188814ec2656d8d506ddcdd8de2aa64c": "Free Bet VIP Blackjack C",
  "18fbbb3a783fc11a6f2f857ba62282b086826295": "Free Bet Vip Blackjack D",
  "43085fb37efe7e1df541bf632bd5cf5cf0332f6b": "Free Bet Vip Blackjack D",
  "61ad22b566c35d430ee50e2e870fc9837784aeb2": "Free Bet VIP Blackjack D",
  "30fe351eb6a40be2f5977fa19adeb712275b0e12": "Free Bet Vip Blackjack E",
  "facf8f207ef6f43a5d0e05a319222b3036d6d1cc": "Free Bet Vip Blackjack E",
  "dbec58ac34abb9334a90be05d298a7b272ba1710": "Free Bet VIP Blackjack E",
  "bc01f895493cdc5207457226c2e0bc44620b334e": "Free Bet Vip Blackjack F",
  "e663e92c9cb3cb8f4440298036bbbf8c46803716": "Free Bet Vip Blackjack F",
  "0273c765027904dbcb7ea16009396914599683b2": "Free Bet VIP Blackjack F",
  "4b9d34f33440740ff6e5e1c626dd84e21096f652": "Free Bet Vip Blackjack G",
  "d07b1d5334639f941ad11a2dc30e1dbd9c92c9b0": "Free Bet Vip Blackjack G",
  "4c9808b0793538358d49c2e367e2f98684f5df98": "Free Bet Vip Blackjack H",
  "ca8a4d6b022a5daa320995387f1ede8b9d30c712": "Free Bet Vip Blackjack H",
  "d9237b1147c5ae95758a3fec8c0579784b5c3de5": "Free Bet VIP Blackjack H",
  "bf3dcd831a1c516eb86777d0e398783ecc09e702": "Free Bet Vip Blackjack I",
  "e6770898fdc0cb2e0cd69b30dd9c2955cd1b4066": "Free Bet Vip Blackjack I",
  "9eb2a2490fd5c61d4850920c522bd7f968a38442": "Free Bet VIP Blackjack I",
  "381564f0a1a9c460c29e93ebcbc051de39665650": "Free Bet Vip Blackjack J",
  "6170c4a3d20e8aff7491f284f1445bead5948595": "Free Bet Vip Blackjack J",
  "177e39e36affbae5a4bb527e739dcf7dff22c282": "Free Bet VIP Blackjack J",
  "b1fd99dd121b8762938352011a720cabf042202b": "Free Bet Vip Blackjack K",
  "e538ad080e01481dce4d9c754212f698609cc129": "Free Bet Vip Blackjack K",
  "1648d3a4462d39c300a65af50cb7b39445a9853b": "Free Bet Vip Blackjack L",
  "8a99ee2ffb58877bbe1b1af8a79780569ab9f5b1": "Free Bet Vip Blackjack L",
  "39cc2c1b2dc34a9ad9794ae325d210feb8b1b08d": "Free Bet Vip Blackjack M",
  "f900e9117e9db8788a5b4207b059e9a7b79e8974": "Free Bet Vip Blackjack M",
  "090c95d0282eb9864dd2e11134d33f5953683de0": "Free Bet Vip Blackjack N",
  "943ef2c6003f291323584fe00b9294f897cd51cf": "Free Bet Vip Blackjack N",
  "5842678794fa712318c02b77376524883d68cefe": "Free Bet Vip Blackjack O",
  "ef572603941a26e1ae68b99efeb24258e43f431e": "Free Bet Vip Blackjack O",
  "c9caa0991f2bb5629dbb599aacfbf50d893595b7": "Free Bet Vip Blackjack P",
  "e456e89b66e65b5aee90f7513684aed109edd846": "Free Bet Vip Blackjack P",
  "da80db887aba1a7032fb946c82d0fa0b85923fd8": "Free Reelin' Joker",
  "9d80c0125d03ba27a601ef3ef9e858a338e1cc8a": "Free Reelin' Joker 1000",
  "bfa6d691b7082af5897859db7258d5667301c408": "Free the Dragon",
  "bde594a4c35b4ae0521a964ba631b241eb56bb85": "freeway-7",
  "4bbd88ca3436f0b2140f71470e1d9f8c19bd17bc": "French Roulette",
  "96c987d2c0b37a9913a14ace34366b1103744ed9": "French Roulette Gold",
  "fd8a1de263302663f8dcca02818b226079f15817": "Frequent Flyer",
  "6b9ea5be29f27a85a483ad3fb0a67b81689234dc": "Freya 1000",
  "223d1742edb214dc4fbb383692275ed8f7880170": "Frightening Frankie",
  "2922289e4bda58a82f6844d89c1856ee6717c7bb": "Frightening Frankie",
  "ea96c973b74995ee93413f659050097c3e566fae": "FRKN Bananas",
  "3cf5f80f715196bc261427193119aab71322565d": "Frog Story",
  "efe1e4e21ad1d303affebccede6cb98b5a5c3600": "Frog's Ball Lock 2 Spin",
  "edbfd92dc8dc50d271bd7fbe97a49ba994499f24": "frogblox",
  "70cd3e4758b3d4e036c52401794037d5efc9eb48": "Froggy Dice",
  "c3299b3d184d4721e6222c2169e7a4acb7f6eb0c": "Frogs & Bugs",
  "d00b1e6582e2ecf43b433e9f650a94bafa4f5428": "From Dusk Till Dawn 10",
  "7195e80d0b5b0973d76afac1793a24c2b5713e35": "Front Runner Odds On",
  "d79610085b01b33a9802e0d194e084f636f6b809": "Front Runner Odds On",
  "bb1d6d40eed8dfecd8d01bb4e24a878e7d60b675": "FrontierFortunes",
  "48d379d63fcfca0a4b516303b8f6459ba0ecbbbc": "Frooty Temptation",
  "37bd53b001f32e4ffdc8ec36ebc6d9536015a361": "Frozen Crown",
  "ac6215ac7fdc419b6f7f641031ddb7d25db7a087": "Frozen Gems",
  "f96ed28aa59818ec6d54c84694b0f79991a161cd": "Frozen Mirror",
  "94aebbbd3bf1a777459ace2aa4e092610d025e71": "Frozen Queen",
  "72e0fa21365e36e07302efc8f78963485fbf6116": "Frozen Tropics",
  "ef91816b0d569c06ac27dfbced7a9e79374e19ee": "Frozen Tropics",
  "7ba5d203c778d614dc816680fe60e25cece3148b": "Frozen Xmas",
  "89a3ff529a23117bc9cfd84fb171e26f80f92997": "Fruit Biters",
  "33d32101275bd6500c42d3d00265f4648c4e808a": "Fruit Boost",
  "64c2e2756dea5fa312703f57af027eab1ecb36aa": "Fruit Box",
  "56642367a217089fa43fea1c04d0ecda0bbec479": "Fruit Duel",
  "074251824248f73d185abddc4c400a78c4bcc745": "Fruit Eruption",
  "283328cfe92a68e6ff0af6c3edfa860d251adfa3": "Fruit Express",
  "25ae5d1d7a860285bbd585ff1e0d51d26afb402d": "Fruit Extravaganza",
  "943c5fec1833c2433980c98fd157f2be4c327ae1": "Fruit Harvest",
  "d6699c9d954fec6554185bd53b80222179a54f8e": "Fruit Invaders",
  "01b32e3b642ce76fde22057125fa8396140ee462": "Fruit King Super Cash",
  "9cf6ba3b308aa7f48896e5608b4f83c92a75e50d": "Fruit Loop",
  "699c33bb8b40c2fd8a17e8891a0e9fda2677f6a7": "Fruit Party",
  "f5a913defbb7ad578e41c98905944c380c7791fe": "Fruit Party",
  "6c3ba5f272d51efbaacce9764ab77a903080e693": "Fruit Party",
  "4913d67c0cfbddaff87441403b415efefef6078b": "Fruit Party 2",
  "dd0aa0ad6b318c0bdea745a9b793e87d42460e9c": "Fruit Party 2",
  "fb486778f51eb6bc0e377b18080551162f4d0336": "Fruit Party Dice",
  "5069c14c7d5de8f5fbdf9af361276a766d4c3135": "Fruit Rainbow",
  "7e5b9430aaf62b3b9e45ef34098276322ae99d6d": "Fruit Rainbow",
  "d31563484d94659961216e9deab369e7e97847ea": "Fruit Shop",
  "a9e190401a0212ffdee4ac44e229bb490c6cedb5": "Fruit Shop Grand Re-Opening",
  "9d257d24f5c03b9c79d67e857c7a6f38f28e8d82": "Fruit Shop™ Megaways™",
  "f1a3e62619067ba7e6952915969e8911d4766724": "Fruit Star",
  "2cbaa0f7788c0864edcd1029335b7b54de1b184b": "Fruitinator",
  "bd175f905594b2c7c9e7442ec810d8cdb139f678": "Fruitoids",
  "0db39fde8489cec0526ab53ad1fe8facd0173204": "Fruitopia",
  "34b11e770e8f6982c7b97c5480f4c633cffd63a9": "FruitPunk",
  "5205d28fa86c675ceb73befa4cacdbde50e80f35": "Fruits",
  "bbca8fe2b02cab3b22c703b0b7b6c392d2a3e360": "Fruits & Gold",
  "65744423b8f526ceeeb5ce140e3d8924849649f2": "Fruits & Gold Dice",
  "8978f34d5a2fe00834e2111945b8d5e8c85cd1b8": "Fruits & Jokers: 100 Lines",
  "93cb41210ba26474e37edf2d47a9e02b48ad3d36": "Fruits & Jokers: 20 lines",
  "fe12c9afddf41654e7dafed7f2b2d289de1b164b": "Fruits & Jokers: 40 Lines",
  "06fdfc6327ec6f3348faf6ee3a3178fca646b176": "Fruits And Coins",
  "c91a5226674f54dcb890f354e274ce51210b290b": "FRUITS GO POP!",
  "f9d4f0cf15dc3b8c3a56d803540c4be03ae88ad8": "Fruits Kingdom",
  "494189917bbe8bcd5324b7858af4cc7c86ea5c18": "Fruits of the Amazon",
  "b078021b04b7904ffe384cc187ddbd557346b1f9": "Fruits'n Jars",
  "a66555ddbd4eb0c867b168693841cb4e761ffab7": "Fruity Fruit Shake",
  "b0d43022b9dff08faf230e328635b8329e8f71d5": "Fruity Sevens",
  "789433db798cecd7d0189238f87459a645db822b": "Fruity Showers",
  "14e1d8d37af760573d439b73ddb8fd40de7bd28c": "Fruity Splasher (Buy Bonus)",
  "ea8ec4cd596983960f5e52d4b120e9619cf5d0e7": "Fruity Time",
  "79c25faec8ebafba645b453d6cf4907dde2f87e9": "Fruity Treats",
  "3f7f956793131f8ea88c151c11963ec8839c2c5c": "Fruity Treats",
  "d6b20098ab342a6b45eda92a940459bdde71fc0d": "FruityHalloween",
  "f06d54d7e53d142b47d2168e23867503dd57dd02": "Fruitylicious",
  "1fcdf924d4fba5afb79281795fa33d3ea5c191b7": "FruityMayan",
  "4f29ccf167d4aa1bdc380f2f167ef8c2b746d469": "Frutz",
  "fca07ce8f48a44f1ee379b76f08292e99e77ff9a": "Fu Double Luck Diamond Explosion®",
  "e5bdf288212a96bb910663ce4e870403851cbad5": "FU ER DAI",
  "8343d1eb93531d86a719ce6b184848606533d4b3": "Fu Fu Fu",
  "29841a2c459661536aa83d56d8ae8848e7e043c8": "Fu Lu Shou",
  "0f7c6067b0e0367b6f4b3dd147634467005f571a": "Fu Pots Summer",
  "18d290cdedba740c24faedc781e32c896233c6d5": "Fu Shenlong",
  "2e4c8c546fdf0593cc956360faef8829ad9d9220": "Full Moon Lanterns",
  "ecc2236b99fdd82df6d202c15b61586d7cf56513": "Full Moon White Panda",
  "4c23c3618915af90645d39a03bdb5c192c9d8e98": "Full Moon Wild Track",
  "2d858b682b8c5d288dc855ad893dff074cb126d0": "Full Moon: White King",
  "8901a75f15336db015a46242ca7b42337f1f3089": "Fulong 88",
  "2bebd3d06a05e25b2188532e532f7d67b0603f42": "Funky Disco",
  "89ccfe9e463bcc9ba4a30fb245790ef960493072": "Funky Time",
  "5cd61688d4c72e1041acfba8840bcca236b922e6": "Funky Time",
  "57ecce57be9510dee5a1680fa4092e86509fb412": "Funky Time",
  "cecdda067d84e7aadfad277819c8188d8d87498f": "Furry Bonanza Megaways",
  "43d2a220b4193efeba3bd0fca3be85f5cfa82142": "Fury of Anubis",
  "f621f98f71f8b19bdf8b5655f0ebe5674969d287": "Fury of Anubis",
  "1a7fe63410897baddd77b894e88594bf2ce33e46": "Fury of Odin Megaways",
  "f690ee2705bd3151d34c66e9af60e5167c69dd97": "Fury of Odin Megaways",
  "a80b0e963b76fa342cf0fe4274a7fd6c7d0e55b0": "Futebol Studio Ao Vivo",
  "eb1f6d6765af7688c1333fd23de7e5577c34bb48": "Fuzanglong Fire Wilds",
  "b903f5e3b866c78f827d4cacb47d504661c7e3ea": "Fútbol Studio",
  "1e63313791d3c75d32ddbf3eaf5ec19a5bf48991": "Gacha Gacha",
  "affd1b67c6b1d3bcf72a149e9a930023ba583895": "GalacticCash",
  "2078c301cd43a666a90f9fed3ae404e7d4f2cece": "Galaxy Chase",
  "6ca81f40f6d662d0f25a5f0b72b80e8dd7bfac0e": "Gallantry",
  "941290a7051e840ea4d8c09e407ece77fb388ab6": "Gamblelicious Hold and Win",
  "90cc03740b0494e5db820a8a7e3ef01189965fec": "Game of Gladiators",
  "392e2b4f739420a18cf72fd1831b727991fa7297": "Game of Gladiators: Uprising",
  "c12fbd1eb45af140e4ad048f3ef90b2857a5269d": "Game of Luck",
  "45a0fa71961e972112d2fd8ad4f18a58ffc648bc": "Game Shows",
  "074ceb47cc4d9ba52fd78f1b194881120f66602c": "Game Shows Lobby",
  "c5a6571ee98e105f17d6b98deb795cfe275ea29b": "Ganamos Blitz Rapid",
  "e0e2b3ee5bdb879e178779aacd7c533eb17a3c0c": "Gang Wars Buy Bonus",
  "600663fdbfe3ce8866bf0db874a1fd6b12411b50": "Gangster",
  "9c6c4f6561fd46d4ff47075b9f56fa3daaa6db74": "Gangsters",
  "b0d4557da8d53651ebc9de86a06249b4e1f3b56e": "Gargantoonz",
  "1c5356bac8b93548497bdddf34a6182fa55d99c3": "Gates of Aztec",
  "96d2ab217d68d630d33e157e0c1a33a674e6d8ee": "Gates of Camelot",
  "78b873ebdedfa899a9272b207dad3cdac80a0550": "Gates of Gatot Kaca",
  "44345c9e46241ac5bd0dc96dc80a8363e9fdf919": "Gates of Gatot Kaca 1000",
  "868b473e60db714931a1b186fca958a88cea75e6": "Gates of Gatot Kaca Super Scatter",
  "137db0bff143f12c8d7bbba8a014430adc2e70d4": "Gates of Hades",
  "71935ef8c56fb1b3b72aeb1436bc478a5843a5e2": "Gates of Hades",
  "ad277df3ae855ae228f47b36b59b7e06b09e52b8": "Gates of Midsummer Fusion Reels",
  "e3c31eae908f6231ec5612272119f21155c71bca": "Gates of Olympus",
  "3080ece85a0f9078995c872d7e5cf0e88a1db3f5": "Gates of Olympus",
  "9c815d7c2dd737d5a6080faeedaa6b726376a33d": "Gates of Olympus 1000",
  "00b1b170237e9d208c5e2bedb08b02eab8780404": "Gates of Olympus 1000",
  "368d3040670ed8af3080fca40b23eeadb9b05180": "Gates of Olympus 1000 Dice",
  "9c0946162252cb62867f6ed6cab4c93194bf9db2": "Gates of Olympus 2500",
  "e5e715b4a8d06d8faedc981e547dd0ab3a254005": "Gates of Olympus Dice",
  "c6cfd63cbd0ba665c17c73f8b9fcb0c74ccc5db2": "Gates of Olympus POP",
  "af220fe708b447ec7b34d68d771a5acfbb1e7760": "Gates of Olympus Roulette",
  "75f39ad0225c95e1193e1f6f7a438fdc9c00130f": "Gates of Olympus Super Scatter",
  "8929277d6ac23a4b43a5f707cc8740c0369cc907": "Gates of Olympus Super Scatter",
  "eea0a785690962f128ae22685ef8f189d765080e": "Gates of Olympus Xmas",
  "3a70ba6a634898c46696c9a6325013c81538bb2b": "Gates of Olympus Xmas 1000",
  "dd75f63bfbb86f1381f0d85991246fb26ffa052e": "Gates of Pyroth",
  "d5e744028cd33daab7df991a6fbcceb168fb2210": "Gates of Troy",
  "9e4847fbc6e7c6fe60b103a78f89271bfa0847bb": "Gates of Valhalla",
  "d84816df4ca1cb8773cdd6ed1a7219e55716a4c4": "Gates of Valhalla",
  "4a4541c2bab1736aef4ffd8492f1bd0028deadc9": "Gator Gold Gigablox",
  "53a54b74614e3e73ac1beb654a2e5ecc31da14e3": "Gator Hunters",
  "0bdb9f5a6774e25b689f64220af93d9e435e018d": "Gatot Kaca's Fury",
  "aa5a1e257091b91e40d4619e5083ce06bcd9d5a6": "Gears of Horus",
  "94b5521c3e6326de516598ea88e0ac0c5a67afb0": "Gears of Horus",
  "6cdf1a51f9e248fbd9312a29b0ee2fb689460896": "Geisha",
  "3fbfcdd8b8f2597e3d99e036907924ac823cf91c": "Gem Elevator",
  "73bc368db3f65d0213dcf01d4ba600dda3cd9299": "Gem Elevator",
  "294c988c0e430c1299e9f971d6e1c9cf2936b47d": "Gem Fall",
  "c7e81654bd7ee9a289b238f987f796af2e6e36d9": "Gem Fire Fortune",
  "eac6e1b82bc6eccba5da8146d8c1c63c1b61dbde": "Gem Fire Fortune",
  "1730438f69e6e6cd65039d09b714b44c7d6d1d60": "Gem Trio",
  "01e60a6a6a0265a4d4b0645bc6e3fc865f89efd9": "Gemix",
  "09205ad46683a1b54616d5211395f3293bed7a66": "Gemix 100",
  "8a82122a622425132e8e6ce34e5dc6d134e9ae66": "Gemix 2",
  "a0563a254ba8dd7a10666b18bb1a449aad859290": "Gems Bonanza",
  "447a7741d55affea008489fe251ee9ef40f19cbc": "Gems Bonanza",
  "aff4ae3d8a09ad0e6c334cdca509844000eeef49": "Gems of Giza",
  "8fc7fc360e979e8fb5ef96d6df044fc82c186b10": "Gems of Serengeti",
  "8bdc0e2f2b01e9a3b274234bff3269597ca81d92": "Gems of Serengeti",
  "eccc588e1004af4e7ffde9ad5abf012e059a3cb3": "Gemstone",
  "d71f4510449d0d4976a8226bf4d6290c61ae09e1": "Gemstone Jam",
  "23afb639a61594040b2cdb7cc7f4c775fb1c5086": "Generous Jack",
  "e734de784fe406e8f8c1da77bc0c47cf9d3c84a1": "Genghis Khan",
  "018bda78b0579d00f76c31edece221a4e55accee": "Genie's Wonderlamp",
  "4103e2e152627e3166f35cba3320d75128856baa": "GeniesShowtime",
  "29a8931b3d8738fec72f6d8fd381c248066fd649": "Genie’s Gem Bonanza",
  "b536d93e98919f7e8a90cde6242b88ccefbee989": "Genie’s Gem Bonanza",
  "b6364744672a3657f6723d0c51962cd67c2d3c3b": "Genius Miner",
  "770ab46ff3a04aa292ddc4065d343e78af30868d": "Genius of Leonardo",
  "19d4a7b40d11d28961d37e768515997d4bc6571a": "Gerard's Gambit",
  "4a3fa6aa1b2d4cb6a35ee4a78ad6757b7d394d83": "Get the CHEESE",
  "344fb80ff43d8edc2db25035576afa701d1ba110": "Get the Coins!",
  "5b4ea00aad2eb258fdb915278687c5e4d3d6a9f6": "Ghost Boo-nanza",
  "00ee471a7750f4df2cf3e899794ff40dfc317ef8": "Ghost Festival",
  "227f5a02d451f144703b876d36ba16b886662487": "Ghost Hunter",
  "0f96280fc55bc5e5536d3df85839ecdb99480674": "Ghost of Dead",
  "355734b056c92b7ba4404d497e8a14fcb88cdc4e": "Ghost Slider",
  "7c640696312c06a5030b1e2be0bc28bf4bdf6383": "Ghost Slider 2024",
  "773f613514358e3f021ba3766fcc8fb31937e49a": "Ghostbuster",
  "5adca04aa696acaab562c8a98629903c7b109fec": "Ghostbusters Plus",
  "c4d1d96928f6f8ea5eadc4c300f63406d36affbd": "Ghostbusters Triple Slime",
  "a339e88c788a529fc017accb7ec47a3bad5e7a9c": "Ghosts Fortune",
  "2fc6b7b05ec61ce8ce3ade6785ebeb80e1655435": "Ghosts Gather",
  "bcea4cf5c2d3ee7818c0c4fa1379a7ea01b27077": "Ghosts Night Walk Lock 2 Spin",
  "c00062721ff7181140366f07a0bc1ec9573c4328": "Giants",
  "1182f1ab95442cc94e860a48b743144dc5dd40e4": "Giants & Sheep",
  "81a9f9f5a5bcb3a387acefe5a40d7b91295c0bff": "Giga Jar",
  "3ab0e2c747ae680d25cc3862160bd560da3878ab": "Giga Match® Egypt",
  "23c30127574e0d51aa75ab5ec2e97c72bf7545a7": "Giga Match® Gems Party",
  "93c50b411a63e417d7b8fbdc388e9dc4964bd4cd": "Giga Match® Mahjong",
  "e1821c2d9c013b1a2256df991dfa1313505d1946": "Giga Match® Moolah",
  "e6f53886541a8f5b061d50164f75d54034feefce": "Giga Match® Phantasmal",
  "eee8ef9e5038db18361906cd4f7353682baae367": "Giga Match® Sugar Skull",
  "8eaa8e88200b5e36e6876b38b14d107740bbe308": "Giga MatchÂ® Fruits",
  "7d3b778b11a4e64485841e4f825ee55ba6367b73": "Giga MatchÂ® North Pole",
  "64e6e1b970db2793cae1abaf73f9783387268f2b": "Giga Zombies",
  "372cb67bcf55c036a3279c3e8aedcce586eb1076": "Gigantoonz",
  "4ea3edaa7a8fcd56d7cfed4fe5f31c5f67742ba0": "giraffalot",
  "7a7f0eb6013880195d973bd1c7f65e6df89c3a21": "Giza Nights: Hold and Win",
  "f0bbb3f025b963ef943e5f857c122500645162d0": "Giza's Portals",
  "45aa0332e03ed7afcac25248fdac6c0924b68057": "Glacial Epoch",
  "c86ed1fc72e16c417666ead408d497b3360524b0": "Gladiator Legends",
  "94e27cdf1771d869841fe0da0a5cc81e854198c2": "Gladiator: Mega Cash Collect",
  "11d1d01ccb146926beb649ccbbeae74d7f8abb14": "gladiatoro",
  "6e8eeb583fbaa5452a6fa91ff13f35496340fcb6": "GladiatorRoyal",
  "3f331f51685a0f78f07ff5403b18bcd0fa587ea2": "Gladiators",
  "28a00e13110ea066a4d71b28602d63d99c4f3f16": "Gladius: Death Or Glory",
  "edf3e087e178a8d0c65bf64f4dd9d51c42df81e3": "GlamRock",
  "f987837f6b7b84351bca375884cd57970389fe18": "Glass Slipper",
  "d8d78ae27206e2de02cf53b61ca033399f96815e": "Glorious Alexander",
  "dac865fe9f47a4bc4d92bf7c9639c097c4008d3b": "Glorious Guardians",
  "dfd2776d922949c5e11907c8ee81a3f77ce20f2f": "Glorious Rome",
  "0f16954c2ceb409a4e3db5098014d4ca31ea80f1": "Gluttony",
  "a3a1104d28a357375967b039f4f33f9aee5e9d9b": "GO CRAPS",
  "0f5dfdff985c9b009de0835b0124534eec1c5950": "Go Escape",
  "c30823f493976a3c4266cf9c07ce8ffc70353718": "Go Go Monsters",
  "89dfb269c5339e2b5425165ff00258dad6e0f853": "Go High® Fruit",
  "1d02420ec1bcaa2abb088963d8213b6b811b0018": "Go High® Gallina",
  "f7988070a671a57ddd76168bcf69e551151140a2": "Go High® Joker",
  "706f6b02d6bc152cb3633e955fe3ccc5af816ebd": "Go High® Olympus",
  "bf9f4a0bb0b462b3909864a7a4a2f396e2111f65": "Go High® Panda",
  "b04ebf60670fa1e9f9a3fd3532424a997ce5b600": "Go High® Puppy Love",
  "dcc8ae180e2041e0501f59c3815c5be2917e163a": "Go High® Safari",
  "33a4d35d8c5270f77e03b20dee02feb56bb1f341": "Go HighÂ® Gone Fishing",
  "5d93f43a47302db4b78a6f63d4d54db8b135631b": "Go HighÂ® Harvest",
  "c95c95590128bfc0a626adebb05fa1d2305f37aa": "Go Joker Go",
  "b341f6f3b31f2a2093783e6d2e3eff2694300198": "Goal",
  "77199897629b949583e1a7879b2fa05bb56cb4f9": "Goal Goal Goal: Pachin-Goal",
  "1374d9934dcae0ae0f951bbff96b985293bdafeb": "Goal Kings Bell Link",
  "0d26b4ab068722af7f47c5b37f238d5bfc6e8bbc": "Goal Kings Bell Link VIP",
  "7fb7144f9031fb53b3c40bc03113b27b51ecc2a9": "Goals of Olympus",
  "881b76e54d94efbd73da4f98825d91abdf304fd6": "Goblin Heist Powernudge",
  "9cfd43b87d7d13afaf1510cda81c27749d413298": "Goblin Heist Powernudge",
  "94b794248bb3b5069ec8047f6b9e864efed5d6fe": "God of Gamblers",
  "926cbc5789e55321b25d7993a71fd8c3034956d9": "God of Love",
  "b1d90f2112cfc0e0a15a5c6c8e61c8912c3d694f": "Godbreaker",
  "1923243cb69eba7fd1002d954eef5eb4d3a28f59": "Goddess of Egypt",
  "942c88d3d2f6b49ee001299ac6bc62c310aa3f82": "Gods of Giza",
  "798a472edf162df8fa2b3df786338d8d268a5d3d": "Gods of Giza",
  "96cc8f6f757224f95d8e0e824da0eee4d37176cd": "Gods of Ireland",
  "11cef53a91440fbc353141be04f6292cce90bed6": "Gods Of Sand",
  "9119258201872c849244cdbdd74d1149a7fa0397": "Gokudo Bentou",
  "1f90f34f34f51ed83c5a1a1f329e4679b605d4c4": "Gold & Crystals",
  "c5122e96eddd86493fae07a246cfef7cbacc63d9": "Gold and Glamour Hold and Win",
  "3f4817ebfbd337b096222f1a1516b5bda718072c": "Gold Beaver",
  "75b7b7856da9e7a62fa65140f91e7db1909a9a5b": "Gold Cup",
  "64c9acda406c94704a32192582de09e3a24e0fb9": "Gold Gold Gold",
  "268991d209937c15dc630054a9a78c5549cfb4c6": "Gold Gold Gold 5000",
  "4fc462947ac8bc3b99c5d78f45dc1c2595091c3b": "Gold Gold Gold Hold and Win",
  "5406be871cc492c5679238f7388dff65297737f8": "Gold Hit & Link: JP Bacon & Co",
  "58bacd487103b920112129eedf2262d26ab96c02": "Gold Hit & Link: Tiger Jones",
  "b7830f6af7ac9d2091732b86d7fc6dcd28eb7c7d": "Gold Hit: Dragon Bonanza",
  "347433fdc20ca199b520cfcb89d79ade506778ee": "Gold Hit: Lil Demon",
  "c67e870a4514c13fc26a950ebaaa40f1f8ebbe47": "Gold Hit: O'Reilly's Charms",
  "325adaae385c8ea197cd532587594b1ce5fb064f": "Gold Hit: Oâ€™Reillyâ€™s Riches",
  "bfac2d50f56795cf7506349fb24ec09e15e3c9a5": "Gold Hit: Shrine of Anubis",
  "c6f7603bece65d4b9f19a91c142a34682ae22130": "Gold King",
  "3b7a0855f82f0fc8823fe00448ccbddff7e9be78": "Gold Magic",
  "4e618d70d7405a4c28013eeb10d0d6d6433aeba4": "Gold Oasis",
  "3eef0881ff8cf69a8224b957b3ad6d79b17025b5": "Gold Oasis",
  "a07dcd097b0776b7939f30168c47d65200257c03": "Gold of Fortune God",
  "9c95658661e77c95d499da46f853b4fe984532c5": "Gold Of Mermaid",
  "988fc6e54077132a9707503d3a07089d2d920166": "Gold Of Olympus",
  "8e76161f121ab4d0dc2d3d106f22bbcb7c3cfb6a": "Gold of Persia",
  "4c283fdf2ad3133e4e42241db1908e37c685b9df": "Gold Party",
  "9270e6b4d90f27df1a4bb24c0cf8021c3ed73e3f": "Gold Party",
  "019df2b0e0d201b7f8b8218b019552c0ee2fc8a7": "Gold Party 2 – After Hours",
  "9317a5b034241d090fd3eba6540f5bbdac8d39bf": "Gold Party 2 – After Hours",
  "24c8e5ba361951e28f1c7547e85932dfe0ba1a2e": "Gold Pile New Year's Gold",
  "f9fe787967470a523892119554ff1159e9a876fb": "Gold Pile Orangutan!",
  "d13521250b4127879811708547a13ff4db207a22": "Gold Pile Toltec Treasure",
  "abe9bd108993a02061e9f9a77d23cc3656fd615e": "Gold Rush",
  "f71887375b49ffc6c3686fa34071bacc11a1877f": "Gold Rush",
  "ed1abc24bc52295e3065b219ef380ec1bbe39ce3": "Gold Rush 250,000",
  "a5c7d73bb45653af1e9ae2232a67537d549a0aa8": "Gold Rush Riches",
  "2abfde6793362b9e672b22035f7df96dfe0f1a83": "Gold Rush: Cash Collect",
  "f50e790c698de0249f7ae6c2d599c39dbfb163a2": "Gold Splash: Toots Froots",
  "b6778b184300d735b5e9c60935814a182dbbaa17": "Gold Train",
  "fe99479deaf857330cd312906d3e52d2f5e7b97f": "Gold Train",
  "39b518f954acb37690c19be97bda54894eebd487": "Gold Trio: Football",
  "3f75f6bae5d57e5f9cb2492ae4af9db5e2ae441f": "Gold Trophy 2",
  "0f8b7f628cf07806cfc14a8fb2a38d9fa0aee4df": "Gold Vault Roulette",
  "7510c1b660b1b83c30ae614a7e4635a0d2a863c8": "Gold Vault Roulette",
  "22dbf47e490fa014189b7c37bec8f2d92db185b2": "Gold Vault Roulette",
  "7d3e57a1068a2b065b5030bc8be708d390443b62": "Gold Vault Roulette",
  "e750200633a760c82b6fb43b0889049d19f2c109": "Gold Volcano",
  "375ce46c7ebd085d62bf8f51c081ea9d6420b9a7": "Gold X",
  "8c2a37f10330c9aa3e21ede1b585e265911cd612": "Golden 777",
  "0c2682631e8c97459603aeb690bd1b4c2b20fcc1": "Golden 777 VIP",
  "f115662fd344a116603e7f2a80ce84b485299df2": "Golden and Silver Horn",
  "2491c70209cfe4e52a98f5ccd2e7e7a6d4494cc4": "Golden Ark",
  "942cdec7e10d9927e4bd334ac58e5671531ec134": "Golden Ball",
  "eaa9a666c291657440e8e19aa200344b11f52b04": "Golden Bull",
  "ee9c52849a7a02835fdd6b07c16f7f75f41509fa": "Golden Caravan",
  "d178fcf2550b17eeffb7bfa9a783eadbb2d4249f": "Golden Cloverfield",
  "2a29c7e1383c098566584cdcf9dbcfc7590b989a": "Golden Colts",
  "7afa5903404d0b02f203607ac563c42df1c8c034": "Golden Egg",
  "778cd7dc4e4fa03879c1fc68b67d9275016e818b": "Golden Fate",
  "77b93452e38398814e34b19cfdfe7a728a840bcc": "Golden Fish",
  "2dd6a0af4773ce9eafb8471b921171bc1700835b": "Golden Fish (Amatic Industries)",
  "310b4462a99a524b81447b06b4e84b6325c90641": "Golden Forge",
  "59e8c245cff09103748db8b3a39ef4ed47bfbf5d": "Golden Gate",
  "189e261d86a7b44d3573717d9350152df441a8cc": "Golden Genie And The Walking Wilds",
  "88ff683b0b2f41e8d032c1b85cd9e20d870c19d9": "Golden Goal Lock 2 Spin",
  "4f0a14da1a146a51d39f3ac58bd39f0d8aa90df6": "Golden Goddess",
  "a45ee131857da295bb16689a41ce10ee1f16abe0": "Golden Goose",
  "5a7187258611daa4cf9922679a5feaf44963accb": "Golden Gorgon",
  "70ff0d1a96326ab7b5734bdfec59bea55749fbd8": "Golden Guns - Grand Junction",
  "af506c4dd7dc3697fd22dfdf7ec7ace097f84b5a": "Golden Joker",
  "2c2771018b680495eb035281959fbe853c35e3ee": "Golden Lantern",
  "56e7900483a09ff7e59fa1431abf783084db6228": "Golden Legend",
  "9b8f54ccf7e0fb248c13fad2514d035e1dd30586": "Golden Lemon",
  "51de62e513975b1ca1bc6baa45aae7705df64f04": "Golden Lemon DeLuxe",
  "d60cdb9ccbf453fbb93dd087e444acb8f35a75ec": "Golden Magic Beans",
  "9a621ce64e15734eba7e21f46f099e53541e962a": "Golden Mouse",
  "c680b8c2cc291d640a9448f63d01af3c364fb14e": "Golden Osiris",
  "fa7daf26b8dfd484f3b61ed3e6fd417edcecaf20": "Golden Ox",
  "efc200fe69b11642d447dff6b0fb3b55fdf7dd18": "Golden Ox",
  "ff1bdb60f5d08290d8485df6e7e11d37ce007ecf": "Golden Penny x1000",
  "4b8b650906e9d0b7c6edcdade4a0793a50d82f3f": "Golden Pig",
  "54993ddd1d6234beff18fa43e939c2db37db07f6": "Golden Quest",
  "96c45cc5e3b9df7626f3c763263593f0cb070c38": "Golden Realms",
  "a87a1e17eab697cc375f3fab2f72bb8eaf01301e": "Golden Retriever",
  "5f24a6419ea40404fa2da5df143068015be0bbcc": "Golden Roar BOOM",
  "6d6a87670643f90618d27a5d9bb8a352d24de003": "Golden Shanghai",
  "31b364268a111e272e840537276dca0a0dbd8f02": "Golden Snake",
  "a835296a251d8898158011ea60187de5e99ff5f2": "Golden Teapot",
  "603907ea248f919c8bc08f19a28dc6d0630035d8": "Golden Ticket",
  "93ce801cd857e09827d887ae36b6330a78d7a0a9": "Golden Ticket 2",
  "1378cc52cc0a61112eaa52ac2220a7d4f5ddc0ec": "Golden Tiger 1000",
  "d0b3ba1be5778b0ca8cb41d36c16fad1441f5d09": "Golden Toro",
  "2c53472efeeea24a59cd0c41c4d70ce7c2c50f77": "Golden Wealth Baccarat",
  "791975fd7c70956d871b169d734586c182896315": "Golden Wealth Baccarat",
  "01b0c533fbae26a5564354125f6a527cecd3cdb0": "Golden Wealth Baccarat",
  "897691878327e24a08bc45fb04214685aa5a6d47": "Golden Wealth Baccarat",
  "f0d2e5ebe35341c77fd0627b667b711414610484": "Golden Year",
  "0525ffbdad7f7377ad54fd1b41dcdfc850a4f0a3": "GoldenTajMahal",
  "2c93fb40cdc2f39b6c757d3065e07cb2da54841d": "GoldenUnicorn",
  "9f87e4cd484393d22ab94bb0964dbb0b1e026cb0": "GoldenUnicornDeluxe",
  "498db2b0869cd3741203812e3179d62d2b1bfea5": "GoldKoiFortune",
  "fdbcfcee46213130359f9c3589d5f0f0d7550cc3": "GoldRush",
  "265ceb52eea05cdb6d7bbd04e1eeb2c15db15fbb": "Gonzo's Quest",
  "c560aebf31fb0eca45db763a12a40b297c3c15a8": "Gonzo's Quest II: Return to El Dorado",
  "828db5271df15df7ac77de270684d96d0c8b0102": "Gonzo's Treasure Map",
  "869b5c9912db6394f33a33337b9e2a03e58d3d87": "Gonzo's Treasure Map",
  "64137f13b0091a4d07c16c5b5b045915157ba3b7": "Good Luck & Good Fortune",
  "4942332ca431a58d5d6fadf70f6c4ae58243b85a": "Good Luck & Good Fortune",
  "88ccfd2771c8c0ddc7c1409a011286f7b7ef61b8": "Goood Heavens",
  "2d2dbfc7f00d74ff0d5ec886c2a234ed08b88581": "Gorgon's Luck",
  "f69c29ee24665899f325d152690b45f5803df945": "Gorilla Mayhem",
  "b8a4bfc999c79d7259c52b2d30bcd5220f827bb1": "Gorilla Mayhem",
  "f29cd75b6db206a3dee6e05230aff29e14b14660": "Gorilla Style",
  "0cec5e9725a793326aa96fd7d7e787efaecd6dfe": "Gorilla™",
  "007782262e5e163a43d20fe117cdfa6f49229325": "Grab the Gold!",
  "a6c45f0f564dbfa12338a50e60ab881c49bc030f": "Grace of Cleopatra",
  "ab73c409061a4e45098a96ba7faf01f26e30a691": "Grace of Cleopatra Buy Bonus",
  "a965443de77dd84e88690f4c8fc3e96eff82a07e": "Grace of Ebisu",
  "76906ce2bbaa2d73a5b85fac2be97f498d38d1da": "Grand Bison",
  "7d706d1db7c9a6aeb1c67721b7eeb85c46ca06f6": "Grand Casanova",
  "a6b18aa27a8c62a0adfbb2b2520b48cda75829ad": "Grand Casino Roulette",
  "36114cba31c511d86ebf25f66e096183418e9204": "Grand Express Action Class",
  "edcb3ae6b17a8e9e73002f01670ab51bc5e4c345": "Grand Express Diamond Class",
  "cd8a8980221639bb326d704f4721d6f05e2f7a9d": "Grand Express Fiesta",
  "ba431b2780b9b55691354e57c194fa3c04bd4d58": "Grand Fruits",
  "0a14417da2cb27fd88f0ea03d8a6382ec42ef04b": "Grand Junction Mountain Express",
  "35abe1a1a42cee2dbe31928d682afcaae620b607": "Grand Junction: Enchanted Inca",
  "307646e65e80816b5c318f4d22a49a308343eb16": "Grand Mariachi",
  "77d07db06502b8981f6413df04ef51ef8e39b719": "Grand Wild Dragon 20",
  "bc2115d90961e479d9eac00a8e8bc9edc5927af6": "Grand X",
  "8b1eb983524d8c7f8a34fee8e1f241e895151c7c": "Granny's Wild",
  "0bfbf9a0661a0cb92c5c99a14f1b5a2c6ac0271e": "GrapeEscape",
  "a21c56271217d355a992085378604d0cbc97e08a": "Gravity Bonanza",
  "dfa343cdec4da2ad6dda51e6ae6ea4c18b08fc6f": "Gravity Bonanza",
  "434c7cd587c612fe2c66b1e5a7afb6efcb48468d": "Great 27",
  "8129732b58f68a45a73708032a9739e2ab70f691": "Great Adventure",
  "f402eb5a814a134ef9d88f3742f3555dd3e7589c": "Great Bear",
  "b2ab6c696de9b7623268efe617eb44d9f4e69c4b": "Great Courtyard",
  "95282cf41906e0f80dec923975f18a2e487d1593": "Great Doctor",
  "36282a295a1eca84a85f4e23c90fde44dbe51d09": "Great Empire",
  "0e58e3576f20fd5bd83ee3aeb4c6533b40bfc178": "Great Fortune",
  "24ed47b4f2614af81b6489553f7e78c65bcbbe66": "Great Game Rockies",
  "d510bf16904283de0108b1fe2914804d6b44df75": "Great Game Serengeti",
  "513f050444535fa464b247e0fc1cfc7ea12aa611": "Great Ghosts!",
  "8019bc92f6ae75f274b1560362ddc2bdb1d86b47": "Great Lagoon",
  "11e74be8df3dab46b1e310c71dc47e9aff5ccd94": "Great Luck",
  "3cf7b807701e983816ad7f1a2ebd78b3a32b6cc8": "Great Ocean",
  "e1c0b48e8018aba08e5f64050412dc7f5720ceb1": "Great Reef",
  "c03c6f562dfbf9d9c4c11366157cd7375f9283af": "Great Reef",
  "bfd7bd318356bdffa0568007d6583309a1c9d760": "Great Rhino",
  "4ca1f5b6b9ea36045991e33ca04a1916c76b68a4": "Great Rhino",
  "156495d97aa50e2a3303e2adcba4b9210116713d": "Great Rhino Deluxe",
  "74b63a462c6c9a4541033ddeaa710fabd15c0548": "Great Rhino Deluxe",
  "82c780ec042ff56f294de6bd9741ba5eefc07d44": "Great Rhino Megaways",
  "0c05ef4b0667c76cde48ef795f9d46ac62c8b250": "Great Rhino Megaways",
  "9c81955c861ecd1bc76de5d859ebb5125d4f99eb": "Great Sparta",
  "271a3e2b0f9e77aa1a6ff623aef1b30d5454a404": "Greatest Show",
  "b988a44c4acbfa1f5bac6c9d48c00664521b6f2f": "Greedy for Gold Power Hit",
  "6fc18e1adc5342624a9a6833975c441209ab9c8f": "Greedy Fortune Pig",
  "c8b55b079da9d41ee934af7c4e7a99c1b1e48fb0": "Greedy Fortune Pig",
  "51133b895b611816ed3f251b3b50fd2c6f56c0c2": "Greedy Night",
  "7ae1d59a05e8831a7271d10b36b3317276ea9187": "Greedy Wolf",
  "34ce2fc11e59c0a370325f3f2d33980a552509c1": "Greedy Wolf",
  "99633196b023843c4d8aee4e6bbd182d6c160b99": "Greek Fortune",
  "cfe64dca59f851dfeb5114decb66b1d29c92fc7a": "Greek Gods",
  "5c67a6ed196e59030f1149212eb9037c032afe70": "Greek Gods",
  "4e64801aca3c8baeaff283c2a71b0cecbd84aae2": "Greek Legends",
  "f93076ce8194933ebcf39e2c10bbb172dbb416e5": "Greek Lightning Roulette",
  "8d426f952c45562fa37321d3d7beaca22bf13624": "Greek Roulette",
  "96eb6f7d8395aeb9c390f5bfc9584f065bbcb509": "Green Chilli",
  "86d555ac4189f5ef8117f38e637087b3725ce9f3": "Green Party",
  "0ed41e9db6dc5fe490a619c5c95b5b1748f1bb17": "Green Wizard Fire Blaze Classics",
  "398da8f3eea8396bc32581e11754266dd4b3bf76": "Greenback Attack",
  "5facd36f5a5544cffa646fd907cf5d8cb2e9b905": "Griffins Throne",
  "43bbb1637d4fd0db8372a5e9f2d029c386f51339": "Grim Circus",
  "a5a6049835a6a44e44c9a34f7ee649c32b91e621": "Grim Muerto",
  "1d61c7515eed1775d988ea7e83e87c14f5dfd6bf": "gritty-kitty",
  "14f6750ac7bde095ff69287d2f175956314bec8d": "Gronk's Gems",
  "5a9170721a931280852fec75afe395d40dfc941c": "Grug Make Fire ",
  "bc84c32cd7baebe26631ca8e13339b389753d41d": "Gryphon's Gold™ deluxe",
  "bf8bf0152e11fe2fa9ae665edacfa4c8916032fa": "Guan Yun Chang",
  "73a2969b5df12e3b23f605c1bce7d415ea422cf2": "Guardian of Ra",
  "2756213db4a7b369d4a2eb00bee7d224eb8414b3": "Guardians of Luxor",
  "92b12a3e35048dc8d58c140d9e8056e9a26756fa": "Guardians of Luxor 4",
  "fa5c4bb90f1061dec86ce22caf5fe724c18448f0": "Guises of Dracula",
  "3772edd628e59e3d53a3bd85a4ba303e5d8fa5eb": "Guitar Quest",
  "7520684902bad16720a5346cb78e6a67e6ee1d5c": "Gummy Bear Kingdom Lock 2 Spin",
  "8f6deeb4477f2d5973f0290dbe6220fcbfc837c7": "Gummy Giga Match®",
  "bdad6f700c1d3c42e9f7c5ab6988a243036ae445": "Gustav Minebuster",
  "c12f0f204373d7f2618570ce76ad045add46376e": "Gypsy Fusion Reels",
  "52edf35646aac2b481e5868c2c97691064be1c8f": "Hacker",
  "ce7ec651a5c8699598aabb96863def7356d017f6": "Hades",
  "d70016beb73c298de1712349dedbbff17408b4fb": "Hades Power",
  "bb5815241d8264fda303fa4c35e6a7069f92a3ca": "Hail the Judge",
  "7d7e74f84d8446d1760a78cb5a650dd41f388f97": "Hainan Ice",
  "42f2fd39299ec500195ed722acb31d3495772cd6": "Halloween",
  "377fe242d3661e564f019d39aa5472d4a30c658c": "Halloween",
  "cde436aeef20ced189112fbc35e07e282faae06a": "Halloween Crystals",
  "4cd306d1841ade8b169aeb11ac3e88a80ae8df01": "Halloween Dice",
  "9cf33db461b7ebd1242995b22b8ee6dba6d3ed55": "Halloween Dice Egypt Quest (EQ)",
  "8b7bec5982c3aee81f33f178a37b6aadeae73f29": "Halloween Egypt Quest (EQ)",
  "6de74be9a56e4a2ef2dbf7b6f03acba55abdd21b": "Halloween Flaming Bars",
  "ea6bac58bc1da0abc261e7468bb33c8baef127eb": "Halloween Fortune",
  "3cdd2081241b81d5e16d55f6e481075ea4af4519": "Halloween Fortune II",
  "c76023308ba8a94fc6fc7349711545d0628775d9": "Halloween Jackpot",
  "e437b5499d19a6f9efe7ee64cabc4a823fabe16a": "Halloween Wins 2",
  "4b252b98760b56e73b6434e6076442b7aa496c4f": "Halloween Wins 3",
  "29af5cdeea0d3537cb1c6df0cf68169c8339a61a": "Hallowin",
  "34c536c82e1a802670e7bb4a3c9337b96baa926e": "Hamlet",
  "0d4a2b64222e6151b6ed5b4de61aa40bfb9943b8": "HammerFall",
  "b3f3237185cb205e288eac3d03d18c9fa08701d9": "Hammerstorm",
  "6dbbfda84be9053cf3bb09ebfe5c25ec65197524": "Hanabi",
  "8910dd6d4227b06681702453b673312e58716f42": "Hand Of Anubis",
  "87c0685ae1271c9bb0927efebbc14882a52641ad": "Hand of Midas 2",
  "f2a498977d5a56c62716d8d477eecb08c78cdca4": "Hand of Midas 2",
  "04ad253731933b9a8d24f1d1979c23abc5e3f7f3": "Hansel and Gretel",
  "9c7e75c12d4297345d850c24bbe0e7a2cf2fe86e": "HappiestChristmasTree",
  "52c5a5eddaaaf47b28df8b6f560a808b4d9ce527": "HAPPY DIAMONDS",
  "251227c1cf54fadd812bea904484ff6d2993fab3": "HAPPY DIAMONDS DICE",
  "78fb7fdc3ccfc6c9ef5c840437cd51e0ded482da": "Happy Dragon",
  "5230b3a3a6738c6caa7ae6e70ae2bb6da03cf556": "Happy Dragon",
  "40017b6379da29ebe8bb320da6788a4ded23e8a8": "Happy Fortune",
  "b6615ad8d37d7018d87f18f32dcdb4de95d7dd09": "Happy Grange",
  "d9993a44dcc55c34100f41b4b8fc741f4b4e9b43": "Happy Halloween",
  "97575791cd4b4be079ec600d87cc5ce749cc9315": "Happy Hooves",
  "7399c5fd1014a73b1ee7924ba01a0b72bdfcd7c2": "Happy Indian Chef",
  "c2fcfaf471a830b7fee569da24792c22a1e19541": "Happy Joker",
  "6701cfae26497c9f1c173186e600b5f9e3861a66": "Happy Marriage",
  "27807bdc239fa4fe92a69bee5102a78b5e5af9f4": "Happy Nets",
  "7707ed6a8f24c4ff712ba0d310e3ee7586113198": "Happy Nets",
  "539ee2e093b7c2b6167e63135e80b9f4cc5c1898": "Happy Thanksgiving",
  "de93c1098a9fbbcdc16e44657bda5b9ca2dce1bc": "HappyApe",
  "f48ac37ff3a7a22e5fbe24366b60264748884a12": "HappyHatchlings",
  "25382fcc359def06b6a27dfd714ea0e3fc09bfdc": "Hare vs. Tortoise",
  "06277b0151f91531cde4124b6a2828b5012f3d5b": "Harlequeen",
  "469755eb3bc6e4301f4960e01e774feedb204774": "Harlequin Carnival",
  "b93871c19fbba535258f49df5713f760da8d7372": "Harvest Moon – Grave Profits",
  "363f4b69ac5853a8623ae6150805b43cc4c364bd": "Harvest Wilds",
  "22c0bb2e403c73186f8d17785cef06dfd05b3d73": "Hat Seller",
  "0c73f65e070154586d9ae1dbb004b0835a1b219b": "Haul of Hades Super Spinner",
  "8576efab513e59720061afee8067bace0c4fd18d": "Haul of Hades™",
  "b248e06f4972d64da83c3dbea4fff67d005e92ad": "Haunted Crypt",
  "651574db093690a27ec8fed45b50de9cb58e9bbc": "Haunted Crypt",
  "60eb38d499ac7a54cf47876c4e5dc2b8e6e8fbc8": "HauntedHarbor",
  "be280d14ea9a8a76ec9b1faa43612477a014ce2c": "HauntedHouse",
  "065c29c753decb4698e3da8c316c1fabd371f2dc": "Hawaiian Fever",
  "cbd6d03424d133fcf0d72c8481eca57edfd7fe67": "Hawaiian Night",
  "d92f119d3b53725a4d254d69bf8efc49dbc1a2ba": "Hawaiitopia",
  "4f0d9734c2164321fac0ede3e49a55dd8b210ef1": "He He Yang",
  "90ee8d2e50583e6ec404cb235519be6c704487c8": "Heart of Cleopatra",
  "e4cee000015d96c26e2f5fb837dba09714790c23": "Heart of Cleopatra",
  "bc58921bcf0d14b038c8ece77f8712e1ad9a24db": "Heart of Rio",
  "42061d50a3bd66699d3d69a5a13fe5fdef2d3d08": "Heart of Rio",
  "e77174efb20e1fed1dba3664da4a786be50b6e2d": "Heart of Venus",
  "64b4210c9869265c0db399104e8e54069ad2ddf4": "Heartbreakers",
  "b47a03c9cb7cc1ce10ba9a7fec4bb8e90c3c8c55": "Heartbreakers",
  "ca649716606c1119f2cf0dfc9a812d6f8dbc6844": "Hearts Go Wild",
  "c03db231e0f291a7f25f7d32ea4c226afe6483ea": "Hearts Highway",
  "b2d0f6685471a0204e4edf6dab3a8291ccb52fc1": "Heidi at Oktoberfest",
  "faffb1a869734329ac9d82b6b52989c31cf4da6c": "Heist for the Golden Nuggets",
  "e0224000bc4d015b401834b8493422acb2501694": "Heist for the Golden Nuggets",
  "21c517eeb0df6b7b2354b0b7d51690176b05da4b": "heist-guys",
  "1d0c4196d1b66063c78c4a6301ce345abe97f610": "Helios Fury",
  "7d2ed7745fbb42dece311b0686dbe4c8dd5e7cc9": "Helios – Triple Sun",
  "cb25e64f3383012d054065c3a01145555ee13ff3": "Hell Butcher",
  "da16b0400f4030717dd28ec54cb7c6cc8b8a3de6": "Hell Butcher",
  "ef596e6e2069602fe56094b0d81686b9c413e4ac": "Helloween",
  "1a42f737ad3cff8e4aa1e08185d48198394d3a05": "Hellvis Wild",
  "b1f178e1dc86cfd863faffcdde474eb9993d03f7": "Hellvis Wild",
  "c9a72c72d974f77a5cfe97b5cf0afe0880316fd8": "Heng and Ha",
  "ab593a72909303bb4fa14c103ad788b77d46bead": "Hercules and Pegasus",
  "65e3ee3dba7b6c919bb15580103a2c405e1f6064": "Hercules and Pegasus",
  "3a94bb5e669ee8d4583a394b63c4d0d9d4a22c4a": "Hercules Son of Zeus",
  "0958e8c8d08a35c16115e620823305fec9b7d597": "Hercules Son of Zeus",
  "007b43740743ca3a33adc6ef019fa27de346c9e7": "Hermes Fortune 2000 High RTP",
  "86231141ad6e3d63b0b550f98bc96b5941cd7417": "Hermes Fortune 2000 High RTP VIP",
  "57ec1b0b960f7beb71f7797601d46da0b2b211a4": "Hermes Fortunes",
  "9449c86a0c06487f9bd97236a354d45aa0e0e627": "Hermes Fortunes 2000",
  "bb4a0232557c3c327ccbe93acbb720fcd3fb519a": "Hermes Fortunes 2000 VIP",
  "a4e50c88311a9bcb062673357b73847cbae65470": "Heroes' Gathering",
  "ead1fa37f9891bd98a99435879260191bdb845d7": "Heroic Spins",
  "711ec8b4908d0458cdd945d93583a404402f8a2f": "Heroic Spins",
  "9755e7623661d8d017cae142207a59bcf8161fc7": "Heroines of the Marsh",
  "2fda304f6e064917bbe8861f3658b4841fe7ba0a": "Hex",
  "c5ba80820024935f43bade3222fdf11501d4ac1d": "Hexen Kessel",
  "34d5e6311bf2053b4ac7d7b6922cfb9063120b94": "HeySushi",
  "5cf8f27f20d54580ac7df0d27d4b29bc450fdf5b": "hidden",
  "5cb488fee3026a8755fb63891cb60b340f6dd930": "High Flyer",
  "53e0aa377343f2108219a851af55fabda775f269": "Highway Kings",
  "1c7217e404a048adf5c471376c193d50d5f82813": "Highway Legends",
  "63f09e4050919a8360a74df13e9f8d38f531ba31": "Highway to Hell",
  "2b7fc641ec0ce4ab69e2f2df5db7c00e0e2b58dc": "Hilo",
  "dde32810f74f4900829e1af10d22c9f105fe4916": "Himalayan Wild",
  "b4d5a3e6ac801ea9400144a6e352cff65a2bb217": "Himalayan Wild",
  "08b6a7149c3aa39c28ea137257c50b40f6e7637a": "Hindi Lightning Roulette",
  "a5d3b15edecf43e271072cd1d3f47579d11a2609": "Hindi Roulette",
  "263266d6b227183671a54d4abb02c8e35dd99039": "Hindi Speed Baccarat A",
  "b311689876941301b10146c598af0a246a94976a": "Hindi Speed Baccarat A",
  "2ffcef2d0011a84bc52248981bc66244c8e96c25": "Hindi Speed Baccarat A",
  "4c79ecae2e74d4fb86765851d94aa3bd964c7e76": "Hindi Speed Baccarat B",
  "fe411e0aa02d12efd61a181e0cae8980382ae26c": "Hindi Speed Baccarat B",
  "87aa40e0b38745723d586fb1fb4d10f120211001": "Hindi Speed Baccarat B",
  "df3ace1d0e6e0227bd3a58dbd51d0d818f79570a": "Hip Hop",
  "919f9b598f4511d573891dcd7b641b1cfb5ebf9f": "Hip Hop Pigeon",
  "ce05f61daa9e9ffbebd48e5407eaba95d6c622de": "Hippo Splash",
  "b5c419a800a22cba029e3722e87432bf1e049b57": "Hit Bar",
  "bba4bf6817b6009cb41fa7fb545875886f9744a6": "Hit Bar: Gold",
  "4b8b3f500a12e5906abfac6d56bff1381dc69fb2": "Hit ME Baby",
  "9791290f94e1689cac39ba24151e74c96fda43b8": "Hit the Gold!",
  "ac51cf1cd1ac3452da1c4678f3e6acf31b005735": "hit-it-big",
  "c9e85553c3c04e09e017ca3e649243669fdebf8e": "hit-it-hard",
  "8f425a785cccddbf774e8ca4b3fc7009ec2aa245": "ho-ho-tower",
  "7a92ce674e9c745d57828add6bf6656c1e62bccd": "Hockey Attack",
  "1a7cac018a7c7a30be0628b2048548e1cdf4ac5a": "Hockey League",
  "10e36de9b97b831efb1187f1f961e4e4861022a6": "Hockey League Wild Match",
  "b3dc96adce5485261d2de4d500fd759855e1aaab": "Hokkaido Wolf",
  "65f261ad15a3fb54326fb74a1bfbd1cfa1c20300": "Hole In One",
  "7e3b0673a5509a99be37756d35c8d4b0bb0d7b91": "Holiday Carol Lock 2 Spin",
  "d6250e5ed8f93a9eea1b7fd9a3fb6e57fe747838": "Holiday Ride",
  "7b7993e33ab1616e36f53ac61a39297992b43613": "Holiday Season",
  "2ff99dc6677ffa8e2074af05118372540d290a49": "Holiday Spirits",
  "6f6693c4be07986af511d05c2fd665ef1b2ec52b": "Holly Jolly Bonanza",
  "f8c69de4016b8c827ef0e50d8d4b087895f8be4f": "Holly Jolly Bonanza 2",
  "cdfb04b784a4b42d0406271671385f79319640d6": "Holly Jolly Cash Pig",
  "092b325fb35e118a1cce1f19cd049f815a1c2e6e": "Holy Beast",
  "5d48a8260d1a4a71f18e64140c4afd3a5741c1d6": "Home of the Brave",
  "7897b08963ef6b02552992d3df7602773f6218ed": "Home of Thor",
  "222f9c6d800cb1d5e67ae2d5cd7d05fd304d3c52": "Honey Honey Honey",
  "9403c5d78a19d4a50eee729bc98e1a7d6b433af2": "Honey Honey Honey",
  "f848344c41629a37ca87db8d39e540aa7933b2ab": "Honey Money",
  "58740a7ce94e3a59dd354b43cb9d1d0e7e8541bd": "Honey Rush",
  "3e947b6c04518453941343d19b8982c3194b880a": "Honey Rush 100",
  "9c9c1bab628dc04d6053ed4f4cc19ba513d17ff9": "Honey Rush Black and Yellow",
  "2aee73903b63415f97539ed6a8329d6c0d81be70": "Hong Kong 60s",
  "cae12c2013b848d1f11f74575819d44ce0956ccb": "hong-kong-tower",
  "decf756905196cd27911bbdb372e2b02b88279d2": "Hook the Cash",
  "4e0b9d0d4ce698d4de12a62ba6b1a92db7ce109b": "Hook the Fortune",
  "3a61c8a4674bee9a6677943bee45492a48fd15b5": "Hooligan Hustle",
  "d58e6d173fa9ba4353875688c2480f321dcbf06b": "Hoot Shot the Sheriff",
  "62811edb0c2bf7d795a2df5f44ec19f5835d9d14": "Hop'N'Pop",
  "c7e3eea2e3770c8b219d45b5ad61f18a2ad155ae": "Hope Unleashed Fortune Rises",
  "42bef029eac185aa82890c63a74585244e7d56c8": "Horoscope",
  "2ba37770f666216c600fd7eca7723f1ee025c5b0": "Horror Hotel",
  "4490c4281bc54469eb12886367525a0966a63af5": "Horse Racing",
  "c70870482d62bd48c166a0072b206eda0b976e3e": "Hot & Cash",
  "c245ffde4dda4223d794aed75dfe5e09f3b7d8bc": "Hot & Win",
  "453d09ef53c1ef1cde856c0e2f6e47449413a9da": "Hot 27",
  "94ffe6e5b24a486f45b5f7a0c8a076e0ac6dfd15": "Hot 4 Cash",
  "1abc3b5d1b971a62b6daddc3dca696593aea58ee": "Hot 40",
  "dd29c017afcc1d4b7fa1bacb0a586cede1dfa821": "Hot 7s Fruit Fiesta",
  "2e7b6b67a29e1950dff58304ff794579b871201b": "Hot 81",
  "7bdbe5fbcc592b125f8d485d4ade5aa8f80b0f3b": "Hot And Heavy",
  "d634dfe47016ddbebf372f9c9b8602502cc6c75d": "Hot Bells on Fire",
  "579a1437c98a5c5a58ecbc7732eea61becebd988": "Hot Blizzard Deluxe",
  "f8416bb3e3a03db3f5034d3dda6d1d65c5dcaf3a": "Hot Burning Wins",
  "7af14b84690c3b0dcd62438e387b36f5e1f33b9c": "Hot Chance™",
  "aa41e7eea26be87a093f89a501bef27074f91ab2": "Hot Charge",
  "9306d40bd8043db58a0b64e4a0986e5c2bdf8221": "Hot Cherry",
  "9573d266ea7d11878ce6da7cdbd697fc724cf3c3": "Hot Chilli",
  "4b04d6f938eea72dd577f4d630f2c9851db1f918": "Hot Chilli",
  "a5a9629ede824e08ff91bf34813cf05824f46798": "Hot Choice Deluxe",
  "973b07e9fbe9ddc0fbf577a1b170ff6430a09e79": "Hot Coin",
  "bd41f4cba034d1a5e82a52a63bc79b9d9eee3798": "Hot Coin Buy Feature",
  "1cefe98467c4c044dab4bc4afd6c748eabf540e2": "Hot Coin VIP",
  "9d2af4f8df36235c971275f9f939ba5cb55c8a3b": "Hot Coins: Hold and Win",
  "e556ac2d4d691bb80006b15b6fb5d9ac9e63b74f": "Hot Crown Deluxe",
  "149a480863732a29e1ce5b814411467cd6326612": "Hot Deco",
  "b9c9dc80feec5b304ef45514e15b589d16b19bf3": "Hot Deco Super Pot",
  "9ab597cffb640f7593e807553a581e23560df5a9": "Hot Diamonds",
  "03ea9a1b23b00264ddb5814eff026e42aac495ed": "Hot Dog Heist",
  "a4ddef2009d7bfe9fae29251340e2dae4567800e": "Hot Dragon",
  "04feb9038b61e84cc8b47751b8a586ec756fcdcd": "Hot Fiesta",
  "669347f6d677beb23055287fb81e5d0667f70605": "Hot Fiesta",
  "72bba8d8192d65e38b145434b520270861f1756a": "Hot Fire Fruits",
  "4e4ab9400eeb355f50270b3bfce16e6a40f5aea9": "Hot Flame",
  "efc792316dfcfedef50742397c00f70accfb30a9": "HOT FRUITS",
  "78eec8be442fbc801ba1d00c042ea499fb478b17": "Hot Fruits 10",
  "54484dcee4dd47b29b01237026cb2982c2dacb75": "Hot Fruits 20",
  "170a8a7775e81582db8927de2e5b97d821214382": "Hot Fruits 20 Cash Spins",
  "be4fec518bc59256810bd34265bc74dfc9ba17b2": "Hot Fruits 27",
  "9a7e202e71f648283e569cedc7ff2fd612451656": "Hot Fruits 40",
  "1aba785007ca3f987c02dfeceaaf866707177d8c": "HOT FRUITS DICE",
  "4c25d24b2adfe946b2bad2aeb0efbacc2cd91ce4": "Hot Fruits Wheel (Amatic Industries)",
  "b2d4054ca0026fd7319db6252c4b24c07c5be90b": "Hot Gem's Xtreme",
  "abe0afa8f0fcc0b555d834ecd2c1d553508b6e53": "HOT HOT 10",
  "b20a3aef1aa2f0484a8c10b9b568f98c1ce203a2": "HOT HOT 20",
  "407edee7f96eea8b61c4e1df6cd5c21088f8cf7b": "HOT HOT 4",
  "92bf1e4fed891eae82ec9ba3613eb5c9d32bf7ee": "HOT HOT 40",
  "db95bb801f2c21a78893a2e3037e93f84549b10f": "Hot Neon",
  "495e15ab6806eea69b4b185fbaf5e9170573fbc0": "Hot Nudge",
  "1eee73b63e7b249e982d726cc8f058da219eb1b6": "Hot Pepper",
  "7d377fbd8e91af91b97b9a87482317f88561b502": "Hot Pepper",
  "72455695c04b9913043004aab852293fa891f665": "Hot Ross",
  "10064712f6da38984d907c7394bc3b148fd8698e": "Hot Safari",
  "3fd9b81669ff5f2f6ef4d7f40f89c5a953cca15d": "Hot Safari",
  "b0ae8c447eb8fac5e740db480da85fad4fdbab65": "Hot Safari 50,000",
  "217e8d7cbcfc01401921ad43653063b13e7421c1": "Hot Scatter",
  "48066c3be3c6b73d9d51f1c43ce8d62c78d54d91": "Hot Scatter Dice",
  "74ae6656b02c62df9f3b37d4596691d0143d8080": "Hot Seven",
  "3b76960aa4a2fa7b6b30b15344d01b41030b3e86": "Hot Seven Deluxe",
  "b3de9e6fe62dc4781dcce60de90f2692aecb9a8f": "Hot Seven Dice",
  "b56806ecd7e2dc39790356e170cdf57d46a74cd3": "Hot Soccer",
  "4f305f81c042e547418d0d3fc442b0dfd47003af": "Hot Star",
  "ec034f0c4eef4eb33754fbb87ea412a18b61760b": "Hot to Burn",
  "6c1e836ac21e53e9a6711b5b7224d7be02b2f88d": "Hot to Burn",
  "48315eccf6896447f640d270dbd014f7e5e78ddc": "Hot to Burn 7 Deadly Free Spins",
  "8154a4e2dedbaaa0ab1a1ce6ce90b27a999ae27d": "Hot To Burn Extreme",
  "989697576e79b4456d936ffaf1bfb49a045074d8": "Hot To Burn Extreme",
  "b753846c1e59069ac13e1b7534a90390f152d710": "Hot to Burn Hold and Spin",
  "64f23afe41ecb5b86c4609548ccf8a1511e650a6": "Hot to Burn Hold and Spin",
  "5cb5d8f0b32b512b71db5ae244a54906871d9d4e": "Hot to Burn Multiplier",
  "df6981a9a66918b1b08d33040fdb7fdaa151e1b6": "Hot To Burn Multiplier",
  "bdb56a680b0fcb25d919ea1b0c75d72819face03": "Hot to Burn – 7 Deadly Free Spins",
  "eb512831ad68413e95d90f2d7443c18999e46272": "Hot Tuna",
  "553cf7b10b88a3c7c9af1296a79d6adceb8dac80": "Hot Tuna",
  "25cfa9f6ac153a5e59d70ad7bbd9e5702dfdb275": "Hot Twenty",
  "4b70c8042da3338f84acddbb062874d5f5615b39": "Hot Wild Pepper",
  "c30f64274950b9261585ec4522ad205fb98843d0": "Hot'n'Fruity",
  "79909fa4931a187c6bfd30fefa16372f902689c1": "Hotel Yeti-Way",
  "0863a56bc03599947107bb6ce9a1ce33adec65cf": "HotHotFruit",
  "fba867106d93d18797683be3c157d9942ce7811b": "HotHotHalloween",
  "e2f4409c8a704c4ba60f1d98304d0cbcf1cc825f": "HotHotSummer",
  "0f8afca2ee769a6e9a095ab7149c2a71d63b80a5": "Hotline",
  "95f433098b7fe9d25c4f45f1bc7e1370186a5a0f": "Hottest Fruits 20 Fixed Lines",
  "3c93cc13eb1c6f739ced290f0d31aa3f6be45a30": "Hottest Fruits 40",
  "cbd9776ff61b7929750811c8b83fb8cf1d95c2f1": "Hou Yi",
  "c89fad6f786841221a48c7754e512e3fa3ceb654": "Hounds of Hell",
  "d1808a0af14514f40fbb44e8371b2d8fc2a71703": "House of Doom",
  "57e85c01c3a76622ca914327354a1dfdeeaf1c9f": "House of Doom 2: The Crypt",
  "60233b8bea841f33e81ad15965eeca338e0e9e4b": "Howling for Gold",
  "87fa8b873217a6df8df599dfdba8eed5352f7e36": "Howling Wolves Megaways",
  "3227cc533837e0cb9cb696e6c34e6f0015fce8a8": "Hu Hu Fighting",
  "9a2dfb72ff4d8b4718fcd91ea91e3d8c99661696": "Hu Yeh",
  "a7297140a4e4feec26451ba9ff23ffdc961c2a2e": "Hua Mulan",
  "2f1aaac447d59fa55fcdabd704f540a8d2e0f0df": "Hugo",
  "dce29326ff6d777ced38f04a6c48a690f7085f21": "Hugo 2",
  "5c0a32918101b7da349b92e6302abc0cc92cb846": "Hugo Carts",
  "2c086f1e8d49c1454d04aa38224896cf91ea8be6": "Hugo Goal",
  "96db477f57c2c8c0c17111f1bd1383a27cf73f3b": "Hugo Legacy",
  "58f94dafbe27913c9b437f322f8ddcb33485a632": "Hugo's Adventure",
  "1ddf4802faf4da02ad32b2698690a05b002e9bd8": "hula-balua",
  "abf324c1f57ca8ee2ed99e73ce1848accbc864be": "Hundreds and Thousands",
  "aaa044c4ee909809693debd17e21b71c7c7bda38": "Hundreds and Thousands",
  "4eb5dbfffbc9727bb284709b9a039ad34f649780": "Hunt the Bucks",
  "5c287a30ba0c1c6b8c363aa540627b0f9525698d": "Hunter Helibu",
  "4506bb013da5f8c3df2de8869c309495e0906311": "Hyper Fruits",
  "8a40ca2b5fa104acced88af124d036a473b9aebf": "Hyperburst",
  "ff54b4d60f9b1c4e991c0932097a833cebe698d1": "ICE BAR 27",
  "c66dd46c3f7066e068b5e91259bacc213ed934fd": "Ice Bass",
  "200108227cdaf82bf5507f932485783180957816": "Ice Cream Truck",
  "cbffbfd4a71dfe2385ff39f6e78cc483f97c14b8": "Ice Dice",
  "1f1478f9993507477376fe471db7f6a221b939ae": "Ice Fishing",
  "99ca4381a1c1a868989a4dea81024096659145b2": "Ice Fishing",
  "793b461e4133fd4517578cb752d6170cc4d4abc4": "Ice Fishing",
  "b8ad507164ce64a08f1ba7815e2fd4cdbc86495a": "Ice Fishing",
  "c96a73ac673e2bd7a5ba968202ea17fc95f01e39": "Ice Fishing Ao Vivo",
  "84e0469dac7b48e48a500734a7c55403186270e1": "Ice Ice Yeti",
  "06daa68edf2f5915002afc2738d24c09e081a07b": "Ice Joker",
  "21805d5d58c8930c6948da1f2ba9eef1384ddc61": "Ice Lobster",
  "66fc0767d86aee041e763e2c7406a957dc3cba30": "Ice Lobster",
  "7fe11691dfc29ee2ac116afec3a6933235b475cb": "Ice Mints",
  "e549682a14c1c56b40a2caa245abd9e9dc53108b": "Ice Mints",
  "793cfacc4106bd8607c0526476e6e6513fc441b3": "Ice Valley",
  "61c4d18181789564d658832fb228bf1fd72c40ab": "ice-wolf",
  "5e08a90ee84f691643621e0f1279490f79eb5ce8": "ice-wolf-2",
  "b04a51f646ab5db370661015145ac796bd82f4fe": "Icy Wilds",
  "5734ca455598a05c49d3f7de161858eef6227e36": "Idol of Fortune",
  "adcaa596f32f612d7ad4dd59f6a7751caab45384": "Idol Pop Fever",
  "aa2b9fae6b0ad60c3d79426b241529adb213a684": "Idol Pop Fever",
  "3cf9acb991166019c796f65585a4f7790fe0fade": "Idunâs Garden Fusion Reels",
  "281311dd13922b2df10fb6c0b535ab89d666b753": "Ignite The Night",
  "15f28eb2a3c6c2cc6de7ea232a2156e5637e8aa1": "illogicool",
  "11d5f1b313cabc44f72904a84a80eaee2ebae1c7": "Immersive Roulette",
  "9591c76c312c700f3ec4f9d2c275a69c8173635b": "Immersive Roulette",
  "19bd4ee915b5b13414015626cda92f128d6b13a1": "Immersive Roulette",
  "d191eb3aefc9b3707e4b1c330a3c4fd96ab9c5c0": "Immersive Roulette",
  "967af2999548e23206c3d2409cde1f9e77a33043": "Immersive Roulette Deluxe",
  "9efd89e8956832f304c6f37b465eed8f4238bee0": "ImmorTails of Egypt",
  "19433c2c41cb2ffc085222c78850e358219499f1": "Immortal Desire",
  "269da810eab5a91319e3e5cce5679fcafb612411": "Immortal Empress",
  "b1a34f6da0419b72d3539b1aaba80e2bdc6c1cca": "Immortal Ways® Champions",
  "12e36430727cbd84ed59e5e24d1da2bb60db1aa8": "Immortal Ways® Cleopatra",
  "f43cbac65db3613686e47986b452bb7c7b8f4216": "Immortal Ways® Gallina Harvest",
  "87d17b98ec8f34b7b90f8cb476a5af340cee8931": "Immortal Ways® Heart To Heart",
  "0e62b46289942e0b38c60a75d15083e8fb81f4f7": "Immortal Ways® Lady Moon",
  "6f7c04bbde5477fa2ed5691ede0ad7bd0b09aa75": "Immortal Ways® Spooktacular",
  "51bf930947489540cac595a8499672d6da1a6dfd": "Immortal Ways® Sweet Coin",
  "8986ad5c2e66c1f144a6c5595b65a9fa4c042bc0": "Immortal Ways® Volcano",
  "ef5b0be902bb3240370b14e8de26d535dc062f6f": "Imperial Dice",
  "75e7e97c262680559fe2e633d7bf91bbf05dc2c9": "Imperial Fruits: 5 Lines",
  "4e48f0c5ea0d6ac68837a60710342026cf680d05": "Imperial Girls",
  "10dbe6188f951fa649b20ef23787130ee4410c67": "Imperial Opera",
  "07be6d692f90be14952eee838f6a01dd22a49ef8": "Imperial Quest",
  "80a4d0dc54b650d8a5fe8be8210b041f825217b8": "Imperial Quest",
  "7887a462e0f0e858c296d7c37a35225ecb1ef8cc": "Imperial Quest",
  "6357d116124f970407a971a31a61324a2f178b41": "Imperial Wars",
  "eabb4fa1ddab1ac11e991b5c1c56078c541f40d7": "In and Out",
  "a79a0d5109f0511e466adea7b45b4f45071eb2dd": "in-the-zone",
  "a5a69ceadda2ca0d8e74365e6e9f9672f5ad290e": "Inca Fantasy",
  "ed0eb6cbab8394e2aafa5e0bfadbf7bc8fd7d1a6": "Inca Gold II",
  "fa69b88f2d7d42269b374d87034f7977471844d5": "Inca Lost Treasure",
  "4e4a2a002482178ad615312ed151562c9c33ec53": "Inca Queen",
  "022a72ef534abce416ac119e16675ca0952fe909": "Inca Queen",
  "bcef62b1f02632aa7d2169771b68dcf9db73c3bc": "Inca's Treasure",
  "637a72a42e28cb0047686acb5540aa91a5627152": "Incinerator",
  "eba90136255b177e2d9111aebf9d79a01fec172c": "Indian Ruby",
  "d86bac9cd9f2cd5a4ea0ce81cd9dda3d658c336f": "IndianaWolf",
  "6cbe493ca81eca4819aee1d4aa14625a247ca1da": "Indonesian Speed Baccarat 1",
  "2855ff4ad546b0f6fbd78fae8f5e0ffe5fbe0b1d": "Infectious 5 xWays®",
  "fe1555e135d1ec6b0ec354dca4dd75d8dca7a701": "Infective Wild",
  "50643b57fa45dfedc54aa608905e3c22fdf1f465": "Infective Wild",
  "216ecec668399edeb8dfae163b1a125020c44af7": "Infernal Fruits",
  "1efb1b00e2574c079db6637529bef9d62d2243ac": "InfernalFury",
  "9c0f74819db2e248943625c33d40e70c94d85374": "Inferno Fortune Power Hit",
  "729167cb0e209ca18adb3ccd8ec27e27f97e0c55": "Inferno Joker",
  "72b287a7518e45544565d6d2bc6a95ea0ae4d012": "Inferno Star",
  "fe9faf56f51a53558267724dadae51315305e16d": "Infernus",
  "428325927638f2eae7c3e7431a683f837bf6201b": "Infinite Bet Stacker Blackjack",
  "825f220c16d83b91ad2204d0eb74e47c9843f411": "Infinite Bet Stacker Blackjack",
  "9e0e987274e5b7fe8d3157068118fc8e51ce09ca": "Infinite Bet Stacker Blackjack",
  "f1997cdc49be03651a80c714aff48231844fff66": "Infinite Bet Stacker Blackjack",
  "26203227bc4e2c2c4844e992d2e96480dda53b29": "Infinite Blackjack",
  "67d4b3b884693fd8994a5c29e72f0fcd7d3dc336": "Infinite Blackjack",
  "b299bc125d7a404013f36fd51af7890407faf129": "Infinite Blackjack",
  "b42eb119ba5c939d8af44a7bd1547b6f045388b0": "Infinite Blackjack",
  "b065625bf3d4024559388becf2e4c1fd41f0fbf1": "Infinite Free Bet Blackjack",
  "e3704633550eb39190e39efd949af0069b585515": "Infinite Free Bet Blackjack",
  "38bc01f826ff6c82cafb3f8d06d6e6f869c3aa93": "Infinite Free Bet Blackjack",
  "2f7c2ea93ea5cd6250b328ef2008c6b59c9322f3": "Infinite Free Bet Blackjack",
  "78a09fff7f779999b4dde1b41eda519f216e2532": "Infinite Fun Fun 21 Blackjack",
  "7db8686792bb167cf8099d269429484343085799": "Infinite Fun Fun 21 Blackjack",
  "f31ca675ddf83afbba7b57d76a9aa70ad5336f42": "Infinite Fun Fun 21 Blackjack",
  "8edb900bb930dca3442e3405c707444899976ec3": "Infinite Fun Fun 21 Blackjack",
  "eba90adb2db7ad0efbcf30f7ed4e350230494590": "Ink Painting Master Buy Feature",
  "eb3067ea1f0e9effa5957de5edbac2f520742aad": "Instant Roulette",
  "fe1b6de83199f178000e0df862c13222c7507bc2": "Instant Roulette",
  "f91c7fe69785037e4269095eb279cc59b72d9bdb": "Instant Roulette",
  "5f25e0810a37b361881cfcf7f4aa5a34eebb1499": "Instant Roulette",
  "5c6b5dd0888235383d693ad314e64fcf5f1179ed": "Insurance Baccarat",
  "f4be83c2e94c4437a31b9941ca52e79486d1d876": "Insurance Baccarat",
  "e43a5ba96d8e30d4b35ffc69ddc4b2df8a691454": "Insurance Baccarat",
  "cc2de2921fb7c0f401ff5a8595b5713ca805969b": "Insurance Baccarat",
  "32f4e36999098536a7a577bca96a517e993ec04a": "Interstellar Home",
  "4c59e6593827c6f5aa5a40d67f18e5ad51115ee4": "Invading Vegas",
  "6a5d0776b1e96b10baceaa81c64f0ab153ec0cde": "Invading Vegas Revenge on Mars",
  "8ee1c122e8d61bc15bae67112b06b549b9a2b4f6": "Invading Vegas: Las Christmas",
  "b45878b412734041a3f830e50ec36262e7cb449e": "Invictus",
  "238402b257e2524c52387f5289922231340ebd71": "io",
  "049461228c61e0c844b6dca5e40bfbf8a737fd03": "Irish Coins Lock 2 Spin",
  "ff1e01d7d36c0b37d2d9bbafde03accab5346e20": "Irish Coins™",
  "fcf61541e6e02549f15f0aa4a3478ef9ba0ed8ab": "Irish Crown",
  "eaa3cc1fbf3fb10d66f00cebcff3cc3e0250e921": "Irish Crown",
  "74c2fe8c68a518f6dc97eaf4f773c3efca3e2443": "Irish Gold",
  "15ce98aa1c53e7935b1b17f7abeb7d13eaf09d61": "Irish Magic",
  "1ca5d72d52b38a5ca0fdfd67773700685491edb5": "Irish Thunder",
  "b58b8ef4bfbc048c6dbd20bb71af18f8da104384": "Iron Girl",
  "7f4fcaf24021957d727c89e66ad9728aaf7b5942": "Iron Phoenix",
  "697d316e78eace13c4676108cddc288af603370c": "Ishtar Power Zones",
  "f8ae2be01946ea4426a21c9165a2f1891987d3de": "IsibayaQueens",
  "3cb7e8645991aaf0921149432bf16902d11fd748": "Island Paradise",
  "f9d8cf517a9330ecbd199db5085d5651fb6db6ef": "It's Time",
  "eaf4efe945b866b735218b95d244c9328ee93ffd": "Italian Lightning Roulette",
  "8d9db0b180917e4068ad6a84608c33033943b215": "Itero",
  "3928b591ada595969381d9aa840f96319d998cb1": "ivanhoe",
  "41205852c325f64190f8174b53de01382a2300a9": "J Mania® 3 Buffalo",
  "d0b93cde7e1128adeb6a2dc8523f66a04ee2f64a": "J Mania® 3 Loose Cannons",
  "521580a288cd0cc3a273d8312ba0348f9a7b645d": "J Mania® Diamonds",
  "5a0d7ed25b0a07717aced79cef2ae5bf4b8adc92": "J Mania® Goal Nations",
  "b67f50efbe2543532d21c67ba13138912ecf28ca": "J Mania® Lucky Pyggs",
  "660accac4b77f65e64a7c11f99c64b96881dbee1": "J Mania® Mayan Cache Dice",
  "e6c5e1d3955445494df9bd2b44d73b81ad9c6fc9": "J Mania® Triple Jam",
  "e270f6e3ffdb189db3f2bd1c6bf40acc01f8b089": "J ManiaÂ® Golden Eggs",
  "968e489adbbea1d78bfd9176b11426b845324ef3": "J ManiaÂ® Hot Asses",
  "735b5d03dbbff81a3642309b040643806c2ec7ac": "J ManiaÂ® Maniac",
  "65ba58a37167e71f8d88dcae6fcd79113b39c698": "J ManiaÂ® Turkey Chef",
  "5a38a8eaa17e2185ec4985a6d2a97fbb9c49f5ef": "J-Monsters",
  "e66ca5ca4794be52104f9b59458313098ccfb6a0": "j-pop",
  "10fa5dc2d8442a390612dc1b29efe3fa1fb411af": "Jack and the Beanstalk™ Remastered",
  "812b982abcb0e0f057bac0d9abd8af06c2139024": "Jack Hammer 3: Diamond Affair",
  "690c11dafd08aa47805ad218702447ea106c5400": "Jack Hammer 4: Chasing the Dragon",
  "4962466cea76df5f8e1f75ebae1043fb0eac1157": "Jack O'Lantern vs The Headless Horseman",
  "22dc6c3905bbc4c9ea0e4f68447c5492356f13e1": "Jack's Crypt",
  "d0095dcd01e112d35e1cb46b9cafa7eeac78dffc": "Jackpot Blaze",
  "a24c1ac22353fdafbb574605a5573a7294c45f4b": "Jackpot Blaze",
  "6b01b2cdcfb06012f3b8982b3f0d3d3ccf16f72c": "Jackpot Blitz Rhino Blitz",
  "96668336701d5f1210da7b5cff812475f8bd7d7b": "Jackpot Hunter",
  "2a5f012f092881928ebe189a61e5c7af4bd643ab": "Jackpot Hunter",
  "2b128490995474f9992007a9082f68cea7cd73f9": "Jackpot Lab",
  "b047074ad3c6bdccc3d4dd452fbb9cf2dde0b95d": "Jackpot Nights",
  "c635a0c9cea0389823101d3a48131d984fc47bfd": "Jackpot Pagoda",
  "ad53cbd0008231341eb1a8f1f2574e65b41be824": "Jacks or Better Draw Poker",
  "655c4969a84f858e56c3ee1e7d32516febb3034b": "Jade Butterfly",
  "7a0b59cae98eb3b3b820585ac4c236e7d2da582d": "Jade Dancer x1000",
  "61a41232bd17ee5738b6b7f59db392157c9e64ac": "Jade Legends",
  "346831e7169a8767e63f4a4feacebd5891d78858": "Jade Magician",
  "43b4d12ee16b75bcfd662abb4412d5e1169557e2": "Jade Power",
  "5e886682e4b390e5246fac1d36ac8632051fba31": "Jade Valley",
  "e0fb47dda5f23daf900b7410d57c7164a5fcf352": "Jaguar Drop",
  "8e05c876afe811c465728e248cd2698c64e6aa99": "Jaguar Treasures",
  "90ac2a1116fac6d9401e8232fa43d500b32f637d": "Jam Bonanza",
  "61ad385a822eeb4a0112b556d4ffc45b551b6eee": "Jammin' Jars 2",
  "a392877fb4dd7ba72b50844f09a3ed6e231144da": "Jammin’ Jars",
  "84bf7b8283dba35732a700861f725a3953dc7b50": "Jane Hunter and the Mask of Montezuma",
  "3aafd6b75da63e82755ec5e769dea98859d448a1": "Jane Hunter and the Mask of Montezuma",
  "58d405f201070d13c9ab852c942e59e61017fb6f": "Jane Jones Book of Kings 2",
  "bdae4e9b8ade51ba63c5086c4c296705720972f8": "Japanese 7 Heroes",
  "c2bf983d6450d1090577b964cc8519030d47c318": "Japanese Roulette",
  "217aa9ed5195e28b071d578261d9af237968a16d": "Japanese Speed Baccarat 1",
  "df42977114dec00b0c3c4786ff7200ab9e85193d": "Japanese Speed Baccarat 2",
  "cd793dabc9f517bca10ad353b3538a5009c43b29": "Japanese Speed Baccarat 3",
  "ff04eb9cccd662be20bc5e9185ce1ac3acbd4e32": "Japanese Speed Blackjack A",
  "a1d3bcc8e685c2a1a44dfa8db2cffa53e706c0e3": "Japanese Speed Blackjack B",
  "8b067d724025c8c9b46de2e3bed30f7dcc06c802": "Japanese Speed Blackjack C",
  "e7e9e9056a27377c89631a05f762974e257093a3": "Japanese Speed Blackjack D",
  "aa9e57e3b8ac168b3ac4999ecc1b5ba7c37f4763": "Japanese Speed Blackjack E",
  "19fc8420927cf578a9d09a4e5fdb9d1199395a30": "Japanese Speed Blackjack F",
  "e3a56182d12be10467f69889619de838b9918b1f": "Jasmine Dreams",
  "d4cb8246f6c4f695371cff5bf8ec7b29b53bc200": "Jasmine Dreams",
  "9d9db687229d2f18bd0a56da5be823837a914b6e": "Jaws of Justice",
  "f6d85f03213856a8f186fa47924885e87a9ff710": "jeff-scully",
  "8d2aa74d32947e17a1fa01aa53a8134e432999a6": "Jelly Candy",
  "3c872b38e8b6e7ebf8e743e35ec44a4777ca38bc": "Jelly Express",
  "c8bb4df9a30d067990de87a7b46543b521f7aa15": "Jelly Express",
  "97205a60754788e004b093f130f3e5b20465c754": "Jelly Slice",
  "86229339f2f00ae8f07db0808e096036d61e18b7": "JellyfishFlowUltra",
  "3f528bd93628894fd04cf4993cf75b63842de55c": "Jellymania",
  "8f12b411b6e1716f36e98b0bd2be874a4ddb0cf5": "Jester Bags",
  "4d92967cfcfafecfe013b128255226954c7dc2ba": "Jester's Bells Bonanza",
  "4d6e26db6c41251e2690ab1c51fe97ccfd4216d4": "Jester's Riches",
  "3b7e57988f0eb70d74cb3a214c567dff804d9514": "Jewel Box",
  "9ff4576cd621b4a1b85ccf1a3cedc923793433ab": "Jewel Rush",
  "d61b15176a6afe0c91e5d01d368421a6e24b2836": "Jewel Rush",
  "3a866f6b8aec2a44caa3142258d7a2d6748fa5cc": "Jewel Thief",
  "8c791f08a7da1450e1d0f4d7a459f302648970e7": "Jingle Balls",
  "fe6ef5b8572fd4f3edad018412c80d257e11b299": "Jingle Coins: Hold and Win",
  "7a29243a96f43a056e41742b60dbee6187057a43": "Jingwei",
  "462f772f4784f2ff30ab5d44a7efde84ea8feb3a": "John Hunter and Galileo’s Secrets",
  "c57e2a28fef689e29ac9133064f151ff5d0ebe8c": "John Hunter and Galileo’s Secrets",
  "87534825041724cf1943388dc6d69893ebf86e74": "John Hunter And The Mayan Gods",
  "0b1197f42920ad2cc22f4ad9a525912a0bb60c63": "John Hunter And The Mayan Gods",
  "371f1d002a182560042b9011c0b97b5924a29487": "John Hunter and the Tomb of the Scarab Queen",
  "b38a8e02db493a709e229a817ea3720c8e637ed2": "John Hunter and the Tomb of the Scarab Queen",
  "d4cd9a63f09db72e590123826de141d819245eab": "John Wild",
  "6d2380ba2efe357deb83a955439c71e741ea4ee8": "JOKER 27",
  "503b23d25aae410f00dfaf6c5dee5fcf723950ee": "JOKER 27 DICE",
  "737072cd60aa503d3c2edaf3e69b775e17f7aa50": "JOKER 27 PLUS",
  "20515654fe99d33109185972cfa5af59e6bf4b7f": "JOKER 81",
  "12f9a8d3e018de8b0352cc29e20501c95f3e7022": "JOKER 81 DICE",
  "66feb114b2d95b5c04ffa175164c5467f5cfa3d5": "Joker Action 6",
  "180f479c596d4984187d4e50262eccb0f08eec59": "JOKER AREA DICE",
  "1d22edd19727c0219325249e3f4d74c3f2d183ac": "JOKER AREA STREET",
  "36cbbc44dc203535f6e064e79ff419a9cdca54da": "Joker Bling",
  "e51c14acb17fc74b1267f72a06ba6abcc5252e27": "Joker Bombs",
  "293026f7311b52ed6fe4d68353dfb873039bdcec": "JOKER BOOM",
  "dd673cc6b4643a3ec60e2c37f6124bba94168b12": "JOKER BOOM PLUS",
  "5d3d4c42fad0cac9d837d4dde5dd3df81ec3df4d": "Joker Chase",
  "e728dad5b295ac5563f404cd6f429c74f9400daf": "Joker Empire",
  "499594add100ef6fc3fdd03d8501881b979204cf": "Joker Expand: 5 Lines",
  "aebd5961ad3c3f7f3a08e83b236e587bb1c38732": "Joker Fiesta",
  "da0be1e45940b6fad8abc7b3182db51015d89612": "Joker Flip",
  "6e5cc9479967f53bb32e5829050455eac39cc03c": "Joker Fruit",
  "ddb511cf2d6e5fe301d4aa132d4f46381cbb34e7": "Joker Hot Reels",
  "1dd9ca0b13e065a5add5c566dfb1dbec308b05d2": "Joker King",
  "3ee0cbfac63a9037f5ba60dafe6532322ddde362": "Joker King",
  "2491a0da04e0e266f9cccfd9bb2ac04f00f82924": "Joker Nature",
  "7903cc1c8bfa4dd7e6c52a7d009bfd733cc3b0bc": "JOKER PLUS II STREET",
  "ff3ffec6c9c3bff7a2e6757f677d65722436f94c": "Joker Race",
  "841eb4c737dafa7b2a395c97874a41b86413257d": "Joker Reelz",
  "f198d42fa1862144c938efd731ed2ebf59b893c7": "Joker Rush",
  "93d44bc7e2b1f6cad01024eb254f8b1a71ae8396": "Joker Rush: Cash Collect",
  "8be8fb51d23c971c47f62059002856b9f70ea41e": "Joker Rush: PowerPlay Jackpot",
  "18926729cbe505c131d14486c0ee26807a9a9b40": "Joker Slot",
  "b5bfc0631d7019443ccec671818536b1b2da95fb": "JOKER STRONG",
  "15503cec7d9080d87e764c344a3d5567e95a2444": "Joker Troupe",
  "2504b4bb1fea425eb79acd3054f24412a5a18f6e": "Joker's Coins: Hold and Win",
  "fbf0272251f932dcafd8d9e2ec16333d3a960d5f": "Joker's Crown Expand",
  "d1d70c59a79b9314914299d9f203299fe514715b": "Joker's Crown Expand VIP",
  "014177b25ff0bc2b382b9868d9746839dd401451": "Joker's Jewel Dice",
  "89751da49925f4cd5d84075823cddb2d7c2dcbc6": "Joker's Jewels",
  "844e9365e53751e3042fb6b614f05893ca1ed187": "Joker's Jewels",
  "80b81073c5c5c5825218549bd838d56e8088d6b7": "Joker's Jewels Dazzle",
  "375761cb4ee869bf860af420efb53f3ebacb67f1": "Joker's Jewels Hot",
  "29df616d7b034cc7cb7bf44e234f279d2184960f": "Joker's Jewels Hot",
  "2d0b30d388fe87214227a84ef6a1abb8f3c8b9cb": "Joker's Jewels Wild",
  "ca9b580049dfb1dee449fdce61b927e02d86483b": "Joker's Jewels Wild",
  "6e73487527e1d677a3ab6298fba2edc04af8a3c8": "Joker's Twist",
  "a8df03a20dfef20cf849ad9b213b33756e53d06d": "joker-gems",
  "fed7685d55bb5aed87f426ce9f7a7668fd1a4401": "Jokers Joy",
  "ee8be7c810920b5b402b91085dadaf3e900467f0": "Joker’s Crown Classic",
  "2f2c1bac7a43817abd9189823b6a51bcb89db261": "Joker’s Crown Classic VIP",
  "b2c320c3dc8744bbd9550c7fe9f7fb2a9028fe11": "Joker’s Jewels Cash",
  "a5d67a4cae2a601c844dfdc8023a282ccab65de5": "Joker’s Jewels Cash",
  "61c0cd87a402c2b930a559484394ffeef758841b": "Joker’s Jewels Hold & Spin",
  "9e9ec13248216399dfce174de36d4efecb963bb4": "Joker’s Jewels Hold & Spin",
  "fcb6647e0cf494fe1d99ccdb2fa0125c670d62ff": "Joker’s Revenge",
  "f29ebec030aacde11bdb4a7b7781a85fa67f81e9": "Joker’s Revenge",
  "b7960dd73bff3312f6a91997ac0d3e5c933f58ea": "Jolly Roger",
  "eba621dc714ab1089b3b0394b11175c149d991fa": "Jolly Roger 2",
  "a291b92212d44b765eb3e4ba47c07bc285e387df": "Jolly Roger Wild Kraken",
  "a851812de7e365b650cb59877421de05209e026d": "JOLLY WISH",
  "0724b0d46c13e0a2b87eadbf07643dd55c57ec92": "Jolly's Cap",
  "12bc34bfab5676361efae2b5058e26e61c8f2997": "Jolly's Cap Power Spins",
  "8059ce09235894985c46ed4ffe3927e4d7da2590": "Journey to Paris",
  "72c3b62ba7348f9b20d2111391cda009928bc501": "Journey to the West",
  "9f3f5951bd23e7893ab5d63fb06d50654fcfa159": "Journey to the West",
  "b4e19c80004b160eefb265e0bed8225db4d4623b": "Journey to the West",
  "96845fbac5ed8c22b38bbb04f54889ac703bd7f1": "Jozi Gold: Soft Life Deluxe",
  "a65fdd9c4ea9cec5b32e00828ecef5d562999745": "Judgemental",
  "8150842b615589f02efd197fb1061dff910af218": "Judges Rule the Show!",
  "a675500c4f2ad846e8d8c6895f83a71669a60f57": "Juggernaut",
  "87e73b0b8597779ca0d6a7e7273125209ee0033f": "Juicy Fruits",
  "85ef665a17e37fb129bc624f48afb65449dd9f51": "Juicy Fruits",
  "491ee2e3e38a18bd2a3f9f45cba710680a3cd2d1": "Juicy Fruits Multihold",
  "842b9d055eb9c1a41fc59d112561155b456c8f86": "Juicy Fruits Multihold",
  "781b7cb6758459dca4ccf5e49e464292365b6de5": "Juicy Sevens Jackpot",
  "e213685b553193b75c0624ae72f34e8b2b4190c1": "Juicy Spins",
  "e089782c33eb1f0ee16e776dbd49b073f7248cbb": "Juicy Wheel",
  "3c88c3def6a42f3796e1a929dc630ffae2641790": "Jumbo Juicy",
  "783b355d2b430f269549715e69e83d995742e12b": "Jumbo Safari",
  "bf6e5ca3fd19857a77171538f7f7f06ee84e0e4d": "Jumbo Safari",
  "d8c47264d1b2d13d285fa893082156f1eb59f986": "Jump2",
  "f9d07ad1d537ebfaff3b5d5d691e863d43a91a46": "Jumping Frog",
  "dfccb17e24c959ec41c8a63cd2b68d0f0f6462ac": "Jumping Mr. First",
  "d6057a358d29db84d98ec9e4a5669b32823fa576": "Jungle",
  "0ff74552993b1e8af64cf0c58962bbb511937b3d": "Jungle Adventure",
  "ff07fe4641239bb85c12d9fd746ed29771dda2f5": "Jungle Break",
  "c447492604c97943fc08b217c6006e98c278f984": "Jungle Gorilla",
  "c9f1ab3cf14dea0cf68f0bac61a65bcee71eec8b": "Jungle Spin",
  "ef0baefde2e094cd0422d424172785ff90a269cb": "JungleRumble",
  "bdc27ca8c6fc935d8fbed94223375f2f02341209": "Jurassic Giants",
  "447e7f32ac7a6ef4d7cde81ee56e630652f0a9b6": "Jurassic Island 2",
  "578fac4f35fa5fe4f3a8ccf76687a90b2d153595": "Just Jewels™ deluxe",
  "0a457b0f96fb6780f9a6bfbea9174d0f28e24cbc": "KA All Star Sports Day",
  "1be3b2d93167267378fbd22dd106ce89ac915791": "Ka Ching Boom",
  "5ad4af2d9b82f033793988d868c53d218436b81d": "Kai Feng Fu",
  "a4f259e802f5794aa520cd9dbba6d0bc8c985d36": "kaiju",
  "5f09115887d4014e51fa832f8115e424dcccf11f": "Kaiserwetter",
  "0c4c599fc688347f554f72aa5220ac75fd9ac12d": "KAJOT LINES STREET",
  "a6e16ba9ac3e03b8fb52f573839e3d65b9341574": "KAJOT LINES STREET DICE",
  "26407a8671abf7c9cdba1fd7eea8dc2d3d692248": "Kamakura",
  "a421d6b1ec0d6b928c4402968273f5f08270c3c7": "KanesInferno",
  "ff3dc934e7451bfb927f60dea25942d3795977ef": "Kangaroo Land",
  "df814d4061349ebd36e9e897e1f6ea47c23bd7f3": "Karen Maneater",
  "48b2bfeb86c513720fd5ae0a6cf370d73cc55016": "Karnak Treasure",
  "34afbede205eedaf8fa1632b3dd517311f37b091": "Kashmir Gold",
  "a33c0f939907ecec0ab39119ac3b29390b36e470": "katmandu-gold",
  "550a4a19daf4feeff86000a169345b36a98b8703": "katmandu-x",
  "176f70950d105365a299d7a05048ac7cfac20c7f": "Keep 'em Cool",
  "2b0ad812d77fbec7d56047d01e1936ac077ea501": "Keep'em",
  "af351b60a66b6604e388cb4b3c311e68152be9db": "Kemet's Dice",
  "58b5579477cc7edd012dc1e3bad2544223e2e01d": "Kemet's Treasures",
  "fb0113e9d33eb99353ec1483072fb4c187e266f9": "Keno",
  "dbd7af5eba57755d7ff27d9f498fb0a1011bce26": "Kick Cash Croc",
  "6ed86d87e138030c61eda8d82ba28de38f51590d": "Kick Cash Llama",
  "5126f2f1e6c96254d7b25b1cca4cba9e8995fa2a": "Kick Cash Monkey",
  "d7d58b7fd5b16ef616379e148f1333da52683219": "Kick Cash Monkey 2 Buy Feature",
  "d428770c3a0589ba38ee5c4293dbb48660f576bd": "Kick Cash Panda",
  "f8f2508e6105d4e703b553aff2c0067f14e939f5": "Kill Em All",
  "e52435660774c0b2e11e338862e55c5b8b2a7a83": "King Blitz",
  "9bf90c025cc2ee1c27b73812f99a86351b736a8d": "King Carrot",
  "e3b45b6e580db53c10bc7da8ce794d1ad8a47372": "King Cobra",
  "e3ede44cb847e818275f3c28ed300d359b645bfe": "King Midas",
  "05ffd330b37b61658a290c348a07ee0e4be22493": "King of Dragon",
  "90be6b62cb08b4520438362efb8f6608a221dce2": "King of Fighting",
  "b145ab33dfbfa14441571eea988c9878bc396d3d": "King of Spear",
  "a3a53b9de449174d81d5ca7b919e02881352d757": "King of Sweets",
  "dc573249b69972235e9da57e98e8594de5e805eb": "King of the God Zeus Lock 2 Spin",
  "95a84a21a958334a6d3af7d9188060710985876c": "King of the Sky: Hit the Bonus™",
  "b727c487a3dfbe0c097872cf0542ed72448da55d": "King's Crown",
  "dd0701736bd1ec23977eaef030245ebed9ca919e": "King's Mask",
  "810f3e7c9d6b3ea8968034394d6a75599a776b47": "King's Mask Eclipse of Gods",
  "6ada0044d08340dbee90a8b40ff534ba2c4fee4a": "King's Mystery",
  "46c78ab7e7f3a036318ab8f3b3987039adbbf683": "King's Sword",
  "2d3bacbd2e1dd6642313a3c0d78f98918dd2440b": "Kingdom Below",
  "fce96fa52fdb18818e3e8dcff5b337a538a2ab45": "Kingdom Crown",
  "205f86d4dc4efba280bb2323ca9ad45d0049bc79": "Kingdom of Asgard",
  "15384dfa01a0bb867a254a365d3eb3579b6cb366": "Kingdom of the Dead",
  "fd95280c8f365d1f8a185309e3573a40bdb203bf": "Kingdom of the Dead",
  "11f36f304ebf8044ca623fc813e86fb1b9fbd2f9": "KingTutsTomb",
  "8b2e90f06783a05942a1bd42ec0304b3e1e99a5b": "Kiss My Chainsaw",
  "7d9c5677da4367ec5542e7ff91daebb81247b94e": "Kiss Reels of Rock",
  "b67e67acd9282aaa457deea381fceae0371345f8": "Kitty Glitter",
  "0fa2b171903668bac2ec8ea3a79e5bbab86cd92a": "Kitty Glitter Grand",
  "2f499ce95dc9d9f4f244770f419fbc52c5d41787": "Kitty Living",
  "d34e08d6c3b346debb5ead601274be88a1a805f8": "Klasik Bet Stacker Blackjack 1",
  "30e05ecac939743b17e892e55081b479c7076eb6": "Klasik Bet Stacker Blackjack 2",
  "cba00266f7738fd33c118ee13bd020af35315be1": "Klasik Bet Stacker Blackjack 3",
  "1da1be27c9221e0a702c94cdde8d51313d4f78ee": "Klasik Bet Stacker Blackjack 4",
  "95ea4e7d77f762bafd50c80b36121063ecb3239e": "Klasik Blackjack",
  "a1452f018275ea19eb0622be30ee3ebc78d0c328": "Klasik Blackjack 11",
  "5ecf0a7cb01581c7e2b1839f54802323ddb481de": "Klasik Blackjack 12",
  "ec09be8b1efc1b6577d79d24f812b55091ffe944": "Klasik Blackjack 2",
  "9b03cd223f90a746bf17e5e80a3a472609987354": "Klasik Blackjack 3",
  "4d21bedc8dfef04c39c659c6fdb354300822d574": "Klasik Blackjack 4",
  "4e639a17e8e63f0e43b3948b140db10779a135ab": "Klasik Blackjack 5",
  "dd95ba78477afc1675479d90fb5eefb97314fc5e": "Klasik Blackjack 8",
  "034a744f15250dcd821deb43ad16c2e30dde767b": "Klasik Blackjack 9",
  "4bf23f7eec89922cbb413a8c5be68382278046a2": "Klasik Free Bet Blackjack 1",
  "f2d8176b832c46fd1a3578fed59e81b5eaa54fa8": "Klasik Free Bet Blackjack 2",
  "a297c3ba28376620a921f4a9fd0fa7f0d58a79d6": "Klasik Speed Blackjack 1",
  "89767c1b246e4ee874df2124cd77f03aed963109": "Klasik Speed Blackjack 2",
  "8d9e388360184faa947dde06fe2a6b78d9d274ba": "Klasik Speed Blackjack 3",
  "911d219defb0afd338061678d05eee145b6e962b": "Klowns",
  "4bcb79d8c0a109169fa7cd0e5dd4ca38197b58dc": "Kluster Krystals Megaclusters",
  "dfab81b13ee733589092cc3d003eb0121b61d59d": "Knight Hot Spotz",
  "9564fe5b5ab37af7378ce1055d765e063e97bcef": "Knight Hot Spotz",
  "d2c6d2f0ed80cca8dd6b6ac6cb07095120ee492c": "Knight's Heart",
  "7b7a192e7d983b46fedce24f0873cbda2e440c1a": "Knight's Life",
  "6b4957dc3177f25cbe59c922e12f9afb1ce20d16": "knight-fight",
  "ae99c673d6f45709a26d4235833fed866abcd17d": "Knights",
  "3918dee691a3888fc4c51767600e57dea45fec2d": "Knights vs Barbarians",
  "05b11795683ce820061f0be867bec1788b3ed5d7": "Knights vs Barbarians",
  "5a5068ef9e13289ee0dd80fb617e611cc586b166": "Knockout Wins",
  "2cbe416dafaf7853870881c1e487ba9b0239bfe0": "knockout-diamonds",
  "28de29f82ae16c3f683500bec3306ab038ec938d": "KnockoutFootballRush",
  "3a00392d17e8e626e141923355e3b76adead1092": "Koi Pond",
  "3e9bd1723f5dd3e8e0293ff1228ac0bb42486246": "KoiKoiTreasure",
  "e6816ba4561fcd674baf28a663be9f665b15f084": "Kongo Bongo",
  "5297248c08a3b162c74c3c41447cade25095f2a2": "Koningsdag",
  "e3999e71228cb6fe3a7467cad6876d72524e47e2": "Kraken Spins",
  "0b037a4f2d161aa1d26ab97e40ff947946a8bb36": "KungFu Kaga",
  "a7466ea2be54814f9b931523e2d48c242c42a39b": "KungFu Kash",
  "84bd4f9a1982f90f90c686c74495b3c8bc3818de": "La Gran Adventura",
  "b915fc95656706bc3888e174954718eae35bfb1a": "La Tomatina",
  "7e22088f56d9715cab6cb50a9b27f90e8fbd01c9": "Lab of Madness It's A-Wild!",
  "d9740246d50b9bfe4984f2ea40a8ff3676b8933a": "Lady Forest",
  "33086a85b416e0d1877ebafcbd6913e1dba1e23e": "Lady Fruits 20",
  "774712b24e686e645683f562df4c8d0326e60a1d": "Lady Fruits 40 Easter",
  "db1c8d37e52dc593e09277220f1406d2dd8754b6": "Lady Godiva",
  "529ca86ccdda25ae4f281c129b6333148ef570ea": "Lady Joker",
  "d1cfd4e71bb42970bb8ec36b4bebcc0da8327ee4": "Lady KAKA",
  "1abdb046192aa72d178b978056d90b387698b4b8": "Lady of Fortune",
  "aa0e41ea843b7d89a47e97ca23e9689bf67e6e13": "Lady of Fortune Destiny Spins",
  "6afb564e87fdfd0738730d309538469edddd5496": "Lady of Fortune Remastered",
  "41004e06ebcd7143a492ee15bcd5709900ba365b": "Lady Phoenix",
  "e1f0d639a3b3570a49b3ff1e393ba0f6bb52b5f1": "Lady Racer",
  "10caae63daeeeebe4fc957b880395aa1ce2fe5c4": "lakes-five",
  "82b0aba42b20f589979b8d0a263e59590f2080aa": "Lamp of Infinity",
  "813aa56dd387a1d87a92e570b74856dc32704531": "Lamp Of Infinity",
  "b579c8ea98fdb9f79d5e986e0cbc96d206127a3b": "Lamp Of Wishes",
  "2768def63fdcb3c47e1e1defe0d8e6d6867e7ead": "Lamp of Wonders Tapper",
  "10d5f5c8ff6027ad7ee4874da152e88d64820f72": "Land of Dwarfs",
  "c48f640805f57f03ec3766a0f27a1e94c62fb707": "Land Of The Free",
  "fd99fc477c14807559e2a896f2c5aeb0cabfe715": "Lands of Gold",
  "7c8b148940c7d38f16458b79dfd8e61a21f18dc6": "Lantern Festival",
  "ab76081e4991b0e7de560243b0b557db80329c1d": "LanternLuck",
  "096c4ae9c080c8b8a3f670513b2e3d7fd68123c1": "Last Fantasy",
  "aaad0d0fb2782731f18748c70b6401f26ee42f4c": "Latin Heart",
  "8b1592186b702697788f58226f392d90516a5597": "LaughingBuddha",
  "8bfe0fe9e70e03739dbfc8d41e2ef06144ec0a9a": "Launch to Riches",
  "1ae54d00664b820bab9017a2baced3ed01b16863": "Launch to Riches",
  "68a862053de120838b267d2ba94a29fc6dc7f346": "Lava Balls",
  "7217ebb12400382926e609caec79f5aad1236dce": "Lava Balls",
  "de0be4add590561f06b6d121b8a3dd1cc6cde2f6": "Lava Coins",
  "990155e2364f6c6cfc7139bda59adc2727513fe0": "Lava Coins 2",
  "b21dfa84166e10da5d1ef07b609beaffdc6aa5c6": "Lavish Joker",
  "93dbb77c84439d56e9cc3c1626de2aa00e98d4b0": "Lawn n' Disorder",
  "26a2bd67e00280b89ed4b09641abdad4e25550bf": "Lazy Monkey",
  "1f5b7b92375d71c62db979a09c7673b91dd34640": "Lazy Rich",
  "f267ff387e7b28e907a0bfbf93f3a6f24f5a0637": "Le Bandit",
  "16431d226f7d906002dbedd17e1490e77b0ee641": "Le Bandit Hold & Win",
  "58baaf7a2f86eed119f0af2fb07b50c04a265542": "Le Bunny",
  "f7454cfe04d466abb584ad21f9cc11f04cb18aa6": "Le Cowboy",
  "58733f07b8b5d7b48fe723475b0463105ba1a540": "Le Digger",
  "3d970b97198b82f60f952d8ebeec5ddfadce9e0b": "Le Fisherman",
  "feb0aaa20377c99addbbf137353efe0f19de1a7b": "Le Football Fan",
  "2c94f279dc29becc4b9f89b991b79010be0840f6": "Le Hooligan",
  "e850964f07b58b6bfa877cf8be4d31d33ef7019d": "Le King",
  "24d664fe6bf48566c2f2471ea552fb9600e29550": "Le Pharaoh",
  "3776dc8c86e012a44f374b8d7f2fe84b24a32b1c": "Le Prechaun",
  "f592391a6117f45bc7fea4c5401aa149d1df4750": "Le Santa",
  "38aea428540e4bdb49595436ccafa1db472007e2": "Le Sortudo",
  "15f3c743d428fd705a34805a018a71ed0da84161": "Le Vampire",
  "f8a12939354a028bbb55e464a8d6b1de6415594b": "Le Viking",
  "66c2dbe6df3a51ac6a8f01d8dd561b2dafe6f538": "Le Zeus",
  "f15aace475985d44e933c535029b5c4033f5cb16": "Left4 Cash",
  "a607b1990ab725984024c70a4a6697011aeb7db8": "Legacy of Athena",
  "2351c205fea6983931c8f17dd1df8b050da955c9": "Legacy of Dead",
  "7fe321ff7d8e8ee753fa3116a9997584d17179b3": "Legacy of Doom",
  "ced3ebeb83bbd9ab7a154445ec4186a186e9a83e": "Legacy of Dynasties",
  "11b4dd8c2682ade4141718b28557a81097f4f2a0": "Legacy of Egypt",
  "440003038213438a9404e858023a61d8fd652ffe": "Legacy of Gems Blitzways",
  "4af388d40a80e5446619853b60469a5ed9c8d572": "Legacy of Inca",
  "a4813fa632e891b50a88a620e5d7b3b3b5950f7f": "Legacy of the Wild",
  "a1b963f4b5ed00dc878105e0134e0185777653cd": "Legacy of the Wild 2",
  "e7f5fe016acb1fc49427de7cffae55865c8dc004": "Legacy of Undead Dragon ABYSSWAYS",
  "76f0d0e7a45d1455f0a2197d3000e66378943f98": "Legend of Akihiro",
  "a3132afc0616c03c427f26e68d09c2eaa1ef2691": "Legend of Athena",
  "6a174b98b82f0bdcfdf33c2db1971ea80fbdf034": "Legend of Atlantis",
  "e03be9dea57b0bba5ad48bbc4fe39abc60e2d7b1": "Legend of Cleopatra Megaways™",
  "95e20c03e1168c047c97d14a0b805d458c1fb394": "Legend of Dragons",
  "726cf4297a2c9c5ab54190a105ad2a78b69bd057": "Legend of Fox Spirit",
  "6dc33a3d60f4db1f03bfc5ea8d6441c104eee4e8": "Legend of Heroes Megaways",
  "24d4e71b90ba31b5786a4170ef336b910324ab0e": "Legend of Hydra Power Zones",
  "7de1d903658cb9c1a3a1956eb1b468a35bcfcfc2": "Legend of Legends",
  "3db6c493f1805590c5f45afe228a7b22a1b7b0cf": "Legend of Paladin",
  "f5a7ca610607351a3aa3a6f9c1a59092c8d353fc": "Legend of Sword",
  "b88e65a17b74efaa3cf37270ed74ae12057f6bda": "Legend of the Ice Dragon",
  "ca98fc38a9c2a4bd0f8a90ee88d04e2d01b918a7": "Legend of the White Snake",
  "1f458f426a82b6509031860111f6921c12482d08": "Legendary Diamonds",
  "1532e8b6817c59e50e131e479af16073291c6ec8": "Legendary Rome",
  "cc6c71ff57a217894bb9366de56aff28b34c248e": "LegendaryBeasts",
  "db7d3b936fbf140055ed281f660901ecf171a995": "LegendOfNezha",
  "ff07d1c73869967c5781848fb56067a68bc880c9": "Legion Gold",
  "aa94467830df4ce43730528f4cc1764d73630973": "Legion Gold and the Sphinx of Dead",
  "5db89a6eaf3c6031aa60a6c667b85fb5ad63f7c2": "Legion Gold Reckoning",
  "68e52bfc682ee6308c3679c766e56d75e9700922": "Legion Gold Unleashed",
  "76323b66cbd59711d8e56e023ea61e9a9a5636b2": "Legion Gold Victory!",
  "8b6dd104a99eb58fe54961380596a314790e989a": "Legion X",
  "1933b1fd4185b6ed52c8f8e80d09baa175875ba4": "Leprechaun Carol",
  "979c9902448c2b1683218d8d381ae29b5ea7be43": "Leprechaun Carol",
  "210fb1d1b84cbe7362dd9c09ce7a66af0ad39725": "Leprechaun goes Egypt",
  "2512cd1f8f53f1479c7d337baca94d44c9e491cb": "Leprechaun Goes Wild",
  "659126f49e319f83757ef3659d08920f8d8528d7": "Leprechaun Hot",
  "d5e8a29dba5a2e420b9528c318cdb406af377b90": "Leprechaun Song",
  "77e0781bdaa8a5c8e2422116132f9507f03fd47b": "Leprechaun Song",
  "0c8c5a14e8373342cc97bac5cd8a9da8cfca2eaf": "Leprechaun's Coins",
  "378d0f31448b8278e5e247f98707a0453f03df32": "Leprechaun's Diamond Dig",
  "55790b71618ca78bdacdfbceeaac5dee9860d3f0": "Leprechaun's Luck Cash Collect Megaways",
  "d3ee7835a5665f68e7ad68df28510925df6c0ba7": "Leprechaun's Luck: Mega Cash Collect",
  "675e3444d7b884223e23fccd025357914bc32798": "Leprechaun's Vault",
  "5fd4ac3cdecb79302f689821fde9e081c712d11a": "Leprechauns",
  "29d60f4c13ab483735b5af7bf18e70baa6801f1a": "Leprechauns Luck: Cash Collect",
  "1a2aa00b863979b9c8df239d6fa4695b19006cae": "Let It Snow",
  "b4513d338b172b3e9d91a5dafc6ef72b9d2c67d4": "Let it Spin",
  "b16cb1580832bbf7fd8c0cdba66a32bc4ce577e9": "Let's get ready to Rumble",
  "6d893e6f870c04a22917a3a0aa406e2a5225a484": "Liberty and Freedom Hold and Win Extreme 10,000",
  "168a658119c837f49873bfce0745f6d9f8132b5f": "Liberty Bells",
  "78940e7717f596402ecf505f32a6017f15ff0ed3": "Life and Death",
  "7861bf322287cfee6471804498c7c3050276d412": "Light Blocks",
  "68f3cc9786603e8df5371a7c3a2f01ed11a362b4": "Lightning Baccarat",
  "ca29ed0cafc587ddd18e879b96beff7168d10167": "Lightning Baccarat",
  "3300785ffd0b6b2a8a4085fd229bc40ec0ca943f": "Lightning Baccarat",
  "099ce438d4715744896d6b6207d8415c9f060dba": "Lightning Baccarat",
  "50846dfaef6baad6c54c0d45e728f14cbf73cda6": "Lightning Ball",
  "c776f8c28eed749af8d124db33cbf0198a28eb1c": "Lightning Ball",
  "1f07605f1732b0d9f0862cec3c88b2e604a3b5aa": "Lightning Blackjack",
  "6412291aa8d51115f2f5abeb76d611f3a4def296": "Lightning Blackjack",
  "bae7786c68aa9789f42c7638bf08ef1118c0a3d0": "Lightning Blackjack",
  "c51e594d5f110107a49f14846500f2fdda46f06d": "Lightning Blackjack",
  "f10734e384f256dcd5517c7363000ec011306100": "Lightning Clovers: Hit the Bonus™",
  "94ab8d87f7ce0a3f7d50af3a5920afe6a07d0785": "Lightning Dice",
  "b821b85e8abdcd1080911f46a172ae3ee4059f2e": "Lightning Dice",
  "bb64b467c36ba066f789afe28278f7b791c21943": "Lightning Dice",
  "b08ffc2377621602a12c4f5663e9b160f922e864": "Lightning Dice",
  "021460cb2a092801c00e2ea422a03ac4a0eb97d8": "Lightning Dragon Tiger",
  "d8089f23bb47de6c1e7fce6f0041bbd2f747767d": "Lightning Dragon Tiger",
  "b30c07143861345993feb1288c415ea1463ecf05": "Lightning Dragon Tiger",
  "30d7d82ed803512af6dc7c6f8c5a8ffe5c55af51": "Lightning Dragon Tiger",
  "92ad1ff9325ad1b6eef612b9a5a9869f1f325861": "Lightning Goddess",
  "a9547d1059bd639daf34867f007974e5130ee8de": "Lightning Joker",
  "a899ed11c2daceb70e05ed80723f8c6955708cbd": "Lightning Lion",
  "9baf7a3febafec1464050d74f1221d912607e70a": "Lightning Roulette",
  "ec80935be19c84a0001e0eabc212589ce9ff51f5": "Lightning Roulette",
  "35dee52fad60facdc0837c0f736e2ee3e7b2fa6a": "Lightning Roulette",
  "f5b59a4f2207248df1c610298219898a60fb1757": "Lightning Roulette",
  "c6c8dd447ea861465a3d163a7c93afe3e1d7fd9e": "Lightning Rush",
  "0fc92b883a3620bd901a30d9700b094f45eb4df0": "Lightning Sic Bo",
  "10482d3992495e647a539a70d007146242ab3aad": "Lightning Sic Bo",
  "d30483dd940600f79d4891d79b84362085473b8d": "Lightning Sic Bo",
  "a45983b8845a55872289d25ade9b72da0f040b2c": "Lightning Sic Bo",
  "286a15dcd3be248c805d3330c77434b35e8110d5": "Lightning Storm",
  "99b6299cd7e393f6117e1f9efeb2b0ec610186d7": "Lightning Storm",
  "be03280ca9c1e5bf6f21417f6ee9c42320b3c0a6": "Lightning Storm",
  "5161fb97c95d6f19f171412385c9e79b5983fb60": "Lightning Storm",
  "277354683a63ee66321e52b3246a42389de9d970": "Lightning Storm",
  "64ba0c7329a31c71f5b565d3c8ad141355b2a2a8": "Lights of Luck",
  "adc84f32d920909d101f14d4d5b8cdc5122c0742": "Lights of Xia",
  "f8435be263ad86f6f8d88a7ce5732953b7fe2867": "Like a Diamond",
  "563c86044a67ad2bc9dae9d8517eebbef2a44287": "Lil Demon: Blazing Lava",
  "859faa8fd6a3c94b9eb3abd74f4aa41ed9704924": "Lil Demon: Mega Cash Collect",
  "c0c8185fb732dd49f1143e03428678994b71a144": "Lilith",
  "a647ed5939ca35dc8fd42df1a931369d602e87df": "Limbo+",
  "18238d8f46a6f40439be3e30a1a46df0a43e0218": "Link King Asian Woods",
  "c791ed6c934d971e5d6b90545441e2caae717270": "Link King Burning Buffalo",
  "c4cede8d3619a16cc92bfa55be9d3152109fc18f": "Link King Casino Mix",
  "b8d1b4baa86e5d359c4569ad2bb20354e7d68867": "Link King Gods Land",
  "f22e0936c93cc10835e29dc82bc0bbea6f7f36b3": "Link King Kuan Kung Gold",
  "365db3a1ac239b611af3aa9aa7fcd18870c3a144": "Link King Lady Dragon",
  "46503a8ea3c84919716229348c20bf4bb6e3a535": "Link King Leprechaun's Hideout",
  "08ec6585863f27334e431b7893432537d2f6efa0": "Link King Power of Maya",
  "9c202f754ae1d301a8a7c373191a095a4437d9d4": "Link King Wonderful Lamp",
  "070e89fb6e43930d50d31f1639fe91b3053c9ac4": "Link Me Sweet Tropical Fruits",
  "2b7bfa1fe6e40a254e85cb066f16ee241146dfa2": "Link Me Warrior Angels",
  "386b2a5a61641189be1f5215474396b45c501c1f": "Lion Coins",
  "a7e0a24def88a8c8977a6a89cac9e723b324bb78": "Lion Dance",
  "60ac024ebf6423bfbaa07e8479d9b35837d06bce": "Lion Gems 3 Pots: Hold and Win",
  "941db66f05691add8e3bb0a1b2b2356899e06d7c": "Lion Gems: Hold and Win",
  "84e7f8d32b6613763715aba16814ed860ee26c31": "Lion King and Eagle King",
  "13f5665f0ec9376d421ff70937854053624311dc": "Lion Kingdom",
  "6da31e2b58476329d1625d8b1339cc20ee764da7": "Lion On Ridge",
  "00f2c04ee2e2c964227bf676dc35486d8316a842": "Lion Safari",
  "94629f738066e6a99de8d45d82f07b27cad75dc4": "Lion Saga Odyssey",
  "8c0a576cb3d5729d56e83efd69969f17fd727c6f": "Lion vs. Shark",
  "72f5d1965c67b2cd4b599e6605038cf612e91cc2": "Little Bighorn",
  "461e6d17b8f864d3173c608f2c10681f30e0921b": "Little Cluckers",
  "ccdc34a397180288c258cec9c184e40721779766": "Little Gem Hold and Spin",
  "a47364766c6e0df97c5997b75b8849aed8244bba": "Little Gem Hold and Spin",
  "6a5a484f0466fa2996891af6d73535ee044e91cd": "Little Monk",
  "b8f84ece5547d31546861bf196c0f65b37df7e16": "Little Witchy",
  "23ad59223fea3b67d06fde056e4d718bb732aa43": "LittleGreenMoney",
  "ca6cf8d3726d7d824222ea73c02e5783bc293594": "Live Streaming Star",
  "a735e1f17cd9f6449cbfac03d9689683fb0586b0": "Loaded 7's",
  "6b803968a171df29d47577c8333e01de330bbb18": "Lobster Bob's Crazy Crab Shack",
  "ca3eeb6944d1bc8d826cf9334a8968185017d3d8": "Lobster Bob's Crazy Crab Shack",
  "9115a7fa73785f8ef0b97b2a92dda132879c0009": "Lobster Bob's Sea Food and Win It",
  "793ec47bb4f69259871c11607a15e934c29bf36d": "Lobster Bob’s Sea Food and Win It",
  "5fa47dedc3064ee58368431ee18f8f933b35f511": "Lobster Crazy Shack",
  "71cccebfefd6b87f3620cc953589e97dba70ec77": "Lobster House",
  "3cfe3a843a9ec23818f35d91f02ccff9fd0f0f1f": "Lobster House",
  "fb13f494513827ec3848ef9bbde5af811bc6d834": "Lobster Splash",
  "7ed929f6358bb25321ef7446e88a321f7d77fa29": "Lock & Hit: Red Knight",
  "2b1b7344c9087512534efdebe5f3a0bf6bd23f45": "Lock and Pop",
  "279a6e1790aa21643f83d2bde84b88ed2b1eb371": "Loki's Riches",
  "c21ceb50ca9dfffc83ab75232536ee66aa4a50c0": "Loki’s Riches",
  "b29f038439e429fe89ba8bf3884443f57e348452": "LondonHunter",
  "816b0a4a259c75a3fe9e62be026966df0f386925": "Lone Star Jackpots",
  "4a43d8ff28c29c8be9714b1e853050c71c116908": "Lone Star Link Eagle Wins Linked",
  "7649307ec5deb5a218b6962d298b53cb300f6c0d": "Lone Star Link Grizzly Wins Linked",
  "0ddf889a95334cb3903cb449b6237f3d1dbb9f6d": "Long Neck Fortune",
  "0857d50fe35c465acd8180792e35cabc9753fec0": "Longmen Express",
  "26c2ee6f5e6508a7dad397c226947181efeabdbd": "Longmu and the Dragons",
  "ead1711406b06b44911a9182e415b5983e58ce9b": "LoonyBlox",
  "216982249587d88608e0324a3aea19dfa0b78936": "Loot & Labyrinths",
  "d69ad03c99ed0e20cd1c5d809b306f12e549acd8": "Loot ΓÇÿnΓÇÖ Load",
  "fc7e90ba024ef1019274330d5a7be40513e37c3c": "Lord Merlin and The Lady of The Lake",
  "64f4e8718e511b7d452799c8d12ff85528da2106": "Lord of the Keys",
  "99d9b0c25c64aa1876564871db1be779a90708ae": "Lord of the Ocean",
  "6847798151e541eaa00cc1eec11e4646ed74c515": "Lord of The Sun",
  "074b31e83d38d23fbe09bc077e7afef5fe858d3c": "Lordi Reel Monsters",
  "29fe113c176dd4981188021f01dc3b7b6b7e7db2": "Lorelei's Pearls",
  "83628ad7d40b51b533f43f51666d33913a2302d4": "Lost Realm",
  "35f46004eccc22276ec899fe360e5ad8be7eb882": "Lotus Dynasty",
  "079413e6c23b20fdfaea7bb040d7518f4c714bd2": "Lotus Flower",
  "712756879ac9b5dca8a242a845846cdae5346c42": "Lotus Roulette",
  "bd07daf0b71ce0e3498915cb60971f062f5a9f16": "Lotus Roulette",
  "38e4a70b1687b4641845133c756680e91a7f51ad": "Lotus Roulette",
  "17c5140f885f876214929b12da27c9befd3ac053": "Lotus Sic Bo",
  "beefb4b16fd3db493ab40e274983110169062aa6": "Lotus Sic Bo",
  "f1f46877da5b5b7d76afb54975f9c5361b37302d": "Lotus Sic Bo",
  "92676e1975f89101c3c968d1b0c437d4bc6753fd": "Lotus Speed Baccarat A",
  "cc23375078c36aa9cf941db60bbc4517effabf13": "Lotus Speed Baccarat A",
  "844126e946fc7fe777c531f3186577814a42b76a": "Lotus Speed Baccarat A",
  "8a2935989743997d7d0e8522966d73b74e8b7648": "Lotus Speed Baccarat B",
  "fecda187a0ecfb557ec6d450c7856d7e7308694b": "Lotus Speed Baccarat B",
  "47e2657c0b1b2593d4a1b4b02f19b7e827531ff7": "Lotus Speed Baccarat B",
  "2c23121c28e62c91140b814d94b1405f438ad7c5": "Lotus Speed Baccarat C",
  "5549168015fd13007d430b252f2aecdd1ba15ad7": "Lotus Speed Baccarat C",
  "be56164a3a294dd8f88573b8bf09ac5bdbbe8bf2": "Lotus Speed Baccarat C",
  "0e117c49c9b165130a24f92190006cc65aa8bb73": "Lounge Club",
  "772586a607440fb7b4af2c6b3a9f02c0d25948a2": "Love Amongst War",
  "0991954535a46c7990c55d8c3a536c8cf01395e8": "Love and Rage: Olympus (Buy Bonus)",
  "d0e1ba888e36303ed4e6428b2197812f8c8fa0dc": "Love Express Lock 2 Spin",
  "1c3e9c47ef8a6bc4b15f0acc7f54aa034e460cfa": "Love fool",
  "687b057aec9ee2306f7e1fd768b4494a7d2347da": "Love Game",
  "ff380689d2a5d7764ef4bb4933e2d15c16a4ca90": "Love in Memory",
  "5191035e57edbc735faffdb70439a04923edb307": "Love is",
  "cad817cf1e41a42f435f735096f166c1c9ed1377": "Love is in the Fair",
  "8a599d3d9d01f121dcaf309188701847b5d3221f": "Love Joker",
  "7548d444cc6ef7eb7b94c769f16011b43f9cf212": "Love Magic",
  "47acaa16c0c3e005eaecc4125138261fc336c716": "LoveAndRichesEldorado",
  "f7e6e37c80f9dc984a2ffca48dc9bfb1979d61eb": "Lovely Lady",
  "a69b212a5b9e9e4b9de84da840e47d9d1d01687a": "Lovely Lady Deluxe",
  "0c04f7b7daa670e6e70a4056241560cdaf2f7206": "Lovely Lady Xmas",
  "a41397355720ac2ccb6ebab75ddfcfcf38d207b2": "Lu Ban",
  "149c09e74e2f6cdb03da85415dff41d4bafb28d2": "Luchamigos",
  "4cdc3ab84f40d400d59cbdcaf897e57864d76f67": "Lucie's cats",
  "3ea0996e52f5faa7703d599d2242368822c18bdc": "Luck88",
  "782eb2e9be05fb77afaec454718f08601fe4cf26": "Luck88 VIP",
  "8923865a2c0870fd62e0858d6ebc59891de454b5": "Lucky & Wild",
  "55e31f4bb1329cc600c1b5c72001bce1d56fd48c": "Lucky 6 Roulette",
  "2005e9acf490e7e39f8ffefca318142e4e544b31": "Lucky Adam",
  "cc2a7f9f0c5cb483ff46df44e0dab79745a27235": "Lucky Ailurus",
  "c2e01dbaee0e10919b2b3f5b0f243c4d027a64d6": "Lucky Animals Lock 2 Spin",
  "7b33cb64c7645f32697c8617dd3f9154da6a4ee8": "Lucky Bandits",
  "15089cc04389c7f8190f1f462ec5845284ead1ee": "Lucky Bank Robbers",
  "62ec509d248470bfdc940414c071c71374eda62c": "Lucky Bells",
  "3f2ab9e644605399a8d27fe8f290dfecf9f423f1": "Lucky Buzz",
  "c880a8fba6d806b50bb8bd6269965620ea5a2f93": "Lucky Casino",
  "8835544c0674644ca480ec6f07990c7ca43d26bb": "Lucky Cat",
  "d14cfddf2a0d167244aee5add35c9bde8a7d8594": "Lucky Cat",
  "5989e97dab430382cd3266e2eb22194ce49492e2": "Lucky Charms Trio",
  "4c64bb9ab2f8fcc6ee3cdabcf4931ea8f4652d70": "Lucky Coin",
  "f0b765c447c8fe7ad545744a0e54703a18bfa28f": "Lucky Diamonds",
  "a4dbee730e6462dfa95d333c123b4208e505b894": "Lucky Dice",
  "1cc2c2543617000058168f57c0ff5e97552b3959": "Lucky Dog",
  "138d767467c2310ae2a4fbb58f7cc430ee2f5560": "Lucky Dolphin",
  "d88c722fae84da6fdf1ce3d395d7dccfb06db7ba": "Lucky Double",
  "5f2ad497e2fa1b9f0d61e4d483014409d5341cd2": "Lucky Dragon Ball",
  "f4783d34c5cab1b27b1d5dcbe94d88c314daa530": "Lucky Dragons",
  "143b9c692b03530b67ccaf4f6f269742f54f7bf4": "Lucky Dragons",
  "25f0585b36f42ed68e67bcf4db6b9fd1d40113cb": "Lucky Drink",
  "5c834d66f840da738100f3f53afffccfd4fa37c6": "Lucky Drums 88",
  "f01cd4901592a6372509728eba47a785ee1eebbb": "Lucky Emeralds",
  "79447c35f283940e7bd153fd21d14c0df9095fa9": "Lucky Fishing",
  "452e7911fc3aed46050410123412b004970bd52e": "Lucky Fishing Megaways",
  "995cc86e425be9401a768eb1b0207ff1cf2d65b3": "Lucky Fortune Tree",
  "74403f0fcecd72a0771a6d17f00db8822d4e3579": "Lucky Gem Fusion Reels",
  "ecac1644fea1c0be88d61036768eb717542f2583": "Lucky Gift: Cash Collect",
  "41db1c22c1e1fe36f68cd1a3e5ff151a5828297b": "Lucky God",
  "eccefc015692b02742f4a8755990f77751e48f56": "Lucky Golden 7s",
  "d0d534ea12080261821ef42a567b9a80ba253534": "Lucky Golden Dragon Lock 2 Spin",
  "28547d3c85b5d1190329a8fe11fbc133d85f989c": "Lucky Golden Toad",
  "92e46cee501d811d0366861c448e6940ddb25df0": "Lucky Grace And Charm",
  "8a4e843df7c79ff4e21b91dbe88d9e5d41d565cb": "Lucky Hot",
  "eadc7419462fada163bc912630784e225bdf2b55": "Lucky Hot Coins",
  "001a63d903e482339d949bfa476d160215d5f971": "Lucky Inn",
  "d53fce4c0708ed2567894e6df747ce4200e458ca": "Lucky Joker 10",
  "ba54c2048bc6bfa3878f2d74d32057af812df4ae": "Lucky Joker 100",
  "36bb8bc099b735c0b2607d73d6eb0cdaf62c69ec": "Lucky Joker 40",
  "0565b3be0c1af082dfbaa7e2b0989cfc88709591": "Lucky Joker 5",
  "5f2f59661d8fba3993496874fefeaf39541f1eb2": "Lucky Larry's Lobstermania",
  "9c7aeb25cc8d759c32813adfc337082d12793102": "Lucky Larry's Lobstermania 2",
  "b021718c31484cf6ccf38c2d2c7c80e7f0082125": "Lucky Larry's Lobstermania High Stakes",
  "628e90a2b9c7d6598692fc99eb82d416fffb7e05": "Lucky Lightning",
  "acc7061f47dacd413ec0727cf1127468c7796593": "Lucky Lightning",
  "8d73086e9f72ee7656f25d1e2db0f356f5f386ed": "Lucky Little Devil",
  "6c64a1abcbb82ba95427d1b9ad496d769b9c80c9": "Lucky Lucky",
  "a6d8680f9794c768fc447ba33434d6f8d74fdb2b": "Lucky money",
  "52e71d2299c7fe26fd650a1de0b7735b15979bec": "Lucky Monkey",
  "af2a1085c399181902179e64d4594132eb2c0f3a": "Lucky Mouse",
  "47b66028c91ed524782d7918113329d73c3800f5": "Lucky Neko",
  "efe78c3e35a357bc36880fe72a34ff4ca29e501c": "Lucky New Year",
  "c1f259b33ce21839d8b99b64b76e49a7f0e47d55": "Lucky New Year",
  "4e935513686c8f00f085a5f7db5d251f7d494651": "Lucky New Year - Tiger Treasures",
  "e370d20720eb9aaf74e66efa60dd4e906de8bbfa": "Lucky Ox",
  "fda640c96e289e8e7a98ea3145c58ebcc65eebb2": "Lucky Ox",
  "8c74f88e535b5b386a46f3b9dfe96c2fcc591496": "Lucky Panda",
  "1dba29f84308133092799f6b540c0a4945bb2db3": "Lucky Panda",
  "4424161969f95e23350b5d22f960d9ad522b3638": "Lucky Penguins",
  "e26851c8aeaacaf37545b071dd49754bd893473e": "Lucky Penny",
  "f2cae288d4aaeb97a29560e4ef009671adbcf726": "Lucky Penny 2",
  "402a24bb0728bc6d4dd39c37f3b9a78bd6c4ca7b": "Lucky Pharaoh Wild",
  "83bcf1596417a6dfa931a19ec5ea542264b56702": "Lucky Phoenix",
  "d5ab7fe8e6589ccbcf58aeac486f8c7e1cb71c44": "LUCKY RANCH",
  "1621b24c749c2bc1b1f0191149ac59d3e225be36": "Lucky Respin",
  "d80ab4f19f62370ce0c679875a419a205fa3b67a": "Lucky Ryan",
  "3f7d21c9653826a23fbae265a1019d3f9b7e398d": "Lucky Scarab",
  "e7c722de10ea6d0caa58d48582a4507ee4a27143": "Lucky Spin Jackpots",
  "0c0d13f58ee018df46d12c57757ee89c5aa74ed5": "Lucky Star",
  "c891c5fdd83a1c40e3f3af4ffcf585f032f4822a": "Lucky Sword Tapper",
  "74da9319386bba6d339b72d7c4243d16b4978b70": "Lucky Tiger",
  "0ee5150eff45605bb96b9c3a38e3129e98597cbd": "Lucky Tiger",
  "2c5e608f98c55d77adf8c5bcaf9b69d98dc0fc27": "Lucky Tiger 1000",
  "c3f8500c3ac69a27abe4ce6cf20cbc7f6bace7fb": "Lucky Tiger 1000",
  "99d4e0044c20a56e83559e1b91ddfb946ed46919": "Lucky Tiger Gold",
  "0c474de62039c1f1de748ebda9dda1735217bfbb": "Lucky Tumbler",
  "f97a109fc750616c3d42a55ba86568afe431ccd0": "Lucky Wood",
  "8ef3688ba740ef66bd12196c9b7bc97787671b95": "Lucky Zodiac",
  "0762781d5a26d9fa061fe2a3a74737a00d92a7fe": "Lucky, Grace & Charm",
  "26159fa745f43773e52e0a34a7df742aeb01e149": "LuckyDurian",
  "1ff8c0caf88219f999e01e1b9649951d869dddb8": "LuckyFortuneCat",
  "2d5a37a9e4362ab425eaa844f3ee114de0fe43a6": "LuckyLucky",
  "4e66de7aa7e57e8da13b2414934b337d1337fef5": "Lucky’s Wild Pub",
  "cbcb29567f0adb30af05bf4570591cba06d158c7": "Lucky’s Wild Pub 2",
  "ac2508ad2d2f53de9619793017f1fdbb35fd55e3": "Lunar Howl",
  "c06c4b76b01311abd58b80e238d0f262f751dda1": "Lunar Link: Nile Moon",
  "e6b29dbfa04ed2ba1f47c32f56444ce308d2d2e4": "Lunar Link: Phoenix Moons",
  "e261364f164fd367e4f5d2f74dc571264ce11005": "Lunar Link: Sky King",
  "d80cab1c831dd89ea2a9bab27d496cd7f54c6b3c": "Lunar Link: The Legend of King Arthur",
  "5a9716f945cc683c9b3ea4339cdd6027a1a03834": "Luxor Gold: Hold and Win",
  "8a8fe0885c08912be74461ab04cadd474024a4c4": "Luxor of Cleopatra",
  "587d74cb6aa1c183db25b0a1955333842299a4a3": "Luxor of Cleopatra",
  "2342fbdd6c384d8b2a9878738dd178f27a5a6cb7": "Luxury Fruits",
  "82f15d0c49b9757f5c20e5729e4088b79397913a": "Luxury Garage",
  "7cb29b4404a36648b71e3960d8a57e64656c399f": "Luxury Vegas",
  "7b5c358bc67fedd302cd3c0e5c3e01b398d012c4": "Luz de Draco 100",
  "c5395c477d8920a2f7c3bab779258ef8082b2555": "Luz de Draco 100/6",
  "217d91b1a08a99c0ec67487f5906c87983b163a3": "Luz de Draco 20",
  "6d2e5f8210af6285e3a4baec0fba5ae5605f0ca3": "Luz de Draco 40",
  "2c48eb79a6f1ca3ea20b47f206eba8804a88504f": "Luz de Draco 40/6",
  "4dc56c10f17e59c2283ab566402a838d4d3c1830": "Luz de Draco 5",
  "5aed2c45814e1770ae5dec94c2858a8f4a3ad030": "Macabra Linx",
  "ac5ac5e700a0f229bba8158f954b1414d3f9959d": "Mad Blast",
  "921be9b64f5d8479624728783bcadbffd543cb0d": "Mad Cars",
  "c32bd62bed62425d12bfc192fdd22325ca8e3744": "Mad Hit® Bearhaus",
  "414599542cba7d2cbe83beca0ef8e415640e974d": "Mad Hit® Diamonds",
  "126f68f7537009fe8b8ea6823c2784d51b62b528": "Mad Hit® Full Steam",
  "4c1e819c5b4f60cf16d9928810ee3ac3c72d9ac0": "Mad Hit® Gorillatron",
  "9d865909e00248f102ea00c3b550cab9ca4dc5a3": "Mad Hit® Hidden Cities",
  "3d1084c4c3aa3587a8111bc600caaf47752acac9": "Mad Hit® Ho Ho Hot Pudding",
  "a27c6c4632e4378ca81c7f3dc90558c7839f5106": "Mad Hit® Oasis",
  "8f0bf48bc109488beccf2106854d0bbad4d1070c": "Mad Hit® Savannah",
  "2f0791640c07c6a28d0ecf7713645e712d34b134": "Mad HitÂ® Devil",
  "910113604a8c4ba2800e80b5c2aef914ad46b9af": "Mad HitÂ® Easter Eggsplosion",
  "469f3f0e6303f354f4cfba1feeb3a9f14871f2da": "Mad HitÂ® Jokester",
  "2367dfc497438486307a97c94ef2522a7992be8d": "Mad HitÂ® Marlin Bonanza",
  "3c1596f3c34929d1d15c6470696e91998213832a": "Mad HitÂ® Mr Coin",
  "03e8c6d61a50580e6cd473b59e848746abee0f71": "Mad HitÂ® Slippery Soap",
  "b8953f8e391f0e0d8db69296850d18caac2c0b21": "Mad HitÂ® Supernova",
  "b2fae93b0aaa21833c6ef57303ae27503aa15c62": "Mad HitÂ® Wild Alice",
  "8c70a0279f81b1c5855ae0363407dce6944ce2eb": "Madame Destiny",
  "73e27db381a27327c83a2292c27fd81016d8ea2f": "Madame Destiny",
  "62a3b84e8d5a71f42e15508c52b9208ae7cc1bdf": "Madame Destiny Megaways",
  "3361a409c81b3520d8993cea6dc33088421a8026": "Madame Destiny Megaways",
  "4f67a5be23080ebec6f9cda95d27be2239d00855": "Madame Ink",
  "978cf724f06a603c6cc54ca534f1e5abf9e3ed8f": "Madame Luck",
  "1c2579af671539e9c1a5c32d66f5d4e30dd7b97c": "Mafia Gold",
  "098e881c44c4506fbbb508c30ee3d78222ce7095": "Magawa vs Mines",
  "0b08744567eb77ebd29b6fca0855cf9ddd48c837": "Magellan",
  "0ad31f7d30fa656e5233ed16033fed54848aa42a": "Magic Apple",
  "c861eaaa69ea2319e8b00a15eb5637490bf7fc76": "Magic Apple 2",
  "51b8cd9d22d8618df179c6ae78742ecf7f1a3e9b": "Magic Carousel",
  "6463ef83fd3c400ba245805142b875e209f32c7f": "Magic Carpet",
  "5c250f2030c32744f773cb9427c97df96f89f8ae": "Magic Clovers",
  "780d7cb630efcd8c5894ef73701a0ea5c70ed072": "Magic Crystals",
  "34807b8f6d6832aca1c0b32df8a4a46db6423134": "Magic Guardians",
  "f248fe6c2972a4d007bd62d6c5556652f2bef567": "Magic Idol",
  "7929f2b5490d1a02de27825eead8a4e8b20d33eb": "Magic Journey",
  "4802fcb74370381e7f8a36b301cd3103b32184a9": "Magic Journey",
  "f79fdf66aa04887a2a982211c2df2043b38493ab": "Magic Mirror",
  "5cef5c9d1f1b33807a0ce77fc370299ebfc059f9": "Magic Mirror Deluxe",
  "54a68f9f2e628d711dbbbc3858f7ef18ec20b8eb": "Magic Mirror Wild",
  "8ade469606b56fcb465eb57810deea081055f328": "Magic Money Maze",
  "2ba97625da33c1699ba5b2e9353837d7b5d707ea": "Magic Money Maze",
  "28f7b744e8c377d503134ebc26166c167b733142": "Magic Owl",
  "775c835af8f3bbdd3f1c9bef57f53ca985544f61": "Magic Piggy",
  "8049057ea73535e342a7a66f6fb20fba37529d7c": "Magic Piggy OG",
  "d9465311d5e7d04d5a47bd7246e3fe582e1ff492": "Magic Queen",
  "2edf080253e346d8ebbfb2679f673c64e5dfba0e": "Magic Wilds",
  "8e6c7711bd4e3b00d86dc7ddeec2a96744591261": "Magical MINE",
  "4899c75a4cd3c1853aded487e2845c46a3ab4d9b": "Magical Mirror",
  "f82042ece26b2334d01c7a9f2eb5d86b2c6c474b": "Magical Store",
  "c5b878a209a3be536969e60e1bbc3c504349ff78": "Magical Wolf",
  "e260783463ed110c0c7df193b513bc6445ac1f02": "Magician House",
  "3104e1e2ac3cfca240377d8119ae876f2989c745": "Magician Merlin",
  "a8262e9b37641973defc0ee53c2bfd2223c9504c": "Magician's Secrets",
  "509e92a4bad3b3c67f2d8574240375710772b417": "Magician's Secrets",
  "887493e6bd16f2ec1a4982449c34ae8594f3ad03": "MagicOak",
  "40c9e31a85f40f030c718eec26bc8d4c770dcb22": "Mahjong 88",
  "1e455a1b3fbdff3e149440f7c562e5598d30323a": "Mahjong Master",
  "98f9667d231c704c8a3a971023af63b276b27d39": "Mahjong Panda",
  "34deddb678959575dbb5c286581da2403ca97df7": "Mahjong Wins",
  "89458b342bf3a91319b6df037fc4769f6f17d8c2": "Mahjong Wins Bonus",
  "b0628fdabb88ed5c7931ad92fb18958a9bd35ab9": "Mahjong Wins Super Scatter",
  "ccff74fd09abb14e0295a327c1503df39787c19a": "Mahjong Wins Super Scatter",
  "96dcce6b17aeb6e6d710692923e1fb539e74298b": "Mahjong Wins Triple Pot",
  "3cfc3fd092ef46c4cb6ea555f972ded7ffeba04f": "Mahjong X",
  "b65618a1e194d290c7d6e3fe80a4c89f1fa7b072": "Majestic Coins",
  "ad6726d127ee6df5c02d08f52cd2b881561c9cdc": "Majestic Express - Gold Run",
  "c7c1f8908c0e8ddeb2a31d18e3a7aeb409ea5906": "Majestic Express – Gold Run",
  "eff2c9967d659bd0998554579f1bf1841cc3ccc7": "Majestic Forest",
  "5b740c4f72400844498d85ccd7383e50dee0a717": "Majestic Forest Buy Bonus",
  "712a706d8210bcfcff3b3f4f2cb641f673cc665c": "Make It Gold",
  "5238a26b7cfeb83c28baf7f4b9e44cdfc62bfa15": "Makeda Epic Kingdom",
  "46a60de32c7c5185d6e24117679101567c334a90": "Mammoth Gold Megaways",
  "51950a2253859602cb36cf2353ce01cdaa31fd2b": "Mammoth Gold Megaways",
  "85aa09144efe6508178509593cc0aa834752e81e": "Mammoth Peak: Hold and Win",
  "d3085d36f95d52e6577994aac7745a418e8f1de8": "Mammut",
  "d7843607a1cee1d4f2ae45a33ce39da6bb6fc4dd": "man-vs-gator",
  "e00a7c6f274bb012610c9d6500f3107cd587721f": "Manhattan Goes Wild",
  "6d7b7f091ec13008b5621fa7e20bc7389a07d955": "Mania Vegas Flowin",
  "f7ab9e00e5351c0f45fbdb613cf7d3313fdcdc29": "Manic Potions",
  "6f4f5343ff898252c4e18f0ac0fb5a77bba8d4d5": "Manta Mayhem",
  "a6fe1041fa3785d1b72a1cbf42a9958dbfd186a5": "Marble Race",
  "d79d0e6f3c5d86c541acb04e456fd75c063483f5": "Marble Race",
  "b9e7a4e3e5b311bf2929787b1a6d90c4587a8648": "Marble Race",
  "a62ff1085f418f377f6173e1fe34e6c9918e1a6a": "Marble Race",
  "0aae3f65576a6448e5ace16792c8c2f3fa41e665": "Marching Legions",
  "1d9487e6a9e13233697e69bf3da1d30ebe8b055b": "Marlin Masters",
  "4b6cc1cd3dab8cd4d296f5e63a73e3490a80d35c": "Marlin Masters Atlantis",
  "604613511bc9bdbdafdc4b7469ee63aa915cd485": "Marlin Masters OG",
  "de4e48001a8366ed48fbb864905ec6b07fc48f1b": "Marlin Masters: The Big Haul",
  "9200aa8723c106a601820b3daa1a948a7fd44ec6": "MarvelousFurlongs",
  "35d3161fbae9b42c24ae4c0abb3041e9df0e5244": "Masked Treasures",
  "05a305588938f4ddc2e5c2fee90c0312db1237ea": "Masquerade",
  "388673a73c4f6c235983cdc63dcf718bc4adae43": "Master Chen's Fortune",
  "04fe5388920de20750d80fea03f93285993d9261": "Master Chen's Fortune",
  "42c750f34d9becdc7c213e26a6c400681b725796": "Master Gems",
  "da172f95d7f977c63cb32cd4f472fe4a75d67629": "Master Gems",
  "f704c1a53db8a0860c3d93bfb45e57e76567925b": "Master Joker",
  "f551283c93e3ff8139dcff04a23057726d1f367c": "Master Joker",
  "28dd50a1cde65017f811ba4d82a8503c4e3cb412": "Master of Gold",
  "b549ce6c46df7d4cdc0a8e476dd730aca388b3cb": "Master of Wulin Lock 2 Spin",
  "36ddf3f2ef2662311c8a1a15a18938afb84a7cdb": "Master of Xmas",
  "0e4e0414565e3f5883d8042703dc62b9f7f97027": "Mata Hari: The Spy",
  "04ec492d6525f8483a07b92d4d993e82dbdb5a8f": "Match Blitz® Scatter Shock",
  "8ee1bbd828d77b4d6915d3e1384d94fe7f365737": "Match More Bayou Queen",
  "641dca0db6362aacd387f11958f430c71a718f44": "Match More Biker s Bounty",
  "b3e2ad20b1df2d9b09ed2f23bc7148626a5cc183": "Match More Flame Queen",
  "e285032330a6f5cc3650fee6a0a69694a7a79223": "Match More Golden Safari",
  "4e232e86f7477bc6af0f891a0e24de4bbbf0f9cf": "Match More Honey Touch",
  "f4ca057c3ff38df6557e47bd656636e7fa3dd6b4": "Match More Jewels and Gems",
  "36a3a7ef1807104f8ec86c756a75cc52337cf77e": "Match More Luck of the Dead",
  "f05861361b6df8b20f92213c1417e6f604758fa2": "Matsuri",
  "2c4f51ec5c712c3d4143755166b3e0a3b84af235": "Max Dangerous and the Lost Relics",
  "87f874442d997ca2a193b546b8a35b55455c3024": "Max Fury",
  "b99e9cf4043c14178d5c422fd5ccc963f848cd43": "Max Gold. Exploring the Unknown",
  "23555c300424e6ea951220bbb0152670659efa4b": "Max Win Machine",
  "b7693eac586cb93fea31b8e44b7c86d274b1b7d2": "Maya",
  "778f61dbc9592b1fbe75bd57834051a7c07e3e91": "Maya Lock",
  "08d5c5c9b005cb27e3fc7dbc2630eeb836b29263": "Mayan Blaze",
  "d6413280a54dd4b6de923ead6de77b89715b044b": "Mayan Blocks",
  "d78529a8474bbff22a8599b6b009f29e8b8deea8": "Mayan Blocks Power Play",
  "1dd21c8bb7271a5163b11c77a87872ad07efe43e": "Mayan Book",
  "7b0811796fd406c922eabf19823c043e9962aab3": "Mayan Cache",
  "3081f7de173e9945218259cdb734f77d173fb411": "Mayan Civilization",
  "5f7ab1f443471f94a74aa30fcd39b22f2ede0fed": "Mayan Gold",
  "00bd3c72d8d6fe217983ad7abe11008ae7e05708": "Mayan Magic Wildfire",
  "e5d5b14913f4416c7fd9ee4245046b11182f39d5": "Mayan Restaurant",
  "8b76a59ddb4415f48fac31bd021830b4d3938c45": "Mayan Spirit",
  "920352359c796ca5678e6c5e93b5a0e7d64f3f64": "Mayan Stackways",
  "6eed29fca17661854994aaccde9a1dc98f7d0274": "Mazu",
  "c491feddfee9278a7682f0967db6b6f02a263a7e": "Medal Winner Megaways",
  "82a7fde7fa687a8b8b6de0eee0c64bd85d32d13e": "Medieval Knights",
  "9679390825fb496c4565d4cdc787db46c03eea67": "Medieval Riches Fusion Reels",
  "c0d55c26e5ba448fed1f5a836cfeafefb34f7b3e": "Medieval Warfare",
  "c9e8b14b51a671c5501af95626913010b2f282f6": "Medusa",
  "10927fec09c28cdc5090905052d02e3055c8377b": "Medusa Hunt",
  "68c3bdd29b3213fbb091ef819b5b358e9fcf201c": "Medusa Money",
  "460695c36248ab41f0c589142654c8600f825de5": "Medusa's Madness",
  "380dd870f0789f05cb40c9247ae01f595f9c65d3": "Medusa's Stone",
  "3d718801218f2c39d3fcd9ff5dd73b8c1300a2a5": "Medusa`s Stone",
  "cea1cbddc38fab2cafeabaa89c1cc28794855284": "Meerkats' Family",
  "12306276ec1bcffcc96646068bdde9d23ff9624d": "Mega Baccarat",
  "0cffbda23488e212562b7a929636a8fc06ca0127": "Mega Ball",
  "c0a07fad5e07c259f873654b452239dab2a76f56": "Mega Ball",
  "da574d665f31eff8bbc384a1fc0aaa1c85208d03": "Mega Ball",
  "1dfc05bee7c4112ef213ee6c951fa444551014c6": "Mega Ball",
  "bbd8c83d44f466ab26abb24b164dfba75e4678d7": "Mega Bola",
  "7927062d26457790c855f363ae0e8a067707cd21": "Mega Bola Da Sorte",
  "51edb0155ac3795c14e5209ca270273dd164c5b7": "Mega Crown",
  "896e11e5e2888f6f87e30abca7447396630a471a": "Mega Don",
  "96b2339d14aad261f47dd19ab299806d9edbe602": "Mega Don Triple Threat",
  "d6b257fe677bed0200d1e5d7fd785f73b6028c71": "Mega Don: Feeding Frenzy",
  "d367cc89b0d5da7e79aa6767016b5d3e8ef3b972": "Mega Drago",
  "faf748b73d710ff1d799085303d99adec02f7f03": "Mega Fire Blaze Big Circus",
  "13f2c363a0efa77e884af80dbf0b7153db5e3dbf": "Mega Fire Blaze Khonsu God of Moon",
  "a8f8ca43b797412ac7beca0afa268064f1932291": "Mega Fire Blaze: 3 Wizards",
  "3e6a689c965afa42f7fb197dd6b8da22ea6729d7": "Mega Fire Blaze: Dwarves and Goblins",
  "2ea514ae6b561ce1229c1736bd7ae08e6399f228": "Mega Fire Blaze: Emperor Of Rome",
  "73357d38fb198660a64f8784dc08b3b7570663d4": "Mega Fire Blaze: Legacy of the Tiger",
  "b3162a980c40eac85771ab5d51f41c8c594fcaa6": "Mega Fire Blaze: Lucky Bass",
  "16f95c56a5af9f1f7afaecdbc9d6ae036941e4fa": "Mega Fire Blaze: Piggies and the Bank",
  "1f02f330afd2e104bfeb8e00143378cfa0ce000c": "Mega Fire Blaze: Rocky",
  "1ace65e90e460f77c7dcc94133cc1b986223b603": "Mega Flip",
  "2a3ed49d0b2f984aa45baddc0c0cf11107ce188c": "Mega Heist",
  "cad14dd492cd5000a753d1dd68b0e35623cc1a9a": "Mega Mine",
  "009443e646c05e35f58af743198b2a8869d5f2fa": "Mega Rich",
  "f3b2c2b1406ce7ec60d50b4d71553b76bb6ed513": "Mega Roulette",
  "9bfeba9f9e7ec49e2423b05a4076264ccf1915bb": "Mega Roulette 3000",
  "a7796fc8aa56d1d753cbffcecac9c96e3022a8e8": "Mega Shark",
  "ec83e3a464e52eb20e70bbc7dad0a6550b5dbe15": "Mega Sic Bo",
  "85fae83300d80c47390a85630e9567b2de32430b": "Mega Stellar",
  "e03a676dc872ca68f03684db4804b02186589e9b": "Mega Wheel",
  "5022e8650b1a968e8391563f2aeee5c2285a5c90": "Mega Wild West",
  "519569c9fadd920fa88de0f0da287d94f1013a20": "Mental",
  "0fceba8439be1a7a97bd8b42777937cac8125847": "Mental II",
  "4fd39a507e79a808b6d28bf1b9dcb491cd0e359e": "Meow Megaways",
  "a18d8d8e103f50d7b8a1e470045db7a52283e330": "Meowfia",
  "3ec077860f6bf465b38e91e3fbaebad410a6bd70": "MeowJanken",
  "a837be6c1c05c008b020e835e2f28c06af3256b6": "Merkur Magnus 7",
  "1f12fe305a25d882fe338bc53e25a8443eee8a5a": "Merlin and the Ice Queen Morgana",
  "e3ff0cdcfc69771c01e527fe38d33ddce81f27ef": "Merlin Realm of Charm",
  "bc430b2b20db7203e42da6455d29e1a4b81fb020": "Merlin's Grimoire",
  "1b86ebaf9b107a091e5cefdd77f9e34724a8c822": "Merlin: Journey of Flame",
  "00feee75ad67e217d5f4331360f07445df7cdaa6": "Mermaid Princess",
  "53d0892807c5b5a6acc232a56ecedc03c7d3f6d5": "Mermaid Seas",
  "f428690ed4dfb1f855a71d30b638d73768d6ed3f": "Mermaid's Diamond",
  "a02823266113e28f2c08616f75614aeac7417662": "Mermaid's Gold",
  "50b636bdb10e32c9f0223ab2ccdd2e03156604f1": "Mermaid's Pearl",
  "29599aa3ce92e7894504249d4e94754a4a10d2b6": "Mermaid’s Treasure Trove",
  "64b41e0c9f87fed9d27a59d7a35d946d6556d2a7": "Mermaid’s Treasure Trove",
  "be18a44ef11a01c16488fae621c3edb93a57b8a5": "Merry Fruits",
  "126ccdc3c2d7f11472a7378f55b66d94ce2e8b8d": "Merry Giftmas: Hold and Win",
  "11754ae02667087d4f0eccfd439aeff88a681008": "Merry Xmas",
  "d323dd8ab3ab0b2af42a88aafcd1969cb4a2f4f9": "Mexicaliente",
  "d83e08535f4fd3ae749f3f5201822f783165b68e": "Mexican Cactus",
  "30931316372949ef50bacd030319370ad41b5f65": "Miami Mayhem",
  "f0125b8a4c692029d29405f9e060980e58a4b7bd": "Miami Multiplier",
  "59d9a89093e7571aa236158d563fd1823f3f68a4": "MiamiX",
  "2e319da444ebbdf4f946a60c695acb7b27aed7f8": "micro-knights",
  "89823fc1ee509a71ceb7eb623f4d51bf6397cb2a": "Midas Dynasty",
  "f07d25d8ae4111ca529ea195fe87e1d469da35a6": "Midas Touch",
  "cb29d4bf24ef12e069ff061d25f805165257baca": "Midas Wins",
  "2f596b0d949827601bafcba326589486adb41ac9": "Midnight Gold",
  "7af1f8cb390426b6dfd483d199a7043fbc327510": "Midnight Marauder",
  "b97317234b41e7c862f7d25ec38030f87ec9fa3c": "Midnight Marauder - ClusterBreaker",
  "da42d7c899f6b0055defd91144e1f074e4d1e07d": "Midnight Marauder Dream Drop",
  "a13888b7d5781978f75d44d8c5ce4a921ace0669": "Midnight Wilds",
  "ad9f302230543ce556482101cafcf80e99f930ee": "Might of Freya Megaways",
  "76815713b418799240ddb3b207d21db584221846": "Might of Freya Megaways",
  "097c58bdd243179ba434e1ba4d28ef7bc3ac101f": "Might of Ra",
  "892c428f781fc3e51f93e3f9050b4b88b54c13b9": "Might of Ra",
  "94a350956b9e3617237e4d6a8deb6aa2e7685312": "Mighty Hat Mine Oâ€™Mine",
  "63f2026409862ec94ad8895fe8decd2c68e9b8b9": "Mighty Hat: Lamp of Gold",
  "3a9546547cbbb056e50021e6fa7e7d72a014922a": "Mighty Heracle",
  "82014f0a30c5b5f803dd14209dea75c5a20eca2c": "Mighty Kong",
  "234c28b5bfcd59f7564790bf2a74a27bfe4995be": "Mighty Masks",
  "616ab81b69a2873ffe4851f46c70b0f052dd573a": "Mighty Munching Melons",
  "45926ee43f42b4a6edd147d365b76e947bb0f2b6": "Mighty Munching Melons",
  "49ee03240d2d023d57c9826c491e63b9d0aa53a9": "Mighty Sparta",
  "9cfa14ab8d0af4945188276d8f8705def4f8ce89": "MightyMedusa",
  "61d3b3b8be5ec2d521a2d328b318514d57c8b0ca": "Milk Girl",
  "8b327056c08e24febc2b0126d9607be49c880d5b": "Millennium Love",
  "c592f67f1c727c2460bdad50392a18a8afc0183a": "Million 7",
  "78a3b7f6d92604ffadfef547cd2736b42bc5484b": "Million 777",
  "e1b481336201635e218d984b9cb25b8e043a9437": "Million 777 Bells",
  "ec2c9cd3b678ee63c4f16fee7009a7ade569b85f": "Million 777 Coins",
  "b2b39773fb676e93992ac8bdb301aadf3bea627e": "Million 777 Wheel",
  "2636f1a918fe4423a76bc7244ae7ee98c6941a9a": "Million 88",
  "1832e68791d9b2e41dfc6e73cba5bafd867474e4": "Million Christmas",
  "cf5b1f213ed3110cbd60f088494394aedf43beb3": "Million Christmas 2",
  "a2dae4e094ab97a4395520000a465739d6504f0b": "Million Christmas 3",
  "6774ab7baf2d9546ebb82bc1c41563fcfa7f651b": "Million Dracula",
  "1bd889f2951fbf2a361c76f6d7a53253cac17e93": "Million Dracula 2",
  "22de83f6fb085841af3fdd7a316281d4b1c86bd0": "Million Irish",
  "067bfe5ea44ee554a2f1b74f99f8b2d7b2ee7ffb": "Million Zeus",
  "e9fee880957e6f46f840bf4809ad58c2223890fd": "Millionaires",
  "f9f1eab0eb3ed2ccd2e9ac480488c0299a208fbf": "Mine Mine Quest",
  "b1d25eaacfe747a088077abf16dc9e2f4a30c8d0": "mine-defender",
  "0299e33bf2fa92a9bfcfb7624916019dd39748a5": "Miner Donkey Trouble",
  "01694ebb61114efc9bac5b8c66019a488b3eca70": "Minerz",
  "95664262f1939fab46d5af74eab256fcfb1bfe73": "Mines",
  "5a3e475cfede2481ffdf61dda93b22a7bfb633eb": "Mines+",
  "ad192a03b6ac1856c6ae68e34895d64a12fff86b": "Ming Imperial Guards",
  "839569519b4dcd477ae9451369313a4a2c3ba3c4": "Mini-Roulette",
  "22691eb44d0e18c8cbde4f47246fb21bd8e9d7b5": "Mining Rush",
  "7c0fd3c0cee1e1cef3fbe9560321b54cda2cefc8": "Mining Rush",
  "2ac71cffa819fef472a28d881b3256ae99d417c8": "Minted Mike",
  "adb0026a3911e7c5d83338eb1eed5469e07e0417": "Mirror House",
  "5e06aa4ab5650ff1400e29eb820455c348e65bd7": "Mirror Joker",
  "740e15a0eb5f216684c94cbcd43f35d7ce2cfc3e": "Misery Mining",
  "3514d2b27aff9ee3ba6ef935c3ea286311861b94": "Miss Gypsy",
  "3acd8ca5953137c8109ca93bd554372ed29b2866": "Miss Joker",
  "52b150bea5898850b1cf4e729b3c1055b2e2a6b3": "Miss Neko",
  "8fd4d15d0a9c49bca380b020040f3cda3d971a1b": "Miss Sailor",
  "a04379ad6d42064620b9b60e45cb824082974b4c": "Miss Tiger",
  "543957d1791622cfa62f3d24934b600785f7b1e7": "Mission Cash",
  "8d6687acb457a7d0d0446ca5db114e5ca1635c21": "Mission:Vegas",
  "657a66396438d66b8e2131a76d3becea9334c43e": "Mistress of Egypt",
  "2a08cd7a02bddde0c65210d00bb834453e291c1a": "Mix Fruits",
  "c3db94b324663dbff579314009922189df4c7c32": "Mjölnir Splash",
  "ccebe6046a295fac6881ab3e0083e45268e95365": "Mochimon",
  "bec781794ddbd4875c1f9a70164d4388726316c4": "Mochimon",
  "67a594164a3eadb166819af1493d800b885a454b": "Modern 7 Wonders",
  "22b43a5569afbd1600d6ae4effc01aa5813aa5ca": "Modernizations",
  "770a31d5b2558a6c6b56bff211a118adf5b55877": "Mojito Beach",
  "a559eaa1edcbf5f1dfc38e2b1b2a160c87d1a296": "Mole Money",
  "a3c7efa8da12cdd324fb582ea27376576c46d90b": "Moleionaire",
  "159580d80ef703e4420dcb5acbd2748ca534a940": "Moleionaire",
  "c26d6bc1cb460f4ef5d04dce3695b2f0bf2bf93c": "Money Bunny Show",
  "177586845c6cb9d88c5bdc93a86d4ba74f32e9e1": "Money Cart",
  "6784849b2373cd49e988350221621af51aab8bdb": "Money Cart 2",
  "2e71620b78d5d43cb589babc8973bc56cdf28a65": "Money Cart 3",
  "f32e6c50f261b032065518c0a868ec4c8be4b2f6": "Money Cart 4",
  "eb9884a238b9a3ae24e7ca2a410af7131c4a50d6": "Money God",
  "e81b3d630f77e05bbb582ed3931870b7c8f294d0": "Money Maker",
  "0a093b74119822dcf3bd63f5b6a9f68c7d6fa184": "Money Money Money",
  "1d0cdff21a9adbda024c072a3bccbdc16ff49ea9": "Money Mouse",
  "3325353790ff8c9406c9f0dcdd48c95360351a48": "Money Mouse",
  "8d58f5a13a1fb77db149dacbd83ebfe5cbb05894": "Money Sleigh",
  "f70261ca03abd5ff0222d285622a6b309d140917": "Money Stack",
  "e35143b1827a0ca566b1724349020c6f21dec160": "Money Stacks",
  "055f2e5d0aa17fa711e9f60ef4578658290395cd": "Money Stacks Dice",
  "697c37089182d9dc85db4207735d9232a483a441": "Money Stacks Megaways",
  "ae2a7578493364d6a4733cc096f1af79c89637ab": "Money Stacks Megaways",
  "fb1a008559fc440d1bc09b0ea40337643e24be7a": "Money Time",
  "a8125ee4377f3418cf6d5b29e9d534ffdb7bd1d3": "Money Train",
  "7e71d2724b4c0f6f9aec06f98745bcbc75e1b7c6": "Money Train 2",
  "1b4c379a02a22d1d4aa5402a81a782a3b7465a9e": "Money Train 4",
  "0ed91ecd333195a543d564c70528c7ee7418559c": "Money Train 5",
  "63a1ce81b779137e9586d66db3f89df0647a82ae": "Monkey and Crab",
  "7ec1ec4e03f5533c2456206949f5b34ae6f2fc34": "Monkey and Rat",
  "7cac847b86e51984de3e5ed53b5b3d7ab9238a4e": "Monkey Heist",
  "d55b4bd8c12811252134d775d330e9bdfbe992db": "Monkey Jackpot",
  "f8086b8ee9c1b0a6dcb7174d54af5f1cfa37aa6e": "Monkey King",
  "849bafbf997b4da50a2fffc275fdb5cc3c580cde": "Monkey Madness",
  "b16e490186eef42a92b9720ea2f676cc896ab673": "Monkey Madness",
  "d6e88276464fd06599cb094ce9531c52ee5874dc": "Monkey Maniac",
  "504fed1378e4e67c3fb08b55161190b0a15f2c14": "Monkey Mayhem",
  "f62b98539e9ece18999098f5dd2b24054e6db6e7": "Monkey Warrior",
  "7f5e46c003b5652f0874ed3f0d82b18bf17883a6": "Monkey Warrior",
  "fc1ec3817034588822356bf267a124341f04348b": "Monkey's Gold xPays",
  "d298faacd8f3c41da81ae05665505496a5db2689": "Monkey: Battle for the Scrolls",
  "696c1b417fc002a92b6b231f9aa4dab6aa26a07f": "Monkeys Go Bananas",
  "665ee90f511a3b995fa214e425ddfa6220994616": "Monopoly Big Baller",
  "7a1cf111342931c84dc20b48c45f06c6a7d6ef64": "Monopoly Big Baller",
  "e9d7be98058bfa98bc0a0c4d1c9cf495a1356a44": "Monopoly Big Baller",
  "a75751b2b35b56fffde1a6889437294573e8a39b": "MONOPOLY Big Baller",
  "35ea42dad5bbef90ea93c4b1881b68c36b56dfdc": "Monopoly Live",
  "7d8dee017cb7b5458fff5fc29f23eb83abd9e222": "Monopoly Live",
  "c844b3e1a9a3f004d683cd0bf956c9663cd27281": "Monopoly Live",
  "9fabaecfa1f49bb77df5fa0cbeb8c2689fff34e6": "MONOPOLY Live",
  "e23ab1e807a8f0cd98afe75f63be0efae908cfd7": "MONOPOLY Money Line",
  "cf36b634380e6845d0b08abe91a95ad457d5d2a6": "MONOPOLY Roll 'em",
  "51e81fcaab49ffd78b9f64ef70fdad322c7a9d27": "Monopoly Roll'em",
  "5cae76c0165ee22afbd3f2a68dca2723bc7621b8": "Monopoly Roll'em",
  "2aa88570ba634e7890ccdc873db098c869d24f05": "MONOPOLY Roulette",
  "09f447124abe979a44962917879505ed64a07076": "Monster Buster",
  "c8ab08905e2746e63c901ea213af4cf8ab730bcc": "Monster File",
  "1e6d321af45f2d0a00551c1bbe45757257993209": "Monster Parade",
  "a4e94309a7ceab155e0e786ab65abac64d3744d4": "Monster Superlanche",
  "3cda320b1c5535c070eee0a709571e748fc1a2b6": "Monster Superlanche",
  "f90de4faaa9a6d6f1396a3cecc22200d036b0d63": "MonsterMashCash",
  "dc7da405cfde26decddf755d1534c8b5730d1801": "Monsters Multipliers",
  "9d1696d13335036ea14cfa585e3428c6649e19a2": "Moon Girls",
  "65c59e25e87806198f58de8132a0449941a60d7c": "Moon Goddess",
  "16648daf29f22bc095d5988ca96479dde53b8ba5": "Moon Princess",
  "24f2a70a0c0b9cfa4a9a6d0757af1ea4b0e21d7c": "Moon Princess 100",
  "c4d47b0e309ad2ab43da9295d7e599bdeff1d29f": "Moon Princess Origins",
  "7646bd2efa2b315a53f9c238fbed29df3077ea3d": "Moon Princess Power of Love",
  "d322c87ca4d7f5e971a26d59217546856f674aae": "Moon Princess Stargazing",
  "60c902d72eb5b8952d44643bd3159bf49b2d7d01": "Moon Princess Trinity",
  "a315b708d4006120586672965efc81b065a0b21a": "Moon Princess: Christmas Kingdom",
  "9344c32b3854534e6834d1b815a46b34dc51ca3d": "Moon Sisters",
  "220c7d6d9f7a4d29d67d49e34d26725747395d4b": "Moonshot",
  "f4b731991dd5135e8d48db9a0cf169cfe3d55460": "More Dice & Roll",
  "4f83a55591b8aa87efae7a136480d1400e7a069c": "More Dragon Ladies",
  "c93d288f66e6da4608fe11c82a3f4fc6d5e6b306": "More Energy Coins: Hold and WIn",
  "e9200e389b505a2d6d13951ff9ba5aa106b343e6": "More Like a Diamond",
  "a93338f71b137d9966a1c60702832626d69190bb": "More Lucky & Wild",
  "4e4630a618aa09574fa6f8a76077f4cef6b802a4": "More Magic Apple",
  "e0c699ef4a06d391191524e7c3fdaf7e49b07767": "Most Wanted",
  "a989c32c9630b917f2ad85b96c32b1cb28a8f0e2": "Mother of Horus",
  "6d8cbdbea7673bf0c9a1dfd7db92965003162966": "Moulin Rouge",
  "a893700226c7fc4eb0b94ebbd68429c860ea5581": "Mount M",
  "0a76651a2217cad7e942a8718c1d23bd1528412f": "MountMazuma",
  "dbda1013472599e1ea3e6f28a054f014227c4387": "Mouse on the Prairie",
  "19153f3b3e3d3dbe564f3253b17e9b03be5b21fa": "Mr Null’s Wicked Wares",
  "5b4ffbdadbcf64324ee2202deb27dd0e0e3227b1": "Mr Null’s Wicked Wares",
  "35c9fb8829adcaa095da39582c4f5243b57f2bb7": "Mr. First 10",
  "db4c517103ceff2cc6f9e8d4edb0637a2b3437ea": "Mr. Oinkster's Hold and Win",
  "b89ab8cf2185bc0624b3048cb8bc0064c998b3d9": "MrBling",
  "0b1a17df64619dabd33a05b506f773d924271476": "Muay Thai",
  "12fd15c0f3c89933d1871bb5be68fe758549267d": "Muerto en Mictlán",
  "dfd989c774b20c703bef4c611cd14685fc2a6d9c": "Muertos Multiplier Megaways",
  "7c8dee93a6376a82ab033009fbbd345f9186f01f": "Multi 7 Wild",
  "c0450eb9fa7383697b2d3d460398e77522b38ebc": "Multi Billyonaire",
  "d16e57460be9bbb395368892d85769c72245d0e0": "MULTI DIAMONDS 81",
  "2d01fda639b8c3a5628a4ef955040f38517501c8": "Multi Supreme 81",
  "a19c4f00034263fd13f92c5a485d05ca6c849d1e": "MULTI VEGAS 81",
  "bfae67271fea5c7c653ab3a85333e3086b59f5b7": "MULTI VEGAS 81 EXCLUSIVE",
  "85dd2467a3267f7fbeaa4eb1ebae05eed11aada5": "Multi Wild",
  "07c60c9a77aa7eb2c1d14fc86ee13b424c335b84": "Multi Wild 243",
  "d3d63bc53e81ea54d3259247479c00ecff4eb92a": "Multifly!",
  "2f3759bff44c7579ce097aee6ace65372a6ad102": "Multifly! 2",
  "8fe82b02cc2beae1cb5c24cdd81d65eb25f5feab": "Multifruit 81",
  "3363fb3d6183b0a55385897df4294646895e1843": "Multiplier Odyssey",
  "b8b125344c83de30f147478d7110ccac50eadecb": "Mummy Secret",
  "2ec6e2c86f80e3883b8e7195d9ced3a06cb3d02a": "MummyHunter",
  "d750dfd2f0effe264077d1235738d7c5ce19defc": "Mummyland Treasures",
  "3efe244c8cf21532358b74e93ec93afbf617fda6": "MummyMoney",
  "48d6a2635302dc2578ab993438bdca4ac3dcdc5d": "Mummy’s Jewels",
  "339985423c59a75e9f5bcf89c919a7b7de59fae2": "Mummy’s Jewels 100",
  "ba99ff1c9da59a880f936c2007b7c2993321bc4f": "Munchies",
  "f1d0f95a26e58596206c2991f67ae47f021e9ffc": "Munchy Milo",
  "16da36ddccad79bcddb2cee81fc2ff580b1c09c7": "Munich Beer Bash",
  "f0ea659dd4e26c07ee53153dbd362d8859b6bf12": "Muscle Cars",
  "58f0e804d9d5175c083719fd9515203cd47a35e0": "Museum of Fantasy Fusion Reels",
  "ed2faee1bd83732406a8e4c07fbe6f2614fbb392": "Musketeers",
  "fa23ed3b4530117bf00c699c9269b18cbb68eadb": "Musketeers 1 wild for all",
  "907b608c84cebd33aa9c0448a01933fe5f8cd8b1": "Must Drop JACKPOT™ Hot Fire Fruits",
  "9cc7801b15b8c4350365ef16c2f688c6754844bb": "Mustang Dreaming (Buy Bonus)",
  "be7a944c1d2998abff28876abba2cd257cdca064": "Mustang Gold",
  "280a01bb953eb931c5b11e52221fbccbf8ea8038": "Mustang Gold",
  "55325ce2226a692a2f6657a927a685461e22942e": "Mustang Gold Megaways",
  "31b7f683767a4d6a25349e49ddeee12100223fec": "Mustang Hold and Win",
  "b31a36e3d62da03ba18dce7ff7f17ff42ecee75f": "Mustang Trail",
  "d09312f1787b551767bbd673bfae4fea76d3a57f": "Mustang Trail",
  "fb8f00a34188a9a610dd808ccef02003245b80c5": "Mustangs and Stallions",
  "8914ff43aed5f196607efcdced87f05b3b6b715c": "MXMania",
  "85765c7122943efc258dc649669ba8d17a3802e0": "Myrtle the Witch",
  "c375221b081abcedf699de89eaec849361442ca3": "Mysteries of Egypt",
  "33dd67ed660fc0fd5dc246760456d647162d8f63": "Mysteries of Karnak",
  "479a51503df240913283e050705501e5da440460": "Mysterious",
  "e4e52e3c288cb1650965a76a5276d8b02e3ba029": "Mysterious",
  "db230a7bb3e9ff51c7ff7c44ba0d319864c4c3c1": "Mysterious Egypt",
  "16a01915c858d21e704b139c4fe5d4f4f8a26d52": "Mysterious Egypt",
  "f8a708d51c46b2d37638793652181fd7ee62efbd": "Mysterious Pyramid",
  "df7450e9ee6bf68b6a1df345e84fb5477c4a8443": "Mysterious Witch",
  "adfa3a80ab4d5aa8ce305d4b59a066595dd8d822": "Mystery Alchemy",
  "48fe29daf4dde9818a83ee8ca4ef122fd923e0dc": "Mystery Bats",
  "38045d8cc9785eaa0695513e1b76317b68a34224": "Mystery Detective Fusion Reels",
  "8ceb85af8ba8135f568198a3aa7cf56605bdbc44": "Mystery Doctor",
  "fe8f333d84f01faf56df202a5a01d675f6838c67": "Mystery Egg Surprise",
  "b765340ceffa22d83d426780f4b75baf5a5e77cb": "Mystery Genie  Fortunes of the Lamp",
  "51468d8e8239045a7889c2b2672008288078a618": "Mystery Joker",
  "318bb15077817b62da8be2dcf76944a00f8d88c1": "Mystery Joker 6000",
  "7050faafcaa1f15828474727970d8b940920a2ce": "Mystery Lady",
  "a672a858a42db42aeeed7a94d4fa271a1897d87b": "Mystery Mice",
  "853e3ce55045c03cbaf441c0ac608dacc7277f36": "Mystery Mice",
  "fef6f0f17d7f9b21e40a1b5915c0e0d43c48911c": "Mystery Mission - To The Moon",
  "d834336222399135b60d2247e3bb2b45ff8601cb": "Mystery Motel",
  "cb6c186eb7cfa38fabf24e36de392881edff8e79": "Mystery Of The Lamp Desert Veil",
  "50a0dd7aa01f26153f94c70ff346dd7e83c7f2d5": "Mystery Of The Lamp Enchanted Palace",
  "b82299cd3485e351adf0cec8beee8c8905d2b79d": "Mystery Of The Lamp Treasure Oasis",
  "d2055881f080d851508c0760e39a1b8974b501ba": "Mystery of the Nile",
  "878377766cf8305b9cb274463c06c2218a59c19d": "Mystery of the Orient",
  "83683b89de41f689824d49df61759fa352d385a8": "Mystery of the Orient",
  "0dc655e7634255e85948e840d25009ed99ccafde": "Mystery Shoot",
  "0215f05913a1261ed7bb309e9ef99ac41e3ab433": "Mystery Stones",
  "d99fb0893d1f85d497744fc6269264ff03945eb7": "Mystic Chief",
  "851c8515e4f4538e7851d63bd04322c81ab7034c": "Mystic Chief",
  "a91d0920c4fcc6a8172383193793b9ffe21f6235": "Mystic Desert",
  "0bf1826e9f95a490531869f09e4c179c2bc037ad": "Mystic Desert Bell Link VIP",
  "523916e049795632d42ca75c2e8bbb60c2afcd14": "Mystic Lady",
  "396e395ca28afa97cf7e00156a85d0fea4b3c840": "Mystic Multipliers",
  "9b9411d44f1fb0d355a620866f16e58497871c8f": "Mystic Secrets™",
  "1dd1d9fd6457d3ce7dcf005e1fc8901b5f6cefdc": "Mystic Spirits",
  "407e199e9a327e36d1900e485f921b2aba44e8f1": "Mystic Tales - Mighty Hat",
  "89a83d042df3da1fa88ece60359131b9ec115803": "Mystic Tiger",
  "86e8f0f40f0b4ea9e5a88f2b3938c6fe13b39a92": "Mystic Wishes",
  "19427cc83b8ed7eb10efdd3e3c5b6916782e814c": "Mystic Wishes",
  "68bb2ff3550834c52ba37039d25ed092cad96af2": "mystic-orbs",
  "80b90925b01b15709042d159efdd41a3d9cef610": "MysticFortune",
  "59b82f2749dcd3313e7f4a95da02b6c7dd36f1aa": "MysticFortuneDeluxe",
  "8fd15b9c783e7376f0f8ac67b6b0c566dc9e487a": "MysticRings",
  "ad5654c82fdaadb591372eeda7e997b439e5936e": "MysticShaman",
  "787037b7faafec35b135bea5e26cb333925e4148": "Myth",
  "a96b101ef766405a41eab8d2b43254efc8ad6903": "Myth of Dead",
  "18670adc71ba0d95998735e1128f11815a986735": "Myth of Ra",
  "7208899379c5d9724c62ea99a69c122e001f03d8": "Mythic",
  "748a87333cb1937f56c9c546eb0d37a289e2f51a": "Mythical Treasure",
  "77e8c2326ded29e402031b60500836258749407c": "Mythological Creatures",
  "bd17cc84fa26f95d6c6e763726635c1379c730c3": "Mötley Crüe",
  "6c423abdac54c66e63ca53c5ceaeb2337f53ac01": "Naughty Nick's Book",
  "5500f80ac38468fde678f612a8406e71d2df6160": "NaughtySanta",
  "4400b26a7817cf2c98463fa2e38f0ab317c15336": "NaughtyWukong",
  "d808d0a26bd880f119e3751d7b7efdf38a124839": "Ne Zha",
  "c9a00a679d328ed49db54390e2cde9c8ee94786c": "Neanderthals",
  "66a5829b33c9037406b7309e38b9a1783726439a": "Necromancer’s Gate",
  "7ea888c714eb0f70a7d3100c473ff7f2aa53c9da": "Nefertiti´s riches",
  "e1f8d36ec59acc5050e66e6ebe8128d7b1733201": "Neon Dice",
  "49091ae0cf0f6b29c08d364667e46123093f04ac": "Neon Party",
  "94d0358b9d4a0a8bf273eaf445a8c6520414bd1c": "Neon Rush: Splitz",
  "32f802767f5b086f069d7fdfc4bfd1f7bb57b8df": "Neon Villains Doublemax",
  "2938e25fb0c3de64c3bf03f9becb491c18bf1bf1": "Neon West",
  "fdb309572ddf7ea5f8d14fa86e7031eee3fdcbbd": "Neonmal",
  "9433459c6c5298456d754ca2520e43f30e3d15ae": "Net Gains",
  "2c562930674a6709a04529986806982c1f7f07eb": "Net Gains Dream Drop",
  "97df696b532331da2e963299496c4e3d5c6c7736": "New Year Riches",
  "de1dea95d7eac230ad1a7ac9d2fb6879d2c83854": "New Year Rising",
  "5d115998f4fdc9b12ebc7f75d6d43ae71f41582f": "NewYearsBash",
  "fea6477288f1e91142535e9010c6010c04c53c27": "Nezha",
  "8047a3f8bd69cdbe52db7cc930e79e9ce2640554": "Nian",
  "babf725dfc020d40e658a882e68a8e509be98d81": "Nicer Dice 100",
  "28821a2adbcae999e1fae92218ffd4f7695d3660": "Nicer Dice 40",
  "f0d281af4b4b8529f89a24f92f40a5821d7aa8c2": "Nie Xiaoqian",
  "e425e2d2db7f1d58833b8c67a85c35d0966ccda4": "Night on the Nile",
  "b58147c9a44e05cc8762cc6dfaa1bef961216566": "night-trax",
  "775a309d54ddf3e1c6fbb15668a28cd974e8e506": "nightmaker",
  "9c26cff95644102a689ef5b47c7f84d45e4f8a53": "Nile Fortune",
  "80c5ccc3446c2cec1b7bad8a63d8665168421055": "Nile Fortune",
  "a131ac4e72f8732f4ff98b041f63b4054cebe13e": "Nine Gems",
  "febf1d4124f2751916b3ae0b767047a3801db1a9": "Nine Lucks",
  "d1a3857a877f9b048bb40fc18444b319be25fd41": "Nine Tailed Fox",
  "94c8397173bd74e648caf4b668d86e10d88f4ff7": "Nine To Five",
  "2a178f08d2e52f8c8bef2eade78f11610f177c0b": "NineTails",
  "582fd37c93e5a476cce1a6f4e054baf65ef95fb0": "Ninja",
  "1c7010b1844a5841bf5bee4158c2d736b7681dbb": "Ninja Fruits",
  "942f54db393d44be108b17b7dbba4d8834ebbe1c": "Nitro Nights",
  "f5d7be230f36651a159e617a8b17dc89b2923496": "Nitro Storm",
  "e21661f80f903d1e26106ce273efec6a7401d9a3": "nitropolis",
  "61cc95656ead616a5b0f28a08ea2975d3e0ea050": "nitropolis-2",
  "b37c37f834dac3ce18a0482f130720d83c230c7e": "nitropolis-3",
  "58431da6b4890af7dded901be0f06ccf669c9299": "nitropolis-4",
  "994c1cb70349f1f87417b3fd0f0fcd6d42fbb317": "nitropolis-5",
  "b4a3890f33d21a4f83d89c81193eaee005f1d71d": "nitropolis-tv",
  "90f9c1b8ad0b66670965d7d542fec90820791045": "No Commission Baccarat",
  "da3d3ac002746a1657c74cc6fbe4e19664604ccd": "No Commission Baccarat",
  "9ec2279a390ccd5dd8c5e306ac250432d4007118": "No Commission Baccarat",
  "d57ff6d936a7d648d511543304c5f96d81aa8a38": "No Commission Baccarat",
  "38d4ec8a7370fb707ae8082a1ebfc019ca2c80d2": "No Commission Speed Baccarat A",
  "6c53e6826f5552b8e0351429e38362ead74a6fc6": "No Commission Speed Baccarat A",
  "d91d223ac2e4f9d9423932fc9ba9525d10323057": "No Commission Speed Baccarat B",
  "e686dd3eb8785aabb208456206f89b8cc9a4d1fc": "No Commission Speed Baccarat B",
  "8355569b5689c2fe0e5c83c97f37efdd88a6e40b": "No Commission Speed Baccarat C",
  "da641da6c059d5c2925e4bdd3732e84aa15df0b2": "No Commission Speed Baccarat C",
  "727aca6d5a0c80296cd758e65bc72a0e05e325ff": "Noble Cat",
  "a0e89feb0076cadec10ec96dfa65ea8e4cf609b8": "Noble Fate 10",
  "990dda1c10013f6ab5a39648758c748e1fffc029": "Noble Fate 20",
  "a1ed5d47f032b08f14587b7f22af3fcaa58020e8": "Noble Fate 5",
  "f904fa8ebabd9f7cfcec8a9359541c7e9d0f85e7": "Norsk Roulette",
  "3665d8d1a99cb1486a4b2d6d55f5359897265aa1": "North Guardians",
  "623e127f52caa3b9657c86cb4ab935ba60a9fe45": "North Guardians",
  "5e20f60426f35cad0b34b7a1d882c1204a2e7e38": "Northern Boom",
  "d69fc3d6b0a21d0a43ffdf72bbdaa0a8e50f1833": "Nostradamus The Prophet",
  "657a1bc47ebb423cb6958f1bc9694da10b015cad": "Nugget n’ Nonsense",
  "e42eacd5fe88e807f33fe24495ea4c3ed5839cb1": "Nugget Ridge",
  "1ea97b56a7089c60b3672e251f2b177d186d0f4b": "Nuwa",
  "b6b6de80757ec4b2e3cad61dba1e7331b9d074d8": "NuwaDeluxe",
  "cfa869dd7c2fb4e07fbda12bd692e7acc06093e4": "Nvwa",
  "39efb5dfe2df8b42d37e2da7f2f4983251e72ce6": "O'Bryans' Funland",
  "0575a720e4cd675c65ac4bbcd12d92d5a5b441b6": "Oasis of Dead",
  "cbd8f82bc6ac9e398c9a63c540c522bb07c29919": "Ocean Frenzy",
  "de3a0dbb03af10e1fb33b75ceccd658ad9c45f34": "Ocean Journey",
  "94db94b1addaf5760e38f06ff591fd0b908e2e69": "Ocean Rush",
  "8b7af0a503fe73a80a8068ab9c26856f5da82cf0": "Ocean Spirit",
  "b6f6fa04592e08e0ff980fcb30091e4ea303017a": "Octo Attack",
  "e974aa75a04a6225172cca8572e866ef195f7230": "Octobeer Fortunes",
  "725133996a4addf2d1258abc4f2bded081168d98": "Octobeer Fortunes",
  "46bebe201eb592dd4072d7a241e70bf868f7fa3a": "Octopus Treasure",
  "2351a98c67e893dc658f9ae6519a0f4201ed7143": "Odin",
  "07496a92cae4e2bfcb928433183920a12725a39f": "Odin Protector of Realms",
  "6ce61a8fb065591f8a50e11f3568712a06aa3f3b": "Ofrenda Magic",
  "29f82115ed6a7c30776189f0f569b1d0dd4dfc24": "Oil Company II",
  "d804172fb58b81a5c0ae024f155cb56c4c6a75a9": "Oink Oink Oink!",
  "ade239ac3f5ba87b901afe228c18ba2a41a60908": "Oink Oink Oink: Astrosnouts",
  "b96daeba3635ee9edc1a9bf5b7ad3d76c1f9f4e2": "Oink Oink Oink: Pharaohs",
  "cc56ca1f9407d621d7199caff0d6565fb257fb3c": "Oktoberfest",
  "6ad18a12590daed4a06c7f5f6cd623af047dfb42": "Oktoberfest",
  "54796f96921530e58d6cf3207d25d22b57752a47": "Oktoberfest (Amatic)",
  "7454cfad2f1c5f4c74af1f43b55e0c44270ed707": "Ola Diego JUMBOWAYS",
  "3b901ccbdf9e4d56be47d7de2ffbc1e24302d4c6": "Ola Diego JUMBOWAYS VIP",
  "adec3552497d6d503ad3ce04b620afa76ad4e7ac": "Old Drac",
  "3cd7b8e0380ad16640e53374f13e1937344b3cf7": "Old Gun",
  "dba702073e4ff5a7975ba753bff3bce8fb4602cb": "Olympus 7s Dream Drop",
  "cdaae8bbf7a3b3023c94ac84734d3b328acb4389": "Olympus Blessing",
  "d886be4de5f3ad7a5d8e6bf9d0ac7e4e6b4bf819": "Olympus Destiny",
  "332ffa6288e96d88dd866fada4549707ae701a9e": "Olympus Explosion",
  "90d29f7d7e6bde60aeee4790335a32bfbfde716e": "Olympus Glory",
  "63cf6356ebb69e64b95c2fe6970905924790ef01": "Olympus Glory Buy Bonus",
  "f47a3e58620c80667ba994c4614cdedb50920bd2": "Olympus Glory Gods & Kings Link",
  "362fc91a17421165767831fe5602e2b5c95c5fc1": "Olympus Gods",
  "150dfe8a8fb85ee94d7c785f091ad9b8c8bc9bf1": "Olympus Rivals",
  "a872e866cb8488ad6e1e4037e16c0b6c51eff059": "Olympus Unleased",
  "b51b7bdccac42e9243ec451a40611dba73cd39e9": "Olympus Wins",
  "4419b7e9a7ea0221d554ab909e0e78c3e840f5c7": "Olympus Wins",
  "3d0ae40a7c797821bdad69ae8e308a6994387385": "OmNom",
  "0979eb44f41b3b3002faaaa4bde37c4fadf05b28": "ONE Blackjack",
  "0380165054260fcf3f0e99758820bbedeaa4fb0d": "ONE Blackjack 2 - Ruby",
  "2e878faf7cc0f093f16f5eea3846c7da6f32018d": "Oodles of Noodles",
  "7ca4132a197931e99c1563674297a6c0aa88aeb9": "Oodles of Noodles",
  "2508d56d07df9d500bc1ed7722321ead7d5d87c5": "Oracle of Gold",
  "a80f2f66e18370c6d0101e99b409b403a48a76ea": "Oracle of Gold",
  "50ae589d9e5207031b17cd8585d224134c607c32": "Orb of Destiny",
  "1249a8419362e1dfd85f87b04d90b3d1f9aa0bfc": "orbitfall",
  "e0e0d0beabf38d84a8d5974176859c9cad1e1a5a": "Orient Story",
  "b420fe0e7425583488ead68336835bcbdba7cfec": "Orient Story Deluxe",
  "a8c7b61ff19f8797ade3e538d73ca3efddaba7b0": "Oriental Beast",
  "de2f33a8fdaafe2101b7b0728b1ce62232c23b06": "Oriental Monster",
  "366640249c12dddd557a375700a665988e1d44db": "Origin Of Fire",
  "4b948d1962e89b9db6bb234f000ae9de40db331b": "Out of the Woods",
  "812db48c2042e1b5a2701317ba96d6d9ae5fda41": "Out of the Woods",
  "ea2dc896dd240ad25904ab02899aa04fa0cbcb03": "Outbreak Escape",
  "569da4c11757915dc228c33e8413b403f4b043dd": "Outlaws Inc.",
  "d1b417a3f3751ac1c0a7b12a323f58e832a6030a": "Outsourced: Payday",
  "1663cf1f61c037b2f20475054a1ca452b291dd71": "Owl In Forest",
  "655406897f25ce56c54bd1335bed18c2aa517ac6": "Owls",
  "a4333cd9d60b51c6f8c494ac9ea008914c42918f": "Ox Riches",
  "e8de508af400243e5db11c3e6c1ed78121ab2aec": "oxygen",
  "42d029c81248a0669d422021fe302499b683a5e3": "oxygen-2",
  "132d50383f52dce8330acab8f649c903ce143c18": "Pack & Cash",
  "c77e57de98fb8b73865ddae07368a06ac0beacc3": "Padric & Pixie",
  "0ffe8435c71848edf9bef62af48a1807e8b5dbc1": "PamperMe",
  "16d27b105a514100bbbdd571e1ebe74f69d84845": "Panda Blitz",
  "7e0f1e8fee50faa3d416a0f14c703c4d83e26a09": "Panda Dinero",
  "7d91947833fa4868a8980cc7fa28938cae181780": "Panda Family",
  "32dc531368394b65e91d53760daaf09717a3d6b0": "Panda Fortune 2",
  "b9f6100ca1a3b263faf165521b9db1eebbf77762": "Panda Fortune 2",
  "b15b501827da4ec1231a207e1baf8614eef9b73a": "Panda Gold 10,000",
  "f012a83266aa08443bd8988dbb685b7de009f192": "Panda Manda",
  "d59d1308384fdd78ca91b13314b0fd00e39a5d59": "Panda Ventura",
  "849a46a2232ffde33ec91c1404a93f4627447aa1": "Panda Ventura HIGH RTP",
  "b9d6a2199a407393462ab05317f6f22a993aabd8": "Panda Ventura HIGH RTP VIP",
  "da4e1ae23e9f254f3fb8a89fb6302b2790c310ea": "Panda's Fortune",
  "e3dc4ac4297371b607f9735c284eb8459d0a2d6b": "Panda's Fortune",
  "2e09a23147ffc665aafe9a312cf3be1352d0100a": "Panda's Gold ",
  "442f853f10a85734c9d9290485b1cc65e5d4a51c": "Panda's Gold Golden Coins Link",
  "38e0a1f052fa96e46bac6eced0aa0c2cd4c8b383": "Panda's Gold Golden Coins Link VIP",
  "5b78892bd33dff71d95239e8cc519da0566a4fec": "Pandastic Adventure",
  "c3c14ae9adab6ce8dd80c62a166f2235799e2657": "Pandemic Rising",
  "26e96263ced50d25abaae658a12c7b8dd9eae62a": "Pandora's Box",
  "07036a53819390c28a40f1a4259819f5764fba01": "Pandora's Box of Evil",
  "0a7c64fe5acbf21eb25eb997bc1b204848c8ecaa": "Pantera Rica",
  "1c3161d79ee3731dbedba7b0e0c6226aefeb9858": "Panther Moon: Bonus Lines",
  "c05a7508086a0406143ad592b375706cc21ac511": "Panther Queen",
  "432527ac662bddec66629d29b1fd58208f5918e8": "Parrot Bay",
  "ca51858a5e36a70ac96166cb96d4da8ea0a40386": "Parthenon: Quest For Immortality™",
  "45bfaee2353b5ad845c33c0eed928280bb0b996c": "Party Girl",
  "2e6d7116d57434c999bc3c6df3a80a761a246d0b": "Party Girl Deluxe Lock 2 Spin",
  "beab793a9e164108223ccb67768bde575a879ea8": "Party Girl Ways",
  "8827ae758818a0930275d94b0bff83f15d9bb8c7": "Party Night",
  "e7c281b8570a1dc5a08af33d58640303d9e6cefa": "Party Parrots",
  "9884707d617741428089b46845e8e8d9e1efd124": "Passionate Basketball",
  "377db53ca42c7fbdbda18db33d939628e4f20bbd": "Patch of Heaven",
  "0f423d842098eb44606f12b5e781f4fcbd20105b": "Pay Day",
  "26ad3aa185797039d01723204dfe21228fabdbc5": "PD Classic Blackjack 1",
  "2e58dee9b429e2885edb5aec7fd9dec6e5daa9f8": "PD Classic Blackjack 2",
  "4a217eb7391f72bfdd4e8cc799843c87869844c5": "PD Classic Blackjack 3",
  "cc09e2b93cba369f6d777436e4341cf3a7eb2503": "PD Classic Blackjack 4",
  "563e4c0c3b41b4812166748243496e0ca4af4974": "PD Classic Blackjack 5",
  "42895df55963cd7f7f4267128d7930f4d317a73b": "PD Classic Blackjack 6",
  "de69678b583496f470912ec6088113b3d397d4fc": "PD Classic Blackjack 7",
  "b869341b3b3bda5cfeed6806def3b4d3e4e151bf": "PD Classic Blackjack 8",
  "f06f6bff6ccc87ec6feb9b2049662ecdc5715390": "PD Classic Blackjack 9",
  "d3adf38f7fa3f476e30381a53fa6e8fec15b88c0": "PD Lightning Roulette",
  "8b51faf3e375790f9fb6fc6fc36d87dba09a1ffc": "PD Roulette",
  "784e17881b5c4dd1d8325e60728a754327974478": "PD Speed Baccarat 1",
  "c2e1390c7ad45e1cd4e49fe137287db00d2f155b": "PD Speed Baccarat 10",
  "96193ec866c37ba36eae1578915f84dd9635ab7a": "PD Speed Baccarat 11",
  "b55dd5f96387a9ef7eaa283ff69a593412fa9e6e": "PD Speed Baccarat 12",
  "36b64babce13a807d7fe83720b47a470da26a012": "PD Speed Baccarat 13",
  "391bc5ffee1cc703524b5426417a9d5bb68a5e13": "PD Speed Baccarat 14",
  "63e3bbcae22a921c0e7babba0037e96a8112be44": "PD Speed Baccarat 15",
  "bb7d56446974c7aa7ce83bfcf1083b67cc1ebb2c": "PD Speed Baccarat 16",
  "0d825fc6b5dbbf47393a0b6f2215b9ac0ecf35ac": "PD Speed Baccarat 17",
  "dd877f6f2ead12ebb5fc684b1d297170678be14f": "PD Speed Baccarat 2",
  "946ab74b7ddf4afa3152da1b43484db9644e1089": "PD Speed Baccarat 3",
  "fc003da89a4cfc240940d55b6eb93a4f81753bc9": "PD Speed Baccarat 4",
  "10260a546cbd1fe34341fdd8e8ab17e868e90d51": "PD Speed Baccarat 5",
  "362740542e662fd6e2046d70c79c5546be5c0bd0": "PD Speed Baccarat 6",
  "2e766d0161205f40d40210e35cba04b05c3416df": "PD Speed Baccarat 7",
  "a8972c219516d33d71ec617f0ff28c0e47cde2dd": "PD Speed Baccarat 8",
  "31b9021c4ce10acbb10e89b37ac75061dbc333bb": "PD Speed Baccarat 9",
  "e5b5971e5a53510efc32b4c379ace8926855eb51": "Peacock Princess Lock 2 Spin",
  "4095b70883fca060e1561368e1d5a1170736c168": "Peak Power",
  "8b431e7a6be4c7c0ab259368935f4e2ea57605b1": "Peak Power",
  "e846ecea507b152847bac5c3c89271af7e142b31": "Pearl Harbor ",
  "85b15ecd0771955231cfad6483d2be9a9df8ef80": "Pearl Lagoon",
  "7a8d8a1926f3f9c75e5e4e7b9796bfdc22ec673b": "Pearls of India",
  "5cfd5d6600c6e14c7159d08e3fb93d7c4ad90225": "Pearls of the Ocean",
  "142145fd88305624e1d6fb7734ae0d251843c7b3": "Peek Baccarat",
  "86d851e6d12c7c19c7911a4ef35ffede67ead310": "Peek Baccarat",
  "9fc602d9f3d748ebefb9ea223fab6bd40c67dec1": "Peek Baccarat",
  "ad9694d6176c87c8bec6ed85651ffa4ee297213b": "Peek Baccarat",
  "66f2b8ce7312a5a19706a10266e8756cf6b71c5e": "Peking Luck",
  "3a6a7b2ca5b3167f8d95d9303252c1748cd46963": "Peking Luck",
  "8b6ea34b99c82cb4ec412ad8511f89d6593dcc29": "Pelican Payday",
  "3e4fb301e3eef02678cc1942a5c60fecd7d5c658": "Penguin Family Lock 2 Spin",
  "f1f3b55ffa280400eee07e7ed26c693da0f3c9ee": "Penguin Holidays",
  "b2cd39244789de843ca246ddbd5071d1ca3db713": "Penguin Style",
  "1b2085efbe2a95bd1add6f4f623d3026e80bd076": "Penguins Christmas Party Time",
  "6a6b54146033dda04c363de60d2806267ef00825": "Penguins Christmas Party Time",
  "99f468a94d1c7bac33753070a76b72839439e82a": "Peppe’s Pepperoni Pizza Plaza",
  "5814926cdee4fa847d78338256a56c1d01993729": "Peppe’s Pepperoni Pizza Plaza",
  "5bd28baf51b863a4d922e801d8349b3191e60b9f": "Perfect Gems",
  "b8f3f60e18f568596c8698de84d13f1de78062a3": "Persia Bonanza Megaways",
  "37db4cd63fd93d25e7cb7d2ebf63289625c6fa46": "Peter Pan",
  "01bed68ff2ed14b60a44728658e0f23a4ecfed2e": "Pets",
  "4e92d6d7af479670296621aa37d4c76ddfba19e5": "Phantom Thief",
  "8f5e4f4fbc7001ce080ff791eb65e1a6f89fe022": "Pharaoh's Empire",
  "bc5a42a76279f27d9fb15125d943f7c7c6c3ba95": "Pharaoh's Fortune",
  "b0feffc79633c331175c2cbb2365b3baee51c7f1": "Pharaoh's Last Wish",
  "828c561a49d82cc8ce4cb412b71fd39709049147": "Pharaohs Gold 20",
  "fcf7b36558cf37c013fb7eeba3fbe68539c7dd58": "Pharaoh’s Ring™",
  "97f7bc590ff440b14cc206a61ffc346602482fc6": "Phil and Kanes Halloween",
  "81238d41afec04411a9f00e7fe63cafdb0c2cfa3": "Phoenix DuelReels",
  "ec37b2cd06aa2f0f3ab0bfd435f7c77e7a946b05": "Phoenix Forge",
  "3035f4deea473d2389116d141cca8a3db1e6a1ad": "Phoenix Forge",
  "a7994d98e277f2ba4c81f9d41d16fe20209773ca": "Phoenix Fortune (Linked)",
  "c48777556eca7deccf6d1b3e36341fe716d357dc": "Phoenix Reborn",
  "91e5def966caefc1ac424551eb85b9b493e5176a": "Phoenix Rising",
  "fe4e21ec350f8e808b67b30ad3888086eed266f7": "Phoenix Star",
  "3f836871cfba6ca9b0be7edde1635e3e3bd012cc": "Phoenix Star Super Pot",
  "a79632b552fa485905238c00f4f2711f397f4fd8": "phoenix-graveyard",
  "afc83678e6695736d3b7bf8c0c6d8cbc4914a6b1": "phoenix-graveyard-ii",
  "a03080d329e6fa65ccdf752d5ac01debbbecfb70": "Photo Safari",
  "bbc6bc9c6b8375689e22e820f02330e86f80a439": "Piece Of Cash",
  "347528cdba3f7d89bcd059824f38390a0256a9d9": "Pied Piper",
  "c79ba8d96ce417702d22d0511e71fe935afc5d11": "Piedra del Sol",
  "d2c494bc6dd36ddf02c1ac17f324583c1b41f5d3": "Piedra Del Sol Deluxe",
  "0a82dbd647a0ac94f6f9da2f1df8d703a0475dff": "Pig Farm",
  "dca0e7f1918d2625cb50f4fb4dd25d8e740372ca": "Pig of Thunder",
  "687273cdc010f8b25b0452c9c26f46d98bc44b45": "Piggies and the Bank: Cash Collect & Link",
  "51d49f8ca54c02b1c7b84ef42ed1d129c8f8fe0a": "Piggy Bank",
  "88089123ea787325cb5cd0ffc2ed213824470d88": "Piggy Bank Bills",
  "cd3ea0cf90899ff4628f69cd3bf3940b8c37f486": "Piggy Bank Bills",
  "525b7ebe3a3d69330f14d4404103266e51978eb0": "Piggy Bank Farm",
  "f3569d1c73d6877fefcc2b2470c7c771fc161784": "Piggy Bank Machine",
  "336b0f614c99b8bf5c5274408c3f069bccb49ac6": "Piggy Bankers",
  "4bba8242655fd5d0349af43c58f3da067e4302b5": "Piggy Bankers",
  "f5b8f4949cff2fe053e2ed54f2981c35b9c784d4": "Piggy Blitz",
  "c50c0cc038576af55f39a855d9b6ca6651305bb0": "Piggy Blitz Casino Gold",
  "a17fbf30f13389718f2a2e0cbd1dd734fea254ca": "Piggy Blitz Disco Gold",
  "f30a297f7ea68e395a8a8fe01eb324e7b5358b49": "Piggy Coins",
  "e5d2c10a1b80971c8bdf2fe93fe1daa9c695db0e": "Piggy Heist",
  "889ae483cfc674aa1b495e5c883ebb4466697d51": "Piggy Inferno",
  "cc9303ac4ab839e1c4bf1a9b68160a769cb609e2": "Piggy Prizes Wand Of Riches (Buy Bonus)",
  "9c816d0549ce825b287a7bd920ea87a13ba169bb": "Piggy Prizes: Wish of Riches [Buy Bonus]",
  "2b7a609d479a4039a5ea826388a5dafaa4d63604": "Piggy Riches™",
  "68ac899747e4ff25941615d274a1fe79c712f44a": "Piggy Trust",
  "515241a69dc8a3a944960976a08dd56f6acb0d74": "Pilgrim of Dead",
  "527c6b575f5664c3444feb4d5b9bb5e806d9167e": "Pimped",
  "75ac8deb9bed77c0b7789fa10b275499d4fdd966": "Pin Up Queens",
  "5a365b24c68c11df47bd0c9ce60237370d7d8cdb": "Pinata",
  "6a55391593cae8e5ac08db30c304ba035a93065b": "Pinball Double Gold",
  "47ab6a40c72fc26236312177f344e3bef50d4671": "Pink Joker: Hold and Win",
  "7a640803851f8110173909f662080d6a9fe935c8": "Pinocchio",
  "2bb7402ecdc6fdf60d292757d70b58edadc467c4": "Pinup Girls",
  "812eaf68638300982bfc397a40fb563679d9ed75": "Piranha Pays",
  "ecd627853336c9e3e1784c97ced5875dc336c042": "Pirate Bonanza",
  "839cfac0cfb9468c2a88ab0cce5f30e2ded23812": "Pirate Bonanza 2",
  "d5312153ae553482f0d07684019c79520fb0b5b9": "Pirate Coins",
  "6349b1b668c17c7ce9b0e6fa0efba7500dad4045": "Pirate Gold",
  "c180861fd36e484c0cfef2aec8a6d7bbc2326de3": "Pirate Gold",
  "d0dd1b84449f5afbca50564939b39912427cadf8": "Pirate Gold Deluxe",
  "615681164be1fccd907fe0b57285bdc709aee8f9": "Pirate Gold Deluxe",
  "1cd1d61444c192e98f5d914f5804e6abab631dad": "Pirate Golden Age",
  "4f4124d246f61dae6d2a3eecfd87cf2d0be28569": "Pirate Golden Age",
  "5aa604969b51cc30ef7e682d0c1d413c31492f73": "Pirate Jackpots",
  "3906b77c55a7989dd395c9be59dc0cd5d713255f": "Pirate King",
  "5be0060114c648026c8b328257f6958c83058ecc": "Pirate's Legacy",
  "5205046f54fa4f6b0c0b810ae31558306a1a7c19": "Pirate's Map",
  "9e9d2000c914e6e7db526a4583a6a6182eb0d50c": "Pirate's Parrot",
  "f61a2eb19e36447bb7d2fdb26112080935db1769": "Pirate's Treasure Quest",
  "df032033c83f1a6278f38304d6edbb5d73d7d442": "Pirates 2: Mutiny",
  "0a487da92dbdf48c9fb3159f2ab10e309103177f": "Pirates Pub",
  "4448d5af95057b896d06f5564936f4d042c0631e": "Pirates Pub",
  "00591ec6bec1670cf901eb2ae2035bb8020bfd9f": "Pirates: Smugglers Paradise",
  "c62e7f5837ea3f0c64ff78bc0f8508b018df6d24": "PiratesPlunder",
  "86e8383a5cc6b4e1c085d2c38a733a389e72bf07": "Pirateâ€™s Booty",
  "3444edc7f7bc55589d6bc8faf255ca37f25bf1ed": "pirots",
  "ba25d8d973815abc4d8b01202effa5dcc1e6781c": "pirots-2",
  "ab3a3f9a2947633c408603ea92c3724d8757a07f": "pirots-4",
  "aa76e8d625cb6c7cb43536429c87cc476997c0eb": "pirots-x",
  "21f4202be52241a4ba08f5136e08330a8f8ad0c2": "pirots3",
  "5b45dd84a386f091ef73f12270401132b09995d1": "Pixie Wings",
  "b18e6ffe0d4a22c58935c3dd04dc4c813d44fcd6": "Pixie Wings",
  "b16693f03049bc798f86974e01065a3ee96978d3": "Pixielicious",
  "27891a1d76596a027fccc7bb50cbb3a82f7e7b29": "Pixies vs Pirates",
  "02fbba93f0a64227dfc33d60e7b2ddd78ac8e25a": "Pizza Express",
  "31de3bc55165df99f95c4463d6928c6f5f06970f": "PIZZA PIZZA PIZZA",
  "ea8c6904a404b4c4d89a841c747f584b675e8206": "PIZZA PIZZA PIZZA",
  "107624956f4cac0cb99d6922a6af9b440da09789": "Plague Doctor",
  "dea7e9ccfcd89397d6ecace522a2c819ff877c05": "Planet Fortune",
  "949e7932412d2fda00ac47eb2a0c6b191bbe22c7": "Planet Guardian",
  "a914cd5f0985338f11f2e7089e44e9c0574e1122": "Plants vs Aliens",
  "22f26f972e959586f7f4d77e6a28507ca47b317e": "Platinum Private Blackjack 1",
  "da89062e2ea176955a3513742c7b8b2d7b3a6489": "Platinum Private Blackjack 1",
  "79ba9ba2862fc616166492fb461c4eba279c3aad": "Platinum Private Blackjack 10",
  "c50d104588859f52320c1b1ce437a62803c60a52": "Platinum Private Blackjack 10",
  "94ab2e2f0b0c814b30c080024db805b2bd5a4c11": "Platinum Private Blackjack 10",
  "a7e9469de8a54e578400e454b08744df656d5ef3": "Platinum Private Blackjack 10",
  "ade820bfa617d41d3e658fcfcc79362b11ce9178": "Platinum Private Blackjack 11",
  "829084d7d8f3aa15accacd14bdc842a5c72fd7ca": "Platinum Private Blackjack 11",
  "aa7739f155c56936e4f7d7c6e235f4751c234176": "Platinum Private Blackjack 12",
  "d73acf65c74fcd6367ddcee51a42c99525a5647b": "Platinum Private Blackjack 12",
  "75e2b66e6adb6ec2014ee5f968beb26b975a7282": "Platinum Private Blackjack 12",
  "d2a9e7419c831586640a32f0ce642e200f6a2b22": "Platinum Private Blackjack 12",
  "0bdb79f2f80356cc667421d60cc51f65c0e06c60": "Platinum Private Blackjack 13",
  "06c253f02d1732339090d7f30c66323fffe0c61a": "Platinum Private Blackjack 13",
  "80d0a67ca33e75ed10a9dcb88570b1ed76c42518": "Platinum Private Blackjack 2",
  "e0ffd7213251045d1f8e04a980eaed40abf82c3f": "Platinum Private Blackjack 2",
  "5d4999cba9d59063d9717e7d35ac37b4549a5c66": "Platinum Private Blackjack 3",
  "024a95f6eed79eb22b9e85103a7a353b6a91177e": "Platinum Private Blackjack 3",
  "a4f6a949db717fd011aaf86191850e04b4446f3c": "Platinum Private Blackjack 4",
  "b7f1d7fd3943743ff9fd021852893cdbdc3a3dc6": "Platinum Private Blackjack 5",
  "28b5e96c84be6a0b459126a3a53ab1779f1c7e54": "Platinum Private Blackjack 5",
  "2893965a2ca8e912cd9e4dbedb56c269e92b8621": "Platinum Private Blackjack 6",
  "65ef1393e72f340a301831f788c1734cf83d905d": "Platinum Private Blackjack 6",
  "66d84a832e7a601f3b3e27362c61d70517152ec7": "Platinum Private Blackjack 7",
  "cb711ae0cd3755afb60b42e8b673021bf9fdb8c6": "Platinum Private Blackjack 7",
  "8105734d373154e07abb32e9fd4d69d06f969629": "Platinum Private Blackjack 8",
  "c4f595254fabd1a7ce152e61a4e964d9f9de2099": "Platinum Private Blackjack 8",
  "37bb74c89b0715262517d57cdf71e225e4419829": "Platinum Private Blackjack 8",
  "6fea3e110eb2e3ace2bd5bd0b722de6dce3e3780": "Platinum Private Blackjack 8",
  "b4f3f987a5d5f73474830423668a0ce8b12cd654": "Platinum Private Blackjack 9",
  "cd9106738a5df454b45f98b44bd4399733287f7d": "Platinum Private Blackjack 9",
  "1f67d6b14bb146bbf3ab650192c01bf511343b8f": "Platinum Private Blackjack 9",
  "10c766f0b03153660eb0269747216bccc2830c1d": "Platinum Private Blackjack 9",
  "272f7b8ad69e6ee0ce7f6f9a98b44a3fccfc8507": "Platinum Privé Blackjack 1",
  "4a20af060c02c27f5dd83d812da14b3c5d034ebc": "Platinum Privé Blackjack 1",
  "0c07463415c618ac246e1b8199f4bb716f2e3dea": "Platinum Privé Blackjack 2",
  "165d769234e6f41750ab230bb75bdcf25d6a9ade": "Platinum Privé Blackjack 2",
  "55253cc54666b449dcb1cc528b16b3197026b326": "Platinum Privé Blackjack 3",
  "976818c5a92519d3b836d887ae91a258016db883": "Platinum Privé Blackjack 3",
  "0ed6a3f8213fb5d8969fccfac21e0d676631670f": "Platinum Privé Blackjack 4",
  "6084c1ec6198d272519b8133bf2a3334f47e5707": "Platinum Privé Blackjack 4",
  "3351747113803d54b57ba26ee1a251bae34fcf3e": "Platinum Privé Blackjack 5",
  "418e5906772025265a9e801698e0bbf70aa66d94": "Platinum Privé Blackjack 5",
  "e30e24f6e41b8ce267c7b7561bd64b1c18468d0c": "Platinum Privé Blackjack 6",
  "e7c45e56bdc90bd35b726d77b2714b25ba24aaeb": "Platinum Privé Blackjack 6",
  "a0856c6e07016602c13d717ad08026d471ded8a4": "Platinum Privé Blackjack 7",
  "a6f3f1c055d2d87648349a601bf343be66e9b786": "Platinum Privé Blackjack 7",
  "6d174b647b5e73f35441d5688d4eec0f8c0b2fd5": "Platinum Privé Blackjack 8",
  "a2fb386c3d47eb7321daca20f16491321008d4f5": "Platinum Privé Blackjack 8",
  "23785c7178f6a420050abd0f2cf50b06bb612a5b": "Platinum Privé Blackjack 9",
  "6e083244533900962e4e2348e25e597936b0cf73": "Platinum Privé Blackjack 9",
  "3bc47b004b0e582168f10884b3d9b2d27aac532c": "platooners",
  "6e9f1066f2c1a76922d902afcb3ab02b54c66658": "Play'n GO Buffalo of Wealth",
  "0b4fe06cd10f8baf5e1b777bb5b8d7838fafa31a": "Play'n GO Mole Digger",
  "7c9edfee31d13f9560d34eed1452346868c25ab2": "Playful Kitten Buy Feature",
  "3a792403a8634eb6c4a0555ea5bc9b045c779d2d": "Plenty Dragons",
  "60052447dbf2fd58cc5669ef91c92d708857d194": "Plinko",
  "ca7cb1b24b705255109b04ac23415a927b1c06ed": "Plinko+",
  "3ea726469ac7bc3704a2469013796c2177df2a42": "Plum Wild!",
  "762c1bd7f1d65e29e0e604e5f5724f82a6c0353e": "Plunder Ahoy Thundershots",
  "66698e42c30270032b4eb2a1b84bf6436d802f7c": "Plunderland",
  "af138dc2cc3361fbb742045779c9365e1ac3df51": "Plushie Wins",
  "9f1ee31ccdca6fd6bbe0bb487e46627c71b6ab09": "Plushie Wins",
  "e89ba9a2d61321c32c0c4bdb9915db7db7b7b3b0": "Po Chi Lam",
  "dbb92e54901b4299a1c482ef910fb66daea97074": "Poison Eve",
  "db3c140976d4ecb329584b4cea7b0f3be526289a": "Poker Lobby",
  "3eff214f09474c43ec618ba24e252f9abb839337": "Pokerstars Mining Bonanza",
  "78ffeb6997d50e0787cf2745d9fc8383e3bb254b": "Polar Buffalo Hold and Win Extreme 25,000",
  "68807405cb3d072854a7ec2a07afffc70d5c4ce3": "Polaroid",
  "91f4ab5b7e45dfdade9573c89bc1662afa901bd2": "poltava",
  "a66236f962f9082aff3e131ba1821c4dfd23701f": "POLY DIAMONDS",
  "98ef180a9851e49b7a327e783fe8a8ca0fc8a313": "Polynesian",
  "a41392cbeb067a7f81ff5811403727d9149097a6": "Pome Race 10",
  "5e5ed52fe095d79db98f274975d560fbbfac79ee": "Pome Race 20",
  "bb0c0f029ec3253800a9f8a20c35bd10eaa8ca51": "Pome Race 5",
  "01e88bb55b5034cb65900d6814445e9647b75800": "Pome Splash 5",
  "ed7303f2b6c4669af111fcb1c3a81c6218f62261": "Pompeii Megareels Megaways",
  "e297950ece0b77ea3a7529ac2e11c1fd65b5fc15": "Pompeii Megareels Megaways",
  "6d7fadb60ec80d2bfc3661b1ef9ee540d5736763": "Pool Master",
  "49bcc35070d969bda2c33d491671bc05cf5583cd": "PoolShark",
  "636921fceb87ce32d2a9d4e6e2e0cfdf0276fd1c": "Pop Art Fruits",
  "8c73f5eae58fd0b4b520e15d36afe2c48dc77585": "Porko Boost Super Pot",
  "973bbfd307b4a73ebcd78fef50a7df32b08659f7": "Porko Collect Super Pot",
  "7b294ba93c504db525d4e88c9f21f1380ddb3b5c": "Porko Wins",
  "7b8a4eb8cad233b4b15200e9b2661b886e8f2067": "Poseidon's Treasure",
  "75f4f9e3220ad291eaa32ad355643aadc0a2ec9b": "Posh Cats",
  "e46769e2d0b82c06cc4b333d114d4b6e10b300b8": "Possessed",
  "d45a1f393b37a557a71be2a8f74c37084a7cb54c": "Pot Feast",
  "3590350e13dd7080d95524a05249b1cf42a63bb4": "Pot o'Pumpkins",
  "11f79c17c8f392e406d542f6e17a138f0cf5a665": "Pot of Fortune",
  "80f5ed601ee7926576290e6ed930b54d18c88a36": "Pot of Fortune",
  "531bf79909a0ce645a6ac7cd0248b5726aa8641e": "Potion of Madness",
  "3b1e7869d6ebfacfd267bbb8a7c0d8149bb6a50b": "Pots of Treasure Win Ways (Ante Bet Buy Bonus)",
  "46cf2e50a5a3b7a0aa72af3e2627ef1a1fea3321": "Power Blackjack",
  "b8d9d8990265f4fc6fb4c599e1926bb1b3e0497a": "Power Blackjack",
  "fbdaecc974a4b7948db11de5b3ac3b0730de3f5c": "Power Blackjack",
  "cf5996ba86783e6548780a6923d4abd0f4f54200": "Power Blackjack",
  "cf53335f964a715ef7b381152a41ff4fe1a3543d": "Power Hot",
  "9555d72165f78926fa141fc16951631f7b19b2c6": "Power of Gods",
  "9a8cb02de96270592a21cf79e865f61a153d8ac6": "Power of Hercules Bonanza",
  "b04d6bb6f65e0a3dbf2eb52c6cbe46ced09be879": "power of Merlin Megaways",
  "69c4f992c9fc9e0b79678c5b524c22120d427ee5": "Power of Merlin Megaways",
  "f6a1b8afece0cffdb9d7f9f6e73034c396a3df5b": "Power of Ninja",
  "63117be1b8bdb620a3cd69fff34372ce7b0975ab": "Power of Olympus",
  "f26ac5fe712daec99c1e62b9cc7507d69007783e": "Power Of Poseidon",
  "e1bd6a287b378242a4efecf46b127f0dd27b9071": "Power of Ten",
  "5bde3ebce65882828fd1080b5e24992568793805": "Power of Thor Megaways",
  "ff8f80355ef4ce3deb2a811759aeff01859436eb": "Power of Thor Megaways",
  "d3811175334e52eec99d523972d64c1d3c05d7d3": "Power Stars",
  "31798c4cdb1830c7cd7464422034b87c32cb017b": "Power Sun",
  "3184d081ac668885536f8608149f13c974b6fef6": "Power Sun XXL",
  "1db13b1b72a3d09fd65a8b68f6ce48133a1f2a8d": "Power Vault",
  "fbc4dc6f1ac738fe8ae2a7cf728ad41b84423bfa": "POWERBUCKS Cleopatra Grand",
  "b8d294b140fd5c65a89eee247436ceb95f7b70a9": "POWERBUCKS Gong Xi Fa Cai",
  "55db25a7703a4722df5fd4af751dc89bae15a2ad": "POWERBUCKS Mega Stars Ultra",
  "48f000240ae1c9add172946eb2434208db282397": "POWERBUCKS Wheel Of Fortune Diamonds Deluxe Date Night",
  "96fa92d0ec8652eae5f8d1e93d9aff5008183e34": "POWERBUCKS Wheel of Fortune Exotic Far East",
  "50f553b0cb90adf5e6d353a7bfa02292122aa33e": "POWERBUCKS Wheel of Fortune Hawaiian Getaway",
  "5300be81d3d30734bf37bebadf6196734954d99b": "POWERBUCKS Wheel of Fortune Latin Getaways",
  "9ed9fd0d7d444098f1f4fb05e88a0768257a159e": "PowerBucks Whitney Houston",
  "4782d71ad61cfdf0fce906ae3956488d6452ca03": "PowerPlay: Wild LinX",
  "f23d0a92804ee964df5bc388caa2b88fa9ad9bd5": "PowerUP Roulette",
  "4e786b7a6c4460836e30087f8c2cfb8f5bb99ad8": "Pragmatic Live Lobby",
  "73a74c0697770a24bebea8ee5c79494f87df4f1e": "Pray for Six",
  "3a2d9002e155f43e9b364d86e251df2bf7cfd476": "Pray for Three",
  "ff6aef334abde37733d0129a430f6810c66f63d4": "Presto",
  "3cd78d8600a69a23107f544aacfe6dddd24a4fd1": "Pretty Princess",
  "7112ec3714a4f0884480ecc5f4d75ac40016f555": "Priceless Museum Fusion Reels",
  "d09ee0670436938459e081a669bb3d0d5b5e7238": "Priest VS. Vampire",
  "85215f0241f8188195b3bbc5aba10dea8df2d54a": "Primal Rampage",
  "caaab41c7a94d761d8f37290e9862e0d55fb0da2": "Primeval Rainforest",
  "3cf300cfad6195303dd855f8aabd6fe84808e877": "Primitive Man",
  "06361a58a0bee71b38329c58ecc8a75101c81239": "Prince of Dead",
  "8e1541417dd1c325dee77da71ff2ed65cbbbe53a": "Prince Of Riches",
  "cfb79e9fa459c316771c397b063a052ff58351ed": "Princess Cash",
  "78ce587ed655ec9d1ced24d746fc1c98665e4a53": "Princess of Elements",
  "76607bc4b9c38d61a46a13b60089585d7d1cce5f": "Princess of Pearls",
  "0d8a0c7ecc643a17e2b69493e087aa0e67e1a6e2": "Princess of Swamp",
  "4438a02343f01e291ffba1d6684c981dbbd57cd6": "Princess Suki",
  "b0e0e2e883419d14ec4d551f05cbcda0fb817458": "Princess Wencheng",
  "ac3687d06203e96e1ffb15b466fad8610f3977c5": "Prism of Gems",
  "5012240a5ab7a422d951fd24cae8d132f70d4a4b": "Prison Situation",
  "9cba54285c2a41ef3ddce4ec3c41113b840f4b96": "Prissy Princess",
  "c89d32da266ed162d851648594b32755f9868df5": "Privé Lounge Baccarat 6",
  "6b26b854404119d99df047d8d7989b4d5e57313a": "Privé Lounge Baccarat 7",
  "47bf03d7c311c05788cf8a9402fac1233ca42d7c": "Privé Lounge Baccarat 8",
  "56cf4f158f00bad355bee6f770b7df6b15dab276": "Privé Lounge Roulette",
  "e122d281d3fe2f39033ab2b62f6c276985a8d091": "Privé Lounge Roulette Deluxe",
  "462f114cea4e5fa903add50d4aa7f4f7f54cb633": "Prize Of The Nile",
  "08527981a7dcb5f21f1f5a9b7e8897de8f7e3f3d": "propaganda",
  "e15790f604d7ed78acb103d2d3ca8ce4c5e2d115": "Prosperity Blessing",
  "d2d7fa6fe0baa29753539152dfbc89e0f7ce71f5": "Prosperity Palace",
  "0dc27e480d70a4efab34da5e58d5a8d358d4a0f1": "Prosperity Tree Baccarat",
  "2b5742d3d308ebb69af6d0bf66adf4ebdfa38c51": "Prosperity Tree Baccarat",
  "480dce4b7275ff120141832827f966ed69f3cfe2": "Prosperity Tree Baccarat",
  "bc0e9ddf59a752ab289c8947c19315687c4b3236": "Prosperity Tree Baccarat",
  "dc4d70a21c208725ed3d8b7e84dafb11b607294c": "ProsperityHorse",
  "78222a2622f2a4c95063c9cf7fb165f7abf406d0": "Prost",
  "a10d9a55085c6c231ed745af7845db414ed936d0": "Pub Kings",
  "836e06caff38be4cf6529c6a4a3b57204f4bd900": "Pub Kings",
  "65e89d48b128bd43c2c3bc9a2d41b0a725d0ba2a": "PuckerUpPrince",
  "a44613d3969f081fbf39a3af78169b5fd82e57b7": "Puebla Parade",
  "e7ccefbc928c48032a085d5bbbc4aebc05a13b34": "Pug Life",
  "3659a1f94d71efd7c62d19c0b282b98baf5d69d8": "pug-thugs-of-nitropolis",
  "db02a58ef924538ed34995789f3d0d25787d48aa": "Pumpkin Smash",
  "87e30c7abfab46fb2a15f66971efa34d184d7743": "Pumpkin Win",
  "9b3272f4b8b734173e29ae5e8f64ac45e851d2bf": "PumpkinPatch",
  "aae20b961c022576dc265a95bbf6c03fed639496": "Punk Rocker",
  "46c4c28f20c5e61d22ac4d1cc776eaee669cfb67": "Punk Rocker 2",
  "ca017ab8422850987097bd47aae33651daa9125c": "Punk Toilet",
  "5c69e8fef665d33605742ab72119260769440904": "Punky Monkey",
  "9136e91cbab82468056534c6d9bb8152e827353f": "Punto Banco",
  "403769a2e2115b479bbbf4d20833460ef1a43cf4": "PUPPET SHOW",
  "572babff235eed555b929eda3e658632242fe83a": "Pure Ecstasy",
  "afbe16b3b5e9a97deea0708d4e96348ef7b9d3df": "Purrrminator",
  "aff10355f96b3c3c2697448812fdc89103f45665": "Purrrminator Dream Drop",
  "59298e568ce1fa346adc69012ed2cba2c8548779": "Pyramid Bonanza",
  "96da567ac56f674b2ab8c0d6c2d3feb811a780d4": "Pyramid King",
  "41083379cfc945f0276c97b3c16619261a19edd4": "Pyramid King",
  "7eec63beb49e2e3d3bd1d9a6595c3869724b401c": "Pyramid Linx",
  "ee72b2053da537a6f5c6e2a63df2d34f91921cea": "Pyramid Riddle Osiris",
  "3be30318321a8a577b39bfd5f85b28951dfca793": "Pyramid Riddles Cleopatra JUMBOWAYS",
  "413179295bb7064736812fa644af681d8f77a538": "Pyramid Riddles Ra Jumboways",
  "7b740a80ae98e8e6db7d806258644a9facd19407": "Pyramid Riddles Ra Jumboways High RTP",
  "6a34dccdc397fbd40020af87b608eaa1730f15c5": "Pyramid Riddles Ra Jumboways High RTP VIP",
  "95e6e47686ff70040b56b951cdae3fb4f6652b3d": "Pyramid Riddles Ra Jumboways VIP",
  "8b289c75681b3b723e5d74266ce42adf408def71": "Pyramids of Egypt",
  "2722c1c009196fd0c9870e17c53ad84fd1359f8a": "Pyramids of the Nile",
  "c43f0742b11afd1dfd6e1452d28b013ab670043b": "Qins Empire",
  "bcc4cb2c18507e01933185ac0581bf3dc86cbe2b": "Qinâ€™s Empire Caishenâ€™s Temple",
  "fdec09ea49c663de3e88724daa04102e028999c9": "Qomolangma",
  "681748d5e02a3d56129a7201dad42bc940818533": "Quackin' Reels",
  "6c046100a122d74f6a51b8503973501dbc24d246": "Quad Link Count",
  "c30c5f5fe2339a90d17cb735c7cdbda07e05023d": "Quad Link Red",
  "12d10d036ca4461af666f2acffaa40377f5ad56f": "Quadruple Dragons",
  "7cee13ff496a7b1e00ae4751e5f6f37bddc3e4cd": "Queen Amber",
  "e7c82a92615dfce907e001c3be218f4f8d6af16d": "Queen Amber High RTP",
  "9e6fed9d3a4d582009af673f0629fe4f469bacde": "Queen Amber High RTP VIP",
  "6654001a3c98a86473cd04a3f71314ffde6c977c": "Queen Amber VIP",
  "ccabc66d07123d25fe0033c464980b6791bb6b02": "Queen Cleopatra",
  "07f6974b447bb44eb90818843485c013207ad026": "Queen of Atlantis",
  "6425ef25f57e8d8f174ab5f5001b354d6a880d1d": "Queen of Gods",
  "40dd05d2c54c65987920d299f166b4a60d1b1710": "Queen of Gods",
  "059652a97652fb821d8e1e7754109937ce730c2a": "Queen of Gold 100,000",
  "aa29ac69bfdee2f21d734f45259df9d184350c45": "Queen of Hearts™ deluxe",
  "6fc1c49fcaa4f718ce7250a3f6ce25c08b5249ed": "Queen of Mars",
  "d07c68957a0e5ba93d1122dcb1adca3bb24d8cd2": "Queen of Rio",
  "a9064647a4ff44df74437cf4a5637e28ed56ac5d": "Queen of the Pyramids: Mega Cash Collect",
  "2805ef591b66ba50011a8137e866bc6ccf49ca6a": "Queen of the Sun",
  "12147b6d8d5802d9774496b47ee4c7db0187a025": "Queen's Day Tilt",
  "997f48af3f32458665ba725066f02d78d2af6fdd": "Queen's Mystery",
  "87e0e9e6d6a9945af61a32b6f889ff74e4e37740": "Queenie",
  "9bdcc9c7c966dd0d7955011580e10f9a605ebdd5": "Queenie",
  "b89fb535e2187ee3f93e00d0239cb864f981067b": "Queens & Diamonds",
  "2b2d3d5589245f7cc9320776e567b6991107cfc9": "Queenâs Corgi",
  "ea2076cb129bd116ff7562a36c6a4668271d5e5e": "Quick Garden",
  "d80601da6ff0b1fbfe7c204cdb43db8d97a88295": "Quick Play Candy",
  "6566e9f813ead8ed263c2ad61dc83e01e873bec7": "Quick Play Jewels",
  "0675916fdf0dffdd6110f6531c65530f49a92c69": "Quick Play Mahjong",
  "a6b9fe0efc04f9bccc0e842143ab71d07cdaa8d2": "Ra vs Osiris",
  "2c0b01cdc014dc958b16cf2528a4d3e774ac0818": "Ra's Reckoning",
  "df6e81b1f2b5f1739d1e3708b5a37855757f7663": "Ra's Relics Bonanza",
  "2dceec897b648840710aa7203b4f949ba1fcbb14": "Rabbit and the Fox",
  "a9011f0c8973a2dc4111627c882f66171ecbe8e2": "Rabbit Bonanza",
  "4d214603624af56dc418b97788778b52038e849f": "Rabbit Garden",
  "b54085bf85a9a50e0a10f01e2d9c0881f2cba970": "Rabbit Garden",
  "6d5d0f21e3c44ad17b308a413995363cf12d46a9": "Rabbit Hole Riches",
  "e3e107c55611cfe73652b137c722731f7b6cb8a7": "Rabbit Hole Riches - Court of Hearts",
  "b3dd29c503c615ea6d0962077668eecc3cec9336": "rabbit-royale",
  "cba0bcac771fc94939d6e58b14c3dca1f5b5496f": "Rabid Randy Gone Fishing",
  "4e421524695f07b4cd83d947d985e397f7bcb033": "Race to Win",
  "dd4cb4d0fde254acd1a4c8f652eea2fb3bcd7568": "Race Track",
  "e85cdc6c234963e0c8f01c35ffb11dac5e5b96a3": "Race Track",
  "d11f81eba3bbfcf97d2031805c6034a14e34c110": "Race Track",
  "51f8d4ed2a1c6221e956ded4c7eb3e29c3c3edb4": "Race Track",
  "5d411ef5d11f267dc6dbde415accd54d6981f918": "RacingRoyalty",
  "92ad0381124fb7578f3b2b1ab715a3395d9c94b5": "Rad Maxx",
  "4779893695d58baa161104c75ee101efd2bf8121": "Radiant City",
  "9d369dc89542353d68df50b887b32d00b41562df": "RAGE",
  "c91843001c7f1a1978b36c155c4751787cdd3d53": "Rage to Riches",
  "52c1be7ffcf68405d946a7ba7f31f7a3794fdbaf": "Raging Bull",
  "98695026c10f48a3cceb828ea9ce4c068137cf6a": "Raging Rex",
  "81140f972f73bd7e82c4af6e41804f5e3deeaf00": "Raging Rex 2",
  "a0fc340533527ac2fb1b128b37bd0fe1d19c6585": "Raging Rex 3",
  "addf0e781cd85b3c68a7dce8a067357d83736723": "Raging Waterfall Megaways",
  "fc8154b26613d7eee44fa576369486313ab84a4b": "Raging Waterfall Megaways",
  "52928aba56ee3115ce1e07270ac7ec6ecf0a9a39": "Ragin´ buffalo",
  "8f285f2b59264185c28fce03eae77487806c9837": "Ragnaravens",
  "2629e1904e443488bef854c4506c43c598929615": "Ragnawolves",
  "f62d9f38e6fd2592c133d1120a5550c94857a2b7": "RaidenShogun",
  "ce498b90a7af021ad620f37f5d276398c441d24a": "Railroad",
  "c6681d0d247b2de3658d3b203821ab07f215941a": "Rainbow Fruit Flowin",
  "ae5b4cc16f45a337060e5dcd5b04280332c57f28": "Rainbow Gold",
  "d087fbacbfe2c5a0dd05de9c96067503092a57a0": "Rainbow Jellyfish",
  "af32bd39ab2d7004660b517058167a834936f8b0": "Rainbow Lands",
  "ccad4d61a01488ebeef27cba076568b76d8b8efc": "Rainbow Luck",
  "1c7c8ea89c30998b6d676aa64bc4ce0eb9c759af": "Rainbow Princess",
  "17ec45f53897966fbabb3a07445befed3a3c08ad": "Rainbow Reels",
  "b97bfb31ff23418384f1a89ab30c72ea214a81c2": "Rainbow Reels",
  "973eb1764029183d6cffc8ce8221209c7bb2f3ef": "Rainbow Ryan",
  "fd38ec8f8fba000dc9fb65a77d6b0f25b9579946": "Rainbowmania",
  "2480ec71e2d927ea62db6fcc582569cdcf7c9a9f": "Rainforest Magic",
  "29d59945cef40d5cea3b9b35541d2567345f8017": "Rainforest Magic Bingo",
  "2d25c1085bea56838ea3c49c21065668812e0d17": "Rally 4 Riches",
  "0ecd6f2949cdde5c8bf9fda02c260c57632c0b21": "Ramses Legacy",
  "0fd4f2d4fc688769d7b7001b6b668f32b69229aa": "Ramses Revenge",
  "831d643a42da68c1671715913f7ff36435826aed": "Raptor 2",
  "800bceaeb334b23c0564c57f30c6ab6a02b64ad0": "Rapunzel",
  "da528d69cc871f8b8453645fda05b1aaedc0a0a9": "Rarities",
  "61b1e56c7d18b6954b766c5608faadb771a0f721": "Rascal Riches",
  "63d1549cc4295e5d05fcd130f33a1c6b1ecdfe59": "Rat King",
  "8616c52db5cbab595171ef6352afb9ba13b00006": "Razor Ways",
  "b459fb50ca836e352ccb188b303dbbc46230d103": "Reaction Link",
  "ce70b657292aa07dafd450c11c939199bd400ac9": "Reactoonz",
  "8dae2060ccfcd96c4209fa412ee2679d336a25f1": "Reactoonz 100",
  "ff3497b8cba7b68b0f07dad9d75dd0ba89d77e77": "Reactoonz 2",
  "066cc5ea18626eb20a80e700b2b2c3f529a704cc": "Ready to Blow: Thundershots",
  "d875ec6ae3119e59ab6fed98dcf5f8ca18d60eb0": "Rebirth",
  "3273467ae551723eaec631717735edf5d78fe766": "Reborn of Zeus 3000",
  "81324748b09a3b27cfe43b70251e91b6a1b5adfe": "Record's Riches",
  "3b1d2b0f6ce63885e394ea7a45846c7f498b26c7": "Red 27",
  "60a0a0b66133ea2cf9e52240f6201770ff6a91cd": "Red Baron",
  "b7bebac52e62a1e8902ed7d01586f79e8bdea2c1": "Red Baron",
  "c325127df13adcf4dd5eff359df4ce42eb1b70d2": "Red Baron",
  "c98747c516f0c0c1ed47ea143f16b7a9ef493d3e": "Red Baron Live",
  "4a0a0d37090cb16492d14e31f0ba6ac0469bdb86": "Red Baron Rng",
  "8f3603f17ab8126c763611c4860024f803e1b143": "Red Baron Rng",
  "b9268c19c478acad541fda0fe797794148284b39": "Red Boy",
  "adab0ec99a5a1d3bccc0526bea4328bc8c304f10": "Red Cliff",
  "f4005161819d9f23ec325fa993567f519fa82701": "Red Door Roulette",
  "db9864087b82b55988379cd03011d958cf71b553": "Red Door Roulette",
  "339699a4c7732e78f94a46ddc57f1312693eb013": "Red Dragon Sails",
  "624d66ed22d1b29ce1b458f62b0904608068ddfe": "Red Dragon vs Blue Dragon",
  "2d83d8771e1d45cfa42752d7f4b5495fbc22ca8d": "Red Fate 10",
  "8d8bd723201b6f2d786c101a8905acb32f5dc30a": "Red Fate 100",
  "609660b61324706401115c6f8a414dc92ffe8447": "Red Fate 100/6",
  "ae92e95e2199ecf2be01f3764fda323b0308df4d": "Red Hot Joker Cascade",
  "d6ee4a2725d61cce787541d6fb585c9ed3fe05e9": "Red Hot Luck",
  "0877cd999c49d6a755ce992f2d5d64f8012fb6a7": "Red Hot Tamales",
  "6043e1f3ff2c9e83c319f074040e00c56f0e39a3": "Red Rascal",
  "f7b679d1d91230cee5a8da922414fe261f58b8fe": "Red Riding Hood",
  "6aa6f99df742aca477b51d2519bb50ef1a50859f": "Red Sorghum",
  "3fc31dd1a1f5f3f50c9c79c2abef3461d1f4a78a": "Red White & Blue",
  "0acfb9bc8a0b5b2f4dbe708f8fad5d60ae9ac328": "Red Wizard Fire Blaze",
  "3ac8b2bf92646034f488bbc93d996c5fddee63e2": "Redhead Bounty",
  "9e7997995743b61ae98aeab02b8e7df8077d7f97": "Reel All-Stars",
  "a51058816c5a0d66b2c4927080830be08accd50f": "Reel Banks",
  "4b9061d4a656f612da258619bcfa75fb949f3476": "Reel Banks",
  "4c7e36e1c51f32533b1c60ee5626125b4a279b09": "Reel Big Catch",
  "31e16268c26e463a77906f49f9125b4a63f4b94a": "Reel Rush XXXtreme",
  "a56cc235dec04e08bbf8d991b70a9459767ff1a5": "Reels Paradise",
  "ff6953aec515cd5fc6328e407b0c013551d7c8b1": "Regal Crown 100",
  "ff65bd169cd73ef83dcc2d1dfb837e977e4e2e92": "Regal Crown 25",
  "8f9b41bd59e2c6b4ce870e1ffd212a2edfa3f2a7": "Regal Crown 50",
  "a98136afa202f8b54b8196e447a47f2600c4a5bb": "Regal Fruits 100",
  "8274db0ad4d08a2e84e9b8c5678e30be27b8d5c2": "Regal Fruits 1000",
  "f533777f75887e3c8386a07b8ed41b0bd9d5839f": "Regal Fruits 20",
  "942a0fad100543cc64cab622c73b79ee5826801d": "Regal Fruits 40",
  "19f9fd547b234dba710c3f40376cd7e08d02da15": "Regal Fruits 5",
  "e92242b28f9c6b2b9e30662372b3da0fa4cdb5a2": "Regal Knights",
  "d6b87920fa08e41ce5f9a38f2b6905f3b0225b23": "Regal Spins 10 Pate Link",
  "73bf3cb31f4d70b1f192ab03cc96283e6835d34d": "Regal Spins 100",
  "c06d6077450f91ebd2a179feade8736a2b833005": "Regal Spins 100/6",
  "d6e102fe7f0fca2318338f75a09960b219892465": "Regal Spins 40",
  "414152acce825227fafbf43298630eac32f39055": "Regal Spins 40/6",
  "1b971e955d21906e1c771cc20fbbb1f2d59d3358": "Reign of Rome",
  "d5398b4291f6f9a83f45e8662ca790c938139425": "reindeer-royale",
  "000a499c78dbb87aaa64419b070be56e9fa11b6d": "Release the Bison",
  "50900a8a2d3fb630c061d63c216ba00ae69756b2": "Release the Bison",
  "9834c9727f28bd1d8d93b0cf82497973c94ff9c6": "Release the Kraken",
  "03bfb65c36471768463a0fe930828cd519aa8910": "Release the Kraken",
  "0490aec54c0680a5366743e89dc3c8aced1434f3": "Release the Kraken 2",
  "ddb0ca9d9f95f1763edd5fa53a8632df9f50e361": "Release the Kraken 2",
  "42434a32b7b34ae24ee75198a1f37ff75bb910cb": "Release the Kraken Megaways",
  "59dce91e15278827d2b4cf520d6c081e174ef18b": "Release the Kraken Megaways",
  "6f818f6d6a55119a9f23cbbe6c13692e3ec140b9": "Remember Gulag",
  "ebcfa3d03be20b50885429c7fe16411d0df0c4fc": "Repair Robot",
  "baaaf0e0af74735affc758b7abde0f793babb59a": "respin-circus",
  "50559f027683d34b970a3d9e9fccf40b199f2990": "Respins & Diamonds",
  "97dad4bc22813b341080774d6e2cd0b85b183451": "Resurrecting Riches",
  "66c5a16187154f493d4cf066c81cbc1c42a7bd21": "Resurrecting Riches",
  "59197ca89f78c4bccc2389a8854e239a09efe193": "Retro Cabaret",
  "8935fce4d63c76bc04cfa27313ef7b7599e5884d": "Retro Electronic",
  "6d3cd44ae9376d5a442f38d5869753b2dfd0985d": "Retro Rush",
  "134cb0869bdd399168e464e69e41554eca036e57": "Retro Style",
  "1af8e75da89d2ecc53b994445f4374e07cbb1a86": "Retro Sweets",
  "92e8f1c80d910c35ce76c298ff4317b69c052f9c": "Retro Tapes",
  "69ab4f58d3a7210fb1d69bc56ea3c23d2928f47f": "RETRO WHEELS",
  "519bd5f72af2b97c8398d119a854cfa844783d76": "RETRO WHEELS DICE",
  "41fc1b301897a96da806086c033f1abed3a421d7": "Return of the Dead",
  "e8ec892099f9694fee12c11f2e35798c242cb079": "Return of the Dead",
  "baaa12b02b19c180ed8cab88d2b30de0400aeb5b": "Return of The Green Knight",
  "92bdd6f92017b6dc13ab52a2a1beccdb27beae82": "Revenge of Loki Megaways",
  "4fd85d7c1f353f139b1ea1e0d657b40b48b63aa9": "Revenge of Loki Megaways",
  "9f4f0a52af1e86bf634e1c24d2a20c15cfa0ad33": "rex-stampede",
  "3d86b32401bc5652b5ced7148b39ad05e8eeb520": "Rhino Coin",
  "3c1b7f139e7641095ac6aa913e771a40fbb795e3": "Rhino Mania",
  "a6cb39f001d3784cb00aa0157ccb3f278ca4f0f1": "Rhino Robbery",
  "9c9fcea4c85d4953f892dfb4438191931f69d9d2": "Rich Diwali",
  "6d81d3c204c5f61249307c386177c59b07f9286a": "Rich Farm",
  "d93387262f1bf5ed09e6a13795f39cd081d7ba2c": "Rich Roll: Lust for Gold!",
  "63e7a13bc1d8ce984c4a180e7ec35bb8ec05c7a8": "Rich Squire",
  "42d0c26d0d41a9ce047888c9217292219ff42483": "Rich Wilde and the Amulet of Dead",
  "822a9506ae997f7673e0f7276ad4ef074d254c20": "Rich Wilde and the Book of Dead",
  "37569df6eb39b8cfc6f186eac44383cb5249d980": "Rich Wilde and the Pearls of Vishnu",
  "98da76bffdc3d3550f870dbca6bf1cb0d2f9e377": "Rich Wilde and the Shield of Athena",
  "7aef2a5c5ffef7ed8cea5d2a59fd5bc10bcc3118": "Rich Wilde and the Tome of Dead",
  "cd4e2bb10f165b49ad7c048fbf1221a5b0ef8334": "Rich Wilde and the Tome of Insanity",
  "2a9171829c8ebfa82ae8cf8158a3165a4a83392d": "Rich Wilde and the Tome of Madness",
  "7d36bba867b0a4171c52e6a52e6e965157989c79": "Rich Wilde and the Wandering City",
  "b4841da4c15a151a94de6729b95a77917dc2b587": "Rich World",
  "56a8eb303450113f6499a9912349ce9e57065efd": "Riches of RA",
  "09dc09f3763b5c42664b8d3e4b3002d30ca8a542": "Riches of Robin",
  "fbc3c8424f3c6a313920d454596bc4cf2b34943a": "Richy Witchy",
  "76e0684e6accaec2834df3e2406ad5869a41c8f3": "Riddle Reels: A Case of Riches",
  "744ab85fd5b8aea4f1adedfe5faa29f61f16b472": "Ride The Lightning",
  "44e056b12d5dddee33459386d8823751af956b70": "Ride The Lightning",
  "ffc82e0409d7ecace73efed6e482806da91b667a": "RideEmCowboy",
  "a5afe1b82c26176171d73c08d576806a2dbe9cc7": "RING OF FIRE XL",
  "751231250311ef43fcf1a3a323eb17e55114a639": "Ring of Odin",
  "0c978a18936be8121841bc08f8283f9255c75a81": "Rings of Prosperity",
  "9f1708b835d860bb83e3e674e495d742f7ea72a7": "Rio Pleasures",
  "589e751f37f8dbf8593b535006f7fb8a0fcc69ba": "Rip City",
  "e026fa233f5e0567e5f144789291725e82c31258": "Ripe Rewards",
  "2bf876a74fa44a90948f0406963265a4a706f6f0": "Ripe Rewards",
  "c41ed4afc1f7cf5f8a40e688da5c97463592d76c": "Rise of Athena",
  "b802cfa801044804bb09938f9c03edb948c6df8d": "Rise of Dead",
  "aef91a2363a68d13df8b22ceb464be757cb90009": "Rise of Egypt",
  "0e89e1669fcc18cc66f5be4d644e1c52c3b3cbda": "Rise of Fortuna",
  "0b91fb72ae8371974f98af01ad7c0f76945f1fb3": "Rise of Giza PowerNudge",
  "c27d39593eeb35bc2e16b48b0b08665b6827c658": "Rise of Giza PowerNudge",
  "cf8c39f48acb9dc7efc8964785488f280e2e69d6": "Rise of Gods: Reckoning",
  "205771f81d2a38b6a6c60a1e49990796fd20fb66": "Rise of Merlin",
  "693131e5880d0eabaefe6186cce217e5eb3b1009": "Rise of Olympus",
  "24cfef593ba06e49518c063ecca203f844c8381e": "Rise of Olympus 100",
  "59dfeb9ebddd46e27a702e5a45b2b3d86f8f1066": "Rise of Olympus 1000",
  "4656ddbf3c29ee2d18f76bb7a0eb34650e2ef5aa": "Rise of Olympus Extreme",
  "58a1d256c09b589a58503306ef891b1a9f0a9fdb": "Rise of Olympus Origins",
  "bed62d5a5a5fbf3a16d193c491ec53c5d6b080de": "Rise of Orpheus",
  "5e8c4829aeadbdf684df32346c119a3b5366b6ec": "Rise of Pyramids",
  "3a9d4a0811a7d696586e4ca12907715737315e0b": "Rise of Pyramids",
  "8101db1b7047121f02818b377b74cf8763cb6384": "Rise of Ra",
  "92b5c41043a728744b19ebd9616acd76c168b123": "Rise of Ra",
  "f14f6facd523091b7e6e15c1f45d090fe922b532": "RISE OF RA",
  "910d6d23dd6f71deb9233b16a3e57cb20acc2587": "Rise of RA Egypt Quest (EQ)",
  "03bf0bd587ad78afc6100d79e50dfed48e508556": "Rise of Ra Gods & Kings Link",
  "db3465f5c3c3b87c0d99ed0768e330bdf1a4817e": "Rise of Samurai",
  "79deef60d727dce7c1a4e3a20ed687c8366d317f": "Rise of Samurai 3",
  "63c091cddc0b9f9c0f7d90a576540ecf016beb4a": "Rise of Samurai 4",
  "894781e22a41f7d3b3d53b6d90105674f648ddfc": "Rise of Samurai Megaways",
  "306c8153f3e218f072f356d3ca9692811d1ee183": "Rise of Ymir",
  "d896cf59e67589b5ac44729c39528688cc78d362": "Rise of Zeus",
  "8c6af8726e252a76b3cfc1d2487a08fd02d1e3c9": "Rising Liner",
  "4ee2818d00551ae559e07e79ed4a9a7a4083dc49": "Rising Treasures",
  "c1674ae7f8787cf04ba2d8e772b5879b2e45bd1a": "Road Rage",
  "e1de58ae753bb0be95289db7a209ea6453832f53": "Roadkill",
  "b6c19ebcb765250e4c92485c829496746c5c211b": "Roaring Era",
  "a05ecf30dff99a4aff3a25b0a87b064d6c114909": "Roaring Forties",
  "33ec0cb1a927612dd9cf421f2117c63d746f50e7": "Robber Strike",
  "bf7d754f41bff2639a9517ef70922f48222b1ea2": "Roberto Carlos: Sporting Legends Feature Bet",
  "4a9014d4e26a0925823038272384f5ef5a097766": "Robo Revolution",
  "e1884dabb0f6016cda6e2e6e22f0fdbeb6acdeb1": "Robots",
  "f5d81877d4d57b60fdfee6446e23eb6ce19588e0": "Rocco Gallo",
  "a52356d6dd5de08c9f293ddcdb224e4c561da9f0": "Rock Bottom",
  "7a89a1a2d431c7deaa839aa4c24e226a8d5afc3d": "Rock Parrot",
  "5c77879027f1a0a195485935b083067b73503ab4": "Rock Vegas",
  "31595cce83030b10535e072c08a2188bac27d990": "Rock Vegas",
  "6e1a556fa18d63ca204486fdcecb568142549543": "Rocket Blast Megaways",
  "3ca1195a28a7a75cb2defba43b1d9f0fde93302e": "Rocket Reels",
  "93c8908981af9058d4b01165a9c4fe88c9ef0e5e": "Rockin' Joker: Hold and Win",
  "b0b2a6684ae135c084bf0515fcf49752d8d1e371": "Rockinâ€™ Gorilla",
  "f1eb1cbe4e85b6a9e43d18d68065bafd2a76f739": "Rocky",
  "da1a8b22ca9d48ccb2d320e34534ea0664d35409": "RodeoDrive",
  "c15dae01fa7030f8f9d99e3cb40319b6c5d6a520": "rogue-rats",
  "1d940a88d269eed95cf4bdedffb3cae592029144": "Rogues Draw",
  "82f9d04cd5d9129d2f1ea873e26c961083050856": "Roleta Ao Vivo",
  "9b6c48d1b0619cbcfbbdc013e8b49e94f5a92cff": "Roleta Ao Vivo",
  "a383e07ae578af75bc39fcbda5a7b4636ffd8bff": "Roleta Ao Vivo",
  "725a3c0a9e021400bc96003ec50e06b06575a21f": "Roleta Relâmpago",
  "d9b277eda30b9d755c5ba9fa06b42cb4e2fac977": "Rolling Dice",
  "f0ec4a15481a70f5eb85e1a247247d933774e70b": "Rolling Dice - Christmas Edition",
  "9e469f9be1509ca95d71831aee99070db68512e3": "Rolling in Treasures",
  "409b3f11bf5f13a9a0831995ba3870d20afdb560": "Rolling in Treasures",
  "3d63cabe992a71b59789db7cfba125e24e96fdc4": "Rolling Wild",
  "46d02a5c248830e6e7461b8ca9569aba12deddf1": "RollingRoger",
  "0041fbbc0d072c445e46989d9e9138d87ddd8535": "Roman Bonanza",
  "31bd33c6ba5ce10f5cd49261dffddfaf46385994": "Roman Fruits",
  "a5816d8391ce2b051f546851211e7c76c72f7c7c": "Romance In England",
  "f338e0f8efb27a7da6208f3129346ed13d955b34": "RomanEmpire",
  "64d7023511f2104f62a4eb1d0df4842c8813506e": "Romani Secret",
  "4360cc2bc8fd06e6be3eec123f4119cb1a202842": "Romeo and Juliet",
  "ecdd3150ceec57bac382a4a017069c01b5f778aa": "Romeo and Juliet",
  "4f78c9e65b8c5567b5149dcf184ac3cc6494d440": "Ronaldinho Spins",
  "7aca4f8a3b8f2a873a6876a9147927b6648cf942": "Ronin Stackways",
  "fdf830c6a0302f8f501c13771fcac436acb6208d": "Ronin's Honour",
  "1474f4e66803a20f4711ba52103697f3a171ff26": "Rosy Orbit Treasure Turn",
  "745b2b24714426dc9f1ea6cae2839746f255ce2a": "Rot Stormo",
  "1d39eff9070c5ae96d8c6a9b79307548aac3976f": "Rotiki",
  "f3a062f268e2a3dce43e79cee7e28e74d39f7a29": "Rotten",
  "0c718e15fd79cc99e4c7ae66ee22fc48f8a4dce3": "Roulette",
  "4d77b1ad75d6a278bb976c0f22bb4582b9637ea0": "Roulette",
  "e6633c5e22c2eb1964557b9be3b89c0caf5279d5": "Roulette",
  "55643a8bb4df17e4dd59ef550497cf11d95e7a8a": "Roulette",
  "5bb9b2d50e7c38d50ba8a94f187c872fc57e6efa": "Roulette Azure",
  "2a591aba279d357acdf84bad24dd9576f00b11d6": "Roulette Green",
  "b245053432ec98637d0ca3c284ae60fe0c2ce808": "Roulette Live",
  "c378e6fbfd9b03011b43edd7159a922f0c5781b0": "Roulette Lobby",
  "58c0314aaf2c2f26319a4437609aa5c7e2698cb2": "Roulette Lobby",
  "97c897ad33b53a94604ad6458ffbe2cfde39a538": "Roulette Macao",
  "f1d3837843010a5af28f3a0250e190973bbb7359": "Roulette Ruby",
  "32f0c981057ee5a9c3b5dbb0b264d4eff9f43de8": "Rouran Khaganate",
  "fcd273e433bda1c36265d731db9b39edea1e37d0": "Route 66",
  "16443d762e9b1e5f134a97f58c87cbdadfd74bf9": "Route of Mexico",
  "438079629422f95bbb9cf2cb906c6556913e1786": "route-777",
  "5f99c192624682ff9f298373258ee2e2e1d8440b": "Royal Coins: Hold and Win",
  "7219100fb7e8eddcd421fef3288ec058be15f50d": "Royal Demeanor",
  "4cf60365ace1eecddab00199ae0c77c39596db6d": "Royal Express: Hold and Win",
  "526403c0298e03f077b3ab4f78b66ce0f9b6b371": "Royal Fortunator: Hold and Win",
  "589ea507968aa8d6d5dc0cfc3bade6ee16286958": "Royal Gardens",
  "d49ac2bf96418063503e90198ec2314010069d83": "Royal Gardens Buy Bonus",
  "9cdcf5b72b8334f7b806388973061362cf8c97ad": "Royal Griffin",
  "f918d2ba1697526d5030d13e2a64e11714dffc8c": "Royal Joker: Hold and Win",
  "564d65e875b4ee91fec66cc3d979dcad555c9039": "Royal Lotus",
  "6d5a84be74efc6f40e40acfcc0e9782f9e48c1d1": "Royal Masquerade",
  "c2731da7f953b4df0427c4e3d93dbab9990d81ae": "Royal Nuts",
  "442c33a0df39a1374ef7ed9273cb1aa24a077d13": "Royal Ruby FeatureStorm",
  "a587d4b1e3bfb2567517f2395df576f589b53420": "Royal Secrets",
  "0e615dbc5dc8d1acebe9c4f1d2b689f92ee02f1f": "Royal Secrets",
  "a3c348a3357773c00b062b1156499d0049b5ba33": "Royal Unicorn",
  "9541b95fe50401cf907eebcad182c946849a8a8d": "Ruby Hit: Hold and Win",
  "ed5432683ed1205927f55b45445c1f6e65097a93": "Ruby Sevens",
  "851dd03f0f06692c7cdfb2bf6af9193a4acb55dd": "Rudolph",
  "5bfbec31fb4033908bf057e514a69e62a2e7b320": "Ruff Heist",
  "b682988f2da6ceec62c90f97533685173e7e972a": "RuffledUp",
  "1380f3c9561ff86c81ee5960aaf31a2291389f20": "Rujak Bonanza",
  "06ab5585590e7451e04120219100732deff011d2": "Ruleta Bola Rapida En Vivo",
  "c2abcd5a9bf0da219cdee9c70740f2e0cdf02bb8": "Ruleta Bola Rapida En Vivo",
  "802b1d0fc546342c9fac776ed24396e738a80e98": "Ruleta Bola Rapida en Vivo",
  "e90191779854525b4f53030ed404f6c581e9a8c2": "Ruleta Bola Rapida en Vivo",
  "119173117c7799596c720ab4e468ea0eae2ba304": "Ruleta En Español",
  "c9bb99f2725295bf74ee3cbe8cf32b80f351b17a": "Ruleta En Español",
  "5a82b68885268d38478ce4ababefdf4b57b6c24d": "Ruleta en Español",
  "d6e7a410a0136bcd659b68fda968cc3baad7d89f": "Ruleta en Español",
  "59e0bd6c8901358a398d703f7573b2c7a1978668": "Ruleta en Vivo",
  "3b3002e98a944045113160185c112e626a315796": "Ruleta Relámpago en Vivo",
  "efad6a8be69ff3cfd502f489461dcc7984be5517": "Ruleta Relámpago XXXtreme",
  "5ea3548202ae01b2c4dc73824df7c17b4eb81f4e": "Ruletka Live",
  "11d83b166095584abce3c3f8140e38c58f388e52": "Running Sushi",
  "a66cbbdb4ce74a1944c78b417548924b50e74e69": "Running Sushi",
  "3163ccb938660a660352d884df830da450940cb1": "Rush Fever 7s",
  "2b8b1cba40007e7411e4e1cb854f422b881ae114": "Rush Fever 7s Deluxe",
  "3d691cb6888210da9e6de8c9c09dcee8458a327e": "Rush Fever® Catch’em All",
  "59273f866c9b8b9b67e68c8df20bcb7e62d5e722": "Rush Fever® Soda Pop",
  "a02bce453d841b52f2e1c20d30920cf2e5d9ed1b": "Rush FeverÂ® 7s Deluxe SE",
  "ae5077bf6124fc7d9c4532919716083ee7228941": "Rusty & Curly",
  "a5d8bcfc48f3f3aa8cdc067ee430f25a7098133b": "Ryan O´Bryan and the Celtic fairies",
  "74f4a6f36a648909ddf8133c5512e7655dd3e638": "ryze",
  "638d368b5a083f6b900c0436a27a4770dfe87fd9": "ryze-2",
  "4d2d7bdfb2a0da11636c4383d6f487197daf7562": "Sabaton",
  "bb0abe650a4f896d481b9bdd66f94676d4f870c6": "Sacred Coins",
  "0d746df963a1c33ad4bcb53a841fc46520b1ab02": "Safari Discovery",
  "7bc42f46fb0ec5ed1e9239e0dc60ee94f07f3a3a": "Safari Heat",
  "2a3dd873edbc355ff9fc8496fa0219685c4fe643": "Safari King",
  "632fa6271f3f4d3b05ad8aaae78edb26db295230": "Safari King",
  "a3c7de485b49385f58af66f5707bd75838d1d712": "Safari of Wealth",
  "6455b17aabe3e6ba345072ad3f65bf3d03c4a067": "Safari Slots",
  "fb57ea41e42bfa9073f9d12768e5c09bce1173d1": "SafariRumble",
  "4af1257b9f9c85fa2bbdfbe4b950f1c05fab880f": "Sahara Riches Cash Collect",
  "119432cbf69cdde800342209bc3094c6ff605169": "Sahara Riches Megaways Cash Collect",
  "e3ed5cfdb3afdaf09d2d98774b796340777b3392": "Sails of Fortune",
  "436b39c619059bc6cb4128b475aa9ebcbad8145a": "Sails of Gold",
  "dcb477f771b5d6ae78b9c27cf0fcac184341c1ef": "Sails of Riches",
  "c8c136d457eca57651475167cdbc73dc0d319ee8": "Saiyan Mania",
  "d8d1a74206b28fb116734de78143a3f536953a44": "Sakura Fruits",
  "220adb1fc27b22d50ce254b01c55d065799d0555": "Sakura Wind",
  "4815eb3003e22c6ee24ace0ef11c22eab14a4586": "Salmon Catch",
  "05a01c348e781885a42220c8f86aff1dda943c4b": "Salon Privé Auto-Roulette A",
  "ba662e12aa0f2d7f96f9e630f8fe5b2a966f752f": "Salon Privé Auto-Roulette A",
  "8fa655ca20ab448a69c465ace6e48c3f5170baab": "Salon Privé Auto-Roulette A",
  "0a3015502df49173dec1880d19afc3a3503cdaf8": "Salon Privé Auto-Roulette B",
  "b3b42c8411da6122c48b8088c3ac166e25edd170": "Salon Privé Auto-Roulette B",
  "683c4f789f2761c7a8511d6091eac8bcf251b25a": "Salon Privé Auto-Roulette B",
  "30969f624472dd80eb16c025239beba4cecf5f96": "Salon Privé Baccarat A",
  "d0ca8aafcec8e0755047c5b9a587461463965096": "Salon Privé Baccarat A",
  "226a818eb1bf05dd24f8e0da8d4bc732915c0158": "Salon Privé Baccarat A",
  "2485b24c8f57e5f025df1b0cc250d4efb71f6349": "Salon Privé Baccarat B",
  "bbc1ddc68c164940bd59544e1ea1ba0fdc7f0e7b": "Salon Privé Baccarat B",
  "5e01eb37d866a8f35711e2bf58cd25356abfc0f4": "Salon Privé Baccarat B",
  "46971cf2818a78362459f862031f0748c6adc41e": "Salon Privé Baccarat C",
  "d8dcb3ffe11318d494f02ea28aeab95938675b5c": "Salon Privé Baccarat C",
  "47312933172d9f9449dc786f07ea25ee65bd8a5a": "Salon Privé Baccarat C",
  "6d1eccaad786bf80f205acb1c726a37f7bb0540c": "Salon Privé Baccarat D",
  "6f1c640e92ccd7ac130fb7bdc3ee215f68457676": "Salon Privé Baccarat D",
  "d0a1b22ff2e4e622676d203d94eb2aaaa2ca371b": "Salon Privé Baccarat D",
  "0d0080361fac7f15d684426b7307be5d50e87113": "Salon Privé Baccarat E",
  "58ad1b9b9d8e0db62b60dde5f22c21d838788c25": "Salon Privé Baccarat E",
  "a41a22aef5f8bc97517090ea92a22c9c9f042fb2": "Salon Privé Baccarat E",
  "11c473e5b920043616b39f0fcbee0efd8b79fb9b": "Salon Privé Baccarat F",
  "b19a8b1b051dbfb0f31c9fbbcdb3f79b0a639fb5": "Salon Privé Baccarat F",
  "d59a86e0e9d395dd4e81e5e69ca1b6f710637933": "Salon Privé Baccarat F",
  "02d062c87725af494c37826239a63ef386d41e25": "Salon Privé Baccarat G",
  "3dd454c58c14f59a441f4338ee452e22c46a73af": "Salon Privé Baccarat G",
  "06a5009090599ab95a90ff85e343e745e6df8c03": "Salon Privé Baccarat G",
  "20a360a8e806778a036540ef83a3b5adee29bce0": "Salon Privé Baccarat H",
  "40e906fd1bbb32747bc816b6b9885b81521f6276": "Salon Privé Baccarat H",
  "6feb68ec58daec7ebbe4e34ef8bcd7ac52d1013a": "Salon Privé Baccarat H",
  "a75fbe2211706cb89d0fd45d088f28b3fe83afd5": "Salon Privé Baccarat I",
  "d6592bd966491e34397aa79c5842f5a8ca4deb64": "Salon Privé Baccarat I",
  "d882e75937aca3735fac9bde6591148e9b775a3e": "Salon Privé Baccarat I",
  "cfffa9dacf85df4a2257f1e68dc3fc190c0b1a6d": "Salon Privé Baccarat J",
  "d53694727f811630095f562979f3fff83f675ed6": "Salon Privé Baccarat J",
  "93b274151d7e6f6459f53987b6f2dddda0388a98": "Salon Privé Baccarat J",
  "91277514df8ca0de904bd8b32d92cfa676f6a046": "Salon Privé Baccarat K",
  "ab2bf965ecc739bdb896669c4ac73e5bc1088499": "Salon Privé Baccarat K",
  "7d07b49b3a5d4951c339dcd10f7706159e08d503": "Salon Privé Baccarat K",
  "7bee18d7d1512da157d559a3a791fad03a49607f": "Salon Privé Baccarat L",
  "eaf2463e95ee4180cdda36d235c7e5d1f29c6f25": "Salon Privé Baccarat L",
  "d88cb11fca0efe62804e1cf4a12ae7a19d6eebbe": "Salon Privé Baccarat L",
  "062f198784c50681c943615473f56680c3e494f2": "Salon Privé Baccarat M",
  "bee38f1a8d1d4636e653f6906347a0d693e84cb4": "Salon Privé Baccarat M",
  "173ac4655966eda6be305d012477d813a1e91e4e": "Salon Privé Baccarat N",
  "5c459454db5d8d65ce343806d822cff693b27377": "Salon Privé Baccarat N",
  "1d840a90000f95a0a7ffc84316a5fe8aa732f52e": "Salon Privé Blackjack A",
  "2cfe01f7f91d61e3a29923d9fb9bf7b013e64657": "Salon Privé Blackjack A",
  "0a0ce68ca95537b26edd48d1b9ade38060dcaf35": "Salon Privé Blackjack A",
  "458c915105ba72a8c011b030b005eedb4987e6d9": "Salon Privé Blackjack B",
  "a9749c4d2bb13dbda4720c5238ee5e22c2e764a4": "Salon Privé Blackjack B",
  "2f1fc0eb28640ffb11fc2d224559f8cdf0664c20": "Salon Privé Blackjack B",
  "28aa18bf973e66bf079105e1364de0813a5ab856": "Salon Privé Blackjack C",
  "e4235df3202d48d7b08326183fc3032151ef42c4": "Salon Privé Blackjack C",
  "d18805b015f493edf4adf87dcad9bf9360c07987": "Salon Privé Blackjack C",
  "a0bdcbb05bae0f9ff23cfc612335d015adc357a3": "Salon Privé Blackjack D",
  "add8460802b9e94055855c38db7e84f6ba52e646": "Salon Privé Blackjack D",
  "9429284d19bcc2e5ad5428ae5482f421e4507019": "Salon Privé Blackjack D",
  "8a82f2b44c539651ec20ad3a2b2c6ab5f1f68ce4": "Salon Privé Blackjack E",
  "d95512810be62ee71897c5aa771e6db10d640836": "Salon Privé Blackjack E",
  "c5e233246f3de34faf51f671486e654b92981ab1": "Salon Privé Blackjack E",
  "5e16ba0527c4a05129b20e7c267420ca42d1690d": "Salon Privé Blackjack F",
  "eb88bdcd9a9217d9b642e6a23517a8bbd32d2ecd": "Salon Privé Blackjack F",
  "9dbf6d93393c5c9eba7bcff1d55bce7b981e4d1c": "Salon Privé Blackjack F",
  "42be6e02d75980df286a73dfcde4c0a74b56c341": "Salon Privé Blackjack G",
  "920a9ee7cae8195aff24b99cc459e7f6dd7c1367": "Salon Privé Blackjack G",
  "07572f65580863b682ba69c6e62387b78e6e13e8": "Salon Privé Blackjack G",
  "183e92cf6ccb5cb03e18f3b66c0de2641d7facde": "Salon Privé Blackjack H",
  "e0fef5b184549ec7e258bf22ad304167f7b6c1ac": "Salon Privé Blackjack H",
  "1ad3d15b38588fea3078b2b783692b95c403f9a5": "Salon Privé Blackjack H",
  "0cdf33983a2ac753a050678b0e9d0d419c886e5d": "Salon Privé Blackjack I",
  "ddbe8923d7bc120bfa9adba80146d60e76f995ed": "Salon Privé Blackjack I",
  "b2abf8183c095e7258e9c33fb8a9d12609283304": "Salon Privé Blackjack I",
  "ca33c0ee66d5081db6b6f4c7df8d7c9ccbd54368": "Salon Privé Blackjack J",
  "dd8abf732e1b2d463be22e0bbe8373dda6e1c508": "Salon Privé Blackjack J",
  "1a4978bf2f80c43d698cc1af8a3ee782b76a813a": "Salon Privé Blackjack J",
  "12bc64906b32422825cbde5d92bf0f99d8452a53": "Salon Privé Blackjack K",
  "4a4b62a0405c190386cf9ec34443d70f75723b89": "Salon Privé Blackjack K",
  "3f5f82220e6f903d2d0646ed2a0faae54df645cb": "Salon Privé Blackjack K",
  "713c8bf0062169a52a6c1a815947f88fffd7add6": "Salon Privé Blackjack L",
  "950e84bb713d934d679d5ff3321c9477e564d0c2": "Salon Privé Blackjack L",
  "5a7c63627d1391678a59da65a15109c43074f7c6": "Salon Privé Blackjack L",
  "13ca290ddb03dd1f4e90f33189de2d1e370fd10d": "Salon Privé Blackjack M",
  "d41c067110754612cd5cb21ffa117fec55f52a3b": "Salon Privé Blackjack M",
  "60aba427eac320a732de46a186dcc14c3c5da805": "Salon Privé Blackjack M",
  "2fde043576d69b82bd6cb8da673e456da8fb917b": "Salon Privé Blackjack N",
  "ca4492544cd169e34899daebb928f0e391fee34f": "Salon Privé Blackjack N",
  "2a611431497daa43a68fc446435ebbe6153ad3c9": "Salon Privé Blackjack N",
  "9fc3c2fe84e10d612ab09b5fb7a214dc1fb7c330": "Salon Privé Blackjack O",
  "b1ae83bed77f632e5be9cacf95d0764c79d2e8c8": "Salon Privé Blackjack O",
  "81f54d329ab1c6a2c161114b5ade596f62482a72": "Salon Privé Blackjack P",
  "9a5b8b30d0dcea3d2e66cf78545da4749f416429": "Salon Privé Blackjack P",
  "5b10d8890b6deaed34dc8f79919093aae4bfa520": "Salon Privé Blackjack Q",
  "bc8c496ef7dfeaa2598fdcc2d94572518bd72a12": "Salon Privé Blackjack Q",
  "4de8c08f74bc60ae8ecc391427401f975d04704f": "Salon Privé Roulette",
  "702492e4f08725205f5700feaabcb966ce387ccd": "Salon Privé Roulette",
  "d4f9b751fd14476bb4b2a77708ec386c2bd215a8": "Salon Privé Roulette",
  "48ace33710b5e94229cf63163d72aa8175bbb080": "sam-on-the-beach",
  "4c3fd64a30c6942e61a637c5ecd7404d62d9bbf0": "Samba Carnival",
  "c3a8a7efaba5f8a5cdaa69e4f6d67d8b85ce6f9a": "Samurai Cats",
  "a5b16f9db123e23c0672adf09c44beaf6cb42855": "Samurai Clash",
  "2d818a49121f9417a5d82479b08d63f5b4ad5d31": "Samurai Code",
  "b8b99632cf36afc7c3f9844bb69d04a5063eba83": "Samurai Code",
  "c276a6ad05081de50d1a90c6af647cf1b23b0348": "Samurai Fury",
  "21bf204d54792905a508a366620d1bd1c929aa9d": "Samurai Way",
  "e57c306b7a9c77f5c4c25e6283a61d73452e907a": "San Quentin xWays®",
  "241abb4c46ff23c687a16cfe86988a3ca8574cce": "Sanatorium Secrets",
  "8a51563deebea0ccdadb955fd59fab7911522317": "Sanatorium Secrets",
  "bb1c90c49331a98308bcfcff8903abe7157a1d92": "Sanctuary of Darkness",
  "60ee12e77b781ea37436368d2b8beacf9d153d1b": "Sand and Ashes",
  "263c765be6f56ea2188bc25cf9d038d283899959": "Santa",
  "21ed68975f66a9f6cc0b1c62f50deccd4b681505": "Santa",
  "1b6ca4bc1018a669cacfb608201e4b39afe33b26": "Santa Bumble Bee Hold and Win",
  "797edc1bdf66687b1eac42f9eb4f60d0a6e2575a": "Santa in Vegas",
  "101245531fbd706f22beeb79234f6a7d33658ed7": "Santa Surprise",
  "0c421459250471abadfb9fd5af71a9489efcc287": "Santa's Bag",
  "3587a13c21a2132eb5b58da365be4277cd132bb0": "Santa's Great Gifts",
  "a6d9cd0ea662cd3c6375e02848667d13fb9b261b": "Santa's Great Gifts",
  "39cccbd8a296871827f15cc5f4dbad2e1bb040ea": "Santa's Slay",
  "ecb6140550e8f9890f0e1a1d99dcc67bae20e3ae": "Santa's Stack",
  "c22b1738983f2cc4d694bba28c22c57d529864cf": "Santa's Stack Dream Drop",
  "a2a3fbb018cc4b8ce053522e0e5d137e2be3d99d": "Santa's Wonderland",
  "7dcf3cba83340a9c59b30dc382221d19a07f5b0f": "Santa's Wonderland",
  "623ae19bf511baaa0179439c0b3b3882f584aa7e": "Santa's Xmas Rush",
  "aca70bb9bf43d88f9c172c2726a95cca3e1203eb": "Santas Fruits",
  "cdfdacaeedbc035dfd7dcac38e1fb184a042707e": "SantasInn",
  "215884a93254a95635d43bdeecc9cef5fb7bb740": "SantasVillage",
  "1086267071296c23f0bd1543cf3ae9c11f115816": "Santa’s Slay",
  "ad6f6ad91e9977b19c830408f525f2ec1032d279": "Santa’s Xmas Rush",
  "363ced853a227e6b82ea376aaecc2559cda68b0a": "Sante",
  "5f16a4fac4a30f33addefa54f02984c53373ba9e": "Saray Ruyasi",
  "efd56879029d31455313ba772b105ce3a9bd8754": "Satan's Kitchen",
  "d6053564dd0d018a33713219a02fbeb8601cb183": "Savanna Song",
  "cf1c79ac0a421647ba9805ceccfc55a7be154d32": "Savanna Stampede",
  "7be0a7755a2aef62a0b037861da3b29210024a56": "Savannah Legend",
  "01566cdcfa8876e59948e1a7811d5dacf910843c": "Savannah Legend",
  "c79ba104a55b5f43a64e0187089071948f577f2b": "Saxon",
  "92d30c428d674db3d18b29ff64a411badfbea09f": "Scales of Dead",
  "648a614f6ab43193c153a541d8df8eb3da0554d9": "Scara-Bucks",
  "458556c4f5cf91bf587a0a7f4edbec817f4276d9": "Scarab",
  "d90a597c7480ffabbe7a6f9c1b617b6dd83251f5": "Scarab Riches",
  "73b4bcad40a7f1ca6410284fc7df6e3780ae8ccb": "Scarab Temple",
  "1b624a82b5742f3170aa84ebe16663d9345abe18": "Scary Clown",
  "fe8060b21728612319c3d543216fa17cb0ed90d3": "Scientists Legends Lock 2 Spin",
  "c88c6609433a39a846fa796fae5587331aaee6cc": "Scopa",
  "47de7dbb724b584d062ee16dec5f8ce7f7298d38": "Scorching Reels 100",
  "eb0df013e95ad7841686f9e8930addd84bf127b5": "Scourge of Rome",
  "da35d60c75d25bcec4cecfb6f8d9084aea330f05": "Scribes of Thebes",
  "3ba8686c8aeb6527ffd5c307656a32e1f1884cbb": "Scroll of Dead",
  "a9cf33c235ebe7364830d71a76dc8bcb47968c94": "Scroll of Seth",
  "0123ae27a2f73b60ab0db8d23dcf7232a278bc15": "ScruffyScallywags",
  "67b627cd2a4ff00de7247c99060fc80fd9bed9ee": "Sea Fantasy",
  "f79056cda681cf8f1dca72c8a12c590c23f63447": "Sea Hunter",
  "c036f29c33990987192442c7a22e5341d9f3e9cc": "Sea of olympus 1000",
  "ae87bb3401e153b93effa20cd291eb2018d94c1f": "Seagull",
  "033876923d28739fbabbd829c686e6cd92072171": "Seamen",
  "5857e7bf60052c337d8e3e19f1a86327032a78df": "Seaside Pelican Buy Feature",
  "e64f3ef47a73f7d30d10af04db371e27d16aa93a": "Secos of Sherwood",
  "285c0ab7f56b5f0804603e2a83ef97409f3da4e2": "Secret Agent",
  "7690f7ad74e4a4dd1ee7bf675cfc1a5236ca9310": "Secret City Gold",
  "02a360a95c42ab6e84238791cce7eae8225ed668": "Secret City Gold",
  "f75a6a4b2ed55f05610002d03be430640c418ec6": "Secret of Dead",
  "b44c4cf2e543b643a2d4ff7342d356d700d42b4a": "Secret of Ocean",
  "a8cbd451ee6fe4ce0e7473cf0ec0a4ef7bc4e179": "Secret of Ocean 2",
  "11acbcc0f1ae431edf4847526ad385d023943c8b": "Secrets of Alchemy",
  "166f9c1fb1aae394336c949e43ad47a169751101": "Secrets Of Cairo",
  "b95f854fb9e056229ac2ff81fc4860846551bc88": "Secrets of the Temple",
  "3d70672b9551b40fb7d7b148a9e8494517031891": "Secrets of the Temple 2",
  "ab7de0c14fa48a45cc1bcfe8706c320db320e962": "Seediq",
  "ad86a5a82f20a3a01a6c80ac85d56b62550dcf8e": "Seker Bey Bell Link",
  "f2a8ef5d153866bb9e4d2e7e79fba7b4f74508ed": "Seker Bey Bell Link VIP",
  "39565349571c596060feed5bdf95d15eead10167": "Serial",
  "4818b504684f1b2f342c2bbf2b7bdb5438ed82d5": "Sevens",
  "bef2ddae2cc231a95f25dabe0dc573a5ec93c965": "Sevens Heat 10",
  "97ab413770e6abae807a391d8c5aa8365c983ea7": "Sevens Heat 100",
  "49a5dcd3a8ad02b40fb6832f43eda1896392e466": "Sevens Heat 20",
  "d4aedf2e7a5245a8d6106ea3f93b58e9c6ac5a76": "Sevens Heat 40",
  "9d07089e9d22694f1d6cac66c991d5841e804c3d": "Sevens Heat 5",
  "b0ed3061958512df4abe5e1b7023fdb10629c261": "Sevens Play",
  "5f00af9ffa1d78c3f98e1fa93e1ad4caeb0bde8a": "Sevens Staxx",
  "291826335df6d19ad24d5b93c7a05bf108b25297": "Sevens&Fruits",
  "07db91227533c8466c1b67e5dc5efdc4eeafae51": "Sevens&Fruits: 20 Lines",
  "4a33e2ee6cc0f57256cd83ee16e70fe720cb3a29": "Señor Muerto",
  "06a2e93cea6e80a14f4823b541ef4e9675cd5068": "Shadow Play",
  "b97b77725b21127e9e45e78140e1ab54e791254e": "Shadow Strike",
  "a10242b173cecf1736563f9785e0d0550c390fcb": "shadow-shifter",
  "be02b112456a9de7a4c28272abf332bc5de3a7bf": "Shake and Win",
  "ff7eb5f999d72a88c4096b447a56b389a0a643b5": "Shamrock Miner",
  "d80681c30c5a0f81927daa14b4c8ab3a0096663e": "Shaolin Legend",
  "4ac0c3e8c4d7f513674d0880bfff22a2ccd5a7ef": "Shaolin Master",
  "f2f89a75563befaf0a381c3562819739df40f298": "Shaolin Soccer",
  "66bf0468cc2a6300468cc5751ba3ce71b42d6fd0": "ShaolinFortunes100",
  "589c9654eaeaeffa04e1a0a4164db7c8770d7fb8": "Shark Bite",
  "8af6904ceba3c826c8768a8ccc6b544d2b22c658": "Shark Blitz",
  "ce4823fc22579838041074f481dadaee5cfa2268": "Shark Treasure",
  "44bab24b3f6b82696cd4beb2925cfa9bce38aaff": "Shark Wash",
  "5b440a61b3c1c194c0fbbd05f027b72a797b9b4a": "Sharky's Choices Win Ways (Buy Bonus)",
  "7dc7e5695c2ea732e5d55358f2063e30b754eeb1": "Sharpshooter",
  "3289efb82bf2cd0d8b10d15cff53bdc66f4dbfe6": "Sheerluck",
  "381453ba5d8aaaf0c13e86d7d23267960bbbfbb3": "Shen Nong",
  "a2e1f76566481fc27b68326da7c96937c0016f68": "Sherlock and the Stolen Gems",
  "de1b4f63d0d0eb746155ce0bcc86adaf500a5ec2": "Sherlock Holmes",
  "527e5139e57e64b9b3d6faf0faaf41ca2970b078": "Sherlock. A Scandal in Bohemia",
  "ee9edb2257616de9b7a1aedb20ea0a5170da38fb": "Sherwood Gold",
  "5a9a65eed3858a6ba72264916c18f85e0983bcb7": "Shield Of Sparta",
  "32c2b61299f3210e6b49b3913a2a0769ce166afb": "Shield Of Sparta",
  "e18b7ed67fc36079233e08f00522af9a5c53f8ca": "Shields of Gold Valkyrie Hold and Win",
  "7e2584b6f81928e9a0cde8d7c9a3ec5d047bfe1a": "Shields of Rome",
  "6138c996e6650c572712747e4c9b302d485806f4": "Shining Boooom",
  "4139438c443df51adae01e97a071b5652492b5d8": "Shining Crown",
  "6974bc919b3107e5812af961f060dfb80b3828b9": "Shining Crown",
  "d706e3f8cb47a9466dea2398f49be379feb75c4f": "Shining Crown - Buy bonus",
  "db2adc1b672e413b25b63aafea587e5d8882d347": "SHINING CROWN BELL LINK",
  "63badaf13cd2d6607f83238613b575a657bab20b": "SHINING CROWN BELL LINK VIP",
  "b2615fc8f4cd14e8dc759894e8b015d926d079cc": "Shining Crown Cash Heat",
  "1c1fb98090d732c8609310ad39cb3eeaecb3c298": "Shining Crown Deluxe",
  "c30a4f9493d34d6e05de49dc4628853c3bc138ab": "Shining Crown Deluxe VIP",
  "22da582a1e75fd976c58166c2dcaa139a6aa4b3d": "Shining Dice",
  "54a37f14218d1b95b4ef3da5789ecdd9b2a3a836": "Shining Gems Flowin",
  "3d1a96fef8fff01a12ee036aca3746563c28f28a": "Shining Hot 100",
  "d2f66371265699a6832a7035c8b90f6da21b3664": "Shining Hot 100",
  "6a5e49920656192a167cb1205e9a4dea45f1228f": "Shining Hot 20",
  "4f0fce6ef5300e1e691222738b885a780fcac5f4": "Shining Hot 20",
  "b0cb6dc0032d2c2a252c5c3e8e0d777bf440c791": "Shining Hot 40",
  "42740d6f2426439af77d927d799f4b9163fd5a81": "Shining Hot 40",
  "ae51277e8d8ccffab97f3afaf07159e09e224602": "Shining Hot 5",
  "1daafa6482ac5279092e8aafb3221480792f3443": "Shining Hot 5",
  "74255e7f3cabd95bd1bd8c2f7d2104ee3b003d51": "ShiveringStrings",
  "a246cdb8cf87b0fab05bb1aea5b5aa52d4b27c4a": "ShogunsLand",
  "dbad09b335860dfb2480e582a65bf1dffd6f6039": "Shooting Stars™",
  "32ae386b2b606f5a79ce16e7b1491dfecd6060a4": "Shopping Fiend",
  "a1b012a230928874550e373bb3d455cbb24bbb22": "Shopping Mall Tycoon",
  "7a31ef0c0eca1a5a764fb2e526ad40a2ed9cc1e8": "Shrimp on the Barbie Buy Bonus",
  "5d37b165c4dece4dd36894cd526033299e878ff8": "Shrove Tuesday",
  "23a96a1f51f473d441cec278aa0aa1e01b8b5cb6": "Siberian Wolf",
  "f2c62960d7e9917a03446161ece643d91310ae5b": "Siberian Wolves",
  "a4ec7d3295b18b00364048b8fe0c007dd8120c28": "Sic Bo",
  "069a2ce7c9d84dc2b605097e3bcb74f7075d096a": "Sicbo",
  "37ab0837720541418c2dc2582dd1deb2d1c20e49": "Silent Samurai: Mega Cash Collect",
  "2274a52588485c11d9f8c3ca559a3456c47de8f0": "Silk Road",
  "761450bbefc2e92f33d5ab752ed44dc1a61b319d": "Silver & Gold Mine",
  "e207ddafb0ca14ebca673b2cf557bcd360fbda24": "Silver Bullet Bandit: Cash Collect",
  "3c7b3c3d3a2009e647ad28c0d5148205dd23b458": "Silver Lux - Big Win Spinner (Linked)",
  "1c7996629a45bc7edbffb34cc8197c1f7781a5c9": "Silver Lux - Coin Run (Linked)",
  "7a64a5c843d76f5eefceaad6e28a2f94afc8f108": "Silver Lux - Coin Stacks (Linked)",
  "074187c701107a025c32e4709ebd94c240248333": "Silverbird",
  "f055a641798709b6a9496eb4befebfe249c1e1e8": "SIMPLE HOT XL 100 DICE",
  "8894747206db0c1541e13077b2ef185ced334aa7": "SIMPLE HOT XL 50 DICE",
  "c385f5fdb31a6b565f182e9c95eb995ff9099c2d": "SIMPLY HOT 10",
  "d0886e54fc617fe4b5d912550bb8692badaf0fb0": "SIMPLY HOT 10 +",
  "e2d1383d98f3f52dbebaeb7edd598cac7466ed05": "SIMPLY HOT 10 + DICE",
  "693da4cd3e7f904dc748072d3924ddc3769b9667": "SIMPLY HOT 10 DICE",
  "d09783226d8e0de4cdf1f69ca86d09289d433f52": "SIMPLY HOT 20",
  "4623790b627bc6329b8dacfc66bff068d074fd90": "SIMPLY HOT 20 +",
  "d1d63d983fc4e5fb243a1c39f331b8584918a2d9": "SIMPLY HOT 20 + DICE",
  "1433143bcd4dfccf153992e156cc3927f32843e9": "SIMPLY HOT 20 DICE",
  "1e33d6d9072dd1a154f40de4794c839e771b445e": "SIMPLY HOT 4",
  "a750c7b42d9e98b2fa59f1c51e2bfe1951947559": "SIMPLY HOT 4 +",
  "9989c53510dd8768bd22be26db578da33ad4b346": "SIMPLY HOT 4 DICE",
  "e145e86abf349cf98b8a196520bd24927e1c0f9f": "SIMPLY HOT 40",
  "aa768f658bf51dd6ec4d9fb231301b4b313609f4": "SIMPLY HOT 40 +",
  "f165e1b1e4050518c71c47950d690dd97c709259": "SIMPLY HOT 40 + DICE",
  "9f03e1050a7fc156542dc9a2a6e9da4cec4e8bb8": "SIMPLY HOT 40 DICE",
  "a4ebe6ef8bee7bc46b0264f4618a3a028a872229": "SIMPLY HOT XL 100",
  "ff755a3bfdcb3de7ff50d5ba7e2fb0ca0f5191bc": "SIMPLY HOT XL 160",
  "1722c4fbc7513536922a9feb2b97b5422d033c6e": "SIMPLY HOT XL 160 DICE",
  "77b860e98270d8d6404769ae7e156616911c7a10": "SIMPLY HOT XL 50",
  "6ebfe9591765b6b9d86f0365a94e354b5f456b09": "SIMPLY HOT XL 80",
  "0be5aba25b32de8014a5fefb060137cb05a16e21": "SIMPLY HOT XL 80 DICE",
  "d682052c524d8d3ff2f48f0704d70c627560bce2": "SIMPLY THE BEST 81",
  "4ecb2dbd83c66adfcc5ab943da316d639787e302": "SIMPLY THE BEST 81 DICE",
  "baa93cce8ab9ee26aea454f3d95130253b45304d": "Simsalaspinn 2 Classic",
  "0fc9d6102455e8f4db2f665ca23ff33b6083dc1b": "Sinbad",
  "229cfc9187afd575c9706086dccb254ead9a3689": "SirBlingalot",
  "05aa48caea1a2ab648661f648bd35a2238a86001": "SirensSpell",
  "546aab608f0c52fde43188cf086f93bd6e820e34": "SIREN´S CALLING",
  "9e777ee764821c12f7a4051db0214f8a3433f896": "SIREN´S CALLING DICE",
  "8b6d53a3d0edf732d905cc4c4a1632fd0eb4fd14": "Sisters of the Sun",
  "8b10170859d7fdf1ee0c006dc651a5a6e9a0229e": "SixSixSix",
  "442a04d04a357c12a721430dff3d71bd1a29b1a6": "Sizzling Coins",
  "aa99a3dbc67046aca36fb2108943142f97ad813b": "Sizzling Hot Deluxe",
  "bddaecf47e393f7da8f1a6357eae380658efd8ae": "Sizzling Spins",
  "96a8b554aa1689beefdcee562765772911fe6d9d": "Skadi's Hunt",
  "9b07485bf8b938f4633d9ca0e8357ec8b13650ad": "Skate or Die",
  "1059ac1f8783735394ee933dbf74f0f1fef9bb24": "Skeleton Key",
  "765c25a54acf14a6ce7bc558ae2496853013d30c": "Skeleton Party",
  "90830f5e51748566ad54d8e828afe87ab7fd2451": "Skeleton Shuffle",
  "8ff16b2cff7bfca872216a4e12016b49319fa388": "skibblings",
  "5157f4ac096cf8aa155bc5be0800303f5dd63240": "Skull Coins",
  "70280039503fcb327d99c656bc1313b94c5b1221": "Sky Bounty",
  "0fb373c7c218db9e2a15d8a04568f3970137e90b": "Sky Bounty",
  "640a6d6bb1f2f4b9b1ba776b32b90c2538db1b4e": "Sky Force",
  "a6ded9a5fd4b5cde58426e9d262570c3d8f962ed": "Sky Journey",
  "38707567f930d709a682190162085915fa3f1b65": "Sky Pearls",
  "c942161daf7bc7ef483f48c84887a29faa67c334": "Slam Dunk Contest Lock 2 Spin",
  "7b0d1d72cc1ca62e6280b81d6065d5802a0d2296": "Slashimi",
  "4737897616dd1b4740782b76bfc4cb8aa9191d23": "Slavic Fantasy",
  "0e45f25113b2c94226fffd4ba144c8c2efe4d373": "Slayers Inc",
  "53fe632dd684a260402807302df3feed755b6fa5": "Sleeping Dragon",
  "7358be2f079e66b553dfd4a81f7ec4d2172eaba5": "Sleeping Dragon",
  "6ab92408d5be9c620bffb338627fcfaf76bd2dd6": "Sleeping Dragon Ultra Dark",
  "ee44955c8e1e6a0872071259d5d9550d1e2dbe9e": "Sleeping Dragon Ultra Dark",
  "0c540de7b7690c92ea7d616df6465a1f5820e4f7": "Sleepwalking Sheep",
  "60ce8f0880c20578b651074394f9036fff8a6239": "Slime Bonanza",
  "bc5d174084f1ce64f00c67274ff236c5a465877d": "Slime Pop",
  "ba3234f9aaa5ed9fb8cb930dab6d9c76c1026a80": "SlimeParty",
  "d26ea0d063613b695f2cc9cc1be1e92786ca4e49": "Slotcade",
  "727ee1b96ea8df6282ad8a5cadd6019420e8fef1": "slurpy",
  "5e911bd15499b8bf2424e7c19b4f127b6f794f7a": "Smashing Sevens: Win Ways",
  "3ddbe500310f8015c377792b01fa8d08d70a60e5": "Smoking Dragon",
  "282a50f9c0d7655b9225e51f5dd937e493df8975": "Smoking Hot 7's (Linked)",
  "33b8d97047f36559867f0d4385dbdc9d9156805b": "Smugglers Cove",
  "b9664ea8b186fa159da46acfc38faa9338fca1e9": "Smugglers Cove",
  "5e574ffea6038a7ad73e313476dbf1d806261d92": "Snake & Ladders Live",
  "865cf16523f69ccdd3c7b680ce4d5a769b1d53d6": "Snake Arena",
  "a67ba03d46440511b4fbf050c512c42bca790724": "Snake Arena Dream Drop",
  "a5e77e33a450768e2a84efe8269a41045c2b4924": "Snake God",
  "491d27e8208bd753668a7e6a40ae89fd28286ee4": "Snakes & Ladders - Snake Eyes",
  "55e4f0524c1bacac04332fa78332c6cc871e6826": "Snakes & Ladders - Snake Eyes",
  "58909f59681ce974380911dbf224803c4fce4049": "Snakes and Ladders Megadice",
  "232cc8a07d6676c407bbd47480bca11c1a87543f": "Snow Goddess",
  "d88454a3267407dff5c9224adaa918e866d27875": "Snow Leopards",
  "f3bf0549968b3e21edf03aa17e3fde9820632152": "Snow Party",
  "6ea7252ba9420ae009b4be53fbd5456f0c18a862": "Snow Slingers",
  "a52441605004d608aedfc876773343ed2a2a968d": "Snow White",
  "add34b233bedefb00fb42f69b7ca958fd790ae38": "Snowy Secrets",
  "db0aa2ae6b4dbced30c40900173c36b628a6d46e": "SNS Friends",
  "9fe60b99b5e3d05d72af2a6c6e3e1ff1f9c59994": "Sobek's Godly Spins",
  "ec27f80a77582619f0972ff94c1efab8fa7ed27e": "Soccer Showdown",
  "b65c72f0fc8ede1527024c11da3c5591650d779f": "SojuBomb",
  "7074a31629e85451fee59af8bf187ef9b567cd86": "Solar Disc",
  "2887f40f2eab807e271b6173ef585b1b78955797": "Solar Eclipse: Desert Treasure",
  "204e5af394014a821f2886f19b069e211c471a3e": "Solar Eclipse: Jaguar's Lair",
  "635192ddbb770c52bc6b7a2eea3ae20592d4aa6c": "Solar Eclipse: Northern Winds",
  "585cb9d0331b1098b90d691e95f50c67d1c2098b": "Solar King",
  "02a8f5de66881c7667023aaf05438ed7089a6a73": "Solar Queen",
  "e7f402ecd2a6b7d4d62802392117dc67f4d2a54d": "Solar Temple",
  "382856262be9e1ba11ffa09cf05e0d54b52c8a9d": "Soldiers",
  "33db175acc22feebb1f3bd3e586a1caf840687fd": "Solomon's Treasure",
  "0cdde8e58c9742b0f72358b64bac599a503ba2e6": "Solomon: The King",
  "fba4b29a037829cf9c1db6345894ecf27b013cdc": "Songkran Warfare",
  "87f580ab1cc6a31876dda98205e9f6b2fbf5bc07": "Sorcerer and Demon",
  "3d8f864aaf30b0a04c85589bb759d62b8beac7b4": "Sorcerer's Guild of Magic",
  "63e69474a2b0920b9a7f14b10bd708662ee368e5": "SOS",
  "e1ed0730cec324beafa114904a716aa40e475b6d": "Soul Gems Fusion Reels",
  "19e0f983d29f10709278d105613dbf6154499cb3": "Soul of Nature",
  "94d67cfa262aaecf24fc1c4cf26cd324f2bf0596": "Space Coins",
  "a1789fbb7c09c60c25467676dd2301df75799a9a": "Space Colonization",
  "cc74bb962331896434ff0e5b46a14e64c65821dc": "Space Donkey",
  "6e193eb88be83cf6ec5c2436edbb7e2208bdb306": "Space Miners",
  "74dae3ba6648d415df3db0d593565f45f5fb3174": "Space Miners Dream Drop",
  "3fa2da38a58b2347aa3f9b2476658d7277490a3e": "Space Race",
  "872f065e9e2ab291ce6a5b560b2f10193d80d1f6": "Space Storm",
  "7d16646816e32998cb23fafc928f08fa327bc1da": "Space Wars™",
  "788f46c6151c773831bad9271c92975575c61772": "Space Wins",
  "6e99ad35f2163503958e999b6fa83b9947136a53": "Space Zoo",
  "2b9df38c86820f231ec1742fac5956be1591d3bf": "SpaceFortune",
  "cba9e72e44cc49fadac78ce608f7cc0dd3f85c93": "SpaceGoonz",
  "ae8e8010fc61b5c46c0846e4ced7f231c6615126": "Spacejammers",
  "bf3f1676b9d4e41229df6c11af55bea1fe598779": "Spaceman",
  "309eed3cf398550796545a1d184a7ad7d450cf70": "Spanish Passion",
  "b1f142e03806d05e7aeecd7d92feb720f1154e61": "Spark of Genius",
  "930132fbbde2002fd94e11a1ee8794f8f3f1a544": "Sparky & Shortz",
  "8131eea6261d36d69543978578a74f918118b8d6": "Sparky&Shortz Hidden Joules",
  "4924550d5f6c38bcada91d5b6663c4dbfdbfefd3": "Sparta",
  "a2af6fe5c3df40fe33a9f5fd4d6f0a8ddc18204b": "Sparta Dice",
  "3be2ee17c83a37e66a24432416df2ce41499cdfb": "Sparta Legend",
  "a6d212a9168bef8e7f20cd841e6f85417635053c": "Spartan",
  "ebe18d6faf5d7fa51b905383a7e1bac21988a9ed": "Spartan King",
  "633de04b6bf8d6e6d1f9763ab4a19ec3f9d3a0fc": "Spartan King",
  "88d000788fb155adf3c39aba8421889bbf206ecd": "Speakeasy",
  "6eb97f1de7a1df7dd0e2903ac1e703cb9e76cb25": "Speakeasy 2 Fusion Reels",
  "2b0ca6c8b74bbdd1177ea77878aaccc6a9550034": "Spear of Athena",
  "44ffff89d9865e1221a49ea97c00ac2fc1b6ca4a": "Speed Auto Roulette",
  "6818e96314fdbf0776d088c99e2a8ec5ca75d074": "Speed Auto Roulette",
  "ec5c28c9feb16fb5722037fba14471bf69c87bf6": "Speed Auto Roulette",
  "59ec089cd16faa3d0d659c7472a015b5c0cad2d7": "Speed Auto Roulette",
  "07386d1392fd497f90010ebc1288c72503e6b793": "Speed Auto Roulette",
  "23b11ce585f95c72a75a7bffc3ea1f57d8306d37": "Speed Baccarat 1",
  "afafb35f97f3e6587c233093e6630b9b06920a23": "Speed Baccarat 1",
  "182fe0179e7b0418c5c3f05aab161ae28cf9ae17": "Speed Baccarat 1",
  "edb60e8e59a075b16b2f07c1fb7f9ad33db648b4": "Speed Baccarat 1",
  "f355541172f72a6767aeda538432b2540d2b8fad": "Speed Baccarat 1",
  "a55f5011542ca6b2fbddf6d524d22d1af372cf35": "Speed Baccarat 10",
  "b4419a68a6287b7aca25a5538afcf58d9b430210": "Speed Baccarat 10",
  "b9d0cc39dd25e7078baf186ae4395528bb6ccf31": "Speed Baccarat 10",
  "2c36f19bfb5d209164b500da7e2a16ed5cf5d2a7": "Speed Baccarat 11",
  "69b51667181cfdac7e1bfe2725ef85d719cfaf75": "Speed Baccarat 11",
  "61caa23fed7809286a634a048abb96d24ef93007": "Speed Baccarat 11",
  "714e04035d3cfa9f8b6aa3e3810a1d3f5dc34573": "Speed Baccarat 11",
  "46a3ecfc398451da019af52865574d1368bb6ca6": "Speed Baccarat 12",
  "a93b6ac5ebc7d7d2fe2c57508c80a3708294b4e2": "Speed Baccarat 12",
  "c3b05682797a8715f36715e4ff86ed1cd4123f42": "Speed Baccarat 12",
  "6d6e2e2b4d834616eab5f9ebe2df284593b17c46": "Speed Baccarat 12",
  "469d2c1cd5199a269d6581bf2e7f9efdc6e0e73d": "Speed Baccarat 13",
  "922a7797a4178399ee7397368aec91c0dc98440d": "Speed Baccarat 13",
  "4d77e17506010fdc713634955ece9d1ce5d9d42c": "Speed Baccarat 13",
  "0cd3c5d68c524e9cf8c1255709849b8bc6901e61": "Speed Baccarat 14",
  "942a3d44582d5bee237f01d3a9d7dc7e4015a73e": "Speed Baccarat 14",
  "d8d34aee9fd5297b522b6cd2342e6c9df8477058": "Speed Baccarat 14",
  "554e7a8d25146e949ff44a7d1d76c62f7b99e9a4": "Speed Baccarat 15",
  "f804a58785791b13788940cda65ee0bb19731cf7": "Speed Baccarat 15",
  "899df99c6546045cc7147f11d66950cca1d0c2d5": "Speed Baccarat 15",
  "4ec972e75b397b5e076510b56fd9eedb15654e37": "Speed Baccarat 16",
  "484b0fd6d90ddb9d513684a878e22c0529a9bcb5": "Speed Baccarat 17",
  "279a1f3bb21aedf95401492a600e72d41feca36c": "Speed Baccarat 2",
  "add91797861b37f21c2ad4ab43fbb220cfaea5c4": "Speed Baccarat 2",
  "78f64c774ab1c7a2575fa459156916525e558aaa": "Speed Baccarat 2",
  "64a9007f503694881e59799fbffd1ee249f12942": "Speed Baccarat 2",
  "7d45a8387be4b56a34891a8180643babf049bad5": "Speed Baccarat 2",
  "3c638402d7cc26d4d96daa539554982364deb8ef": "Speed Baccarat 3",
  "a433deea6b36ee1a0de45420d9c82006d1b459ac": "Speed Baccarat 3",
  "d320ed30039455f173dc403921f676ee00185012": "Speed Baccarat 3",
  "1f361be690083bfab8aa1e7863ccc31c148af57f": "Speed Baccarat 3",
  "98680cad1124aec4319e479c107542bb1cd11b5a": "Speed Baccarat 3",
  "652e07056f006965b542c61355788602dc543080": "Speed Baccarat 4",
  "e1f3db771134c1ff25e47df5433c79ed88bfd7ea": "Speed Baccarat 4",
  "9822623edc38746f93ae6d8a61f8e4c4ea3a4402": "Speed Baccarat 4",
  "44368f68e7e16b62792c7b29c6e286ea00940d1b": "Speed Baccarat 5",
  "ec3e0e88e2ffec878116a23e94a713211c590859": "Speed Baccarat 5",
  "af015b383d063d519dfa7c604b30bbfe2410abe8": "Speed Baccarat 5",
  "e3742702b07e09acef611cb419a29a41aae3e49d": "Speed Baccarat 5",
  "3105fb27169c89ac3e0ea9e2c7f2ac820827a076": "Speed Baccarat 6",
  "98c43734c1f9d30b70ad438fdc1a9c8977df55c5": "Speed Baccarat 6",
  "6e9bec989c385fbbda2deabadb7ecbd634db4ba2": "Speed Baccarat 6",
  "536342176dd79d7e1f749ebe472cc7aba3b0556d": "Speed Baccarat 6",
  "177f467c211cfef9c88698d1ed500f8d3581b2ce": "Speed Baccarat 7",
  "e2c4303c585e81b59b4306ba049aa517393bc3c1": "Speed Baccarat 7",
  "94832b569718464025e461b4f036e8b09f0096e6": "Speed Baccarat 7",
  "44ddb1fa55bee9df47ac00df5051a48afe87d710": "Speed Baccarat 8",
  "c1b2d291cec6f6132709155f9536fe23f4cba968": "Speed Baccarat 8",
  "cb0bd7924e6055229ce9b44bcfffff9f60fdda5a": "Speed Baccarat 8",
  "968d2c9723f05b62f127a29d5dff94b4dd27d417": "Speed Baccarat 8",
  "109fb17c2d12f6f4382dc9daf37a57964803d7d9": "Speed Baccarat 9",
  "dbfa1d46ac797ac989d7a8fcdd2ad0be85bf229f": "Speed Baccarat 9",
  "4e7618f546035d9f66cfbaa35576e200d790c64c": "Speed Baccarat 9",
  "1a5b4c7c254f3622dab640907c870e8c25a93540": "Speed Baccarat 9",
  "31955220ee8ae00fd4e4b076da97ecc147628511": "Speed Baccarat A",
  "a96bc05de75cc8ed2627c3534f4edc81d5c18aee": "Speed Baccarat A",
  "c29cea4bdc9907b3b69fb54d3b84fbcd5e7eb282": "Speed Baccarat A",
  "53eaf2b1e4894839fbb273502293884621c51d16": "Speed Baccarat A",
  "5e25d5081581ae000efe20d0838330e65e27e469": "Speed Baccarat B",
  "f691c266b66b0dcb7e327fde712e4c3f5a8f37cc": "Speed Baccarat B",
  "263745650febf668558324698c4fd20335468ca9": "Speed Baccarat B",
  "6f80587a873c9bce86351e4f07448aa6f1451b0c": "Speed Baccarat B",
  "11c57390588b56ddd1297b3ef45f3d439fe974c3": "Speed Baccarat C",
  "ba9486c4de946ca29a704c37aac6f7daafcf21d0": "Speed Baccarat C",
  "532bb8c658a884cb1ce7dfaf330092ace5d1400c": "Speed Baccarat C",
  "62ee43a8b2a973e17b4cc22e0ce3e6bb6e30e0a4": "Speed Baccarat C",
  "110732a33d03b762163772fa82b2a5bec5c59be9": "Speed Baccarat D",
  "65b5818a4848aa48a8a6c4f62f55eff66f624cc8": "Speed Baccarat D",
  "cd607a6548bd56662c8d4992141b5e0b36808042": "Speed Baccarat D",
  "3e4e8e1255d1ceeca51ec90c23683d10bc125779": "Speed Baccarat D",
  "6b5f80a01248943f14ca8ab4c1db9067d3702117": "Speed Baccarat E",
  "ae3498cd9731e7ef05e37198618b572547d8ed26": "Speed Baccarat E",
  "740ed22f9090c7c3e44c6abff0d8c620e7d1c444": "Speed Baccarat E",
  "467680989f023d4ae710be819baf937efec36419": "Speed Baccarat E",
  "189e704af382c6d20d9fba59f0cd59c471f9b296": "Speed Baccarat F",
  "e2759762969d06d56852e30efb1e6b3a080d012a": "Speed Baccarat F",
  "9ab20bd4cd0ae6c99ca700468a3576956d0dc937": "Speed Baccarat F",
  "cddd29d036fbf971513e9645ff0915d93ab91d28": "Speed Baccarat F",
  "0c76fc6a24ed767d55e091ef414a19814c5320de": "Speed Baccarat G",
  "87bbe78cb5c23fdb98f782f0714f42b24297c5d6": "Speed Baccarat G",
  "58d33acfa0e5539eda28f35db64a70ec3e80fe9f": "Speed Baccarat G",
  "fedd98f461efd2480145fcd9fe4785bc7754b1f5": "Speed Baccarat G",
  "698d0a0e82c75af61090b7207b319f6050d5c8e9": "Speed Baccarat H",
  "ea780d527ccce4fb4ef7ed33263f91d70340b3d4": "Speed Baccarat H",
  "dcc714226a58f2128856844bf46ef7f761aa4f43": "Speed Baccarat H",
  "350386dc7a994bad941819cfd03526aacbd129f0": "Speed Baccarat H",
  "66906a91534b371e599c9e3af6f1de0436318596": "Speed Baccarat I",
  "ae61ee43eaf7d71934d3e2fdcc67d1a697ad978f": "Speed Baccarat I",
  "f57ec9465a735595870cfcd348899bb4643e8654": "Speed Baccarat I",
  "63071bbb346d8b455a2dfb0ce52e7384c5312339": "Speed Baccarat I",
  "c83a854f70cc784661b57de45a2f287622a4732d": "Speed Baccarat J",
  "d5bbafaf912d106906c11e7629ea1d221bf36539": "Speed Baccarat J",
  "b83c3b1cfdad9e961de40e77a561ac760d2c3993": "Speed Baccarat J",
  "62d9c28cbb95d13c7da1fe79b3357493a7507d95": "Speed Baccarat J",
  "40403c07e790d6036578948d9b020c7a2c089495": "Speed Baccarat K",
  "5b507d396bd218b5bb0d9d2f49944a4a1d2667ed": "Speed Baccarat K",
  "36509088c14b6c0235ccdab9f4dc3adbc32cc8bc": "Speed Baccarat K",
  "b88e48696eb8a1ae613659f3d360340163b21760": "Speed Baccarat L",
  "f31d8dea6bad76333eb27991b90a7ea6294efcf0": "Speed Baccarat L",
  "df65f4fd7265b93dc862ca6b32723e4c7e38159a": "Speed Baccarat L",
  "3a1fd3d07d493f537ccdc13161674616f82bc46a": "Speed Baccarat L",
  "19633097db083d80958bc85b6ede5d646c4726d0": "Speed Baccarat M",
  "7983a8b83db530aae91cdb2af9d8ed70627157cb": "Speed Baccarat M",
  "cb06871e2a397c7f8b58449156458a1d2a972e77": "Speed Baccarat N",
  "ee06b2be30f53c2ae4565aa7ba3bcb0f60a42c4c": "Speed Baccarat N",
  "d78e8308b0711b039aa57767d76f58878c9acab1": "Speed Baccarat N",
  "6af86d2afaedd0a4da2aac6624f05708b3e520b1": "Speed Baccarat N",
  "1d1652887f7fba48e40e97466780c99334ed256f": "Speed Baccarat O",
  "89275e97945b1d3ad052a8860c8fde5ac935dbc8": "Speed Baccarat O",
  "2f8b320f3691078fcc01f57f9980d744dda42cc1": "Speed Baccarat P",
  "58eb5f8be17e39f9689791dd9962a8af2d49a33b": "Speed Baccarat P",
  "f33ad32a6e869a12edbbf8eff6dc50a4bc6c6447": "Speed Baccarat Q",
  "f9de212f0d23301e1a2d90f4a8d13bf03d1c4708": "Speed Baccarat Q",
  "f66a995406c1fd6c7bc0a2a29b1c9bad186b885d": "Speed Baccarat Q",
  "e7e24c06684e77fbcf05983db49daab71d1f5f81": "Speed Baccarat Q",
  "72309bf6a3ab86c3b551e0077976c69e0eb5fd66": "Speed Baccarat R",
  "feb6fe6cb9df69e7c1e6d386824a8b67b0f816d0": "Speed Baccarat R",
  "9b59f323dd8622f1bfba7bab2efedf504ca3e53e": "Speed Baccarat R",
  "97a90cdef5a38778c7c24c4e31a93104ab973001": "Speed Baccarat R",
  "1e86f3da7ef1d67204be7fbb45c292eeba74ad63": "Speed Baccarat S",
  "4a08026e88346bfe266cabe21210c764579e5576": "Speed Baccarat S",
  "55d68fc9bf6434b515beb36f5b44e2e52c3000be": "Speed Baccarat S",
  "477c4847ef77b60905edb05fdd1189a367bc0e29": "Speed Baccarat S",
  "29f42fc1062e7a223fc8bb37f37ed9fe6820adc0": "Speed Baccarat T",
  "f25b81224223ecd195ca687625fdf68eb48480d9": "Speed Baccarat T",
  "49ecc24039772c2000859062b44c893a86d0de69": "Speed Baccarat T",
  "39fd25838a5b671b5a8749f404d9bda57625d8f3": "Speed Baccarat T",
  "6d7c6e135ef2d75a2a6cb292e612b0cae1b3bf0c": "Speed Baccarat U",
  "cb69079e8fec670d165778029a4354dc94280a78": "Speed Baccarat U",
  "f9724d390643d8583af9d741109ac70d072a8dd1": "Speed Baccarat U",
  "55f5f02f36bdc60dbdcd68f325ae6ca98d7e8a36": "Speed Baccarat U",
  "130e196df0ee683910fd193a9fcc16b6b6902c0b": "Speed Baccarat V",
  "907a7193200812a5b5204bf8a5ab01bb31df6685": "Speed Baccarat V",
  "ef130814211964d50351ae72f5072e1da7c49091": "Speed Baccarat V",
  "d06c4f6ed5ea07fa12d6cf4bf1dd4abc8778aced": "Speed Baccarat V",
  "7c72d32964a92e023d36c05511ba97bccb3eaae6": "Speed Baccarat W",
  "f250dbef5a89629448f61dc59437ca8dbd4bfff0": "Speed Baccarat W",
  "3feb334f33e5050dc053df38a1811b99107aef30": "Speed Baccarat W",
  "f018fe1c8eaa3fd0e2611a7d925e11a69323d9e5": "Speed Baccarat W",
  "3c1eaa10ae766cda29ebe1b332f084aaab9dafbd": "Speed Baccarat X",
  "4569be4e8af946135b605931ba85ce7388672ec1": "Speed Baccarat X",
  "ff2d5cc60f5a452b677456587f95579321bf5f58": "Speed Baccarat X",
  "799fa1db92788db61e997b39ca6e2069a97d6b3a": "Speed Baccarat X",
  "062ecaf137ce0e5dcbb42d5bae8531b3705b2b57": "Speed Baccarat Z",
  "2e890c3171c434b56c919e6972715a5b4f79559c": "Speed Baccarat Z",
  "8387652bc34858e545fc51e6b4803c331ba1b687": "Speed Baccarat Z",
  "edc15fa2307eb26ab1a695ee4fb6e41e6cc67b74": "Speed Baccarat Z",
  "b7535cfa15b81eab5671e8b6c77728025831d175": "Speed Blackjack -15 Ruby",
  "60a080527542822db5e72fabfb1f802eb0e2c3ab": "Speed Blackjack -16 Ruby",
  "d691416bdcfdd70077377ac7260d8c43a3b8cdff": "Speed Blackjack -17 Ruby",
  "4176db106f4291b36a65ea7317b9b2f4abac91b0": "Speed Blackjack -18 Ruby",
  "9ebf9f3984b2af17a007c9ff360a1550c662e24f": "Speed Blackjack 1 - Ruby",
  "13c53682c16c407594ab2a0463aa25309cd59f9b": "Speed Blackjack 10 - Ruby",
  "bbebb3534cc6c19db8db1626ebe9c3f38b2939a9": "Speed Blackjack 11 - Azure",
  "121811dc40a382f053cee6fbcc2e29bd9391dffd": "Speed Blackjack 12 - Azure",
  "b771b21ab98a2e93155bad1740bd49cb31acb990": "Speed Blackjack 14 - Azure",
  "0147e73cde17437c0a3002b6ce8c8719274c0c0e": "Speed Blackjack 19 - Emerald",
  "cd68650d1ce15cdab3b2f73f01f6103aca8eefbc": "Speed Blackjack 2 - Ruby",
  "5a104fc871dcb317a90171a695d2d4b1cf9fc31c": "Speed Blackjack 20 - Emerald",
  "018691f1e47aeb904b1a746bc7dec4ec6bd84ac8": "Speed Blackjack 21 - Emerald",
  "b3ed67ca2d0467821e8a63eeac715fd8a1fb2b63": "Speed Blackjack 22 - Emerald",
  "b452fa9517c4b125b0b4692b4d26a8fa34c0a53b": "Speed Blackjack 24 - Emerald",
  "481c40d57dbf3ce0f84d3afe33e0d12936a511ff": "Speed Blackjack 25 - Emerald",
  "41ddcb9f76528e63d0645440533f42a06d5ba889": "Speed Blackjack 26 - Emerald",
  "de71a826435b80e398dd0a654a9b892f141edf2c": "Speed Blackjack 27 - Emerald",
  "46627e1b9799742cf99fc14828dfedffdb328c7b": "Speed Blackjack 28 - Emerald",
  "a6c6892158ef13f11ac98fe3da878b2b345bd76c": "Speed Blackjack 29 - Emerald",
  "0d9806ab30daa15fe9645e33e4a29d9fc7fc42c2": "Speed Blackjack 3 - Ruby",
  "c7381bd8f763dbf0cf01415ca9c300f257fafcb3": "Speed Blackjack 30 - Emerald",
  "38c2104a0c8390b7e2c8d507f894822a71307439": "Speed Blackjack 31 - Emerald",
  "de105d9005c63b0c465865cc74b5524c66718116": "Speed Blackjack 32 - Emerald",
  "7713aefa2ac257108f066c3e0b41e0cb60683347": "Speed Blackjack 33 - Emerald",
  "ce99c34523fcdfa40a9a625bd92b64a9c475f4a9": "Speed Blackjack 34 - Emerald",
  "bf8393acda9899cf2a9ddc06b3d88b2c9195ba80": "Speed Blackjack 35 - Emerald",
  "8944a0a2cb1256317754a05c5c4d1a531a18f23a": "Speed Blackjack 36 - The Club",
  "54a4d6f826049fa21964e15568dce1fc19617a36": "Speed Blackjack 37 - The Club",
  "57a49148bc1de8c6e1dc389ea7f4fad07a2c05ec": "Speed Blackjack 38 - Ruby",
  "c3f6c7e2adf2e269dd509580a58bea12e8629fbd": "Speed Blackjack 39 - Ruby",
  "cc252ff99f3840cf36009c62e15ab2fbce6a626c": "Speed Blackjack 4 - Ruby",
  "a40d3c9a9c32770ebcedccabf39fe16f49312317": "Speed Blackjack 40 - Emerald",
  "eafb839f759742f370ed1ee02c3fda91d4d9a28e": "Speed Blackjack 41 - Emerald",
  "133b26ef81a1d4e7dca9069d38a72ef5f028b4df": "Speed Blackjack 42 - Emerald",
  "b8efa08410e95bb1a4e4327e98b304daa8bebf55": "Speed Blackjack 43 - Azure",
  "7968a54643e203e1b18717de5ef5d729f75ce577": "Speed Blackjack 44 - Azure",
  "f468f22f2b7dc8b7d55ab97e3dc53019993df6a3": "Speed Blackjack 45 - Azure",
  "d63e0f76de7792f33fef939d86ab63a1c59ed0cf": "Speed Blackjack 46 - Azure",
  "eaaa316c7c25f014b0ee0a29c2d85d7fb709e10f": "Speed Blackjack 47 - Azure",
  "165756913bfba1f5a691eec1a5dc2191dd6a071f": "Speed Blackjack 48 - Emerald",
  "b5da6bee08f88d86fe34d573ac4bfbccfd4428fe": "Speed Blackjack 49 - Emerald",
  "1ff8dd9edcd86a608fb424af83c3a236ae38f95d": "Speed Blackjack 5 - Ruby",
  "b642a38816ea9a20f5ec651e769e9cd0fabdd78c": "Speed Blackjack 50 - Emerald",
  "e5b5e97472681b7fc437a519c41d1618e85870ca": "Speed Blackjack 51 - Azure",
  "a7df49b4d42282d31f541b384d61a25b9f4a81cc": "Speed Blackjack 52 - Azure",
  "8e0bdfd9de10b11a0d2b062f2cbb3b5586837204": "Speed Blackjack 53 - Azure",
  "6a3417703b970bb46db7f8ccb401136a3c7740f3": "Speed Blackjack 54 - Azure",
  "246a311c45e0c7c2696a6b71af643d002adb677a": "Speed Blackjack 55 - Emerald",
  "9c5ed91d6f2ea6c8d5a5bf7dad4e91794d62d6a3": "Speed Blackjack 56 - Emerald",
  "df7b56923ee7a957da20977bfdab1110a18f3ca2": "Speed Blackjack 57 - Emerald",
  "114020ccef6548b34b6224b940455d22684e93e3": "Speed Blackjack 58 - Emerald",
  "3d0064f89d837a74dd3f5547d59411dddf14e9d4": "Speed Blackjack 59 - Emerald",
  "ed6bdd0a717b83c3a463f161445db76262be7eb9": "Speed Blackjack 6 - Ruby",
  "58e0fc12117ab9a36e9dbbabf4fc6bf54ed06dc3": "Speed Blackjack 60 - Emerald",
  "1ed63d3a1df2a0447ac9612bb2d10d30d452ced6": "Speed Blackjack 61 - Emerald",
  "e345acc1bdc1ab9e95ca27687b1a78c735afa9f0": "Speed Blackjack 7 - Ruby",
  "b23db910970553d8d089c24508b9145ef5a3721c": "Speed Blackjack 8 - Ruby",
  "5feaa13d30e3f3054ac7baa93af9a6b81ac683b4": "Speed Blackjack 9 - Ruby",
  "76fbcb2c338394fa1c2ab94241ebb512bb9dd207": "Speed Blackjack D",
  "ab66f0a7572d6a841a18ec089108610291904a21": "Speed Blackjack D",
  "1929cd72a5e70501eeae589380aefee7a23a3a81": "Speed Blackjack E",
  "995f56177142fc754f59893f82125965f7d06e06": "Speed Blackjack E",
  "00c5af118d7f062740ae928e64097ac90429df62": "Speed Blackjack G",
  "18fac68a3beb56d28f66d731c62486a0054ce805": "Speed Blackjack G",
  "24cfd1e18d75f6d1a59833ed7b5a6618f39279dd": "Speed Blackjack G",
  "d5b5f755ec8801cbb6779ec5daebeae4d131e177": "Speed Blackjack H",
  "fc0097d39eafa98bbc841c057ad3635a434c1aa0": "Speed Blackjack H",
  "deb9f7eabe7d1266a375d3bdc83a5b4379b428c4": "Speed Blackjack H",
  "0b1ea8bd3a9ef0eead5ccf9a7046d02934aaaed8": "Speed Blackjack I",
  "810f68dd5b091e71c1f52fa083d94448667eae15": "Speed Blackjack I",
  "899da12095c85b66e29ef3a3ce78790d10f1aa4d": "Speed Blackjack I",
  "5121ff44b5e5dca3a44a7ae5b6ab66e32f5bc505": "Speed Blackjack J",
  "7b5ef8a1ec96bd23de9868abee4002daf7add558": "Speed Blackjack J",
  "331b361611477ed1fba65af94af74c98772bb668": "Speed Blackjack J",
  "0078e14b3bec8ce0ebaff4a9592e2b93ca5216ff": "Speed Blackjack K",
  "efea356614960649eb6aca26680d6efa4936c9d6": "Speed Blackjack K",
  "93d36e13c99ed94e9322b0aa4d665cd0b048fe77": "Speed Blackjack K",
  "166803dab698c246783b86854a4bc48227d5e9f7": "Speed Blackjack L",
  "5193a34fb8157311474fa6d240c846d3b8baa670": "Speed Blackjack L",
  "fa3b676e28bfca16b0522011f3453ba20efe35a1": "Speed Blackjack L",
  "125f66e06a9a76f267cd9376285c372da558e542": "Speed Blackjack M",
  "cd64f72509b2e638764565ab22b1b50fbda0a1de": "Speed Blackjack M",
  "0e5137cdcb4760f8653658910905a113bcc2b48e": "Speed Blackjack M",
  "17c40ff26113e145872f9ca37eec3619c2c7ac37": "Speed Heroes",
  "755833e32e81ab47ca4ba74298473794658dd0b8": "Speed King",
  "d3c2bafc353651c873f37e60e2fd324b3a327aad": "Speed Roulette",
  "e5a4c7f5e6f8afa8a3bb9ac7b179869c95856574": "Speed Roulette",
  "ddf5abe7de277531fecd289d26a460be6bdf1095": "Speed Roulette",
  "87512c032b500c60566a555818cc8d4c283a5b65": "Speed Roulette",
  "112c0c5e85be6b609ccb1506d2ed87fb198897e0": "Speed Roulette 1",
  "287722f21a72d6ecdae88f74163c0e2840bb2e01": "Speed Roulette 2",
  "0eadae80e3e56844361562c8b7720a18a657f665": "Speed Super Sic Bo",
  "47c6699c9ceab5779e978e4147d845b8b418bd51": "Speed Super Sic Bo",
  "3e83c3d7d7dd60e17c6410bc3dd3bd954f0e0b2f": "Speed Super Sic Bo",
  "3574a9f97a34c397a68ee774f449357bdd8261c1": "Speed Super Sic Bo",
  "1cc8f5d5d0bd011a720f2f0b85bfefad195b2911": "Speed Vip Blackjack 1",
  "9098e77854c33ff39da27104b37c7b996df3e553": "Speed Vip Blackjack 1",
  "4164a114d8151215615e91cc5e7565116d74e1ed": "Speed Vip Blackjack 2",
  "4fa44228ccf8ddd3738b2d717f02218940a688a4": "Speed Vip Blackjack 2",
  "77bfaca5d82f48c34fc225e88107811d65f62a16": "Speed Vip Blackjack A",
  "798bdf82556e308679dfa2601cee1f47269bcf2e": "Speed Vip Blackjack A",
  "32bdcef31dce46a3ff636318b5851dc0dd8bfe38": "Speed VIP Blackjack A",
  "228290f5ffb1c2479d21e994ccf874c80d3236ee": "Speed VIP Blackjack A",
  "5bda70faee4fb207adf82bef206af6fdbe660eea": "Speed Vip Blackjack B",
  "7a55677b2262e4fe82b6c6ee8f877c8e91622e83": "Speed Vip Blackjack B",
  "47f5afa63f775dd9f43e57569d75d81fb9525482": "Speed VIP Blackjack B",
  "b8ea9fcee779ab377dc0cfd2e88c490e0d5a0fb3": "Speed VIP Blackjack B",
  "42a4ad99a5f6176ac071c42efc2684f7baf2bd2b": "Speed Vip Blackjack C",
  "86daf551b102827192f5a6ded20a11ac6d6b10e4": "Speed Vip Blackjack C",
  "d8dac4138bbfb9cf06178467b00d015e39424448": "Speed VIP Blackjack C",
  "63cbea0c17daf93bce1851512053b8363270a293": "Speed VIP Blackjack C",
  "2fe07dcb640bfd94ccf99f789c8ebeb5449b7283": "Speed Vip Blackjack D",
  "ffc32fe882c6a01b3026d4aac213008d3a3925e5": "Speed Vip Blackjack D",
  "8a4f6d68ad2ab4985b48400bc348a106f5f7179d": "Speed VIP Blackjack D",
  "ee1c07dd44d10b92a15dd9c0d362dc640695c8d2": "Speed VIP Blackjack D",
  "529d6bf0bf56ba64cbcb374b411524b697d74899": "Speed Vip Blackjack E",
  "cd0f32a18918ae22e96f70b8321e562e2bfdccce": "Speed Vip Blackjack E",
  "0915c85416f545e17075a38505f6155511ba2305": "Speed VIP Blackjack E",
  "23d3770158323aa9e92553e2a4debae4f3e019cf": "Speed VIP Blackjack E",
  "9314ebf53ad032ab8bfec910318c0d66bec3796d": "Speed Vip Blackjack F",
  "ac9a7f21cc901e82cb2f8f488e365979dac0ee46": "Speed Vip Blackjack F",
  "a56d5494cd072cdd727759ea388a4d6f7cef9992": "Speed VIP Blackjack F",
  "fa31eae57a770740934067c7a1a778ce0daae612": "Speed VIP Blackjack F",
  "2913711d538ecb61a2d84ce55e9c38af6bb11f4a": "Speed Vip Blackjack G",
  "3d1242232615a784f4d12a742e4bc82211b5b024": "Speed Vip Blackjack G",
  "62f649abcabc64610bc0620e2f45bec620ae3562": "Speed VIP Blackjack G",
  "bde684cce16816a552b2b6a4cf0f77adce8021ab": "Speed VIP Blackjack G",
  "cb264aff8d781fe23001a38541f8b5fe233f0c6a": "Speed Vip Blackjack H",
  "f5b4466b98bb36966138bb2da7ec1ebab1deb7b0": "Speed Vip Blackjack H",
  "1c08fb132f8283e5526eddef5d34f5eeaf69dc1c": "Speed VIP Blackjack H",
  "3bc7886b2e99ef7e62bf884397a27aa266a6d7e1": "Speed VIP Blackjack H",
  "204677f7aa7fd36cbb40eb1d14961776f010e9a8": "Speed Vip Blackjack I",
  "43e65eb1f83413860df192fc3c412453bbf6250d": "Speed Vip Blackjack I",
  "2e4522b82f2b4d1e0cd859b7d8768859126fe3d3": "Speed VIP Blackjack I",
  "320fc5e539ba9755a36a8b92a6540e92fcc34fbb": "Speed VIP Blackjack I",
  "93bbfcdcebc53386b2a51095a38ccf6dee216757": "Speed Vip Blackjack J",
  "aae827eb9008c446d9f24b7ad953524bba0d2907": "Speed Vip Blackjack J",
  "3f58bd7511feb0fddffbd923bbcd97ae1199f3a8": "Speed VIP Blackjack J",
  "2766e6463fa248064aab2cff924cb90ec0080cdc": "Speed VIP Blackjack J",
  "70ce7bbb417dd8aa7145ab294edb773304e769a0": "Speed Vip Blackjack K",
  "ab4f92abba5ed907446f0a979bda291a5b401d1f": "Speed Vip Blackjack K",
  "bb4943acd9e5c4f1c888fb1eb80c139aaf08414e": "Speed VIP Blackjack K",
  "501ccfcc9fe5d29d02ca340bfa836ba79b720d97": "Speed VIP Blackjack K",
  "122c80c16ccc777c5fa9bcf6f0d4488d049383cf": "Speed Vip Blackjack L",
  "1698a197b21c178eb06f0aef1d4780af83de0d76": "Speed Vip Blackjack L",
  "bf0a726dc92ec796ad7c4a48cb1c976697f7aaed": "Speed VIP Blackjack L",
  "bbe40f8aecfadf84dce5586586185af5b31335df": "Speed VIP Blackjack L",
  "8045b6883d6429ef33ab4c35876e416eedf14abd": "Speed Vip Blackjack M",
  "d32cb01237db47bff180311a6096fe77b052097e": "Speed Vip Blackjack M",
  "15ae89968410b543ed97049704de0856902f3d53": "Speed VIP Blackjack M",
  "9c26ba9e5950e6a08ab646115ae3cee4d3dfb12b": "Speed VIP Blackjack M",
  "170a793aaf2ea0b8c4d1b6f6ddc5424265e792ef": "Speed Vip Blackjack N",
  "fbf58864ebcf8534592d8f2d1176ca4532c6f22d": "Speed Vip Blackjack N",
  "b10fbd1fb26db72fc617b99257178ce51d6aed0d": "Speed VIP Blackjack N",
  "58aba16794e8901f41a59402a6517b436bb6f202": "Speed VIP Blackjack N",
  "8b74123c1da91a3369b400b7e15f5616a24a645a": "Speed Vip Blackjack O",
  "e8740142973da2f66c7bbee63e71462cd810c8bf": "Speed Vip Blackjack O",
  "d3cc5db9739a579042c06f2ccedd7e935a741970": "Speed VIP Blackjack O",
  "10b3726e22780a1c05a9cd153af0359cdedade6c": "Speed VIP Blackjack O",
  "edb24d07e7f5dd63dbcaaf4d4d98f646d681e301": "Speed Vip Blackjack P",
  "f8fcea3efb30b6e68dfde5f04acdd11ec2036c9f": "Speed Vip Blackjack P",
  "161f812e31712f9db55bb32b97f4446efcfb517b": "Speed VIP Blackjack P",
  "1daa87abe2e528214daa8e192ca2efae692c904a": "Speed VIP Blackjack P",
  "23daa7510d53b97aa412547810b9ed8643ce5069": "Speed Vip Blackjack Q",
  "4286898c391429b32c5e32b475e828755e3ae253": "Speed Vip Blackjack Q",
  "bbe9094d5949ba363906aaa417a6c0932a68399e": "Speed VIP Blackjack Q",
  "f15b0b7ba7243227be60a78e8312ed8735f685cf": "Speed VIP Blackjack Q",
  "3b015244fac8dee34db0edbaf9f72d5f672ceba9": "Speed Vip Blackjack R",
  "659e1f8714a462a2d2843b286a75fc0aa6ba7b63": "Speed Vip Blackjack R",
  "15335de477bd05c1fb5b8049bc5d3463be3b9bf4": "Speed VIP Blackjack R",
  "0d6d6f1bf68b9754a9390501976069dc4581f715": "Speed VIP Blackjack R",
  "c8bbcfdb65aa5e59194c16dcdba6568bc2eea833": "Speed Vip Blackjack S",
  "fe0d47260b4974796c707f08e2f30bb006f7b2c6": "Speed Vip Blackjack S",
  "1c4e993ab802de87f0256ad52ca52b06b364abc4": "Speed VIP Blackjack S",
  "400cb8ed93f29f5c055052886072d98408a49ae4": "Speed Vip Blackjack T",
  "830db69978e86d32fbfc999563e88b07179694b9": "Speed Vip Blackjack T",
  "448446d4b24897c041f1bb3baa628473379593d5": "Speed Vip Blackjack U",
  "79dff508274e4d361f05dd4e135476f952870ded": "Speed Vip Blackjack U",
  "64986fc5c6a3883ff568e6988cf936d048d32d12": "Speed Vip Blackjack V",
  "f871c3a23c03995cdee59d226454c4b64d69290f": "Speed Vip Blackjack V",
  "1c38204b1501bbf33f2ad2d978cc02b613d00a53": "Speed Vip Blackjack W",
  "2f186ea0bff13d0b097384aecb321e6bffd88421": "Speed Vip Blackjack W",
  "ee9cb5d05984218a1196300602daee28d4dcf31c": "Speed VIP Blackjack W",
  "1dc8f22fe48e70ca6c616b043aea47f466d21924": "Speed Vip Blackjack X",
  "38cf0a08595db7b3ac673198bf21cd749c4428b8": "Speed Vip Blackjack X",
  "2523c0514df2dd057a19167d72525732b645b43d": "Speed VIP Blackjack X",
  "ae0a7de51ffd226ebdf4396a9578d7e365968726": "Speed Vip Blackjack Y",
  "c6f1f7c379f29107e084b4be0540903e12ca8a5e": "Speed Vip Blackjack Y",
  "80d69a3b7cf16c8cf3aee914716f59bc4c61c160": "Speed VIP Blackjack Y",
  "2af80574d80a4ffaf919de7eecb8ccaf989ade6e": "Speed Vip Blackjack Z",
  "b3bb61abd4694793f4e45cd59f4de31345324740": "Speed Vip Blackjack Z",
  "b32a99f2b71db6b77ba4480f4ee80371b8309032": "Speed VIP Blackjack Z",
  "ae3bc8766d1389f6b48e7f2fc764eed101050eca": "Spellbinding Mystery",
  "dd576c9c5984af4421e1c21a6ceb3a40c6927755": "Spellbinding Mystery",
  "1f847cf0eadb9a7005f934d9b0b6a5a2b06e64b3": "Spellmaster",
  "b5a25c34205da5bb60666fddf531aa2f955de050": "Sphinx Coin Boost! High Stakes",
  "2921e7ad4cf9715db51362a83aa85e5299682ff6": "Spice",
  "9884f597c4185d1d0a3ea95518208c2b165a4470": "Spice Spice Baby!",
  "bc99df85d1588a883eb6295db3541d8b67969758": "Spider Goblin",
  "02fe124aa4ecd1b514214b56b2956f8802d63953": "Spin & Score Megaways",
  "6bec2d805384d3d9e730fe76f1e673f9efbf0e2c": "Spin & Score Megaways",
  "712039cff9103efd40751499d96e475568e969e4": "Spin 'em Round",
  "378dc70552b4060e1a2063e2684f3e64a6b53e46": "Spin Party",
  "8e9ca44b6af6d304b80954e0bc27e87e2537e231": "Spina Colada",
  "7741d13182331e40e0e43567b647f2c47a46497a": "Spinball",
  "2e1e4f80720e0eb85ab766b6313b021793145dc0": "Spinman",
  "0c0e13369c9c9a7d7e026f9bc77b206aee372dba": "Spinnin' Records Into the Beat",
  "9e26a17c66a2a5ac4a108caa9fda98c63a4f12ac": "Spinnin' Records: Raving Reels",
  "7bb4f62e3ab7616da4232bb7b55fe31486f04535": "Spinning Crown",
  "e4dc4aedf4afa4d32fb75ed23cbb00302db63117": "Spinning In Space",
  "02f969f7a2cde0f4057fc1b919d5d9b90c375f8e": "Spire+",
  "1e6ae61837295e3242d72a28aa7d2adcb151aae9": "Spirit of Adventure",
  "bf340b84640c3283ad6fd70754d52a0c111cdeef": "Spirit of Adventure",
  "95ab5fbc7f312013ab243d413f30d0bb7eba5db5": "Spirit of The Beast",
  "b607405e888a7a7105934be9c26fd7a53fc88554": "Spirits of the Praires",
  "e2729892df77adbd36c82d85314944d58f0e4796": "Splash Clash",
  "01910a52057b93dd432ed460ee5428cf9bbee0b1": "Spooktacular Bonanza",
  "7c6ed94bb531cc6d7d70ae6ec5bc2c35ae7be42a": "Spooky Jack",
  "55aba0e89eaa3ce6dce764445c13cbdc31a92551": "Spooky Roulette",
  "f388f8173d343f50eb0edbc1172723f6f3a5f635": "Sportradar Sportsbook",
  "ac2bc6a076042394099170aa82715759ac49af4e": "Spring Blossom",
  "2e442c157acd2b8f8420c8cf5fd538b179a61348": "squeeze",
  "8df05ca9bf1df6286d46edacc4c3fa84c48e4413": "Squeeze Baccarat",
  "974a1077877306d3d53b1ed3d19fc6398b64234b": "Squeeze Baccarat",
  "f15a3e64097e298168236ccae5467f962a1a5365": "Squeeze Baccarat",
  "8f837c3210eede3a5dc206c92f1a3cc19c633793": "Squeeze Baccarat",
  "df1dc3b814bff4a659ec442387cb8acac8cded35": "St Louis 1904",
  "b7ef0b5f87931343863a29bc6915db0a5a4bb6c8": "Stack'Em",
  "14b4bc0e8c53afc5bfc3e232c828355bd3d8f121": "Stadium of Riches",
  "b6317cac3a406f8d99680fac666aac6401681382": "Stamp World",
  "be633cf880525b0540ae4cf380d5afdea8f2b680": "Stampede Bonanza",
  "9537b55b3bc3a9df325195f90a46d2288fba49a4": "Stampede Rush® Trident",
  "0c3ef2bbbc328c4cf0d8735d21889aee52a0e591": "Stampede Rush® Wicked",
  "3662189a34377c705ebdc8dab4414d85f6b393aa": "Stampede RushÂ® Speedy Santa",
  "94120ef3279f5fb5c187b353729c6afb555460b5": "Star Bounty",
  "4f9b5b2810cd368ede7a4458ed271301defd8af2": "Star Bounty",
  "513e28ef8bd6053bda78a902aabd3ad36f476425": "Star Candy (Buy Bonus)",
  "d82b6eed5c74da4aba78e2922a7b9b4a5c176adf": "Star Joker",
  "95b6ec92f88d076673a8b6a60a1979bc9f63df9d": "Star Pirates Code",
  "d21d217794de3f85813526cb15384c19d8b8797d": "Star Pirates Code",
  "5750979486a74aefd72c58f9a63bd05e491ea82b": "Star Supreme",
  "d53af38c7e8299ca3a6d020b0e17ad8e80a15292": "Star Wins",
  "c0fdc963b753d3a8868808df9c339186afa8aab6": "Starburst Galaxy™",
  "a0669d61421934ccb5d371881a3467360d824a73": "Starburst™",
  "2674632f99f7aa32c433b03a28f02c569c7a084c": "Stardom Rush",
  "42eab77d6ddbb1a41bd631503318f0dc34654cd6": "Starlight Christmas",
  "66e34167c174a220d3db0b72c96d14b62e0d5c27": "Starlight Christmas",
  "2c18f638b6e80feaa36aaaa5a253912c25a9ab0c": "Starlight Coins",
  "278af07f79bed691589f018b9ae6944dfbdefb65": "Starlight Princess",
  "2355c8341f0cc36e34445c2425ac5f675ace85c3": "Starlight Princess",
  "0fe29c34bdc0a8c0c15ace69eab2e7c8dfb379b3": "Starlight Princess 1000",
  "90709dbd8828ad4a270c14965d6c7eed97bc9607": "Starlight Princess 1000",
  "742109fb0510c0941eccbef24732afd5930290fb": "Starlight Princess Pachi",
  "51d0a5d56ddb8f9ced0f5c0682e363ab71e28b8b": "Starlight Princess Pachi",
  "d620bc7d2fadc3d4b5379d8acb4a25c9bf46c962": "Starlight Princess Super Scatter",
  "c11288cc6ac75f6b879071fd0b9d0c32097c4c0e": "Starlight Princess Super Scatter",
  "517c758e5bd2bdb875b3b283b1b888fd9b21dcf4": "Starlight Wins",
  "a5059e756acd358d96ca96a16695770f556b0460": "Starlight Wins",
  "e038e60470b22a79e2cccf44fd60df3a3f9ef0a6": "STARS",
  "3884f4bd6ec93dcd6b4e6bd53ad4232083b5c54f": "Stars & Coins Respin",
  "40236a09bb1bd2dc5e7e725c6c40c16dcba08629": "Stars & Coins Respin VIP",
  "17f4de00e8133e60acc2c22a0753f5b168834311": "STARS DICE",
  "a5079f6d6815f1f935de1d012dc13bf8408242af": "stars-of-orion",
  "9a3d5e70d621250d5f43fe8b494451921a2a45a1": "StarShine Princess",
  "c30130a00d9e29c2b656449c2b2743a417f49131": "Starstruck",
  "1ea502460bfed03c1f9467eaa3ff34f41c5cda7b": "Starz Megaways",
  "0948fb7b68c55dd868176d84995af40df57f389d": "Starz Megaways",
  "8f6502bb4f459254333175287879b7e57955c490": "Static Nightmare ABYSSWAYS",
  "9f6248b1de642dd98445e3b658e69e1493b0766a": "Station Red",
  "c847e8f1e0ce76541f6a9fdeeed8fca5443cf996": "Steamin’ Reels",
  "14d1b6a5171cf4c7029780a3096b5aa9bdb94385": "Steamin’ Reels",
  "4995e1988a562e67c6e3f848b2b31bd159090f9f": "Steampunk Lock 2 Spin",
  "df28a09329dd37c213fd410915b60003cdc51c91": "SteampunkPlinko",
  "a89fbc08113cd6f9001bda1ebbfc6028de42661c": "Steamrunners",
  "c24f806060091fa1c82fb691a740fd951f3f3ad2": "Stein Haus",
  "bdcb909fada670c6d1cc503be1469eca79729d84": "Stellar Fantasia",
  "918d2a23c43bd0dc85810ebc644617b8935eda48": "Stellar Joker",
  "ca529695add00d4363a896742e06190e0333cefc": "Stepping Diamonds",
  "86d0122fd47f596f7191ab3aaef2626fc2b31d7f": "Stick'Em",
  "8d2b9366f2456c299508fb0d4febb439eb91da1e": "Sticky Bees",
  "06be3e437baee7fc2f57f3b54e1cefbf992d9412": "Sticky Bees",
  "56d9fcc119d7c7fcaf04a95a71ecb3be08a72846": "Sticky Joker",
  "7a6226dba554793793d74153761dafbfe8a606ac": "Sticky Piggy",
  "510bddee196cd602bba4632ee57b0941eacf1454": "Stinkin' Rich",
  "3a3f1d6a454c079f0eee33cb209f1f11db7dcdad": "Stinkin' Rich Skunks Gone Wild",
  "c0754fdf5b175f8bedac40a7ad5852c849cb7981": "Stock Market",
  "0f6e13dc392a986427026524ea586ffcab28f89f": "Stock Market",
  "45032fbb77a5c60b7c1956128039d620b844945b": "Stock Market A",
  "7986cbaf73a551b348966b8688ada24ed8a101f1": "Stock Market A",
  "f212bf8d78917792ea1037624b75199c1b0f858b": "Stocked Bar",
  "3494ec0b14c9b542bf6adb9953b269ce5e8252c3": "Stockholm Syndrome",
  "7584bf4bc9f17cdc88ec344341a6435995d6de0a": "Stoichkov #8",
  "ff1df74485a4ccee83c8983bc5257fa15b54e68a": "Stonehenge",
  "b62ec353fe977e6c8ea0ae9c1b4897dd3c6fa00f": "Stormborn",
  "7b37bf1fc396acdccb811e89c9be32598117544b": "Stormforged",
  "5d9d0f8dbda1d1fa9e9dd5e3e8f013209e9f059a": "Story of Farmer",
  "c8d2942319f53fbac46ae5caa9db7548016d3231": "Story of Jing Jiang",
  "c3664b44d3c6ef4ea0f4ac599021c9f402706fb4": "Strawberry Cocktail",
  "3dc77ac1f90081ff6edc84848d917577d3d3182f": "Strawberry Cocktail",
  "506752bc16af98b6498fffc824201890d742f571": "Streaming Girls",
  "48f5b6ec735cb6cc2476470a2142e354f2cfe67b": "Street Magic",
  "db0cb5ac51571118000480e8d4d2ccc357b23d9d": "Street Racer",
  "f1d8ee9c00573193ecc88705896c101cfa73055f": "Street Racer",
  "883930e12809aedebb0de2fc86eede8c9555f95e": "Street Racing",
  "83b40889f43fb5aeee9edb8748b562de1ef6a4c9": "Strength of Hercules",
  "0e59c495aabf5bb3c2a847f699cd765ed6a584d2": "Strike it Gold: Win Ways",
  "97e213d1b4f324700f85c81b7bc1223757262668": "Striking Hot 5",
  "2bc79a252ef7d15ab38c10cf52ff729502106c3c": "Striking Hot 5",
  "4cda3ad66a3c05ce141f820bb174ef4414ab044e": "Submariner",
  "5273099d9547a3490de73349cf07c8c99d773caf": "Succubus Secret",
  "8a2973ebb22aedf1618b2c1f0106bda3e95f12a9": "Sugar Burst",
  "f6d7f9367847ca388c734d2a4163bb610de945c5": "Sugar Duke",
  "ad27ed371fa36dbc5c1646d74a1f3aad74de6479": "Sugar Duke 1000",
  "c2d0b8671a56292f1e49dc62deff7ae41e05eba8": "Sugar Duke 1000 High RTP",
  "1db279bc26f964861624bf06a4c63a62491e5e22": "Sugar Duke 1000 High RTP VIP",
  "550dcff0ae6540f5235c73b3362b24b67a5cd2db": "Sugar Duke 1000 VIP",
  "e0f82f131db01bef52f0e9d6f7bdd592e7fa23d9": "Sugar Rush",
  "e2d3ab46b9efd108cad3632abadff599a6a3d70b": "Sugar Rush",
  "4cef706d0a9b05a856c4b21b987974fb24404293": "Sugar Rush 1000",
  "a97ea83b7e80407f9af020cb815e5962f8b0553e": "Sugar Rush 1000",
  "3870debd9e8f75d4b60dbe6b2fb6cec0901dcaee": "Sugar Rush Dice",
  "0ed69208f2d45d2da23bd70789104fe878bec86e": "Sugar Rush FeverÂ®",
  "8942f139af1870797ac7ed124df407a3587ded18": "Sugar Rush Super Scatter",
  "3154d62c5895a813635887cb5f49156301935554": "Sugar Rush Super Scatter",
  "65fed0aa9e81228aa473e321599de2078a28afa7": "Sugar Rush Xmas",
  "515e0a0b108692e0103db64cbde74c3955084858": "Sugar Rush Xmas",
  "e51dad269c8b76fd5b3104a3d2dabe729664d2cc": "Sugar supreme Powernudge",
  "abfb1ee76116681442fefed4ef178ae6d060ac0f": "Sugar Supreme Powernudge",
  "beb6faaa809db6def867725085dc707f85b66aa3": "Sugar Teddy x1000",
  "156d75f9e74a6b19ab30876c679a0fb65d5e1598": "Sugartime",
  "58559683de4862e6c9735d929962b72ee1bd7b6d": "Sugartime 1000",
  "d0b5f38bb8fdad22124875e5dad24e1e5d604459": "SugarVille",
  "36fae2ca46ac8693793b56975f9d5b32d3532ffd": "SugarVille 1000",
  "da6d411db094124589db4e0ec1daeb1ba7987aa7": "Sultan Spins",
  "eb32e67bdc5c9039d2a466d1ad31ecad2aed203b": "Sultan's Fortune",
  "58a273f765db7fbf84a9553b7f448606f3b1a35f": "Summer Bliss",
  "9a5ece78ea4f4dee6f85f281c17cbad85c581b5b": "Summer Fireworks Festival",
  "3d5f13899656cd3716b43ac9584c65cefbdb8a97": "Summer Samba",
  "9219be12a84bd7d5d3fb616621bd45d8161fc6ad": "Sumo",
  "ec054a212360b97d2ace87a92dc779000b7ee58a": "Sumo Supreme Megaways",
  "15f21240eef7cafd7ad4666944fc75e103a0741b": "Sumo Supreme Megaways",
  "ba7f8dd57fef920046947845536672940548991a": "sumo-sumo",
  "9aece4f9bce7e3687bf5dc2680cbbe0a2703af2d": "Sun Crown",
  "fbd3f146d1f23fe2a04a7f4871c3fdac15492a1f": "Sun Goddess",
  "82872d21a30bc906e2c978ba025b09e2effc1d7f": "Sun of Egypt",
  "bd6a0c2fb1a43462d6a9682f672be706551bfc74": "Sun of Egypt 2",
  "9a5209be6ba98776d82a167ef78f8e5a8411ee8d": "Sun of Egypt 3",
  "1eb35801bb1d7e3dd5c867b03e51cc827aa9e02b": "Sun of Egypt 4",
  "e5af5150014fb2c47d27d962a52eaa9223cf603b": "Sun of Egypt 5",
  "cb6d3e3c2f7102fcf696028b561e3208d930a5d3": "Sun Of Ra",
  "d5389f31e73a983538733208f8eda8c5695cfc9c": "Sun Princess",
  "836af5e67c21ea488a973090e628a12245067711": "Suncatcher Gigablox",
  "b084485f97e60a8aba83a4b95460e68030b02325": "Sunlight Princess",
  "d14aef0a2356f73177462ccac1d2bc5d55d941b6": "Sunny Bikini",
  "994e87f3033ab010f4b1836190e20748777629a7": "Sunny Fruits Lock 2 Spin",
  "445d46eb741a8fab6095d368f90671056ccb65d0": "Sunny Fruits: Hold and Win",
  "ae17531e3c681c59b244c72b8ca6032a48eeb834": "Sunny Shores",
  "72303d7a695bb3157574b110afdcc7701ecccfd8": "Sunnydaze Asylum",
  "d897c48cdabc1773c7f77548dfc36d94e28b8306": "Sunnydaze Asylum",
  "a442cae60054d70c8d16df8d753e9f9ab97dbbb3": "Sunshine Fruits",
  "3de2583e200737a5b021133bc1efd93c5344d3fc": "Suomalainen Ruletti",
  "71b55a6744046bc2791c87add879a214a05a63a8": "Super 10 Stars",
  "d5abc545ee81335350ce354e1ac6e6d00a91e9e7": "Super 12 Stars",
  "af20a5d48498285281b0bae56d0fc0b7c3b7eb86": "Super 15 Stars",
  "f94860853b9c6534fcbd7007b2720d82fb0e4cc1": "Super 20",
  "c9f7e42fbd92d96aaafe88f7fdada3da8ec193b5": "Super 20 Stars",
  "dc4adaf802cd09678ddcf2daa19ce9cf39a5cfdd": "Super 25 Stars",
  "06b000dd7dc169661614e284eb4cfbb0eaec058e": "Super 5 Stars",
  "816e03ff22b99d0b2a645cdb42da8c689bf30d74": "Super 50 Stars",
  "c2e4ecaeb9d0cf8058a5e096de247f8876ac2d20": "Super 60 Stars",
  "3bd028a08428b9a41058073fd6e7682b0944469b": "Super 7 Reels",
  "a41a0f49f0ce0295ef94b4ec23ce1387b83533de": "Super 7 Stars",
  "9b273512464ecb731f57afdd398b6457a745dcbd": "Super 70 Stars",
  "1d7c5d2a1ca7f1f4c578f0e5a3a2efd14c222579": "Super 7s",
  "a6b11f4312bbce9419316f333268eb3743486656": "Super 7s ",
  "2c90436345e407343639e8a5a815d11ac1a04694": "Super 8 Baccarat",
  "4942b0eca69437db749496d8a4bf439bb9c8c03e": "Super Andar Bahar",
  "688bcb2fc7cc398cdb2402ff837f470cd33f61b8": "Super Andar Bahar",
  "8eedc2717927e104f3e6389e5b23f040d7c6bd91": "Super Andar Bahar",
  "9f26c042f945e717a589d9e2c501a25f70b39a8e": "Super Andar Bahar Live",
  "689416c0e096e590787ef2d22c913d2624d227fa": "Super Bonus Mania",
  "3569fe918210970caf0771e72c860e11b8074188": "Super Box",
  "791b92b3b3fc314edda60a90a7cc669d09d0cd5b": "Super Burning Wins",
  "58031980f2b2fb8759664d3a90ca72ac73498789": "Super Cats",
  "f71cf07b420f80fcb5241586050fa05e2bd2ef9a": "Super Cherry 1000",
  "b63d3763d98220163cde58fe725be398ef2acc44": "Super Cherry 2000",
  "3090fbb539db72bd1d41b0cb04158a6c05269616": "Super Cherry 5000",
  "1705aa1800b98e8a7f8e1f78ec359459afafc986": "Super Cherry Lock 'N' Win (Linked)",
  "c50fb06d1de65ec195e7c23338712637b4d5047c": "Super Chili",
  "968a9fb7c2233ca677e3178ed2bbe7d8064ae56b": "Super China Pots",
  "077116fff93e90f2f0034a66ae107cbe002ec08d": "Super Color Game",
  "80b77d1e876f931d4b493d4a0bab29302b1b2e6e": "Super Color Game",
  "962d96119a43dca64e134372ae9599384843f92a": "Super Color Game",
  "24a2f8839686c1289761a67c6f92fd5747d8b7c9": "Super Color Game",
  "87881014bfdb4f48c6954299ad0dd79c9ec0dc8b": "Super Crazy Red x1000",
  "75d3f4909cab20694b4df8c80602c339926fc74a": "Super Dragon Tiger",
  "e1c37334fa509386f2ad6a431d75ae2035f0ed73": "Super Duper",
  "11c61ff5e39e0d5a4da64145fb6f67cf49e7cf31": "Super Energy",
  "c9759fefba53fd37ddef49933b8c19b80428a65f": "Super Flip",
  "cdeb9858a256daa79df48777df97cf849b9635c3": "Super Flip Deluxe",
  "4a9df5e071306c7592750dd79a0bb67a92fe4506": "Super Gummy Strike",
  "70ec80f4ec04dd5774db3f0193ce41c18b1041d4": "Super Gummy Strike",
  "e92e98aa6080954200bd00a5cffec40ecb3bf0eb": "Super Hot Chilli",
  "948bebd98595fd9e108c03b93148409c0fa24641": "Super Hot Teapots",
  "8dd96901f499faa43d19052f2fa351a2fe9534ee": "Super Joker",
  "da332a981a39f4387e3214b2188a49d7fe1fafa7": "Super Joker",
  "8ce8bc5877c3fc483fb20fc6eb6d74923046a24b": "SUPER JOKER 40",
  "45dc53e43901678f7b1a865c73ad71260be8210b": "Super Liner",
  "090625ef9f6c9ed428f4248457fdb0b426386232": "Super Piggy Inferno",
  "b3e68dae47d2b73bda3da869f8c923f58fa88539": "Super Pink Joker: Hold and Win",
  "4237d4dc49c44ebe59e87e50d04202351ca25d70": "Super Serge",
  "65bdfa61b5fac0640826ad044117333be2fe4411": "Super Sevens",
  "10a0ab0bfa3c3074f48809c9bfe7e9c85813eb68": "Super Sic Bo",
  "4cc7a0a1eafbae1beefcc076d141bacd91ab3cb9": "Super Sic Bo",
  "c3b68ec0a6af64770dfa712ac7a8cceefab4ba5d": "Super Sic Bo",
  "60b6b70ce756ca9dafa20d98cd9ac751775c8fec": "Super Sic Bo",
  "b803119b8d1fb7172dd7931575f616bbdf8f97fc": "Super Slime",
  "df5bad39b8967ca2028da7740fab6f109979cdc3": "Super Speed Baccarat",
  "e1941634fb29ac73c8c840bdf71a35514ebf8d9e": "Super Speed Baccarat",
  "273f6855922697b5f448441b94c758207f9dac30": "Super Speed Baccarat",
  "b206547a8a1464a4fb0a9da7e086aa8564a5917e": "Super Speed Baccarat",
  "45f42785a949dedc00f0871aa465dcb6f0d6e6a3": "Super Speed Baccarat A",
  "c8ac497dae912a37d5c2df63e173ffcbefccc069": "Super Speed Baccarat A",
  "c20dbd1f96e07926938f7c47818689272c5949b6": "Super Speed Baccarat A",
  "6b65ce359e7a58e32e309812c406cd6620e1bbed": "Super Speed Dragon Tiger",
  "972f67c2950d21c8a1f8034611acbf500bbb507f": "Super Speed Dragon Tiger",
  "d94aa76c285b1406a5f42b60c4068146cc6cbfe5": "Super Speed Dragon Tiger",
  "c19113f1541865fd57b1ed5d9ed2290660ea1178": "Super Speed Dragon Tiger",
  "c5261970b6d39e012cbb7f356c264c864a684078": "Super Sticky Piggy",
  "4d82453f3c1f9062584331a0603d3855fcfabfff": "Super Tiki Strike",
  "65ce12fce165a32165ef046771915d614c4ff989": "Super Tiki Strike",
  "cbe60aaeae2ecf86f0dabd998963d4fbd224509c": "Super Triple Fortune",
  "ddbf2779274a5f76e1f5b6b4fca89b3be6a7523d": "Super Twins",
  "6e33c37fd5b97bc56da57edc026c0e183a4590af": "Super X",
  "a3dc2f11a4a7858cd6473fd61c16a3826515f4ee": "Super X",
  "a32c937c7e0d2b5aeb8eebb9579ba1555e47b761": "Supermania",
  "23f33f1bc509d34d208664aca4bc2b087e04c603": "SuperShot",
  "d5cf98bf2e0c91de015e39a93f5bd099cfa20e60": "SuperShot 2",
  "41f9e93acf08474dcaf311a1036d2351c19a45b5": "Superstar Sevens",
  "d9f1ffa02e07852dd82e82a21526233fd5a82b8c": "SuperStrike",
  "5d1a7cd35b8f6d6e36e89d9ec9fb6e6dde5a52a2": "SuperTwister",
  "ae8b138c13c4ccab72daf6165bc4c8d408d565d2": "Supreme Cash",
  "f60f5ad22b21bf57836e3e862ee2c6f90db50164": "Supreme Dice",
  "0899bc99e235ab1728b6f5761233ef074e9f5fdb": "Supreme Hot",
  "1d626649a17736c816585a3b6e050028f6025c03": "Supreme Zeus",
  "cd6cb5613ae8535bc821f2db94f2e17ffd39cd3c": "Surprise Box",
  "0c8686410d4b4d4657d221896de07b611f48a8ba": "Sushi",
  "24e2d5310de0a2c97a9ce3f7ca5efc2cf88c61cd": "Sushi Fruits",
  "084443251970baabebc4cc1e8d0ce9ae37982082": "Sushi Ninja",
  "047262d772640a36a0cde6b703b3a65672e96fe2": "Svensk Roulette",
  "c4d80a3cec634200421a3bb66bcf0710f459b429": "Sweet 27",
  "2beb55bcca430d882815c1a173ccc6f88fd0d62d": "Sweet Alchemy",
  "133de618d393b9f79dc277030dbe1d1fcd319849": "Sweet Alchemy 100",
  "373580f9a6f52086cd5af65ec62758ef8735cc64": "Sweet Alchemy 2",
  "38ad939cd79704c7ebe6686132853283c5a4a5db": "Sweet Alchemy Bingo",
  "403f80f33ce3a3542e0cf9838a5cede841337300": "Sweet Baklava",
  "fcf21b663322b5350b2cc66e8b156eb42560b51d": "Sweet Bonanza",
  "34fa44d859cb6617a236a898efd84d8347c64f33": "Sweet Bonanza",
  "83d362666220c4b4c637943ae77bd31d2159bf7f": "Sweet Bonanza 1000",
  "3cbe79d4bd7d6a08d9617b61700437f00c482a80": "Sweet Bonanza 1000",
  "e44a15e93f48e586ca4ca963b029f02ab1ad1707": "Sweet Bonanza 1000 Dice",
  "f10a1adaa5df48656507323ba20704b1c2a89a24": "Sweet Bonanza 2500",
  "cf6e9e5b5ae37641f5714db7074dcba53b2a2345": "Sweet Bonanza 2500",
  "03205f4a633d63297e46361c083458574f32f9ae": "Sweet Bonanza CandyLand",
  "92d7ab12622974af80d1335c34a7c9b8b54a0158": "Sweet Bonanza Dice",
  "bf8042f524593ad44a0d77b66549404a52b41caf": "Sweet Bonanza POP",
  "818730433de21b52faeff3b67b88dc4ea96483ae": "Sweet Bonanza Super Scatter",
  "ada458aeeca0ff7bf59e093897cc30df99af8216": "Sweet Bonanza Super Scatter",
  "aa2a68bc95566ede2a155c9e34c726c703cabec2": "Sweet Bonanza Xmas",
  "9b8338161e916de3fd135e1c8bf8c2f00469c074": "Sweet Bonanza XMAS",
  "2566548f7133ac5a8986d0c91c1be20073aa7d46": "Sweet Burst",
  "b158a95b2ccc824cd1d7e1bf115dd1cd13619769": "Sweet Burst",
  "e518fcd813eea5d1ba86e568115f645d0f210247": "Sweet Craze",
  "08df8615890e1b86424f6bbee95cfcf47666add2": "Sweet Craze",
  "dce766ffb6a6eb4cbf288f71b86fd87afe5c6d9e": "Sweet Gold 3000",
  "d9532910198c7bb7d90664f7631fd9afb81ca39a": "Sweet Kingdom",
  "866d906b5439f6c1b444222151f222bd7ef4a3f2": "Sweet Kingdom",
  "708dd857a457eea451a64470407956b5461382f9": "Sweet Maid",
  "6bab7036a17291bdae2a4e41bcd03ffafa412a99": "Sweet Powernudge",
  "b35fb6fece191a42fc2533992e68d0e85390a772": "Sweet Powernudge",
  "8603cbc986638a242f260b0811e72dd48770b0af": "Sweet Rush Bonanza",
  "91f45671cf1d5fa373e86d9784d1fe98a214ebfe": "Sweet Rush Bonanza",
  "58533b4000dc71b5992560858af47352fc2c68a6": "Sweetie Party Fusion Reels",
  "63f46eef031512b141516c897b54fab94d34bd00": "Sweetopia",
  "c2850a1426f64dbd4d124d49605369a2d1729fb2": "Sword and Crown Bell Link",
  "a7f9f11d831493e1a0c96254a1f591cc3924c198": "Sword and Crown Bell Link VIP",
  "ae081e0c41201fbe8feddb6fbb6f99b339a23014": "Sword of Ares",
  "70cca7d1308a1acf3adeeca8265f0663fc46aff6": "Sword of Ares",
  "425d38eefbaa50e90358ecc6f329aba0cb4ff573": "Symbiote",
  "a39905d1a2ad0f7b2373ac49e97044c24fc6d2a4": "Symphony Fantasia Lock 2 Spin",
  "637329f0f69ed1e50d624e67a092338ac1606ec1": "Syncronite",
  "cc8fe7e725821a1e105fa9459f71bede54d4b499": "TabernaDeLosMuertos",
  "382272a9f14548d68d8c95179455e8e3b37ae624": "TabernaDeLosMuertosUltra",
  "158ca980934e3fe24b47578ee88b8ac4c516423b": "taco-brothers",
  "eca2f865a5e8ae07cbeeaee3f0e8482897896456": "taco-brothers-deralied",
  "cb8cb4b5f9039d241e9ac98dfe35cf25e1a6ab02": "taco-brothers-saving-christmas",
  "1e1b6ddf61435e934e3974e189200aa0c5c2acde": "tahiti-gold",
  "2ca75eaa5cdfa45040b784fcbbf479ee2551c81d": "Tai Chi",
  "105b3e9765c0e047ecc800cb03f55a92ddddb6e2": "Tai the Toad",
  "311b208f6c4ec9d2d213578eb2ed3f1ad068b91e": "Taiko Master",
  "3083c77482edea80db830614ab1466dccdb82fa4": "TaikoBeats",
  "e295c6757731308a96568765d63e249e047dad96": "Taiwan Black Bear",
  "8edc0cab6e77b5d9dbdd9bac7b666278c3fc805f": "Taketori Monogatari",
  "336a83bae1e6a27e1379f9f19dafbfc3b3745354": "Tale of Kyubiko",
  "5ae05b7dbd084534aedba627f5edaea1b5b002b7": "Tales of Asgard: Freya's Wedding",
  "3b7481db32d890232d35444cec6baef6a02c5985": "Tales of Asgard: Loki's Fortune",
  "20f9a31d13472669e51053d85a5c295960bcaa55": "Tales of Mithrune Syn's Fortune",
  "a694a8b6d61fa184ceb4e08b88d9ddccd57b77bc": "Tango Bonanza",
  "9c6d82d3a6532943ae331e0570ff40f70fe7ce90": "Tango Twirl",
  "7db0ccf1797e22c128e07de7f914bc19e6ce4862": "Tanuki Tavern",
  "afe65eef42e399986c3c9f937ec2a62f1e248d59": "Tao",
  "344b3932199a2bb6efca6e2b489cea67e8cf97b3": "Tao Tree Coins",
  "2f7a8a8b70e48e76d39c15ecee2a4eaf31fb2ed5": "Tasty Treats",
  "24e6b13be81cead080c795a20227821f7bd28fa4": "TechnoTumble",
  "90074e47f5ba5e7a0d44809295a415a9de7dff5b": "Teen Patti",
  "59362fd2d9bca9215a136ac117220094a515dcb2": "Teen Patti",
  "b4bd4f4bbece0db44e829c0fb9226909a29fe524": "Teen Patti",
  "67653cf4df26e4cc84d179f0249b696b7dbdbaba": "Tempest Spins 100",
  "bdac766fda19c394599b4aa0089f32e50a861432": "Templar Tumble",
  "3c5f05b8a6500505349d01df09d4694888dd97ea": "Templar Tumble Dream Drop",
  "ed2abe7b2297a15fabd21f31899408822d1e10b0": "Temple Guardians",
  "bb774bb4e165d2873075a534fa5c12a371930ba2": "Temple Guardians",
  "09a6ddba0f979b4c455f491a87b03cde33d7d76e": "Temple of Prosperity",
  "61ac6bf3f6c6542d009dfdba402a619e7fc7458c": "Temple of Tollan",
  "233d69c95425bb738d6d7cdea67abb2d493b7b3a": "Temple of Torment",
  "b7114f2e43232ebcfdacd53b5ff0e7ec2cbe46f7": "Temple Trails",
  "1a6c5be8fdeed3191a8079f5f3638ab48965c385": "Temple Tumble",
  "83cf851ac547dff11f920fecebe25a52902b3116": "Temujin Treasures",
  "2ae92acf35e8e11cd13b90922366e09b217dc23c": "Temujin Treasures",
  "626c4032fbc5687d85e8bc89a9a9f0cfdf191716": "Ten Jin Matsuri",
  "f8974698dbe80a31363ca24f815a6717b02c1b33": "Ten Ton Ways® Goldfish",
  "ed81d79b06a34404990919a57a796785261ea54b": "Ten Ton Ways® Luck",
  "133dff452a0fa2e76d610ff1f0e819ea229c5261": "Ten Ton Ways® Odinâ€™s Gifts",
  "4b0f2da8c81a308c6c822a05103cf01e86366f43": "Ten Ton Ways® Stampede",
  "d6dca2cc197179f22f66053d193eaf69b6944ab8": "Ternion",
  "6e5cb71565f525c7b950b00aeebb1bab66610339": "Terror Trail",
  "0dc0d8d1502743b164202f5a074607c85f332e66": "Tesla Jolt",
  "fa225b314b34136b018bed463986c6e091778984": "Testament",
  "8d44b4bd5537d1c97ea6d3428c0b5661b2d211a7": "Texas Hold'em Bonus Poker",
  "e378bf6776e02f633c6f6814ea5aa1e233ddd85d": "Texas Hold'em Bonus Poker",
  "592460ebee709b4ccb94c774bdd88ce98a4473b6": "Texas Hold'em Bonus Poker",
  "a0a586c7fcacafea8c18b94e157477639c8e9eff": "Texas Hold'em Bonus Poker",
  "50263f8583f211b0101748deb6280b196ba33049": "Texas Tea",
  "eb6ccf1b9e6580f39306dcaa4a991ab1b20dc14d": "Thai Charm",
  "8e77f9e5bd086fb4022698116a8e42b56eca1bae": "Thai Speed Baccarat 1",
  "4807bf6b66aeaaaebf55af541fab7a2d753fb51f": "Thai Speed Baccarat A",
  "6eb7e7664b8ab7bc4002034145f6889c88b7c637": "Thai Speed Baccarat A",
  "c1487b6389d272d9c2588a641419d379f8e8e7cd": "Thai Speed Baccarat A",
  "a56ca841c02a3681de71771f3d89d5e257e11147": "Thai Speed Baccarat B",
  "e0682800250eed6c5877719edc2b9931bee4ec3b": "Thai Speed Baccarat B",
  "e96cd7535942705addc0ab7d06f31c9a7ec77010": "Thai Speed Baccarat B",
  "7d39c7aff8fee96d12d1c51e9ffa6b55945723e6": "Thai Speed Baccarat C",
  "ab5da34fa3c55e6c95188fee96488db5672e5cb5": "Thai Speed Baccarat C",
  "f1d4f3463829e037d7ad502289495ceb0becc077": "Thai Speed Baccarat C",
  "7bd1dd53737e90767752ed195e92322538a7f7f1": "That's Rich",
  "2369b1f48d43a3bb6dd3dd673e2f875de74d7d8d": "The Adventures of Ali Baba",
  "26b6ffad1ebea1b15080cae766916e99898d1ff8": "The Alter Ego",
  "b3cb481599afc840814aafdfe454e8c0bd526732": "The Alter Ego",
  "fbba1d820b5e24145806fedc59fe1f447f087254": "The Apes",
  "9b0cea339441c049c132da116d2e285f99d6bc08": "The Asp of Cleopatra",
  "1e36b21d732397deb3254208d54f2bc334f94789": "The Big Dawgs",
  "4f153588d1aa0fb905812c6ad2fd134f0d371129": "The Big Dawgs",
  "f4a9e4d385895117808bed506a1f6794dfe6d20e": "The Big Dog House",
  "1a067b0254b4a76d17bcfe036d8baed43ed48c9a": "The Big Dog House",
  "b3d3e7f77656a9297b536a04298b4f3c3c937c7c": "The Big Journey",
  "4864e2c8fb44de8671657978e75130a2718682d7": "The Big Score",
  "bdc405f29be965c5e7479c06ba14efccf53b3d85": "The Bingo Spot",
  "2e9faf34b927f7eb7b2ac22b0fe598da22082009": "The Border",
  "7b35f14d7948af75e3d6bf716f1567ce51a9a662": "The Bowery Boys",
  "874fef162b1f5ca9fd877896a3b6a253a3a8f79f": "The Boy Who Cried Wolf",
  "0cf2e3f99dd3ca407fa79d89faad7df5940ed8a8": "The Catfather",
  "6b8b45296411307e44dec78b4d8ec6deb02ef48b": "The Catfather II",
  "8d3a167e39b8a5db347d6a07dd7e84b32b6188f4": "The Champions",
  "a5c897b0c3aadca28d0285839bae4a0f91084043": "The Count",
  "c0eafdf81801b760e9e1c8239d8edaab50537ca4": "The Count of Monte Cristo",
  "4f699205782f3f5174ddb70b4b1cb54d7dc50968": "The Creepy Carnival",
  "8061719cfbbd9ef83a447e2ab127811c6ca913f9": "The Crypt",
  "ec7847aff0f0e94c80f320474381f4dcf6ba54bb": "The Crypto",
  "8640bbf260b204d3682b06b2598e33c490b79065": "The Cursed King",
  "d6dd43c1cbfbf961edae52f3f74090bd167ec453": "The Dog House",
  "13078d187e84f0d2fa83ad3d56cfec22ae4be2f7": "The Dog House",
  "36a79b439b53865f8637975ae00d66dceabc362a": "The Dog House - Dog or Alive",
  "93ef32770fe1cef25409b3407c4cfe4de4dc677e": "The Dog House - Royal Hunt",
  "31806c027c29e069affc721f28b982c97f4b1391": "The Dog House Dice Show",
  "01f6fdf0c4de460e6bd501e564235d767f601a3c": "The Dog House Megaways",
  "a737ce3a363b9095bb13ce514d62eaa601e3a3cb": "The Dog House Megaways",
  "c35db776dc38a16e8913e2e09c0b9fb580383194": "The Dog House Megaways 1000",
  "6ecc1f5e1b71570785a2dfffbc27fbfb02207d14": "The Dog House Megaways 1000",
  "4b5c1f94f56a0f35e44b8333397d0c5ba11f979e": "The Dog House Multihold",
  "cdcc02ffac6f1206d72880d4391381edb74aa326": "The Dog House Multihold",
  "357bb05186f7c4c8aafac65bd2177909deed0d64": "The Dog House – Dog or Alive",
  "d88ac08f674e4a1a4902043519b3e956dd20bb46": "The Dog House – Muttley Crew",
  "6b7151e7ef8adf4636db9edf15cbedb61a1f2b4d": "The Dog House – Muttley Crew",
  "6d032eaadced5b7dc9fcdc31701937fd7a7007c4": "The Dog House – Royal Hunt",
  "79d889ea2a9ec6071202569b3b617c06eea9239e": "The Door Gods",
  "fce0e3001f743d2870d849dd52897dce06a0586e": "The Dragon Tiger",
  "adcdedfc40e1568d3bad7c648dd1d843b82aad8c": "The Dragon Tiger",
  "89ca970913bb1af9a39e6089b9a6e3f1f6af7652": "The Emperor's New Clothes",
  "72b02d33bf60a9568b371bdf8c26a54a9103d7f6": "The Explorers",
  "66d5fbbc83ef393135a1c52d693ef30f3da47876": "The Faces of Freya",
  "eed306dcb296f47c60c10c7a0b6365a8d00d7483": "The Four Scholars",
  "1cb0cf0cb6b08fdbc952ed4ccce84192c7f9c398": "The Frog Prince",
  "52cedc75aba6932f3a7b1bedccd999213bbfb55a": "The Ghost Walks",
  "00044971abce9fd0b85a251eb2923625eb723422": "The Gingerbread Land",
  "c36760ebfb64c0883fc911d4654c71e27cc6d8db": "The Golden Ax",
  "510ba6428d8a19dd6bd031ad83be348a8b714214": "The Grand Show",
  "d3d1b8e6f4cbdde95baf770379ad070b6e7a8b93": "The Grandmaster",
  "cc38450cbf9a4e7a44b6c43930c8a6a8e00fe9db": "The Great Chicken Escape",
  "9be9c64ac605e90b917394e10a415362457f32c8": "The Great Chicken Escape",
  "233bf31d6ff7252a15eb018efb8c95e4c73576ce": "The Great Egypt",
  "12f219f6bf352b91a00d8972ffaf2497d93b14cd": "The Great Pigsby",
  "2e5d9e07116781f957c1f168fcefacf7b9888eae": "The Great Pigsby Dream Drop",
  "ded5588da6c4803a219a801b12582a6e70a8ccb2": "The Great Pigsby Megapays",
  "4e75121cdae3f37902985111bc4e87e734813b91": "The Great Stick-up",
  "24be930e4637e37fb14412854a4992a723b6616f": "The Great Stick-up",
  "d8fa46e87d0e87e568c4ac5624645c307652a39c": "The Great Voyages",
  "0eb71cd82b841a0597cb17a62122f42e70bd6dea": "The Green Knight",
  "156d31099fa8cdadf127e8d0c407ec6cc1b3199b": "The Green Knight Oath of Thorns",
  "24b728b7b9fefa58a9369762ada2413cc562feda": "The Guard of Hades",
  "961df154c99dcc6285de516c7a68ffc51bce9bd5": "The Hand of Midas",
  "1bb9eae02ffd9970255355eb5e8af5fba9abe431": "The Hand of Midas",
  "38f3616db833b17966df0604feb27d09798b8276": "The Happy Prince",
  "740112c6c2808da06c9ef466ae1e7a622e2325eb": "The Haunted Manor",
  "2494d63c7af4e0a162ea36219e54943a7060e3de": "The Jade Path Hold & Win",
  "83cddab254bb2298ba452866eee953ceac70df50": "The Jungle House Win Ways Buy Bonus",
  "31ac0aa26143588090833463d8d97624ef8f31e4": "The King of Dinosaurs",
  "00b079b98b3517929bff359ffb7d9f9333078770": "The King Producer",
  "5df2a8996439d4ea5b0660c39c0e7667b8ec7464": "The Knight King",
  "5cdb8d62e90b8135fbd39a6675cccbddb1866fb2": "The Knight King",
  "359d6b5373d048c40b40af2b754fe47d5504668b": "The Last Sundown",
  "c310a94638899027594478266846b6dadb4f9de2": "The Legend of Heroes",
  "a3c5056f9fc7192d7c95ef0cad83481d1b50bd9d": "The Legendary Red Dragon",
  "8cb9924750f097e6038d153a3b35cef40d4ba09a": "The Little Prince Lock 2 Spin",
  "a6a29ee39ff2ea39ce2bb3a965ae0a105d2b7edc": "The Lotus Lamp",
  "e3d3752568b6f412647c4f3de37577bffe9aa405": "The Luxe",
  "156ae03035eb42f14a78af2b63b729b2ecadc601": "The Magic Cauldron",
  "c69358b96df025dbf94dca72e58fd669d3828144": "The Magic Cauldron",
  "dee56cd7f2b7575fe6e1611abe19c9abdb733b44": "The Mask of Zorro",
  "e03171859290e3f7b45ef9fc8d7d47e24172e8b8": "The Master Cat",
  "ae6cf53a85eca298548331c468287b0def406f1f": "The Mighty Toro",
  "535edba85b61774483658fe887c07e8432f767db": "The Money Men Megaways",
  "8e8adc0b2ca3b23a745630fd568a51095131fc75": "The Money Men Megaways",
  "423d0308113be85f4315f26554036bd2b674ede6": "The Naughty Tattooist Buy Feature",
  "91bd15e99afd075ca7be6875f830a4de8ed82413": "The Night Racing",
  "c95f85346c3b8334396bba8973770d334ee12a1e": "The Nut Cracker",
  "99aca541c522ae7784033ddfe20c4e6100d32fd1": "The Paying Piano Club",
  "6904efca6f6212714863f5299b5c4ad420430575": "The Peony Pavilion",
  "c06c590140e5a867a5908858ab0c3d859c2eebc0": "The Racaroon",
  "07b079e833e5f9eaeb187ada0e2452d8c09adc32": "The Rave",
  "f482871b50c6d41c06670b8f9b3d985205922594": "The Red Queen",
  "ac063ea0b126e5932129f8a5bbeb0feb30eb9c89": "The Red Queen",
  "0e8ce680eb856b7e9580feeac13f5da8de671d58": "The Respinners",
  "30a16c91bd50c38c65415d1990d0f2a28e8d02b0": "The Secret of Ba",
  "5546bebdaa730067b6edeee042c5e0778939d566": "The Secret of the Opera",
  "2c106a767ed0657ef6f284b9c60cd543f33d290e": "The Secrets of London",
  "e2ffc80cc81e0072c71fa0fc03f1ca86527450e8": "The Shimmering Woods",
  "c9725f8c0dca1f34a6a5d583b348cee7e94ce33e": "The Story of Alexander",
  "ffcf4f3b07bf132845aa6b9495b64329d0c6c881": "The Story of Alexander 2",
  "76d3a1db0c61a174b2656dc37c14400145e2a941": "The Sword and The Grail",
  "066fead60ee89ea0d4aef797c0f5e8fe30d3ed23": "The Sword and the Grail Excalibur",
  "2bd5089ca79ad6cda93e97cfa5c407acb6a567ac": "The Three Musketeers",
  "90910f305031b0c49d2e0c0db7fb1ed53952ccfc": "The Tiger Warrior",
  "8fb30181eddab7631633da873445d4821bf3e924": "The Travels of Marco",
  "e2641ef9f7b3a5a8d5f45460e270aebea69d21dd": "The Tumbles",
  "086d45e73c77bcd7d7dd2e9fa519a4a5527a2666": "The Tweety House",
  "90368a15d44b81987274a95421b0150ee9a12f3c": "The Ultimate 5",
  "839980e6374892748bbd8caf3e006c5e6674fe74": "The Ultimate 5",
  "52d23efcd3cb34fa35d9fa63bcd5c52483f3575b": "The Walking Dead",
  "e229b98e8663d107a6546ce0c882f917e9134160": "The Walking Dead: Cash Collect",
  "844e7e8edcd045b3929e3a9b8e5a344eb6d82f59": "The West Chamber",
  "c91400086e30cad42d8e5432ce60f3609d0a3905": "The White Wolf",
  "4e1439b9600fb1852cb45dad4f2df113bb823551": "The Wild Class",
  "2660a9bad405fd1fa2e4a3be7c3a84efb47fdfd3": "The Wild Four",
  "09bc99ee6e6d1c36c13bd4b13e999dd81982626c": "The wild Gang",
  "cac88e7698b3bf1574f1dbaa95618ef692e786b5": "The Wild Gang",
  "55336b820803a70d85f74f4862e2943c67de5da5": "The Wild Griffin",
  "6151fd2a1761e6200e213e47df4d1e06cb62cddc": "The Wild Life",
  "00d8783d45648dd751ca5b5afaf9420a7346882a": "The Wild Life Extreme",
  "4c9eb08ec6f4fb92000fbaba49f942ad7872a226": "The Wild Machine",
  "1a0948c74bfa380bcbc07bb7fb5a7c7ef7c7712d": "The Wild Machine",
  "db7b9cb38f0bd2b17c19eaba9bf14237349df34f": "The Wild Wings of Phoenix",
  "8b25582a30e3a54e5af74fb71a34d463891f5d23": "The Wild Wings of Phoenix Deluxe",
  "8de8a183d9a4ab4c8ec114d858fef467f201709d": "The Wildwood Curse",
  "854708551429bf0583c9800728206aa24ffbd854": "The Wizard of Oz",
  "23f08c14ddc4cfbff734f2daa7e835fd7f63e6a2": "the-wiz",
  "fc6dc1a2f47fcea28e44672ca95a51c8fc97f8d9": "Theatre of Rome",
  "54acdaba630026f8fa8fab27573dd8aa813ad8dd": "TheBigDeal",
  "40264d1f584087c50bbff7131cc9e07238c5bd66": "TheBigDealDeluxe",
  "edeef8e155b173181470cfb28d59a37afd62d9b8": "TheDeadEscape",
  "98fb9914d7a6f98ef6b13f338598333c815a55e1": "TheDragonCastle",
  "dc3cabf9b7ebcb010e366a03c23eb516a21110bd": "TheKoiGate",
  "553fcc812890d098085fe49a0652f265b8ce37e5": "Thief",
  "c27ea76c6f0368a5c5dc4b6601bb477420d72f55": "Thief Dog Buy Feature",
  "3553184996a88665bafa41c621164dd26c04445e": "Thor Hammer Time",
  "84f58fdae2d9665570f4245da4cf5311d5b82da3": "Thor Turbo Power",
  "3d560882ce620acf7cf6036187d5acaccdaf79d7": "thoro",
  "bd542fa2b5579d86647c2c933a24a5f523f7ecf3": "Three Bandits",
  "594a93096610255cdb24e694e2cb4c3bd9c22fa3": "Three Card Poker",
  "cc371b1c1fb490bf392445452c60a751e894615b": "Three Gods",
  "706163067cd3837013ecffa3ab058a37caa6abc5": "Three Heroes",
  "55da4b005815aa974dc5fb31a9bae59c3a03bc2a": "Three Little Pigs",
  "3b732911a74a461fbe98e39cc426230d773df7b3": "Three Star Fortune",
  "d0b9f2643b029f0ea4cf3a449bcf77e8eb4226d0": "Three Star Fortune",
  "c56afc495cfdd8f109b10a81b88d46301bb1f896": "Thrill to Grill",
  "784319076b82eaadd57aec0411320ff94542f1ec": "Thumbelina",
  "30d719a73e25d0690ebb954d67b8d6e75a69e596": "Thunder and Love",
  "ab04a817906b23bf851bba8fc60a91e38c02cc14": "Thunder Birds Power Zones",
  "61d4f249c9796ba430517a54c615b2cd4f831891": "Thunder Cash Juicy Juicy",
  "8e0fb8296d138b4f609fc9cbee91f08a495f9715": "Thunder Coins XXL: Hold and Win",
  "a3ef4db7f028eaccbc2c1e442abaec473e04a969": "Thunder Coins XXL: Multicoin",
  "b55e61eef37b971d8c6f1a22372ac7b53c041d07": "Thunder Coins: Hold and Win",
  "07c0f0a327a5ff6a2830f1022c35782f21bf78ed": "Thunder Eagle Hold and Win Extreme 10,000",
  "f2fbee5cba423ab49b3839fe3b45c5fd32a70957": "Thunder God",
  "3f4d1bc902a49d585ca713bbab342b5cdfced446": "Thunder Screech",
  "1acd555aec1f106ee23151980f9c3f7da62dd146": "Thundershots Fairy Gathering",
  "31ea60a3fa1cf671eb56a940e1fafd9e7145cda6": "Tibet Plateau",
  "97316f3759745c019aad486833ce66b544e8e305": "Tic Tac Take",
  "ce09940948c8746c4be9469fc1e91810ce044ab3": "Tic Tac Take",
  "0fe736a9a07cd0c912672b0f4c407861f996a07b": "Tiger and Dragon",
  "2a59f375707e98e7de758e86267c2d0d5a15fa4d": "Tiger and Jewel",
  "ebf5ee1fb321afdba20d2f25a2aa2998cc8314dc": "Tiger Claw",
  "9295adb70d9baf9ee389784ad7725f5d51341567": "Tiger Girl",
  "4400975313873d79f500f6bf0d0c6d19c1b207bb": "Tiger Jungle",
  "fea6fdb270a92cf493a3fabd06df05dff88bcc4b": "Tiger Kingdom Infinity Reels",
  "a496dee6e33ae090314813d8aef79a12c11e32ff": "Tiger Legends",
  "f60c5b82e06d1aa1490d1a12fa9b851a27f2d778": "Tiger Ventura",
  "4e957d457c0d10f5f98113e75f3acd3469f4e3a9": "Tiger Ventura HIGH RTP",
  "8bec31c84a54aab8716aa0f1f817b4121b0db4da": "Tiger Ventura HIGH RTP VIP",
  "d15600fbf957dadfdf2d4f788114cb590281663e": "Tiger Ventura VIP",
  "8140ad1bc65c0ee51c9a66effc27a8b664c3eff5": "Tigers Pride: Gold Pile",
  "e64d9f44f210125427a0ad5695ab8c8dbb91252b": "Tiki Blaze",
  "e96685e64be22a7274566895879e2a71087b028c": "Tiki Goddess",
  "28045a048dfbdd60173d8197665423104d87390e": "Tiki Tiki Boo Boo",
  "99ace070ae568913d02c86fe416e589249273862": "Timber Stacks",
  "b6c4feeeab3a70f0ca7f282f2e434d44a0cde1e6": "Timber Stacks",
  "c79d112da91aec8a7aaf327831ee0052b7845c6a": "Timber Trail Treasures",
  "e70ba0796e046f05136a2a0a7fca0897418160a7": "Time Spinners",
  "26e3f5473280722bafdf5762a3e1432c15741744": "Time Travel Tigers",
  "18329cede9fcaa85fe8584efd008c62c170feb0d": "Timeless Diamonds: Hold and Win",
  "1ac58dab84abfa08fdd2ffde789472c6442a102e": "tinkerbot",
  "88397ee3d0f2aca157971257b2d80d5c061d72f5": "Tiny Toads",
  "71b5f8c3cd63ec07f17fd6ba8a634ae9cb727e22": "Tiny Toads",
  "e64915ab15ac52ce3783ec670600589b25942ed7": "Tiny Warriors",
  "8ed7420986f0dc8a40d833a21baa9fd7fb83a528": "Tirol Fest",
  "15991fa6ca4f0bb17f11afa5d735988eb944951d": "TNT Bonanza",
  "e7de26fb8899179020c16395d6b2ee23d2bc237e": "TNT Bonanza 2",
  "bc9b01035d57ec4a1c5e9cf017e83490ffa642ea": "TNT Jack",
  "f3a79143827a9fe7838b26170b8a4bae88637d30": "TNT Jack High RTP",
  "ef7111bef8a9ce860256b4bf2bf08c0c58a3e8ca": "TNT Jack High RTP VIP",
  "3132af2f8a28021c41e6398ff56b251853c5750c": "TNT Jack VIP",
  "ce38980fe3d2abf5d3b9058a022551fb302c579c": "TNT Tumble",
  "ca383394ac29c3fbb1d228c0be03c17d6791fd72": "TNT Tumble Dream Drop",
  "f3fe1e284b4470cf17507e8ed5a75f024260784e": "Toad Super Pot",
  "566bf63b6dbafd5fd882ab0fcd9b7f00b33ca6e9": "Tomb Heroes",
  "fdea47f74258066ccb2bfd1b2420569cff503922": "Tomb of Akhenaten",
  "87b860609ca05f91abdc43f7d74e5aeec2f50823": "Tomb of Gold",
  "2ad653b20964e87c4887d7eb13917f36fb27a270": "Tomb of Gold II",
  "252814e8960bf22018c3c5d9625f5c5a7152343a": "Tomb of Gold Reimagined",
  "7b67fe35f51772ec91e217e9bbf0a0a591f83c4f": "Tomb of Nefertiti",
  "b941028e124b4cdcf9ab11b42ffb9f3b8f589aee": "Tombstone",
  "9a6531ad0022ced06bc576fc14c66e08cf4e5288": "Tombstone R.I.P",
  "39e0cfea7b5a4b040c320627b895fa0ea64e8a26": "Tombstone Slaughter: El Gordo's Revenge",
  "3a7fc9af8f4778d452230366789f9ec1dc83a75f": "Tombstone: No Mercy",
  "03856ccf37d8246fa3af9abdc711c49ccc8f25b2": "Tome of Madness Bingo",
  "5ac1f14fdb755876cd59b56018a766292a3a88eb": "Tommy Gun's Vendetta",
  "aa20025aa40d5c263767c1de81634596ae987070": "Top Dawg$",
  "d0c624e82dc6b3111564889155bc2cfe640e89d9": "Top Games Lobby",
  "0cb655afa1186d20d6a79e4aea1cfe2a8e72ef3f": "Toro Amigo",
  "78e29474ba7186cb93ef1677c5d133ad280ebced": "toro-7s",
  "d1a5394e4b6a6064a226adf966bdbaa3b035bc33": "toro-shogun",
  "735053380dbaa64fd9b7a8cc7cecd28f7fb648ee": "toro911",
  "ac9169bb1cf6c3a020e72586ad0a15086e9e737d": "Toshi Video Club",
  "1baa1d698aa61b9c5b57fc3c4582fe17ee53a910": "Toshi Ways Club",
  "f5bbc7c8d41541a0978a3a4d9eb8eecaa6121e33": "Totem Mystique",
  "4e2c5b224d77eb65a567c591e395df8d9a15d917": "TotemTowers",
  "baf28183c3e1ea5d90dbf60dddfc96abab6d0eca": "TotemWarrior",
  "a910507d74708574766dd301b25f4adc29b20239": "Tower of Babel",
  "b177ecc54df6383988829ba3e3e219d883c43aad": "Tower Quest",
  "d3602bafaad118d2da205dd641745f8168f43616": "Tower Quest Legacy",
  "55fb1a72de9095541cef9437a3a2deceba707084": "Tower Tumble",
  "0187ec96a10fc17df3aa3740e26e70126b3ebca9": "Towering Fortunes",
  "78d3b966f7feb9459cadc1b9da976ee6f05be030": "Towering Fortunes",
  "6dfc1dbb54426eafccda22e4af0ac19c3d763d10": "TowerOfPizza",
  "c5fa5071bb16a5d752599f76db88580015c24ec7": "Toy World",
  "5531cfa7b0a9c57afb2a55df10e6f5801a9ab10d": "Track n' Gold",
  "dea78b9e4ebbb1741f48765b85e76d278ed5ff3a": "Tractor Beam",
  "2cb12fa47e139a111fbdfdd0945a6dbb59014bb3": "Travel Through Time",
  "bf9c57983e41b6e84c89d576586b96401eeaf0b0": "Treasure Bowl",
  "f18ff1b72d8e53abbcb8da9e7e33350eac648885": "Treasure Bowl Megaways",
  "34e7b03a16bb1fe924da659752f6dca5bd0bbe1d": "Treasure Bowl VIP",
  "2728d67657520dc57ac1f4b98ba7933e74fa8d03": "Treasure Box Dynasty",
  "bb2b66748d3462d5de8a7b4d68e7cbcab19769d7": "Treasure Carp",
  "a98160af20aca80a675f0e224bb79d6fa0f78761": "Treasure Goblin",
  "227d4f27980c5e07d6bb6568026ccf276e716acc": "Treasure Horse",
  "a85d876c2dabb5f0d5aa3218ad6589cf83060002": "Treasure Horse",
  "c8ff4c1f3c1b02e600d5bfa7adf94bb00af5cf8d": "Treasure Hunt",
  "263eb265a51e9b6f3579a13b068622d08914dbfe": "Treasure Island",
  "c4de979cb77cd3b1f27751848d79ade13ab51ab8": "Treasure Raider",
  "d833a54e37062fea5c35de7c87beb7af2d7f1848": "Treasure Tiger",
  "e2b5811996350c016abbea6ae68fba7109bf0c48": "Treasure Tumble",
  "1c57454b489b47554676e7bb88b646296efbd75d": "Treasure Wild",
  "103eb90fcc3ed552805bf1eb132ffe4b82f24a60": "Treasure Wild",
  "ba4c72b3c99afe31e591b7b636b2f61876df57c1": "Treasures of Kongar",
  "0094b12aaeea9baebaf7b5ab6ef23cf058c85e30": "Treasures of Osiris",
  "0d1bb5d22ed59d1504c93d342c4455afda3acdf3": "Treasures of Troy",
  "ece9357a0efa94454bcc788348b82fc703dca601": "TreasureTomb",
  "c63edfbe2f756bc89fe9ce681bcbf235e86fb448": "Treats of Terror",
  "a8b59ea0859eeacfa786249e2338a49891031999": "Treats of Terror II",
  "c7dec23071502870d0898b87ecbf7a73fd8c576a": "Tree of Riches",
  "b252325486d868f09fb0500a80884d694ee1196a": "Tree of Riches",
  "c945e9a9b462f2a01293cf64b35fadc2b772e340": "Tree Wishes",
  "420f463e27e8d1b68ecea7d38ba68e04f82b73de": "Trees of Treasure",
  "d61a88b2cc5e5f2f4ab6ae463602d4c68724d09a": "Trees of Treasure",
  "925c1237309baf00014fd230d3a803a95d0a208e": "Tri Piki",
  "74d2b09a6cee2e95f9b42f988936c30bab1f878c": "Trick or Treat",
  "56beb0166d69ebe0a3de2273e6496e3e49384abe": "Trickstar Spins",
  "1045b493609d4e5ff24d9d922cd24cc0d73b42b6": "Trinity Crowns",
  "398a11b53438fbf9336f9f13a31a5eec725a03ab": "Trinity Impact",
  "16641770825fb5eab6f02dbe9ee33d01ad36a75a": "Trinity Treasures Wukong Buy Bonus",
  "6638662b3e36107d8bce6fc36c4158ac72e4bf3c": "Triple Card Poker",
  "c9808cb028395c078a4ca4cc8054872a8903946b": "Triple Card Poker",
  "eca9f139470401b778e6189f3e1796138f9a6ae2": "Triple Card Poker",
  "ecce8d958ffde93ec3547d49e1ef18cb5e3e80a1": "Triple Card Poker",
  "9b328b1414d09124e26da705c038ea5123c4ab7e": "Triple Diamond",
  "ba43bea08117989902eb9f3bb3844e7923e90522": "Triple Dragon",
  "352cc6eba762692e45fd112aa9dc8898def516ac": "Triple Dragons",
  "53c69237357b11abc849a5ce0553ea796379422d": "Triple Dragons",
  "180da6ef31789b86864bc929dfa0e1cdc646432c": "Triple Dragons",
  "cec1a8087b9ca548c7b46aea90d378db80d72af7": "Triple Flame",
  "1c75ec775b415535475508a39f51f397b33328bc": "Triple Fortune Festival",
  "df6ac225b6914875e076349800df145c5b3a8db2": "Triple Fu Lu Shou",
  "53ca0d95c9e4ccb7322306253d11918c67ae681b": "Triple Gold",
  "ab3d086a2ae03ea1f6225d26f53d9adb75470ce1": "Triple Gold Bars",
  "be038bf9d62cc05ab70f0a279ae7e1776a21a722": "Triple Hop Pots",
  "516135ee36831729b5ebcf7bf5057cfe9b79fbb3": "Triple Irish",
  "23fca874809d3fb0c446d52c1d2c41e463b5371b": "Triple Jokers",
  "6c225eaa6ae79a758ccc48169c7bed3535ea5a45": "Triple Money Jackpot",
  "4c514f7505c5c6e6f0fff2624f3b618e3582c5ef": "Triple Money Jackpot Bells",
  "1badc52317cfa85a76d67f63803a29f35ef2f140": "Triple Pot Diamond",
  "a5d835f4fb7302ba9a6f93759b07951f64abbd96": "Triple Pot Diamond",
  "62ecf2e03ae50d94a78abcc40ae184b96f1efa3f": "Triple Pot Gold",
  "bfba05d6c94cdb2903c607a1205f811fceb51a22": "Triple Pot Plinko – Hercules",
  "18218b0727d6b81c4f5c8e171f93b70056be4fbf": "Triple Red Hot 7s Free Games",
  "9d9f73ad5baaa86f98198f89800277aaa6a36944": "Triple Stop: Hercules Rules",
  "f876ba7434f74ce9eee27dc915572bdf767ef702": "Triple Stop: Mermaids Find",
  "7d5e595ab7a69099ab5e7ff1befa38e893d6ccce": "Triple Tigers",
  "51d8c18723a500ee607393ffd250bbba53a37d50": "Triple Triple Chance",
  "2ceed000761218928d61a0acd751c572b3a38fe0": "Triple Up",
  "68a6fb135a32b1975f7ecd8c2ba1e491fcd0fa3c": "Triple Wild",
  "1a5518e59e5dfa13520017845a9f1999624036e4": "Triple X Hot Pepper",
  "5969457cf29048a7f62254efc0b2bf603b4122b3": "Trippy Mushrooms",
  "660620a95b4167808d18a827e96d707e4ceb1e35": "Troll Hunters",
  "003b45389b1b65b81227918514c181178a233a6e": "Troll Hunters 2",
  "b59c92f5f35e95ebd1d9542706067047d51491c2": "Troll's Gold",
  "7cd34390762e5da169b57146bb86c1e2f20a20c0": "Trollfufu Bonanza",
  "09a06ab6d72db7c5713ce9489784bb8931e9ca41": "Tropical Beauties",
  "2391e143471bcfd05ef325fcf9fba018390ba8f9": "Tropical Heat",
  "e9b30a498d488adcd99f5820adb6e7d208fdbeca": "Tropical Tiki",
  "86d6b10c1d68864f61d1eb741987034785646f15": "Tropical Tiki",
  "04ce6f4efcbb982b920b84c4f2bbf6bac5457768": "tropicool",
  "28f4de68636219fe102a2b2e14fb10c25b60d91c": "tropicool-2",
  "4e0cbcea2e9e9f66b479ff8fe197e5e7f8715293": "tropicool-3",
  "83dcaef77b59e80896ca985e82f11627e083ed4d": "tropicool-4",
  "3a8fe793d25e566e5936b7b01c759f90a40c9381": "tropicool-5",
  "55e36f5cd4899ce47059957274af9b78d65f3554": "True Grit Redemption",
  "a38143d3d0e199e2f4e7f585734e6e5c6d56003d": "True Kult",
  "0c8175140e9598d0216d09ed28bce3aeef8ccf89": "Tuan Yuan",
  "1266ad71ec8b10050f252ad21f4abb42a6a68808": "Tug of War",
  "bd7bf6adfcec38e62f459b9efafa5a4007762e1c": "TukTukThailand",
  "f9c7a4c188e38f397d91e05377209617e78fb681": "Tundra's Fortune",
  "b2b1b6cd5b5e72dd3e2f8219f0ac62ee1834392d": "Tundra's Fortune",
  "82960c183c4fa68589b8266eba372c115673978d": "TURBO 27",
  "4d9e5c4f76b8168c69c8c96b33f8d53e6342a204": "TURBO 27 DICE",
  "7442756af88a265d1cef2fd24a298246c3130ca5": "Turbo Baccarat",
  "61871c4870cca238c5f8de46bfcc28b0cd4648bc": "Tut`s Legacy",
  "066e4a5f1e5f6b3253e6deacae99896ac791fdb8": "TUTTI FRUTTI",
  "07c6be64a82b92e2de7d0bcfb56b6a2467ebd33f": "TUTTI FRUTTI DICE",
  "9689d48ce94e07c5d3cd71495651a6371c8757ad": "Tut’s Treasure Tower",
  "c2517b7f90157a6ffe076121ac0d6bad39802216": "Tut’s Treasure Tower",
  "b771fb78eca0c54f2b0ebce56452905ad842f0f5": "Twilight Princess",
  "befce727a94d1991ceda81e5810773e197fbb925": "Twilight Princess",
  "45c66b021ee5e9ac0166c254ec20860564d05b8d": "Twin Harlequin",
  "b5155fb465e61b1b1eb17c2a033a6a5085e14bbb": "Twin Spinner Book of Ra deluxe",
  "0670bb969faef7ddc3d9239a78dedd7e7602d71c": "Twin Spinner Sizzling Hot Deluxe",
  "6c9af9d1e807b4e90acccbc88f4a2b4766d9cf31": "Twin Spin™",
  "900295c8ae5a38afa78189e73da32de44396aeba": "Twist Casino",
  "2e3e40448e90974ed7c8c54421121feb7b4b92c0": "Twisted Jester",
  "7cbea14778c4d34612e89d2b81ebb7df6db012a7": "Twisted Lab",
  "f18314f0947e244515a30e77fd92f9acc5d3d16f": "Twisted Sister",
  "3550bc000cf71aee5d7b212b30370e22a09d9fa1": "Twister",
  "d7b0d68d004a0bfcfd51ac541431f2246ff1f4ff": "Türkçe Crazy Time",
  "296181e64fd05039dc650d5aa4f37d74d462582a": "Türkçe Futbol Stüdyosu",
  "5c888e63808bba4b9a1cd132eb09d6cbb7aed56d": "Türkçe Lightning Rulet",
  "594231ebd8b382f5a3b62e55cce5f2823c75a00e": "Türkçe Rulet",
  "40083cb44e50ae87230f4a46f5a0d053cc604635": "UFO",
  "9d3894d62be360d5c5cbd31990a2eaadf83a22b5": "UFO Hunt",
  "7d576271a7b17549ed03e4a862115db5f8c3545b": "Ugliest Catch",
  "3330959badc16ea0c03e1bb676c44cc53717469d": "ULTIMATE CRYSTAL",
  "8c1b43d62d23cc93c404099072a7101931f2fbfb": "Ultimate Fruits",
  "9b436d61a507a7479c024052dbef95d133dd0ec2": "Ultimate Hot",
  "09cf792cc80d8064f605037a4de7e45e64089b4e": "Ultimate Hot",
  "9c642021d89b5f059dd1c93baac601b808d82153": "Ultimate Slot of America",
  "22b8771e11306eae82a7a1c245d66ed06f2b3b61": "Ultimate Texas Hold'em",
  "393fc2ba04c4468767e242dd6b4856d31b9172b0": "Ultra Blitz Chilli El Toro (Buy Bonus)",
  "fdc0b51409bab1815e16a0d0fcc72fd1842a2dc3": "Ultra Burn",
  "49529c055985094ce244baabfc4cf1db9659a12b": "Ultra Burn",
  "d7f38981dd79c60ce5155f4948823e9be43163c9": "Ultra Burn Dice",
  "d75b18d4a1cc0ead549d10759b06a78092b1f767": "Ultra Burst",
  "246ed0bd152af403ceb8cabeca1d81138ba1ff6a": "Ultra Disco",
  "835a022bfb47a2ec47dfcdff14d8d3561c191984": "Ultra Hold and Spin",
  "29e0b129cad80b167f85f66a395eb47658d468d6": "Ultra Hold and Spin",
  "680e72c7fc366937886d7126d8c0822faee85537": "Ultra Seven",
  "c7e02f6f4f9450270c85c440018ac7a2abfd72c2": "Un D├¡a de Muertos",
  "a755e5ee7e5576cd1a3603253edf725d6043308f": "Undead Fortune",
  "4a27dc3b0756b4263ea0214155f00762c4e660dc": "Undefeated Xerxes",
  "3b890eb7d19ad1d0838f8421e6c2ee498d5314a2": "Underwater Treasure",
  "a0e59e775a6b4bd30390e822f40bc8db1780deed": "Underworld Empire",
  "fa823834076cf511bc5321a8bb4ea0ad88465089": "Unicorn Party",
  "ab5e52e2131b4f8d0805e65a8e5d618fba840340": "Up Helly Aa",
  "6b7fffd8e4b81698e9e8019b2b7808aa8e92878f": "USA Flip",
  "44879c30da0a2e1cb7c10790423432860fea3cd8": "ValentineMonchy",
  "c33294f993ea8e068ecf0cb115a5854c9b8f8314": "valhall-gold",
  "90ac94d6070b387688ff035a777a88d8a3980272": "ValhalLuck",
  "41da25956686be89c9da6029d2f425bc1bb1b924": "valkyrie",
  "f4173b6d1aa1fdc944027d2f96cf5395b47732f0": "Valley of the Dead",
  "c3bba3eff89dd707b3e7ad94bd9e5acdcb2fac3c": "Valley of the Gods",
  "a61152b18f55a242b005014706d45f066c84627e": "Valley of the Gods 2",
  "ee1b9769fcd82dc225626e064e3c8ba7b6880850": "Vampire Beast",
  "5242474249bea41eac8373bc78f78672c808fafd": "Vampire Dice",
  "ddd6aad391a0df8e00ab615084b47402fed34058": "Vampire Joker",
  "740e5dd3cc15a2c906ba7fb0944b8820967f06f6": "Vampire Night",
  "57c198bb8c6274260aa43faf84495f1d591408dc": "Vampire Night",
  "9dd003f50581e26cd16dcf9dc16ab495a02e8c60": "VAMPIRE NIGHT BELL LINK",
  "f38613c884c55796992f465624059c253ca4d13e": "VAMPIRE NIGHT BELL LINK VIP",
  "0977da5204e9616ff85fd244dd420e043c296730": "Vampire Riches",
  "0977a934a0ec78874f9e408434c5bebdf0847d0c": "Vampire's Night",
  "89f32c0652fa0ac0ad22a85d6c18d4bb2ccfb7c6": "Vampire's Tale",
  "d12f4bf122c803bf7dde9aad16bd62ef04182bea": "Vampires",
  "b5991fa0f2e34827ff742cb91566be8fbce73b1d": "Vampires 2",
  "d909c1dac17c89fde9a1530aa47fa3f44b4bee46": "Vampires vs Wolves",
  "7aac09a025d92b582ab6d3d5f61ca1780972ab9e": "Vampires vs Wolves",
  "f3955330b7c79ce9882a480bcdb87a01e43fa07c": "VampiresFate",
  "8a2b32e1d57e8500701ed811132bf09823740cb6": "Vampy Party",
  "3566aaf65e127bc649cd7c93d14e9fcdce0a80d3": "Vasco Da Gama",
  "cd51d4c1d833cbfeb1815657d3a5067d4d08a2dc": "Vault of Fortune",
  "61a5d97ecacbcf92ae0498a5361a91a465892277": "VEGAS 27 STREET DICE",
  "7cfd2cca698a344b6eb6d99c25d67bd187b1546b": "Vegas All In",
  "2a3cb0828d233649faf82306f9ccc5b669b87446": "Vegas Glitz",
  "7833af39ddf04513c7141b949c9de7c8b698bf6b": "Vegas Magic",
  "688585e8a6dbb96635c8d320064b873203315feb": "Vegas Magic",
  "2e9716190607ea0814b78010ee05aaf8c83ffd5c": "Vegas Nights",
  "dc608d247e11956b5918b0ed7761c54e487059d5": "Vegas Nights",
  "d8bd192d7cbda15232ce31fa19def261155134f3": "Vegas No Limit Wins",
  "8038e595ed572a1b7c3833f11f34aeffbb365952": "Vegas No Limit Wins SE",
  "c17dffd7a02291e23bddb91e7244cfd9cbb7a8cb": "Vegas Repeat Wins",
  "273ee28420ba255b96cf01ddf6b0538fe9a2ac55": "vegas-diamonds",
  "d70035b772e9a18a3b007c0652b4fa40d021631a": "Veggies Plot",
  "77917fe0f655cfc4d73fe6c6c1165bf481ea3482": "Veils of Venice",
  "a061d9293859edab492d8905ede3a5d74d64323f": "Vending Machine",
  "5b7af4e4a0aa5995a2fcb31c296cc80b2f381165": "Venezia D'oro",
  "ed242b21d87ee261d8dfb4157a0421fc845f922d": "Venezia La Partage",
  "ab339cc7d85931b5f14c17d86e445cca7768fa82": "Venezia Roulette",
  "049bb1cd27e05233bbb1613ade83b92b2161335e": "Versailles Gold",
  "199b738ff2f7e4035cfbd3c4660c0d02762804cd": "Versailles Gold",
  "26b8faf7dda953cb25a5a1e9dd4b2c3feecab47d": "VERSAILLES GOLD",
  "d300e846067ff4c52371f2eed8ee6117c4d52bb1": "Versailles Gold Buy Bonus",
  "21e3940e718af914e57b8d2dde8a53eb1c4fcf15": "Victory Horse",
  "00ccd029b40386c496f7ec09367076239f94d656": "Video Poker",
  "5eb2c1c7c8072d786cc25f0963316d683ac218c1": "Video Poker",
  "ea36c45c8dc82738ddacc36816b1573012ea6768": "Viking Crusade",
  "f4d7f78636c246f3de0085ffd51c48ba3dcc1462": "Viking Forge",
  "a1c972c742b959054eed8dc4c89f9785b9bd9d43": "Viking Forge",
  "cd0e29bec1939bd5a802433e519938a7afe6bcb0": "Viking Rising",
  "d788cbcfacc2952863941b79078f2b6aed3d02d4": "Viking Runecraft",
  "602776115ae4e13e9d6179cdc8e70d35c26b1d5f": "Viking Runecraft 100",
  "01fb36b54cfe8d3ce84ccf9a78fcb2af35571dce": "Viking Runecraft Bingo",
  "f157c6925a96f7d7396d871a16991690300ead53": "Viking Runecraft: Apocalypse",
  "ed89d63fc1c71487510e4e36d5d09c35f975d611": "Viking's Quest",
  "493fa33cea5d2015b72c59a544296ea52a08deb0": "VIKINGS",
  "a39de029f2e630d27d99eacaad6b955e3c484d00": "VIKINGS 2 DICE",
  "af18eff5c028e2d526cde5be70e546af45810d41": "VIKINGS DICE",
  "4cfd8636192d3c71dc0f9e020cde5b00b7a5d0dd": "Vikings Go To Olympus",
  "4855834f2a2870c30e5056d62854abbcca47ce12": "Vikings go Wild",
  "b76dc3df1283644b6f5334b214d96f74e2d9b2a8": "VIKINGS II",
  "cb959e1a08232789176e5dbb1c781c76bdd89ac0": "Vikings Journey",
  "8da884acf61e7cdb67aa219a55d95e2c9960c676": "VikingsPlunder",
  "00138e38684908ab142e84a9c1a65c06519520f0": "Vip Always 6 Blackjack 1",
  "69ebc153e84f11840cf5c67d38e3a5d54858b0f5": "Vip Always 6 Blackjack 1",
  "ba150206fe10083f1aa57d2d6e6d10bd5f141350": "VIP Always 6 Blackjack 1",
  "85ac3e67cb3f3f812e6e12039b4787ed742e18d3": "VIP Always 6 Blackjack 1",
  "51943dc9ed1e555285d515bf2469e157a8b454e7": "Vip Always 6 Blackjack 2",
  "aade7d322b7576158b2d5cfb67f8dff3f3fdcb51": "Vip Always 6 Blackjack 2",
  "8e17010fbcd432b7e082d90c9f5cf0b9bc7eb6d4": "VIP Always 6 Blackjack 2",
  "9cddf115d6390a9b10a75e8d957a5732027c0ad9": "VIP Always 6 Blackjack 2",
  "5ed3dd302dd6efab7074cbd0e3f3ed04be61fffb": "Vip Always 6 Blackjack 3",
  "a868dd5c367a8a61fd64d74d58967d373b20c24e": "Vip Always 6 Blackjack 3",
  "e2fbbafd32442f385e1723fccc5cfb70781e4e39": "VIP Always 6 Blackjack 3",
  "7d97c39e6c8538dd313b7d7dff5b4113321bd0f5": "VIP Always 6 Blackjack 3",
  "e4be176f10c53b1a1497ac87f6018e13a3f9d8d9": "VIP Auto Roulette",
  "860165e503c02b8b19f27808523256133cba7822": "VIP Bet Stacker Blackjack 1",
  "08fd79a4fbfb7b73538756829551568737809581": "VIP Bet Stacker Blackjack 1",
  "c508df682efd751ee151ed41fc2574e6dfaa5d78": "VIP Bet Stacker Blackjack 10",
  "78f49acf784969792242760aaff0896f09dfdc24": "VIP Bet Stacker Blackjack 2",
  "9444d8d2314f918ac8af0da7081abee8589992ae": "VIP Bet Stacker Blackjack 3",
  "0e41b10b6581c4419df589f29f9bc580e9a8ebad": "VIP Bet Stacker Blackjack 4",
  "efb5774f6c64a948a51cae834683f2ed897f046a": "VIP Bet Stacker Blackjack 5",
  "5b347151b89ae97802057537502914b9e1aa7aeb": "VIP Bet Stacker Blackjack 6",
  "496dc3f127434b076b7333dea97f1d26f5fca80b": "VIP Bet Stacker Blackjack 7",
  "1770c372038258938c7e0892b53ac9a5f225bf62": "VIP Bet Stacker Blackjack 8",
  "188ca4207f7f94312e302f27f203db7d6b0ca7c4": "VIP Bet Stacker Blackjack 9",
  "16b77e5d6f148a64986e42bf344200f1129e804f": "VIP Blackjack 1 - Ruby",
  "0021dbc03968b7fe5c320ae45eed9d92c370d007": "VIP Blackjack 10 - Ruby",
  "4a8352cde17b1a7c8ea777d976720ffe09ebad14": "VIP Blackjack 11 - Ruby",
  "dfa75c23dcf61222c2692d431f40ffb884286d25": "VIP Blackjack 12 - Ruby",
  "fa37d4d23fd45873f06ff02a1916164f8c646d1f": "VIP Blackjack 13 – Emerald",
  "471aa623d5de914354bd0738d7821bd929eed381": "VIP Blackjack 14 - Emerald",
  "324e5702c0c9c73abae4bcaee6ca9ad8b6019427": "VIP Blackjack 2 - Ruby",
  "18d54cc8b4f2a7f91bf6b347715bccb2433ae870": "VIP Blackjack 3 - Ruby",
  "2018c35a8f59e7c46e3d4976cba593832f000cb0": "VIP Blackjack 4 - Ruby",
  "d35b4f50a0653d2c12861464e707fd7c0e180a93": "VIP Blackjack 5 - Ruby",
  "b2238671ffa1f9649ff027b368c1c8c9a61e7809": "VIP Blackjack 6",
  "9459d26bc697fc8f87b06d2799f8c5c87c19935d": "VIP Blackjack 7",
  "99cb8277be6cd65cada011aa73f027161732fe09": "VIP Blackjack 8",
  "6fb50675f39bafaeb994f69b6844e8dc9da9e40a": "VIP Blackjack 9 - Ruby",
  "73723bb5b96b1f3987945aa6475a7b177b47506f": "VIP Blackjack em Português",
  "f11ea428ea26be6da1658cb76c258232dceb5be5": "VIP Blackjack em Português 2",
  "9510781caf88f39861c4e437e16a5cf721a5e121": "VIP Blackjack em Português 3",
  "5cb6ae7826ac2e4604aa5903d5795a32dac51821": "VIP Blackjack em Português 3",
  "0b2945cc6f90113f8dfcb51a375cfd0cd6cebd49": "VIP Blackjack em Português 4",
  "56916599e6fc170e0bd2a060c6c2143a93678e57": "VIP Blackjack em Português 5",
  "0213b44dfc0588e81f00b55fc30b948991f809c0": "VIP Blackjack en Español",
  "d01c44ce58aa874cee1c0e3c23d90adeabef3c38": "VIP Blackjack en Español 1",
  "58b1333ba12aea0f217d95ffb1aab18c1d13632d": "VIP Blackjack en Español 2",
  "65204d88615cbf9dcff1bfd188f40845f07ed591": "VIP Blackjack en Español 3",
  "d12eb230ec106b3db4c3d53c37d89bf8d9241099": "VIP Blackjack en Español 4",
  "066da1d8409c1d2d417527e357e7f65dd5354520": "Vip Fruits",
  "4cdd01b3fb27cd172ad7e3b62dff582f73b9b5fb": "Vip Roulette",
  "51e8325e8e70f6d9315bfe0fdd0d0ca228df6405": "Vip Roulette",
  "a5874942c311cac0301118ed8f359b050611cc5e": "Vip Roulette",
  "e09b6050e7ff3c3e79a6e1ced2cd29b8d5f4a319": "Vip Roulette",
  "4576a8a2ccba75e10a1eeab8b346620b47d7b8a4": "VIP Roulette",
  "879833461aedffcb62e63c244857eb2126c6515c": "VIP Roulette",
  "dbff28972b14225bd226949a19e9e84da238cf26": "VIP Roulette - The Club",
  "e737334403c015c237022d2c5d84ec35f3e21efa": "Viper City Heist",
  "b2ae7ad98a9f8f23e0307cdb630c914b4bcfbf3c": "Viva las Vegas",
  "1360eb478d09cacc82a3fcc299509473f7e467f6": "Vizier Of The North x1000",
  "66828f16d3d3a64bbc3d875186cdea89572efde0": "Volatile Vikings",
  "7d97e86be3c8fbb9d56fe55b53f64c2f67189123": "Volcano Adventure",
  "a43e59e26ab0902748a9d5fc7c804feab237d4a4": "Volcano Goddess",
  "6ebd267b57723d0ac52a1ad593d97dd67b7b6d7b": "Volcano Goddess",
  "28ae05e3898882f91ca578ca5f559d6f626fa591": "Volcano Rising",
  "6fe364a0a2d991eba8369da1588794eeecb06a6b": "Volcano Rising SE",
  "84682724b43f6699b2581688b6e981a636025ddf": "Volcano Wealth",
  "579b927d59f4ffa29175925fb5e523803b7a379d": "Voltage Blitz Egypt",
  "bd2d3bd026ec6fbc0509a33f8be6f7eda92db73b": "Voltage Blitz Heat Rush",
  "043d5e4a31dd899cd44b5f19bfa22f876557ee61": "Voltage Blitz Rapid",
  "21ccc42f8018918b48672094a84bf23e7530d372": "Voltage Blitz Stars",
  "bef993bcc9310077cc0f1c607fedd631c02a13a7": "Voltage Blitz Vortex",
  "dac01de8de9c513d0ff8d87029836963bfb21279": "Voltage Blitz Zeus Up",
  "9753fac3d492e550f868b1b1b85af3de67044191": "Voodoo Charms",
  "1c462467442a0c4516cf0041fe16f067b86ec76b": "Voodoo Coins",
  "e99f1aa4023277f36878f1850567fa9fb8cb238c": "Voodoo Magic",
  "16536f1cdb23046d6428253a274620a27c0a6e6f": "Voodoo Magic",
  "69ab06ee04ef6fa0fbcb8748be2dafe13e788153": "Voodoo Shark",
  "0cd86deb3807c9b13ed36714888c24c504207c45": "voodoo-gold",
  "fb807ccb3473079c06cef3822607ee9611ebbb6c": "Walk of Shame",
  "3bae6012793f3223c778e0b6cd23faee23035245": "Walking Oz",
  "fc74a6e5d09d80cd227f697d9a4c96f04e5c7311": "WaltzBeauty",
  "b508b2eb77a6dc841b91c7bf6262a7a1715927f4": "WanFu JinAn",
  "c244086127e6f83275ca507e913ef5c7057b261c": "Wanted Dead Or a Wild",
  "cc91e10727af101ee8701ff5c65b1c2f73c11a78": "WANTED!",
  "c17844240789e18c843a614af0dd660b4568f83c": "Wanted10",
  "42ddafc98079b2f669ea50d8692285e7426319c1": "War",
  "92edea067c46acedf967d20b0571eb8e2b84c729": "War",
  "371e8f0f8e8ac045092e36ef5c83abfe167785ac": "War",
  "0a48765cd5d09b1d3113a922be08bfb2ec4dc7d0": "War",
  "d518834c5b08bb2b9df2250097a021c44d496fb3": "War of Thrones",
  "3073a5d671b84a69856ef0e2740880b1739e7b37": "Warrior Graveyard xNudge®",
  "48ac6eee74b4f9607006226e3b1791197690bb5f": "Water Dice",
  "52f674401ecbda472c5d6861db7f054b0addac53": "Waves of Poseidon",
  "0c687c67db052a5ea7af370f9e40df7457980aed": "Waves of Poseidon",
  "dd638ba6b8b3f3e892a8641e4fd061cb31daea92": "Ways of the Gauls",
  "d7b0f65260d4bf55ded85192a39153dcd51167a4": "Ways of the Genie",
  "61dfde37f7baf20dad47d4df3e0951b638227a73": "Ways of the Genie â€“ Thundershots",
  "e04e79c30f8056c4beb50e8c3e67e6dec51bb134": "Ways of the Samurai",
  "0784cc2a9427b58dde2a09d825d24ddc384303af": "Wealth of Wisdom",
  "9c3257bd2aef31b0e9286e834d8b61f22e1254a4": "Wealth Toad",
  "e0096ed0ad378bc6c590d2235ad2ac32ca115ab3": "WealthInn",
  "2fd2b650ef54e2dc552ba0408f824e91a0b84971": "Wealthy Coins",
  "7d44d8a420ad14ce413b0d9e1107f5a2efa16c2d": "Wealthy Frog",
  "84ca8dc171f09dc726a67233b21ae91869d56073": "WeirdScience",
  "259015f308dfb86e5d2ad56e9855d46062f27ae1": "Welcome Fortune",
  "851d10ee7565ae41d9dae9d9a3b7f9123176b5d3": "Wen Ding",
  "a2384ea764c344342a9dea97515be5beeec137c2": "Wenshi Lion",
  "3537d7fd3703012c25caac222c76d424ca8feaec": "Werewolf",
  "681040caa93ca0b38d808d925a98c837e9f3972a": "Werewolf Is Coming",
  "f926632576203bdcf5c23af3ecb14b6800cd1ff5": "Westward",
  "49a2d1847686db7fc2200f8e1aa85f3fa74c65bc": "Westward Powerspins",
  "3e1a96929a3d16c7129eceaa7c6ccb5439647c1e": "Whacked!",
  "6a221795a3a3ead46d29d72ad6223785d2f96f29": "Whale Wild",
  "696fec48b693e217d6541ce54d5a2ed76960946f": "What's Up? Witches",
  "35f762fb88d5a77ab06109e021d83a091e235259": "Wheel O'Gold",
  "e33a314c78f76ee8a91ce9f700e69994b1e2f979": "Wheel Of Fortune Diamond Spins 2X Wilds",
  "03c0a1317389c1b1522f3ad067e4651b40ceb987": "Wheel of Fortune Megaways",
  "61043bf045ecbde7fa435497fcb5993bf32db609": "Wheel of Fortune Triple Extreme Spin",
  "7136bbe6703dd23ea9a92fc75a487f5e81ff27d8": "Wheel of Fortune Triple Gold Gold Spin",
  "0d9f7703f739dafa9eaa7ff2ceeb6c4f4c224be7": "Wheel of Happiness",
  "959dc5698eaf36f60881a199f5dc4501c2604cf3": "Wheel of Happiness",
  "c6425efa7a316ebf2c04a0c4a5cf63b2d37e1435": "Wheel of Luck. Hold&Win",
  "7041c8a863da45d36f0854daab2fb9e0d092f74b": "Wheel of Mictlan",
  "149ebf3e479ffe0c63db2e598d332c18eab541b9": "Wheel O’Gold",
  "06a4abd352e178175f90047d5930b04a791fa18b": "Wheels of Flame",
  "91fc9649ee8f7535ec2f15de4532799a05bfb22c": "Wheels of Flame PowerPlay Jackpot",
  "6d8d8a5add76daacfa79fc1e512734ef2f6bee5c": "Whispering Winds",
  "54d025b8d1aff9e2d7f98e936c1d85e19aaca811": "White Deer",
  "d82d45413ca4fb7402cd3ab8e16da5cea426bc4f": "White Nose Cat",
  "b8b76c5388fc2f0c92d30ee09fc4fc45e76a878e": "White Orchid",
  "638c3647abedd906eefd4975d937fd06d8ef8a4d": "Whitney Houston",
  "0458609cd82304ed000635d95f64d2dd87e1e7f8": "Who Let the Dogs Out",
  "7eec7cf49cd8efeafeb87f5773bf20fbef0433eb": "Wicked Grin",
  "f4b98b3818ff389bf6a501f318a7210fe6b63859": "WickedWitch",
  "94cf8e36920aab6251ce5169089fcc1ee4a658c3": "Wild 7",
  "3eff4a0b49baca2c8550c6f710e777bda1504a55": "Wild Alaska",
  "247b7fc163a8699b793831f941b167b7206f2b78": "Wild Animals",
  "e864a27f77d987f45d9681eb43a2e6a60d14ccb4": "Wild Anubis",
  "309f6f56eff91b08d7c8ce17c25d0971a54d53b7": "Wild Bandolier",
  "be592ae98f020b585e013383989dc10eaa2fdf1b": "Wild Beach Party",
  "5c9fd7d67b0bc9a21f45d9dce98ce2d2432f1a6a": "Wild Beach Party",
  "98e1f20e290499f9211472db29e1e772ad56a218": "Wild Bison Charge",
  "f9418b5e2f26cf0ca42bbc57e02ad61f1c57dd38": "Wild Bison Charge",
  "cac0eae4566eb7af64337b5f1be99102aea3986e": "Wild Blood",
  "74b4ec1f8aa750542efa5c911f0704e2a3dd32e3": "Wild Blood 2",
  "f1eaa255bce109f4e9d4606e7d45c910630e4aeb": "Wild Booster",
  "70ea65f9fc71742c392df5504c3fd676f4af2516": "Wild Booster",
  "5d9012a19ba3c7452f02cc15f74c5241a1dee2aa": "Wild Celebrity Bus Megaways",
  "6c6af96a0efb0b51bb96f3ef073c91edb69f4ea2": "Wild Celebrity Bus Megaways",
  "f487ec9344a95142e31022c682c0d35774f48378": "Wild Chapo",
  "577f8f29c247ed922b1a16b9546123e226d4bfd8": "Wild Chapo 2",
  "d3873f566daafd3a89eb690cd2e8b6380f393246": "Wild Chapo 2 Dream Drop",
  "0f9bff9c17d57e87313a14cfa15f251acac71186": "Wild Chapo Dream Drop",
  "02f33add643c38cd9cb40583cca172e4dac39963": "Wild Christmas Fusion Reels",
  "e21bb6c87479976c6d30876a5077876c0a437f42": "Wild Classic",
  "e95a5d01ec15ff900e792085eb810234bb1d9b3b": "Wild Country™",
  "4bfd32317df925082da3ea1a2b90a50820614206": "Wild Coyote",
  "69511370c7ee8f6565919e8833039f9d89597a8e": "Wild Crowns",
  "b8d7f460ee3ae2000c0df1b2026a3cd2bab15615": "Wild Depths",
  "5bc41962c9385e09ba3248eb80a6287d4f94bb69": "Wild Depths",
  "c94257e35eab64e52f10818407384459b876adbf": "Wild Detective",
  "e183be9017df3b3f293cea122c16fec8a89bb9d4": "Wild Dragon",
  "bc5873116df0ecb7bc94a5c3f79327f4ad097e0f": "Wild Falls",
  "536ce8667ae5b5c5a2c4d63c86329bf7f214200b": "Wild Falls 2",
  "75f42d5e8b736b0bc3a53f2df105fb8682e28868": "Wild Fortune",
  "beccc44c332d1e391bcccf068424946281f294bd": "Wild Frames",
  "1a0a04f1b30fd819e4cde39a934f5de0fc47aa29": "Wild Fruit Jam",
  "235dcfb79ccaf6666a23b4222b45ec52f9f02ee6": "Wild Fury Jackpots",
  "2b3654bdf12031db7006bc14e879609ffcf50a0f": "Wild Gladiator",
  "944278181e41fc532181583d60c155ca49dabab6": "Wild Gladiator",
  "7e1ffa90edabfb8f845c26c3218afeacf7887aa6": "Wild Hop & Drop",
  "8aa5fdb52ac1fb3862cd344e836de76bcf541ba5": "Wild Hop & Drop",
  "e0310578a8c030001bfa128ff93ea01fd1d80e6e": "Wild Jungle",
  "6264ea08eb0b34f8dd77ce6fe4e390674daf640a": "Wild Kong Lock 2 Spin",
  "eea0b70b92fc7b379500c7c865a2adb04d6b39be": "Wild Lines: American Eagle",
  "cb7264be1e5ad2466b7f8b7dcd4d2c475da5185a": "Wild LinX",
  "aacd2762c071b448fdcf2574992cbdb0bc95a197": "Wild Linx Low",
  "7c303f3d00f9f86da8eea8a9ba7047be108a6c60": "Wild Melon",
  "90189686d335685f04c2add44b82912aae839a23": "Wild Mining™ XXXtreme",
  "f9cfe2ae9d3053d2987a03613b555e347dbb646c": "Wild Mirage",
  "ebc57dc42f6104fc7d32a2c690f804fe19f1621f": "Wild North",
  "33524dfd68b149f564a920125d37ae59a0dec438": "Wild North Radiant Skies GO Collect",
  "91db37315dc0bfb6c25529dac7e23cd8d9ba6d04": "Wild Pixies",
  "3fb2a233a0b17f2b85571b05f523defec32e7eef": "Wild Pixies",
  "f482fc62b5b5365dbf50f7581b87a6f7d3f03af1": "Wild Rails",
  "dc1d3c740533a3e83cf87074b834ae33823923cb": "Wild Ranger",
  "010ca219ddfb94fb8a339ac652d195d6dffd2316": "Wild Respin",
  "0c555123d9712b34e1ed732212207909a4d51e4a": "Wild Robo Factory",
  "1560eea1fb4c6f8fd93762570e2f103c77b0a881": "Wild Shark",
  "ae44d956e3362ee1f3e5aa75799df15ce98edc11": "Wild Shark Bonus",
  "b9e454d9a7ce6020a40e111ff1e02c4d498f37cb": "Wild Skullz",
  "6953e9afb8d461e86e73e087cf517d4ce81a9bf0": "Wild Skullz",
  "befe0c7a747a6d9867112a876304106843639f39": "Wild Skyfire",
  "5d8e412731f79e058db5a0170daa0c36858c944e": "Wild Snowflakes",
  "cf58be1ac141c602f1dd0a757137856e3953db44": "Wild Spells",
  "04ccd937d0d32b99729517163673bb6cf41c8451": "Wild Spin",
  "0f02a634d4232a0609a362bb4a0edd74a52938d9": "Wild Spin Deluxe",
  "fd624a0e63cd46d48e2a7139349a13c3b772b73e": "Wild Stack Frenzy",
  "df0cf589c59b2e087f3f1ad594a25c07d23f3bae": "Wild Stars",
  "83e9d95c3557ae370b0612935bedee9045f1f8d1": "Wild Supreme",
  "c546a30de6c7d6b3a9f848025316c017a974aaef": "Wild Survivor",
  "fce9660f08fa780694087bcf6c574628f45c8197": "Wild Swarm",
  "2125ed9140db8c9296d61a08ab2c43bedfcc0da0": "Wild Swarm 2",
  "feb395f8bc64f3dedf309682dc03ecfb014fca07": "Wild Thirst",
  "307bece88c2646012baa3b4b54fff8c8b26902fb": "Wild Tribe Wall",
  "9623c7c0a0114aaed427d86d71e9827cc211747f": "Wild Trigger",
  "2b36c9364732c2a0f87e5532ab39c4631c711e83": "Wild Vick",
  "5a46c2eac55e9453b8ea0c0bba7fd3b16dda6060": "Wild Walker",
  "c591580d4d946e0bd30355130d2966f69354b8e1": "Wild Walker",
  "d5e2f036121060913adb45dc7b780aeb673a10c2": "Wild Weather",
  "21638e7c165bcc0252bceccc9ed35c849599517f": "Wild West Duels",
  "24e509f89c5148af5facbfaa17db59d5c1f29e31": "Wild West Gold",
  "d1fcbf1e399a9090d7b0c2498891b86b8ee83404": "Wild West Gold Blazing Bounty",
  "a6daab8ee591a08930033015967196f9e0af0c26": "Wild West Gold Blazing Bounty",
  "cf057105a8dc98aff284cf1a2f1254ff6b777e8d": "Wild West Gold Megaways",
  "87ed8c9363dd04b8aaf84806255b677174d71f7c": "Wild West Gold Megaways",
  "3685f9c0874381dae3c601d3b797b586d5821e38": "Wild West Wild",
  "c1d5963e2f890631999cc2f06f94065423845572": "Wild Wild Bananas",
  "b9fcad09352f143ca3eb61684cdd14eb8a934b9b": "Wild Wild Bell",
  "057bbd9e9344d105f4d8f363b412b1836d69f649": "Wild Wild Joker",
  "fe4eca0e87d6a830ebc8879157041936353dbd9c": "Wild Wild Joker",
  "5c45b770e9184b4cb413bdd97e79cf523842e3a6": "Wild Wild Pearls",
  "1fc66320def24833eaa0e7c082c86a9cc84a45d9": "Wild Wild Pearls",
  "e02de3f61ff71f8a68d987cc9d6b9d4b5a7fcf6b": "Wild Wild Riches",
  "db95841d211d535fa7f3d229ced6a1dfa0965602": "Wild Wild Riches Megaways",
  "4dafd9a9f291c5ce1ac03d77fe4c8a0469a0d6a3": "Wild Wild Riches Megaways",
  "3b28c40a915e9ba1e784990d80439a43477ecb54": "Wild Wild Riches Returns",
  "c1b1ab561850526f653787259964da47192bf952": "Wild Wild Riches Returns",
  "90e831307a78ddd384e75df104cf7ef379987ad0": "Wild Wildebeest Wins",
  "5731a9f7577c6d6d7af12b77b7e76af078e52576": "Wild Wildebeest Wins",
  "272d67467c78004b7bbf38246554daaf2264c8eb": "wild-toro",
  "685a65043075dcbf19c8620e1cfe87561a984d07": "wild-toro-2",
  "57bee73c5611d29df50e731bf4048035ee9e36bb": "Wildcano with Orbital Reels™",
  "f9690bb6bfde75b555f727e0d89a93865652e7c8": "Wildchemy",
  "8564142d3494315677c4b0bdf7a8def503f891ac": "Wilderness Cowboy",
  "806b3a65bed53c13791cd62272d98ad50ea3f79c": "Wildest Gambit",
  "e979bfb57f13585210ea0fbae72b62079c3ef4c5": "Wildfire Joker",
  "c89552fcda2581fa5e20adb961544a1ccb188765": "WildFlow",
  "a34a602acbc9d0eb734a3ac7eb8c74706340ff9f": "Wildhound Derby",
  "8a285427025b59a556e54ea374ec89f80462da6c": "Wildies",
  "1d9ade59ad7ed1511613055881b5728150dc4582": "Wildies",
  "bdbbd23a357536794a485e13523711b0b8b49470": "WildTrucks",
  "fda341bb67c3e5980ce4343fac62fcc45b4e1c1e": "Win-A-Beest",
  "1462c686f62a8084fc2d8acf9c1bb5cc28664759": "win-win",
  "6e88c76adba1e8474f5a758069b8db600b1f4502": "Wind Lion God",
  "bcc4bdce33eba026184119d6cfaae07163e81aa6": "Wings of Horus",
  "c0b181f78bfd2631d9b9b63c7542ea510f8c3af5": "Winter Thunder",
  "b0d78f5cbd65f258e83b787699c913c0906c06d3": "Winterberries",
  "de404cb91e88254ac9d7690fc0fdb6eb240227d7": "Winterberries 2",
  "beef1c5b9f9bf91df6ed3a7a51e56cf296802399": "Wisdom of Athena",
  "a8b22ce2f67c6f54cefe8d273d35b4fcb78c4b17": "Wisdom of Athena",
  "3d8d043d17ec5fcee389bf773f59003a90eb7ab2": "Wisdom of Athena 1000",
  "07df5efa2322ae1df495fd73e677d3934449f5c1": "Wisdom of Athena 1000",
  "222025d11691c4ac957500f83ceb59410443e94d": "Wisdom of Athena 1000 Xmas",
  "aa7fe47561b7682580479727ab6fdb93ce40e10e": "Wisdom of Athena 1000 Xmas",
  "f459bd3391311ea97cf50202ad8105a014aa2659": "Wish Upon a Star",
  "fc4fda0258882ea9f7b6dbaf84dffdd1473c7635": "Wishbringer",
  "cedb85068bce01a10c4d35822d526cba56e8ee12": "Witch Academy",
  "be60e38f16a29bb7e69bb05a94a80ba8bd2c9161": "Witch Heart Megaways",
  "6ea38e22fe215176ae16c44c7536e88e143902a2": "Witch Heart Megaways",
  "3bd2ee8758be260e12004a0da0e45b8c320a1e22": "Witch School",
  "6b194a805f77b2cb90ada0245d23109a13fe6a10": "Witches - Cash Collect",
  "ab31067a56de52b76c5606057046f5902cd2ef6f": "Witches' Charm",
  "0f4bc70f283f9ff609f47680b5f9134aeaa8c44b": "WitchesTome",
  "aa7975d2146781393ebde12a8b19d54a0032aecf": "Wixx",
  "640683d8cd7cc5d74f8df82557f6b4cb4cea39ca": "Wizard of Gems",
  "d179045daef9dc4b74b633b6852f19469b8db33d": "Wizard of the Wild",
  "8ebd19786898ad09a5c49314a4214cb833d33550": "Wizard's Academy",
  "fef65229b84bdcc34335358c6984143fc842477d": "Wizardry",
  "79e8d1cb40c89ce49cb9c74cad0f12d4689d1b49": "WizardsWantWar",
  "c25cb894321057ceaf8dda1fa3a126fe9fae06e8": "Wizardâ€™s Spell",
  "7b56f6b6f9ef012db7ac78d1953a2b677af84030": "Wolf Gold",
  "e52262e58f2880a86432f0a9e7531c863a1c2a66": "Wolf Gold",
  "f11a61a7eb614860394bd1051eccaa487d1b1b09": "Wolf Gold 1,000,000",
  "91a8d438a5ef0f087e8e0e93ddb14e973a153876": "Wolf Gold 4 Pack",
  "14916d6dca21b346fad8d601f23f367cc432991e": "Wolf Gold 4 Pack",
  "b2027f1f4f2e9c2517dda26db23faf31fca06887": "Wolf Gold Power Jackpot",
  "90b1a37fdf155a6edd444fa1bb6d93876512789a": "Wolf Gold Ultimate",
  "772d1b0cea6ab0b06ab4fc687eadfd57dcb1b3a3": "Wolf Gold Ultimate",
  "eb945e3e72c5d42de695da6f51d2525caec1fd77": "Wolf Land: Hold and Win",
  "3d9b9241d57ee690aa9efba268ae27ec52747aea": "Wolf Moon",
  "5e67671d0cc61e9661a913c0c83f319f4b28eed8": "Wolf Power Megaways™",
  "47410ae3a983d1b56c9d75fc63631598b8d8cbf4": "Wolf Power: Hold and Win",
  "16e61edffe5d3ef2c623406529f27ebfbdfa7bc0": "Wolf Run",
  "385769a8c458df53a106208f2791491ef5fcdaca": "Wolf Run Eclipse",
  "e6fa3539a1615c8000e0e7636e97c1bb68374669": "Wolf Saga",
  "ba7cc937ed8ec9b58d8a186cf18c98492e92f244": "Wolf Sierra",
  "14984a1394abb21d17345698e9c4720f1e04d6d4": "Wolf Thunder",
  "7c17ea9a21e719d42155a933e50a1697a4d5e1d7": "Wolf Warrior",
  "f2e07d0a36017126c540da79e0fac64be5fcebbf": "Wolves! Cash Collect & Link",
  "5928eac48a297895cf117d9c6fcc01621948c29a": "Won Won Rich",
  "58edc69345953f9d681111f6e629805969ff0e82": "Wonder Tree",
  "1e9cf512291126b239b3367c5ba61302adc04daf": "WondeReels",
  "3b6cbd52f486362ce47fbabff1c78b97516a50d4": "Wonderheart",
  "9676a701949f2181e46e38ec0715e92d0078857d": "Wonders of Aztec",
  "f9b15120fd160ef17104a408c13b29dc72fa2669": "Wong TaiSin",
  "2cfd15223534cbef53c2803f0971563df65e5c6c": "World Cup Roulette",
  "968d542e1452b6a922914ba8d61733c03e6079bc": "World of Circus",
  "e1935e6e7ab8e86f6da281ed5147fe0641e9aed8": "world-eaters",
  "9b14eb0157759418fc6fe2519bf22fcb022a3460": "Wrappin' Gold",
  "098d197c04ca811010303c09f7fadb73b27efcbf": "Wrestling Queen",
  "0a72dd1748ad323929e3d5550804ca6495f1c101": "Wu Gang",
  "101627dfe77b74821de214175929ca01b7696799": "Wu Song",
  "fea4b58b99f2db9e464df774119b7ae58fa85473": "Wu Zetian",
  "74ddbc2a536cbf75a61629e0ba06224182c4c7ca": "WUKONG",
  "6bbcde8def2725f5b95b00e617f9379d11f138d6": "Wukong Rush",
  "1321d0e574c61c25535b7f31c0ffa6e25d0c0b83": "Wushu Punch",
  "7a60b5f33257e353bc0d71b196f5455569bf9208": "X-Bomber",
  "76b3aa742945ac0f9af98165f58534397a7966c9": "X-Elements",
  "f638103740a1d3fe866b0bd9dc7a47e794eb5295": "X-Mas Buffalo",
  "f347f2d2bf1617cfb8be2223f366661103c57ddc": "X-Mas Gifts",
  "b72b842a15a831bd692981bdd8e2f6aec11a5e35": "X1000 Golden Penny 2",
  "e47018ef75097c3d3a0e521ea06c607d492e1ea4": "Xing Fu Panda",
  "4f201fd08fbf4dfb26f48d86639774dd68a1a812": "Xmas Avalanche",
  "3ed50c6c8451aed9a3a86056e3ed6c312671cd3e": "Xmas Bells",
  "4a2822501098e175b1add19754791476732fc6e7": "Xmas Drop",
  "d18188120096e23b8fb6c19b62d39a561fa3d0d9": "Xmas Invaders",
  "719479fbb5b9576299d8c90a177bb5e9ebb8e422": "Xmas Joker",
  "8eb1854761d986e4accd3020000f3e4f7d6f4e47": "Xmas Magic",
  "18713f6c7a087c6038b2cd6463aa165b83488f9c": "Xmas Wishes",
  "a167573eda65a12d079a07d1c669e5e0a0499a30": "Xpander",
  "0f8e56b1fd623ffdff8cf685ad7ea4c17c6a3a0f": "Xtra Hot™",
  "ae1e3109df5b0d19aea7af1f8aa7b1959ec082c2": "xWays Hoarder 2",
  "39b25860c0ad9c2d37f66c2d59225e7dd1d4dfeb": "xWays Hoarder xSplit®",
  "ee9729df524a69032b68667df389530b625398ee": "XXXtreme Lightning Baccarat",
  "180fe387311fffe9da0b0bbfb1aa7b76891929e4": "XXXtreme Lightning Baccarat",
  "59d9ef62b5395dc1c8ee4408d9bd3c878a7dfdd4": "XXXTreme Lightning Roulette",
  "b84bcc7d842b80f0653722134cedc53c2a5038cc": "XXXtreme Lightning Roulette",
  "c2da4376b21f3737cc8cce04ece07b0db5e694b0": "Yakyuken",
  "8198f7da7971f168ec105c64ae6ba2bd6e9ea7be": "Yamato",
  "d1501963541ed9f668e7252deb71e1806708c8bb": "Year Of The Dragon King",
  "38388b948f2b86a385c8476b4836c41c079234a9": "Year of the Dragon King™",
  "dc57197dae2e9cdd393482e3ed74e4d9868615a5": "Year of the Rabbit",
  "5ddca2332f7f11bd55c1a981bd1471ef633ee29c": "Year of the Tiger",
  "47ba63cafb7220e84d02c131d067bbc46b9518d2": "Yeti Quest",
  "2482a0655c50fd1f832a6ab8474ac3b20a8aee26": "Yeti Quest",
  "1e3abbfe6a10883ee8a279bbe6f67cbacd95b579": "Yokozuna Clash",
  "348e5eafe319bd4525164c941ed274821484ccd6": "You Can Piggy Bank On It",
  "2def04aeb42625d6dcad4e1e41e0b770d61ca795": "You Can Piggy Bank On It",
  "2c575b7eb72196e858e25cf791d951c46af9e69c": "Your Own Island",
  "d6b9584b296b5779d844062ce707a5b950b38f2b": "Yu Fu",
  "d985267a56fabbe7d6abce16bfd30e9ae3b1df47": "Yu Gong",
  "251395ef7a5782b51bbec102dc540cce2b7a981f": "Yu Tu Jin Cai: Cash Collect",
  "822f2acd6376ddab58d966f79efbfaa4dd3427a9": "Yue Fei",
  "f5f6fccc815c5e4cf8e65e8c38b47e278726b3c8": "Yummy Thanksgiving",
  "b88fafa85e1b703ce67a25e1f4058f6bf4f66a7c": "Yun Cai Tong Zi",
  "cfa1e7c1ee99c627089fe1cf973307744ed46621": "zaplab",
  "bc0d1e7d5454454583c695f31d9079e44ebed735": "ZapOtec Gold",
  "f2703b5545ebd78c239f3d27dc415db2b1337a4a": "Zashiki God",
  "1d6008e5ccd88b668bbc16807d0eb76a180c8c65": "Ze Zeus",
  "a3b8289c755e0fb265de8fed9289f61928e405a6": "Zentaurus",
  "e5ac10e0e34d9eb150d2656c01fa07d2635ae3c4": "Zeus",
  "b0ad635c67ad1da3693ce68c32d7fe73aad84f2c": "Zeus Divine Multipliers",
  "47c3f1ac90d1d2defb2eb7d9a473550994194e45": "Zeus Rush Fever",
  "a1f32c641556d46178fcdeeae1fb07350bf47506": "Zeus Rush Fever Deluxe",
  "2434faf50648ebe6d7759f977449e602bc6c4e59": "Zeus Rush Fever® Deluxe SE",
  "0ada89fba6daed11e3ae995630b96890f1a0b27c": "Zeus vs Hades - Gods of War",
  "8018db4840dd1b48750115da0ed6ba52fec01eb5": "Zeus vs Hades – Gods of War 250",
  "53bead007dda4a6f743c560a4169d111121cfc0b": "Zeus vs Hades – Gods of War 250",
  "30c8ea5646caed881a454c7e60b73c1f86e643d3": "Zeus vs Typhon",
  "e0a2502fbcbc4bdd85d2a273aac3b6040097f404": "Zeus vs Typhon",
  "c0c0e8ba1dfad94a3df4f56dfcb299e58bafb45e": "Zeus Ze Zecond",
  "1343ec5347cd95ab642d7e798f09ad4dedb33a27": "Zhong Yi and Dragon",
  "005e06ce733b931c6f252d537caa2e189a1030fd": "Zodiac Charms",
  "bfc4ae9e65b523271ee6790993c7ab6aa59b6eef": "Zodiac Wheel",
  "0bf672eeaab7e1682ce75db4c8f499a243107e6c": "Zodiac Wheel",
  "b9024ed6f1d8c89696b9ace4ad3b1891ea529e1a": "Zodiac Wheel Bell Link",
  "bee40dbd3deadf2277320dbb9d67a4a19fddf2f4": "Zodiac Wheel Bell Link VIP",
  "089ad9df7fd4ef0e281b9954c6034ce95793cee7": "Zodiac Wheel Xtra Bell Link",
  "edd5a6bddb661bf0a9bb0e525b3224f51196012b": "Zodiac Wheel Xtra Bell Link VIP",
  "1fdb87acb16505d0c73387bb69153f67c54c1c78": "Zombie Carnival",
  "4f09b902ac10cee98662472e19cd5cd09c7b0736": "Zombie Circus",
  "b3199bfbd1aba062ea3aea9c4889831a518cf9c4": "Zombie Expert Lock 2 Spin",
  "3f7dc3122a3c5aada99615478b97bfa6ac881a1a": "Zombie Land",
  "abdf0c650f0cf49ebaf3b4d7795a743c2ea79acd": "Zombie School Megaways",
  "ec21da2b2d135eaec956237c970557699dcac7d8": "Zombie School Megaways",
  "d8c10367b0b7b0a83420513a4ddb1cd2fbbfd34f": "Zombie Siege",
  "3c4e4b2efbbd5017c06c4b727b2c926d27c49315": "Zombie Train",
  "d383e3aa903173e39d774278f8a17cf5f47c4e6b": "Zombies",
  "3691002be3fd3683226744f3bbebd5b2da37174e": "zulu-gold",
  "35abdb0b618977d7b8a3771ebf50083687a8bc62": "ZZ Top Roadside Riches"
};

export { databetrixGameNameMapping };
export default databetrixGameNameMapping;
